function _loadWasmModule(B, ja, Y) {
  for (var U = ja.length, vb = new Uint8Array((3 * U) / 4 - ("=" == ja[U - 2] ? 2 : "=" == ja[U - 1] ? 1 : 0)), Ob = new Uint8Array(130), Ma = 0; 64 > Ma; Ma++)
    Ob["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charCodeAt(Ma)] = Ma;
  for (var ka = (Ma = 0); Ma < U; Ma += 4) {
    var nd = Ob[ja.charCodeAt(Ma + 1)],
      ia = Ob[ja.charCodeAt(Ma + 2)];
    vb[ka++] = (Ob[ja.charCodeAt(Ma)] << 2) | (nd >> 4);
    vb[ka++] = ((nd & 15) << 4) | (ia >> 2);
    vb[ka++] = ((ia & 3) << 6) | (Ob[ja.charCodeAt(Ma + 3)] & 63);
  }
  return Y && !B ? WebAssembly.instantiate(vb, Y) : Y || B ? ((B = new WebAssembly.Module(vb)), Y ? new WebAssembly.Instance(B, Y) : B) : WebAssembly.compile(vb);
}
(function (B, ja) {
  "object" === typeof exports && "undefined" !== typeof module
    ? ja(exports)
    : "function" === typeof define && define.amd
    ? define(["exports"], ja)
    : ((B = B || self), ja((B.mapvgl = {})));
})(this, function (B) {
  function ja(e) {
    this.options = e || {};
    this.paneName = this.options.paneName || "labelPane";
    this.zIndex = this.options.zIndex || 1;
    this._map = e.map;
    this._lastDrawTime = null;
    this.show();
  }
  function Y(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e["default"] : e;
  }
  function U(e, b) {
    return (b = { exports: {} }), e(b, b.exports), b.exports;
  }
  function vb(e, b) {
    return function (d) {
      return b(e(d));
    };
  }
  function Ob(e) {
    var b = function (b) {
      if (void 0 === b || null === b) return b;
      1 < arguments.length && (b = Array.prototype.slice.call(arguments));
      return e(b);
    };
    "conversion" in e && (b.conversion = e.conversion);
    return b;
  }
  function Ma(e) {
    var b = function (b) {
      if (void 0 === b || null === b) return b;
      1 < arguments.length && (b = Array.prototype.slice.call(arguments));
      var a = e(b);
      if ("object" === ("undefined" === typeof a ? "undefined" : Ha(a))) for (var c = a.length, d = 0; d < c; d++) a[d] = Math.round(a[d]);
      return a;
    };
    "conversion" in e && (b.conversion = e.conversion);
    return b;
  }
  function ka(e, b) {
    if (!(this instanceof ka)) return new ka(e, b);
    b && b in Jf && (b = null);
    if (b && !(b in Na)) throw Error("Unknown model: " + b);
    if ("undefined" === typeof e) (this.model = "rgb"), (this.color = [0, 0, 0]), (this.valpha = 1);
    else if (e instanceof ka) (this.model = e.model), (this.color = e.color.slice()), (this.valpha = e.valpha);
    else if ("string" === typeof e) {
      b = xc.get(e);
      if (null === b) throw Error("Unable to parse color from string: " + e);
      this.model = b.model;
      var d = Na[this.model].channels;
      this.color = b.value.slice(0, d);
      this.valpha = "number" === typeof b.value[d] ? b.value[d] : 1;
    } else if (e.length)
      (this.model = b || "rgb"), (d = Na[this.model].channels), (b = fe.call(e, 0, d)), (this.color = ge(b, d)), (this.valpha = "number" === typeof e[d] ? e[d] : 1);
    else if ("number" === typeof e) (e &= 16777215), (this.model = "rgb"), (this.color = [(e >> 16) & 255, (e >> 8) & 255, e & 255]), (this.valpha = 1);
    else {
      this.valpha = 1;
      b = qa(e);
      "alpha" in e && (b.splice(b.indexOf("alpha"), 1), (this.valpha = "number" === typeof e.alpha ? e.alpha : 0));
      b = b.sort().join("");
      if (!(b in he)) throw Error("Unable to parse color from object: " + yc(e));
      this.model = he[b];
      d = Na[this.model].labels;
      var a = [];
      for (b = 0; b < d.length; b++) a.push(e[d[b]]);
      this.color = ge(a);
    }
    if (od[this.model]) for (d = Na[this.model].channels, b = 0; b < d; b++) (e = od[this.model][b]) && (this.color[b] = e(this.color[b]));
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    Kf && Kf(this);
  }
  function nd(e) {
    return function (b) {
      return Number(b.toFixed(e));
    };
  }
  function ia(e, b, d) {
    e = Array.isArray(e) ? e : [e];
    e.forEach(function (a) {
      (od[a] || (od[a] = []))[b] = d;
    });
    e = e[0];
    return function (a) {
      if (arguments.length) {
        d && (a = d(a));
        var c = this[e]();
        c.color[b] = a;
        return c;
      }
      c = this[e]().color[b];
      d && (c = d(c));
      return c;
    };
  }
  function sa(e) {
    return function (b) {
      return Math.max(0, Math.min(e, b));
    };
  }
  function ge(e, b) {
    for (var d = 0; d < b; d++) "number" !== typeof e[d] && (e[d] = 0);
    return e;
  }
  function za(e) {
    return (e * Math.PI) / 180;
  }
  function ie(e) {
    return (e / Math.PI) * 180;
  }
  function lb(e) {
    return Math.pow(2, Math.ceil(Math.log(e) / Math.LN2));
  }
  function je(e) {
    return Math.pow(2, Math.floor(Math.log(e) / Math.LN2));
  }
  function ke(e, b) {
    return 1e-8 > Math.abs(e - b);
  }
  function le(e) {
    var b = e[0],
      d = e[e.length - 1];
    return (
      Math.sqrt(Math.pow(b[0] - d[0], 2) + Math.pow(b[1] - d[1], 2) + Math.pow((b[2] || 0) - (d[2] || 0), 2)) <
      (1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 2e-7)
    );
  }
  function Ea() {}
  function me(e, b) {
    for (var d in b) e[d] = b[d];
  }
  function Oa(e, b) {
    this.lng = e;
    this.lat = b;
  }
  function Lf(e, b) {
    this.x = e;
    this.y = b;
  }
  function ne(e, b) {
    var d = document.createElement("canvas");
    e && (d.width = e);
    b && (d.height = b);
    return d;
  }
  function Ba(e) {
    e = e || {};
    this.gradient = e.gradient || { 0.25: "rgba(0, 0, 255, 1)", 0.55: "rgba(0, 255, 0, 1)", 0.85: "rgba(255, 255, 0, 1)", 1: "rgba(255, 0, 0, 1)" };
    this.maxSize = void 0 === e.maxSize ? 35 : e.maxSize;
    this.minSize = e.minSize || 0;
    this.max = e.max || 100;
    this.min = e.min || 0;
    this.initPalette();
  }
  function mb(e) {
    this.options = e || {};
    this._initialize();
  }
  function oe(e, b, d, a, c) {
    var f = 1 - e,
      h = 1 - e;
    return f * f * f * b + 3 * h * h * e * d + 3 * (1 - e) * e * e * a + e * e * e * c;
  }
  function wb(e) {
    this.WORLD_SIZE_MC_HALF = 2.0037726372307256e7;
    this.WORLD_SIZE_MC = 2 * this.WORLD_SIZE_MC_HALF;
    this.options = e || {};
    this._initialize();
  }
  function Mf(e, b) {
    return e && b ? Math.round(Math.sqrt(Math.pow(e.lng - b.lng, 2) + Math.pow(e.lat - b.lat, 2))) : 0;
  }
  function pd(e) {
    e = e.split("|");
    e[0] = e[0].split(",");
    return { lng: parseFloat(e[0][0]), lat: parseFloat(e[0][1]) };
  }
  function dc(e) {
    for (var b = e.length; 0 <= --b; ) e[b] = 0;
  }
  function pe(e, b, d, a, c) {
    this.static_tree = e;
    this.extra_bits = b;
    this.extra_base = d;
    this.elems = a;
    this.max_length = c;
    this.has_stree = e && e.length;
  }
  function qe(e, b) {
    this.dyn_tree = e;
    this.max_code = 0;
    this.stat_desc = b;
  }
  function ab(e, b, d, a, c) {
    this.good_length = e;
    this.max_lazy = b;
    this.nice_length = d;
    this.max_chain = a;
    this.func = c;
  }
  function Hi() {
    this.strm = null;
    this.status = 0;
    this.pending_buf = null;
    this.wrap = this.pending = this.pending_out = this.pending_buf_size = 0;
    this.gzhead = null;
    this.gzindex = 0;
    this.method = qd;
    this.last_flush = -1;
    this.w_mask = this.w_bits = this.w_size = 0;
    this.window = null;
    this.window_size = 0;
    this.head = this.prev = null;
    this.nice_match =
      this.good_match =
      this.strategy =
      this.level =
      this.max_lazy_match =
      this.max_chain_length =
      this.prev_length =
      this.lookahead =
      this.match_start =
      this.strstart =
      this.match_available =
      this.prev_match =
      this.match_length =
      this.block_start =
      this.hash_shift =
      this.hash_mask =
      this.hash_bits =
      this.hash_size =
      this.ins_h =
        0;
    this.dyn_ltree = new Uint16Array(1146);
    this.dyn_dtree = new Uint16Array(122);
    this.bl_tree = new Uint16Array(78);
    xb(this.dyn_ltree);
    xb(this.dyn_dtree);
    xb(this.bl_tree);
    this.bl_desc = this.d_desc = this.l_desc = null;
    this.bl_count = new Uint16Array(16);
    this.heap = new Uint16Array(573);
    xb(this.heap);
    this.heap_max = this.heap_len = 0;
    this.depth = new Uint16Array(573);
    xb(this.depth);
    this.bi_valid = this.bi_buf = this.insert = this.matches = this.static_len = this.opt_len = this.d_buf = this.last_lit = this.lit_bufsize = this.l_buf = 0;
  }
  function zc(e) {
    e = this.options = rd.assign({ level: Ii, method: Ji, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: Ki }, e || {});
    e.raw && 0 < e.windowBits ? (e.windowBits = -e.windowBits) : e.gzip && 0 < e.windowBits && 16 > e.windowBits && (e.windowBits += 16);
    this.err = 0;
    this.msg = "";
    this.ended = !1;
    this.chunks = [];
    this.strm = new Nf();
    this.strm.avail_out = 0;
    var b = Ac.deflateInit2(this.strm, e.level, e.method, e.windowBits, e.memLevel, e.strategy);
    if (b !== sd) throw Error(Pb[b]);
    e.header && Ac.deflateSetHeader(this.strm, e.header);
    if (e.dictionary) {
      e = "string" === typeof e.dictionary ? Bc.string2buf(e.dictionary) : "[object ArrayBuffer]" === Of.call(e.dictionary) ? new Uint8Array(e.dictionary) : e.dictionary;
      b = Ac.deflateSetDictionary(this.strm, e);
      if (b !== sd) throw Error(Pb[b]);
      this._dict_set = !0;
    }
  }
  function re(e, b) {
    b = new zc(b);
    b.push(e, !0);
    if (b.err) throw b.msg || Pb[b.err];
    return b.result;
  }
  function Li() {
    this.mode = 0;
    this.last = !1;
    this.wrap = 0;
    this.havedict = !1;
    this.total = this.check = this.dmax = this.flags = 0;
    this.head = null;
    this.wnext = this.whave = this.wsize = this.wbits = 0;
    this.window = null;
    this.extra = this.offset = this.length = this.bits = this.hold = 0;
    this.distcode = this.lencode = null;
    this.have = this.ndist = this.nlen = this.ncode = this.distbits = this.lenbits = 0;
    this.next = null;
    this.lens = new Uint16Array(320);
    this.work = new Uint16Array(288);
    this.distdyn = this.lendyn = null;
    this.was = this.back = this.sane = 0;
  }
  function Cc(e) {
    var b = (this.options = rd.assign({ chunkSize: 65536, windowBits: 15, to: "" }, e || {}));
    b.raw && 0 <= b.windowBits && 16 > b.windowBits && ((b.windowBits = -b.windowBits), 0 === b.windowBits && (b.windowBits = -15));
    !(0 <= b.windowBits && 16 > b.windowBits) || (e && e.windowBits) || (b.windowBits += 32);
    15 < b.windowBits && 48 > b.windowBits && 0 === (b.windowBits & 15) && (b.windowBits |= 15);
    this.err = 0;
    this.msg = "";
    this.ended = !1;
    this.chunks = [];
    this.strm = new Nf();
    this.strm.avail_out = 0;
    e = nb.inflateInit2(this.strm, b.windowBits);
    if (e !== Dc) throw Error(Pb[e]);
    this.header = new Mi();
    nb.inflateGetHeader(this.strm, this.header);
    if (
      b.dictionary &&
      ("string" === typeof b.dictionary
        ? (b.dictionary = Bc.string2buf(b.dictionary))
        : "[object ArrayBuffer]" === Pf.call(b.dictionary) && (b.dictionary = new Uint8Array(b.dictionary)),
      b.raw && ((e = nb.inflateSetDictionary(this.strm, b.dictionary)), e !== Dc))
    )
      throw Error(Pb[e]);
  }
  function se(e, b) {
    b = new Cc(b);
    b.push(e);
    if (b.err) throw b.msg || Pb[b.err];
    return b.result;
  }
  function Qf(e, b) {
    for (var d = ["webgl2", "experimental-webgl2", "webgl", "experimental-webgl"], a = void 0, c = 0; c < d.length; c++)
      try {
        if ((a = e.getContext(d[c], { stencil: !0, alpha: !0, premultipliedAlpha: !1, antialias: b.antialias || !0, preserveDrawingBuffer: b.preserveDrawingBuffer || !1 }))) break;
      } catch (f) {}
    return a;
  }
  function ec(e, b, d) {
    var a = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};
    d = S({ TEXTURE_MAG_FILTER: "LINEAR", TEXTURE_MIN_FILTER: "LINEAR", TEXTURE_WRAP_S: "REPEAT", TEXTURE_WRAP_T: "REPEAT" }, d);
    var c = e.createTexture();
    e.bindTexture(e.TEXTURE_2D, c);
    e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, a.flipY || !0);
    if (a.format && a.width) {
      var f = e.LUMINANCE;
      a.format && (f = e[a.format]);
      "RGBA" !== a.format && "RGB" !== a.format
        ? ((b = new Float32Array(b)), e.texImage2D(e.TEXTURE_2D, 0, e.R32F, a.width, a.height, 0, e.RED, e[a.type] || e.FLOAT, b))
        : e.texImage2D(e.TEXTURE_2D, 0, f, a.width, a.height, 0, f, e[a.type] || e.FLOAT, b);
    } else e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, b);
    for (var h in d) e.texParameteri(e.TEXTURE_2D, e[h], e[d[h]]);
    e.bindTexture(e.TEXTURE_2D, null);
    return { texture: c, data: { width: a.width, height: a.height, data: b, type: a.type } };
  }
  function ta(e, b, d, a, c) {
    if ("object" === ("undefined" === typeof b ? "undefined" : Ha(b))) (b = ec(e, b, a, c)), d(b.texture, null, b.data);
    else {
      var f = new Image();
      f.crossOrigin = "anonymous";
      f.onload = function () {
        var b = je(f.width),
          g = je(f.height),
          k = document.createElement("canvas");
        k.width = b;
        k.height = g;
        var l = k.getContext("2d");
        l.drawImage(f, 0, 0, b, g);
        f = k;
        k = ec(e, f, a, c).texture;
        d(k, f, { width: b, height: g, data: l.getImageData(0, 0, b, g), type: "RGBA" });
      };
      f.src = b;
    }
  }
  function Va(e, b) {
    if (b instanceof Array) {
      var d = {
        zero: e.ZERO,
        one: e.ONE,
        src_color: e.SRC_COLOR,
        one_minus_src_color: e.ONE_MINUS_SRC_COLOR,
        dst_color: e.DST_COLOR,
        one_minus_dst_color: e.ONE_MINUS_DST_COLOR,
        src_alpha: e.SRC_ALPHA,
        one_minus_src_alpha: e.ONE_MINUS_SRC_ALPHA,
        dst_alpha: e.DST_ALPHA,
        one_minus_dst_alpha: e.ONE_MINUS_DST_ALPHA,
        constant_color: e.CONSTANT_COLOR,
        one_minus_constant_color: e.ONE_MINUS_CONSTANT_COLOR,
        constant_alpha: e.CONSTANT_ALPHA,
        one_minus_constant_alpha: e.ONE_MINUS_CONSTANT_ALPHA,
        src_alpha_saturate: e.SRC_ALPHA_SATURATE
      };
      return b.map(function (a) {
        return d[a];
      });
    }
    switch (b) {
      case "default":
        return Rf ? [e.SRC_ALPHA, e.ZERO, e.ONE, e.ZERO] : [e.ONE, e.ZERO];
      case "deeper":
        return [e.ONE, e.ONE_MINUS_SRC_ALPHA];
      case "normal":
        return [e.SRC_ALPHA, e.ONE];
      case "lighter":
        return [e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA];
      default:
        return [e.ONE, e.ZERO];
    }
  }
  function Sf(e, b) {
    var d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : [],
      a = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : "#ccc",
      c = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 1,
      f = document.createElement("canvas"),
      h = f.getContext("2d");
    f.width = 256;
    f.height = c;
    f = b[0];
    var g = b[b.length - 1];
    if (e.length === b.length) {
      for (var k = h.createLinearGradient(0, 0, 256, 1), l = 0; l < e.length; ++l) k.addColorStop((b[l] - f) / (g - f), e[l]);
      h.fillStyle = k;
      h.fillRect(0, 0, 256, c);
    } else if (-1 === e.length - b.length) {
      k = 0;
      l = 1;
      for (var n = 0; n < e.length; ++n) {
        var m = Math.floor(((b[l] - f) / (g - f)) * 256);
        h.fillStyle = e[n];
        h.fillRect(k, 0, m, c);
        k = m;
        l++;
      }
    } else (h.fillStyle = a || "#ccc"), h.fillRect(0, 0, 256, c);
    -1 >= e.length - b.length &&
      2 === d.length &&
      ((h.fillStyle = a || "#ccc"),
      (a = (d[0] - f) / (g - f)),
      (a = Math.floor(256 * a)),
      h.fillRect(0, 0, a, c),
      (a = (d[1] - f) / (g - f)),
      (a = Math.floor(256 * a)),
      h.fillRect(a, 0, 255, c));
    return { data: new Uint8Array(new Uint8ClampedArray(h.getImageData(0, 0, 256, c).data)), width: 256, height: c };
  }
  function Fa(e, b, d) {
    d = d || 2;
    var a = b && b.length,
      c = a ? b[0] * d : e.length,
      f = Tf(e, 0, c, d, !0),
      h = [];
    if (!f || f.next === f.prev) return h;
    var g;
    if (a) {
      var k = d;
      a = [];
      var l;
      var n = 0;
      for (l = b.length; n < l; n++) {
        var m = b[n] * k;
        var p = n < l - 1 ? b[n + 1] * k : e.length;
        m = Tf(e, m, p, k, !1);
        m === m.next && (m.steiner = !0);
        a.push(Ni(m));
      }
      a.sort(Oi);
      for (n = 0; n < a.length; n++) {
        k = a[n];
        b = f;
        if ((b = Pi(k, b))) (k = Uf(b, k)), yb(b, b.next), yb(k, k.next);
        f = yb(f, f.next);
      }
    }
    if (e.length > 80 * d) {
      var q = (g = e[0]);
      var t = (a = e[1]);
      for (k = d; k < c; k += d) (n = e[k]), (b = e[k + 1]), n < q && (q = n), b < t && (t = b), n > g && (g = n), b > a && (a = b);
      g = Math.max(g - q, a - t);
      g = 0 !== g ? 1 / g : 0;
    }
    Ec(f, h, d, q, t, g);
    return h;
  }
  function Tf(e, b, d, a, c) {
    if (c === 0 < te(e, b, d, a)) for (c = b; c < d; c += a) var f = Vf(c, e[c], e[c + 1], f);
    else for (c = d - a; c >= b; c -= a) f = Vf(c, e[c], e[c + 1], f);
    f && td(f, f.next) && (Fc(f), (f = f.next));
    return f;
  }
  function yb(e, b) {
    if (!e) return e;
    b || (b = e);
    do {
      var d = !1;
      if (e.steiner || (!td(e, e.next) && 0 !== ma(e.prev, e, e.next))) e = e.next;
      else {
        Fc(e);
        e = b = e.prev;
        if (e === e.next) break;
        d = !0;
      }
    } while (d || e !== b);
    return b;
  }
  function Ec(e, b, d, a, c, f, h) {
    if (e) {
      if (!h && f) {
        var g = e,
          k = g;
        do null === k.z && (k.z = ue(k.x, k.y, a, c, f)), (k.prevZ = k.prev), (k = k.nextZ = k.next);
        while (k !== g);
        k.prevZ.nextZ = null;
        k.prevZ = null;
        g = k;
        var l,
          n,
          m,
          p,
          q = 1;
        do {
          k = g;
          var t = (g = null);
          for (n = 0; k; ) {
            n++;
            var v = k;
            for (l = m = 0; l < q && (m++, (v = v.nextZ), v); l++);
            for (p = q; 0 < m || (0 < p && v); )
              0 !== m && (0 === p || !v || k.z <= v.z) ? ((l = k), (k = k.nextZ), m--) : ((l = v), (v = v.nextZ), p--), t ? (t.nextZ = l) : (g = l), (l.prevZ = t), (t = l);
            k = v;
          }
          t.nextZ = null;
          q *= 2;
        } while (1 < n);
      }
      for (g = e; e.prev !== e.next; ) {
        k = e.prev;
        v = e.next;
        if (f) t = Qi(e, a, c, f);
        else
          a: if (((t = e), (n = t.prev), (m = t), (q = t.next), 0 <= ma(n, m, q))) t = !1;
          else {
            for (l = t.next.next; l !== t.prev; ) {
              if (fc(n.x, n.y, m.x, m.y, q.x, q.y, l.x, l.y) && 0 <= ma(l.prev, l, l.next)) {
                t = !1;
                break a;
              }
              l = l.next;
            }
            t = !0;
          }
        if (t) b.push(k.i / d), b.push(e.i / d), b.push(v.i / d), Fc(e), (g = e = v.next);
        else if (((e = v), e === g)) {
          if (!h) Ec(yb(e), b, d, a, c, f, 1);
          else if (1 === h) {
            e = yb(e);
            h = b;
            g = d;
            k = e;
            do
              (v = k.prev),
                (t = k.next.next),
                !td(v, t) && Wf(v, k, k.next, t) && Gc(v, t) && Gc(t, v) && (h.push(v.i / g), h.push(k.i / g), h.push(t.i / g), Fc(k), Fc(k.next), (k = e = t)),
                (k = k.next);
            while (k !== e);
            e = yb(k);
            Ec(e, b, d, a, c, f, 2);
          } else if (2 === h)
            a: {
              h = e;
              do {
                for (g = h.next.next; g !== h.prev; ) {
                  if ((k = h.i !== g.i)) {
                    k = h;
                    v = g;
                    if ((t = k.next.i !== v.i && k.prev.i !== v.i)) {
                      b: {
                        t = k;
                        do {
                          if (t.i !== k.i && t.next.i !== k.i && t.i !== v.i && t.next.i !== v.i && Wf(t, t.next, k, v)) {
                            t = !0;
                            break b;
                          }
                          t = t.next;
                        } while (t !== k);
                        t = !1;
                      }
                      t = !t;
                    }
                    if (t) {
                      if ((t = Gc(k, v) && Gc(v, k))) {
                        t = k;
                        n = !1;
                        m = (k.x + v.x) / 2;
                        q = (k.y + v.y) / 2;
                        do t.y > q !== t.next.y > q && t.next.y !== t.y && m < ((t.next.x - t.x) * (q - t.y)) / (t.next.y - t.y) + t.x && (n = !n), (t = t.next);
                        while (t !== k);
                        t = n;
                      }
                      t = (t && (ma(k.prev, k, v.prev) || ma(k, v.prev, v))) || (td(k, v) && 0 < ma(k.prev, k, k.next) && 0 < ma(v.prev, v, v.next));
                    }
                    k = t;
                  }
                  if (k) {
                    e = Uf(h, g);
                    h = yb(h, h.next);
                    e = yb(e, e.next);
                    Ec(h, b, d, a, c, f);
                    Ec(e, b, d, a, c, f);
                    break a;
                  }
                  g = g.next;
                }
                h = h.next;
              } while (h !== e);
            }
          break;
        }
      }
    }
  }
  function Qi(e, b, d, a) {
    var c = e.prev,
      f = e.next;
    if (0 <= ma(c, e, f)) return !1;
    var h = c.x > e.x ? (c.x > f.x ? c.x : f.x) : e.x > f.x ? e.x : f.x,
      g = c.y > e.y ? (c.y > f.y ? c.y : f.y) : e.y > f.y ? e.y : f.y,
      k = ue(c.x < e.x ? (c.x < f.x ? c.x : f.x) : e.x < f.x ? e.x : f.x, c.y < e.y ? (c.y < f.y ? c.y : f.y) : e.y < f.y ? e.y : f.y, b, d, a);
    b = ue(h, g, b, d, a);
    d = e.prevZ;
    for (a = e.nextZ; d && d.z >= k && a && a.z <= b; ) {
      if (d !== e.prev && d !== e.next && fc(c.x, c.y, e.x, e.y, f.x, f.y, d.x, d.y) && 0 <= ma(d.prev, d, d.next)) return !1;
      d = d.prevZ;
      if (a !== e.prev && a !== e.next && fc(c.x, c.y, e.x, e.y, f.x, f.y, a.x, a.y) && 0 <= ma(a.prev, a, a.next)) return !1;
      a = a.nextZ;
    }
    for (; d && d.z >= k; ) {
      if (d !== e.prev && d !== e.next && fc(c.x, c.y, e.x, e.y, f.x, f.y, d.x, d.y) && 0 <= ma(d.prev, d, d.next)) return !1;
      d = d.prevZ;
    }
    for (; a && a.z <= b; ) {
      if (a !== e.prev && a !== e.next && fc(c.x, c.y, e.x, e.y, f.x, f.y, a.x, a.y) && 0 <= ma(a.prev, a, a.next)) return !1;
      a = a.nextZ;
    }
    return !0;
  }
  function Oi(e, b) {
    return e.x - b.x;
  }
  function Pi(e, b) {
    var d = b,
      a = e.x,
      c = e.y,
      f = -Infinity;
    do {
      if (c <= d.y && c >= d.next.y && d.next.y !== d.y) {
        var h = d.x + ((c - d.y) * (d.next.x - d.x)) / (d.next.y - d.y);
        if (h <= a && h > f) {
          f = h;
          if (h === a) {
            if (c === d.y) return d;
            if (c === d.next.y) return d.next;
          }
          var g = d.x < d.next.x ? d : d.next;
        }
      }
      d = d.next;
    } while (d !== b);
    if (!g) return null;
    if (a === f) return g;
    b = g;
    h = g.x;
    var k = g.y,
      l = Infinity;
    d = g;
    do {
      if (a >= d.x && d.x >= h && a !== d.x && fc(c < k ? a : f, c, h, k, c < k ? f : a, c, d.x, d.y)) {
        var n = Math.abs(c - d.y) / (a - d.x);
        var m;
        if ((m = Gc(d, e)) && !(m = n < l) && (m = n === l) && !(m = d.x > g.x) && (m = d.x === g.x)) {
          m = g;
          var p = d;
          m = 0 > ma(m.prev, m, p.prev) && 0 > ma(p.next, m, m.next);
        }
        m && ((g = d), (l = n));
      }
      d = d.next;
    } while (d !== b);
    return g;
  }
  function ue(e, b, d, a, c) {
    e = 32767 * (e - d) * c;
    b = 32767 * (b - a) * c;
    e = (e | (e << 8)) & 16711935;
    e = (e | (e << 4)) & 252645135;
    e = (e | (e << 2)) & 858993459;
    b = (b | (b << 8)) & 16711935;
    b = (b | (b << 4)) & 252645135;
    b = (b | (b << 2)) & 858993459;
    return ((e | (e << 1)) & 1431655765) | (((b | (b << 1)) & 1431655765) << 1);
  }
  function Ni(e) {
    var b = e,
      d = e;
    do {
      if (b.x < d.x || (b.x === d.x && b.y < d.y)) d = b;
      b = b.next;
    } while (b !== e);
    return d;
  }
  function fc(e, b, d, a, c, f, h, g) {
    return 0 <= (c - h) * (b - g) - (e - h) * (f - g) && 0 <= (e - h) * (a - g) - (d - h) * (b - g) && 0 <= (d - h) * (f - g) - (c - h) * (a - g);
  }
  function ma(e, b, d) {
    return (b.y - e.y) * (d.x - b.x) - (b.x - e.x) * (d.y - b.y);
  }
  function td(e, b) {
    return e.x === b.x && e.y === b.y;
  }
  function Wf(e, b, d, a) {
    var c = ud(ma(e, b, d)),
      f = ud(ma(e, b, a)),
      h = ud(ma(d, a, e)),
      g = ud(ma(d, a, b));
    return (c !== f && h !== g) || (0 === c && vd(e, d, b)) || (0 === f && vd(e, a, b)) || (0 === h && vd(d, e, a)) || (0 === g && vd(d, b, a)) ? !0 : !1;
  }
  function vd(e, b, d) {
    return b.x <= Math.max(e.x, d.x) && b.x >= Math.min(e.x, d.x) && b.y <= Math.max(e.y, d.y) && b.y >= Math.min(e.y, d.y);
  }
  function ud(e) {
    return 0 < e ? 1 : 0 > e ? -1 : 0;
  }
  function Gc(e, b) {
    return 0 > ma(e.prev, e, e.next) ? 0 <= ma(e, b, e.next) && 0 <= ma(e, e.prev, b) : 0 > ma(e, b, e.prev) || 0 > ma(e, e.next, b);
  }
  function Uf(e, b) {
    var d = new ve(e.i, e.x, e.y),
      a = new ve(b.i, b.x, b.y),
      c = e.next,
      f = b.prev;
    e.next = b;
    b.prev = e;
    d.next = c;
    c.prev = d;
    a.next = d;
    d.prev = a;
    f.next = a;
    a.prev = f;
    return a;
  }
  function Vf(e, b, d, a) {
    e = new ve(e, b, d);
    a ? ((e.next = a.next), (e.prev = a), (a.next.prev = e), (a.next = e)) : ((e.prev = e), (e.next = e));
    return e;
  }
  function Fc(e) {
    e.next.prev = e.prev;
    e.prev.next = e.next;
    e.prevZ && (e.prevZ.nextZ = e.nextZ);
    e.nextZ && (e.nextZ.prevZ = e.prevZ);
  }
  function ve(e, b, d) {
    this.i = e;
    this.x = b;
    this.y = d;
    this.nextZ = this.prevZ = this.z = this.next = this.prev = null;
    this.steiner = !1;
  }
  function te(e, b, d, a) {
    for (var c = 0, f = d - a; b < d; b += a) (c += (e[f] - e[b]) * (e[b + 1] + e[f + 1])), (f = b);
    return c;
  }
  function Xf(e) {
    try {
      return wd.createObjectURL(new Blob([e], { type: "application/javascript" }));
    } catch (d) {
      var b = new Ri();
      b.append(e);
      return wd.createObjectURL(b.getBlob(type));
    }
  }
  function Qb(e, b) {
    this.shapeLayer = e;
    this.gl = b;
    this.initData();
  }
  function Yf(e, b, d, a) {
    var c = [];
    a = (a * Math.PI) / 180;
    c[0] = (e - d[0]) * Math.cos(a) - (b - d[1]) * Math.sin(a) + d[0];
    c[1] = (e - d[0]) * Math.sin(a) + (b - d[1]) * Math.cos(a) + d[1];
    return c;
  }
  function zb(e) {
    var b = 0,
      d = 0,
      a = !0,
      c = !1,
      f = void 0;
    try {
      for (var h = gc(e), g; !(a = (g = h.next()).done); a = !0) {
        var k = g.value;
        b += k.w * k.h;
        d = Math.max(d, k.w);
      }
    } catch (v) {
      (c = !0), (f = v);
    } finally {
      try {
        !a && h.return && h.return();
      } finally {
        if (c) throw f;
      }
    }
    e.sort(function (a, c) {
      return c.h - a.h;
    });
    d = [{ x: 0, y: 0, w: Math.max(Math.ceil(Math.sqrt(b / 0.95)), d), h: Infinity }];
    c = a = 0;
    f = !0;
    h = !1;
    g = void 0;
    try {
      for (var l = gc(e), n; !(f = (n = l.next()).done); f = !0)
        for (var m = n.value, p = d.length - 1; 0 <= p; p--) {
          var q = d[p];
          if (!(m.w > q.w || m.h > q.h)) {
            m.x = q.x;
            m.y = q.y;
            c = Math.max(c, m.y + m.h);
            a = Math.max(a, m.x + m.w);
            if (m.w === q.w && m.h === q.h) {
              var t = d.pop();
              p < d.length && (d[p] = t);
            } else m.h === q.h ? ((q.x += m.w), (q.w -= m.w)) : (m.w !== q.w && d.push({ x: q.x + m.w, y: q.y, w: q.w - m.w, h: m.h }), (q.y += m.h), (q.h -= m.h));
            break;
          }
        }
    } catch (v) {
      (h = !0), (g = v);
    } finally {
      try {
        !f && l.return && l.return();
      } finally {
        if (h) throw g;
      }
    }
    return { w: a, h: c, fill: b / (a * c) || 0 };
  }
  function Zf() {
    we = !0;
    for (var e = 0; 64 > e; ++e)
      (bb[e] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[e]), (Qa["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charCodeAt(e)] = e);
    Qa[45] = 62;
    Qa[95] = 63;
  }
  function Si(e, b, d) {
    for (var a = [], c = b; c < d; c += 3) (b = (e[c] << 16) + (e[c + 1] << 8) + e[c + 2]), a.push(bb[(b >> 18) & 63] + bb[(b >> 12) & 63] + bb[(b >> 6) & 63] + bb[b & 63]);
    return a.join("");
  }
  function $f(e) {
    we || Zf();
    for (var b = e.length, d = b % 3, a = "", c = [], f = 0, h = b - d; f < h; f += 16383) c.push(Si(e, f, f + 16383 > h ? h : f + 16383));
    1 === d
      ? ((e = e[b - 1]), (a += bb[e >> 2]), (a += bb[(e << 4) & 63]), (a += "=="))
      : 2 === d && ((e = (e[b - 2] << 8) + e[b - 1]), (a += bb[e >> 10]), (a += bb[(e >> 4) & 63]), (a += bb[(e << 2) & 63]), (a += "="));
    c.push(a);
    return c.join("");
  }
  function xd(e, b, d, a, c) {
    var f = 8 * c - a - 1;
    var h = (1 << f) - 1,
      g = h >> 1,
      k = -7;
    c = d ? c - 1 : 0;
    var l = d ? -1 : 1,
      n = e[b + c];
    c += l;
    d = n & ((1 << -k) - 1);
    n >>= -k;
    for (k += f; 0 < k; d = 256 * d + e[b + c], c += l, k -= 8);
    f = d & ((1 << -k) - 1);
    d >>= -k;
    for (k += a; 0 < k; f = 256 * f + e[b + c], c += l, k -= 8);
    if (0 === d) d = 1 - g;
    else {
      if (d === h) return f ? NaN : Infinity * (n ? -1 : 1);
      f += Math.pow(2, a);
      d -= g;
    }
    return (n ? -1 : 1) * f * Math.pow(2, d - a);
  }
  function ag(e, b, d, a, c, f) {
    var h,
      g = 8 * f - c - 1,
      k = (1 << g) - 1,
      l = k >> 1,
      n = 23 === c ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    f = a ? 0 : f - 1;
    var m = a ? 1 : -1,
      p = 0 > b || (0 === b && 0 > 1 / b) ? 1 : 0;
    b = Math.abs(b);
    isNaN(b) || Infinity === b
      ? ((b = isNaN(b) ? 1 : 0), (a = k))
      : ((a = Math.floor(Math.log(b) / Math.LN2)),
        1 > b * (h = Math.pow(2, -a)) && (a--, (h *= 2)),
        (b = 1 <= a + l ? b + n / h : b + n * Math.pow(2, 1 - l)),
        2 <= b * h && (a++, (h /= 2)),
        a + l >= k ? ((b = 0), (a = k)) : 1 <= a + l ? ((b = (b * h - 1) * Math.pow(2, c)), (a += l)) : ((b = b * Math.pow(2, l - 1) * Math.pow(2, c)), (a = 0)));
    for (; 8 <= c; e[d + f] = b & 255, f += m, b /= 256, c -= 8);
    a = (a << c) | b;
    for (g += c; 0 < g; e[d + f] = a & 255, f += m, a /= 256, g -= 8);
    e[d + f - m] |= 128 * p;
  }
  function ob(e, b) {
    if ((z.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823) < b) throw new RangeError("Invalid typed array length");
    z.TYPED_ARRAY_SUPPORT ? ((e = new Uint8Array(b)), (e.__proto__ = z.prototype)) : (null === e && (e = new z(b)), (e.length = b));
    return e;
  }
  function z(e, b, d) {
    if (!(z.TYPED_ARRAY_SUPPORT || this instanceof z)) return new z(e, b, d);
    if ("number" === typeof e) {
      if ("string" === typeof b) throw Error("If encoding is specified then the first argument must be a string");
      return xe(this, e);
    }
    return bg(this, e, b, d);
  }
  function bg(e, b, d, a) {
    if ("number" === typeof b) throw new TypeError('"value" argument must not be a number');
    if ("undefined" !== typeof ArrayBuffer && b instanceof ArrayBuffer) {
      b.byteLength;
      if (0 > d || b.byteLength < d) throw new RangeError("'offset' is out of bounds");
      if (b.byteLength < d + (a || 0)) throw new RangeError("'length' is out of bounds");
      b = void 0 === d && void 0 === a ? new Uint8Array(b) : void 0 === a ? new Uint8Array(b, d) : new Uint8Array(b, d, a);
      z.TYPED_ARRAY_SUPPORT ? ((e = b), (e.__proto__ = z.prototype)) : (e = ye(e, b));
      return e;
    }
    if ("string" === typeof b) {
      a = e;
      e = d;
      if ("string" !== typeof e || "" === e) e = "utf8";
      if (!z.isEncoding(e)) throw new TypeError('"encoding" must be a valid string encoding');
      d = cg(b, e) | 0;
      a = ob(a, d);
      b = a.write(b, e);
      b !== d && (a = a.slice(0, b));
      return a;
    }
    return Ti(e, b);
  }
  function dg(e) {
    if ("number" !== typeof e) throw new TypeError('"size" argument must be a number');
    if (0 > e) throw new RangeError('"size" argument must not be negative');
  }
  function xe(e, b) {
    dg(b);
    e = ob(e, 0 > b ? 0 : ze(b) | 0);
    if (!z.TYPED_ARRAY_SUPPORT) for (var d = 0; d < b; ++d) e[d] = 0;
    return e;
  }
  function ye(e, b) {
    var d = 0 > b.length ? 0 : ze(b.length) | 0;
    e = ob(e, d);
    for (var a = 0; a < d; a += 1) e[a] = b[a] & 255;
    return e;
  }
  function Ti(e, b) {
    if (cb(b)) {
      var d = ze(b.length) | 0;
      e = ob(e, d);
      if (0 === e.length) return e;
      b.copy(e, 0, 0, d);
      return e;
    }
    if (b) {
      if (("undefined" !== typeof ArrayBuffer && b.buffer instanceof ArrayBuffer) || "length" in b)
        return (d = "number" !== typeof b.length) || ((d = b.length), (d = d !== d)), d ? ob(e, 0) : ye(e, b);
      if ("Buffer" === b.type && eg(b.data)) return ye(e, b.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
  }
  function ze(e) {
    if (e >= (z.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823))
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + (z.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823).toString(16) + " bytes");
    return e | 0;
  }
  function cb(e) {
    return !(null == e || !e._isBuffer);
  }
  function cg(e, b) {
    if (cb(e)) return e.length;
    if ("undefined" !== typeof ArrayBuffer && "function" === typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
    "string" !== typeof e && (e = "" + e);
    var d = e.length;
    if (0 === d) return 0;
    for (var a = !1; ; )
      switch (b) {
        case "ascii":
        case "latin1":
        case "binary":
          return d;
        case "utf8":
        case "utf-8":
        case void 0:
          return yd(e).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return 2 * d;
        case "hex":
          return d >>> 1;
        case "base64":
          return fg(e).length;
        default:
          if (a) return yd(e).length;
          b = ("" + b).toLowerCase();
          a = !0;
      }
  }
  function Ui(e, b, d) {
    var a = !1;
    if (void 0 === b || 0 > b) b = 0;
    if (b > this.length) return "";
    if (void 0 === d || d > this.length) d = this.length;
    if (0 >= d) return "";
    d >>>= 0;
    b >>>= 0;
    if (d <= b) return "";
    for (e || (e = "utf8"); ; )
      switch (e) {
        case "hex":
          e = b;
          b = d;
          d = this.length;
          if (!e || 0 > e) e = 0;
          if (!b || 0 > b || b > d) b = d;
          a = "";
          for (d = e; d < b; ++d) (e = a), (a = this[d]), (a = 16 > a ? "0" + a.toString(16) : a.toString(16)), (a = e + a);
          return a;
        case "utf8":
        case "utf-8":
          return gg(this, b, d);
        case "ascii":
          e = "";
          for (d = Math.min(this.length, d); b < d; ++b) e += String.fromCharCode(this[b] & 127);
          return e;
        case "latin1":
        case "binary":
          e = "";
          for (d = Math.min(this.length, d); b < d; ++b) e += String.fromCharCode(this[b]);
          return e;
        case "base64":
          return (b = 0 === b && d === this.length ? $f(this) : $f(this.slice(b, d))), b;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          b = this.slice(b, d);
          d = "";
          for (e = 0; e < b.length; e += 2) d += String.fromCharCode(b[e] + 256 * b[e + 1]);
          return d;
        default:
          if (a) throw new TypeError("Unknown encoding: " + e);
          e = (e + "").toLowerCase();
          a = !0;
      }
  }
  function Rb(e, b, d) {
    var a = e[b];
    e[b] = e[d];
    e[d] = a;
  }
  function hg(e, b, d, a, c) {
    if (0 === e.length) return -1;
    "string" === typeof d ? ((a = d), (d = 0)) : 2147483647 < d ? (d = 2147483647) : -2147483648 > d && (d = -2147483648);
    d = +d;
    isNaN(d) && (d = c ? 0 : e.length - 1);
    0 > d && (d = e.length + d);
    if (d >= e.length) {
      if (c) return -1;
      d = e.length - 1;
    } else if (0 > d)
      if (c) d = 0;
      else return -1;
    "string" === typeof b && (b = z.from(b, a));
    if (cb(b)) return 0 === b.length ? -1 : ig(e, b, d, a, c);
    if ("number" === typeof b)
      return (
        (b &= 255),
        z.TYPED_ARRAY_SUPPORT && "function" === typeof Uint8Array.prototype.indexOf
          ? c
            ? Uint8Array.prototype.indexOf.call(e, b, d)
            : Uint8Array.prototype.lastIndexOf.call(e, b, d)
          : ig(e, [b], d, a, c)
      );
    throw new TypeError("val must be string, number or Buffer");
  }
  function ig(e, b, d, a, c) {
    function f(a, c) {
      return 1 === h ? a[c] : a.readUInt16BE(c * h);
    }
    var h = 1,
      g = e.length,
      k = b.length;
    if (void 0 !== a && ((a = String(a).toLowerCase()), "ucs2" === a || "ucs-2" === a || "utf16le" === a || "utf-16le" === a)) {
      if (2 > e.length || 2 > b.length) return -1;
      h = 2;
      g /= 2;
      k /= 2;
      d /= 2;
    }
    if (c)
      for (a = -1; d < g; d++)
        if (f(e, d) === f(b, -1 === a ? 0 : d - a)) {
          if ((-1 === a && (a = d), d - a + 1 === k)) return a * h;
        } else -1 !== a && (d -= d - a), (a = -1);
    else
      for (d + k > g && (d = g - k); 0 <= d; d--) {
        g = !0;
        for (a = 0; a < k; a++)
          if (f(e, d + a) !== f(b, a)) {
            g = !1;
            break;
          }
        if (g) return d;
      }
    return -1;
  }
  function gg(e, b, d) {
    d = Math.min(e.length, d);
    for (var a = []; b < d; ) {
      var c = e[b],
        f = null,
        h = 239 < c ? 4 : 223 < c ? 3 : 191 < c ? 2 : 1;
      if (b + h <= d)
        switch (h) {
          case 1:
            128 > c && (f = c);
            break;
          case 2:
            var g = e[b + 1];
            128 === (g & 192) && ((c = ((c & 31) << 6) | (g & 63)), 127 < c && (f = c));
            break;
          case 3:
            g = e[b + 1];
            var k = e[b + 2];
            128 === (g & 192) && 128 === (k & 192) && ((c = ((c & 15) << 12) | ((g & 63) << 6) | (k & 63)), 2047 < c && (55296 > c || 57343 < c) && (f = c));
            break;
          case 4:
            g = e[b + 1];
            k = e[b + 2];
            var l = e[b + 3];
            128 === (g & 192) &&
              128 === (k & 192) &&
              128 === (l & 192) &&
              ((c = ((c & 15) << 18) | ((g & 63) << 12) | ((k & 63) << 6) | (l & 63)), 65535 < c && 1114112 > c && (f = c));
        }
      null === f ? ((f = 65533), (h = 1)) : 65535 < f && ((f -= 65536), a.push(((f >>> 10) & 1023) | 55296), (f = 56320 | (f & 1023)));
      a.push(f);
      b += h;
    }
    e = a.length;
    if (e <= jg) a = String.fromCharCode.apply(String, a);
    else {
      d = "";
      for (b = 0; b < e; ) d += String.fromCharCode.apply(String, a.slice(b, (b += jg)));
      a = d;
    }
    return a;
  }
  function va(e, b, d) {
    if (0 !== e % 1 || 0 > e) throw new RangeError("offset is not uint");
    if (e + b > d) throw new RangeError("Trying to access beyond buffer length");
  }
  function Ia(e, b, d, a, c, f) {
    if (!cb(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (b > c || b < f) throw new RangeError('"value" argument is out of bounds');
    if (d + a > e.length) throw new RangeError("Index out of range");
  }
  function zd(e, b, d, a) {
    0 > b && (b = 65535 + b + 1);
    for (var c = 0, f = Math.min(e.length - d, 2); c < f; ++c) e[d + c] = (b & (255 << (8 * (a ? c : 1 - c)))) >>> (8 * (a ? c : 1 - c));
  }
  function Ad(e, b, d, a) {
    0 > b && (b = 4294967295 + b + 1);
    for (var c = 0, f = Math.min(e.length - d, 4); c < f; ++c) e[d + c] = (b >>> (8 * (a ? c : 3 - c))) & 255;
  }
  function kg(e, b, d, a, c, f) {
    if (d + a > e.length) throw new RangeError("Index out of range");
    if (0 > d) throw new RangeError("Index out of range");
  }
  function lg(e, b, d, a, c) {
    c || kg(e, b, d, 4, 3.4028234663852886e38, -3.4028234663852886e38);
    ag(e, b, d, a, 23, 4);
    return d + 4;
  }
  function mg(e, b, d, a, c) {
    c || kg(e, b, d, 8, 1.7976931348623157e308, -1.7976931348623157e308);
    ag(e, b, d, a, 52, 8);
    return d + 8;
  }
  function yd(e, b) {
    b = b || Infinity;
    for (var d, a = e.length, c = null, f = [], h = 0; h < a; ++h) {
      d = e.charCodeAt(h);
      if (55295 < d && 57344 > d) {
        if (!c) {
          if (56319 < d) {
            -1 < (b -= 3) && f.push(239, 191, 189);
            continue;
          } else if (h + 1 === a) {
            -1 < (b -= 3) && f.push(239, 191, 189);
            continue;
          }
          c = d;
          continue;
        }
        if (56320 > d) {
          -1 < (b -= 3) && f.push(239, 191, 189);
          c = d;
          continue;
        }
        d = (((c - 55296) << 10) | (d - 56320)) + 65536;
      } else c && -1 < (b -= 3) && f.push(239, 191, 189);
      c = null;
      if (128 > d) {
        if (0 > --b) break;
        f.push(d);
      } else if (2048 > d) {
        if (0 > (b -= 2)) break;
        f.push((d >> 6) | 192, (d & 63) | 128);
      } else if (65536 > d) {
        if (0 > (b -= 3)) break;
        f.push((d >> 12) | 224, ((d >> 6) & 63) | 128, (d & 63) | 128);
      } else if (1114112 > d) {
        if (0 > (b -= 4)) break;
        f.push((d >> 18) | 240, ((d >> 12) & 63) | 128, ((d >> 6) & 63) | 128, (d & 63) | 128);
      } else throw Error("Invalid code point");
    }
    return f;
  }
  function ng(e) {
    for (var b = [], d = 0; d < e.length; ++d) b.push(e.charCodeAt(d) & 255);
    return b;
  }
  function fg(e) {
    e = (e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "")).replace(Vi, "");
    if (2 > e.length) e = "";
    else for (; 0 !== e.length % 4; ) e += "=";
    we || Zf();
    var b = e.length;
    if (0 < b % 4) throw Error("Invalid string. Length must be a multiple of 4");
    var d = "=" === e[b - 2] ? 2 : "=" === e[b - 1] ? 1 : 0;
    var a = new Wi((3 * b) / 4 - d);
    var c = 0 < d ? b - 4 : b;
    var f = 0;
    for (b = 0; b < c; b += 4) {
      var h = (Qa[e.charCodeAt(b)] << 18) | (Qa[e.charCodeAt(b + 1)] << 12) | (Qa[e.charCodeAt(b + 2)] << 6) | Qa[e.charCodeAt(b + 3)];
      a[f++] = (h >> 16) & 255;
      a[f++] = (h >> 8) & 255;
      a[f++] = h & 255;
    }
    2 === d
      ? ((h = (Qa[e.charCodeAt(b)] << 2) | (Qa[e.charCodeAt(b + 1)] >> 4)), (a[f++] = h & 255))
      : 1 === d && ((h = (Qa[e.charCodeAt(b)] << 10) | (Qa[e.charCodeAt(b + 1)] << 4) | (Qa[e.charCodeAt(b + 2)] >> 2)), (a[f++] = (h >> 8) & 255), (a[f++] = h & 255));
    return a;
  }
  function Hc(e, b, d, a) {
    for (var c = 0; c < a && !(c + d >= b.length || c >= e.length); ++c) b[c + d] = e[c];
    return c;
  }
  function og(e) {
    return !!e.constructor && "function" === typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
  }
  function Ra(e, b) {
    var d = [];
    e.forEach(function (a) {
      d.push(b ? -a : a, a);
    });
    return d;
  }
  function pg(e) {
    for (var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, d = [], a = 0; a < e - 1; a++) {
      var c = 2 * (a + b);
      d.push(c, c + 1, c + 2);
      d.push(c + 2, c + 1, c + 3);
    }
    return d;
  }
  function Bd(e) {
    return function (b, d, a) {
      b = d + e;
      d = a.length - 1;
      return a[0 < d ? (0 > b ? 0 : b > d ? d : b) : b < d ? d : 0 < b ? 0 : b];
    };
  }
  function db(e) {
    if (!e[0] || !e[0].length) return e;
    for (var b = e[0].length, d = [], a = 0, c = 0; c < e.length; c++) for (var f = 0; f < b; f++) d[a++] = e[c][f];
    return d;
  }
  function qg() {
    for (var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [], b = [], d = 0, a = 0; a < e.length; a++) {
      var c = e[a];
      if (0 < a) {
        var f = e[a - 1];
        d += Math.sqrt(Math.pow(c[0] - f[0], 2) + Math.pow(c[1] - f[1], 2));
      }
      b.push(d);
    }
    return { arr: b, total: d };
  }
  function rg() {
    var e = document.createElement("canvas");
    e.width = e.height = 32;
    var b = e.getContext("2d");
    return { canvas: e, ctx: b };
  }
  function sg() {
    var e = (0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}).color,
      b = rg(),
      d = b.canvas;
    b = b.ctx;
    b.save();
    b.moveTo(0, 0);
    b.lineTo(20, 0);
    b.lineTo(32, 16);
    b.lineTo(20, 32);
    b.lineTo(0, 32);
    b.lineTo(10, 16);
    b.fillStyle = e || "#fff";
    b.fill();
    b.restore();
    return d;
  }
  function Cd(e, b) {
    return Z.set(e, -b[1], b[0]);
  }
  function tg(e, b, d) {
    Z.sub(e, b, d);
    Z.normalize(e, e);
    return e;
  }
  function Xi(e) {
    var b, d;
    this.promise = new e(function (a, c) {
      if (void 0 !== b || void 0 !== d) throw TypeError("Bad Promise constructor");
      b = a;
      d = c;
    });
    this.resolve = Sb(b);
    this.reject = Sb(d);
  }
  function Yi(e, b, d) {
    d = (Math.PI / 180) * (60 * d + 30);
    return [e.x + b * Math.cos(d), e.y + b * Math.sin(d)];
  }
  function Zi(e, b, d) {
    for (var a = {}, c = [], f = e.length, h = b / 2 / Math.sin(Math.PI / 3), g = 1.5 * h, k = 1, l = 0; l < f; ++l) {
      var n = e[l].geometry.coordinates;
      d && (n = d(n));
      var m = +n[0],
        p = +n[1];
      if (!isNaN(m) && !isNaN(p)) {
        n = Math.round((p /= g));
        var q = Math.round((m = m / b - (n & 1) / 2)),
          t = p - n;
        if (1 < 3 * Math.abs(t)) {
          var v = m - q,
            r = q + (m < q ? -1 : 1) / 2,
            u = n + (p < n ? -1 : 1);
          m -= r;
          p -= u;
          v * v + t * t > m * m + p * p && ((q = r + (n & 1 ? 1 : -1) / 2), (n = u));
        }
        t = q + "-" + n;
        (v = a[t])
          ? ((v.count += e[l].count || 1), (k = Math.max(k, v.count)))
          : ((a[t] = { center: { x: (q + (n & 1) / 2) * b, y: n * g }, count: e[l].count || 1 }), c.push(a[t]));
      }
    }
    c.max = k;
    c.r = h;
    return c;
  }
  function $i(e, b, d, a) {
    switch (a) {
      case 5122:
        return new Int16Array(e, b, d);
      case 5123:
        return new Uint16Array(e, b, d);
      case 5124:
        return new Int32Array(e, b, d);
      case 5125:
        return new Uint32Array(e, b, d);
      case 5126:
        return new Float32Array(e, b, d);
      default:
        return null;
    }
  }
  function Dd(e) {
    return $i(e.bufferView.data, e.byteOffset, e.count * Ae[e.type], e.componentType);
  }
  function aj(e) {
    var b = "",
      d = e.lastIndexOf("/");
    -1 !== d && (b = e.substring(0, d + 1));
    return b;
  }
  function bj(e, b) {
    var d = new XMLHttpRequest();
    d.overrideMimeType("application/json");
    d.open("GET", e, !0);
    d.onreadystatechange = function () {
      4 == d.readyState && "200" == d.status && b(d.responseText, this);
    };
    d.send(null);
  }
  function cj(e, b) {
    var d = new XMLHttpRequest();
    d.responseType = "arraybuffer";
    d.open("GET", e, !0);
    d.onreadystatechange = function () {
      if (4 == d.readyState && "200" == d.status) {
        var a = d.response;
        a && b && b(a);
      }
    };
    d.send(null);
  }
  function dj(e, b, d) {
    var a = new Image();
    a.crossOrigin = "Anonymous";
    a.src = e;
    a.onload = function () {
      d(a, b);
    };
  }
  function ej(e) {
    function b(a, c) {
      d.uniform1i(a, c.index);
      d.activeTexture(d.TEXTURE0 + c.index);
      a = C.glTF.textures[c.index];
      d.bindTexture(d.TEXTURE_2D, a.texture);
      d.bindSampler(c.index, a.sampler ? a.sampler.sampler : h);
    }
    var d = e.gl,
      a = 0,
      c = [];
    e = d.canvas;
    var f = function (a, c, b) {
        this.glTFScene = a;
        this.glTF = c;
        this.id = b;
        this.rootTransform = L.create();
        this.nodeMatrix = Array(c.nodes.length);
        a = 0;
        for (c = this.nodeMatrix.length; a < c; a++) this.nodeMatrix[a] = L.create();
      },
      h = d.createSampler();
    d.samplerParameteri(h, d.TEXTURE_MIN_FILTER, d.NEAREST_MIPMAP_LINEAR);
    d.samplerParameteri(h, d.TEXTURE_MAG_FILTER, d.LINEAR);
    d.samplerParameteri(h, d.TEXTURE_WRAP_S, d.REPEAT);
    d.samplerParameteri(h, d.TEXTURE_WRAP_T, d.REPEAT);
    d.bindVertexArray(null);
    d.bindVertexArray(null);
    var g = { HAS_SKIN: 1, SKIN_VEC8: 2, HAS_BASECOLORMAP: 4, HAS_NORMALMAP: 8, HAS_METALROUGHNESSMAP: 16, HAS_OCCLUSIONMAP: 32, HAS_EMISSIVEMAP: 64 },
      k = {},
      l = function () {
        this.flags = 0;
        this.programObject = null;
      };
    l.prototype.hasSkin = function () {
      return this.flags & g.HAS_SKIN;
    };
    l.prototype.hasBaseColorMap = function () {
      return this.flags & g.HAS_BASECOLORMAP;
    };
    l.prototype.hasNormalMap = function () {
      return this.flags & g.HAS_NORMALMAP;
    };
    l.prototype.hasMetalRoughnessMap = function () {
      return this.flags & g.HAS_METALROUGHNESSMAP;
    };
    l.prototype.hasOcclusionMap = function () {
      return this.flags & g.HAS_OCCLUSIONMAP;
    };
    l.prototype.hasEmissiveMap = function () {
      return this.flags & g.HAS_EMISSIVEMAP;
    };
    l.prototype.defineMacro = function (a) {
      void 0 !== g[a] && (this.flags |= g[a]);
    };
    l.prototype.compile = function () {
      var a = k[this.flags];
      if (a) this.programObject = a;
      else {
        var c = (a = "");
        this.flags & g.HAS_SKIN && (a += "#define HAS_SKIN\n");
        this.flags & g.SKIN_VEC8 && (a += "#define SKIN_VEC8\n");
        this.flags & g.HAS_BASECOLORMAP && (c += "#define HAS_BASECOLORMAP\n");
        this.flags & g.HAS_NORMALMAP && (c += "#define HAS_NORMALMAP\n");
        this.flags & g.HAS_METALROUGHNESSMAP && (c += "#define HAS_METALROUGHNESSMAP\n");
        this.flags & g.HAS_OCCLUSIONMAP && (c += "#define HAS_OCCLUSIONMAP\n");
        this.flags & g.HAS_EMISSIVEMAP && (c += "#define HAS_EMISSIVEMAP\n");
        a = hc.createProgram(
          d,
          "#version 300 es\n" +
            a +
            "#define POSITION_LOCATION 0\n#define NORMAL_LOCATION 1\n#define TEXCOORD_0_LOCATION 2\n#define JOINTS_0_LOCATION 3\n#define JOINTS_1_LOCATION 5\n#define WEIGHTS_0_LOCATION 4\n#define WEIGHTS_1_LOCATION 6\n#define TANGENT_LOCATION 7\nprecision highp float;precision highp int;uniform mat4 u_MVP;uniform mat4 u_MV;uniform mat4 u_MVNormal;\n#ifdef HAS_SKIN\nuniform JointMatrix{mat4 matrix[65];}u_jointMatrix;\n#endif\nlayout(location=POSITION_LOCATION)in vec3 position;layout(location=NORMAL_LOCATION)in vec3 normal;layout(location=TEXCOORD_0_LOCATION)in vec2 uv;\n#ifdef HAS_SKIN\nlayout(location=JOINTS_0_LOCATION)in vec4 joint0;layout(location=WEIGHTS_0_LOCATION)in vec4 weight0;\n#ifdef SKIN_VEC8\nlayout(location=JOINTS_1_LOCATION)in vec4 joint1;layout(location=WEIGHTS_1_LOCATION)in vec4 weight1;\n#endif\n#endif\nout vec3 v_position;out vec3 v_normal;out vec2 v_uv;void main(){\n#ifdef HAS_SKIN\nmat4 skinMatrix=weight0.x*u_jointMatrix.matrix[int(joint0.x)]+weight0.y*u_jointMatrix.matrix[int(joint0.y)]+weight0.z*u_jointMatrix.matrix[int(joint0.z)]+weight0.w*u_jointMatrix.matrix[int(joint0.w)];\n#ifdef SKIN_VEC8\nskinMatrix+=weight1.x*u_jointMatrix.matrix[int(joint1.x)]+weight1.y*u_jointMatrix.matrix[int(joint1.y)]+weight1.z*u_jointMatrix.matrix[int(joint1.z)]+weight1.w*u_jointMatrix.matrix[int(joint1.w)];\n#endif\n#endif\nv_uv=uv;\n#ifdef HAS_SKIN\nv_normal=normalize((u_MVNormal*transpose(inverse(skinMatrix))*vec4(normal,0)).xyz);vec4 pos=u_MV*skinMatrix*vec4(position,1.0);gl_Position=u_MVP*skinMatrix*vec4(position,1.0);\n#else\nv_normal=normalize((u_MVNormal*vec4(normal,0)).xyz);vec4 pos=u_MV*vec4(position,1.0);gl_Position=u_MVP*vec4(position,1.0);\n#endif\nv_position=vec3(pos.xyz)/pos.w;}",
          "#version 300 es\n" +
            c +
            "#define FRAG_COLOR_LOCATION 0\nprecision highp float;precision highp int;uniform sampler2D u_brdfLUT;uniform vec4 u_baseColorFactor;\n#ifdef HAS_BASECOLORMAP\nuniform sampler2D u_baseColorTexture;\n#endif\n#ifdef HAS_NORMALMAP\nuniform sampler2D u_normalTexture;uniform float u_normalTextureScale;\n#endif\n#ifdef HAS_EMISSIVEMAP\nuniform sampler2D u_emissiveTexture;uniform vec3 u_emissiveFactor;\n#endif\n#ifdef HAS_METALROUGHNESSMAP\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\nuniform float u_metallicFactor;uniform float u_roughnessFactor;\n#ifdef HAS_OCCLUSIONMAP\nuniform sampler2D u_occlusionTexture;uniform float u_occlusionStrength;\n#endif\nin vec3 v_position;in vec3 v_normal;in vec2 v_uv;layout(location=FRAG_COLOR_LOCATION)out vec4 frag_color;struct PBRInfo{float NdotL;float NdotV;float NdotH;float LdotH;float VdotH;float perceptualRoughness;float metalness;vec3 reflectance0;vec3 reflectance90;float alphaRoughness;vec3 diffuseColor;vec3 specularColor;};const float M_PI=3.141592653589793;const float c_MinRoughness=0.04;vec3 getNormal(){vec3 pos_dx=dFdx(v_position);vec3 pos_dy=dFdy(v_position);vec3 tex_dx=dFdx(vec3(v_uv,0.0));vec3 tex_dy=dFdy(vec3(v_uv,0.0));vec3 t=(tex_dy.t*pos_dx-tex_dx.t*pos_dy)/(tex_dx.s*tex_dy.t-tex_dy.s*tex_dx.t);vec3 ng=v_normal;t=normalize(t-ng*dot(ng,t));vec3 b=normalize(cross(ng,t));mat3 tbn=mat3(t,b,ng);\n#ifdef HAS_NORMALMAP\nvec3 n=texture(u_normalTexture,v_uv).rgb;n=normalize(tbn*((2.0*n-1.0)*vec3(u_normalTextureScale,u_normalTextureScale,1.0)));\n#else\nvec3 n=tbn[2].xyz;\n#endif\nreturn n;}vec3 getIBLContribution(PBRInfo pbrInputs,vec3 n,vec3 reflection){float mipCount=10.0;float lod=(pbrInputs.perceptualRoughness*mipCount);vec3 brdf=texture(u_brdfLUT,vec2(pbrInputs.NdotV,1.0-pbrInputs.perceptualRoughness)).rgb;vec3 diffuseLight=vec3(0.6,0.6,0.6);vec3 specularLight=vec3(0.6,0.6,0.6);vec3 diffuse=diffuseLight*pbrInputs.diffuseColor;vec3 specular=specularLight*(pbrInputs.specularColor*brdf.x+brdf.y);return diffuse+specular;}vec3 diffuse(PBRInfo pbrInputs){return pbrInputs.diffuseColor/M_PI;}vec3 specularReflection(PBRInfo pbrInputs){return pbrInputs.reflectance0+(pbrInputs.reflectance90-pbrInputs.reflectance0)*pow(clamp(1.0-pbrInputs.VdotH,0.0,1.0),5.0);}float geometricOcclusion(PBRInfo pbrInputs){float NdotL=pbrInputs.NdotL;float NdotV=pbrInputs.NdotV;float r=pbrInputs.alphaRoughness;float attenuationL=2.0*NdotL/(NdotL+sqrt(r*r+(1.0-r*r)*(NdotL*NdotL)));float attenuationV=2.0*NdotV/(NdotV+sqrt(r*r+(1.0-r*r)*(NdotV*NdotV)));return attenuationL*attenuationV;}float microfacetDistribution(PBRInfo pbrInputs){float roughnessSq=pbrInputs.alphaRoughness*pbrInputs.alphaRoughness;float f=(pbrInputs.NdotH*roughnessSq-pbrInputs.NdotH)*pbrInputs.NdotH+1.0;return roughnessSq/(M_PI*f*f);}void main(){float perceptualRoughness=u_roughnessFactor;float metallic=u_metallicFactor;\n#ifdef HAS_METALROUGHNESSMAP\nvec4 mrSample=texture(u_metallicRoughnessTexture,v_uv);perceptualRoughness=mrSample.g*perceptualRoughness;metallic=mrSample.b*metallic;\n#endif\nperceptualRoughness=clamp(perceptualRoughness,c_MinRoughness,1.0);metallic=clamp(metallic,0.0,1.0);float alphaRoughness=perceptualRoughness*perceptualRoughness;\n#ifdef HAS_BASECOLORMAP\nvec4 baseColor=texture(u_baseColorTexture,v_uv)*u_baseColorFactor;\n#else\nvec4 baseColor=u_baseColorFactor;\n#endif\nvec3 f0=vec3(0.04);vec3 diffuseColor=baseColor.rgb*(vec3(1.0)-f0);diffuseColor*=1.0-metallic;vec3 specularColor=mix(f0,baseColor.rgb,metallic);float reflectance=max(max(specularColor.r,specularColor.g),specularColor.b);float reflectance90=clamp(reflectance*25.0,0.0,1.0);vec3 specularEnvironmentR0=specularColor.rgb;vec3 specularEnvironmentR90=vec3(1.0,1.0,1.0)*reflectance90;vec3 n=getNormal();vec3 v=normalize(-v_position);vec3 l=normalize(vec3(1.0,1.0,1.0));vec3 h=normalize(l+v);vec3 reflection=-normalize(reflect(v,n));float NdotL=clamp(dot(n,l),0.001,1.0);float NdotV=abs(dot(n,v))+0.001;float NdotH=clamp(dot(n,h),0.0,1.0);float LdotH=clamp(dot(l,h),0.0,1.0);float VdotH=clamp(dot(v,h),0.0,1.0);PBRInfo pbrInputs=PBRInfo(NdotL,NdotV,NdotH,LdotH,VdotH,perceptualRoughness,metallic,specularEnvironmentR0,specularEnvironmentR90,alphaRoughness,diffuseColor,specularColor);vec3 F=specularReflection(pbrInputs);float G=geometricOcclusion(pbrInputs);float D=microfacetDistribution(pbrInputs);vec3 diffuseContrib=(1.0-F)*diffuse(pbrInputs);vec3 specContrib=max(vec3(0.0),F*G*D/(4.0*NdotL*NdotV));vec3 color=NdotL*(diffuseContrib+specContrib);color+=getIBLContribution(pbrInputs,n,reflection);\n#ifdef HAS_OCCLUSIONMAP\nfloat ao=texture(u_occlusionTexture,v_uv).r;color=mix(color,color*ao,u_occlusionStrength);\n#endif\n#ifdef HAS_EMISSIVEMAP\nvec3 emissive=texture(u_emissiveTexture,v_uv).rgb*u_emissiveFactor;color+=emissive;\n#endif\nfrag_color=vec4(color,baseColor.a);}"
        );
        this.programObject = { program: a, uniformLocations: {}, uniformBlockIndices: {} };
        this.flags & g.HAS_SKIN && (this.programObject.uniformBlockIndices.JointMatrix = d.getUniformBlockIndex(a, "JointMatrix"));
        c = this.programObject.uniformLocations;
        c.MVP = d.getUniformLocation(a, "u_MVP");
        c.MVNormal = d.getUniformLocation(a, "u_MVNormal");
        c.MV = d.getUniformLocation(a, "u_MV");
        c.baseColorFactor = d.getUniformLocation(a, "u_baseColorFactor");
        c.metallicFactor = d.getUniformLocation(a, "u_metallicFactor");
        c.roughnessFactor = d.getUniformLocation(a, "u_roughnessFactor");
        this.flags & g.HAS_BASECOLORMAP && (c.baseColorTexture = d.getUniformLocation(a, "u_baseColorTexture"));
        this.flags & g.HAS_NORMALMAP && ((c.normalTexture = d.getUniformLocation(a, "u_normalTexture")), (c.normalTextureScale = d.getUniformLocation(a, "u_normalTextureScale")));
        this.flags & g.HAS_METALROUGHNESSMAP && (c.metallicRoughnessTexture = d.getUniformLocation(a, "u_metallicRoughnessTexture"));
        this.flags & g.HAS_OCCLUSIONMAP &&
          ((c.occlusionTexture = d.getUniformLocation(a, "u_occlusionTexture")), (c.occlusionStrength = d.getUniformLocation(a, "u_occlusionStrength")));
        this.flags & g.HAS_EMISSIVEMAP && ((c.emissiveTexture = d.getUniformLocation(a, "u_emissiveTexture")), (c.emissiveFactor = d.getUniformLocation(a, "u_emissiveFactor")));
        d.useProgram(null);
        k[this.flags] = this.programObject;
      }
    };
    var n = 1,
      m = P.create(),
      p = L.create();
    Ed.create();
    var q = [];
    d.enable(d.CULL_FACE);
    d.cullFace(d.BACK);
    d.frontFace(d.CCW);
    var t = !0;
    d.enable(d.DEPTH_TEST);
    d.depthFunc(d.LEQUAL);
    var v = v || {},
      r = null;
    P.create();
    var u = L.create();
    L.perspective(u, 0.785, e.width / e.height, 0.01, 100);
    L.create();
    var w = L.create(),
      y = L.create(),
      x = L.create();
    L.create();
    var D,
      C,
      A = [1, 1, 1, 1],
      E = (v.drawPrimitive = function (a, c) {
        if (z) {
          y = w = z.matrix;
          L.invert(x, w);
          L.transpose(x, x);
          c = A;
          var f = a.shader,
            g = a.material;
          if (null !== g) {
            var e = g.pbrMetallicRoughness;
            c = e.baseColorFactor;
            a.material.doubleSided === t && ((t = !a.material.doubleSided) ? d.enable(d.CULL_FACE) : d.disable(d.CULL_FACE));
          }
          r != a.shader.programObject && ((r = a.shader.programObject), d.useProgram(r.program));
          g &&
            (f.hasBaseColorMap() && b(r.uniformLocations.baseColorTexture, e.baseColorTexture),
            f.hasNormalMap() && (b(r.uniformLocations.normalTexture, g.normalTexture), d.uniform1f(r.uniformLocations.normalTextureScale, g.normalTexture.scale)),
            f.hasMetalRoughnessMap() && b(r.uniformLocations.metallicRoughnessTexture, e.metallicRoughnessTexture),
            d.uniform1f(r.uniformLocations.metallicFactor, e.metallicFactor),
            d.uniform1f(r.uniformLocations.roughnessFactor, e.roughnessFactor),
            f.hasOcclusionMap() && (b(r.uniformLocations.occlusionTexture, g.occlusionTexture), d.uniform1f(r.uniformLocations.occlusionStrength, g.occlusionTexture.strength)),
            f.hasEmissiveMap() && (b(r.uniformLocations.emissiveTexture, g.emissiveTexture), d.uniform3fv(r.uniformLocations.emissiveFactor, g.emissiveFactor)));
          f.hasSkin() && d.uniformBlockBinding(r.program, r.uniformBlockIndices.JointMatrix, D);
          d.activeTexture(d.TEXTURE0 + 29);
          d.bindTexture(d.TEXTURE_2D, null);
          d.uniform4fv(r.uniformLocations.baseColorFactor, c);
          d.uniformMatrix4fv(r.uniformLocations.MV, !1, w);
          d.uniformMatrix4fv(r.uniformLocations.MVP, !1, y);
          d.uniformMatrix4fv(r.uniformLocations.MVNormal, !1, x);
          d.bindVertexArray(a.vertexArray);
          null !== a.indices ? d.drawElements(a.mode, a.indicesLength, a.indicesComponentType, a.indicesOffset) : d.drawArrays(a.mode, a.drawArraysOffset, a.drawArraysCount);
          d.bindVertexArray(null);
        }
      }),
      J = L.create(),
      G = L.create(),
      M = (v.drawNode = function (a, c, b, f) {
        c = b[c];
        void 0 !== f ? L.mul(c, f, a.matrix) : L.copy(c, a.matrix);
        if (null !== a.skin) {
          var g = a.skin;
          D = g.uniformBlockID;
          var e = a.skin.joints;
          L.invert(G, c);
          f = 0;
          for (k = e.length; f < k; f++) {
            var h = e[f];
            L.mul(J, b[h.nodeID], g.inverseBindMatrix[f]);
            L.mul(J, G, J);
            g.jointMatrixUnidormBufferData.set(J, 16 * f);
          }
          d.bindBuffer(d.UNIFORM_BUFFER, g.jointMatrixUniformBuffer);
          d.bufferSubData(d.UNIFORM_BUFFER, 0, g.jointMatrixUnidormBufferData, 0, g.jointMatrixUnidormBufferData.length);
        }
        var k;
        if (null !== a.mesh) for (g = a.mesh, f = 0, k = g.primitives.length; f < k; f++) E(g.primitives[f], c);
        null !== a.skin && d.bindBuffer(d.UNIFORM_BUFFER, null);
        f = 0;
        for (k = a.children.length; f < k; f++) M(a.children[f], a.children[f].nodeID, b, c);
      }),
      O = (v.drawScene = function (c) {
        var b = c.glTF;
        if (b.animations) {
          var d = b.animations[a];
          var f;
          var g = 0;
          for (f = d.samplers.length; g < f; g++) d.samplers[g].getValue(B);
          g = 0;
          for (f = d.channels.length; g < f; g++) {
            var e = d.channels[g];
            var h = e.sampler;
            var k = b.nodes[e.target.nodeID];
            switch (e.target.path) {
              case "rotation":
                na.copy(k.rotation, h.curValue);
                break;
              case "translation":
                P.copy(k.translation, h.curValue);
                break;
              case "scale":
                P.copy(k.scale, h.curValue);
            }
            k.updateMatrixFromTRS();
          }
        }
        d = 0;
        for (b = c.glTFScene.nodes.length; d < b; d++) M(c.glTFScene.nodes[d], c.glTFScene.nodes[d].nodeID, c.nodeMatrix, c.rootTransform);
      }),
      T = performance.now(),
      B = 0,
      z;
    return {
      setupScene: function (b, g) {
        function e(a, c) {
          if (void 0 !== a) {
            var b = a.bufferView;
            null === b.target ? (d.bindBuffer(d.ARRAY_BUFFER, b.buffer), d.bufferData(d.ARRAY_BUFFER, b.data, d.STATIC_DRAW)) : d.bindBuffer(b.target, b.buffer);
            a.prepareVertexAttrib(c, d);
            return !0;
          }
          return !1;
        }
        var h;
        if (b.animations) {
          var k = 0;
          for (h = b.animations.length; k < h; k++) c.add(b.animations[k].name || k);
        }
        a = 0;
        k = b.scenes[b.defaultScene];
        P.fromValues(1.2 * k.boundingBox.transform[0], 0, 0);
        P.create();
        g ? (g = q[g.id] = new f(k, b, g.id)) : ((g = new f(k, b, q.length)), q.push(g));
        1 === q.length &&
          (L.identity(p),
          (n = 1 / Math.max(k.boundingBox.transform[0], Math.max(k.boundingBox.transform[5], k.boundingBox.transform[10]))),
          L.getTranslation(m, k.boundingBox.transform),
          P.scale(m, m, -1),
          (m[0] += -0.5 * k.boundingBox.transform[0]),
          (m[1] += -0.5 * k.boundingBox.transform[5]),
          (m[2] += -0.5 * k.boundingBox.transform[10]),
          (n *= 0.5),
          (p[0] = n),
          (p[5] = n),
          (p[10] = n),
          L.translate(p, p, m),
          P.set(m, 0, 0, -1.5),
          (n = 1));
        var t;
        k = 0;
        for (h = b.bufferViews.length; k < h; k++) {
          var v = b.bufferViews[k];
          v.createBuffer(d);
          v.bindData(d);
        }
        if (b.textures)
          for (k = 0, h = b.textures.length; k < h; k++) {
            var r = b.textures[k];
            r.createTexture(d);
          }
        if (b.samplers) for (k = 0, h = b.samplers.length; k < h; k++) (r = b.samplers[k]), r.createSampler(d);
        if (b.skins)
          for (k = 0, h = b.skins.length; k < h; k++)
            (r = b.skins[k]),
              (r.jointMatrixUniformBuffer = d.createBuffer()),
              d.bindBufferBase(d.UNIFORM_BUFFER, r.uniformBlockID, r.jointMatrixUniformBuffer),
              d.bindBuffer(d.UNIFORM_BUFFER, r.jointMatrixUniformBuffer),
              d.bufferData(d.UNIFORM_BUFFER, r.jointMatrixUnidormBufferData, d.DYNAMIC_DRAW),
              d.bufferSubData(d.UNIFORM_BUFFER, 0, r.jointMatrixUnidormBufferData),
              d.bindBuffer(d.UNIFORM_BUFFER, null);
        var w = 0;
        for (t = b.meshes.length; w < t; w++)
          for (r = b.meshes[w], k = 0, h = r.primitives.length; k < h; ++k) {
            var u = r.primitives[k];
            u.shader = new l();
            u.vertexArray = v = d.createVertexArray();
            d.bindVertexArray(v);
            e(u.attributes.POSITION, 0);
            e(u.attributes.NORMAL, 1);
            e(u.attributes.TEXCOORD_0, 2);
            e(u.attributes.JOINTS_0, 3) && e(u.attributes.WEIGHTS_0, 4) && u.shader.defineMacro("HAS_SKIN");
            e(u.attributes.JOINTS_1, 5) && e(u.attributes.WEIGHTS_1, 6) && u.shader.defineMacro("SKIN_VEC8");
            null !== u.indices &&
              ((v = b.accessors[u.indices]),
              (v = v.bufferView),
              null === v.target
                ? (d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, v.buffer), d.bufferData(d.ELEMENT_ARRAY_BUFFER, v.data, d.STATIC_DRAW))
                : d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, v.buffer));
            d.bindVertexArray(null);
            d.bindBuffer(d.ARRAY_BUFFER, null);
            d.bindBuffer(d.ELEMENT_ARRAY_BUFFER, null);
            if ((v = u.material))
              v.pbrMetallicRoughness.baseColorTexture && u.shader.defineMacro("HAS_BASECOLORMAP"),
                v.pbrMetallicRoughness.metallicRoughnessTexture && u.shader.defineMacro("HAS_METALROUGHNESSMAP"),
                v.normalTexture && u.shader.defineMacro("HAS_NORMALMAP"),
                v.occlusionTexture && u.shader.defineMacro("HAS_OCCLUSIONMAP"),
                v.emissiveTexture && u.shader.defineMacro("HAS_EMISSIVEMAP");
            u.shader.compile();
          }
        return g;
      },
      render: (v.render = function (a) {
        z = a;
        a = new Date().getTime();
        var c;
        var b = 0;
        for (c = q.length; b < c; b++) (C = q[b]), O(q[b]);
        r = null;
        B = 0.001 * (a - T);
      })
    };
  }
  function fj(e, b, d, a, c, f) {
    if ("string" == typeof b && "number" == typeof d && "number" == typeof a) for (b = b.split(f), f = 0; f < b.length; f++) e.fillText(b[f], d, a), (a += c);
  }
  function oa(e) {
    this.options = e = e || {};
    e.colors = e.colors || ["rgba(0,192,73,0.99609375)", "rgba(242,48,48,0.99609375)", "rgba(255,159,25,0.99609375)"];
    var b = e.colors;
    this.drawTogether = !0;
    this.parseColors(b);
    this.tileSize = 256;
    this.ratio = window.devicePixelRatio;
    this.cache = {};
    e.getTileUrl && (this.getTileUrl = e.getTileUrl);
    this._loadCount = {};
  }
  function gj(e) {
    var b = e / 2,
      d = e + b,
      a = new ne(2 * d, 2 * d),
      c = a.getContext("2d");
    c.shadowBlur = b;
    c.shadowColor = "black";
    c.shadowOffsetX = c.shadowOffsetY = 1e4;
    c.beginPath();
    c.arc(d - 1e4, d - 1e4, e, 0, 2 * Math.PI, !0);
    c.closePath();
    c.fill();
    return a;
  }
  var Be = window.BMapGL || window.BMap;
  Be && Be.Overlay && (ja.prototype = new Be.Overlay());
  ja.prototype.initialize = function (e) {
    this._map = e;
    var b = (this.canvas = document.createElement("canvas")),
      d = (this.ctx = this.canvas.getContext("2d"));
    b.style.cssText = "position:absolute;left:0;top:0;z-index:" + this.zIndex + ";";
    this.adjustSize();
    this.adjustRatio(d);
    e.getContainer().appendChild(b);
    var a = this;
    e.addEventListener("resize", function () {
      a.adjustSize();
      a._draw();
    });
    return this.canvas;
  };
  ja.prototype.adjustSize = function () {
    var e = this._map.getSize(),
      b = this.canvas;
    b.width = e.width;
    b.height = e.height;
    b.style.width = b.width + "px";
    b.style.height = b.height + "px";
  };
  ja.prototype.adjustRatio = function (e) {
    var b =
        (window.devicePixelRatio || 1) /
        (e.backingStorePixelRatio ||
          e.webkitBackingStorePixelRatio ||
          e.mozBackingStorePixelRatio ||
          e.msBackingStorePixelRatio ||
          e.oBackingStorePixelRatio ||
          e.backingStorePixelRatio ||
          1),
      d = e.canvas.width,
      a = e.canvas.height;
    e.canvas.width = d * b;
    e.canvas.height = a * b;
    e.canvas.style.width = d + "px";
    e.canvas.style.height = a + "px";
    e.scale(b, b);
  };
  ja.prototype.draw = function () {
    this._draw.apply(this, arguments);
  };
  ja.prototype._draw = function () {
    this.dispatchEvent("draw");
    this.options.update && this.options.update.apply(this, arguments);
  };
  ja.prototype.getContainer = function () {
    return this.canvas;
  };
  ja.prototype.show = function () {
    this.canvas || this._map.addOverlay(this);
    this.canvas.style.display = "block";
  };
  ja.prototype.hide = function () {
    this.canvas.style.display = "none";
  };
  ja.prototype.setZIndex = function (e) {
    this.canvas.style.zIndex = e;
  };
  ja.prototype.getZIndex = function () {
    return this.zIndex;
  };
  var ug =
      "undefined" !== typeof globalThis ? globalThis : "undefined" !== typeof window ? window : "undefined" !== typeof global ? global : "undefined" !== typeof self ? self : {},
    hj = U(function (e, b) {
      b.__esModule = !0;
      b.default = function (b, a) {
        if (!(b instanceof a)) throw new TypeError("Cannot call a class as a function");
      };
    }),
    F = Y(hj),
    Ab = function (e) {
      if (void 0 == e) throw TypeError("Can't call method on  " + e);
      return e;
    },
    ij = {}.hasOwnProperty,
    ha = function (e, b) {
      return ij.call(e, b);
    },
    jj = {}.toString,
    Tb = function (e) {
      return jj.call(e).slice(8, -1);
    },
    Ce = Object("z").propertyIsEnumerable(0)
      ? Object
      : function (e) {
          return "String" == Tb(e) ? e.split("") : Object(e);
        },
    eb = function (e) {
      return Ce(Ab(e));
    },
    kj = Math.ceil,
    lj = Math.floor,
    De = function (e) {
      return isNaN((e = +e)) ? 0 : (0 < e ? lj : kj)(e);
    },
    mj = Math.min,
    Fd = function (e) {
      return 0 < e ? mj(De(e), 9007199254740991) : 0;
    },
    nj = Math.max,
    oj = Math.min,
    ea = U(function (e) {
      e = e.exports = { version: "2.6.5" };
      "number" == typeof __e && (__e = e);
    }),
    aa = U(function (e) {
      e = e.exports = "undefined" != typeof window && Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = e);
    }),
    Ic = U(function (e) {
      var b = aa["__core-js_shared__"] || (aa["__core-js_shared__"] = {});
      (e.exports = function (d, a) {
        return b[d] || (b[d] = void 0 !== a ? a : {});
      })("versions", []).push({ version: ea.version, mode: "pure", copyright: "\u00a9 2019 Denis Pushkarev (zloirock.ru)" });
    }),
    pj = 0,
    qj = Math.random(),
    Gd = function (e) {
      return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++pj + qj).toString(36));
    },
    vg = Ic("keys"),
    Ee = function (e) {
      return vg[e] || (vg[e] = Gd(e));
    },
    rj = (function (e) {
      return function (b, d, a) {
        b = eb(b);
        var c = Fd(b.length);
        a = De(a);
        a = 0 > a ? nj(a + c, 0) : oj(a, c);
        if (e && d != d)
          for (; c > a; ) {
            if (((d = b[a++]), d != d)) return !0;
          }
        else for (; c > a; a++) if ((e || a in b) && b[a] === d) return e || a || 0;
        return !e && -1;
      };
    })(!1),
    sj = Ee("IE_PROTO"),
    wg = function (e, b) {
      e = eb(e);
      var d = 0,
        a = [],
        c;
      for (c in e) c != sj && ha(e, c) && a.push(c);
      for (; b.length > d; ) ha(e, (c = b[d++])) && (~rj(a, c) || a.push(c));
      return a;
    },
    Hd = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
    ic =
      Object.keys ||
      function (e) {
        return wg(e, Hd);
      },
    Sb = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");
      return e;
    },
    wa = function (e, b, d) {
      Sb(e);
      if (void 0 === b) return e;
      switch (d) {
        case 1:
          return function (a) {
            return e.call(b, a);
          };
        case 2:
          return function (a, c) {
            return e.call(b, a, c);
          };
        case 3:
          return function (a, c, d) {
            return e.call(b, a, c, d);
          };
      }
      return function () {
        return e.apply(b, arguments);
      };
    },
    Ca = function (e) {
      return "object" === typeof e ? null !== e : "function" === typeof e;
    },
    Ga = function (e) {
      if (!Ca(e)) throw TypeError(e + " is not an object!");
      return e;
    },
    Bb = function (e) {
      try {
        return !!e();
      } catch (b) {
        return !0;
      }
    },
    Sa = !Bb(function () {
      return (
        7 !=
        Object.defineProperty({}, "a", {
          get: function () {
            return 7;
          }
        }).a
      );
    }),
    jc = aa.document,
    Id = Ca(jc) && Ca(jc.createElement),
    xg =
      !Sa &&
      !Bb(function () {
        return (
          7 !=
          Object.defineProperty(Id ? jc.createElement("div") : {}, "a", {
            get: function () {
              return 7;
            }
          }).a
        );
      }),
    Jc = function (e, b) {
      if (!Ca(e)) return e;
      var d, a;
      if (
        (b && "function" == typeof (d = e.toString) && !Ca((a = d.call(e)))) ||
        ("function" == typeof (d = e.valueOf) && !Ca((a = d.call(e)))) ||
        (!b && "function" == typeof (d = e.toString) && !Ca((a = d.call(e))))
      )
        return a;
      throw TypeError("Can't convert object to primitive value");
    },
    tj = Object.defineProperty,
    Pa = {
      f: Sa
        ? Object.defineProperty
        : function (e, b, d) {
            Ga(e);
            b = Jc(b, !0);
            Ga(d);
            if (xg)
              try {
                return tj(e, b, d);
              } catch (a) {}
            if ("get" in d || "set" in d) throw TypeError("Accessors not supported!");
            "value" in d && (e[b] = d.value);
            return e;
          }
    },
    Cb = function (e, b) {
      return { enumerable: !(e & 1), configurable: !(e & 2), writable: !(e & 4), value: b };
    },
    pb = Sa
      ? function (e, b, d) {
          return Pa.f(e, b, Cb(1, d));
        }
      : function (e, b, d) {
          e[b] = d;
          return e;
        },
    Da = function (e, b, d) {
      var a = e & Da.F,
        c = e & Da.G,
        f = e & Da.S,
        h = e & Da.P,
        g = e & Da.B,
        k = e & Da.W,
        l = c ? ea : ea[b] || (ea[b] = {}),
        n = l.prototype;
      f = c ? aa : f ? aa[b] : (aa[b] || {}).prototype;
      var m;
      c && (d = b);
      for (m in d)
        if (((b = !a && f && void 0 !== f[m]), !b || !ha(l, m))) {
          var p = b ? f[m] : d[m];
          l[m] =
            c && "function" != typeof f[m]
              ? d[m]
              : g && b
              ? wa(p, aa)
              : k && f[m] == p
              ? (function (a) {
                  var c = function (c, b, d) {
                    if (this instanceof a) {
                      switch (arguments.length) {
                        case 0:
                          return new a();
                        case 1:
                          return new a(c);
                        case 2:
                          return new a(c, b);
                      }
                      return new a(c, b, d);
                    }
                    return a.apply(this, arguments);
                  };
                  c.prototype = a.prototype;
                  return c;
                })(p)
              : h && "function" == typeof p
              ? wa(Function.call, p)
              : p;
          h && (((l.virtual || (l.virtual = {}))[m] = p), e & Da.R && n && !n[m] && pb(n, m, p));
        }
    };
  Da.F = 1;
  Da.G = 2;
  Da.S = 4;
  Da.P = 8;
  Da.B = 16;
  Da.W = 32;
  Da.U = 64;
  Da.R = 128;
  var H = Da,
    Jd = function (e, b) {
      var d = (ea.Object || {})[e] || Object[e],
        a = {};
      a[e] = b(d);
      H(
        H.S +
          H.F *
            Bb(function () {
              d(1);
            }),
        "Object",
        a
      );
    };
  Jd("keys", function () {
    return function (e) {
      return ic(Object(Ab(e)));
    };
  });
  var uj = ea.Object.keys,
    vj = U(function (e) {
      e.exports = { default: uj, __esModule: !0 };
    }),
    qa = Y(vj),
    Fe = Object.getOwnPropertySymbols,
    Kd = {}.propertyIsEnumerable,
    Ld = Object.assign,
    wj =
      !Ld ||
      Bb(function () {
        var e = {},
          b = {},
          d = Symbol();
        e[d] = 7;
        "abcdefghijklmnopqrst".split("").forEach(function (a) {
          b[a] = a;
        });
        return 7 != Ld({}, e)[d] || "abcdefghijklmnopqrst" != Object.keys(Ld({}, b)).join("");
      })
        ? function (e, b) {
            for (var d = Object(Ab(e)), a = arguments.length, c = 1, f = Fe, h = Kd; a > c; )
              for (var g = Ce(arguments[c++]), k = f ? ic(g).concat(f(g)) : ic(g), l = k.length, n = 0, m; l > n; ) h.call(g, (m = k[n++])) && (d[m] = g[m]);
            return d;
          }
        : Ld;
  H(H.S + H.F, "Object", { assign: wj });
  var xj = ea.Object.assign,
    yj = U(function (e) {
      e.exports = { default: xj, __esModule: !0 };
    }),
    S = Y(yj),
    yg = Ee("IE_PROTO"),
    zj = Object.prototype,
    zg =
      Object.getPrototypeOf ||
      function (e) {
        e = Object(Ab(e));
        return ha(e, yg) ? e[yg] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? zj : null;
      };
  Jd("getPrototypeOf", function () {
    return function (e) {
      return zg(Object(Ab(e)));
    };
  });
  var Aj = ea.Object.getPrototypeOf,
    Kc = U(function (e) {
      e.exports = { default: Aj, __esModule: !0 };
    }),
    N = Y(Kc);
  H(H.S + H.F * !Sa, "Object", { defineProperty: Pa.f });
  var Bj = ea.Object,
    Cj = function (e, b, d) {
      return Bj.defineProperty(e, b, d);
    },
    qb = U(function (e) {
      e.exports = { default: Cj, __esModule: !0 };
    }),
    ra = Y(qb),
    Dj = U(function (e, b) {
      b.__esModule = !0;
      var d = qb && qb.__esModule ? qb : { default: qb };
      b.default = (function () {
        function a(a, b) {
          for (var c = 0; c < b.length; c++) {
            var f = b[c];
            f.enumerable = f.enumerable || !1;
            f.configurable = !0;
            "value" in f && (f.writable = !0);
            (0, d.default)(a, f.key, f);
          }
        }
        return function (c, b, d) {
          b && a(c.prototype, b);
          d && a(c, d);
          return c;
        };
      })();
    }),
    I = Y(Dj),
    fb = {},
    Ej = Sa
      ? Object.defineProperties
      : function (e, b) {
          Ga(e);
          for (var d = ic(b), a = d.length, c = 0, f; a > c; ) Pa.f(e, (f = d[c++]), b[f]);
          return e;
        },
    Ag = aa.document,
    Ge = Ag && Ag.documentElement,
    Fj = Ee("IE_PROTO"),
    He = function () {},
    Md = function () {
      var e = Id ? jc.createElement("iframe") : {},
        b = Hd.length;
      e.style.display = "none";
      Ge.appendChild(e);
      e.src = "javascript:";
      e = e.contentWindow.document;
      e.open();
      e.write("<script>document.F=Object\x3c/script>");
      e.close();
      for (Md = e.F; b--; ) delete Md.prototype[Hd[b]];
      return Md();
    },
    Db =
      Object.create ||
      function (e, b) {
        if (null !== e) {
          He.prototype = Ga(e);
          var d = new He();
          He.prototype = null;
          d[Fj] = e;
        } else d = Md();
        return void 0 === b ? d : Ej(d, b);
      },
    ua = U(function (e) {
      var b = Ic("wks"),
        d = aa.Symbol,
        a = "function" == typeof d;
      (e.exports = function (c) {
        return b[c] || (b[c] = (a && d[c]) || (a ? d : Gd)("Symbol." + c));
      }).store = b;
    }),
    Gj = Pa.f,
    Bg = ua("toStringTag"),
    Ub = function (e, b, d) {
      e && !ha((e = d ? e : e.prototype), Bg) && Gj(e, Bg, { configurable: !0, value: b });
    },
    Cg = {};
  pb(Cg, ua("iterator"), function () {
    return this;
  });
  var Hj = function (e, b, d) {
      e.prototype = Db(Cg, { next: Cb(1, d) });
      Ub(e, b + " Iterator");
    },
    Ie = ua("iterator"),
    Je = !([].keys && "next" in [].keys()),
    Ij = function () {
      return this;
    },
    Ke = function (e, b, d, a, c, f, h) {
      Hj(d, b, a);
      a = function (a) {
        return !Je && a in n
          ? n[a]
          : function () {
              return new d(this, a);
            };
      };
      var g = b + " Iterator",
        k = "values" == c,
        l = !1,
        n = e.prototype,
        m = n[Ie] || n["@@iterator"] || (c && n[c]),
        p = m || a(c),
        q = c ? (k ? a("entries") : p) : void 0,
        t = "Array" == b ? n.entries || m : m,
        v;
      t && ((e = zg(t.call(new e()))), e !== Object.prototype && e.next && Ub(e, g, !0));
      k &&
        m &&
        "values" !== m.name &&
        ((l = !0),
        (p = function () {
          return m.call(this);
        }));
      h && (Je || l || !n[Ie]) && pb(n, Ie, p);
      fb[b] = p;
      fb[g] = Ij;
      if (c) {
        var r = { values: k ? p : a("values"), keys: f ? p : a("keys"), entries: q };
        if (h) for (v in r) v in n || pb(n, v, r[v]);
        else H(H.P + H.F * (Je || l), b, r);
      }
      return r;
    },
    Jj = (function (e) {
      return function (b, d) {
        b = String(Ab(b));
        d = De(d);
        var a = b.length,
          c;
        if (0 > d || d >= a) return e ? "" : void 0;
        var f = b.charCodeAt(d);
        return 55296 > f || 56319 < f || d + 1 === a || 56320 > (c = b.charCodeAt(d + 1)) || 57343 < c
          ? e
            ? b.charAt(d)
            : f
          : e
          ? b.slice(d, d + 2)
          : ((f - 55296) << 10) + (c - 56320) + 65536;
      };
    })(!0);
  Ke(
    String,
    "String",
    function (e) {
      this._t = String(e);
      this._i = 0;
    },
    function () {
      var e = this._t,
        b = this._i;
      if (b >= e.length) return { value: void 0, done: !0 };
      e = Jj(e, b);
      this._i += e.length;
      return { value: e, done: !1 };
    }
  );
  var Eb = function (e, b) {
    return { value: b, done: !!e };
  };
  Ke(
    Array,
    "Array",
    function (e, b) {
      this._t = eb(e);
      this._i = 0;
      this._k = b;
    },
    function () {
      var e = this._t,
        b = this._k,
        d = this._i++;
      return !e || d >= e.length ? ((this._t = void 0), Eb(1)) : "keys" == b ? Eb(0, d) : "values" == b ? Eb(0, e[d]) : Eb(0, [d, e[d]]);
    },
    "values"
  );
  fb.Arguments = fb.Array;
  for (
    var Dg = ua("toStringTag"),
      Eg =
        "CSSRuleList CSSStyleDeclaration CSSValueList ClientRectList DOMRectList DOMStringList DOMTokenList DataTransferItemList FileList HTMLAllCollection HTMLCollection HTMLFormElement HTMLSelectElement MediaList MimeTypeArray NamedNodeMap NodeList PaintRequestList Plugin PluginArray SVGLengthList SVGNumberList SVGPathSegList SVGPointList SVGStringList SVGTransformList SourceBufferList StyleSheetList TextTrackCueList TextTrackList TouchList".split(
          " "
        ),
      Le = 0;
    Le < Eg.length;
    Le++
  ) {
    var Me = Eg[Le],
      Fg = aa[Me],
      Ne = Fg && Fg.prototype;
    Ne && !Ne[Dg] && pb(Ne, Dg, Me);
    fb[Me] = fb.Array;
  }
  var Nd = { f: ua },
    Kj = Nd.f("iterator"),
    Lc = U(function (e) {
      e.exports = { default: Kj, __esModule: !0 };
    });
  Y(Lc);
  var Od = U(function (e) {
      var b = Gd("meta"),
        d = Pa.f,
        a = 0,
        c =
          Object.isExtensible ||
          function () {
            return !0;
          },
        f = !Bb(function () {
          return c(Object.preventExtensions({}));
        }),
        h = function (c) {
          d(c, b, { value: { i: "O" + ++a, w: {} } });
        },
        g = (e.exports = {
          KEY: b,
          NEED: !1,
          fastKey: function (a, d) {
            if (!Ca(a)) return "symbol" == typeof a ? a : ("string" == typeof a ? "S" : "P") + a;
            if (!ha(a, b)) {
              if (!c(a)) return "F";
              if (!d) return "E";
              h(a);
            }
            return a[b].i;
          },
          getWeak: function (a, d) {
            if (!ha(a, b)) {
              if (!c(a)) return !0;
              if (!d) return !1;
              h(a);
            }
            return a[b].w;
          },
          onFreeze: function (a) {
            f && g.NEED && c(a) && !ha(a, b) && h(a);
            return a;
          }
        });
    }),
    Lj = Pa.f,
    Oe = function (e) {
      var b = ea.Symbol || (ea.Symbol = {});
      "_" == e.charAt(0) || e in b || Lj(b, e, { value: Nd.f(e) });
    },
    Pe =
      Array.isArray ||
      function (e) {
        return "Array" == Tb(e);
      },
    Mj = Hd.concat("length", "prototype"),
    Gg =
      Object.getOwnPropertyNames ||
      function (e) {
        return wg(e, Mj);
      },
    Hg = Gg,
    Nj = {}.toString,
    Ig = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
    Jg = function (e) {
      if (Ig && "[object Window]" == Nj.call(e))
        try {
          var b = Hg(e);
        } catch (d) {
          b = Ig.slice();
        }
      else b = Hg(eb(e));
      return b;
    },
    Kg = Object.getOwnPropertyDescriptor,
    Pd = {
      f: Sa
        ? Kg
        : function (e, b) {
            e = eb(e);
            b = Jc(b, !0);
            if (xg)
              try {
                return Kg(e, b);
              } catch (d) {}
            if (ha(e, b)) return Cb(!Kd.call(e, b), e[b]);
          }
    },
    Oj = Od.KEY,
    Lg = Pd.f,
    Vb = Pa.f,
    Mg = Jg,
    Ja = aa.Symbol,
    Qd = aa.JSON,
    Rd = Qd && Qd.stringify,
    Ka = ua("_hidden"),
    Ng = ua("toPrimitive"),
    Pj = {}.propertyIsEnumerable,
    Mc = Ic("symbol-registry"),
    rb = Ic("symbols"),
    Nc = Ic("op-symbols"),
    Wa = Object.prototype,
    kc = "function" == typeof Ja,
    Qe = aa.QObject,
    Re = !Qe || !Qe.prototype || !Qe.prototype.findChild,
    Se =
      Sa &&
      Bb(function () {
        return (
          7 !=
          Db(
            Vb({}, "a", {
              get: function () {
                return Vb(this, "a", { value: 7 }).a;
              }
            })
          ).a
        );
      })
        ? function (e, b, d) {
            var a = Lg(Wa, b);
            a && delete Wa[b];
            Vb(e, b, d);
            a && e !== Wa && Vb(Wa, b, a);
          }
        : Vb,
    Og = function (e) {
      var b = (rb[e] = Db(Ja.prototype));
      b._k = e;
      return b;
    },
    Te =
      kc && "symbol" == typeof Ja.iterator
        ? function (e) {
            return "symbol" == typeof e;
          }
        : function (e) {
            return e instanceof Ja;
          },
    Sd = function (e, b, d) {
      e === Wa && Sd(Nc, b, d);
      Ga(e);
      b = Jc(b, !0);
      Ga(d);
      return ha(rb, b)
        ? (d.enumerable ? (ha(e, Ka) && e[Ka][b] && (e[Ka][b] = !1), (d = Db(d, { enumerable: Cb(0, !1) }))) : (ha(e, Ka) || Vb(e, Ka, Cb(1, {})), (e[Ka][b] = !0)), Se(e, b, d))
        : Vb(e, b, d);
    },
    Pg = function (e, b) {
      Ga(e);
      var d = (b = eb(b)),
        a = ic(d),
        c = Fe;
      if (c) {
        c = c(d);
        for (var f = Kd, h = 0, g; c.length > h; ) f.call(d, (g = c[h++])) && a.push(g);
      }
      d = 0;
      g = a.length;
      for (var k; g > d; ) Sd(e, (k = a[d++]), b[k]);
      return e;
    },
    Qj = function (e) {
      var b = Pj.call(this, (e = Jc(e, !0)));
      return this === Wa && ha(rb, e) && !ha(Nc, e) ? !1 : b || !ha(this, e) || !ha(rb, e) || (ha(this, Ka) && this[Ka][e]) ? b : !0;
    },
    Qg = function (e, b) {
      e = eb(e);
      b = Jc(b, !0);
      if (e !== Wa || !ha(rb, b) || ha(Nc, b)) {
        var d = Lg(e, b);
        !d || !ha(rb, b) || (ha(e, Ka) && e[Ka][b]) || (d.enumerable = !0);
        return d;
      }
    },
    Rg = function (e) {
      e = Mg(eb(e));
      for (var b = [], d = 0, a; e.length > d; ) ha(rb, (a = e[d++])) || a == Ka || a == Oj || b.push(a);
      return b;
    },
    Sg = function (e) {
      var b = e === Wa;
      e = Mg(b ? Nc : eb(e));
      for (var d = [], a = 0, c; e.length > a; ) ha(rb, (c = e[a++])) && (b ? ha(Wa, c) : 1) && d.push(rb[c]);
      return d;
    };
  kc ||
    ((Ja = function () {
      if (this instanceof Ja) throw TypeError("Symbol is not a constructor!");
      var e = Gd(0 < arguments.length ? arguments[0] : void 0),
        b = function (d) {
          this === Wa && b.call(Nc, d);
          ha(this, Ka) && ha(this[Ka], e) && (this[Ka][e] = !1);
          Se(this, e, Cb(1, d));
        };
      Sa && Re && Se(Wa, e, { configurable: !0, set: b });
      return Og(e);
    }),
    pb(Ja.prototype, "toString", function () {
      return this._k;
    }),
    (Pd.f = Qg),
    (Pa.f = Sd),
    (Gg = Jg = Rg),
    (Kd = Qj),
    (Fe = Sg),
    (Nd.f = function (e) {
      return Og(ua(e));
    }));
  H(H.G + H.W + H.F * !kc, { Symbol: Ja });
  for (var Tg = "hasInstance isConcatSpreadable iterator match replace search species split toPrimitive toStringTag unscopables".split(" "), Ug = 0; Tg.length > Ug; ) ua(Tg[Ug++]);
  for (var Vg = ic(ua.store), Wg = 0; Vg.length > Wg; ) Oe(Vg[Wg++]);
  H(H.S + H.F * !kc, "Symbol", {
    for: function (e) {
      return ha(Mc, (e += "")) ? Mc[e] : (Mc[e] = Ja(e));
    },
    keyFor: function (e) {
      if (!Te(e)) throw TypeError(e + " is not a symbol!");
      for (var b in Mc) if (Mc[b] === e) return b;
    },
    useSetter: function () {
      Re = !0;
    },
    useSimple: function () {
      Re = !1;
    }
  });
  H(H.S + H.F * !kc, "Object", {
    create: function (e, b) {
      return void 0 === b ? Db(e) : Pg(Db(e), b);
    },
    defineProperty: Sd,
    defineProperties: Pg,
    getOwnPropertyDescriptor: Qg,
    getOwnPropertyNames: Rg,
    getOwnPropertySymbols: Sg
  });
  Qd &&
    H(
      H.S +
        H.F *
          (!kc ||
            Bb(function () {
              var e = Ja();
              return "[null]" != Rd([e]) || "{}" != Rd({ a: e }) || "{}" != Rd(Object(e));
            })),
      "JSON",
      {
        stringify: function (e) {
          for (var b = [e], d = 1, a; arguments.length > d; ) b.push(arguments[d++]);
          a = d = b[1];
          if ((Ca(d) || void 0 !== e) && !Te(e))
            return (
              Pe(d) ||
                (d = function (c, b) {
                  "function" == typeof a && (b = a.call(this, c, b));
                  if (!Te(b)) return b;
                }),
              (b[1] = d),
              Rd.apply(Qd, b)
            );
        }
      }
    );
  Ja.prototype[Ng] || pb(Ja.prototype, Ng, Ja.prototype.valueOf);
  Ub(Ja, "Symbol");
  Ub(Math, "Math", !0);
  Ub(aa.JSON, "JSON", !0);
  Oe("asyncIterator");
  Oe("observable");
  var Rj = ea.Symbol,
    Oc = U(function (e) {
      e.exports = { default: Rj, __esModule: !0 };
    }),
    Xg = Y(Oc),
    lc = U(function (e, b) {
      b.__esModule = !0;
      e = Lc && Lc.__esModule ? Lc : { default: Lc };
      var d = Oc && Oc.__esModule ? Oc : { default: Oc },
        a =
          "function" === typeof d.default && "symbol" === typeof e.default
            ? function (a) {
                return typeof a;
              }
            : function (a) {
                return a && "function" === typeof d.default && a.constructor === d.default && a !== d.default.prototype ? "symbol" : typeof a;
              };
      b.default =
        "function" === typeof d.default && "symbol" === a(e.default)
          ? function (c) {
              return "undefined" === typeof c ? "undefined" : a(c);
            }
          : function (c) {
              return c && "function" === typeof d.default && c.constructor === d.default && c !== d.default.prototype ? "symbol" : "undefined" === typeof c ? "undefined" : a(c);
            };
    }),
    Ha = Y(lc),
    Sj = U(function (e, b) {
      b.__esModule = !0;
      var d = lc && lc.__esModule ? lc : { default: lc };
      b.default = function (a, c) {
        if (!a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !c || ("object" !== ("undefined" === typeof c ? "undefined" : (0, d.default)(c)) && "function" !== typeof c) ? a : c;
      };
    }),
    Q = Y(Sj),
    Tj =
      Object.setPrototypeOf ||
      ("__proto__" in {}
        ? (function (e, b, d) {
            try {
              (d = wa(Function.call, Pd.f(Object.prototype, "__proto__").set, 2)), d(e, []), (b = !(e instanceof Array));
            } catch (a) {
              b = !0;
            }
            return function (a, c) {
              Ga(a);
              if (!Ca(c) && null !== c) throw TypeError(c + ": can't set as prototype!");
              b ? (a.__proto__ = c) : d(a, c);
              return a;
            };
          })({}, !1)
        : void 0);
  H(H.S, "Object", { setPrototypeOf: Tj });
  var Uj = ea.Object.setPrototypeOf,
    Yg = U(function (e) {
      e.exports = { default: Uj, __esModule: !0 };
    });
  Y(Yg);
  H(H.S, "Object", { create: Db });
  var Vj = ea.Object,
    Wj = function (e, b) {
      return Vj.create(e, b);
    },
    Zg = U(function (e) {
      e.exports = { default: Wj, __esModule: !0 };
    }),
    Xj = Y(Zg),
    Yj = U(function (e, b) {
      function d(a) {
        return a && a.__esModule ? a : { default: a };
      }
      b.__esModule = !0;
      var a = d(Yg),
        c = d(Zg),
        f = d(lc);
      b.default = function (b, d) {
        if ("function" !== typeof d && null !== d)
          throw new TypeError("Super expression must either be null or a function, not " + ("undefined" === typeof d ? "undefined" : (0, f.default)(d)));
        b.prototype = (0, c.default)(d && d.prototype, { constructor: { value: b, enumerable: !1, writable: !0, configurable: !0 } });
        d && (a.default ? (0, a.default)(b, d) : (b.__proto__ = d));
      };
    }),
    R = Y(Yj),
    Zj = ua("toStringTag"),
    ak =
      "Arguments" ==
      Tb(
        (function () {
          return arguments;
        })()
      ),
    Td = function (e) {
      var b;
      if (void 0 === e) var d = "Undefined";
      else {
        if (null === e) var a = "Null";
        else {
          a: {
            var c = (e = Object(e));
            try {
              a = c[Zj];
              break a;
            } catch (f) {}
            a = void 0;
          }
          a = "string" == typeof (d = a) ? d : ak ? Tb(e) : "Object" == (b = Tb(e)) && "function" == typeof e.callee ? "Arguments" : b;
        }
        d = a;
      }
      return d;
    },
    bk = ua("iterator"),
    ck = (ea.isIterable = function (e) {
      e = Object(e);
      return void 0 !== e[bk] || "@@iterator" in e || fb.hasOwnProperty(Td(e));
    }),
    Pc = U(function (e) {
      e.exports = { default: ck, __esModule: !0 };
    });
  Y(Pc);
  var dk = ua("iterator"),
    Ue = (ea.getIteratorMethod = function (e) {
      if (void 0 != e) return e[dk] || e["@@iterator"] || fb[Td(e)];
    }),
    ek = (ea.getIterator = function (e) {
      var b = Ue(e);
      if ("function" != typeof b) throw TypeError(e + " is not iterable!");
      return Ga(b.call(e));
    }),
    Qc = U(function (e) {
      e.exports = { default: ek, __esModule: !0 };
    }),
    gc = Y(Qc),
    fk = U(function (e, b) {
      b.__esModule = !0;
      var d = Pc && Pc.__esModule ? Pc : { default: Pc },
        a = Qc && Qc.__esModule ? Qc : { default: Qc };
      b.default = (function () {
        return function (c, b) {
          if (Array.isArray(c)) return c;
          if ((0, d.default)(Object(c))) {
            var f = [],
              g = !0,
              e = !1,
              l = void 0;
            try {
              for (var n = (0, a.default)(c), m; !(g = (m = n.next()).done) && (f.push(m.value), !b || f.length !== b); g = !0);
            } catch (p) {
              (e = !0), (l = p);
            } finally {
              try {
                if (!g && n["return"]) n["return"]();
              } finally {
                if (e) throw l;
              }
            }
            return f;
          }
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      })();
    }),
    da = Y(fk),
    $g = function (e, b, d, a) {
      try {
        return a ? b(Ga(d)[0], d[1]) : b(d);
      } catch (c) {
        throw ((b = e["return"]), void 0 !== b && Ga(b.call(e)), c);
      }
    },
    ah = ua("iterator"),
    bh = Array.prototype,
    Ve = ua("iterator"),
    ch = !1;
  try {
    [7][Ve]()["return"] = function () {
      ch = !0;
    };
  } catch (e) {}
  var dh = function (e, b) {
    if (!b && !ch) return !1;
    var d = !1;
    try {
      b = [7];
      var a = b[Ve]();
      a.next = function () {
        return { done: (d = !0) };
      };
      b[Ve] = function () {
        return a;
      };
      e(b);
    } catch (c) {}
    return d;
  };
  H(H.S + H.F * !dh(function (e) {}), "Array", {
    from: function (e) {
      var b = Object(Ab(e)),
        d = "function" == typeof this ? this : Array,
        a = arguments.length,
        c = 1 < a ? arguments[1] : void 0,
        f = void 0 !== c,
        h = 0,
        g = Ue(b),
        k;
      f && (c = wa(c, 2 < a ? arguments[2] : void 0, 2));
      if (void 0 != g && (d != Array || void 0 === g || (fb.Array !== g && bh[ah] !== g)))
        for (b = g.call(b), d = new d(); !(k = b.next()).done; h++) (a = d), (g = h), (k = f ? $g(b, c, [k.value, h], !0) : k.value), g in a ? Pa.f(a, g, Cb(0, k)) : (a[g] = k);
      else
        for (a = Fd(b.length), d = new d(a); a > h; h++) {
          g = d;
          k = h;
          var l = f ? c(b[h], h) : b[h];
          k in g ? Pa.f(g, k, Cb(0, l)) : (g[k] = l);
        }
      d.length = h;
      return d;
    }
  });
  var gk = ea.Array.from,
    Rc = U(function (e) {
      e.exports = { default: gk, __esModule: !0 };
    }),
    Ud = Y(Rc),
    hk = U(function (e, b) {
      b.__esModule = !0;
      var d = Rc && Rc.__esModule ? Rc : { default: Rc };
      b.default = function (a) {
        if (Array.isArray(a)) {
          for (var c = 0, b = Array(a.length); c < a.length; c++) b[c] = a[c];
          return b;
        }
        return (0, d.default)(a);
      };
    }),
    W = Y(hk),
    ik = Od.onFreeze;
  Jd("freeze", function (e) {
    return function (b) {
      return e && Ca(b) ? e(ik(b)) : b;
    };
  });
  var jk = ea.Object.freeze,
    kk = U(function (e) {
      e.exports = { default: jk, __esModule: !0 };
    }),
    Kf = Y(kk),
    eh = ea.JSON || (ea.JSON = { stringify: JSON.stringify }),
    lk = function (e) {
      return eh.stringify.apply(eh, arguments);
    },
    mk = U(function (e) {
      e.exports = { default: lk, __esModule: !0 };
    }),
    yc = Y(mk),
    Xa = {
      aliceblue: [240, 248, 255],
      antiquewhite: [250, 235, 215],
      aqua: [0, 255, 255],
      aquamarine: [127, 255, 212],
      azure: [240, 255, 255],
      beige: [245, 245, 220],
      bisque: [255, 228, 196],
      black: [0, 0, 0],
      blanchedalmond: [255, 235, 205],
      blue: [0, 0, 255],
      blueviolet: [138, 43, 226],
      brown: [165, 42, 42],
      burlywood: [222, 184, 135],
      cadetblue: [95, 158, 160],
      chartreuse: [127, 255, 0],
      chocolate: [210, 105, 30],
      coral: [255, 127, 80],
      cornflowerblue: [100, 149, 237],
      cornsilk: [255, 248, 220],
      crimson: [220, 20, 60],
      cyan: [0, 255, 255],
      darkblue: [0, 0, 139],
      darkcyan: [0, 139, 139],
      darkgoldenrod: [184, 134, 11],
      darkgray: [169, 169, 169],
      darkgreen: [0, 100, 0],
      darkgrey: [169, 169, 169],
      darkkhaki: [189, 183, 107],
      darkmagenta: [139, 0, 139],
      darkolivegreen: [85, 107, 47],
      darkorange: [255, 140, 0],
      darkorchid: [153, 50, 204],
      darkred: [139, 0, 0],
      darksalmon: [233, 150, 122],
      darkseagreen: [143, 188, 143],
      darkslateblue: [72, 61, 139],
      darkslategray: [47, 79, 79],
      darkslategrey: [47, 79, 79],
      darkturquoise: [0, 206, 209],
      darkviolet: [148, 0, 211],
      deeppink: [255, 20, 147],
      deepskyblue: [0, 191, 255],
      dimgray: [105, 105, 105],
      dimgrey: [105, 105, 105],
      dodgerblue: [30, 144, 255],
      firebrick: [178, 34, 34],
      floralwhite: [255, 250, 240],
      forestgreen: [34, 139, 34],
      fuchsia: [255, 0, 255],
      gainsboro: [220, 220, 220],
      ghostwhite: [248, 248, 255],
      gold: [255, 215, 0],
      goldenrod: [218, 165, 32],
      gray: [128, 128, 128],
      green: [0, 128, 0],
      greenyellow: [173, 255, 47],
      grey: [128, 128, 128],
      honeydew: [240, 255, 240],
      hotpink: [255, 105, 180],
      indianred: [205, 92, 92],
      indigo: [75, 0, 130],
      ivory: [255, 255, 240],
      khaki: [240, 230, 140],
      lavender: [230, 230, 250],
      lavenderblush: [255, 240, 245],
      lawngreen: [124, 252, 0],
      lemonchiffon: [255, 250, 205],
      lightblue: [173, 216, 230],
      lightcoral: [240, 128, 128],
      lightcyan: [224, 255, 255],
      lightgoldenrodyellow: [250, 250, 210],
      lightgray: [211, 211, 211],
      lightgreen: [144, 238, 144],
      lightgrey: [211, 211, 211],
      lightpink: [255, 182, 193],
      lightsalmon: [255, 160, 122],
      lightseagreen: [32, 178, 170],
      lightskyblue: [135, 206, 250],
      lightslategray: [119, 136, 153],
      lightslategrey: [119, 136, 153],
      lightsteelblue: [176, 196, 222],
      lightyellow: [255, 255, 224],
      lime: [0, 255, 0],
      limegreen: [50, 205, 50],
      linen: [250, 240, 230],
      magenta: [255, 0, 255],
      maroon: [128, 0, 0],
      mediumaquamarine: [102, 205, 170],
      mediumblue: [0, 0, 205],
      mediumorchid: [186, 85, 211],
      mediumpurple: [147, 112, 219],
      mediumseagreen: [60, 179, 113],
      mediumslateblue: [123, 104, 238],
      mediumspringgreen: [0, 250, 154],
      mediumturquoise: [72, 209, 204],
      mediumvioletred: [199, 21, 133],
      midnightblue: [25, 25, 112],
      mintcream: [245, 255, 250],
      mistyrose: [255, 228, 225],
      moccasin: [255, 228, 181],
      navajowhite: [255, 222, 173],
      navy: [0, 0, 128],
      oldlace: [253, 245, 230],
      olive: [128, 128, 0],
      olivedrab: [107, 142, 35],
      orange: [255, 165, 0],
      orangered: [255, 69, 0],
      orchid: [218, 112, 214],
      palegoldenrod: [238, 232, 170],
      palegreen: [152, 251, 152],
      paleturquoise: [175, 238, 238],
      palevioletred: [219, 112, 147],
      papayawhip: [255, 239, 213],
      peachpuff: [255, 218, 185],
      peru: [205, 133, 63],
      pink: [255, 192, 203],
      plum: [221, 160, 221],
      powderblue: [176, 224, 230],
      purple: [128, 0, 128],
      rebeccapurple: [102, 51, 153],
      red: [255, 0, 0],
      rosybrown: [188, 143, 143],
      royalblue: [65, 105, 225],
      saddlebrown: [139, 69, 19],
      salmon: [250, 128, 114],
      sandybrown: [244, 164, 96],
      seagreen: [46, 139, 87],
      seashell: [255, 245, 238],
      sienna: [160, 82, 45],
      silver: [192, 192, 192],
      skyblue: [135, 206, 235],
      slateblue: [106, 90, 205],
      slategray: [112, 128, 144],
      slategrey: [112, 128, 144],
      snow: [255, 250, 250],
      springgreen: [0, 255, 127],
      steelblue: [70, 130, 180],
      tan: [210, 180, 140],
      teal: [0, 128, 128],
      thistle: [216, 191, 216],
      tomato: [255, 99, 71],
      turquoise: [64, 224, 208],
      violet: [238, 130, 238],
      wheat: [245, 222, 179],
      white: [255, 255, 255],
      whitesmoke: [245, 245, 245],
      yellow: [255, 255, 0],
      yellowgreen: [154, 205, 50]
    },
    nk = Pd.f;
  Jd("getOwnPropertyDescriptor", function () {
    return function (e, b) {
      return nk(eb(e), b);
    };
  });
  var ok = ea.Object,
    pk = function (e, b) {
      return ok.getOwnPropertyDescriptor(e, b);
    },
    Sc = U(function (e) {
      e.exports = { default: pk, __esModule: !0 };
    }),
    pa = Y(Sc),
    Tc = U(function (e) {
      var b = Array.prototype.concat,
        d = Array.prototype.slice,
        a = (e.exports = function (a) {
          for (var c = [], e = 0, g = a.length; e < g; e++) {
            var k = a[e];
            var l =
              (l = k) && "string" !== typeof l
                ? l instanceof Array || Array.isArray(l) || (0 <= l.length && (l.splice instanceof Function || (pa(l, l.length - 1) && "String" !== l.constructor.name)))
                : !1;
            l ? (c = b.call(c, d.call(k))) : c.push(k);
          }
          return c;
        });
      a.wrap = function (c) {
        return function () {
          return c(a(arguments));
        };
      };
    }),
    xc = U(function (e) {
      function b(a, c, b) {
        return Math.min(Math.max(c, a), b);
      }
      function d(a) {
        a = a.toString(16).toUpperCase();
        return 2 > a.length ? "0" + a : a;
      }
      var a = {},
        c;
      for (c in Xa) Xa.hasOwnProperty(c) && (a[Xa[c]] = c);
      var f = (e.exports = { to: {}, get: {} });
      f.get = function (a) {
        switch (a.substring(0, 3).toLowerCase()) {
          case "hsl":
            a = f.get.hsl(a);
            var c = "hsl";
            break;
          case "hwb":
            a = f.get.hwb(a);
            c = "hwb";
            break;
          default:
            (a = f.get.rgb(a)), (c = "rgb");
        }
        return a ? { model: c, value: a } : null;
      };
      f.get.rgb = function (a) {
        if (!a) return null;
        var c = /^#([a-f0-9]{3,4})$/i,
          d = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
          f = /^rgba?\(\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
          e = /(\D+)/,
          h = [0, 0, 0, 1],
          p;
        if ((p = a.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i))) {
          c = p[2];
          p = p[1];
          for (a = 0; 3 > a; a++) (d = 2 * a), (h[a] = parseInt(p.slice(d, d + 2), 16));
          c && (h[3] = Math.round((parseInt(c, 16) / 255) * 100) / 100);
        } else if ((p = a.match(c))) {
          p = p[1];
          c = p[3];
          for (a = 0; 3 > a; a++) h[a] = parseInt(p[a] + p[a], 16);
          c && (h[3] = Math.round((parseInt(c + c, 16) / 255) * 100) / 100);
        } else if ((p = a.match(d))) {
          for (a = 0; 3 > a; a++) h[a] = parseInt(p[a + 1], 0);
          p[4] && (h[3] = parseFloat(p[4]));
        } else if ((p = a.match(f))) {
          for (a = 0; 3 > a; a++) h[a] = Math.round(2.55 * parseFloat(p[a + 1]));
          p[4] && (h[3] = parseFloat(p[4]));
        } else {
          if ((p = a.match(e))) {
            if ("transparent" === p[1]) return [0, 0, 0, 0];
            h = Xa[p[1]];
            if (!h) return null;
            h[3] = 1;
            return h;
          }
          return null;
        }
        for (a = 0; 3 > a; a++) h[a] = b(h[a], 0, 255);
        h[3] = b(h[3], 0, 1);
        return h;
      };
      f.get.hsl = function (a) {
        if (!a) return null;
        var c = a.match(/^hsla?\(\s*([+-]?(?:\d*\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/);
        if (c) {
          var d = parseFloat(c[4]);
          a = (parseFloat(c[1]) + 360) % 360;
          var f = b(parseFloat(c[2]), 0, 100);
          c = b(parseFloat(c[3]), 0, 100);
          d = b(isNaN(d) ? 1 : d, 0, 1);
          return [a, f, c, d];
        }
        return null;
      };
      f.get.hwb = function (a) {
        if (!a) return null;
        var c = a.match(/^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/);
        if (c) {
          var d = parseFloat(c[4]);
          a = ((parseFloat(c[1]) % 360) + 360) % 360;
          var f = b(parseFloat(c[2]), 0, 100);
          c = b(parseFloat(c[3]), 0, 100);
          d = b(isNaN(d) ? 1 : d, 0, 1);
          return [a, f, c, d];
        }
        return null;
      };
      f.to.hex = function () {
        var a = Tc(arguments);
        return "#" + d(a[0]) + d(a[1]) + d(a[2]) + (1 > a[3] ? d(Math.round(255 * a[3])) : "");
      };
      f.to.rgb = function () {
        var a = Tc(arguments);
        return 4 > a.length || 1 === a[3]
          ? "rgb(" + Math.round(a[0]) + ", " + Math.round(a[1]) + ", " + Math.round(a[2]) + ")"
          : "rgba(" + Math.round(a[0]) + ", " + Math.round(a[1]) + ", " + Math.round(a[2]) + ", " + a[3] + ")";
      };
      f.to.rgb.percent = function () {
        var a = Tc(arguments),
          c = Math.round((a[0] / 255) * 100),
          b = Math.round((a[1] / 255) * 100),
          d = Math.round((a[2] / 255) * 100);
        return 4 > a.length || 1 === a[3] ? "rgb(" + c + "%, " + b + "%, " + d + "%)" : "rgba(" + c + "%, " + b + "%, " + d + "%, " + a[3] + ")";
      };
      f.to.hsl = function () {
        var a = Tc(arguments);
        return 4 > a.length || 1 === a[3] ? "hsl(" + a[0] + ", " + a[1] + "%, " + a[2] + "%)" : "hsla(" + a[0] + ", " + a[1] + "%, " + a[2] + "%, " + a[3] + ")";
      };
      f.to.hwb = function () {
        var a = Tc(arguments),
          c = "";
        4 <= a.length && 1 !== a[3] && (c = ", " + a[3]);
        return "hwb(" + a[0] + ", " + a[1] + "%, " + a[2] + "%" + c + ")";
      };
      f.to.keyword = function (c) {
        return a[c.slice(0, 3)];
      };
    }),
    Wb = U(function (e) {
      var b = {};
      for (c in Xa) Xa.hasOwnProperty(c) && (b[Xa[c]] = c);
      var d = (e.exports = {
          rgb: { channels: 3, labels: "rgb" },
          hsl: { channels: 3, labels: "hsl" },
          hsv: { channels: 3, labels: "hsv" },
          hwb: { channels: 3, labels: "hwb" },
          cmyk: { channels: 4, labels: "cmyk" },
          xyz: { channels: 3, labels: "xyz" },
          lab: { channels: 3, labels: "lab" },
          lch: { channels: 3, labels: "lch" },
          hex: { channels: 1, labels: ["hex"] },
          keyword: { channels: 1, labels: ["keyword"] },
          ansi16: { channels: 1, labels: ["ansi16"] },
          ansi256: { channels: 1, labels: ["ansi256"] },
          hcg: { channels: 3, labels: ["h", "c", "g"] },
          apple: { channels: 3, labels: ["r16", "g16", "b16"] },
          gray: { channels: 1, labels: ["gray"] }
        }),
        a;
      for (a in d)
        if (d.hasOwnProperty(a)) {
          if (!("channels" in d[a])) throw Error("missing channels property: " + a);
          if (!("labels" in d[a])) throw Error("missing channel labels property: " + a);
          if (d[a].labels.length !== d[a].channels) throw Error("channel and label counts mismatch: " + a);
          e = d[a].channels;
          var c = d[a].labels;
          delete d[a].channels;
          delete d[a].labels;
          Object.defineProperty(d[a], "channels", { value: e });
          Object.defineProperty(d[a], "labels", { value: c });
        }
      d.rgb.hsl = function (a) {
        var c = a[0] / 255,
          b = a[1] / 255,
          d = a[2] / 255;
        a = Math.min(c, b, d);
        var f = Math.max(c, b, d),
          e = f - a,
          m;
        f === a ? (m = 0) : c === f ? (m = (b - d) / e) : b === f ? (m = 2 + (d - c) / e) : d === f && (m = 4 + (c - b) / e);
        m = Math.min(60 * m, 360);
        0 > m && (m += 360);
        c = (a + f) / 2;
        return [m, 100 * (f === a ? 0 : 0.5 >= c ? e / (f + a) : e / (2 - f - a)), 100 * c];
      };
      d.rgb.hsv = function (a) {
        var c,
          b = a[0] / 255,
          d = a[1] / 255,
          f = a[2] / 255,
          e = Math.max(b, d, f);
        var m = e - Math.min(b, d, f);
        if (0 === m) var p = (c = 0);
        else {
          c = m / e;
          a = (e - b) / 6 / m + 0.5;
          var q = (e - d) / 6 / m + 0.5;
          m = (e - f) / 6 / m + 0.5;
          b === e ? (p = m - q) : d === e ? (p = 1 / 3 + a - m) : f === e && (p = 2 / 3 + q - a);
          0 > p ? (p += 1) : 1 < p && --p;
        }
        return [360 * p, 100 * c, 100 * e];
      };
      d.rgb.hwb = function (a) {
        var c = a[0],
          b = a[1],
          f = a[2];
        a = d.rgb.hsl(a)[0];
        var e = (1 / 255) * Math.min(c, Math.min(b, f));
        f = 1 - (1 / 255) * Math.max(c, Math.max(b, f));
        return [a, 100 * e, 100 * f];
      };
      d.rgb.cmyk = function (a) {
        var c = a[0] / 255,
          b = a[1] / 255;
        a = a[2] / 255;
        var d = Math.min(1 - c, 1 - b, 1 - a);
        return [100 * ((1 - c - d) / (1 - d) || 0), 100 * ((1 - b - d) / (1 - d) || 0), 100 * ((1 - a - d) / (1 - d) || 0), 100 * d];
      };
      d.rgb.keyword = function (a) {
        var c = b[a];
        if (c) return c;
        c = Infinity;
        var d;
        for (d in Xa)
          if (Xa.hasOwnProperty(d)) {
            var f = Xa[d];
            f = Math.pow(a[0] - f[0], 2) + Math.pow(a[1] - f[1], 2) + Math.pow(a[2] - f[2], 2);
            if (f < c) {
              c = f;
              var e = d;
            }
          }
        return e;
      };
      d.keyword.rgb = function (a) {
        return Xa[a];
      };
      d.rgb.xyz = function (a) {
        var c = a[0] / 255,
          b = a[1] / 255;
        a = a[2] / 255;
        c = 0.04045 < c ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
        b = 0.04045 < b ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        a = 0.04045 < a ? Math.pow((a + 0.055) / 1.055, 2.4) : a / 12.92;
        return [100 * (0.4124 * c + 0.3576 * b + 0.1805 * a), 100 * (0.2126 * c + 0.7152 * b + 0.0722 * a), 100 * (0.0193 * c + 0.1192 * b + 0.9505 * a)];
      };
      d.rgb.lab = function (a) {
        var c = d.rgb.xyz(a);
        a = c[0];
        var b = c[1];
        c = c[2];
        a /= 95.047;
        b /= 100;
        c /= 108.883;
        a = 0.008856 < a ? Math.pow(a, 1 / 3) : 7.787 * a + 16 / 116;
        b = 0.008856 < b ? Math.pow(b, 1 / 3) : 7.787 * b + 16 / 116;
        c = 0.008856 < c ? Math.pow(c, 1 / 3) : 7.787 * c + 16 / 116;
        return [116 * b - 16, 500 * (a - b), 200 * (b - c)];
      };
      d.hsl.rgb = function (a) {
        var c = a[0] / 360,
          b = a[1] / 100;
        a = a[2] / 100;
        if (0 === b) {
          var d = 255 * a;
          return [d, d, d];
        }
        b = 0.5 > a ? a * (1 + b) : a + b - a * b;
        a = 2 * a - b;
        var f = [0, 0, 0];
        for (var e = 0; 3 > e; e++)
          (d = c + (1 / 3) * -(e - 1)),
            0 > d && d++,
            1 < d && d--,
            (d = 1 > 6 * d ? a + 6 * (b - a) * d : 1 > 2 * d ? b : 2 > 3 * d ? a + (b - a) * (2 / 3 - d) * 6 : a),
            (f[e] = 255 * d);
        return f;
      };
      d.hsl.hsv = function (a) {
        var c = a[0],
          b = a[1] / 100;
        a = a[2] / 100;
        var d = b,
          f = Math.max(a, 0.01);
        a *= 2;
        b *= 1 >= a ? a : 2 - a;
        d *= 1 >= f ? f : 2 - f;
        return [c, 100 * (0 === a ? (2 * d) / (f + d) : (2 * b) / (a + b)), ((a + b) / 2) * 100];
      };
      d.hsv.rgb = function (a) {
        var c = a[0] / 60,
          b = a[1] / 100;
        a = a[2] / 100;
        var d = Math.floor(c) % 6,
          f = c - Math.floor(c);
        c = 255 * a * (1 - b);
        var e = 255 * a * (1 - b * f);
        b = 255 * a * (1 - b * (1 - f));
        a *= 255;
        switch (d) {
          case 0:
            return [a, b, c];
          case 1:
            return [e, a, c];
          case 2:
            return [c, a, b];
          case 3:
            return [c, e, a];
          case 4:
            return [b, c, a];
          case 5:
            return [a, c, e];
        }
      };
      d.hsv.hsl = function (a) {
        var c = a[0],
          b = a[1] / 100;
        a = a[2] / 100;
        var d = Math.max(a, 0.01);
        var f = (2 - b) * d;
        d = (b * d) / (1 >= f ? f : 2 - f) || 0;
        return [c, 100 * d, (((2 - b) * a) / 2) * 100];
      };
      d.hwb.rgb = function (a) {
        var c = a[0] / 360,
          b = a[1] / 100;
        a = a[2] / 100;
        var d = b + a;
        1 < d && ((b /= d), (a /= d));
        d = Math.floor(6 * c);
        a = 1 - a;
        c = 6 * c - d;
        0 !== (d & 1) && (c = 1 - c);
        c = b + c * (a - b);
        switch (d) {
          default:
          case 6:
          case 0:
            d = a;
            var f = c;
            break;
          case 1:
            d = c;
            f = a;
            break;
          case 2:
            d = b;
            f = a;
            b = c;
            break;
          case 3:
            d = b;
            f = c;
            b = a;
            break;
          case 4:
            d = c;
            f = b;
            b = a;
            break;
          case 5:
            (d = a), (f = b), (b = c);
        }
        return [255 * d, 255 * f, 255 * b];
      };
      d.cmyk.rgb = function (a) {
        var c = a[3] / 100;
        return [255 * (1 - Math.min(1, (a[0] / 100) * (1 - c) + c)), 255 * (1 - Math.min(1, (a[1] / 100) * (1 - c) + c)), 255 * (1 - Math.min(1, (a[2] / 100) * (1 - c) + c))];
      };
      d.xyz.rgb = function (a) {
        var c = a[0] / 100,
          b = a[1] / 100,
          d = a[2] / 100;
        a = 3.2406 * c + -1.5372 * b + -0.4986 * d;
        var f = -0.9689 * c + 1.8758 * b + 0.0415 * d;
        c = 0.0557 * c + -0.204 * b + 1.057 * d;
        a = 0.0031308 < a ? 1.055 * Math.pow(a, 1 / 2.4) - 0.055 : 12.92 * a;
        f = 0.0031308 < f ? 1.055 * Math.pow(f, 1 / 2.4) - 0.055 : 12.92 * f;
        c = 0.0031308 < c ? 1.055 * Math.pow(c, 1 / 2.4) - 0.055 : 12.92 * c;
        a = Math.min(Math.max(0, a), 1);
        f = Math.min(Math.max(0, f), 1);
        c = Math.min(Math.max(0, c), 1);
        return [255 * a, 255 * f, 255 * c];
      };
      d.xyz.lab = function (a) {
        var c = a[0],
          b = a[1];
        a = a[2];
        c /= 95.047;
        b /= 100;
        a /= 108.883;
        c = 0.008856 < c ? Math.pow(c, 1 / 3) : 7.787 * c + 16 / 116;
        b = 0.008856 < b ? Math.pow(b, 1 / 3) : 7.787 * b + 16 / 116;
        a = 0.008856 < a ? Math.pow(a, 1 / 3) : 7.787 * a + 16 / 116;
        return [116 * b - 16, 500 * (c - b), 200 * (b - a)];
      };
      d.lab.xyz = function (a) {
        var c = a[1],
          b = a[2];
        a = (a[0] + 16) / 116;
        c = c / 500 + a;
        b = a - b / 200;
        var d = Math.pow(a, 3),
          f = Math.pow(c, 3),
          e = Math.pow(b, 3);
        return [95.047 * (0.008856 < f ? f : (c - 16 / 116) / 7.787), 100 * (0.008856 < d ? d : (a - 16 / 116) / 7.787), 108.883 * (0.008856 < e ? e : (b - 16 / 116) / 7.787)];
      };
      d.lab.lch = function (a) {
        var c = a[0],
          b = a[1];
        a = a[2];
        var d = (360 * Math.atan2(a, b)) / 2 / Math.PI;
        0 > d && (d += 360);
        return [c, Math.sqrt(b * b + a * a), d];
      };
      d.lch.lab = function (a) {
        var c = a[0],
          b = a[1];
        a = (a[2] / 360) * 2 * Math.PI;
        return [c, b * Math.cos(a), b * Math.sin(a)];
      };
      d.rgb.ansi16 = function (a) {
        var c = a[0],
          b = a[1],
          f = a[2],
          e = 1 in arguments ? arguments[1] : d.rgb.hsv(a)[2];
        e = Math.round(e / 50);
        if (0 === e) return 30;
        c = 30 + ((Math.round(f / 255) << 2) | (Math.round(b / 255) << 1) | Math.round(c / 255));
        2 === e && (c += 60);
        return c;
      };
      d.hsv.ansi16 = function (a) {
        return d.rgb.ansi16(d.hsv.rgb(a), a[2]);
      };
      d.rgb.ansi256 = function (a) {
        var c = a[0],
          b = a[1];
        a = a[2];
        return c === b && b === a
          ? 8 > c
            ? 16
            : 248 < c
            ? 231
            : Math.round(((c - 8) / 247) * 24) + 232
          : 16 + 36 * Math.round((c / 255) * 5) + 6 * Math.round((b / 255) * 5) + Math.round((a / 255) * 5);
      };
      d.ansi16.rgb = function (a) {
        var c = a % 10;
        if (0 === c || 7 === c) return 50 < a && (c += 3.5), (c = (c / 10.5) * 255), [c, c, c];
        a = 0.5 * (~~(50 < a) + 1);
        return [(c & 1) * a * 255, ((c >> 1) & 1) * a * 255, ((c >> 2) & 1) * a * 255];
      };
      d.ansi256.rgb = function (a) {
        if (232 <= a) {
          var c = 10 * (a - 232) + 8;
          return [c, c, c];
        }
        a -= 16;
        c = (Math.floor(a / 36) / 5) * 255;
        var b = (Math.floor((a %= 36) / 6) / 5) * 255;
        return [c, b, ((a % 6) / 5) * 255];
      };
      d.rgb.hex = function (a) {
        a = (((Math.round(a[0]) & 255) << 16) + ((Math.round(a[1]) & 255) << 8) + (Math.round(a[2]) & 255)).toString(16).toUpperCase();
        return "000000".substring(a.length) + a;
      };
      d.hex.rgb = function (a) {
        a = a.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
        if (!a) return [0, 0, 0];
        var c = a[0];
        3 === a[0].length &&
          (c = c
            .split("")
            .map(function (a) {
              return a + a;
            })
            .join(""));
        a = parseInt(c, 16);
        return [(a >> 16) & 255, (a >> 8) & 255, a & 255];
      };
      d.rgb.hcg = function (a) {
        var c = a[0] / 255,
          b = a[1] / 255;
        a = a[2] / 255;
        var d = Math.max(Math.max(c, b), a),
          f = Math.min(Math.min(c, b), a),
          e = d - f;
        return [(((0 >= e ? 0 : d === c ? ((b - a) / e) % 6 : d === b ? 2 + (a - c) / e : (c - b) / e + 8) / 6) % 1) * 360, 100 * e, 100 * (1 > e ? f / (1 - e) : 0)];
      };
      d.hsl.hcg = function (a) {
        var c = a[1] / 100,
          b = a[2] / 100,
          d = 0;
        c = 0.5 > b ? 2 * c * b : 2 * c * (1 - b);
        1 > c && (d = (b - 0.5 * c) / (1 - c));
        return [a[0], 100 * c, 100 * d];
      };
      d.hsv.hcg = function (a) {
        var c = a[2] / 100,
          b = (a[1] / 100) * c,
          d = 0;
        1 > b && (d = (c - b) / (1 - b));
        return [a[0], 100 * b, 100 * d];
      };
      d.hcg.rgb = function (a) {
        var c = a[1] / 100,
          b = a[2] / 100;
        if (0 === c) return [255 * b, 255 * b, 255 * b];
        var d = [0, 0, 0];
        a = ((a[0] / 360) % 1) * 6;
        var f = a % 1,
          e = 1 - f;
        switch (Math.floor(a)) {
          case 0:
            d[0] = 1;
            d[1] = f;
            d[2] = 0;
            break;
          case 1:
            d[0] = e;
            d[1] = 1;
            d[2] = 0;
            break;
          case 2:
            d[0] = 0;
            d[1] = 1;
            d[2] = f;
            break;
          case 3:
            d[0] = 0;
            d[1] = e;
            d[2] = 1;
            break;
          case 4:
            d[0] = f;
            d[1] = 0;
            d[2] = 1;
            break;
          default:
            (d[0] = 1), (d[1] = 0), (d[2] = e);
        }
        b *= 1 - c;
        return [255 * (c * d[0] + b), 255 * (c * d[1] + b), 255 * (c * d[2] + b)];
      };
      d.hcg.hsv = function (a) {
        var c = a[1] / 100,
          b = c + (a[2] / 100) * (1 - c),
          d = 0;
        0 < b && (d = c / b);
        return [a[0], 100 * d, 100 * b];
      };
      d.hcg.hsl = function (a) {
        var c = a[1] / 100,
          b = (a[2] / 100) * (1 - c) + 0.5 * c,
          d = 0;
        0 < b && 0.5 > b ? (d = c / (2 * b)) : 0.5 <= b && 1 > b && (d = c / (2 * (1 - b)));
        return [a[0], 100 * d, 100 * b];
      };
      d.hcg.hwb = function (a) {
        var c = a[1] / 100,
          b = c + (a[2] / 100) * (1 - c);
        return [a[0], 100 * (b - c), 100 * (1 - b)];
      };
      d.hwb.hcg = function (a) {
        var c = 1 - a[2] / 100,
          b = c - a[1] / 100,
          d = 0;
        1 > b && (d = (c - b) / (1 - b));
        return [a[0], 100 * b, 100 * d];
      };
      d.apple.rgb = function (a) {
        return [(a[0] / 65535) * 255, (a[1] / 65535) * 255, (a[2] / 65535) * 255];
      };
      d.rgb.apple = function (a) {
        return [(a[0] / 255) * 65535, (a[1] / 255) * 65535, (a[2] / 255) * 65535];
      };
      d.gray.rgb = function (a) {
        return [(a[0] / 100) * 255, (a[0] / 100) * 255, (a[0] / 100) * 255];
      };
      d.gray.hsl = d.gray.hsv = function (a) {
        return [0, 0, a[0]];
      };
      d.gray.hwb = function (a) {
        return [0, 100, a[0]];
      };
      d.gray.cmyk = function (a) {
        return [0, 0, 0, a[0]];
      };
      d.gray.lab = function (a) {
        return [a[0], 0, 0];
      };
      d.gray.hex = function (a) {
        a = Math.round((a[0] / 100) * 255) & 255;
        a = ((a << 16) + (a << 8) + a).toString(16).toUpperCase();
        return "000000".substring(a.length) + a;
      };
      d.rgb.gray = function (a) {
        return [((a[0] + a[1] + a[2]) / 3 / 255) * 100];
      };
    }),
    qk = function (e) {
      for (var b = {}, d = qa(Wb), a = d.length, c = 0; c < a; c++) b[d[c]] = { distance: -1, parent: null };
      d = [e];
      for (b[e].distance = 0; d.length; ) {
        e = d.pop();
        a = qa(Wb[e]);
        c = a.length;
        for (var f = 0; f < c; f++) {
          var h = a[f],
            g = b[h];
          -1 === g.distance && ((g.distance = b[e].distance + 1), (g.parent = e), d.unshift(h));
        }
      }
      d = {};
      e = qa(b);
      a = e.length;
      for (c = 0; c < a; c++) {
        var k = e[c];
        if (null !== b[k].parent) {
          f = k;
          h = b;
          g = [h[k].parent, k];
          var l = Wb[h[k].parent][k];
          for (k = h[k].parent; h[k].parent; ) g.unshift(h[k].parent), (l = vb(Wb[h[k].parent][k], l)), (k = h[k].parent);
          l.conversion = g;
          d[f] = l;
        }
      }
      return d;
    },
    mc = {};
  qa(Wb).forEach(function (e) {
    mc[e] = {};
    Object.defineProperty(mc[e], "channels", { value: Wb[e].channels });
    Object.defineProperty(mc[e], "labels", { value: Wb[e].labels });
    var b = qk(e);
    qa(b).forEach(function (d) {
      var a = b[d];
      mc[e][d] = Ma(a);
      mc[e][d].raw = Ob(a);
    });
  });
  var Na = mc,
    fe = [].slice,
    Jf = ["keyword", "gray", "hex"],
    he = {};
  qa(Na).forEach(function (e) {
    he[fe.call(Na[e].labels).sort().join("")] = e;
  });
  var od = {};
  ka.prototype = {
    toString: function () {
      return this.string();
    },
    toJSON: function () {
      return this[this.model]();
    },
    string: function (e) {
      var b = this.model in xc.to ? this : this.rgb();
      b = b.round("number" === typeof e ? e : 1);
      e = 1 === b.valpha ? b.color : b.color.concat(this.valpha);
      return xc.to[b.model](e);
    },
    percentString: function (e) {
      e = this.rgb().round("number" === typeof e ? e : 1);
      e = 1 === e.valpha ? e.color : e.color.concat(this.valpha);
      return xc.to.rgb.percent(e);
    },
    array: function () {
      return 1 === this.valpha ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function () {
      for (var e = {}, b = Na[this.model].channels, d = Na[this.model].labels, a = 0; a < b; a++) e[d[a]] = this.color[a];
      1 !== this.valpha && (e.alpha = this.valpha);
      return e;
    },
    unitArray: function () {
      var e = this.rgb().color;
      e[0] /= 255;
      e[1] /= 255;
      e[2] /= 255;
      1 !== this.valpha && e.push(this.valpha);
      return e;
    },
    unitObject: function () {
      var e = this.rgb().object();
      e.r /= 255;
      e.g /= 255;
      e.b /= 255;
      1 !== this.valpha && (e.alpha = this.valpha);
      return e;
    },
    round: function (e) {
      e = Math.max(e || 0, 0);
      return new ka(this.color.map(nd(e)).concat(this.valpha), this.model);
    },
    alpha: function (e) {
      return arguments.length ? new ka(this.color.concat(Math.max(0, Math.min(1, e))), this.model) : this.valpha;
    },
    red: ia("rgb", 0, sa(255)),
    green: ia("rgb", 1, sa(255)),
    blue: ia("rgb", 2, sa(255)),
    hue: ia(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, function (e) {
      return ((e % 360) + 360) % 360;
    }),
    saturationl: ia("hsl", 1, sa(100)),
    lightness: ia("hsl", 2, sa(100)),
    saturationv: ia("hsv", 1, sa(100)),
    value: ia("hsv", 2, sa(100)),
    chroma: ia("hcg", 1, sa(100)),
    gray: ia("hcg", 2, sa(100)),
    white: ia("hwb", 1, sa(100)),
    wblack: ia("hwb", 2, sa(100)),
    cyan: ia("cmyk", 0, sa(100)),
    magenta: ia("cmyk", 1, sa(100)),
    yellow: ia("cmyk", 2, sa(100)),
    black: ia("cmyk", 3, sa(100)),
    x: ia("xyz", 0, sa(100)),
    y: ia("xyz", 1, sa(100)),
    z: ia("xyz", 2, sa(100)),
    l: ia("lab", 0, sa(100)),
    a: ia("lab", 1),
    b: ia("lab", 2),
    keyword: function (e) {
      return arguments.length ? new ka(e) : Na[this.model].keyword(this.color);
    },
    hex: function (e) {
      return arguments.length ? new ka(e) : xc.to.hex(this.rgb().round().color);
    },
    rgbNumber: function () {
      var e = this.rgb().color;
      return ((e[0] & 255) << 16) | ((e[1] & 255) << 8) | (e[2] & 255);
    },
    luminosity: function () {
      for (var e = this.rgb().color, b = [], d = 0; d < e.length; d++) {
        var a = e[d] / 255;
        b[d] = 0.03928 >= a ? a / 12.92 : Math.pow((a + 0.055) / 1.055, 2.4);
      }
      return 0.2126 * b[0] + 0.7152 * b[1] + 0.0722 * b[2];
    },
    contrast: function (e) {
      var b = this.luminosity();
      e = e.luminosity();
      return b > e ? (b + 0.05) / (e + 0.05) : (e + 0.05) / (b + 0.05);
    },
    level: function (e) {
      e = this.contrast(e);
      return 7.1 <= e ? "AAA" : 4.5 <= e ? "AA" : "";
    },
    isDark: function () {
      var e = this.rgb().color;
      return 128 > (299 * e[0] + 587 * e[1] + 114 * e[2]) / 1e3;
    },
    isLight: function () {
      return !this.isDark();
    },
    negate: function () {
      for (var e = this.rgb(), b = 0; 3 > b; b++) e.color[b] = 255 - e.color[b];
      return e;
    },
    lighten: function (e) {
      var b = this.hsl();
      b.color[2] += b.color[2] * e;
      return b;
    },
    darken: function (e) {
      var b = this.hsl();
      b.color[2] -= b.color[2] * e;
      return b;
    },
    saturate: function (e) {
      var b = this.hsl();
      b.color[1] += b.color[1] * e;
      return b;
    },
    desaturate: function (e) {
      var b = this.hsl();
      b.color[1] -= b.color[1] * e;
      return b;
    },
    whiten: function (e) {
      var b = this.hwb();
      b.color[1] += b.color[1] * e;
      return b;
    },
    blacken: function (e) {
      var b = this.hwb();
      b.color[2] += b.color[2] * e;
      return b;
    },
    grayscale: function () {
      var e = this.rgb().color;
      e = 0.3 * e[0] + 0.59 * e[1] + 0.11 * e[2];
      return ka.rgb(e, e, e);
    },
    fade: function (e) {
      return this.alpha(this.valpha - this.valpha * e);
    },
    opaquer: function (e) {
      return this.alpha(this.valpha + this.valpha * e);
    },
    rotate: function (e) {
      var b = this.hsl(),
        d = b.color[0];
      d = (d + e) % 360;
      b.color[0] = 0 > d ? 360 + d : d;
      return b;
    },
    mix: function (e, b) {
      if (!e || !e.rgb) throw Error('Argument to "mix" was not a Color instance, but rather an instance of ' + ("undefined" === typeof e ? "undefined" : Ha(e)));
      e = e.rgb();
      var d = this.rgb();
      b = void 0 === b ? 0.5 : b;
      var a = 2 * b - 1,
        c = e.alpha() - d.alpha();
      a = ((-1 === a * c ? a : (a + c) / (1 + a * c)) + 1) / 2;
      c = 1 - a;
      return ka.rgb(a * e.red() + c * d.red(), a * e.green() + c * d.green(), a * e.blue() + c * d.blue(), e.alpha() * b + d.alpha() * (1 - b));
    }
  };
  qa(Na).forEach(function (e) {
    if (-1 === Jf.indexOf(e)) {
      var b = Na[e].channels;
      ka.prototype[e] = function () {
        if (this.model === e) return new ka(this);
        if (arguments.length) return new ka(arguments, e);
        var d = "number" === typeof arguments[b] ? b : this.valpha;
        var a = Na[this.model][e].raw(this.color);
        a = Array.isArray(a) ? a : [a];
        return new ka(a.concat(d), e);
      };
      ka[e] = function (d) {
        "number" === typeof d && (d = ge(fe.call(arguments), b));
        return new ka(d, e);
      };
    }
  });
  me(Oa.prototype, {
    equals: function (e) {
      return this.lat === e.lat && this.lng === e.lng;
    },
    clone: function () {
      return new Oa(this.lat, this.lng);
    },
    getLngSpan: function (e) {
      e = Math.abs(e - this.lng);
      180 < e && (e = 360 - e);
      return e;
    },
    sub: function (e) {
      return new Oa(this.lat - e.lat, this.lng - e.lng);
    },
    toString: function () {
      return "Point";
    }
  });
  me(Ea, {
    EARTHRADIUS: 6370996.81,
    MCBAND: [1.289059486e7, 8362377.87, 5591021, 3481989.83, 1678043.12, 0],
    LLBAND: [75, 60, 45, 30, 15, 0],
    MC2LL: [
      [
        1.410526172116255e-8, 8.98305509648872e-6, -1.9939833816331, 200.9824383106796, -187.2403703815547, 91.6087516669843, -23.38765649603339, 2.57121317296198,
        -0.03801003308653, 1.73379812e7
      ],
      [
        -7.435856389565537e-9, 8.983055097726239e-6, -0.78625201886289, 96.32687599759846, -1.85204757529826, -59.36935905485877, 47.40033549296737, -16.50741931063887,
        2.28786674699375, 1.026014486e7
      ],
      [
        -3.030883460898826e-8, 8.98305509983578e-6, 0.30071316287616, 59.74293618442277, 7.357984074871, -25.38371002664745, 13.45380521110908, -3.29883767235584, 0.32710905363475,
        6856817.37
      ],
      [
        -1.981981304930552e-8, 8.983055099779535e-6, 0.03278182852591, 40.31678527705744, 0.65659298677277, -4.44255534477492, 0.85341911805263, 0.12923347998204,
        -0.04625736007561, 4482777.06
      ],
      [
        3.09191371068437e-9, 8.983055096812155e-6, 6.995724062e-5, 23.10934304144901, -2.3663490511e-4, -0.6321817810242, -0.00663494467273, 0.03430082397953, -0.00466043876332,
        2555164.4
      ],
      [2.890871144776878e-9, 8.983055095805407e-6, -3.068298e-8, 7.47137025468032, -3.53937994e-6, -0.02145144861037, -1.234426596e-5, 1.0322952773e-4, -3.23890364e-6, 826088.5]
    ],
    LL2MC: [
      [-0.0015702102444, 111320.7020616939, 0x60e374c3105a3, -0x24bb4115e2e164, 0x5cc55543bb0ae8, -0x7ce070193f3784, 0x5e7ca61ddf8150, -0x261a578d8b24d0, 0x665d60f3742ca, 82.5],
      [
        8.277824516172526e-4, 111320.7020463578, 6.477955746671607e8, -4.082003173641316e9, 1.077490566351142e10, -1.517187553151559e10, 1.205306533862167e10, -5.124939663577472e9,
        9.133119359512032e8, 67.5
      ],
      [
        0.00337398766765, 111320.7020202162, 4481351.045890365, -2.339375119931662e7, 7.968221547186455e7, -1.159649932797253e8, 9.723671115602145e7, -4.366194633752821e7,
        8477230.501135234, 52.5
      ],
      [
        0.00220636496208, 111320.7020209128, 51751.86112841131, 3796837.749470245, 992013.7397791013, -1221952.21711287, 1340652.697009075, -620943.6990984312, 144416.9293806241,
        37.5
      ],
      [
        -3.441963504368392e-4, 111320.7020576856, 278.2353980772752, 2485758.690035394, 6070.750963243378, 54821.18345352118, 9540.606633304236, -2710.55326746645,
        1405.483844121726, 22.5
      ],
      [
        -3.218135878613132e-4, 111320.7020701615, 0.00369383431289, 823725.6402795718, 0.46104986909093, 2351.343141331292, 1.58060784298199, 8.77738589078284, 0.37238884252424,
        7.45
      ]
    ],
    getDistanceByMC: function (e, b) {
      if (!e || !b) return 0;
      e = this.convertMC2LL(e);
      if (!e) return 0;
      var d = this.toRadians(e.lng);
      e = this.toRadians(e.lat);
      b = this.convertMC2LL(b);
      if (!b) return 0;
      var a = this.toRadians(b.lng);
      b = this.toRadians(b.lat);
      return this.getDistance(d, a, e, b);
    },
    getDistanceByLL: function (e, b) {
      if (!e || !b) return 0;
      e.lng = this.getLoop(e.lng, -180, 180);
      e.lat = this.getRange(e.lat, -74, 74);
      b.lng = this.getLoop(b.lng, -180, 180);
      b.lat = this.getRange(b.lat, -74, 74);
      var d = this.toRadians(e.lng);
      var a = this.toRadians(e.lat);
      e = this.toRadians(b.lng);
      b = this.toRadians(b.lat);
      return this.getDistance(d, e, a, b);
    },
    convertMC2LL: function (e) {
      if (null === e || void 0 === e) return new Oa(0, 0);
      if (180 > e.lng && -180 < e.lng && 90 > e.lat && -90 < e.lat) return e;
      var b = new Oa(Math.abs(e.lng), Math.abs(e.lat));
      for (var d = 0; d < this.MCBAND.length; d++)
        if (b.lat >= this.MCBAND[d]) {
          var a = this.MC2LL[d];
          break;
        }
      e = this.convertor(e, a);
      return (e = new Oa(e.lng.toFixed(6), e.lat.toFixed(6)));
    },
    convertLL2MC: function (e) {
      if (null === e || void 0 === e) return new Oa(0, 0);
      if (180 < e.lng || -180 > e.lng || 90 < e.lat || -90 > e.lat) return e;
      e.lng = this.getLoop(e.lng, -180, 180);
      e.lat = this.getRange(e.lat, -74, 74);
      var b = new Oa(e.lng, e.lat);
      for (var d = 0; d < this.LLBAND.length; d++)
        if (b.lat >= this.LLBAND[d]) {
          var a = this.LL2MC[d];
          break;
        }
      if (!a)
        for (d = 0; d < this.LLBAND.length; d++)
          if (b.lat <= -this.LLBAND[d]) {
            a = this.LL2MC[d];
            break;
          }
      e = this.convertor(e, a);
      return (e = new Oa(Number(e.lng.toFixed(2)), Number(e.lat.toFixed(2))));
    },
    convertor: function (e, b) {
      if (e && b) {
        var d = b[0] + b[1] * Math.abs(e.lng),
          a = Math.abs(e.lat) / b[9];
        b = b[2] + b[3] * a + b[4] * a * a + b[5] * a * a * a + b[6] * a * a * a * a + b[7] * a * a * a * a * a + b[8] * a * a * a * a * a * a;
        d *= 0 > e.lng ? -1 : 1;
        b *= 0 > e.lat ? -1 : 1;
        return new Oa(d, b);
      }
    },
    getDistance: function (e, b, d, a) {
      return this.EARTHRADIUS * Math.acos(Math.sin(d) * Math.sin(a) + Math.cos(d) * Math.cos(a) * Math.cos(b - e));
    },
    toRadians: function (e) {
      return (Math.PI * e) / 180;
    },
    toDegrees: function (e) {
      return (180 * e) / Math.PI;
    },
    getRange: function (e, b, d) {
      null != b && (e = Math.max(e, b));
      null != d && (e = Math.min(e, d));
      return e;
    },
    getLoop: function (e, b, d) {
      for (; e > d; ) e -= d - b;
      for (; e < b; ) e += d - b;
      return e;
    }
  });
  me(Ea.prototype, {
    lngLatToMercator: function (e) {
      return Ea.convertLL2MC(e);
    },
    lngLatToPoint: function (e) {
      e = Ea.convertLL2MC(e);
      return new Lf(e.lng, e.lat);
    },
    mercatorToLngLat: function (e) {
      return Ea.convertMC2LL(e);
    },
    pointToLngLat: function (e) {
      e = new Oa(e.x, e.y);
      return Ea.convertMC2LL(e);
    },
    pointToPixel: function (e, b, d, a, c) {
      if (e)
        return (e = this.lngLatToMercator(e, c)), (b = this.getZoomUnits(b)), new Lf(Math.round((e.lng - d.lng) / b + a.width / 2), Math.round((d.lat - e.lat) / b + a.height / 2));
    },
    pixelToPoint: function (e, b, d, a, c) {
      if (e) return (b = this.getZoomUnits(b)), (e = new Oa(d.lng + b * (e.x - a.width / 2), d.lat - b * (e.y - a.height / 2))), this.mercatorToLngLat(e, c);
    },
    getZoomUnits: function (e) {
      return Math.pow(2, 18 - e);
    }
  });
  Ba.prototype.setMax = function (e) {
    this.max = e || 100;
  };
  Ba.prototype.setMin = function (e) {
    this.min = e || 0;
  };
  Ba.prototype.setMaxSize = function (e) {
    this.maxSize = e || 35;
  };
  Ba.prototype.setMinSize = function (e) {
    this.minSize = e || 0;
  };
  Ba.prototype.initPalette = function () {
    var e = this.gradient,
      b = (this.paletteCtx = new ne(256, 1).getContext("2d")),
      d = b.createLinearGradient(0, 0, 256, 1);
    qa(e).forEach(function (a) {
      d.addColorStop(parseFloat(a), e[a]);
    });
    b.fillStyle = d;
    b.fillRect(0, 0, 256, 1);
    b.imageData = b.getImageData(0, 0, 256, 1).data;
  };
  Ba.prototype.getColor = function (e) {
    e = this.getImageData(e);
    return "rgba(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] / 256 + ")";
  };
  Ba.prototype.getImageData = function (e) {
    var b = this.paletteCtx.imageData;
    if (void 0 === e) return b;
    var d = this.max,
      a = this.min;
    e > d && (e = d);
    e < a && (e = a);
    e = 4 * Math.floor(((e - a) / (d - a)) * 255);
    return [b[e], b[e + 1], b[e + 2], b[e + 3]];
  };
  Ba.prototype.getSize = function (e) {
    var b = this.max,
      d = this.min,
      a = this.maxSize,
      c = this.minSize;
    e > b && (e = b);
    e < d && (e = d);
    return c + ((e - d) / (b - d)) * (a - c);
  };
  mb.prototype._initialize = function () {
    this.v0 = this._normalizaCoord(this.options.start);
    this.v3 = this._normalizaCoord(this.options.end);
    this.v1 = this._getControlPoint(this.v0, this.v3, 4);
    this.v2 = this._getControlPoint(this.v3, this.v0, 5);
    this.v0[2] || (this.v0[2] = 0);
    this.v3[2] || (this.v3[2] = 0);
  };
  mb.prototype.setOptions = function (e) {
    this.options = e || {};
    this._initialize();
  };
  mb.prototype.getPoints = function (e) {
    void 0 === e && (e = 20);
    for (var b = [], d = 0; d <= e; d++) b.push(this._getPoint(d / e));
    return b;
  };
  mb.prototype._normalizaCoord = function (e) {
    if (!e) return [];
    e = Ea.convertLL2MC({ lng: Number(e[0]), lat: Number(e[1]) });
    return [e.lng, e.lat];
  };
  mb.prototype._getControlPoint = function (e, b) {
    var d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 1;
    return [].concat(W(this._getQuarter(e, b)), [this._getDistance(e, b) / d]);
  };
  mb.prototype._getQuarter = function (e, b) {
    return [(3 * e[0] + b[0]) / 4, (3 * e[1] + b[1]) / 4];
  };
  mb.prototype._getDistance = function (e, b) {
    return Math.sqrt(Math.pow(e[0] - b[0], 2) + Math.pow(e[1] - b[1], 2));
  };
  mb.prototype._getPoint = function (e) {
    var b = [],
      d = this.v0,
      a = this.v1,
      c = this.v2,
      f = this.v3;
    b.push(oe(e, d[0], a[0], c[0], f[0]), oe(e, d[1], a[1], c[1], f[1]), oe(e, d[2], a[2], c[2], f[2]));
    return b;
  };
  wb.prototype._initialize = function () {
    this.points = this.options.points || this.options.point || [];
    this.greatCirclePoints = [];
    for (var e = [], b = 0; b < this.points.length; b++) {
      var d = this._normalizaCoord(this.points[b]);
      d && e.push(d);
    }
    this.points = e;
  };
  wb.prototype.setOptions = function (e) {
    this.options = e || {};
    this._initialize();
  };
  wb.prototype.getPoints = function () {
    if (0 === this.greatCirclePoints.length) for (var e = 0; e < this.points.length - 1; e++) this._calcGreatCirclePoints(this.points[e], this.points[e + 1]);
    return this.greatCirclePoints;
  };
  wb.prototype._normalizaCoord = function (e) {
    if (!e) return null;
    e instanceof Array && (e = { lng: Number(e[0]), lat: Number(e[1]) });
    var b = Ea.convertLL2MC(e);
    e = Ea.convertMC2LL(e);
    b.latLng = e;
    return b;
  };
  wb.prototype._calcGreatCirclePoints = function (e, b) {
    var d = e.latLng,
      a = b.latLng;
    if (!ke(d.lng, a.lng) || !ke(d.lat, a.lat)) {
      var c = Ea.getDistance(za(d.lng), za(d.lat), za(a.lng), za(a.lat));
      if (!(25e4 > c)) {
        c = Math.round(c / 15e4);
        var f = this._calcAngularDistance(d, a);
        this.greatCirclePoints.push([e.lng, e.lat]);
        for (var h = 0; h < c; h++) {
          var g = this._calcMiddlePoint(d, a, h / c, f);
          g = Ea.convertLL2MC(g);
          var k = Mf(g, e);
          30037726 < k && (g.lng = g.lng < e.lng ? g.lng + this.WORLD_SIZE_MC : g.lng - this.WORLD_SIZE_MC);
          this.greatCirclePoints.push([g.lng, g.lat]);
          e = g;
        }
        k = Mf(b, e);
        30037726 < k && (b.lng = b.lng < e.lng ? b.lng + this.WORLD_SIZE_MC : b.lng - this.WORLD_SIZE_MC);
        this.greatCirclePoints.push([b.lng, b.lat]);
      }
    }
  };
  wb.prototype._calcAngularDistance = function (e, b) {
    var d = za(e.lat),
      a = za(b.lat);
    e = za(e.lng);
    b = za(b.lng);
    return Math.acos(Math.sin(d) * Math.sin(a) + Math.cos(d) * Math.cos(a) * Math.cos(Math.abs(b - e)));
  };
  wb.prototype._calcMiddlePoint = function (e, b, d, a) {
    var c = b.lat,
      f = e.lng;
    b = b.lng;
    e = za(e.lat);
    c = za(c);
    f = za(f);
    var h = za(b);
    b = Math.sin((1 - d) * a) / Math.sin(a);
    a = Math.sin(d * a) / Math.sin(a);
    d = b * Math.cos(e) * Math.cos(f) + a * Math.cos(c) * Math.cos(h);
    f = b * Math.cos(e) * Math.sin(f) + a * Math.cos(c) * Math.sin(h);
    e = Math.atan2(b * Math.sin(e) + a * Math.sin(c), Math.sqrt(Math.pow(d, 2) + Math.pow(f, 2)));
    return new Oa(ie(Math.atan2(f, d)), ie(e));
  };
  var rk = (function () {
      function e() {
        var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
        F(this, e);
        this.options = b;
        this._initialize();
      }
      I(e, [
        {
          key: "_initialize",
          value: function () {
            this.points = this.options.points;
          }
        },
        {
          key: "_normalizaCoord",
          value: function (b) {
            if (!b) return null;
            b instanceof Array && (b = { lng: Number(b[0]), lat: Number(b[1]) });
            return Ea.convertLL2MC(b);
          }
        },
        {
          key: "setOptions",
          value: function () {
            this.options = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
            this._initialize();
          }
        },
        {
          key: "getPoints",
          value: function (b) {
            for (var d = [], a = this.points, c = 0; c < a.length - 1; c++) {
              var f = this.getCurveByTwoPoints(this._normalizaCoord(a[c]), this._normalizaCoord(a[c + 1]), b);
              f && 0 < f.length && (d = d.concat(f));
            }
            return d;
          }
        },
        {
          key: "getCurveByTwoPoints",
          value: function (b, d) {
            var a = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 20;
            if (!b || !d) return null;
            var c = [],
              f = 0;
            if (void 0 === ("undefined" === typeof d ? "undefined" : Ha(d))) "undefined" === typeof c || Ha(c);
            else {
              var e = parseFloat(b.lat),
                g = parseFloat(d.lat),
                k = parseFloat(b.lng),
                l = parseFloat(d.lng);
              l > k && 180 < parseFloat(l - k) && 0 > k && ((k = parseFloat(360 + k)), (l = parseFloat(360 + l)));
              var n = 0;
              if (g === e) {
                var m = 0;
                var p = k - l;
              } else l === k ? ((m = Math.PI / 2), (p = e - g)) : ((m = Math.atan((g - e) / (l - k))), (p = (g - e) / Math.sin(m)));
              0 === n && (n = m + Math.PI / 5);
              p /= 2;
              m = p * Math.cos(n) + k;
              n = p * Math.sin(n) + e;
              for (p = 0; p < a + 1; p++) {
                var q = k * (1 - 2 * f + f * f) + m * (2 * f - 2 * f * f) + l * f * f,
                  t = d.lng;
                c.push([0 > b.lng && 0 < t ? q - 360 : q, e * (1 - 2 * f + f * f) + n * (2 * f - 2 * f * f) + g * f * f]);
                f += 1 / a;
              }
              return c;
            }
          }
        }
      ]);
      return e;
    })(),
    We = [
      { n: "\u5317\u4eac", g: "116.395645,39.929986|12" },
      { n: "\u4e0a\u6d77", g: "121.487899,31.249162|12" },
      { n: "\u5929\u6d25", g: "117.210813,39.14393|12" },
      { n: "\u91cd\u5e86", g: "106.530635,29.544606|12" }
    ],
    Xb = [
      {
        n: "\u5b89\u5fbd",
        g: "117.216005,31.859252|8",
        cities: [
          { n: "\u5408\u80a5", g: "117.282699,31.866942|12" },
          { n: "\u5b89\u5e86", g: "117.058739,30.537898|13" },
          { n: "\u868c\u57e0", g: "117.35708,32.929499|13" },
          { n: "\u4eb3\u5dde", g: "115.787928,33.871211|13" },
          { n: "\u5de2\u6e56", g: "117.88049,31.608733|13" },
          { n: "\u6c60\u5dde", g: "117.494477,30.660019|14" },
          { n: "\u6ec1\u5dde", g: "118.32457,32.317351|13" },
          { n: "\u961c\u9633", g: "115.820932,32.901211|13" },
          { n: "\u6dee\u5317", g: "116.791447,33.960023|13" },
          { n: "\u6dee\u5357", g: "117.018639,32.642812|13" },
          { n: "\u9ec4\u5c71", g: "118.29357,29.734435|13" },
          { n: "\u516d\u5b89", g: "116.505253,31.755558|13" },
          { n: "\u9a6c\u978d\u5c71", g: "118.515882,31.688528|13" },
          { n: "\u5bbf\u5dde", g: "116.988692,33.636772|13" },
          { n: "\u94dc\u9675", g: "117.819429,30.94093|14" },
          { n: "\u829c\u6e56", g: "118.384108,31.36602|12" },
          { n: "\u5ba3\u57ce", g: "118.752096,30.951642|13" }
        ]
      },
      {
        n: "\u798f\u5efa",
        g: "117.984943,26.050118|8",
        cities: [
          { n: "\u798f\u5dde", g: "119.330221,26.047125|12" },
          { n: "\u9f99\u5ca9", g: "117.017997,25.078685|13" },
          { n: "\u5357\u5e73", g: "118.181883,26.643626|13" },
          { n: "\u5b81\u5fb7", g: "119.542082,26.656527|14" },
          { n: "\u8386\u7530", g: "119.077731,25.44845|13" },
          { n: "\u6cc9\u5dde", g: "118.600362,24.901652|12" },
          { n: "\u4e09\u660e", g: "117.642194,26.270835|14" },
          { n: "\u53a6\u95e8", g: "118.103886,24.489231|12" },
          { n: "\u6f33\u5dde", g: "117.676205,24.517065|12" }
        ]
      },
      {
        n: "\u7518\u8083",
        g: "102.457625,38.103267|6",
        cities: [
          { n: "\u5170\u5dde", g: "103.823305,36.064226|12" },
          { n: "\u767d\u94f6", g: "104.171241,36.546682|13" },
          { n: "\u5b9a\u897f", g: "104.626638,35.586056|13" },
          { n: "\u7518\u5357\u5dde", g: "102.917442,34.992211|14" },
          { n: "\u5609\u5cea\u5173", g: "98.281635,39.802397|13" },
          { n: "\u91d1\u660c", g: "102.208126,38.516072|13" },
          { n: "\u9152\u6cc9", g: "98.508415,39.741474|13" },
          { n: "\u4e34\u590f\u5dde", g: "103.215249,35.598514|13" },
          { n: "\u9647\u5357", g: "104.934573,33.39448|14" },
          { n: "\u5e73\u51c9", g: "106.688911,35.55011|13" },
          { n: "\u5e86\u9633", g: "107.644227,35.726801|13" },
          { n: "\u5929\u6c34", g: "105.736932,34.584319|13" },
          { n: "\u6b66\u5a01", g: "102.640147,37.933172|13" },
          { n: "\u5f20\u6396", g: "100.459892,38.93932|13" }
        ]
      },
      {
        n: "\u5e7f\u4e1c",
        g: "113.394818,23.408004|8",
        cities: [
          { n: "\u5e7f\u5dde", g: "113.30765,23.120049|12" },
          { n: "\u6f6e\u5dde", g: "116.630076,23.661812|13" },
          { n: "\u4e1c\u839e", g: "113.763434,23.043024|12" },
          { n: "\u4f5b\u5c71", g: "113.134026,23.035095|13" },
          { n: "\u6cb3\u6e90", g: "114.713721,23.757251|12" },
          { n: "\u60e0\u5dde", g: "114.410658,23.11354|12" },
          { n: "\u6c5f\u95e8", g: "113.078125,22.575117|13" },
          { n: "\u63ed\u9633", g: "116.379501,23.547999|13" },
          { n: "\u8302\u540d", g: "110.931245,21.668226|13" },
          { n: "\u6885\u5dde", g: "116.126403,24.304571|13" },
          { n: "\u6e05\u8fdc", g: "113.040773,23.698469|13" },
          { n: "\u6c55\u5934", g: "116.72865,23.383908|13" },
          { n: "\u6c55\u5c3e", g: "115.372924,22.778731|14" },
          { n: "\u97f6\u5173", g: "113.594461,24.80296|13" },
          { n: "\u6df1\u5733", g: "114.025974,22.546054|12" },
          { n: "\u9633\u6c5f", g: "111.97701,21.871517|14" },
          { n: "\u4e91\u6d6e", g: "112.050946,22.937976|13" },
          { n: "\u6e5b\u6c5f", g: "110.365067,21.257463|13" },
          { n: "\u8087\u5e86", g: "112.479653,23.078663|13" },
          { n: "\u4e2d\u5c71", g: "113.42206,22.545178|12" },
          { n: "\u73e0\u6d77", g: "113.562447,22.256915|13" }
        ]
      },
      {
        n: "\u5e7f\u897f",
        g: "108.924274,23.552255|7",
        cities: [
          { n: "\u5357\u5b81", g: "108.297234,22.806493|12" },
          { n: "\u767e\u8272", g: "106.631821,23.901512|13" },
          { n: "\u5317\u6d77", g: "109.122628,21.472718|13" },
          { n: "\u5d07\u5de6", g: "107.357322,22.415455|14" },
          { n: "\u9632\u57ce\u6e2f", g: "108.351791,21.617398|15" },
          { n: "\u6842\u6797", g: "110.26092,25.262901|12" },
          { n: "\u8d35\u6e2f", g: "109.613708,23.103373|13" },
          { n: "\u6cb3\u6c60", g: "108.069948,24.699521|14" },
          { n: "\u8d3a\u5dde", g: "111.552594,24.411054|14" },
          { n: "\u6765\u5bbe", g: "109.231817,23.741166|14" },
          { n: "\u67f3\u5dde", g: "109.422402,24.329053|12" },
          { n: "\u94a6\u5dde", g: "108.638798,21.97335|13" },
          { n: "\u68a7\u5dde", g: "111.305472,23.485395|13" },
          { n: "\u7389\u6797", g: "110.151676,22.643974|14" }
        ]
      },
      {
        n: "\u8d35\u5dde",
        g: "106.734996,26.902826|8",
        cities: [
          { n: "\u8d35\u9633", g: "106.709177,26.629907|12" },
          { n: "\u5b89\u987a", g: "105.92827,26.228595|13" },
          { n: "\u6bd5\u8282\u5730\u533a", g: "105.300492,27.302612|14" },
          { n: "\u516d\u76d8\u6c34", g: "104.852087,26.591866|13" },
          { n: "\u94dc\u4ec1\u5730\u533a", g: "109.196161,27.726271|14" },
          { n: "\u9075\u4e49", g: "106.93126,27.699961|13" },
          { n: "\u9ed4\u897f\u5357\u5dde", g: "104.900558,25.095148|11" },
          { n: "\u9ed4\u4e1c\u5357\u5dde", g: "107.985353,26.583992|11" },
          { n: "\u9ed4\u5357\u5dde", g: "107.523205,26.264536|11" }
        ]
      },
      {
        n: "\u6d77\u5357",
        g: "109.733755,19.180501|9",
        cities: [
          { n: "\u6d77\u53e3", g: "110.330802,20.022071|13" },
          { n: "\u767d\u6c99", g: "109.358586,19.216056|12" },
          { n: "\u4fdd\u4ead", g: "109.656113,18.597592|12" },
          { n: "\u660c\u6c5f", g: "109.0113,19.222483|12" },
          { n: "\u510b\u5dde", g: "109.413973,19.571153|13" },
          { n: "\u6f84\u8fc8", g: "109.996736,19.693135|13" },
          { n: "\u4e1c\u65b9", g: "108.85101,18.998161|13" },
          { n: "\u5b9a\u5b89", g: "110.32009,19.490991|13" },
          { n: "\u743c\u6d77", g: "110.414359,19.21483|13" },
          { n: "\u743c\u4e2d", g: "109.861849,19.039771|12" },
          { n: "\u4e50\u4e1c", g: "109.062698,18.658614|12" },
          { n: "\u4e34\u9ad8", g: "109.724101,19.805922|13" },
          { n: "\u9675\u6c34", g: "109.948661,18.575985|12" },
          { n: "\u4e09\u4e9a", g: "109.522771,18.257776|12" },
          { n: "\u5c6f\u660c", g: "110.063364,19.347749|13" },
          { n: "\u4e07\u5b81", g: "110.292505,18.839886|13" },
          { n: "\u6587\u660c", g: "110.780909,19.750947|13" },
          { n: "\u4e94\u6307\u5c71", g: "109.51775,18.831306|13" }
        ]
      },
      {
        n: "\u6cb3\u5317",
        g: "115.661434,38.61384|7",
        cities: [
          { n: "\u77f3\u5bb6\u5e84", g: "114.522082,38.048958|12" },
          { n: "\u4fdd\u5b9a", g: "115.49481,38.886565|13" },
          { n: "\u6ca7\u5dde", g: "116.863806,38.297615|13" },
          { n: "\u627f\u5fb7", g: "117.933822,40.992521|14" },
          { n: "\u90af\u90f8", g: "114.482694,36.609308|13" },
          { n: "\u8861\u6c34", g: "115.686229,37.746929|13" },
          { n: "\u5eca\u574a", g: "116.703602,39.518611|13" },
          { n: "\u79e6\u7687\u5c9b", g: "119.604368,39.945462|12" },
          { n: "\u5510\u5c71", g: "118.183451,39.650531|13" },
          { n: "\u90a2\u53f0", g: "114.520487,37.069531|13" },
          { n: "\u5f20\u5bb6\u53e3", g: "114.893782,40.811188|13" }
        ]
      },
      {
        n: "\u6cb3\u5357",
        g: "113.486804,34.157184|7",
        cities: [
          { n: "\u90d1\u5dde", g: "113.649644,34.75661|12" },
          { n: "\u5b89\u9633", g: "114.351807,36.110267|12" },
          { n: "\u9e64\u58c1", g: "114.29777,35.755426|13" },
          { n: "\u7126\u4f5c", g: "113.211836,35.234608|13" },
          { n: "\u5f00\u5c01", g: "114.351642,34.801854|13" },
          { n: "\u6d1b\u9633", g: "112.447525,34.657368|12" },
          { n: "\u6f2f\u6cb3", g: "114.046061,33.576279|13" },
          { n: "\u5357\u9633", g: "112.542842,33.01142|13" },
          { n: "\u5e73\u9876\u5c71", g: "113.300849,33.745301|13" },
          { n: "\u6fee\u9633", g: "115.026627,35.753298|12" },
          { n: "\u4e09\u95e8\u5ce1", g: "111.181262,34.78332|13" },
          { n: "\u5546\u4e18", g: "115.641886,34.438589|13" },
          { n: "\u65b0\u4e61", g: "113.91269,35.307258|13" },
          { n: "\u4fe1\u9633", g: "114.085491,32.128582|13" },
          { n: "\u8bb8\u660c", g: "113.835312,34.02674|13" },
          { n: "\u5468\u53e3", g: "114.654102,33.623741|13" },
          { n: "\u9a7b\u9a6c\u5e97", g: "114.049154,32.983158|13" }
        ]
      },
      {
        n: "\u9ed1\u9f99\u6c5f",
        g: "128.047414,47.356592|6",
        cities: [
          { n: "\u54c8\u5c14\u6ee8", g: "126.657717,45.773225|12" },
          { n: "\u5927\u5e86", g: "125.02184,46.596709|12" },
          { n: "\u5927\u5174\u5b89\u5cad\u5730\u533a", g: "124.196104,51.991789|10" },
          { n: "\u9e64\u5c97", g: "130.292472,47.338666|13" },
          { n: "\u9ed1\u6cb3", g: "127.50083,50.25069|14" },
          { n: "\u9e21\u897f", g: "130.941767,45.32154|13" },
          { n: "\u4f73\u6728\u65af", g: "130.284735,46.81378|12" },
          { n: "\u7261\u4e39\u6c5f", g: "129.608035,44.588521|13" },
          { n: "\u4e03\u53f0\u6cb3", g: "131.019048,45.775005|14" },
          { n: "\u9f50\u9f50\u54c8\u5c14", g: "123.987289,47.3477|13" },
          { n: "\u53cc\u9e2d\u5c71", g: "131.171402,46.655102|13" },
          { n: "\u7ee5\u5316", g: "126.989095,46.646064|13" },
          { n: "\u4f0a\u6625", g: "128.910766,47.734685|14" }
        ]
      },
      {
        n: "\u6e56\u5317",
        g: "112.410562,31.209316|8",
        cities: [
          { n: "\u6b66\u6c49", g: "114.3162,30.581084|12" },
          { n: "\u9102\u5dde", g: "114.895594,30.384439|14" },
          { n: "\u6069\u65bd", g: "109.517433,30.308978|14" },
          { n: "\u9ec4\u5188", g: "114.906618,30.446109|14" },
          { n: "\u9ec4\u77f3", g: "115.050683,30.216127|13" },
          { n: "\u8346\u95e8", g: "112.21733,31.042611|13" },
          { n: "\u8346\u5dde", g: "112.241866,30.332591|12" },
          { n: "\u6f5c\u6c5f", g: "112.768768,30.343116|13" },
          { n: "\u795e\u519c\u67b6\u6797\u533a", g: "110.487231,31.595768|13" },
          { n: "\u5341\u5830", g: "110.801229,32.636994|13" },
          { n: "\u968f\u5dde", g: "113.379358,31.717858|13" },
          { n: "\u5929\u95e8", g: "113.12623,30.649047|13" },
          { n: "\u4ed9\u6843", g: "113.387448,30.293966|13" },
          { n: "\u54b8\u5b81", g: "114.300061,29.880657|13" },
          { n: "\u8944\u9633", g: "112.176326,32.094934|12" },
          { n: "\u5b5d\u611f", g: "113.935734,30.927955|13" },
          { n: "\u5b9c\u660c", g: "111.310981,30.732758|13" }
        ]
      },
      {
        n: "\u6e56\u5357",
        g: "111.720664,27.695864|7",
        cities: [
          { n: "\u957f\u6c99", g: "112.979353,28.213478|12" },
          { n: "\u5e38\u5fb7", g: "111.653718,29.012149|12" },
          { n: "\u90f4\u5dde", g: "113.037704,25.782264|13" },
          { n: "\u8861\u9633", g: "112.583819,26.898164|13" },
          { n: "\u6000\u5316", g: "109.986959,27.557483|13" },
          { n: "\u5a04\u5e95", g: "111.996396,27.741073|13" },
          { n: "\u90b5\u9633", g: "111.461525,27.236811|13" },
          { n: "\u6e58\u6f6d", g: "112.935556,27.835095|13" },
          { n: "\u6e58\u897f\u5dde", g: "109.745746,28.317951|14" },
          { n: "\u76ca\u9633", g: "112.366547,28.588088|13" },
          { n: "\u6c38\u5dde", g: "111.614648,26.435972|13" },
          { n: "\u5cb3\u9633", g: "113.146196,29.378007|13" },
          { n: "\u5f20\u5bb6\u754c", g: "110.48162,29.124889|13" },
          { n: "\u682a\u6d32", g: "113.131695,27.827433|13" }
        ]
      },
      {
        n: "\u6c5f\u82cf",
        g: "119.368489,33.013797|8",
        cities: [
          { n: "\u5357\u4eac", g: "118.778074,32.057236|12" },
          { n: "\u5e38\u5dde", g: "119.981861,31.771397|12" },
          { n: "\u6dee\u5b89", g: "119.030186,33.606513|12" },
          { n: "\u8fde\u4e91\u6e2f", g: "119.173872,34.601549|12" },
          { n: "\u5357\u901a", g: "120.873801,32.014665|12" },
          { n: "\u82cf\u5dde", g: "120.619907,31.317987|12" },
          { n: "\u5bbf\u8fc1", g: "118.296893,33.95205|13" },
          { n: "\u6cf0\u5dde", g: "119.919606,32.476053|13" },
          { n: "\u65e0\u9521", g: "120.305456,31.570037|12" },
          { n: "\u5f90\u5dde", g: "117.188107,34.271553|12" },
          { n: "\u76d0\u57ce", g: "120.148872,33.379862|12" },
          { n: "\u626c\u5dde", g: "119.427778,32.408505|13" },
          { n: "\u9547\u6c5f", g: "119.455835,32.204409|13" }
        ]
      },
      {
        n: "\u6c5f\u897f",
        g: "115.676082,27.757258|7",
        cities: [
          { n: "\u5357\u660c", g: "115.893528,28.689578|12" },
          { n: "\u629a\u5dde", g: "116.360919,27.954545|13" },
          { n: "\u8d63\u5dde", g: "114.935909,25.845296|13" },
          { n: "\u5409\u5b89", g: "114.992039,27.113848|13" },
          { n: "\u666f\u5fb7\u9547", g: "117.186523,29.303563|12" },
          { n: "\u4e5d\u6c5f", g: "115.999848,29.71964|13" },
          { n: "\u840d\u4e61", g: "113.859917,27.639544|13" },
          { n: "\u4e0a\u9976", g: "117.955464,28.457623|13" },
          { n: "\u65b0\u4f59", g: "114.947117,27.822322|13" },
          { n: "\u5b9c\u6625", g: "114.400039,27.81113|13" },
          { n: "\u9e70\u6f6d", g: "117.03545,28.24131|13" }
        ]
      },
      {
        n: "\u5409\u6797",
        g: "126.262876,43.678846|7",
        cities: [
          { n: "\u957f\u6625", g: "125.313642,43.898338|12" },
          { n: "\u767d\u57ce", g: "122.840777,45.621086|13" },
          { n: "\u767d\u5c71", g: "126.435798,41.945859|13" },
          { n: "\u5409\u6797", g: "126.564544,43.871988|12" },
          { n: "\u8fbd\u6e90", g: "125.133686,42.923303|13" },
          { n: "\u56db\u5e73", g: "124.391382,43.175525|12" },
          { n: "\u677e\u539f", g: "124.832995,45.136049|13" },
          { n: "\u901a\u5316", g: "125.94265,41.736397|13" },
          { n: "\u5ef6\u8fb9", g: "129.485902,42.896414|13" }
        ]
      },
      {
        n: "\u8fbd\u5b81",
        g: "122.753592,41.6216|8",
        cities: [
          { n: "\u6c88\u9633", g: "123.432791,41.808645|12" },
          { n: "\u978d\u5c71", g: "123.007763,41.118744|13" },
          { n: "\u672c\u6eaa", g: "123.778062,41.325838|12" },
          { n: "\u671d\u9633", g: "120.446163,41.571828|13" },
          { n: "\u5927\u8fde", g: "121.593478,38.94871|12" },
          { n: "\u4e39\u4e1c", g: "124.338543,40.129023|12" },
          { n: "\u629a\u987a", g: "123.92982,41.877304|12" },
          { n: "\u961c\u65b0", g: "121.660822,42.01925|14" },
          { n: "\u846b\u82a6\u5c9b", g: "120.860758,40.74303|13" },
          { n: "\u9526\u5dde", g: "121.147749,41.130879|13" },
          { n: "\u8fbd\u9633", g: "123.172451,41.273339|14" },
          { n: "\u76d8\u9526", g: "122.073228,41.141248|13" },
          { n: "\u94c1\u5cad", g: "123.85485,42.299757|13" },
          { n: "\u8425\u53e3", g: "122.233391,40.668651|13" }
        ]
      },
      {
        n: "\u5185\u8499\u53e4",
        g: "114.415868,43.468238|5",
        cities: [
          { n: "\u547c\u548c\u6d69\u7279", g: "111.660351,40.828319|12" },
          { n: "\u963f\u62c9\u5584\u76df", g: "105.695683,38.843075|14" },
          { n: "\u5305\u5934", g: "109.846239,40.647119|12" },
          { n: "\u5df4\u5f66\u6dd6\u5c14", g: "107.423807,40.76918|12" },
          { n: "\u8d64\u5cf0", g: "118.930761,42.297112|12" },
          { n: "\u9102\u5c14\u591a\u65af", g: "109.993706,39.81649|12" },
          { n: "\u547c\u4f26\u8d1d\u5c14", g: "119.760822,49.201636|12" },
          { n: "\u901a\u8fbd", g: "122.260363,43.633756|12" },
          { n: "\u4e4c\u6d77", g: "106.831999,39.683177|13" },
          { n: "\u4e4c\u5170\u5bdf\u5e03", g: "113.112846,41.022363|12" },
          { n: "\u9521\u6797\u90ed\u52d2\u76df", g: "116.02734,43.939705|11" },
          { n: "\u5174\u5b89\u76df", g: "122.048167,46.083757|11" }
        ]
      },
      {
        n: "\u5b81\u590f",
        g: "106.155481,37.321323|8",
        cities: [
          { n: "\u94f6\u5ddd", g: "106.206479,38.502621|12" },
          { n: "\u56fa\u539f", g: "106.285268,36.021523|13" },
          { n: "\u77f3\u5634\u5c71", g: "106.379337,39.020223|13" },
          { n: "\u5434\u5fe0", g: "106.208254,37.993561|14" },
          { n: "\u4e2d\u536b", g: "105.196754,37.521124|14" }
        ]
      },
      {
        n: "\u9752\u6d77",
        g: "96.202544,35.499761|7",
        cities: [
          { n: "\u897f\u5b81", g: "101.767921,36.640739|12" },
          { n: "\u679c\u6d1b\u5dde", g: "100.223723,34.480485|11" },
          { n: "\u6d77\u4e1c\u5730\u533a", g: "102.085207,36.51761|11" },
          { n: "\u6d77\u5317\u5dde", g: "100.879802,36.960654|11" },
          { n: "\u6d77\u5357\u5dde", g: "100.624066,36.284364|11" },
          { n: "\u6d77\u897f\u5dde", g: "97.342625,37.373799|11" },
          { n: "\u9ec4\u5357\u5dde", g: "102.0076,35.522852|11" },
          { n: "\u7389\u6811\u5dde", g: "97.013316,33.00624|14" }
        ]
      },
      {
        n: "\u5c71\u4e1c",
        g: "118.527663,36.09929|8",
        cities: [
          { n: "\u6d4e\u5357", g: "117.024967,36.682785|12" },
          { n: "\u6ee8\u5dde", g: "117.968292,37.405314|12" },
          { n: "\u4e1c\u8425", g: "118.583926,37.487121|12" },
          { n: "\u5fb7\u5dde", g: "116.328161,37.460826|12" },
          { n: "\u83cf\u6cfd", g: "115.46336,35.26244|13" },
          { n: "\u6d4e\u5b81", g: "116.600798,35.402122|13" },
          { n: "\u83b1\u829c", g: "117.684667,36.233654|13" },
          { n: "\u804a\u57ce", g: "115.986869,36.455829|12" },
          { n: "\u4e34\u6c82", g: "118.340768,35.072409|12" },
          { n: "\u9752\u5c9b", g: "120.384428,36.105215|12" },
          { n: "\u65e5\u7167", g: "119.50718,35.420225|12" },
          { n: "\u6cf0\u5b89", g: "117.089415,36.188078|13" },
          { n: "\u5a01\u6d77", g: "122.093958,37.528787|13" },
          { n: "\u6f4d\u574a", g: "119.142634,36.716115|12" },
          { n: "\u70df\u53f0", g: "121.309555,37.536562|12" },
          { n: "\u67a3\u5e84", g: "117.279305,34.807883|13" },
          { n: "\u6dc4\u535a", g: "118.059134,36.804685|12" }
        ]
      },
      {
        n: "\u5c71\u897f",
        g: "112.515496,37.866566|7",
        cities: [
          { n: "\u592a\u539f", g: "112.550864,37.890277|12" },
          { n: "\u957f\u6cbb", g: "113.120292,36.201664|12" },
          { n: "\u5927\u540c", g: "113.290509,40.113744|12" },
          { n: "\u664b\u57ce", g: "112.867333,35.499834|13" },
          { n: "\u664b\u4e2d", g: "112.738514,37.693362|13" },
          { n: "\u4e34\u6c7e", g: "111.538788,36.099745|13" },
          { n: "\u5415\u6881", g: "111.143157,37.527316|14" },
          { n: "\u6714\u5dde", g: "112.479928,39.337672|13" },
          { n: "\u5ffb\u5dde", g: "112.727939,38.461031|12" },
          { n: "\u9633\u6cc9", g: "113.569238,37.869529|13" },
          { n: "\u8fd0\u57ce", g: "111.006854,35.038859|13" }
        ]
      },
      {
        n: "\u9655\u897f",
        g: "109.503789,35.860026|7",
        cities: [
          { n: "\u897f\u5b89", g: "108.953098,34.2778|12" },
          { n: "\u5b89\u5eb7", g: "109.038045,32.70437|13" },
          { n: "\u5b9d\u9e21", g: "107.170645,34.364081|12" },
          { n: "\u6c49\u4e2d", g: "107.045478,33.081569|13" },
          { n: "\u5546\u6d1b", g: "109.934208,33.873907|13" },
          { n: "\u94dc\u5ddd", g: "108.968067,34.908368|13" },
          { n: "\u6e2d\u5357", g: "109.483933,34.502358|13" },
          { n: "\u54b8\u9633", g: "108.707509,34.345373|13" },
          { n: "\u5ef6\u5b89", g: "109.50051,36.60332|13" },
          { n: "\u6986\u6797", g: "109.745926,38.279439|12" }
        ]
      },
      {
        n: "\u56db\u5ddd",
        g: "102.89916,30.367481|7",
        cities: [
          { n: "\u6210\u90fd", g: "104.067923,30.679943|12" },
          { n: "\u963f\u575d\u5dde", g: "102.228565,31.905763|15" },
          { n: "\u5df4\u4e2d", g: "106.757916,31.869189|14" },
          { n: "\u8fbe\u5dde", g: "107.494973,31.214199|14" },
          { n: "\u5fb7\u9633", g: "104.402398,31.13114|13" },
          { n: "\u7518\u5b5c\u5dde", g: "101.969232,30.055144|15" },
          { n: "\u5e7f\u5b89", g: "106.63572,30.463984|13" },
          { n: "\u5e7f\u5143", g: "105.819687,32.44104|13" },
          { n: "\u4e50\u5c71", g: "103.760824,29.600958|13" },
          { n: "\u51c9\u5c71\u5dde", g: "102.259591,27.892393|14" },
          { n: "\u6cf8\u5dde", g: "105.44397,28.89593|14" },
          { n: "\u5357\u5145", g: "106.105554,30.800965|13" },
          { n: "\u7709\u5c71", g: "103.84143,30.061115|13" },
          { n: "\u7ef5\u9633", g: "104.705519,31.504701|12" },
          { n: "\u5185\u6c5f", g: "105.073056,29.599462|13" },
          { n: "\u6500\u679d\u82b1", g: "101.722423,26.587571|14" },
          { n: "\u9042\u5b81", g: "105.564888,30.557491|12" },
          { n: "\u96c5\u5b89", g: "103.009356,29.999716|13" },
          { n: "\u5b9c\u5bbe", g: "104.633019,28.769675|13" },
          { n: "\u8d44\u9633", g: "104.63593,30.132191|13" },
          { n: "\u81ea\u8d21", g: "104.776071,29.359157|13" }
        ]
      },
      {
        n: "\u897f\u85cf",
        g: "89.137982,31.367315|6",
        cities: [
          { n: "\u62c9\u8428", g: "91.111891,29.662557|13" },
          { n: "\u963f\u91cc\u5730\u533a", g: "81.107669,30.404557|11" },
          { n: "\u660c\u90fd\u5730\u533a", g: "97.185582,31.140576|15" },
          { n: "\u6797\u829d\u5730\u533a", g: "94.349985,29.666941|11" },
          { n: "\u90a3\u66f2\u5730\u533a", g: "92.067018,31.48068|14" },
          { n: "\u65e5\u5580\u5219\u5730\u533a", g: "88.891486,29.269023|14" },
          { n: "\u5c71\u5357\u5730\u533a", g: "91.750644,29.229027|11" }
        ]
      },
      {
        n: "\u65b0\u7586",
        g: "85.614899,42.127001|6",
        cities: [
          { n: "\u4e4c\u9c81\u6728\u9f50", g: "87.564988,43.84038|12" },
          { n: "\u963f\u62c9\u5c14", g: "81.291737,40.61568|13" },
          { n: "\u963f\u514b\u82cf\u5730\u533a", g: "80.269846,41.171731|12" },
          { n: "\u963f\u52d2\u6cf0\u5730\u533a", g: "88.137915,47.839744|13" },
          { n: "\u5df4\u97f3\u90ed\u695e", g: "86.121688,41.771362|12" },
          { n: "\u535a\u5c14\u5854\u62c9\u5dde", g: "82.052436,44.913651|11" },
          { n: "\u660c\u5409\u5dde", g: "87.296038,44.007058|13" },
          { n: "\u54c8\u5bc6\u5730\u533a", g: "93.528355,42.858596|13" },
          { n: "\u548c\u7530\u5730\u533a", g: "79.930239,37.116774|13" },
          { n: "\u5580\u4ec0\u5730\u533a", g: "75.992973,39.470627|12" },
          { n: "\u514b\u62c9\u739b\u4f9d", g: "84.88118,45.594331|13" },
          { n: "\u514b\u5b5c\u52d2\u82cf\u5dde", g: "76.137564,39.750346|11" },
          { n: "\u77f3\u6cb3\u5b50", g: "86.041865,44.308259|13" },
          { n: "\u5854\u57ce\u5730\u533a", g: "82.974881,46.758684|12" },
          { n: "\u56fe\u6728\u8212\u514b", g: "79.198155,39.889223|13" },
          { n: "\u5410\u9c81\u756a\u5730\u533a", g: "89.181595,42.96047|13" },
          { n: "\u4e94\u5bb6\u6e20", g: "87.565449,44.368899|13" },
          { n: "\u4f0a\u7281\u5dde", g: "81.297854,43.922248|11" }
        ]
      },
      {
        n: "\u4e91\u5357",
        g: "101.592952,24.864213|7",
        cities: [
          { n: "\u6606\u660e", g: "102.714601,25.049153|12" },
          { n: "\u4fdd\u5c71", g: "99.177996,25.120489|13" },
          { n: "\u695a\u96c4\u5dde", g: "101.529382,25.066356|13" },
          { n: "\u5927\u7406\u5dde", g: "100.223675,25.5969|14" },
          { n: "\u5fb7\u5b8f\u5dde", g: "98.589434,24.44124|14" },
          { n: "\u8fea\u5e86\u5dde", g: "99.713682,27.831029|14" },
          { n: "\u7ea2\u6cb3\u5dde", g: "103.384065,23.367718|11" },
          { n: "\u4e3d\u6c5f", g: "100.229628,26.875351|13" },
          { n: "\u4e34\u6ca7", g: "100.092613,23.887806|14" },
          { n: "\u6012\u6c5f\u5dde", g: "98.859932,25.860677|14" },
          { n: "\u666e\u6d31", g: "100.980058,22.788778|14" },
          { n: "\u66f2\u9756", g: "103.782539,25.520758|12" },
          { n: "\u662d\u901a", g: "103.725021,27.340633|13" },
          { n: "\u6587\u5c71", g: "104.089112,23.401781|14" },
          { n: "\u897f\u53cc\u7248\u7eb3", g: "100.803038,22.009433|13" },
          { n: "\u7389\u6eaa", g: "102.545068,24.370447|13" }
        ]
      },
      {
        n: "\u6d59\u6c5f",
        g: "119.957202,29.159494|8",
        cities: [
          { n: "\u676d\u5dde", g: "120.219375,30.259244|12" },
          { n: "\u6e56\u5dde", g: "120.137243,30.877925|12" },
          { n: "\u5609\u5174", g: "120.760428,30.773992|13" },
          { n: "\u91d1\u534e", g: "119.652576,29.102899|12" },
          { n: "\u4e3d\u6c34", g: "119.929576,28.4563|13" },
          { n: "\u5b81\u6ce2", g: "121.579006,29.885259|12" },
          { n: "\u8862\u5dde", g: "118.875842,28.95691|12" },
          { n: "\u7ecd\u5174", g: "120.592467,30.002365|13" },
          { n: "\u53f0\u5dde", g: "121.440613,28.668283|13" },
          { n: "\u6e29\u5dde", g: "120.690635,28.002838|12" },
          { n: "\u821f\u5c71", g: "122.169872,30.03601|13" }
        ]
      }
    ],
    Xe = [
      { n: "\u9999\u6e2f", g: "114.186124,22.293586|11" },
      { n: "\u6fb3\u95e8", g: "113.557519,22.204118|13" },
      { n: "\u53f0\u6e7e", g: "120.961454,23.80406|8" }
    ],
    Uc = void 0,
    fh = (function () {
      if (void 0 !== Uc) return Uc;
      var e = navigator.userAgent,
        b = "Android;iPhone;SymbianOS;Windows Phone;iPad;iPod".split(";");
      Uc = !1;
      for (var d = 0; d < b.length; d++)
        if (0 < e.indexOf(b[d])) {
          Uc = !0;
          break;
        }
      return Uc;
    })(),
    Vc = void 0,
    Rf = (function () {
      if (void 0 !== Vc) return Vc;
      var e = navigator.userAgent,
        b = ["iPhone", "iPad", "iPod"];
      Vc = !1;
      for (var d = 0; d < b.length; d++)
        if (0 < e.indexOf(b[d])) {
          Vc = !0;
          break;
        }
      return Vc;
    })(),
    Ye = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]),
    Vd = new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]),
    sk = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]),
    gh = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
    sb = Array(576);
  dc(sb);
  var Wc = Array(60);
  dc(Wc);
  var Yb = Array(512);
  dc(Yb);
  var Xc = Array(256);
  dc(Xc);
  var Ze = Array(29);
  dc(Ze);
  var Wd = Array(30);
  dc(Wd);
  var hh = void 0,
    ih = void 0,
    jh = void 0,
    Yc = function (e, b) {
      e.pending_buf[e.pending++] = b & 255;
      e.pending_buf[e.pending++] = (b >>> 8) & 255;
    },
    La = function (e, b, d) {
      e.bi_valid > 16 - d
        ? ((e.bi_buf |= (b << e.bi_valid) & 65535), Yc(e, e.bi_buf), (e.bi_buf = b >> (16 - e.bi_valid)), (e.bi_valid += d - 16))
        : ((e.bi_buf |= (b << e.bi_valid) & 65535), (e.bi_valid += d));
    },
    gb = function (e, b, d) {
      La(e, d[2 * b], d[2 * b + 1]);
    },
    kh = function (e, b) {
      var d = 0;
      do (d |= e & 1), (e >>>= 1), (d <<= 1);
      while (0 < --b);
      return d >>> 1;
    },
    lh = function (e, b, d) {
      var a = Array(16),
        c = 0,
        f;
      for (f = 1; 15 >= f; f++) a[f] = c = (c + d[f - 1]) << 1;
      for (d = 0; d <= b; d++) (c = e[2 * d + 1]), 0 !== c && (e[2 * d] = kh(a[c]++, c));
    },
    mh = function (e) {
      var b;
      for (b = 0; 286 > b; b++) e.dyn_ltree[2 * b] = 0;
      for (b = 0; 30 > b; b++) e.dyn_dtree[2 * b] = 0;
      for (b = 0; 19 > b; b++) e.bl_tree[2 * b] = 0;
      e.dyn_ltree[512] = 1;
      e.opt_len = e.static_len = 0;
      e.last_lit = e.matches = 0;
    },
    nh = function (e) {
      8 < e.bi_valid ? Yc(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf);
      e.bi_buf = 0;
      e.bi_valid = 0;
    },
    oh = function (e, b, d, a) {
      var c = 2 * b,
        f = 2 * d;
      return e[c] < e[f] || (e[c] === e[f] && a[b] <= a[d]);
    },
    $e = function (e, b, d) {
      for (var a = e.heap[d], c = d << 1; c <= e.heap_len; ) {
        c < e.heap_len && oh(b, e.heap[c + 1], e.heap[c], e.depth) && c++;
        if (oh(b, a, e.heap[c], e.depth)) break;
        e.heap[d] = e.heap[c];
        d = c;
        c <<= 1;
      }
      e.heap[d] = a;
    },
    ph = function (e, b, d) {
      var a = 0;
      if (0 !== e.last_lit) {
        do {
          var c = (e.pending_buf[e.d_buf + 2 * a] << 8) | e.pending_buf[e.d_buf + 2 * a + 1];
          var f = e.pending_buf[e.l_buf + a];
          a++;
          if (0 === c) gb(e, f, b);
          else {
            var h = Xc[f];
            gb(e, h + 256 + 1, b);
            var g = Ye[h];
            0 !== g && ((f -= Ze[h]), La(e, f, g));
            c--;
            h = 256 > c ? Yb[c] : Yb[256 + (c >>> 7)];
            gb(e, h, d);
            g = Vd[h];
            0 !== g && ((c -= Wd[h]), La(e, c, g));
          }
        } while (a < e.last_lit);
      }
      gb(e, 256, b);
    },
    af = function (e, b) {
      var d = b.dyn_tree,
        a = b.stat_desc.static_tree,
        c = b.stat_desc.has_stree,
        f = b.stat_desc.elems,
        h,
        g = -1;
      e.heap_len = 0;
      e.heap_max = 573;
      for (h = 0; h < f; h++) 0 !== d[2 * h] ? ((e.heap[++e.heap_len] = g = h), (e.depth[h] = 0)) : (d[2 * h + 1] = 0);
      for (; 2 > e.heap_len; ) {
        var k = (e.heap[++e.heap_len] = 2 > g ? ++g : 0);
        d[2 * k] = 1;
        e.depth[k] = 0;
        e.opt_len--;
        c && (e.static_len -= a[2 * k + 1]);
      }
      b.max_code = g;
      for (h = e.heap_len >> 1; 1 <= h; h--) $e(e, d, h);
      k = f;
      do
        (h = e.heap[1]),
          (e.heap[1] = e.heap[e.heap_len--]),
          $e(e, d, 1),
          (a = e.heap[1]),
          (e.heap[--e.heap_max] = h),
          (e.heap[--e.heap_max] = a),
          (d[2 * k] = d[2 * h] + d[2 * a]),
          (e.depth[k] = (e.depth[h] >= e.depth[a] ? e.depth[h] : e.depth[a]) + 1),
          (d[2 * h + 1] = d[2 * a + 1] = k),
          (e.heap[1] = k++),
          $e(e, d, 1);
      while (2 <= e.heap_len);
      e.heap[--e.heap_max] = e.heap[1];
      h = b.dyn_tree;
      k = b.max_code;
      a = b.stat_desc.static_tree;
      c = b.stat_desc.has_stree;
      f = b.stat_desc.extra_bits;
      var l = b.stat_desc.extra_base,
        n = b.stat_desc.max_length,
        m,
        p = 0;
      for (m = 0; 15 >= m; m++) e.bl_count[m] = 0;
      h[2 * e.heap[e.heap_max] + 1] = 0;
      for (b = e.heap_max + 1; 573 > b; b++) {
        var q = e.heap[b];
        m = h[2 * h[2 * q + 1] + 1] + 1;
        m > n && ((m = n), p++);
        h[2 * q + 1] = m;
        if (!(q > k)) {
          e.bl_count[m]++;
          var t = 0;
          q >= l && (t = f[q - l]);
          var v = h[2 * q];
          e.opt_len += v * (m + t);
          c && (e.static_len += v * (a[2 * q + 1] + t));
        }
      }
      if (0 !== p) {
        do {
          for (m = n - 1; 0 === e.bl_count[m]; ) m--;
          e.bl_count[m]--;
          e.bl_count[m + 1] += 2;
          e.bl_count[n]--;
          p -= 2;
        } while (0 < p);
        for (m = n; 0 !== m; m--)
          for (q = e.bl_count[m]; 0 !== q; ) (a = e.heap[--b]), a > k || (h[2 * a + 1] !== m && ((e.opt_len += (m - h[2 * a + 1]) * h[2 * a]), (h[2 * a + 1] = m)), q--);
      }
      lh(d, g, e.bl_count);
    },
    qh = function (e, b, d) {
      var a,
        c = -1,
        f = b[1],
        h = 0,
        g = 7,
        k = 4;
      0 === f && ((g = 138), (k = 3));
      b[2 * (d + 1) + 1] = 65535;
      for (a = 0; a <= d; a++) {
        var l = f;
        f = b[2 * (a + 1) + 1];
        (++h < g && l === f) ||
          (h < k ? (e.bl_tree[2 * l] += h) : 0 !== l ? (l !== c && e.bl_tree[2 * l]++, e.bl_tree[32]++) : 10 >= h ? e.bl_tree[34]++ : e.bl_tree[36]++,
          (h = 0),
          (c = l),
          0 === f ? ((g = 138), (k = 3)) : l === f ? ((g = 6), (k = 3)) : ((g = 7), (k = 4)));
      }
    },
    rh = function (e, b, d) {
      var a,
        c = -1,
        f = b[1],
        h = 0,
        g = 7,
        k = 4;
      0 === f && ((g = 138), (k = 3));
      for (a = 0; a <= d; a++) {
        var l = f;
        f = b[2 * (a + 1) + 1];
        if (!(++h < g && l === f)) {
          if (h < k) {
            do gb(e, l, e.bl_tree);
            while (0 !== --h);
          } else
            0 !== l
              ? (l !== c && (gb(e, l, e.bl_tree), h--), gb(e, 16, e.bl_tree), La(e, h - 3, 2))
              : 10 >= h
              ? (gb(e, 17, e.bl_tree), La(e, h - 3, 3))
              : (gb(e, 18, e.bl_tree), La(e, h - 11, 7));
          h = 0;
          c = l;
          0 === f ? ((g = 138), (k = 3)) : l === f ? ((g = 6), (k = 3)) : ((g = 7), (k = 4));
        }
      }
    },
    tk = function (e) {
      var b = 4093624447,
        d;
      for (d = 0; 31 >= d; d++, b >>>= 1) if (b & 1 && 0 !== e.dyn_ltree[2 * d]) return 0;
      if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;
      for (d = 32; 256 > d; d++) if (0 !== e.dyn_ltree[2 * d]) return 1;
      return 0;
    },
    sh = !1,
    th = function (e, b, d, a) {
      La(e, a ? 1 : 0, 3);
      nh(e);
      Yc(e, d);
      Yc(e, ~d);
      e.pending_buf.set(e.window.subarray(b, b + d), e.pending);
      e.pending += d;
    },
    Zc = function (e, b, d, a) {
      var c = (e & 65535) | 0;
      e = ((e >>> 16) & 65535) | 0;
      for (var f; 0 !== d; ) {
        f = 2e3 < d ? 2e3 : d;
        d -= f;
        do (c = (c + b[a++]) | 0), (e = (e + c) | 0);
        while (--f);
        c %= 65521;
        e %= 65521;
      }
      return c | (e << 16) | 0;
    },
    uk = new Uint32Array(
      (function () {
        for (var e, b = [], d = 0; 256 > d; d++) {
          e = d;
          for (var a = 0; 8 > a; a++) e = e & 1 ? 3988292384 ^ (e >>> 1) : e >>> 1;
          b[d] = e;
        }
        return b;
      })()
    ),
    xa = function (e, b, d, a) {
      d = a + d;
      for (e ^= -1; a < d; a++) e = (e >>> 8) ^ uk[(e ^ b[a]) & 255];
      return e ^ -1;
    },
    Pb = {
      2: "need dictionary",
      1: "stream end",
      0: "",
      "-1": "file error",
      "-2": "stream error",
      "-3": "data error",
      "-4": "insufficient memory",
      "-5": "buffer error",
      "-6": "incompatible version"
    },
    V = {
      Z_NO_FLUSH: 0,
      Z_PARTIAL_FLUSH: 1,
      Z_SYNC_FLUSH: 2,
      Z_FULL_FLUSH: 3,
      Z_FINISH: 4,
      Z_BLOCK: 5,
      Z_TREES: 6,
      Z_OK: 0,
      Z_STREAM_END: 1,
      Z_NEED_DICT: 2,
      Z_ERRNO: -1,
      Z_STREAM_ERROR: -2,
      Z_DATA_ERROR: -3,
      Z_MEM_ERROR: -4,
      Z_BUF_ERROR: -5,
      Z_NO_COMPRESSION: 0,
      Z_BEST_SPEED: 1,
      Z_BEST_COMPRESSION: 9,
      Z_DEFAULT_COMPRESSION: -1,
      Z_FILTERED: 1,
      Z_HUFFMAN_ONLY: 2,
      Z_RLE: 3,
      Z_FIXED: 4,
      Z_DEFAULT_STRATEGY: 0,
      Z_BINARY: 0,
      Z_TEXT: 1,
      Z_UNKNOWN: 2,
      Z_DEFLATED: 8
    },
    Fb = function (e, b, d) {
      e.pending_buf[e.d_buf + 2 * e.last_lit] = (b >>> 8) & 255;
      e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = b & 255;
      e.pending_buf[e.l_buf + e.last_lit] = d & 255;
      e.last_lit++;
      0 === b ? e.dyn_ltree[2 * d]++ : (e.matches++, b--, e.dyn_ltree[2 * (Xc[d] + 256 + 1)]++, e.dyn_dtree[2 * (256 > b ? Yb[b] : Yb[256 + (b >>> 7)])]++);
      return e.last_lit === e.lit_bufsize - 1;
    },
    Zb = V.Z_NO_FLUSH,
    vk = V.Z_PARTIAL_FLUSH,
    wk = V.Z_FULL_FLUSH,
    Gb = V.Z_FINISH,
    uh = V.Z_BLOCK,
    hb = V.Z_OK,
    vh = V.Z_STREAM_END,
    Ya = V.Z_STREAM_ERROR,
    xk = V.Z_DATA_ERROR,
    bf = V.Z_BUF_ERROR,
    yk = V.Z_DEFAULT_COMPRESSION,
    zk = V.Z_FILTERED,
    Xd = V.Z_HUFFMAN_ONLY,
    Ak = V.Z_RLE,
    Bk = V.Z_FIXED,
    Ck = V.Z_DEFAULT_STRATEGY,
    Dk = V.Z_UNKNOWN,
    qd = V.Z_DEFLATED,
    Hb = function (e, b) {
      e.msg = Pb[b];
      return b;
    },
    xb = function (e) {
      for (var b = e.length; 0 <= --b; ) e[b] = 0;
    },
    Ib = function (e, b, d) {
      return ((b << e.hash_shift) ^ d) & e.hash_mask;
    },
    Jb = function (e) {
      var b = e.state,
        d = b.pending;
      d > e.avail_out && (d = e.avail_out);
      0 !== d &&
        (e.output.set(b.pending_buf.subarray(b.pending_out, b.pending_out + d), e.next_out),
        (e.next_out += d),
        (b.pending_out += d),
        (e.total_out += d),
        (e.avail_out -= d),
        (b.pending -= d),
        0 === b.pending && (b.pending_out = 0));
    },
    Aa = function (e, b) {
      var d = 0 <= e.block_start ? e.block_start : -1,
        a = e.strstart - e.block_start,
        c = 0;
      if (0 < e.level) {
        2 === e.strm.data_type && (e.strm.data_type = tk(e));
        af(e, e.l_desc);
        af(e, e.d_desc);
        qh(e, e.dyn_ltree, e.l_desc.max_code);
        qh(e, e.dyn_dtree, e.d_desc.max_code);
        af(e, e.bl_desc);
        for (c = 18; 3 <= c && 0 === e.bl_tree[2 * gh[c] + 1]; c--);
        e.opt_len += 3 * (c + 1) + 14;
        var f = (e.opt_len + 3 + 7) >>> 3;
        var h = (e.static_len + 3 + 7) >>> 3;
        h <= f && (f = h);
      } else f = h = a + 5;
      if (a + 4 <= f && -1 !== d) th(e, d, a, b);
      else if (4 === e.strategy || h === f) La(e, 2 + (b ? 1 : 0), 3), ph(e, sb, Wc);
      else {
        La(e, 4 + (b ? 1 : 0), 3);
        d = e.l_desc.max_code + 1;
        a = e.d_desc.max_code + 1;
        c += 1;
        La(e, d - 257, 5);
        La(e, a - 1, 5);
        La(e, c - 4, 4);
        for (f = 0; f < c; f++) La(e, e.bl_tree[2 * gh[f] + 1], 3);
        rh(e, e.dyn_ltree, d - 1);
        rh(e, e.dyn_dtree, a - 1);
        ph(e, e.dyn_ltree, e.dyn_dtree);
      }
      mh(e);
      b && nh(e);
      e.block_start = e.strstart;
      Jb(e.strm);
    },
    ba = function (e, b) {
      e.pending_buf[e.pending++] = b;
    },
    $c = function (e, b) {
      e.pending_buf[e.pending++] = (b >>> 8) & 255;
      e.pending_buf[e.pending++] = b & 255;
    },
    wh = function (e, b) {
      var d = e.max_chain_length,
        a = e.strstart,
        c = e.prev_length,
        f = e.nice_match,
        h = e.strstart > e.w_size - 262 ? e.strstart - (e.w_size - 262) : 0,
        g = e.window,
        k = e.w_mask,
        l = e.prev,
        n = e.strstart + 258,
        m = g[a + c - 1],
        p = g[a + c];
      e.prev_length >= e.good_match && (d >>= 2);
      f > e.lookahead && (f = e.lookahead);
      do {
        var q = b;
        if (g[q + c] === p && g[q + c - 1] === m && g[q] === g[a] && g[++q] === g[a + 1]) {
          a += 2;
          for (
            q++;
            g[++a] === g[++q] &&
            g[++a] === g[++q] &&
            g[++a] === g[++q] &&
            g[++a] === g[++q] &&
            g[++a] === g[++q] &&
            g[++a] === g[++q] &&
            g[++a] === g[++q] &&
            g[++a] === g[++q] &&
            a < n;

          );
          q = 258 - (n - a);
          a = n - 258;
          if (q > c) {
            e.match_start = b;
            c = q;
            if (q >= f) break;
            m = g[a + c - 1];
            p = g[a + c];
          }
        }
      } while ((b = l[b & k]) > h && 0 !== --d);
      return c <= e.lookahead ? c : e.lookahead;
    },
    $b = function (e) {
      var b = e.w_size,
        d;
      do {
        var a = e.window_size - e.lookahead - e.strstart;
        if (e.strstart >= b + (b - 262)) {
          e.window.set(e.window.subarray(b, b + b), 0);
          e.match_start -= b;
          e.strstart -= b;
          e.block_start -= b;
          var c = (d = e.hash_size);
          do {
            var f = e.head[--c];
            e.head[c] = f >= b ? f - b : 0;
          } while (--d);
          c = d = b;
          do (f = e.prev[--c]), (e.prev[c] = f >= b ? f - b : 0);
          while (--d);
          a += b;
        }
        if (0 === e.strm.avail_in) break;
        c = e.strm;
        d = e.window;
        f = e.strstart + e.lookahead;
        var h = c.avail_in;
        h > a && (h = a);
        0 === h
          ? (d = 0)
          : ((c.avail_in -= h),
            d.set(c.input.subarray(c.next_in, c.next_in + h), f),
            1 === c.state.wrap ? (c.adler = Zc(c.adler, d, h, f)) : 2 === c.state.wrap && (c.adler = xa(c.adler, d, h, f)),
            (c.next_in += h),
            (c.total_in += h),
            (d = h));
        e.lookahead += d;
        if (3 <= e.lookahead + e.insert)
          for (
            a = e.strstart - e.insert, e.ins_h = e.window[a], e.ins_h = Ib(e, e.ins_h, e.window[a + 1]);
            e.insert &&
            !((e.ins_h = Ib(e, e.ins_h, e.window[a + 3 - 1])), (e.prev[a & e.w_mask] = e.head[e.ins_h]), (e.head[e.ins_h] = a), a++, e.insert--, 3 > e.lookahead + e.insert);

          );
      } while (262 > e.lookahead && 0 !== e.strm.avail_in);
    },
    cf = function (e, b) {
      for (var d; ; ) {
        if (262 > e.lookahead) {
          $b(e);
          if (262 > e.lookahead && b === Zb) return 1;
          if (0 === e.lookahead) break;
        }
        d = 0;
        3 <= e.lookahead && ((e.ins_h = Ib(e, e.ins_h, e.window[e.strstart + 3 - 1])), (d = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h]), (e.head[e.ins_h] = e.strstart));
        0 !== d && e.strstart - d <= e.w_size - 262 && (e.match_length = wh(e, d));
        if (3 <= e.match_length)
          if (((d = Fb(e, e.strstart - e.match_start, e.match_length - 3)), (e.lookahead -= e.match_length), e.match_length <= e.max_lazy_match && 3 <= e.lookahead)) {
            e.match_length--;
            do e.strstart++, (e.ins_h = Ib(e, e.ins_h, e.window[e.strstart + 3 - 1])), (e.prev[e.strstart & e.w_mask] = e.head[e.ins_h]), (e.head[e.ins_h] = e.strstart);
            while (0 !== --e.match_length);
            e.strstart++;
          } else (e.strstart += e.match_length), (e.match_length = 0), (e.ins_h = e.window[e.strstart]), (e.ins_h = Ib(e, e.ins_h, e.window[e.strstart + 1]));
        else (d = Fb(e, 0, e.window[e.strstart])), e.lookahead--, e.strstart++;
        if (d && (Aa(e, !1), 0 === e.strm.avail_out)) return 1;
      }
      e.insert = 2 > e.strstart ? e.strstart : 2;
      return b === Gb ? (Aa(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (Aa(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
    },
    nc = function (e, b) {
      for (var d, a; ; ) {
        if (262 > e.lookahead) {
          $b(e);
          if (262 > e.lookahead && b === Zb) return 1;
          if (0 === e.lookahead) break;
        }
        d = 0;
        3 <= e.lookahead && ((e.ins_h = Ib(e, e.ins_h, e.window[e.strstart + 3 - 1])), (d = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h]), (e.head[e.ins_h] = e.strstart));
        e.prev_length = e.match_length;
        e.prev_match = e.match_start;
        e.match_length = 2;
        0 !== d &&
          e.prev_length < e.max_lazy_match &&
          e.strstart - d <= e.w_size - 262 &&
          ((e.match_length = wh(e, d)), 5 >= e.match_length && (e.strategy === zk || (3 === e.match_length && 4096 < e.strstart - e.match_start)) && (e.match_length = 2));
        if (3 <= e.prev_length && e.match_length <= e.prev_length) {
          a = e.strstart + e.lookahead - 3;
          d = Fb(e, e.strstart - 1 - e.prev_match, e.prev_length - 3);
          e.lookahead -= e.prev_length - 1;
          e.prev_length -= 2;
          do ++e.strstart <= a && ((e.ins_h = Ib(e, e.ins_h, e.window[e.strstart + 3 - 1])), (e.prev[e.strstart & e.w_mask] = e.head[e.ins_h]), (e.head[e.ins_h] = e.strstart));
          while (0 !== --e.prev_length);
          e.match_available = 0;
          e.match_length = 2;
          e.strstart++;
          if (d && (Aa(e, !1), 0 === e.strm.avail_out)) return 1;
        } else if (e.match_available) {
          if (((d = Fb(e, 0, e.window[e.strstart - 1])) && Aa(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out)) return 1;
        } else (e.match_available = 1), e.strstart++, e.lookahead--;
      }
      e.match_available && (Fb(e, 0, e.window[e.strstart - 1]), (e.match_available = 0));
      e.insert = 2 > e.strstart ? e.strstart : 2;
      return b === Gb ? (Aa(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (Aa(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
    },
    Ek = function (e, b) {
      for (var d, a, c, f = e.window; ; ) {
        if (258 >= e.lookahead) {
          $b(e);
          if (258 >= e.lookahead && b === Zb) return 1;
          if (0 === e.lookahead) break;
        }
        e.match_length = 0;
        if (3 <= e.lookahead && 0 < e.strstart && ((a = e.strstart - 1), (d = f[a]), d === f[++a] && d === f[++a] && d === f[++a])) {
          for (c = e.strstart + 258; d === f[++a] && d === f[++a] && d === f[++a] && d === f[++a] && d === f[++a] && d === f[++a] && d === f[++a] && d === f[++a] && a < c; );
          e.match_length = 258 - (c - a);
          e.match_length > e.lookahead && (e.match_length = e.lookahead);
        }
        3 <= e.match_length
          ? ((d = Fb(e, 1, e.match_length - 3)), (e.lookahead -= e.match_length), (e.strstart += e.match_length), (e.match_length = 0))
          : ((d = Fb(e, 0, e.window[e.strstart])), e.lookahead--, e.strstart++);
        if (d && (Aa(e, !1), 0 === e.strm.avail_out)) return 1;
      }
      e.insert = 0;
      return b === Gb ? (Aa(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (Aa(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
    },
    Fk = function (e, b) {
      for (var d; ; ) {
        if (0 === e.lookahead && ($b(e), 0 === e.lookahead)) {
          if (b === Zb) return 1;
          break;
        }
        e.match_length = 0;
        d = Fb(e, 0, e.window[e.strstart]);
        e.lookahead--;
        e.strstart++;
        if (d && (Aa(e, !1), 0 === e.strm.avail_out)) return 1;
      }
      e.insert = 0;
      return b === Gb ? (Aa(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (Aa(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
    },
    ad = [
      new ab(0, 0, 0, 0, function (e, b) {
        var d = 65535;
        for (d > e.pending_buf_size - 5 && (d = e.pending_buf_size - 5); ; ) {
          if (1 >= e.lookahead) {
            $b(e);
            if (0 === e.lookahead && b === Zb) return 1;
            if (0 === e.lookahead) break;
          }
          e.strstart += e.lookahead;
          e.lookahead = 0;
          var a = e.block_start + d;
          if (0 === e.strstart || e.strstart >= a) if (((e.lookahead = e.strstart - a), (e.strstart = a), Aa(e, !1), 0 === e.strm.avail_out)) return 1;
          if (e.strstart - e.block_start >= e.w_size - 262 && (Aa(e, !1), 0 === e.strm.avail_out)) return 1;
        }
        e.insert = 0;
        if (b === Gb) return Aa(e, !0), 0 === e.strm.avail_out ? 3 : 4;
        e.strstart > e.block_start && Aa(e, !1);
        return 1;
      }),
      new ab(4, 4, 8, 4, cf),
      new ab(4, 5, 16, 8, cf),
      new ab(4, 6, 32, 32, cf),
      new ab(4, 4, 16, 16, nc),
      new ab(8, 16, 32, 32, nc),
      new ab(8, 16, 128, 128, nc),
      new ab(8, 32, 128, 256, nc),
      new ab(32, 128, 258, 1024, nc),
      new ab(32, 258, 258, 4096, nc)
    ],
    xh = function (e) {
      if (!e || !e.state) return Hb(e, Ya);
      e.total_in = e.total_out = 0;
      e.data_type = Dk;
      var b = e.state;
      b.pending = 0;
      b.pending_out = 0;
      0 > b.wrap && (b.wrap = -b.wrap);
      b.status = b.wrap ? 42 : 113;
      e.adler = 2 === b.wrap ? 0 : 1;
      b.last_flush = Zb;
      if (!sh) {
        var d, a, c;
        e = Array(16);
        for (c = a = 0; 28 > c; c++) for (Ze[c] = a, d = 0; d < 1 << Ye[c]; d++) Xc[a++] = c;
        Xc[a - 1] = c;
        for (c = a = 0; 16 > c; c++) for (Wd[c] = a, d = 0; d < 1 << Vd[c]; d++) Yb[a++] = c;
        for (a >>= 7; 30 > c; c++) for (Wd[c] = a << 7, d = 0; d < 1 << (Vd[c] - 7); d++) Yb[256 + a++] = c;
        for (d = 0; 15 >= d; d++) e[d] = 0;
        for (d = 0; 143 >= d; ) (sb[2 * d + 1] = 8), d++, e[8]++;
        for (; 255 >= d; ) (sb[2 * d + 1] = 9), d++, e[9]++;
        for (; 279 >= d; ) (sb[2 * d + 1] = 7), d++, e[7]++;
        for (; 287 >= d; ) (sb[2 * d + 1] = 8), d++, e[8]++;
        lh(sb, 287, e);
        for (d = 0; 30 > d; d++) (Wc[2 * d + 1] = 5), (Wc[2 * d] = kh(d, 5));
        hh = new pe(sb, Ye, 257, 286, 15);
        ih = new pe(Wc, Vd, 0, 30, 15);
        jh = new pe([], sk, 0, 19, 7);
        sh = !0;
      }
      b.l_desc = new qe(b.dyn_ltree, hh);
      b.d_desc = new qe(b.dyn_dtree, ih);
      b.bl_desc = new qe(b.bl_tree, jh);
      b.bi_buf = 0;
      b.bi_valid = 0;
      mh(b);
      return hb;
    },
    yh = function (e) {
      var b = xh(e);
      b === hb &&
        ((e = e.state),
        (e.window_size = 2 * e.w_size),
        xb(e.head),
        (e.max_lazy_match = ad[e.level].max_lazy),
        (e.good_match = ad[e.level].good_length),
        (e.nice_match = ad[e.level].nice_length),
        (e.max_chain_length = ad[e.level].max_chain),
        (e.strstart = 0),
        (e.block_start = 0),
        (e.lookahead = 0),
        (e.insert = 0),
        (e.match_length = e.prev_length = 2),
        (e.match_available = 0),
        (e.ins_h = 0));
      return b;
    },
    zh = function (e, b, d, a, c, f) {
      if (!e) return Ya;
      var h = 1;
      b === yk && (b = 6);
      0 > a ? ((h = 0), (a = -a)) : 15 < a && ((h = 2), (a -= 16));
      if (1 > c || 9 < c || d !== qd || 8 > a || 15 < a || 0 > b || 9 < b || 0 > f || f > Bk) return Hb(e, Ya);
      8 === a && (a = 9);
      var g = new Hi();
      e.state = g;
      g.strm = e;
      g.wrap = h;
      g.gzhead = null;
      g.w_bits = a;
      g.w_size = 1 << g.w_bits;
      g.w_mask = g.w_size - 1;
      g.hash_bits = c + 7;
      g.hash_size = 1 << g.hash_bits;
      g.hash_mask = g.hash_size - 1;
      g.hash_shift = ~~((g.hash_bits + 3 - 1) / 3);
      g.window = new Uint8Array(2 * g.w_size);
      g.head = new Uint16Array(g.hash_size);
      g.prev = new Uint16Array(g.w_size);
      g.lit_bufsize = 1 << (c + 6);
      g.pending_buf_size = 4 * g.lit_bufsize;
      g.pending_buf = new Uint8Array(g.pending_buf_size);
      g.d_buf = 1 * g.lit_bufsize;
      g.l_buf = 3 * g.lit_bufsize;
      g.level = b;
      g.strategy = f;
      g.method = d;
      return yh(e);
    },
    Ac = {
      deflateInit: function (e, b) {
        return zh(e, b, qd, 15, 8, Ck);
      },
      deflateInit2: zh,
      deflateReset: yh,
      deflateResetKeep: xh,
      deflateSetHeader: function (e, b) {
        if (!e || !e.state || 2 !== e.state.wrap) return Ya;
        e.state.gzhead = b;
        return hb;
      },
      deflate: function (e, b) {
        if (!e || !e.state || b > uh || 0 > b) return e ? Hb(e, Ya) : Ya;
        var d = e.state;
        if (!e.output || (!e.input && 0 !== e.avail_in) || (666 === d.status && b !== Gb)) return Hb(e, 0 === e.avail_out ? bf : Ya);
        d.strm = e;
        var a = d.last_flush;
        d.last_flush = b;
        if (42 === d.status)
          if (2 === d.wrap)
            (e.adler = 0),
              ba(d, 31),
              ba(d, 139),
              ba(d, 8),
              d.gzhead
                ? (ba(d, (d.gzhead.text ? 1 : 0) + (d.gzhead.hcrc ? 2 : 0) + (d.gzhead.extra ? 4 : 0) + (d.gzhead.name ? 8 : 0) + (d.gzhead.comment ? 16 : 0)),
                  ba(d, d.gzhead.time & 255),
                  ba(d, (d.gzhead.time >> 8) & 255),
                  ba(d, (d.gzhead.time >> 16) & 255),
                  ba(d, (d.gzhead.time >> 24) & 255),
                  ba(d, 9 === d.level ? 2 : d.strategy >= Xd || 2 > d.level ? 4 : 0),
                  ba(d, d.gzhead.os & 255),
                  d.gzhead.extra && d.gzhead.extra.length && (ba(d, d.gzhead.extra.length & 255), ba(d, (d.gzhead.extra.length >> 8) & 255)),
                  d.gzhead.hcrc && (e.adler = xa(e.adler, d.pending_buf, d.pending, 0)),
                  (d.gzindex = 0),
                  (d.status = 69))
                : (ba(d, 0), ba(d, 0), ba(d, 0), ba(d, 0), ba(d, 0), ba(d, 9 === d.level ? 2 : d.strategy >= Xd || 2 > d.level ? 4 : 0), ba(d, 3), (d.status = 113));
          else {
            var c = (qd + ((d.w_bits - 8) << 4)) << 8;
            c |= (d.strategy >= Xd || 2 > d.level ? 0 : 6 > d.level ? 1 : 6 === d.level ? 2 : 3) << 6;
            0 !== d.strstart && (c |= 32);
            d.status = 113;
            $c(d, c + (31 - (c % 31)));
            0 !== d.strstart && ($c(d, e.adler >>> 16), $c(d, e.adler & 65535));
            e.adler = 1;
          }
        if (69 === d.status)
          if (d.gzhead.extra) {
            for (
              c = d.pending;
              d.gzindex < (d.gzhead.extra.length & 65535) &&
              (d.pending !== d.pending_buf_size ||
                (d.gzhead.hcrc && d.pending > c && (e.adler = xa(e.adler, d.pending_buf, d.pending - c, c)), Jb(e), (c = d.pending), d.pending !== d.pending_buf_size));

            )
              ba(d, d.gzhead.extra[d.gzindex] & 255), d.gzindex++;
            d.gzhead.hcrc && d.pending > c && (e.adler = xa(e.adler, d.pending_buf, d.pending - c, c));
            d.gzindex === d.gzhead.extra.length && ((d.gzindex = 0), (d.status = 73));
          } else d.status = 73;
        if (73 === d.status)
          if (d.gzhead.name) {
            c = d.pending;
            do {
              if (
                d.pending === d.pending_buf_size &&
                (d.gzhead.hcrc && d.pending > c && (e.adler = xa(e.adler, d.pending_buf, d.pending - c, c)), Jb(e), (c = d.pending), d.pending === d.pending_buf_size)
              ) {
                var f = 1;
                break;
              }
              f = d.gzindex < d.gzhead.name.length ? d.gzhead.name.charCodeAt(d.gzindex++) & 255 : 0;
              ba(d, f);
            } while (0 !== f);
            d.gzhead.hcrc && d.pending > c && (e.adler = xa(e.adler, d.pending_buf, d.pending - c, c));
            0 === f && ((d.gzindex = 0), (d.status = 91));
          } else d.status = 91;
        if (91 === d.status)
          if (d.gzhead.comment) {
            c = d.pending;
            do {
              if (
                d.pending === d.pending_buf_size &&
                (d.gzhead.hcrc && d.pending > c && (e.adler = xa(e.adler, d.pending_buf, d.pending - c, c)), Jb(e), (c = d.pending), d.pending === d.pending_buf_size)
              ) {
                f = 1;
                break;
              }
              f = d.gzindex < d.gzhead.comment.length ? d.gzhead.comment.charCodeAt(d.gzindex++) & 255 : 0;
              ba(d, f);
            } while (0 !== f);
            d.gzhead.hcrc && d.pending > c && (e.adler = xa(e.adler, d.pending_buf, d.pending - c, c));
            0 === f && (d.status = 103);
          } else d.status = 103;
        103 === d.status &&
          (d.gzhead.hcrc
            ? (d.pending + 2 > d.pending_buf_size && Jb(e),
              d.pending + 2 <= d.pending_buf_size && (ba(d, e.adler & 255), ba(d, (e.adler >> 8) & 255), (e.adler = 0), (d.status = 113)))
            : (d.status = 113));
        if (0 !== d.pending) {
          if ((Jb(e), 0 === e.avail_out)) return (d.last_flush = -1), hb;
        } else if (0 === e.avail_in && (b << 1) - (4 < b ? 9 : 0) <= (a << 1) - (4 < a ? 9 : 0) && b !== Gb) return Hb(e, bf);
        if (666 === d.status && 0 !== e.avail_in) return Hb(e, bf);
        if (0 !== e.avail_in || 0 !== d.lookahead || (b !== Zb && 666 !== d.status)) {
          a = d.strategy === Xd ? Fk(d, b) : d.strategy === Ak ? Ek(d, b) : ad[d.level].func(d, b);
          if (3 === a || 4 === a) d.status = 666;
          if (1 === a || 3 === a) return 0 === e.avail_out && (d.last_flush = -1), hb;
          if (
            2 === a &&
            (b === vk
              ? (La(d, 2, 3),
                gb(d, 256, sb),
                16 === d.bi_valid
                  ? (Yc(d, d.bi_buf), (d.bi_buf = 0), (d.bi_valid = 0))
                  : 8 <= d.bi_valid && ((d.pending_buf[d.pending++] = d.bi_buf & 255), (d.bi_buf >>= 8), (d.bi_valid -= 8)))
              : b !== uh && (th(d, 0, 0, !1), b === wk && (xb(d.head), 0 === d.lookahead && ((d.strstart = 0), (d.block_start = 0), (d.insert = 0)))),
            Jb(e),
            0 === e.avail_out)
          )
            return (d.last_flush = -1), hb;
        }
        if (b !== Gb) return hb;
        if (0 >= d.wrap) return vh;
        2 === d.wrap
          ? (ba(d, e.adler & 255),
            ba(d, (e.adler >> 8) & 255),
            ba(d, (e.adler >> 16) & 255),
            ba(d, (e.adler >> 24) & 255),
            ba(d, e.total_in & 255),
            ba(d, (e.total_in >> 8) & 255),
            ba(d, (e.total_in >> 16) & 255),
            ba(d, (e.total_in >> 24) & 255))
          : ($c(d, e.adler >>> 16), $c(d, e.adler & 65535));
        Jb(e);
        0 < d.wrap && (d.wrap = -d.wrap);
        return 0 !== d.pending ? hb : vh;
      },
      deflateEnd: function (e) {
        if (!e || !e.state) return Ya;
        var b = e.state.status;
        if (42 !== b && 69 !== b && 73 !== b && 91 !== b && 103 !== b && 113 !== b && 666 !== b) return Hb(e, Ya);
        e.state = null;
        return 113 === b ? Hb(e, xk) : hb;
      },
      deflateSetDictionary: function (e, b) {
        var d = b.length;
        if (!e || !e.state) return Ya;
        var a = e.state,
          c = a.wrap;
        if (2 === c || (1 === c && 42 !== a.status) || a.lookahead) return Ya;
        1 === c && (e.adler = Zc(e.adler, b, d, 0));
        a.wrap = 0;
        if (d >= a.w_size) {
          0 === c && (xb(a.head), (a.strstart = 0), (a.block_start = 0), (a.insert = 0));
          var f = new Uint8Array(a.w_size);
          f.set(b.subarray(d - a.w_size, d), 0);
          b = f;
          d = a.w_size;
        }
        f = e.avail_in;
        var h = e.next_in,
          g = e.input;
        e.avail_in = d;
        e.next_in = 0;
        e.input = b;
        for ($b(a); 3 <= a.lookahead; ) {
          b = a.strstart;
          d = a.lookahead - 2;
          do (a.ins_h = Ib(a, a.ins_h, a.window[b + 3 - 1])), (a.prev[b & a.w_mask] = a.head[a.ins_h]), (a.head[a.ins_h] = b), b++;
          while (--d);
          a.strstart = b;
          a.lookahead = 2;
          $b(a);
        }
        a.strstart += a.lookahead;
        a.block_start = a.strstart;
        a.insert = a.lookahead;
        a.lookahead = 0;
        a.match_length = a.prev_length = 2;
        a.match_available = 0;
        e.next_in = h;
        e.input = g;
        e.avail_in = f;
        a.wrap = c;
        return hb;
      },
      deflateInfo: "pako deflate (from Nodeca project)"
    },
    rd = {
      assign: function (e) {
        for (var b = Array.prototype.slice.call(arguments, 1); b.length; ) {
          var d = b.shift();
          if (d) {
            if ("object" !== ("undefined" === typeof d ? "undefined" : Ha(d))) throw new TypeError(d + "must be non-object");
            for (var a in d) Object.prototype.hasOwnProperty.call(d, a) && (e[a] = d[a]);
          }
        }
        return e;
      },
      flattenChunks: function (e) {
        for (var b = 0, d = 0, a = e.length; d < a; d++) b += e[d].length;
        b = new Uint8Array(b);
        a = d = 0;
        for (var c = e.length; d < c; d++) {
          var f = e[d];
          b.set(f, a);
          a += f.length;
        }
        return b;
      }
    },
    Ah = !0;
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch (e) {
    Ah = !1;
  }
  for (var bd = new Uint8Array(256), Kb = 0; 256 > Kb; Kb++) bd[Kb] = 252 <= Kb ? 6 : 248 <= Kb ? 5 : 240 <= Kb ? 4 : 224 <= Kb ? 3 : 192 <= Kb ? 2 : 1;
  bd[254] = bd[254] = 1;
  var Bc = {
      string2buf: function (e) {
        var b,
          d,
          a = e.length,
          c = 0;
        for (b = 0; b < a; b++) {
          var f = e.charCodeAt(b);
          if (55296 === (f & 64512) && b + 1 < a) {
            var h = e.charCodeAt(b + 1);
            56320 === (h & 64512) && ((f = 65536 + ((f - 55296) << 10) + (h - 56320)), b++);
          }
          c += 128 > f ? 1 : 2048 > f ? 2 : 65536 > f ? 3 : 4;
        }
        var g = new Uint8Array(c);
        for (b = d = 0; d < c; b++)
          (f = e.charCodeAt(b)),
            55296 === (f & 64512) && b + 1 < a && ((h = e.charCodeAt(b + 1)), 56320 === (h & 64512) && ((f = 65536 + ((f - 55296) << 10) + (h - 56320)), b++)),
            128 > f
              ? (g[d++] = f)
              : (2048 > f
                  ? (g[d++] = 192 | (f >>> 6))
                  : (65536 > f ? (g[d++] = 224 | (f >>> 12)) : ((g[d++] = 240 | (f >>> 18)), (g[d++] = 128 | ((f >>> 12) & 63))), (g[d++] = 128 | ((f >>> 6) & 63))),
                (g[d++] = 128 | (f & 63)));
        return g;
      },
      buf2string: function (e, b) {
        var d,
          a,
          c = b || e.length;
        b = Array(2 * c);
        for (d = a = 0; d < c; ) {
          var f = e[d++];
          if (128 > f) b[a++] = f;
          else {
            var h = bd[f];
            if (4 < h) (b[a++] = 65533), (d += h - 1);
            else {
              for (f &= 2 === h ? 31 : 3 === h ? 15 : 7; 1 < h && d < c; ) (f = (f << 6) | (e[d++] & 63)), h--;
              1 < h ? (b[a++] = 65533) : 65536 > f ? (b[a++] = f) : ((f -= 65536), (b[a++] = 55296 | ((f >> 10) & 1023)), (b[a++] = 56320 | (f & 1023)));
            }
          }
        }
        e = a;
        if (65534 > e && b.subarray && Ah) b = String.fromCharCode.apply(null, b.length === e ? b : b.subarray(0, e));
        else {
          d = "";
          for (a = 0; a < e; a++) d += String.fromCharCode(b[a]);
          b = d;
        }
        return b;
      },
      utf8border: function (e, b) {
        b = b || e.length;
        b > e.length && (b = e.length);
        for (var d = b - 1; 0 <= d && 128 === (e[d] & 192); ) d--;
        return 0 > d || 0 === d ? b : d + bd[e[d]] > b ? d : b;
      }
    },
    Nf = function () {
      this.input = null;
      this.total_in = this.avail_in = this.next_in = 0;
      this.output = null;
      this.total_out = this.avail_out = this.next_out = 0;
      this.msg = "";
      this.state = null;
      this.data_type = 2;
      this.adler = 0;
    },
    Of = Object.prototype.toString,
    Gk = V.Z_NO_FLUSH,
    Hk = V.Z_SYNC_FLUSH,
    Ik = V.Z_FULL_FLUSH,
    Jk = V.Z_FINISH,
    sd = V.Z_OK,
    Kk = V.Z_STREAM_END,
    Ii = V.Z_DEFAULT_COMPRESSION,
    Ki = V.Z_DEFAULT_STRATEGY,
    Ji = V.Z_DEFLATED;
  zc.prototype.push = function (e, b) {
    var d = this.strm,
      a = this.options.chunkSize;
    if (this.ended) return !1;
    b = b === ~~b ? b : !0 === b ? Jk : Gk;
    "string" === typeof e ? (d.input = Bc.string2buf(e)) : "[object ArrayBuffer]" === Of.call(e) ? (d.input = new Uint8Array(e)) : (d.input = e);
    d.next_in = 0;
    for (d.avail_in = d.input.length; ; )
      if ((0 === d.avail_out && ((d.output = new Uint8Array(a)), (d.next_out = 0), (d.avail_out = a)), (b === Hk || b === Ik) && 6 >= d.avail_out))
        this.onData(d.output.subarray(0, d.next_out)), (d.avail_out = 0);
      else {
        e = Ac.deflate(d, b);
        if (e === Kk) {
          if (0 < d.next_out) this.onData(d.output.subarray(0, d.next_out));
          e = Ac.deflateEnd(this.strm);
          this.onEnd(e);
          this.ended = !0;
          return e === sd;
        }
        if (0 === d.avail_out) this.onData(d.output);
        else if (0 < b && 0 < d.next_out) this.onData(d.output.subarray(0, d.next_out)), (d.avail_out = 0);
        else if (0 === d.avail_in) break;
      }
    return !0;
  };
  zc.prototype.onData = function (e) {
    this.chunks.push(e);
  };
  zc.prototype.onEnd = function (e) {
    e === sd && (this.result = rd.flattenChunks(this.chunks));
    this.chunks = [];
    this.err = e;
    this.msg = this.strm.msg;
  };
  var Lk = new Uint16Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]),
    Mk = new Uint8Array([16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78]),
    Nk = new Uint16Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]),
    Ok = new Uint8Array([16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64]),
    cd = function (e, b, d, a, c, f, h, g) {
      var k = g.bits,
        l,
        n,
        m,
        p,
        q,
        t,
        v = 0,
        r = new Uint16Array(16);
      var u = new Uint16Array(16);
      var w,
        y = 0;
      for (l = 0; 15 >= l; l++) r[l] = 0;
      for (n = 0; n < a; n++) r[b[d + n]]++;
      var x = k;
      for (m = 15; 1 <= m && 0 === r[m]; m--);
      x > m && (x = m);
      if (0 === m) return (c[f++] = 20971520), (c[f++] = 20971520), (g.bits = 1), 0;
      for (k = 1; k < m && 0 === r[k]; k++);
      x < k && (x = k);
      for (l = p = 1; 15 >= l; l++) if (((p <<= 1), (p -= r[l]), 0 > p)) return -1;
      if (0 < p && (0 === e || 1 !== m)) return -1;
      u[1] = 0;
      for (l = 1; 15 > l; l++) u[l + 1] = u[l] + r[l];
      for (n = 0; n < a; n++) 0 !== b[d + n] && (h[u[b[d + n]]++] = n);
      if (0 === e) {
        var D = (w = h);
        var C = 19;
      } else 1 === e ? ((D = Lk), (v -= 257), (w = Mk), (y -= 257), (C = 256)) : ((D = Nk), (w = Ok), (C = -1));
      n = q = 0;
      l = k;
      var A = f;
      a = x;
      u = 0;
      var E = -1;
      var J = 1 << x;
      var G = J - 1;
      if ((1 === e && 852 < J) || (2 === e && 592 < J)) return 1;
      for (;;) {
        var M = l - u;
        if (h[n] < C) {
          var O = 0;
          var T = h[n];
        } else h[n] > C ? ((O = w[y + h[n]]), (T = D[v + h[n]])) : ((O = 96), (T = 0));
        p = 1 << (l - u);
        k = t = 1 << a;
        do (t -= p), (c[A + (q >> u) + t] = (M << 24) | (O << 16) | T | 0);
        while (0 !== t);
        for (p = 1 << (l - 1); q & p; ) p >>= 1;
        0 !== p ? ((q &= p - 1), (q += p)) : (q = 0);
        n++;
        if (0 === --r[l]) {
          if (l === m) break;
          l = b[d + h[n]];
        }
        if (l > x && (q & G) !== E) {
          0 === u && (u = x);
          A += k;
          a = l - u;
          for (p = 1 << a; a + u < m; ) {
            p -= r[a + u];
            if (0 >= p) break;
            a++;
            p <<= 1;
          }
          J += 1 << a;
          if ((1 === e && 852 < J) || (2 === e && 592 < J)) return 1;
          E = q & G;
          c[E] = (x << 24) | (a << 16) | (A - f) | 0;
        }
      }
      0 !== q && (c[A + q] = ((l - u) << 24) | 4194304);
      g.bits = x;
      return 0;
    },
    Bh = V.Z_FINISH,
    Pk = V.Z_BLOCK,
    Yd = V.Z_TREES,
    ac = V.Z_OK,
    Qk = V.Z_STREAM_END,
    Rk = V.Z_NEED_DICT,
    Ta = V.Z_STREAM_ERROR,
    Ch = V.Z_DATA_ERROR,
    Dh = V.Z_MEM_ERROR,
    Sk = V.Z_BUF_ERROR,
    Eh = V.Z_DEFLATED,
    Fh = function (e) {
      return ((e >>> 24) & 255) + ((e >>> 8) & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
    },
    Gh = function (e) {
      if (!e || !e.state) return Ta;
      var b = e.state;
      e.total_in = e.total_out = b.total = 0;
      e.msg = "";
      b.wrap && (e.adler = b.wrap & 1);
      b.mode = 1;
      b.last = 0;
      b.havedict = 0;
      b.dmax = 32768;
      b.head = null;
      b.hold = 0;
      b.bits = 0;
      b.lencode = b.lendyn = new Int32Array(852);
      b.distcode = b.distdyn = new Int32Array(592);
      b.sane = 1;
      b.back = -1;
      return ac;
    },
    Hh = function (e) {
      if (!e || !e.state) return Ta;
      var b = e.state;
      b.wsize = 0;
      b.whave = 0;
      b.wnext = 0;
      return Gh(e);
    },
    Ih = function (e, b) {
      if (!e || !e.state) return Ta;
      var d = e.state;
      if (0 > b) {
        var a = 0;
        b = -b;
      } else (a = (b >> 4) + 1), 48 > b && (b &= 15);
      if (b && (8 > b || 15 < b)) return Ta;
      null !== d.window && d.wbits !== b && (d.window = null);
      d.wrap = a;
      d.wbits = b;
      return Hh(e);
    },
    Jh = function (e, b) {
      if (!e) return Ta;
      var d = new Li();
      e.state = d;
      d.window = null;
      b = Ih(e, b);
      b !== ac && (e.state = null);
      return b;
    },
    Kh = !0,
    df = void 0,
    ef = void 0,
    Lh = function (e, b, d, a) {
      var c = e.state;
      null === c.window && ((c.wsize = 1 << c.wbits), (c.wnext = 0), (c.whave = 0), (c.window = new Uint8Array(c.wsize)));
      a >= c.wsize
        ? (c.window.set(b.subarray(d - c.wsize, d), 0), (c.wnext = 0), (c.whave = c.wsize))
        : ((e = c.wsize - c.wnext),
          e > a && (e = a),
          c.window.set(b.subarray(d - a, d - a + e), c.wnext),
          (a -= e)
            ? (c.window.set(b.subarray(d - a, d), 0), (c.wnext = a), (c.whave = c.wsize))
            : ((c.wnext += e), c.wnext === c.wsize && (c.wnext = 0), c.whave < c.wsize && (c.whave += e)));
      return 0;
    },
    nb = {
      inflateReset: Hh,
      inflateReset2: Ih,
      inflateResetKeep: Gh,
      inflateInit: function (e) {
        return Jh(e, 15);
      },
      inflateInit2: Jh,
      inflate: function (e, b) {
        var d = new Uint8Array(4),
          a = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
        if (!e || !e.state || !e.output || (!e.input && 0 !== e.avail_in)) return Ta;
        var c = e.state;
        12 === c.mode && (c.mode = 13);
        var f = e.next_out;
        var h = e.output;
        var g = e.avail_out;
        var k = e.next_in;
        var l = e.input;
        var n = e.avail_in;
        var m = c.hold;
        var p = c.bits;
        var q = n;
        var t = g;
        var v = ac;
        a: for (;;)
          switch (c.mode) {
            case 1:
              if (0 === c.wrap) {
                c.mode = 13;
                break;
              }
              for (; 16 > p; ) {
                if (0 === n) break a;
                n--;
                m += l[k++] << p;
                p += 8;
              }
              if (c.wrap & 2 && 35615 === m) {
                c.check = 0;
                d[0] = m & 255;
                d[1] = (m >>> 8) & 255;
                c.check = xa(c.check, d, 2, 0);
                p = m = 0;
                c.mode = 2;
                break;
              }
              c.flags = 0;
              c.head && (c.head.done = !1);
              if (!(c.wrap & 1) || (((m & 255) << 8) + (m >> 8)) % 31) {
                e.msg = "incorrect header check";
                c.mode = 30;
                break;
              }
              if ((m & 15) !== Eh) {
                e.msg = "unknown compression method";
                c.mode = 30;
                break;
              }
              m >>>= 4;
              p -= 4;
              var r = (m & 15) + 8;
              if (0 === c.wbits) c.wbits = r;
              else if (r > c.wbits) {
                e.msg = "invalid window size";
                c.mode = 30;
                break;
              }
              c.dmax = 1 << c.wbits;
              e.adler = c.check = 1;
              c.mode = m & 512 ? 10 : 12;
              p = m = 0;
              break;
            case 2:
              for (; 16 > p; ) {
                if (0 === n) break a;
                n--;
                m += l[k++] << p;
                p += 8;
              }
              c.flags = m;
              if ((c.flags & 255) !== Eh) {
                e.msg = "unknown compression method";
                c.mode = 30;
                break;
              }
              if (c.flags & 57344) {
                e.msg = "unknown header flags set";
                c.mode = 30;
                break;
              }
              c.head && (c.head.text = (m >> 8) & 1);
              c.flags & 512 && ((d[0] = m & 255), (d[1] = (m >>> 8) & 255), (c.check = xa(c.check, d, 2, 0)));
              p = m = 0;
              c.mode = 3;
            case 3:
              for (; 32 > p; ) {
                if (0 === n) break a;
                n--;
                m += l[k++] << p;
                p += 8;
              }
              c.head && (c.head.time = m);
              c.flags & 512 && ((d[0] = m & 255), (d[1] = (m >>> 8) & 255), (d[2] = (m >>> 16) & 255), (d[3] = (m >>> 24) & 255), (c.check = xa(c.check, d, 4, 0)));
              p = m = 0;
              c.mode = 4;
            case 4:
              for (; 16 > p; ) {
                if (0 === n) break a;
                n--;
                m += l[k++] << p;
                p += 8;
              }
              c.head && ((c.head.xflags = m & 255), (c.head.os = m >> 8));
              c.flags & 512 && ((d[0] = m & 255), (d[1] = (m >>> 8) & 255), (c.check = xa(c.check, d, 2, 0)));
              p = m = 0;
              c.mode = 5;
            case 5:
              if (c.flags & 1024) {
                for (; 16 > p; ) {
                  if (0 === n) break a;
                  n--;
                  m += l[k++] << p;
                  p += 8;
                }
                c.length = m;
                c.head && (c.head.extra_len = m);
                c.flags & 512 && ((d[0] = m & 255), (d[1] = (m >>> 8) & 255), (c.check = xa(c.check, d, 2, 0)));
                p = m = 0;
              } else c.head && (c.head.extra = null);
              c.mode = 6;
            case 6:
              if (c.flags & 1024) {
                var u = c.length;
                u > n && (u = n);
                u &&
                  (c.head && ((r = c.head.extra_len - c.length), c.head.extra || (c.head.extra = new Uint8Array(c.head.extra_len)), c.head.extra.set(l.subarray(k, k + u), r)),
                  c.flags & 512 && (c.check = xa(c.check, l, u, k)),
                  (n -= u),
                  (k += u),
                  (c.length -= u));
                if (c.length) break a;
              }
              c.length = 0;
              c.mode = 7;
            case 7:
              if (c.flags & 2048) {
                if (0 === n) break a;
                u = 0;
                do (r = l[k + u++]), c.head && r && 65536 > c.length && (c.head.name += String.fromCharCode(r));
                while (r && u < n);
                c.flags & 512 && (c.check = xa(c.check, l, u, k));
                n -= u;
                k += u;
                if (r) break a;
              } else c.head && (c.head.name = null);
              c.length = 0;
              c.mode = 8;
            case 8:
              if (c.flags & 4096) {
                if (0 === n) break a;
                u = 0;
                do (r = l[k + u++]), c.head && r && 65536 > c.length && (c.head.comment += String.fromCharCode(r));
                while (r && u < n);
                c.flags & 512 && (c.check = xa(c.check, l, u, k));
                n -= u;
                k += u;
                if (r) break a;
              } else c.head && (c.head.comment = null);
              c.mode = 9;
            case 9:
              if (c.flags & 512) {
                for (; 16 > p; ) {
                  if (0 === n) break a;
                  n--;
                  m += l[k++] << p;
                  p += 8;
                }
                if (m !== (c.check & 65535)) {
                  e.msg = "header crc mismatch";
                  c.mode = 30;
                  break;
                }
                p = m = 0;
              }
              c.head && ((c.head.hcrc = (c.flags >> 9) & 1), (c.head.done = !0));
              e.adler = c.check = 0;
              c.mode = 12;
              break;
            case 10:
              for (; 32 > p; ) {
                if (0 === n) break a;
                n--;
                m += l[k++] << p;
                p += 8;
              }
              e.adler = c.check = Fh(m);
              p = m = 0;
              c.mode = 11;
            case 11:
              if (0 === c.havedict) return (e.next_out = f), (e.avail_out = g), (e.next_in = k), (e.avail_in = n), (c.hold = m), (c.bits = p), Rk;
              e.adler = c.check = 1;
              c.mode = 12;
            case 12:
              if (b === Pk || b === Yd) break a;
            case 13:
              if (c.last) {
                m >>>= p & 7;
                p -= p & 7;
                c.mode = 27;
                break;
              }
              for (; 3 > p; ) {
                if (0 === n) break a;
                n--;
                m += l[k++] << p;
                p += 8;
              }
              c.last = m & 1;
              m >>>= 1;
              --p;
              switch (m & 3) {
                case 0:
                  c.mode = 14;
                  break;
                case 1:
                  u = c;
                  if (Kh) {
                    df = new Int32Array(512);
                    ef = new Int32Array(32);
                    for (r = 0; 144 > r; ) u.lens[r++] = 8;
                    for (; 256 > r; ) u.lens[r++] = 9;
                    for (; 280 > r; ) u.lens[r++] = 7;
                    for (; 288 > r; ) u.lens[r++] = 8;
                    cd(1, u.lens, 0, 288, df, 0, u.work, { bits: 9 });
                    for (r = 0; 32 > r; ) u.lens[r++] = 5;
                    cd(2, u.lens, 0, 32, ef, 0, u.work, { bits: 5 });
                    Kh = !1;
                  }
                  u.lencode = df;
                  u.lenbits = 9;
                  u.distcode = ef;
                  u.distbits = 5;
                  c.mode = 20;
                  if (b === Yd) {
                    m >>>= 2;
                    p -= 2;
                    break a;
                  }
                  break;
                case 2:
                  c.mode = 17;
                  break;
                case 3:
                  (e.msg = "invalid block type"), (c.mode = 30);
              }
              m >>>= 2;
              p -= 2;
              break;
            case 14:
              m >>>= p & 7;
              for (p -= p & 7; 32 > p; ) {
                if (0 === n) break a;
                n--;
                m += l[k++] << p;
                p += 8;
              }
              if ((m & 65535) !== ((m >>> 16) ^ 65535)) {
                e.msg = "invalid stored block lengths";
                c.mode = 30;
                break;
              }
              c.length = m & 65535;
              p = m = 0;
              c.mode = 15;
              if (b === Yd) break a;
            case 15:
              c.mode = 16;
            case 16:
              if ((u = c.length)) {
                u > n && (u = n);
                u > g && (u = g);
                if (0 === u) break a;
                h.set(l.subarray(k, k + u), f);
                n -= u;
                k += u;
                g -= u;
                f += u;
                c.length -= u;
                break;
              }
              c.mode = 12;
              break;
            case 17:
              for (; 14 > p; ) {
                if (0 === n) break a;
                n--;
                m += l[k++] << p;
                p += 8;
              }
              c.nlen = (m & 31) + 257;
              m >>>= 5;
              p -= 5;
              c.ndist = (m & 31) + 1;
              m >>>= 5;
              p -= 5;
              c.ncode = (m & 15) + 4;
              m >>>= 4;
              p -= 4;
              if (286 < c.nlen || 30 < c.ndist) {
                e.msg = "too many length or distance symbols";
                c.mode = 30;
                break;
              }
              c.have = 0;
              c.mode = 18;
            case 18:
              for (; c.have < c.ncode; ) {
                for (; 3 > p; ) {
                  if (0 === n) break a;
                  n--;
                  m += l[k++] << p;
                  p += 8;
                }
                c.lens[a[c.have++]] = m & 7;
                m >>>= 3;
                p -= 3;
              }
              for (; 19 > c.have; ) c.lens[a[c.have++]] = 0;
              c.lencode = c.lendyn;
              c.lenbits = 7;
              u = { bits: c.lenbits };
              v = cd(0, c.lens, 0, 19, c.lencode, 0, c.work, u);
              c.lenbits = u.bits;
              if (v) {
                e.msg = "invalid code lengths set";
                c.mode = 30;
                break;
              }
              c.have = 0;
              c.mode = 19;
            case 19:
              for (; c.have < c.nlen + c.ndist; ) {
                for (;;) {
                  var w = c.lencode[m & ((1 << c.lenbits) - 1)];
                  u = w >>> 24;
                  w &= 65535;
                  if (u <= p) break;
                  if (0 === n) break a;
                  n--;
                  m += l[k++] << p;
                  p += 8;
                }
                if (16 > w) (m >>>= u), (p -= u), (c.lens[c.have++] = w);
                else {
                  if (16 === w) {
                    for (r = u + 2; p < r; ) {
                      if (0 === n) break a;
                      n--;
                      m += l[k++] << p;
                      p += 8;
                    }
                    m >>>= u;
                    p -= u;
                    if (0 === c.have) {
                      e.msg = "invalid bit length repeat";
                      c.mode = 30;
                      break;
                    }
                    r = c.lens[c.have - 1];
                    u = 3 + (m & 3);
                    m >>>= 2;
                    p -= 2;
                  } else if (17 === w) {
                    for (r = u + 3; p < r; ) {
                      if (0 === n) break a;
                      n--;
                      m += l[k++] << p;
                      p += 8;
                    }
                    m >>>= u;
                    p -= u;
                    r = 0;
                    u = 3 + (m & 7);
                    m >>>= 3;
                    p -= 3;
                  } else {
                    for (r = u + 7; p < r; ) {
                      if (0 === n) break a;
                      n--;
                      m += l[k++] << p;
                      p += 8;
                    }
                    m >>>= u;
                    p -= u;
                    r = 0;
                    u = 11 + (m & 127);
                    m >>>= 7;
                    p -= 7;
                  }
                  if (c.have + u > c.nlen + c.ndist) {
                    e.msg = "invalid bit length repeat";
                    c.mode = 30;
                    break;
                  }
                  for (; u--; ) c.lens[c.have++] = r;
                }
              }
              if (30 === c.mode) break;
              if (0 === c.lens[256]) {
                e.msg = "invalid code -- missing end-of-block";
                c.mode = 30;
                break;
              }
              c.lenbits = 9;
              u = { bits: c.lenbits };
              v = cd(1, c.lens, 0, c.nlen, c.lencode, 0, c.work, u);
              c.lenbits = u.bits;
              if (v) {
                e.msg = "invalid literal/lengths set";
                c.mode = 30;
                break;
              }
              c.distbits = 6;
              c.distcode = c.distdyn;
              u = { bits: c.distbits };
              v = cd(2, c.lens, c.nlen, c.ndist, c.distcode, 0, c.work, u);
              c.distbits = u.bits;
              if (v) {
                e.msg = "invalid distances set";
                c.mode = 30;
                break;
              }
              c.mode = 20;
              if (b === Yd) break a;
            case 20:
              c.mode = 21;
            case 21:
              if (6 <= n && 258 <= g) {
                e.next_out = f;
                e.avail_out = g;
                e.next_in = k;
                e.avail_in = n;
                c.hold = m;
                c.bits = p;
                l = e;
                var y = l.state;
                h = l.next_in;
                var x = l.input;
                k = h + (l.avail_in - 5);
                f = l.next_out;
                var D = l.output;
                n = f - (t - l.avail_out);
                g = f + (l.avail_out - 257);
                m = y.dmax;
                p = y.wsize;
                u = y.whave;
                r = y.wnext;
                var C = y.window;
                var A = y.hold;
                var E = y.bits;
                w = y.lencode;
                var J = y.distcode;
                var G = (1 << y.lenbits) - 1;
                var M = (1 << y.distbits) - 1;
                b: do {
                  15 > E && ((A += x[h++] << E), (E += 8), (A += x[h++] << E), (E += 8));
                  var O = w[A & G];
                  c: for (;;) {
                    var T = O >>> 24;
                    A >>>= T;
                    E -= T;
                    T = (O >>> 16) & 255;
                    if (0 === T) D[f++] = O & 65535;
                    else if (T & 16) {
                      var B = O & 65535;
                      if ((T &= 15)) E < T && ((A += x[h++] << E), (E += 8)), (B += A & ((1 << T) - 1)), (A >>>= T), (E -= T);
                      15 > E && ((A += x[h++] << E), (E += 8), (A += x[h++] << E), (E += 8));
                      O = J[A & M];
                      d: for (;;) {
                        T = O >>> 24;
                        A >>>= T;
                        E -= T;
                        T = (O >>> 16) & 255;
                        if (T & 16) {
                          O &= 65535;
                          T &= 15;
                          E < T && ((A += x[h++] << E), (E += 8), E < T && ((A += x[h++] << E), (E += 8)));
                          O += A & ((1 << T) - 1);
                          if (O > m) {
                            l.msg = "invalid distance too far back";
                            y.mode = 30;
                            break b;
                          }
                          A >>>= T;
                          E -= T;
                          T = f - n;
                          if (O > T) {
                            T = O - T;
                            if (T > u && y.sane) {
                              l.msg = "invalid distance too far back";
                              y.mode = 30;
                              break b;
                            }
                            var z = 0;
                            var F = C;
                            if (0 === r) {
                              if (((z += p - T), T < B)) {
                                B -= T;
                                do D[f++] = C[z++];
                                while (--T);
                                z = f - O;
                                F = D;
                              }
                            } else if (r < T) {
                              if (((z += p + r - T), (T -= r), T < B)) {
                                B -= T;
                                do D[f++] = C[z++];
                                while (--T);
                                z = 0;
                                if (r < B) {
                                  T = r;
                                  B -= T;
                                  do D[f++] = C[z++];
                                  while (--T);
                                  z = f - O;
                                  F = D;
                                }
                              }
                            } else if (((z += r - T), T < B)) {
                              B -= T;
                              do D[f++] = C[z++];
                              while (--T);
                              z = f - O;
                              F = D;
                            }
                            for (; 2 < B; ) (D[f++] = F[z++]), (D[f++] = F[z++]), (D[f++] = F[z++]), (B -= 3);
                            B && ((D[f++] = F[z++]), 1 < B && (D[f++] = F[z++]));
                          } else {
                            z = f - O;
                            do (D[f++] = D[z++]), (D[f++] = D[z++]), (D[f++] = D[z++]), (B -= 3);
                            while (2 < B);
                            B && ((D[f++] = D[z++]), 1 < B && (D[f++] = D[z++]));
                          }
                        } else if (0 === (T & 64)) {
                          O = J[(O & 65535) + (A & ((1 << T) - 1))];
                          continue d;
                        } else {
                          l.msg = "invalid distance code";
                          y.mode = 30;
                          break b;
                        }
                        break;
                      }
                    } else if (0 === (T & 64)) {
                      O = w[(O & 65535) + (A & ((1 << T) - 1))];
                      continue c;
                    } else {
                      T & 32 ? (y.mode = 12) : ((l.msg = "invalid literal/length code"), (y.mode = 30));
                      break b;
                    }
                    break;
                  }
                } while (h < k && f < g);
                B = E >> 3;
                h -= B;
                E -= B << 3;
                l.next_in = h;
                l.next_out = f;
                l.avail_in = h < k ? 5 + (k - h) : 5 - (h - k);
                l.avail_out = f < g ? 257 + (g - f) : 257 - (f - g);
                y.hold = A & ((1 << E) - 1);
                y.bits = E;
                f = e.next_out;
                h = e.output;
                g = e.avail_out;
                k = e.next_in;
                l = e.input;
                n = e.avail_in;
                m = c.hold;
                p = c.bits;
                12 === c.mode && (c.back = -1);
                break;
              }
              for (c.back = 0; ; ) {
                w = c.lencode[m & ((1 << c.lenbits) - 1)];
                u = w >>> 24;
                r = (w >>> 16) & 255;
                w &= 65535;
                if (u <= p) break;
                if (0 === n) break a;
                n--;
                m += l[k++] << p;
                p += 8;
              }
              if (r && 0 === (r & 240)) {
                C = u;
                A = r;
                for (E = w; ; ) {
                  w = c.lencode[E + ((m & ((1 << (C + A)) - 1)) >> C)];
                  u = w >>> 24;
                  r = (w >>> 16) & 255;
                  w &= 65535;
                  if (C + u <= p) break;
                  if (0 === n) break a;
                  n--;
                  m += l[k++] << p;
                  p += 8;
                }
                m >>>= C;
                p -= C;
                c.back += C;
              }
              m >>>= u;
              p -= u;
              c.back += u;
              c.length = w;
              if (0 === r) {
                c.mode = 26;
                break;
              }
              if (r & 32) {
                c.back = -1;
                c.mode = 12;
                break;
              }
              if (r & 64) {
                e.msg = "invalid literal/length code";
                c.mode = 30;
                break;
              }
              c.extra = r & 15;
              c.mode = 22;
            case 22:
              if (c.extra) {
                for (r = c.extra; p < r; ) {
                  if (0 === n) break a;
                  n--;
                  m += l[k++] << p;
                  p += 8;
                }
                c.length += m & ((1 << c.extra) - 1);
                m >>>= c.extra;
                p -= c.extra;
                c.back += c.extra;
              }
              c.was = c.length;
              c.mode = 23;
            case 23:
              for (;;) {
                w = c.distcode[m & ((1 << c.distbits) - 1)];
                u = w >>> 24;
                r = (w >>> 16) & 255;
                w &= 65535;
                if (u <= p) break;
                if (0 === n) break a;
                n--;
                m += l[k++] << p;
                p += 8;
              }
              if (0 === (r & 240)) {
                C = u;
                A = r;
                for (E = w; ; ) {
                  w = c.distcode[E + ((m & ((1 << (C + A)) - 1)) >> C)];
                  u = w >>> 24;
                  r = (w >>> 16) & 255;
                  w &= 65535;
                  if (C + u <= p) break;
                  if (0 === n) break a;
                  n--;
                  m += l[k++] << p;
                  p += 8;
                }
                m >>>= C;
                p -= C;
                c.back += C;
              }
              m >>>= u;
              p -= u;
              c.back += u;
              if (r & 64) {
                e.msg = "invalid distance code";
                c.mode = 30;
                break;
              }
              c.offset = w;
              c.extra = r & 15;
              c.mode = 24;
            case 24:
              if (c.extra) {
                for (r = c.extra; p < r; ) {
                  if (0 === n) break a;
                  n--;
                  m += l[k++] << p;
                  p += 8;
                }
                c.offset += m & ((1 << c.extra) - 1);
                m >>>= c.extra;
                p -= c.extra;
                c.back += c.extra;
              }
              if (c.offset > c.dmax) {
                e.msg = "invalid distance too far back";
                c.mode = 30;
                break;
              }
              c.mode = 25;
            case 25:
              if (0 === g) break a;
              u = t - g;
              if (c.offset > u) {
                u = c.offset - u;
                if (u > c.whave && c.sane) {
                  e.msg = "invalid distance too far back";
                  c.mode = 30;
                  break;
                }
                u > c.wnext ? ((u -= c.wnext), (r = c.wsize - u)) : (r = c.wnext - u);
                u > c.length && (u = c.length);
                C = c.window;
              } else (C = h), (r = f - c.offset), (u = c.length);
              u > g && (u = g);
              g -= u;
              c.length -= u;
              do h[f++] = C[r++];
              while (--u);
              0 === c.length && (c.mode = 21);
              break;
            case 26:
              if (0 === g) break a;
              h[f++] = c.length;
              g--;
              c.mode = 21;
              break;
            case 27:
              if (c.wrap) {
                for (; 32 > p; ) {
                  if (0 === n) break a;
                  n--;
                  m |= l[k++] << p;
                  p += 8;
                }
                t -= g;
                e.total_out += t;
                c.total += t;
                t && (e.adler = c.check = c.flags ? xa(c.check, h, t, f - t) : Zc(c.check, h, t, f - t));
                t = g;
                if ((c.flags ? m : Fh(m)) !== c.check) {
                  e.msg = "incorrect data check";
                  c.mode = 30;
                  break;
                }
                p = m = 0;
              }
              c.mode = 28;
            case 28:
              if (c.wrap && c.flags) {
                for (; 32 > p; ) {
                  if (0 === n) break a;
                  n--;
                  m += l[k++] << p;
                  p += 8;
                }
                if (m !== (c.total & 4294967295)) {
                  e.msg = "incorrect length check";
                  c.mode = 30;
                  break;
                }
                p = m = 0;
              }
              c.mode = 29;
            case 29:
              v = Qk;
              break a;
            case 30:
              v = Ch;
              break a;
            case 31:
              return Dh;
            default:
              return Ta;
          }
        e.next_out = f;
        e.avail_out = g;
        e.next_in = k;
        e.avail_in = n;
        c.hold = m;
        c.bits = p;
        (c.wsize || (t !== e.avail_out && 30 > c.mode && (27 > c.mode || b !== Bh))) && Lh(e, e.output, e.next_out, t - e.avail_out);
        q -= e.avail_in;
        t -= e.avail_out;
        e.total_in += q;
        e.total_out += t;
        c.total += t;
        c.wrap && t && (e.adler = c.check = c.flags ? xa(c.check, h, t, e.next_out - t) : Zc(c.check, h, t, e.next_out - t));
        e.data_type = c.bits + (c.last ? 64 : 0) + (12 === c.mode ? 128 : 0) + (20 === c.mode || 15 === c.mode ? 256 : 0);
        ((0 === q && 0 === t) || b === Bh) && v === ac && (v = Sk);
        return v;
      },
      inflateEnd: function (e) {
        if (!e || !e.state) return Ta;
        var b = e.state;
        b.window && (b.window = null);
        e.state = null;
        return ac;
      },
      inflateGetHeader: function (e, b) {
        if (!e || !e.state) return Ta;
        e = e.state;
        if (0 === (e.wrap & 2)) return Ta;
        e.head = b;
        b.done = !1;
        return ac;
      },
      inflateSetDictionary: function (e, b) {
        var d = b.length;
        if (!e || !e.state) return Ta;
        var a = e.state;
        if (0 !== a.wrap && 11 !== a.mode) return Ta;
        if (11 === a.mode) {
          var c = Zc(1, b, d, 0);
          if (c !== a.check) return Ch;
        }
        if (Lh(e, b, d, d)) return (a.mode = 31), Dh;
        a.havedict = 1;
        return ac;
      },
      inflateInfo: "pako inflate (from Nodeca project)"
    },
    Mi = function () {
      this.os = this.xflags = this.time = this.text = 0;
      this.extra = null;
      this.extra_len = 0;
      this.comment = this.name = "";
      this.hcrc = 0;
      this.done = !1;
    },
    Pf = Object.prototype.toString,
    Tk = V.Z_NO_FLUSH,
    Uk = V.Z_FINISH,
    Dc = V.Z_OK,
    ff = V.Z_STREAM_END,
    gf = V.Z_NEED_DICT,
    Vk = V.Z_STREAM_ERROR,
    Mh = V.Z_DATA_ERROR,
    Wk = V.Z_MEM_ERROR;
  Cc.prototype.push = function (e, b) {
    var d = this.strm,
      a = this.options.chunkSize,
      c = this.options.dictionary;
    if (this.ended) return !1;
    var f = b === ~~b ? b : !0 === b ? Uk : Tk;
    "[object ArrayBuffer]" === Pf.call(e) ? (d.input = new Uint8Array(e)) : (d.input = e);
    d.next_in = 0;
    for (d.avail_in = d.input.length; ; ) {
      0 === d.avail_out && ((d.output = new Uint8Array(a)), (d.next_out = 0), (d.avail_out = a));
      b = nb.inflate(d, f);
      b === gf && c && ((b = nb.inflateSetDictionary(d, c)), b === Dc ? (b = nb.inflate(d, f)) : b === Mh && (b = gf));
      for (; 0 < d.avail_in && b === ff && 0 < d.state.wrap && 0 !== e[d.next_in]; ) nb.inflateReset(d), (b = nb.inflate(d, f));
      switch (b) {
        case Vk:
        case Mh:
        case gf:
        case Wk:
          return this.onEnd(b), (this.ended = !0), !1;
      }
      var h = d.avail_out;
      if (d.next_out && (0 === d.avail_out || b === ff))
        if ("string" === this.options.to) {
          var g = Bc.utf8border(d.output, d.next_out),
            k = d.next_out - g,
            l = Bc.buf2string(d.output, g);
          d.next_out = k;
          d.avail_out = a - k;
          k && d.output.set(d.output.subarray(g, g + k), 0);
          this.onData(l);
        } else this.onData(d.output.length === d.next_out ? d.output : d.output.subarray(0, d.next_out));
      if (b !== Dc || 0 !== h) {
        if (b === ff) {
          b = nb.inflateEnd(this.strm);
          this.onEnd(b);
          this.ended = !0;
          break;
        }
        if (0 === d.avail_in) break;
      }
    }
    return !0;
  };
  Cc.prototype.onData = function (e) {
    this.chunks.push(e);
  };
  Cc.prototype.onEnd = function (e) {
    e === Dc && (this.result = "string" === this.options.to ? this.chunks.join("") : rd.flattenChunks(this.chunks));
    this.chunks = [];
    this.err = e;
    this.msg = this.strm.msg;
  };
  var Nh = {
      Deflate: zc,
      deflate: re,
      deflateRaw: function (e, b) {
        b = b || {};
        b.raw = !0;
        return re(e, b);
      },
      gzip: function (e, b) {
        b = b || {};
        b.gzip = !0;
        return re(e, b);
      },
      Inflate: Cc,
      inflate: se,
      inflateRaw: function (e, b) {
        b = b || {};
        b.raw = !0;
        return se(e, b);
      },
      ungzip: se,
      constants: V
    },
    Za = U(function (e, b) {
      Object.defineProperty(b, "__esModule", { value: !0 });
      b.setMatrixArrayType = function (c) {
        b.ARRAY_TYPE = a = c;
      };
      b.toRadian = function (a) {
        return a * c;
      };
      b.equals = function (a, c) {
        return Math.abs(a - c) <= d * Math.max(1, Math.abs(a), Math.abs(c));
      };
      b.RANDOM = b.ARRAY_TYPE = b.EPSILON = void 0;
      var d = 1e-6;
      b.EPSILON = d;
      var a = "undefined" !== typeof Float32Array ? Float32Array : Array;
      b.ARRAY_TYPE = a;
      b.RANDOM = Math.random;
      var c = Math.PI / 180;
    });
  Y(Za);
  var Oh = U(function (e, b) {
    function d(a, c, b) {
      var d = c[0],
        f = c[1],
        e = c[2];
      c = c[3];
      var g = b[0],
        h = b[1],
        q = b[2];
      b = b[3];
      a[0] = d * g + e * h;
      a[1] = f * g + c * h;
      a[2] = d * q + e * b;
      a[3] = f * q + c * b;
      return a;
    }
    function a(a, c, b) {
      a[0] = c[0] - b[0];
      a[1] = c[1] - b[1];
      a[2] = c[2] - b[2];
      a[3] = c[3] - b[3];
      return a;
    }
    Object.defineProperty(b, "__esModule", { value: !0 });
    b.create = function () {
      var a = new c.ARRAY_TYPE(4);
      c.ARRAY_TYPE != Float32Array && ((a[1] = 0), (a[2] = 0));
      a[0] = 1;
      a[3] = 1;
      return a;
    };
    b.clone = function (a) {
      var b = new c.ARRAY_TYPE(4);
      b[0] = a[0];
      b[1] = a[1];
      b[2] = a[2];
      b[3] = a[3];
      return b;
    };
    b.copy = function (a, c) {
      a[0] = c[0];
      a[1] = c[1];
      a[2] = c[2];
      a[3] = c[3];
      return a;
    };
    b.identity = function (a) {
      a[0] = 1;
      a[1] = 0;
      a[2] = 0;
      a[3] = 1;
      return a;
    };
    b.fromValues = function (a, b, d, e) {
      var f = new c.ARRAY_TYPE(4);
      f[0] = a;
      f[1] = b;
      f[2] = d;
      f[3] = e;
      return f;
    };
    b.set = function (a, c, b, d, e) {
      a[0] = c;
      a[1] = b;
      a[2] = d;
      a[3] = e;
      return a;
    };
    b.transpose = function (a, c) {
      if (a === c) {
        var b = c[1];
        a[1] = c[2];
        a[2] = b;
      } else (a[0] = c[0]), (a[1] = c[2]), (a[2] = c[1]), (a[3] = c[3]);
      return a;
    };
    b.invert = function (a, c) {
      var b = c[0],
        d = c[1],
        f = c[2];
      c = c[3];
      var e = b * c - f * d;
      if (!e) return null;
      e = 1 / e;
      a[0] = c * e;
      a[1] = -d * e;
      a[2] = -f * e;
      a[3] = b * e;
      return a;
    };
    b.adjoint = function (a, c) {
      var b = c[0];
      a[0] = c[3];
      a[1] = -c[1];
      a[2] = -c[2];
      a[3] = b;
      return a;
    };
    b.determinant = function (a) {
      return a[0] * a[3] - a[2] * a[1];
    };
    b.multiply = d;
    b.rotate = function (a, c, b) {
      var d = c[0],
        f = c[1],
        e = c[2];
      c = c[3];
      var g = Math.sin(b);
      b = Math.cos(b);
      a[0] = d * b + e * g;
      a[1] = f * b + c * g;
      a[2] = d * -g + e * b;
      a[3] = f * -g + c * b;
      return a;
    };
    b.scale = function (a, c, b) {
      var d = c[1],
        f = c[2],
        e = c[3],
        g = b[0];
      b = b[1];
      a[0] = c[0] * g;
      a[1] = d * g;
      a[2] = f * b;
      a[3] = e * b;
      return a;
    };
    b.fromRotation = function (a, c) {
      var b = Math.sin(c);
      c = Math.cos(c);
      a[0] = c;
      a[1] = b;
      a[2] = -b;
      a[3] = c;
      return a;
    };
    b.fromScaling = function (a, c) {
      a[0] = c[0];
      a[1] = 0;
      a[2] = 0;
      a[3] = c[1];
      return a;
    };
    b.str = function (a) {
      return "mat2(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
    };
    b.frob = function (a) {
      return Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2));
    };
    b.LDU = function (a, c, b, d) {
      a[2] = d[2] / d[0];
      b[0] = d[0];
      b[1] = d[1];
      b[3] = d[3] - a[2] * b[1];
      return [a, c, b];
    };
    b.add = function (a, c, b) {
      a[0] = c[0] + b[0];
      a[1] = c[1] + b[1];
      a[2] = c[2] + b[2];
      a[3] = c[3] + b[3];
      return a;
    };
    b.subtract = a;
    b.exactEquals = function (a, c) {
      return a[0] === c[0] && a[1] === c[1] && a[2] === c[2] && a[3] === c[3];
    };
    b.equals = function (a, b) {
      var d = a[0],
        e = a[1],
        f = a[2];
      a = a[3];
      var h = b[0],
        m = b[1],
        p = b[2];
      b = b[3];
      return (
        Math.abs(d - h) <= c.EPSILON * Math.max(1, Math.abs(d), Math.abs(h)) &&
        Math.abs(e - m) <= c.EPSILON * Math.max(1, Math.abs(e), Math.abs(m)) &&
        Math.abs(f - p) <= c.EPSILON * Math.max(1, Math.abs(f), Math.abs(p)) &&
        Math.abs(a - b) <= c.EPSILON * Math.max(1, Math.abs(a), Math.abs(b))
      );
    };
    b.multiplyScalar = function (a, c, b) {
      a[0] = c[0] * b;
      a[1] = c[1] * b;
      a[2] = c[2] * b;
      a[3] = c[3] * b;
      return a;
    };
    b.multiplyScalarAndAdd = function (a, c, b, d) {
      a[0] = c[0] + b[0] * d;
      a[1] = c[1] + b[1] * d;
      a[2] = c[2] + b[2] * d;
      a[3] = c[3] + b[3] * d;
      return a;
    };
    b.sub = b.mul = void 0;
    var c = (function (a) {
      if (a && a.__esModule) return a;
      var c = {};
      if (null != a)
        for (var b in a)
          if (Object.prototype.hasOwnProperty.call(a, b)) {
            var d = ra && pa ? pa(a, b) : {};
            d.get || d.set ? ra(c, b, d) : (c[b] = a[b]);
          }
      c.default = a;
      return c;
    })(Za);
    b.mul = d;
    b.sub = a;
  });
  Y(Oh);
  var Ph = U(function (e, b) {
    function d(a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2],
        g = c[3],
        h = c[4];
      c = c[5];
      var q = b[0],
        t = b[1],
        v = b[2],
        r = b[3],
        u = b[4];
      b = b[5];
      a[0] = d * q + f * t;
      a[1] = e * q + g * t;
      a[2] = d * v + f * r;
      a[3] = e * v + g * r;
      a[4] = d * u + f * b + h;
      a[5] = e * u + g * b + c;
      return a;
    }
    function a(a, c, b) {
      a[0] = c[0] - b[0];
      a[1] = c[1] - b[1];
      a[2] = c[2] - b[2];
      a[3] = c[3] - b[3];
      a[4] = c[4] - b[4];
      a[5] = c[5] - b[5];
      return a;
    }
    Object.defineProperty(b, "__esModule", { value: !0 });
    b.create = function () {
      var a = new c.ARRAY_TYPE(6);
      c.ARRAY_TYPE != Float32Array && ((a[1] = 0), (a[2] = 0), (a[4] = 0), (a[5] = 0));
      a[0] = 1;
      a[3] = 1;
      return a;
    };
    b.clone = function (a) {
      var b = new c.ARRAY_TYPE(6);
      b[0] = a[0];
      b[1] = a[1];
      b[2] = a[2];
      b[3] = a[3];
      b[4] = a[4];
      b[5] = a[5];
      return b;
    };
    b.copy = function (a, c) {
      a[0] = c[0];
      a[1] = c[1];
      a[2] = c[2];
      a[3] = c[3];
      a[4] = c[4];
      a[5] = c[5];
      return a;
    };
    b.identity = function (a) {
      a[0] = 1;
      a[1] = 0;
      a[2] = 0;
      a[3] = 1;
      a[4] = 0;
      a[5] = 0;
      return a;
    };
    b.fromValues = function (a, b, d, e, l, n) {
      var f = new c.ARRAY_TYPE(6);
      f[0] = a;
      f[1] = b;
      f[2] = d;
      f[3] = e;
      f[4] = l;
      f[5] = n;
      return f;
    };
    b.set = function (a, c, b, d, e, n, m) {
      a[0] = c;
      a[1] = b;
      a[2] = d;
      a[3] = e;
      a[4] = n;
      a[5] = m;
      return a;
    };
    b.invert = function (a, c) {
      var b = c[0],
        d = c[1],
        e = c[2],
        f = c[3],
        h = c[4];
      c = c[5];
      var p = b * f - d * e;
      if (!p) return null;
      p = 1 / p;
      a[0] = f * p;
      a[1] = -d * p;
      a[2] = -e * p;
      a[3] = b * p;
      a[4] = (e * c - f * h) * p;
      a[5] = (d * h - b * c) * p;
      return a;
    };
    b.determinant = function (a) {
      return a[0] * a[3] - a[1] * a[2];
    };
    b.multiply = d;
    b.rotate = function (a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2],
        g = c[3],
        h = c[4];
      c = c[5];
      var q = Math.sin(b);
      b = Math.cos(b);
      a[0] = d * b + f * q;
      a[1] = e * b + g * q;
      a[2] = d * -q + f * b;
      a[3] = e * -q + g * b;
      a[4] = h;
      a[5] = c;
      return a;
    };
    b.scale = function (a, c, b) {
      var d = c[1],
        e = c[2],
        f = c[3],
        g = c[4],
        h = c[5],
        q = b[0];
      b = b[1];
      a[0] = c[0] * q;
      a[1] = d * q;
      a[2] = e * b;
      a[3] = f * b;
      a[4] = g;
      a[5] = h;
      return a;
    };
    b.translate = function (a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2],
        g = c[3],
        h = c[4];
      c = c[5];
      var q = b[0];
      b = b[1];
      a[0] = d;
      a[1] = e;
      a[2] = f;
      a[3] = g;
      a[4] = d * q + f * b + h;
      a[5] = e * q + g * b + c;
      return a;
    };
    b.fromRotation = function (a, c) {
      var b = Math.sin(c);
      c = Math.cos(c);
      a[0] = c;
      a[1] = b;
      a[2] = -b;
      a[3] = c;
      a[4] = 0;
      a[5] = 0;
      return a;
    };
    b.fromScaling = function (a, c) {
      a[0] = c[0];
      a[1] = 0;
      a[2] = 0;
      a[3] = c[1];
      a[4] = 0;
      a[5] = 0;
      return a;
    };
    b.fromTranslation = function (a, c) {
      a[0] = 1;
      a[1] = 0;
      a[2] = 0;
      a[3] = 1;
      a[4] = c[0];
      a[5] = c[1];
      return a;
    };
    b.str = function (a) {
      return "mat2d(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ")";
    };
    b.frob = function (a) {
      return Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + 1);
    };
    b.add = function (a, c, b) {
      a[0] = c[0] + b[0];
      a[1] = c[1] + b[1];
      a[2] = c[2] + b[2];
      a[3] = c[3] + b[3];
      a[4] = c[4] + b[4];
      a[5] = c[5] + b[5];
      return a;
    };
    b.subtract = a;
    b.multiplyScalar = function (a, c, b) {
      a[0] = c[0] * b;
      a[1] = c[1] * b;
      a[2] = c[2] * b;
      a[3] = c[3] * b;
      a[4] = c[4] * b;
      a[5] = c[5] * b;
      return a;
    };
    b.multiplyScalarAndAdd = function (a, c, b, d) {
      a[0] = c[0] + b[0] * d;
      a[1] = c[1] + b[1] * d;
      a[2] = c[2] + b[2] * d;
      a[3] = c[3] + b[3] * d;
      a[4] = c[4] + b[4] * d;
      a[5] = c[5] + b[5] * d;
      return a;
    };
    b.exactEquals = function (a, c) {
      return a[0] === c[0] && a[1] === c[1] && a[2] === c[2] && a[3] === c[3] && a[4] === c[4] && a[5] === c[5];
    };
    b.equals = function (a, b) {
      var d = a[0],
        e = a[1],
        f = a[2],
        h = a[3],
        m = a[4];
      a = a[5];
      var p = b[0],
        q = b[1],
        t = b[2],
        v = b[3],
        r = b[4];
      b = b[5];
      return (
        Math.abs(d - p) <= c.EPSILON * Math.max(1, Math.abs(d), Math.abs(p)) &&
        Math.abs(e - q) <= c.EPSILON * Math.max(1, Math.abs(e), Math.abs(q)) &&
        Math.abs(f - t) <= c.EPSILON * Math.max(1, Math.abs(f), Math.abs(t)) &&
        Math.abs(h - v) <= c.EPSILON * Math.max(1, Math.abs(h), Math.abs(v)) &&
        Math.abs(m - r) <= c.EPSILON * Math.max(1, Math.abs(m), Math.abs(r)) &&
        Math.abs(a - b) <= c.EPSILON * Math.max(1, Math.abs(a), Math.abs(b))
      );
    };
    b.sub = b.mul = void 0;
    var c = (function (a) {
      if (a && a.__esModule) return a;
      var c = {};
      if (null != a)
        for (var b in a)
          if (Object.prototype.hasOwnProperty.call(a, b)) {
            var d = ra && pa ? pa(a, b) : {};
            d.get || d.set ? ra(c, b, d) : (c[b] = a[b]);
          }
      c.default = a;
      return c;
    })(Za);
    b.mul = d;
    b.sub = a;
  });
  Y(Ph);
  var hf = U(function (e, b) {
    function d(a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2],
        g = c[3],
        h = c[4],
        q = c[5],
        t = c[6],
        v = c[7];
      c = c[8];
      var r = b[0],
        u = b[1],
        w = b[2],
        y = b[3],
        x = b[4],
        D = b[5],
        C = b[6],
        A = b[7];
      b = b[8];
      a[0] = r * d + u * g + w * t;
      a[1] = r * e + u * h + w * v;
      a[2] = r * f + u * q + w * c;
      a[3] = y * d + x * g + D * t;
      a[4] = y * e + x * h + D * v;
      a[5] = y * f + x * q + D * c;
      a[6] = C * d + A * g + b * t;
      a[7] = C * e + A * h + b * v;
      a[8] = C * f + A * q + b * c;
      return a;
    }
    function a(a, c, b) {
      a[0] = c[0] - b[0];
      a[1] = c[1] - b[1];
      a[2] = c[2] - b[2];
      a[3] = c[3] - b[3];
      a[4] = c[4] - b[4];
      a[5] = c[5] - b[5];
      a[6] = c[6] - b[6];
      a[7] = c[7] - b[7];
      a[8] = c[8] - b[8];
      return a;
    }
    Object.defineProperty(b, "__esModule", { value: !0 });
    b.create = function () {
      var a = new c.ARRAY_TYPE(9);
      c.ARRAY_TYPE != Float32Array && ((a[1] = 0), (a[2] = 0), (a[3] = 0), (a[5] = 0), (a[6] = 0), (a[7] = 0));
      a[0] = 1;
      a[4] = 1;
      a[8] = 1;
      return a;
    };
    b.fromMat4 = function (a, c) {
      a[0] = c[0];
      a[1] = c[1];
      a[2] = c[2];
      a[3] = c[4];
      a[4] = c[5];
      a[5] = c[6];
      a[6] = c[8];
      a[7] = c[9];
      a[8] = c[10];
      return a;
    };
    b.clone = function (a) {
      var b = new c.ARRAY_TYPE(9);
      b[0] = a[0];
      b[1] = a[1];
      b[2] = a[2];
      b[3] = a[3];
      b[4] = a[4];
      b[5] = a[5];
      b[6] = a[6];
      b[7] = a[7];
      b[8] = a[8];
      return b;
    };
    b.copy = function (a, c) {
      a[0] = c[0];
      a[1] = c[1];
      a[2] = c[2];
      a[3] = c[3];
      a[4] = c[4];
      a[5] = c[5];
      a[6] = c[6];
      a[7] = c[7];
      a[8] = c[8];
      return a;
    };
    b.fromValues = function (a, b, d, e, l, n, m, p, q) {
      var f = new c.ARRAY_TYPE(9);
      f[0] = a;
      f[1] = b;
      f[2] = d;
      f[3] = e;
      f[4] = l;
      f[5] = n;
      f[6] = m;
      f[7] = p;
      f[8] = q;
      return f;
    };
    b.set = function (a, c, b, d, e, n, m, p, q, t) {
      a[0] = c;
      a[1] = b;
      a[2] = d;
      a[3] = e;
      a[4] = n;
      a[5] = m;
      a[6] = p;
      a[7] = q;
      a[8] = t;
      return a;
    };
    b.identity = function (a) {
      a[0] = 1;
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      a[4] = 1;
      a[5] = 0;
      a[6] = 0;
      a[7] = 0;
      a[8] = 1;
      return a;
    };
    b.transpose = function (a, c) {
      if (a === c) {
        var b = c[1],
          d = c[2],
          e = c[5];
        a[1] = c[3];
        a[2] = c[6];
        a[3] = b;
        a[5] = c[7];
        a[6] = d;
        a[7] = e;
      } else (a[0] = c[0]), (a[1] = c[3]), (a[2] = c[6]), (a[3] = c[1]), (a[4] = c[4]), (a[5] = c[7]), (a[6] = c[2]), (a[7] = c[5]), (a[8] = c[8]);
      return a;
    };
    b.invert = function (a, c) {
      var b = c[0],
        d = c[1],
        e = c[2],
        f = c[3],
        h = c[4],
        p = c[5],
        q = c[6],
        t = c[7];
      c = c[8];
      var v = c * h - p * t,
        r = -c * f + p * q,
        u = t * f - h * q,
        w = b * v + d * r + e * u;
      if (!w) return null;
      w = 1 / w;
      a[0] = v * w;
      a[1] = (-c * d + e * t) * w;
      a[2] = (p * d - e * h) * w;
      a[3] = r * w;
      a[4] = (c * b - e * q) * w;
      a[5] = (-p * b + e * f) * w;
      a[6] = u * w;
      a[7] = (-t * b + d * q) * w;
      a[8] = (h * b - d * f) * w;
      return a;
    };
    b.adjoint = function (a, c) {
      var b = c[0],
        d = c[1],
        e = c[2],
        f = c[3],
        h = c[4],
        p = c[5],
        q = c[6],
        t = c[7];
      c = c[8];
      a[0] = h * c - p * t;
      a[1] = e * t - d * c;
      a[2] = d * p - e * h;
      a[3] = p * q - f * c;
      a[4] = b * c - e * q;
      a[5] = e * f - b * p;
      a[6] = f * t - h * q;
      a[7] = d * q - b * t;
      a[8] = b * h - d * f;
      return a;
    };
    b.determinant = function (a) {
      var c = a[3],
        b = a[4],
        d = a[5],
        e = a[6],
        f = a[7],
        m = a[8];
      return a[0] * (m * b - d * f) + a[1] * (-m * c + d * e) + a[2] * (f * c - b * e);
    };
    b.multiply = d;
    b.translate = function (a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2],
        g = c[3],
        h = c[4],
        q = c[5],
        t = c[6],
        v = c[7];
      c = c[8];
      var r = b[0];
      b = b[1];
      a[0] = d;
      a[1] = e;
      a[2] = f;
      a[3] = g;
      a[4] = h;
      a[5] = q;
      a[6] = r * d + b * g + t;
      a[7] = r * e + b * h + v;
      a[8] = r * f + b * q + c;
      return a;
    };
    b.rotate = function (a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2],
        g = c[3],
        h = c[4],
        q = c[5],
        t = c[6],
        v = c[7];
      c = c[8];
      var r = Math.sin(b);
      b = Math.cos(b);
      a[0] = b * d + r * g;
      a[1] = b * e + r * h;
      a[2] = b * f + r * q;
      a[3] = b * g - r * d;
      a[4] = b * h - r * e;
      a[5] = b * q - r * f;
      a[6] = t;
      a[7] = v;
      a[8] = c;
      return a;
    };
    b.scale = function (a, c, b) {
      var d = b[0];
      b = b[1];
      a[0] = d * c[0];
      a[1] = d * c[1];
      a[2] = d * c[2];
      a[3] = b * c[3];
      a[4] = b * c[4];
      a[5] = b * c[5];
      a[6] = c[6];
      a[7] = c[7];
      a[8] = c[8];
      return a;
    };
    b.fromTranslation = function (a, c) {
      a[0] = 1;
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      a[4] = 1;
      a[5] = 0;
      a[6] = c[0];
      a[7] = c[1];
      a[8] = 1;
      return a;
    };
    b.fromRotation = function (a, c) {
      var b = Math.sin(c);
      c = Math.cos(c);
      a[0] = c;
      a[1] = b;
      a[2] = 0;
      a[3] = -b;
      a[4] = c;
      a[5] = 0;
      a[6] = 0;
      a[7] = 0;
      a[8] = 1;
      return a;
    };
    b.fromScaling = function (a, c) {
      a[0] = c[0];
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      a[4] = c[1];
      a[5] = 0;
      a[6] = 0;
      a[7] = 0;
      a[8] = 1;
      return a;
    };
    b.fromMat2d = function (a, c) {
      a[0] = c[0];
      a[1] = c[1];
      a[2] = 0;
      a[3] = c[2];
      a[4] = c[3];
      a[5] = 0;
      a[6] = c[4];
      a[7] = c[5];
      a[8] = 1;
      return a;
    };
    b.fromQuat = function (a, c) {
      var b = c[0],
        d = c[1],
        e = c[2];
      c = c[3];
      var f = b + b,
        h = d + d,
        p = e + e;
      b *= f;
      var q = d * f;
      d *= h;
      var t = e * f,
        v = e * h;
      e *= p;
      f *= c;
      h *= c;
      c *= p;
      a[0] = 1 - d - e;
      a[3] = q - c;
      a[6] = t + h;
      a[1] = q + c;
      a[4] = 1 - b - e;
      a[7] = v - f;
      a[2] = t - h;
      a[5] = v + f;
      a[8] = 1 - b - d;
      return a;
    };
    b.normalFromMat4 = function (a, c) {
      var b = c[0],
        d = c[1],
        e = c[2],
        f = c[3],
        h = c[4],
        p = c[5],
        q = c[6],
        t = c[7],
        v = c[8],
        r = c[9],
        u = c[10],
        w = c[11],
        y = c[12],
        x = c[13],
        D = c[14];
      c = c[15];
      var C = b * p - d * h,
        A = b * q - e * h,
        E = b * t - f * h,
        J = d * q - e * p,
        G = d * t - f * p,
        M = e * t - f * q,
        O = v * x - r * y,
        z = v * D - u * y;
      v = v * c - w * y;
      var B = r * D - u * x;
      r = r * c - w * x;
      u = u * c - w * D;
      w = C * u - A * r + E * B + J * v - G * z + M * O;
      if (!w) return null;
      w = 1 / w;
      a[0] = (p * u - q * r + t * B) * w;
      a[1] = (q * v - h * u - t * z) * w;
      a[2] = (h * r - p * v + t * O) * w;
      a[3] = (e * r - d * u - f * B) * w;
      a[4] = (b * u - e * v + f * z) * w;
      a[5] = (d * v - b * r - f * O) * w;
      a[6] = (x * M - D * G + c * J) * w;
      a[7] = (D * E - y * M - c * A) * w;
      a[8] = (y * G - x * E + c * C) * w;
      return a;
    };
    b.projection = function (a, c, b) {
      a[0] = 2 / c;
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      a[4] = -2 / b;
      a[5] = 0;
      a[6] = -1;
      a[7] = 1;
      a[8] = 1;
      return a;
    };
    b.str = function (a) {
      return "mat3(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ")";
    };
    b.frob = function (a) {
      return Math.sqrt(
        Math.pow(a[0], 2) +
          Math.pow(a[1], 2) +
          Math.pow(a[2], 2) +
          Math.pow(a[3], 2) +
          Math.pow(a[4], 2) +
          Math.pow(a[5], 2) +
          Math.pow(a[6], 2) +
          Math.pow(a[7], 2) +
          Math.pow(a[8], 2)
      );
    };
    b.add = function (a, c, b) {
      a[0] = c[0] + b[0];
      a[1] = c[1] + b[1];
      a[2] = c[2] + b[2];
      a[3] = c[3] + b[3];
      a[4] = c[4] + b[4];
      a[5] = c[5] + b[5];
      a[6] = c[6] + b[6];
      a[7] = c[7] + b[7];
      a[8] = c[8] + b[8];
      return a;
    };
    b.subtract = a;
    b.multiplyScalar = function (a, c, b) {
      a[0] = c[0] * b;
      a[1] = c[1] * b;
      a[2] = c[2] * b;
      a[3] = c[3] * b;
      a[4] = c[4] * b;
      a[5] = c[5] * b;
      a[6] = c[6] * b;
      a[7] = c[7] * b;
      a[8] = c[8] * b;
      return a;
    };
    b.multiplyScalarAndAdd = function (a, c, b, d) {
      a[0] = c[0] + b[0] * d;
      a[1] = c[1] + b[1] * d;
      a[2] = c[2] + b[2] * d;
      a[3] = c[3] + b[3] * d;
      a[4] = c[4] + b[4] * d;
      a[5] = c[5] + b[5] * d;
      a[6] = c[6] + b[6] * d;
      a[7] = c[7] + b[7] * d;
      a[8] = c[8] + b[8] * d;
      return a;
    };
    b.exactEquals = function (a, c) {
      return a[0] === c[0] && a[1] === c[1] && a[2] === c[2] && a[3] === c[3] && a[4] === c[4] && a[5] === c[5] && a[6] === c[6] && a[7] === c[7] && a[8] === c[8];
    };
    b.equals = function (a, b) {
      var d = a[0],
        e = a[1],
        f = a[2],
        h = a[3],
        m = a[4],
        p = a[5],
        q = a[6],
        t = a[7];
      a = a[8];
      var v = b[0],
        r = b[1],
        u = b[2],
        w = b[3],
        y = b[4],
        x = b[5],
        D = b[6],
        C = b[7];
      b = b[8];
      return (
        Math.abs(d - v) <= c.EPSILON * Math.max(1, Math.abs(d), Math.abs(v)) &&
        Math.abs(e - r) <= c.EPSILON * Math.max(1, Math.abs(e), Math.abs(r)) &&
        Math.abs(f - u) <= c.EPSILON * Math.max(1, Math.abs(f), Math.abs(u)) &&
        Math.abs(h - w) <= c.EPSILON * Math.max(1, Math.abs(h), Math.abs(w)) &&
        Math.abs(m - y) <= c.EPSILON * Math.max(1, Math.abs(m), Math.abs(y)) &&
        Math.abs(p - x) <= c.EPSILON * Math.max(1, Math.abs(p), Math.abs(x)) &&
        Math.abs(q - D) <= c.EPSILON * Math.max(1, Math.abs(q), Math.abs(D)) &&
        Math.abs(t - C) <= c.EPSILON * Math.max(1, Math.abs(t), Math.abs(C)) &&
        Math.abs(a - b) <= c.EPSILON * Math.max(1, Math.abs(a), Math.abs(b))
      );
    };
    b.sub = b.mul = void 0;
    var c = (function (a) {
      if (a && a.__esModule) return a;
      var c = {};
      if (null != a)
        for (var b in a)
          if (Object.prototype.hasOwnProperty.call(a, b)) {
            var d = ra && pa ? pa(a, b) : {};
            d.get || d.set ? ra(c, b, d) : (c[b] = a[b]);
          }
      c.default = a;
      return c;
    })(Za);
    b.mul = d;
    b.sub = a;
  });
  Y(hf);
  var jf = U(function (e, b) {
    function d(a) {
      a[0] = 1;
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      a[4] = 0;
      a[5] = 1;
      a[6] = 0;
      a[7] = 0;
      a[8] = 0;
      a[9] = 0;
      a[10] = 1;
      a[11] = 0;
      a[12] = 0;
      a[13] = 0;
      a[14] = 0;
      a[15] = 1;
      return a;
    }
    function a(a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2],
        g = c[3],
        k = c[4],
        h = c[5],
        l = c[6],
        u = c[7],
        w = c[8],
        y = c[9],
        x = c[10],
        D = c[11],
        C = c[12],
        A = c[13],
        E = c[14];
      c = c[15];
      var J = b[0],
        G = b[1],
        M = b[2],
        O = b[3];
      a[0] = J * d + G * k + M * w + O * C;
      a[1] = J * e + G * h + M * y + O * A;
      a[2] = J * f + G * l + M * x + O * E;
      a[3] = J * g + G * u + M * D + O * c;
      J = b[4];
      G = b[5];
      M = b[6];
      O = b[7];
      a[4] = J * d + G * k + M * w + O * C;
      a[5] = J * e + G * h + M * y + O * A;
      a[6] = J * f + G * l + M * x + O * E;
      a[7] = J * g + G * u + M * D + O * c;
      J = b[8];
      G = b[9];
      M = b[10];
      O = b[11];
      a[8] = J * d + G * k + M * w + O * C;
      a[9] = J * e + G * h + M * y + O * A;
      a[10] = J * f + G * l + M * x + O * E;
      a[11] = J * g + G * u + M * D + O * c;
      J = b[12];
      G = b[13];
      M = b[14];
      O = b[15];
      a[12] = J * d + G * k + M * w + O * C;
      a[13] = J * e + G * h + M * y + O * A;
      a[14] = J * f + G * l + M * x + O * E;
      a[15] = J * g + G * u + M * D + O * c;
      return a;
    }
    function c(a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2],
        g = c[3],
        k = d + d,
        h = e + e,
        l = f + f;
      c = d * k;
      var u = d * h;
      d *= l;
      var w = e * h;
      e *= l;
      f *= l;
      k *= g;
      h *= g;
      g *= l;
      a[0] = 1 - (w + f);
      a[1] = u + g;
      a[2] = d - h;
      a[3] = 0;
      a[4] = u - g;
      a[5] = 1 - (c + f);
      a[6] = e + k;
      a[7] = 0;
      a[8] = d + h;
      a[9] = e - k;
      a[10] = 1 - (c + w);
      a[11] = 0;
      a[12] = b[0];
      a[13] = b[1];
      a[14] = b[2];
      a[15] = 1;
      return a;
    }
    function f(a, c, b) {
      a[0] = c[0] - b[0];
      a[1] = c[1] - b[1];
      a[2] = c[2] - b[2];
      a[3] = c[3] - b[3];
      a[4] = c[4] - b[4];
      a[5] = c[5] - b[5];
      a[6] = c[6] - b[6];
      a[7] = c[7] - b[7];
      a[8] = c[8] - b[8];
      a[9] = c[9] - b[9];
      a[10] = c[10] - b[10];
      a[11] = c[11] - b[11];
      a[12] = c[12] - b[12];
      a[13] = c[13] - b[13];
      a[14] = c[14] - b[14];
      a[15] = c[15] - b[15];
      return a;
    }
    Object.defineProperty(b, "__esModule", { value: !0 });
    b.create = function () {
      var a = new h.ARRAY_TYPE(16);
      h.ARRAY_TYPE != Float32Array &&
        ((a[1] = 0), (a[2] = 0), (a[3] = 0), (a[4] = 0), (a[6] = 0), (a[7] = 0), (a[8] = 0), (a[9] = 0), (a[11] = 0), (a[12] = 0), (a[13] = 0), (a[14] = 0));
      a[0] = 1;
      a[5] = 1;
      a[10] = 1;
      a[15] = 1;
      return a;
    };
    b.clone = function (a) {
      var c = new h.ARRAY_TYPE(16);
      c[0] = a[0];
      c[1] = a[1];
      c[2] = a[2];
      c[3] = a[3];
      c[4] = a[4];
      c[5] = a[5];
      c[6] = a[6];
      c[7] = a[7];
      c[8] = a[8];
      c[9] = a[9];
      c[10] = a[10];
      c[11] = a[11];
      c[12] = a[12];
      c[13] = a[13];
      c[14] = a[14];
      c[15] = a[15];
      return c;
    };
    b.copy = function (a, c) {
      a[0] = c[0];
      a[1] = c[1];
      a[2] = c[2];
      a[3] = c[3];
      a[4] = c[4];
      a[5] = c[5];
      a[6] = c[6];
      a[7] = c[7];
      a[8] = c[8];
      a[9] = c[9];
      a[10] = c[10];
      a[11] = c[11];
      a[12] = c[12];
      a[13] = c[13];
      a[14] = c[14];
      a[15] = c[15];
      return a;
    };
    b.fromValues = function (a, c, b, d, e, f, q, t, v, r, u, w, y, x, D, C) {
      var g = new h.ARRAY_TYPE(16);
      g[0] = a;
      g[1] = c;
      g[2] = b;
      g[3] = d;
      g[4] = e;
      g[5] = f;
      g[6] = q;
      g[7] = t;
      g[8] = v;
      g[9] = r;
      g[10] = u;
      g[11] = w;
      g[12] = y;
      g[13] = x;
      g[14] = D;
      g[15] = C;
      return g;
    };
    b.set = function (a, c, b, d, e, f, h, t, v, r, u, w, y, x, D, C, A) {
      a[0] = c;
      a[1] = b;
      a[2] = d;
      a[3] = e;
      a[4] = f;
      a[5] = h;
      a[6] = t;
      a[7] = v;
      a[8] = r;
      a[9] = u;
      a[10] = w;
      a[11] = y;
      a[12] = x;
      a[13] = D;
      a[14] = C;
      a[15] = A;
      return a;
    };
    b.identity = d;
    b.transpose = function (a, c) {
      if (a === c) {
        var b = c[1],
          d = c[2],
          e = c[3],
          f = c[6],
          g = c[7],
          h = c[11];
        a[1] = c[4];
        a[2] = c[8];
        a[3] = c[12];
        a[4] = b;
        a[6] = c[9];
        a[7] = c[13];
        a[8] = d;
        a[9] = f;
        a[11] = c[14];
        a[12] = e;
        a[13] = g;
        a[14] = h;
      } else
        (a[0] = c[0]),
          (a[1] = c[4]),
          (a[2] = c[8]),
          (a[3] = c[12]),
          (a[4] = c[1]),
          (a[5] = c[5]),
          (a[6] = c[9]),
          (a[7] = c[13]),
          (a[8] = c[2]),
          (a[9] = c[6]),
          (a[10] = c[10]),
          (a[11] = c[14]),
          (a[12] = c[3]),
          (a[13] = c[7]),
          (a[14] = c[11]),
          (a[15] = c[15]);
      return a;
    };
    b.invert = function (a, c) {
      var b = c[0],
        d = c[1],
        e = c[2],
        f = c[3],
        g = c[4],
        h = c[5],
        k = c[6],
        r = c[7],
        u = c[8],
        w = c[9],
        y = c[10],
        x = c[11],
        D = c[12],
        C = c[13],
        A = c[14];
      c = c[15];
      var E = b * h - d * g,
        J = b * k - e * g,
        G = b * r - f * g,
        M = d * k - e * h,
        O = d * r - f * h,
        z = e * r - f * k,
        B = u * C - w * D,
        F = u * A - y * D,
        I = u * c - x * D,
        K = w * A - y * C,
        L = w * c - x * C,
        N = y * c - x * A,
        H = E * N - J * L + G * K + M * I - O * F + z * B;
      if (!H) return null;
      H = 1 / H;
      a[0] = (h * N - k * L + r * K) * H;
      a[1] = (e * L - d * N - f * K) * H;
      a[2] = (C * z - A * O + c * M) * H;
      a[3] = (y * O - w * z - x * M) * H;
      a[4] = (k * I - g * N - r * F) * H;
      a[5] = (b * N - e * I + f * F) * H;
      a[6] = (A * G - D * z - c * J) * H;
      a[7] = (u * z - y * G + x * J) * H;
      a[8] = (g * L - h * I + r * B) * H;
      a[9] = (d * I - b * L - f * B) * H;
      a[10] = (D * O - C * G + c * E) * H;
      a[11] = (w * G - u * O - x * E) * H;
      a[12] = (h * F - g * K - k * B) * H;
      a[13] = (b * K - d * F + e * B) * H;
      a[14] = (C * J - D * M - A * E) * H;
      a[15] = (u * M - w * J + y * E) * H;
      return a;
    };
    b.adjoint = function (a, c) {
      var b = c[0],
        d = c[1],
        e = c[2],
        f = c[3],
        g = c[4],
        h = c[5],
        k = c[6],
        r = c[7],
        u = c[8],
        w = c[9],
        y = c[10],
        x = c[11],
        D = c[12],
        C = c[13],
        A = c[14];
      c = c[15];
      a[0] = h * (y * c - x * A) - w * (k * c - r * A) + C * (k * x - r * y);
      a[1] = -(d * (y * c - x * A) - w * (e * c - f * A) + C * (e * x - f * y));
      a[2] = d * (k * c - r * A) - h * (e * c - f * A) + C * (e * r - f * k);
      a[3] = -(d * (k * x - r * y) - h * (e * x - f * y) + w * (e * r - f * k));
      a[4] = -(g * (y * c - x * A) - u * (k * c - r * A) + D * (k * x - r * y));
      a[5] = b * (y * c - x * A) - u * (e * c - f * A) + D * (e * x - f * y);
      a[6] = -(b * (k * c - r * A) - g * (e * c - f * A) + D * (e * r - f * k));
      a[7] = b * (k * x - r * y) - g * (e * x - f * y) + u * (e * r - f * k);
      a[8] = g * (w * c - x * C) - u * (h * c - r * C) + D * (h * x - r * w);
      a[9] = -(b * (w * c - x * C) - u * (d * c - f * C) + D * (d * x - f * w));
      a[10] = b * (h * c - r * C) - g * (d * c - f * C) + D * (d * r - f * h);
      a[11] = -(b * (h * x - r * w) - g * (d * x - f * w) + u * (d * r - f * h));
      a[12] = -(g * (w * A - y * C) - u * (h * A - k * C) + D * (h * y - k * w));
      a[13] = b * (w * A - y * C) - u * (d * A - e * C) + D * (d * y - e * w);
      a[14] = -(b * (h * A - k * C) - g * (d * A - e * C) + D * (d * k - e * h));
      a[15] = b * (h * y - k * w) - g * (d * y - e * w) + u * (d * k - e * h);
      return a;
    };
    b.determinant = function (a) {
      var c = a[0],
        b = a[1],
        d = a[2],
        e = a[3],
        f = a[4],
        g = a[5],
        h = a[6],
        v = a[7],
        r = a[8],
        u = a[9],
        w = a[10],
        y = a[11],
        x = a[12],
        D = a[13],
        C = a[14];
      a = a[15];
      return (
        (c * g - b * f) * (w * a - y * C) -
        (c * h - d * f) * (u * a - y * D) +
        (c * v - e * f) * (u * C - w * D) +
        (b * h - d * g) * (r * a - y * x) -
        (b * v - e * g) * (r * C - w * x) +
        (d * v - e * h) * (r * D - u * x)
      );
    };
    b.multiply = a;
    b.translate = function (a, c, b) {
      var d = b[0],
        e = b[1];
      b = b[2];
      if (c === a)
        (a[12] = c[0] * d + c[4] * e + c[8] * b + c[12]),
          (a[13] = c[1] * d + c[5] * e + c[9] * b + c[13]),
          (a[14] = c[2] * d + c[6] * e + c[10] * b + c[14]),
          (a[15] = c[3] * d + c[7] * e + c[11] * b + c[15]);
      else {
        var f = c[0];
        var g = c[1];
        var h = c[2];
        var k = c[3];
        var l = c[4];
        var u = c[5];
        var w = c[6];
        var y = c[7];
        var x = c[8];
        var D = c[9];
        var C = c[10];
        var A = c[11];
        a[0] = f;
        a[1] = g;
        a[2] = h;
        a[3] = k;
        a[4] = l;
        a[5] = u;
        a[6] = w;
        a[7] = y;
        a[8] = x;
        a[9] = D;
        a[10] = C;
        a[11] = A;
        a[12] = f * d + l * e + x * b + c[12];
        a[13] = g * d + u * e + D * b + c[13];
        a[14] = h * d + w * e + C * b + c[14];
        a[15] = k * d + y * e + A * b + c[15];
      }
      return a;
    };
    b.scale = function (a, c, b) {
      var d = b[0],
        e = b[1];
      b = b[2];
      a[0] = c[0] * d;
      a[1] = c[1] * d;
      a[2] = c[2] * d;
      a[3] = c[3] * d;
      a[4] = c[4] * e;
      a[5] = c[5] * e;
      a[6] = c[6] * e;
      a[7] = c[7] * e;
      a[8] = c[8] * b;
      a[9] = c[9] * b;
      a[10] = c[10] * b;
      a[11] = c[11] * b;
      a[12] = c[12];
      a[13] = c[13];
      a[14] = c[14];
      a[15] = c[15];
      return a;
    };
    b.rotate = function (a, c, b, d) {
      var e = d[0],
        f = d[1];
      d = d[2];
      var g = Math.sqrt(e * e + f * f + d * d);
      if (g < h.EPSILON) return null;
      g = 1 / g;
      e *= g;
      f *= g;
      d *= g;
      var k = Math.sin(b);
      var l = Math.cos(b);
      var r = 1 - l;
      b = c[0];
      g = c[1];
      var n = c[2];
      var w = c[3];
      var y = c[4];
      var x = c[5];
      var D = c[6];
      var C = c[7];
      var A = c[8];
      var E = c[9];
      var J = c[10];
      var G = c[11];
      var M = e * e * r + l;
      var O = f * e * r + d * k;
      var z = d * e * r - f * k;
      var B = e * f * r - d * k;
      var F = f * f * r + l;
      var H = d * f * r + e * k;
      var I = e * d * r + f * k;
      e = f * d * r - e * k;
      f = d * d * r + l;
      a[0] = b * M + y * O + A * z;
      a[1] = g * M + x * O + E * z;
      a[2] = n * M + D * O + J * z;
      a[3] = w * M + C * O + G * z;
      a[4] = b * B + y * F + A * H;
      a[5] = g * B + x * F + E * H;
      a[6] = n * B + D * F + J * H;
      a[7] = w * B + C * F + G * H;
      a[8] = b * I + y * e + A * f;
      a[9] = g * I + x * e + E * f;
      a[10] = n * I + D * e + J * f;
      a[11] = w * I + C * e + G * f;
      c !== a && ((a[12] = c[12]), (a[13] = c[13]), (a[14] = c[14]), (a[15] = c[15]));
      return a;
    };
    b.rotateX = function (a, c, b) {
      var d = Math.sin(b);
      b = Math.cos(b);
      var e = c[4],
        f = c[5],
        g = c[6],
        h = c[7],
        k = c[8],
        l = c[9],
        u = c[10],
        w = c[11];
      c !== a && ((a[0] = c[0]), (a[1] = c[1]), (a[2] = c[2]), (a[3] = c[3]), (a[12] = c[12]), (a[13] = c[13]), (a[14] = c[14]), (a[15] = c[15]));
      a[4] = e * b + k * d;
      a[5] = f * b + l * d;
      a[6] = g * b + u * d;
      a[7] = h * b + w * d;
      a[8] = k * b - e * d;
      a[9] = l * b - f * d;
      a[10] = u * b - g * d;
      a[11] = w * b - h * d;
      return a;
    };
    b.rotateY = function (a, c, b) {
      var d = Math.sin(b);
      b = Math.cos(b);
      var e = c[0],
        f = c[1],
        g = c[2],
        h = c[3],
        k = c[8],
        l = c[9],
        u = c[10],
        w = c[11];
      c !== a && ((a[4] = c[4]), (a[5] = c[5]), (a[6] = c[6]), (a[7] = c[7]), (a[12] = c[12]), (a[13] = c[13]), (a[14] = c[14]), (a[15] = c[15]));
      a[0] = e * b - k * d;
      a[1] = f * b - l * d;
      a[2] = g * b - u * d;
      a[3] = h * b - w * d;
      a[8] = e * d + k * b;
      a[9] = f * d + l * b;
      a[10] = g * d + u * b;
      a[11] = h * d + w * b;
      return a;
    };
    b.rotateZ = function (a, c, b) {
      var d = Math.sin(b);
      b = Math.cos(b);
      var e = c[0],
        f = c[1],
        g = c[2],
        h = c[3],
        k = c[4],
        l = c[5],
        u = c[6],
        w = c[7];
      c !== a && ((a[8] = c[8]), (a[9] = c[9]), (a[10] = c[10]), (a[11] = c[11]), (a[12] = c[12]), (a[13] = c[13]), (a[14] = c[14]), (a[15] = c[15]));
      a[0] = e * b + k * d;
      a[1] = f * b + l * d;
      a[2] = g * b + u * d;
      a[3] = h * b + w * d;
      a[4] = k * b - e * d;
      a[5] = l * b - f * d;
      a[6] = u * b - g * d;
      a[7] = w * b - h * d;
      return a;
    };
    b.fromTranslation = function (a, c) {
      a[0] = 1;
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      a[4] = 0;
      a[5] = 1;
      a[6] = 0;
      a[7] = 0;
      a[8] = 0;
      a[9] = 0;
      a[10] = 1;
      a[11] = 0;
      a[12] = c[0];
      a[13] = c[1];
      a[14] = c[2];
      a[15] = 1;
      return a;
    };
    b.fromScaling = function (a, c) {
      a[0] = c[0];
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      a[4] = 0;
      a[5] = c[1];
      a[6] = 0;
      a[7] = 0;
      a[8] = 0;
      a[9] = 0;
      a[10] = c[2];
      a[11] = 0;
      a[12] = 0;
      a[13] = 0;
      a[14] = 0;
      a[15] = 1;
      return a;
    };
    b.fromRotation = function (a, c, b) {
      var d = b[0],
        e = b[1];
      b = b[2];
      var f = Math.sqrt(d * d + e * e + b * b);
      if (f < h.EPSILON) return null;
      f = 1 / f;
      d *= f;
      e *= f;
      b *= f;
      f = Math.sin(c);
      c = Math.cos(c);
      var g = 1 - c;
      a[0] = d * d * g + c;
      a[1] = e * d * g + b * f;
      a[2] = b * d * g - e * f;
      a[3] = 0;
      a[4] = d * e * g - b * f;
      a[5] = e * e * g + c;
      a[6] = b * e * g + d * f;
      a[7] = 0;
      a[8] = d * b * g + e * f;
      a[9] = e * b * g - d * f;
      a[10] = b * b * g + c;
      a[11] = 0;
      a[12] = 0;
      a[13] = 0;
      a[14] = 0;
      a[15] = 1;
      return a;
    };
    b.fromXRotation = function (a, c) {
      var b = Math.sin(c);
      c = Math.cos(c);
      a[0] = 1;
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      a[4] = 0;
      a[5] = c;
      a[6] = b;
      a[7] = 0;
      a[8] = 0;
      a[9] = -b;
      a[10] = c;
      a[11] = 0;
      a[12] = 0;
      a[13] = 0;
      a[14] = 0;
      a[15] = 1;
      return a;
    };
    b.fromYRotation = function (a, c) {
      var b = Math.sin(c);
      c = Math.cos(c);
      a[0] = c;
      a[1] = 0;
      a[2] = -b;
      a[3] = 0;
      a[4] = 0;
      a[5] = 1;
      a[6] = 0;
      a[7] = 0;
      a[8] = b;
      a[9] = 0;
      a[10] = c;
      a[11] = 0;
      a[12] = 0;
      a[13] = 0;
      a[14] = 0;
      a[15] = 1;
      return a;
    };
    b.fromZRotation = function (a, c) {
      var b = Math.sin(c);
      c = Math.cos(c);
      a[0] = c;
      a[1] = b;
      a[2] = 0;
      a[3] = 0;
      a[4] = -b;
      a[5] = c;
      a[6] = 0;
      a[7] = 0;
      a[8] = 0;
      a[9] = 0;
      a[10] = 1;
      a[11] = 0;
      a[12] = 0;
      a[13] = 0;
      a[14] = 0;
      a[15] = 1;
      return a;
    };
    b.fromRotationTranslation = c;
    b.fromQuat2 = function (a, b) {
      var d = new h.ARRAY_TYPE(3),
        e = -b[0],
        f = -b[1],
        g = -b[2],
        k = b[3],
        t = b[4],
        v = b[5],
        r = b[6],
        u = b[7],
        w = e * e + f * f + g * g + k * k;
      0 < w
        ? ((d[0] = (2 * (t * k + u * e + v * g - r * f)) / w), (d[1] = (2 * (v * k + u * f + r * e - t * g)) / w), (d[2] = (2 * (r * k + u * g + t * f - v * e)) / w))
        : ((d[0] = 2 * (t * k + u * e + v * g - r * f)), (d[1] = 2 * (v * k + u * f + r * e - t * g)), (d[2] = 2 * (r * k + u * g + t * f - v * e)));
      c(a, b, d);
      return a;
    };
    b.getTranslation = function (a, c) {
      a[0] = c[12];
      a[1] = c[13];
      a[2] = c[14];
      return a;
    };
    b.getScaling = function (a, c) {
      var b = c[0],
        d = c[1],
        e = c[2],
        f = c[4],
        g = c[5],
        h = c[6],
        k = c[8],
        r = c[9];
      c = c[10];
      a[0] = Math.sqrt(b * b + d * d + e * e);
      a[1] = Math.sqrt(f * f + g * g + h * h);
      a[2] = Math.sqrt(k * k + r * r + c * c);
      return a;
    };
    b.getRotation = function (a, c) {
      var b = c[0] + c[5] + c[10];
      0 < b
        ? ((b = 2 * Math.sqrt(b + 1)), (a[3] = 0.25 * b), (a[0] = (c[6] - c[9]) / b), (a[1] = (c[8] - c[2]) / b), (a[2] = (c[1] - c[4]) / b))
        : c[0] > c[5] && c[0] > c[10]
        ? ((b = 2 * Math.sqrt(1 + c[0] - c[5] - c[10])), (a[3] = (c[6] - c[9]) / b), (a[0] = 0.25 * b), (a[1] = (c[1] + c[4]) / b), (a[2] = (c[8] + c[2]) / b))
        : c[5] > c[10]
        ? ((b = 2 * Math.sqrt(1 + c[5] - c[0] - c[10])), (a[3] = (c[8] - c[2]) / b), (a[0] = (c[1] + c[4]) / b), (a[1] = 0.25 * b), (a[2] = (c[6] + c[9]) / b))
        : ((b = 2 * Math.sqrt(1 + c[10] - c[0] - c[5])), (a[3] = (c[1] - c[4]) / b), (a[0] = (c[8] + c[2]) / b), (a[1] = (c[6] + c[9]) / b), (a[2] = 0.25 * b));
      return a;
    };
    b.fromRotationTranslationScale = function (a, c, b, d) {
      var e = c[0],
        f = c[1],
        g = c[2],
        h = c[3],
        k = e + e,
        l = f + f,
        n = g + g;
      c = e * k;
      var w = e * l;
      e *= n;
      var y = f * l;
      f *= n;
      g *= n;
      k *= h;
      l *= h;
      h *= n;
      n = d[0];
      var x = d[1];
      d = d[2];
      a[0] = (1 - (y + g)) * n;
      a[1] = (w + h) * n;
      a[2] = (e - l) * n;
      a[3] = 0;
      a[4] = (w - h) * x;
      a[5] = (1 - (c + g)) * x;
      a[6] = (f + k) * x;
      a[7] = 0;
      a[8] = (e + l) * d;
      a[9] = (f - k) * d;
      a[10] = (1 - (c + y)) * d;
      a[11] = 0;
      a[12] = b[0];
      a[13] = b[1];
      a[14] = b[2];
      a[15] = 1;
      return a;
    };
    b.fromRotationTranslationScaleOrigin = function (a, c, b, d, e) {
      var f = c[0],
        g = c[1],
        h = c[2],
        m = c[3],
        k = f + f,
        l = g + g,
        n = h + h;
      c = f * k;
      var y = f * l,
        x = f * n;
      f = g * l;
      g *= n;
      var D = h * n;
      h = m * k;
      l *= m;
      var C = m * n,
        A = d[0],
        E = d[1];
      n = d[2];
      d = e[0];
      m = e[1];
      e = e[2];
      k = (1 - (f + D)) * A;
      var J = (y + C) * A;
      A *= x - l;
      y = (y - C) * E;
      D = (1 - (c + D)) * E;
      E *= g + h;
      x = (x + l) * n;
      g = (g - h) * n;
      c = (1 - (c + f)) * n;
      a[0] = k;
      a[1] = J;
      a[2] = A;
      a[3] = 0;
      a[4] = y;
      a[5] = D;
      a[6] = E;
      a[7] = 0;
      a[8] = x;
      a[9] = g;
      a[10] = c;
      a[11] = 0;
      a[12] = b[0] + d - (k * d + y * m + x * e);
      a[13] = b[1] + m - (J * d + D * m + g * e);
      a[14] = b[2] + e - (A * d + E * m + c * e);
      a[15] = 1;
      return a;
    };
    b.fromQuat = function (a, c) {
      var b = c[0],
        d = c[1],
        e = c[2];
      c = c[3];
      var f = b + b,
        g = d + d,
        h = e + e;
      b *= f;
      var k = d * f;
      d *= g;
      var r = e * f,
        u = e * g;
      e *= h;
      f *= c;
      g *= c;
      c *= h;
      a[0] = 1 - d - e;
      a[1] = k + c;
      a[2] = r - g;
      a[3] = 0;
      a[4] = k - c;
      a[5] = 1 - b - e;
      a[6] = u + f;
      a[7] = 0;
      a[8] = r + g;
      a[9] = u - f;
      a[10] = 1 - b - d;
      a[11] = 0;
      a[12] = 0;
      a[13] = 0;
      a[14] = 0;
      a[15] = 1;
      return a;
    };
    b.frustum = function (a, c, b, d, e, f, h) {
      var g = 1 / (b - c),
        m = 1 / (e - d),
        p = 1 / (f - h);
      a[0] = 2 * f * g;
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      a[4] = 0;
      a[5] = 2 * f * m;
      a[6] = 0;
      a[7] = 0;
      a[8] = (b + c) * g;
      a[9] = (e + d) * m;
      a[10] = (h + f) * p;
      a[11] = -1;
      a[12] = 0;
      a[13] = 0;
      a[14] = h * f * 2 * p;
      a[15] = 0;
      return a;
    };
    b.perspective = function (a, c, b, d, e) {
      c = 1 / Math.tan(c / 2);
      a[0] = c / b;
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      a[4] = 0;
      a[5] = c;
      a[6] = 0;
      a[7] = 0;
      a[8] = 0;
      a[9] = 0;
      a[11] = -1;
      a[12] = 0;
      a[13] = 0;
      a[15] = 0;
      null != e && Infinity !== e ? ((b = 1 / (d - e)), (a[10] = (e + d) * b), (a[14] = 2 * e * d * b)) : ((a[10] = -1), (a[14] = -2 * d));
      return a;
    };
    b.perspectiveFromFieldOfView = function (a, c, b, d) {
      var e = Math.tan((c.upDegrees * Math.PI) / 180),
        f = Math.tan((c.downDegrees * Math.PI) / 180),
        g = Math.tan((c.leftDegrees * Math.PI) / 180);
      c = Math.tan((c.rightDegrees * Math.PI) / 180);
      var h = 2 / (g + c),
        k = 2 / (e + f);
      a[0] = h;
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      a[4] = 0;
      a[5] = k;
      a[6] = 0;
      a[7] = 0;
      a[8] = -((g - c) * h * 0.5);
      a[9] = (e - f) * k * 0.5;
      a[10] = d / (b - d);
      a[11] = -1;
      a[12] = 0;
      a[13] = 0;
      a[14] = (d * b) / (b - d);
      a[15] = 0;
      return a;
    };
    b.ortho = function (a, c, b, d, e, f, h) {
      var g = 1 / (c - b),
        m = 1 / (d - e),
        p = 1 / (f - h);
      a[0] = -2 * g;
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      a[4] = 0;
      a[5] = -2 * m;
      a[6] = 0;
      a[7] = 0;
      a[8] = 0;
      a[9] = 0;
      a[10] = 2 * p;
      a[11] = 0;
      a[12] = (c + b) * g;
      a[13] = (e + d) * m;
      a[14] = (h + f) * p;
      a[15] = 1;
      return a;
    };
    b.lookAt = function (a, c, b, e) {
      var f = c[0],
        g = c[1];
      c = c[2];
      var k = e[0];
      var t = e[1];
      var l = e[2];
      var r = b[0];
      e = b[1];
      var n = b[2];
      if (Math.abs(f - r) < h.EPSILON && Math.abs(g - e) < h.EPSILON && Math.abs(c - n) < h.EPSILON) return d(a);
      b = f - r;
      e = g - e;
      r = c - n;
      var w = 1 / Math.sqrt(b * b + e * e + r * r);
      b *= w;
      e *= w;
      r *= w;
      n = t * r - l * e;
      l = l * b - k * r;
      k = k * e - t * b;
      (w = Math.sqrt(n * n + l * l + k * k)) ? ((w = 1 / w), (n *= w), (l *= w), (k *= w)) : (k = l = n = 0);
      t = e * k - r * l;
      var y = r * n - b * k;
      var x = b * l - e * n;
      (w = Math.sqrt(t * t + y * y + x * x)) ? ((w = 1 / w), (t *= w), (y *= w), (x *= w)) : (x = y = t = 0);
      a[0] = n;
      a[1] = t;
      a[2] = b;
      a[3] = 0;
      a[4] = l;
      a[5] = y;
      a[6] = e;
      a[7] = 0;
      a[8] = k;
      a[9] = x;
      a[10] = r;
      a[11] = 0;
      a[12] = -(n * f + l * g + k * c);
      a[13] = -(t * f + y * g + x * c);
      a[14] = -(b * f + e * g + r * c);
      a[15] = 1;
      return a;
    };
    b.targetTo = function (a, c, b, d) {
      var e = c[0],
        f = c[1];
      c = c[2];
      var h = d[0],
        g = d[1],
        k = d[2];
      d = e - b[0];
      var l = f - b[1];
      b = c - b[2];
      var n = d * d + l * l + b * b;
      0 < n && ((n = 1 / Math.sqrt(n)), (d *= n), (l *= n), (b *= n));
      var w = g * b - k * l;
      k = k * d - h * b;
      h = h * l - g * d;
      n = w * w + k * k + h * h;
      0 < n && ((n = 1 / Math.sqrt(n)), (w *= n), (k *= n), (h *= n));
      a[0] = w;
      a[1] = k;
      a[2] = h;
      a[3] = 0;
      a[4] = l * h - b * k;
      a[5] = b * w - d * h;
      a[6] = d * k - l * w;
      a[7] = 0;
      a[8] = d;
      a[9] = l;
      a[10] = b;
      a[11] = 0;
      a[12] = e;
      a[13] = f;
      a[14] = c;
      a[15] = 1;
      return a;
    };
    b.str = function (a) {
      return (
        "mat4(" +
        a[0] +
        ", " +
        a[1] +
        ", " +
        a[2] +
        ", " +
        a[3] +
        ", " +
        a[4] +
        ", " +
        a[5] +
        ", " +
        a[6] +
        ", " +
        a[7] +
        ", " +
        a[8] +
        ", " +
        a[9] +
        ", " +
        a[10] +
        ", " +
        a[11] +
        ", " +
        a[12] +
        ", " +
        a[13] +
        ", " +
        a[14] +
        ", " +
        a[15] +
        ")"
      );
    };
    b.frob = function (a) {
      return Math.sqrt(
        Math.pow(a[0], 2) +
          Math.pow(a[1], 2) +
          Math.pow(a[2], 2) +
          Math.pow(a[3], 2) +
          Math.pow(a[4], 2) +
          Math.pow(a[5], 2) +
          Math.pow(a[6], 2) +
          Math.pow(a[7], 2) +
          Math.pow(a[8], 2) +
          Math.pow(a[9], 2) +
          Math.pow(a[10], 2) +
          Math.pow(a[11], 2) +
          Math.pow(a[12], 2) +
          Math.pow(a[13], 2) +
          Math.pow(a[14], 2) +
          Math.pow(a[15], 2)
      );
    };
    b.add = function (a, c, b) {
      a[0] = c[0] + b[0];
      a[1] = c[1] + b[1];
      a[2] = c[2] + b[2];
      a[3] = c[3] + b[3];
      a[4] = c[4] + b[4];
      a[5] = c[5] + b[5];
      a[6] = c[6] + b[6];
      a[7] = c[7] + b[7];
      a[8] = c[8] + b[8];
      a[9] = c[9] + b[9];
      a[10] = c[10] + b[10];
      a[11] = c[11] + b[11];
      a[12] = c[12] + b[12];
      a[13] = c[13] + b[13];
      a[14] = c[14] + b[14];
      a[15] = c[15] + b[15];
      return a;
    };
    b.subtract = f;
    b.multiplyScalar = function (a, c, b) {
      a[0] = c[0] * b;
      a[1] = c[1] * b;
      a[2] = c[2] * b;
      a[3] = c[3] * b;
      a[4] = c[4] * b;
      a[5] = c[5] * b;
      a[6] = c[6] * b;
      a[7] = c[7] * b;
      a[8] = c[8] * b;
      a[9] = c[9] * b;
      a[10] = c[10] * b;
      a[11] = c[11] * b;
      a[12] = c[12] * b;
      a[13] = c[13] * b;
      a[14] = c[14] * b;
      a[15] = c[15] * b;
      return a;
    };
    b.multiplyScalarAndAdd = function (a, c, b, d) {
      a[0] = c[0] + b[0] * d;
      a[1] = c[1] + b[1] * d;
      a[2] = c[2] + b[2] * d;
      a[3] = c[3] + b[3] * d;
      a[4] = c[4] + b[4] * d;
      a[5] = c[5] + b[5] * d;
      a[6] = c[6] + b[6] * d;
      a[7] = c[7] + b[7] * d;
      a[8] = c[8] + b[8] * d;
      a[9] = c[9] + b[9] * d;
      a[10] = c[10] + b[10] * d;
      a[11] = c[11] + b[11] * d;
      a[12] = c[12] + b[12] * d;
      a[13] = c[13] + b[13] * d;
      a[14] = c[14] + b[14] * d;
      a[15] = c[15] + b[15] * d;
      return a;
    };
    b.exactEquals = function (a, c) {
      return (
        a[0] === c[0] &&
        a[1] === c[1] &&
        a[2] === c[2] &&
        a[3] === c[3] &&
        a[4] === c[4] &&
        a[5] === c[5] &&
        a[6] === c[6] &&
        a[7] === c[7] &&
        a[8] === c[8] &&
        a[9] === c[9] &&
        a[10] === c[10] &&
        a[11] === c[11] &&
        a[12] === c[12] &&
        a[13] === c[13] &&
        a[14] === c[14] &&
        a[15] === c[15]
      );
    };
    b.equals = function (a, c) {
      var b = a[0],
        d = a[1],
        e = a[2],
        f = a[3],
        g = a[4],
        k = a[5],
        v = a[6],
        r = a[7],
        u = a[8],
        w = a[9],
        y = a[10],
        x = a[11],
        D = a[12],
        C = a[13],
        A = a[14];
      a = a[15];
      var E = c[0],
        J = c[1],
        G = c[2],
        M = c[3],
        O = c[4],
        z = c[5],
        B = c[6],
        F = c[7],
        H = c[8],
        I = c[9],
        K = c[10],
        L = c[11],
        N = c[12],
        P = c[13],
        Q = c[14];
      c = c[15];
      return (
        Math.abs(b - E) <= h.EPSILON * Math.max(1, Math.abs(b), Math.abs(E)) &&
        Math.abs(d - J) <= h.EPSILON * Math.max(1, Math.abs(d), Math.abs(J)) &&
        Math.abs(e - G) <= h.EPSILON * Math.max(1, Math.abs(e), Math.abs(G)) &&
        Math.abs(f - M) <= h.EPSILON * Math.max(1, Math.abs(f), Math.abs(M)) &&
        Math.abs(g - O) <= h.EPSILON * Math.max(1, Math.abs(g), Math.abs(O)) &&
        Math.abs(k - z) <= h.EPSILON * Math.max(1, Math.abs(k), Math.abs(z)) &&
        Math.abs(v - B) <= h.EPSILON * Math.max(1, Math.abs(v), Math.abs(B)) &&
        Math.abs(r - F) <= h.EPSILON * Math.max(1, Math.abs(r), Math.abs(F)) &&
        Math.abs(u - H) <= h.EPSILON * Math.max(1, Math.abs(u), Math.abs(H)) &&
        Math.abs(w - I) <= h.EPSILON * Math.max(1, Math.abs(w), Math.abs(I)) &&
        Math.abs(y - K) <= h.EPSILON * Math.max(1, Math.abs(y), Math.abs(K)) &&
        Math.abs(x - L) <= h.EPSILON * Math.max(1, Math.abs(x), Math.abs(L)) &&
        Math.abs(D - N) <= h.EPSILON * Math.max(1, Math.abs(D), Math.abs(N)) &&
        Math.abs(C - P) <= h.EPSILON * Math.max(1, Math.abs(C), Math.abs(P)) &&
        Math.abs(A - Q) <= h.EPSILON * Math.max(1, Math.abs(A), Math.abs(Q)) &&
        Math.abs(a - c) <= h.EPSILON * Math.max(1, Math.abs(a), Math.abs(c))
      );
    };
    b.sub = b.mul = void 0;
    var h = (function (a) {
      if (a && a.__esModule) return a;
      var c = {};
      if (null != a)
        for (var b in a)
          if (Object.prototype.hasOwnProperty.call(a, b)) {
            var d = ra && pa ? pa(a, b) : {};
            d.get || d.set ? ra(c, b, d) : (c[b] = a[b]);
          }
      c.default = a;
      return c;
    })(Za);
    b.mul = a;
    b.sub = f;
  });
  Y(jf);
  var kf = U(function (e, b) {
    function d() {
      var a = new q.ARRAY_TYPE(3);
      q.ARRAY_TYPE != Float32Array && ((a[0] = 0), (a[1] = 0), (a[2] = 0));
      return a;
    }
    function a(a) {
      var c = a[0],
        b = a[1];
      a = a[2];
      return Math.sqrt(c * c + b * b + a * a);
    }
    function c(a, c, b) {
      var d = new q.ARRAY_TYPE(3);
      d[0] = a;
      d[1] = c;
      d[2] = b;
      return d;
    }
    function f(a, c, b) {
      a[0] = c[0] - b[0];
      a[1] = c[1] - b[1];
      a[2] = c[2] - b[2];
      return a;
    }
    function h(a, c, b) {
      a[0] = c[0] * b[0];
      a[1] = c[1] * b[1];
      a[2] = c[2] * b[2];
      return a;
    }
    function g(a, c, b) {
      a[0] = c[0] / b[0];
      a[1] = c[1] / b[1];
      a[2] = c[2] / b[2];
      return a;
    }
    function k(a, c) {
      var b = c[0] - a[0],
        d = c[1] - a[1];
      a = c[2] - a[2];
      return Math.sqrt(b * b + d * d + a * a);
    }
    function l(a, c) {
      var b = c[0] - a[0],
        d = c[1] - a[1];
      a = c[2] - a[2];
      return b * b + d * d + a * a;
    }
    function n(a) {
      var c = a[0],
        b = a[1];
      a = a[2];
      return c * c + b * b + a * a;
    }
    function m(a, c) {
      var b = c[0],
        d = c[1],
        e = c[2];
      b = b * b + d * d + e * e;
      0 < b && (b = 1 / Math.sqrt(b));
      a[0] = c[0] * b;
      a[1] = c[1] * b;
      a[2] = c[2] * b;
      return a;
    }
    function p(a, c) {
      return a[0] * c[0] + a[1] * c[1] + a[2] * c[2];
    }
    Object.defineProperty(b, "__esModule", { value: !0 });
    b.create = d;
    b.clone = function (a) {
      var c = new q.ARRAY_TYPE(3);
      c[0] = a[0];
      c[1] = a[1];
      c[2] = a[2];
      return c;
    };
    b.length = a;
    b.fromValues = c;
    b.copy = function (a, c) {
      a[0] = c[0];
      a[1] = c[1];
      a[2] = c[2];
      return a;
    };
    b.set = function (a, c, b, d) {
      a[0] = c;
      a[1] = b;
      a[2] = d;
      return a;
    };
    b.add = function (a, c, b) {
      a[0] = c[0] + b[0];
      a[1] = c[1] + b[1];
      a[2] = c[2] + b[2];
      return a;
    };
    b.subtract = f;
    b.multiply = h;
    b.divide = g;
    b.ceil = function (a, c) {
      a[0] = Math.ceil(c[0]);
      a[1] = Math.ceil(c[1]);
      a[2] = Math.ceil(c[2]);
      return a;
    };
    b.floor = function (a, c) {
      a[0] = Math.floor(c[0]);
      a[1] = Math.floor(c[1]);
      a[2] = Math.floor(c[2]);
      return a;
    };
    b.min = function (a, c, b) {
      a[0] = Math.min(c[0], b[0]);
      a[1] = Math.min(c[1], b[1]);
      a[2] = Math.min(c[2], b[2]);
      return a;
    };
    b.max = function (a, c, b) {
      a[0] = Math.max(c[0], b[0]);
      a[1] = Math.max(c[1], b[1]);
      a[2] = Math.max(c[2], b[2]);
      return a;
    };
    b.round = function (a, c) {
      a[0] = Math.round(c[0]);
      a[1] = Math.round(c[1]);
      a[2] = Math.round(c[2]);
      return a;
    };
    b.scale = function (a, c, b) {
      a[0] = c[0] * b;
      a[1] = c[1] * b;
      a[2] = c[2] * b;
      return a;
    };
    b.scaleAndAdd = function (a, c, b, d) {
      a[0] = c[0] + b[0] * d;
      a[1] = c[1] + b[1] * d;
      a[2] = c[2] + b[2] * d;
      return a;
    };
    b.distance = k;
    b.squaredDistance = l;
    b.squaredLength = n;
    b.negate = function (a, c) {
      a[0] = -c[0];
      a[1] = -c[1];
      a[2] = -c[2];
      return a;
    };
    b.inverse = function (a, c) {
      a[0] = 1 / c[0];
      a[1] = 1 / c[1];
      a[2] = 1 / c[2];
      return a;
    };
    b.normalize = m;
    b.dot = p;
    b.cross = function (a, c, b) {
      var d = c[0],
        e = c[1];
      c = c[2];
      var f = b[0],
        h = b[1];
      b = b[2];
      a[0] = e * b - c * h;
      a[1] = c * f - d * b;
      a[2] = d * h - e * f;
      return a;
    };
    b.lerp = function (a, c, b, d) {
      var e = c[0],
        f = c[1];
      c = c[2];
      a[0] = e + d * (b[0] - e);
      a[1] = f + d * (b[1] - f);
      a[2] = c + d * (b[2] - c);
      return a;
    };
    b.hermite = function (a, c, b, d, e, f) {
      var h = f * f,
        g = h * (2 * f - 3) + 1,
        m = h * (f - 2) + f,
        p = h * (f - 1);
      f = h * (3 - 2 * f);
      a[0] = c[0] * g + b[0] * m + d[0] * p + e[0] * f;
      a[1] = c[1] * g + b[1] * m + d[1] * p + e[1] * f;
      a[2] = c[2] * g + b[2] * m + d[2] * p + e[2] * f;
      return a;
    };
    b.bezier = function (a, c, b, d, e, f) {
      var h = 1 - f,
        g = h * h,
        m = f * f,
        p = g * h;
      g *= 3 * f;
      h *= 3 * m;
      f *= m;
      a[0] = c[0] * p + b[0] * g + d[0] * h + e[0] * f;
      a[1] = c[1] * p + b[1] * g + d[1] * h + e[1] * f;
      a[2] = c[2] * p + b[2] * g + d[2] * h + e[2] * f;
      return a;
    };
    b.random = function (a, c) {
      c = c || 1;
      var b = 2 * q.RANDOM() * Math.PI,
        d = 2 * q.RANDOM() - 1,
        e = Math.sqrt(1 - d * d) * c;
      a[0] = Math.cos(b) * e;
      a[1] = Math.sin(b) * e;
      a[2] = d * c;
      return a;
    };
    b.transformMat4 = function (a, c, b) {
      var d = c[0],
        e = c[1];
      c = c[2];
      var f = b[3] * d + b[7] * e + b[11] * c + b[15];
      f = f || 1;
      a[0] = (b[0] * d + b[4] * e + b[8] * c + b[12]) / f;
      a[1] = (b[1] * d + b[5] * e + b[9] * c + b[13]) / f;
      a[2] = (b[2] * d + b[6] * e + b[10] * c + b[14]) / f;
      return a;
    };
    b.transformMat3 = function (a, c, b) {
      var d = c[0],
        e = c[1];
      c = c[2];
      a[0] = d * b[0] + e * b[3] + c * b[6];
      a[1] = d * b[1] + e * b[4] + c * b[7];
      a[2] = d * b[2] + e * b[5] + c * b[8];
      return a;
    };
    b.transformQuat = function (a, c, b) {
      var d = b[0],
        e = b[1],
        f = b[2],
        h = c[0],
        g = c[1];
      c = c[2];
      var m = e * c - f * g,
        p = f * h - d * c,
        k = d * g - e * h;
      b = 2 * b[3];
      a[0] = h + m * b + 2 * (e * k - f * p);
      a[1] = g + p * b + 2 * (f * m - d * k);
      a[2] = c + k * b + 2 * (d * p - e * m);
      return a;
    };
    b.rotateX = function (a, c, b, d) {
      var e = [],
        f = [];
      e[0] = c[0] - b[0];
      e[1] = c[1] - b[1];
      e[2] = c[2] - b[2];
      f[0] = e[0];
      f[1] = e[1] * Math.cos(d) - e[2] * Math.sin(d);
      f[2] = e[1] * Math.sin(d) + e[2] * Math.cos(d);
      a[0] = f[0] + b[0];
      a[1] = f[1] + b[1];
      a[2] = f[2] + b[2];
      return a;
    };
    b.rotateY = function (a, c, b, d) {
      var e = [],
        f = [];
      e[0] = c[0] - b[0];
      e[1] = c[1] - b[1];
      e[2] = c[2] - b[2];
      f[0] = e[2] * Math.sin(d) + e[0] * Math.cos(d);
      f[1] = e[1];
      f[2] = e[2] * Math.cos(d) - e[0] * Math.sin(d);
      a[0] = f[0] + b[0];
      a[1] = f[1] + b[1];
      a[2] = f[2] + b[2];
      return a;
    };
    b.rotateZ = function (a, c, b, d) {
      var e = [],
        f = [];
      e[0] = c[0] - b[0];
      e[1] = c[1] - b[1];
      e[2] = c[2] - b[2];
      f[0] = e[0] * Math.cos(d) - e[1] * Math.sin(d);
      f[1] = e[0] * Math.sin(d) + e[1] * Math.cos(d);
      f[2] = e[2];
      a[0] = f[0] + b[0];
      a[1] = f[1] + b[1];
      a[2] = f[2] + b[2];
      return a;
    };
    b.angle = function (a, b) {
      a = c(a[0], a[1], a[2]);
      b = c(b[0], b[1], b[2]);
      m(a, a);
      m(b, b);
      b = p(a, b);
      return 1 < b ? 0 : -1 > b ? Math.PI : Math.acos(b);
    };
    b.zero = function (a) {
      a[0] = 0;
      a[1] = 0;
      a[2] = 0;
      return a;
    };
    b.str = function (a) {
      return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
    };
    b.exactEquals = function (a, c) {
      return a[0] === c[0] && a[1] === c[1] && a[2] === c[2];
    };
    b.equals = function (a, c) {
      var b = a[0],
        d = a[1];
      a = a[2];
      var e = c[0],
        f = c[1];
      c = c[2];
      return (
        Math.abs(b - e) <= q.EPSILON * Math.max(1, Math.abs(b), Math.abs(e)) &&
        Math.abs(d - f) <= q.EPSILON * Math.max(1, Math.abs(d), Math.abs(f)) &&
        Math.abs(a - c) <= q.EPSILON * Math.max(1, Math.abs(a), Math.abs(c))
      );
    };
    b.forEach = b.sqrLen = b.len = b.sqrDist = b.dist = b.div = b.mul = b.sub = void 0;
    var q = (function (a) {
      if (a && a.__esModule) return a;
      var c = {};
      if (null != a)
        for (var b in a)
          if (Object.prototype.hasOwnProperty.call(a, b)) {
            var d = ra && pa ? pa(a, b) : {};
            d.get || d.set ? ra(c, b, d) : (c[b] = a[b]);
          }
      c.default = a;
      return c;
    })(Za);
    b.sub = f;
    b.mul = h;
    b.div = g;
    b.dist = k;
    b.sqrDist = l;
    b.len = a;
    b.sqrLen = n;
    e = (function () {
      var a = d();
      return function (c, b, d, e, f, h) {
        b || (b = 3);
        d || (d = 0);
        for (e = e ? Math.min(e * b + d, c.length) : c.length; d < e; d += b)
          (a[0] = c[d]), (a[1] = c[d + 1]), (a[2] = c[d + 2]), f(a, a, h), (c[d] = a[0]), (c[d + 1] = a[1]), (c[d + 2] = a[2]);
        return c;
      };
    })();
    b.forEach = e;
  });
  Y(kf);
  var lf = U(function (e, b) {
    function d() {
      var a = new n.ARRAY_TYPE(4);
      n.ARRAY_TYPE != Float32Array && ((a[0] = 0), (a[1] = 0), (a[2] = 0), (a[3] = 0));
      return a;
    }
    function a(a, c, b) {
      a[0] = c[0] - b[0];
      a[1] = c[1] - b[1];
      a[2] = c[2] - b[2];
      a[3] = c[3] - b[3];
      return a;
    }
    function c(a, c, b) {
      a[0] = c[0] * b[0];
      a[1] = c[1] * b[1];
      a[2] = c[2] * b[2];
      a[3] = c[3] * b[3];
      return a;
    }
    function f(a, c, b) {
      a[0] = c[0] / b[0];
      a[1] = c[1] / b[1];
      a[2] = c[2] / b[2];
      a[3] = c[3] / b[3];
      return a;
    }
    function h(a, c) {
      var b = c[0] - a[0],
        d = c[1] - a[1],
        e = c[2] - a[2];
      a = c[3] - a[3];
      return Math.sqrt(b * b + d * d + e * e + a * a);
    }
    function g(a, c) {
      var b = c[0] - a[0],
        d = c[1] - a[1],
        e = c[2] - a[2];
      a = c[3] - a[3];
      return b * b + d * d + e * e + a * a;
    }
    function k(a) {
      var c = a[0],
        b = a[1],
        d = a[2];
      a = a[3];
      return Math.sqrt(c * c + b * b + d * d + a * a);
    }
    function l(a) {
      var c = a[0],
        b = a[1],
        d = a[2];
      a = a[3];
      return c * c + b * b + d * d + a * a;
    }
    Object.defineProperty(b, "__esModule", { value: !0 });
    b.create = d;
    b.clone = function (a) {
      var c = new n.ARRAY_TYPE(4);
      c[0] = a[0];
      c[1] = a[1];
      c[2] = a[2];
      c[3] = a[3];
      return c;
    };
    b.fromValues = function (a, c, b, d) {
      var e = new n.ARRAY_TYPE(4);
      e[0] = a;
      e[1] = c;
      e[2] = b;
      e[3] = d;
      return e;
    };
    b.copy = function (a, c) {
      a[0] = c[0];
      a[1] = c[1];
      a[2] = c[2];
      a[3] = c[3];
      return a;
    };
    b.set = function (a, c, b, d, e) {
      a[0] = c;
      a[1] = b;
      a[2] = d;
      a[3] = e;
      return a;
    };
    b.add = function (a, c, b) {
      a[0] = c[0] + b[0];
      a[1] = c[1] + b[1];
      a[2] = c[2] + b[2];
      a[3] = c[3] + b[3];
      return a;
    };
    b.subtract = a;
    b.multiply = c;
    b.divide = f;
    b.ceil = function (a, c) {
      a[0] = Math.ceil(c[0]);
      a[1] = Math.ceil(c[1]);
      a[2] = Math.ceil(c[2]);
      a[3] = Math.ceil(c[3]);
      return a;
    };
    b.floor = function (a, c) {
      a[0] = Math.floor(c[0]);
      a[1] = Math.floor(c[1]);
      a[2] = Math.floor(c[2]);
      a[3] = Math.floor(c[3]);
      return a;
    };
    b.min = function (a, c, b) {
      a[0] = Math.min(c[0], b[0]);
      a[1] = Math.min(c[1], b[1]);
      a[2] = Math.min(c[2], b[2]);
      a[3] = Math.min(c[3], b[3]);
      return a;
    };
    b.max = function (a, c, b) {
      a[0] = Math.max(c[0], b[0]);
      a[1] = Math.max(c[1], b[1]);
      a[2] = Math.max(c[2], b[2]);
      a[3] = Math.max(c[3], b[3]);
      return a;
    };
    b.round = function (a, c) {
      a[0] = Math.round(c[0]);
      a[1] = Math.round(c[1]);
      a[2] = Math.round(c[2]);
      a[3] = Math.round(c[3]);
      return a;
    };
    b.scale = function (a, c, b) {
      a[0] = c[0] * b;
      a[1] = c[1] * b;
      a[2] = c[2] * b;
      a[3] = c[3] * b;
      return a;
    };
    b.scaleAndAdd = function (a, c, b, d) {
      a[0] = c[0] + b[0] * d;
      a[1] = c[1] + b[1] * d;
      a[2] = c[2] + b[2] * d;
      a[3] = c[3] + b[3] * d;
      return a;
    };
    b.distance = h;
    b.squaredDistance = g;
    b.length = k;
    b.squaredLength = l;
    b.negate = function (a, c) {
      a[0] = -c[0];
      a[1] = -c[1];
      a[2] = -c[2];
      a[3] = -c[3];
      return a;
    };
    b.inverse = function (a, c) {
      a[0] = 1 / c[0];
      a[1] = 1 / c[1];
      a[2] = 1 / c[2];
      a[3] = 1 / c[3];
      return a;
    };
    b.normalize = function (a, c) {
      var b = c[0],
        d = c[1],
        e = c[2];
      c = c[3];
      var f = b * b + d * d + e * e + c * c;
      0 < f && (f = 1 / Math.sqrt(f));
      a[0] = b * f;
      a[1] = d * f;
      a[2] = e * f;
      a[3] = c * f;
      return a;
    };
    b.dot = function (a, c) {
      return a[0] * c[0] + a[1] * c[1] + a[2] * c[2] + a[3] * c[3];
    };
    b.cross = function (a, c, b, d) {
      var e = b[0] * d[1] - b[1] * d[0],
        f = b[0] * d[2] - b[2] * d[0],
        h = b[0] * d[3] - b[3] * d[0],
        g = b[1] * d[2] - b[2] * d[1],
        m = b[1] * d[3] - b[3] * d[1];
      b = b[2] * d[3] - b[3] * d[2];
      d = c[0];
      var k = c[1],
        p = c[2];
      c = c[3];
      a[0] = k * b - p * m + c * g;
      a[1] = -(d * b) + p * h - c * f;
      a[2] = d * m - k * h + c * e;
      a[3] = -(d * g) + k * f - p * e;
      return a;
    };
    b.lerp = function (a, c, b, d) {
      var e = c[0],
        f = c[1],
        h = c[2];
      c = c[3];
      a[0] = e + d * (b[0] - e);
      a[1] = f + d * (b[1] - f);
      a[2] = h + d * (b[2] - h);
      a[3] = c + d * (b[3] - c);
      return a;
    };
    b.random = function (a, c) {
      c = c || 1;
      do {
        var b = 2 * n.RANDOM() - 1;
        var d = 2 * n.RANDOM() - 1;
        var e = b * b + d * d;
      } while (1 <= e);
      do {
        var f = 2 * n.RANDOM() - 1;
        var h = 2 * n.RANDOM() - 1;
        var g = f * f + h * h;
      } while (1 <= g);
      e = Math.sqrt((1 - e) / g);
      a[0] = c * b;
      a[1] = c * d;
      a[2] = c * f * e;
      a[3] = c * h * e;
      return a;
    };
    b.transformMat4 = function (a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2];
      c = c[3];
      a[0] = b[0] * d + b[4] * e + b[8] * f + b[12] * c;
      a[1] = b[1] * d + b[5] * e + b[9] * f + b[13] * c;
      a[2] = b[2] * d + b[6] * e + b[10] * f + b[14] * c;
      a[3] = b[3] * d + b[7] * e + b[11] * f + b[15] * c;
      return a;
    };
    b.transformQuat = function (a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2],
        h = b[0],
        g = b[1],
        m = b[2];
      b = b[3];
      var k = b * d + g * f - m * e,
        p = b * e + m * d - h * f,
        l = b * f + h * e - g * d;
      d = -h * d - g * e - m * f;
      a[0] = k * b + d * -h + p * -m - l * -g;
      a[1] = p * b + d * -g + l * -h - k * -m;
      a[2] = l * b + d * -m + k * -g - p * -h;
      a[3] = c[3];
      return a;
    };
    b.zero = function (a) {
      a[0] = 0;
      a[1] = 0;
      a[2] = 0;
      a[3] = 0;
      return a;
    };
    b.str = function (a) {
      return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
    };
    b.exactEquals = function (a, c) {
      return a[0] === c[0] && a[1] === c[1] && a[2] === c[2] && a[3] === c[3];
    };
    b.equals = function (a, c) {
      var b = a[0],
        d = a[1],
        e = a[2];
      a = a[3];
      var f = c[0],
        h = c[1],
        g = c[2];
      c = c[3];
      return (
        Math.abs(b - f) <= n.EPSILON * Math.max(1, Math.abs(b), Math.abs(f)) &&
        Math.abs(d - h) <= n.EPSILON * Math.max(1, Math.abs(d), Math.abs(h)) &&
        Math.abs(e - g) <= n.EPSILON * Math.max(1, Math.abs(e), Math.abs(g)) &&
        Math.abs(a - c) <= n.EPSILON * Math.max(1, Math.abs(a), Math.abs(c))
      );
    };
    b.forEach = b.sqrLen = b.len = b.sqrDist = b.dist = b.div = b.mul = b.sub = void 0;
    var n = (function (a) {
      if (a && a.__esModule) return a;
      var c = {};
      if (null != a)
        for (var b in a)
          if (Object.prototype.hasOwnProperty.call(a, b)) {
            var d = ra && pa ? pa(a, b) : {};
            d.get || d.set ? ra(c, b, d) : (c[b] = a[b]);
          }
      c.default = a;
      return c;
    })(Za);
    b.sub = a;
    b.mul = c;
    b.div = f;
    b.dist = h;
    b.sqrDist = g;
    b.len = k;
    b.sqrLen = l;
    e = (function () {
      var a = d();
      return function (c, b, d, e, f, h) {
        b || (b = 4);
        d || (d = 0);
        for (e = e ? Math.min(e * b + d, c.length) : c.length; d < e; d += b)
          (a[0] = c[d]), (a[1] = c[d + 1]), (a[2] = c[d + 2]), (a[3] = c[d + 3]), f(a, a, h), (c[d] = a[0]), (c[d + 1] = a[1]), (c[d + 2] = a[2]), (c[d + 3] = a[3]);
        return c;
      };
    })();
    b.forEach = e;
  });
  Y(lf);
  var mf = U(function (e, b) {
    function d(a) {
      if (a && a.__esModule) return a;
      var c = {};
      if (null != a)
        for (var b in a)
          if (Object.prototype.hasOwnProperty.call(a, b)) {
            var d = ra && pa ? pa(a, b) : {};
            d.get || d.set ? ra(c, b, d) : (c[b] = a[b]);
          }
      c.default = a;
      return c;
    }
    function a() {
      var a = new k.ARRAY_TYPE(4);
      k.ARRAY_TYPE != Float32Array && ((a[0] = 0), (a[1] = 0), (a[2] = 0));
      a[3] = 1;
      return a;
    }
    function c(a, c, b) {
      b *= 0.5;
      var d = Math.sin(b);
      a[0] = d * c[0];
      a[1] = d * c[1];
      a[2] = d * c[2];
      a[3] = Math.cos(b);
      return a;
    }
    function f(a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2];
      c = c[3];
      var h = b[0],
        g = b[1],
        k = b[2];
      b = b[3];
      a[0] = d * b + c * h + e * k - f * g;
      a[1] = e * b + c * g + f * h - d * k;
      a[2] = f * b + c * k + d * g - e * h;
      a[3] = c * b - d * h - e * g - f * k;
      return a;
    }
    function h(a, c, b, d) {
      var e = c[0],
        f = c[1],
        h = c[2];
      c = c[3];
      var g = b[0],
        m = b[1],
        p = b[2];
      b = b[3];
      var l = e * g + f * m + h * p + c * b;
      0 > l && ((l = -l), (g = -g), (m = -m), (p = -p), (b = -b));
      if (1 - l > k.EPSILON) {
        var q = Math.acos(l);
        var n = Math.sin(q);
        l = Math.sin((1 - d) * q) / n;
        d = Math.sin(d * q) / n;
      } else l = 1 - d;
      a[0] = l * e + d * g;
      a[1] = l * f + d * m;
      a[2] = l * h + d * p;
      a[3] = l * c + d * b;
      return a;
    }
    function g(a, c) {
      var b = c[0] + c[4] + c[8];
      if (0 < b) (b = Math.sqrt(b + 1)), (a[3] = 0.5 * b), (b = 0.5 / b), (a[0] = (c[5] - c[7]) * b), (a[1] = (c[6] - c[2]) * b), (a[2] = (c[1] - c[3]) * b);
      else {
        var d = 0;
        c[4] > c[0] && (d = 1);
        c[8] > c[3 * d + d] && (d = 2);
        var e = (d + 1) % 3,
          f = (d + 2) % 3;
        b = Math.sqrt(c[3 * d + d] - c[3 * e + e] - c[3 * f + f] + 1);
        a[d] = 0.5 * b;
        b = 0.5 / b;
        a[3] = (c[3 * e + f] - c[3 * f + e]) * b;
        a[e] = (c[3 * e + d] + c[3 * d + e]) * b;
        a[f] = (c[3 * f + d] + c[3 * d + f]) * b;
      }
      return a;
    }
    Object.defineProperty(b, "__esModule", { value: !0 });
    b.create = a;
    b.identity = function (a) {
      a[0] = 0;
      a[1] = 0;
      a[2] = 0;
      a[3] = 1;
      return a;
    };
    b.setAxisAngle = c;
    b.getAxisAngle = function (a, c) {
      var b = 2 * Math.acos(c[3]),
        d = Math.sin(b / 2);
      d > k.EPSILON ? ((a[0] = c[0] / d), (a[1] = c[1] / d), (a[2] = c[2] / d)) : ((a[0] = 1), (a[1] = 0), (a[2] = 0));
      return b;
    };
    b.multiply = f;
    b.rotateX = function (a, c, b) {
      b *= 0.5;
      var d = c[0],
        e = c[1],
        f = c[2];
      c = c[3];
      var h = Math.sin(b);
      b = Math.cos(b);
      a[0] = d * b + c * h;
      a[1] = e * b + f * h;
      a[2] = f * b - e * h;
      a[3] = c * b - d * h;
      return a;
    };
    b.rotateY = function (a, c, b) {
      b *= 0.5;
      var d = c[0],
        e = c[1],
        f = c[2];
      c = c[3];
      var h = Math.sin(b);
      b = Math.cos(b);
      a[0] = d * b - f * h;
      a[1] = e * b + c * h;
      a[2] = f * b + d * h;
      a[3] = c * b - e * h;
      return a;
    };
    b.rotateZ = function (a, c, b) {
      b *= 0.5;
      var d = c[0],
        e = c[1],
        f = c[2];
      c = c[3];
      var h = Math.sin(b);
      b = Math.cos(b);
      a[0] = d * b + e * h;
      a[1] = e * b - d * h;
      a[2] = f * b + c * h;
      a[3] = c * b - f * h;
      return a;
    };
    b.calculateW = function (a, c) {
      var b = c[0],
        d = c[1];
      c = c[2];
      a[0] = b;
      a[1] = d;
      a[2] = c;
      a[3] = Math.sqrt(Math.abs(1 - b * b - d * d - c * c));
      return a;
    };
    b.slerp = h;
    b.random = function (a) {
      var c = k.RANDOM(),
        b = k.RANDOM(),
        d = k.RANDOM(),
        e = Math.sqrt(1 - c);
      c = Math.sqrt(c);
      a[0] = e * Math.sin(2 * Math.PI * b);
      a[1] = e * Math.cos(2 * Math.PI * b);
      a[2] = c * Math.sin(2 * Math.PI * d);
      a[3] = c * Math.cos(2 * Math.PI * d);
      return a;
    };
    b.invert = function (a, c) {
      var b = c[0],
        d = c[1],
        e = c[2];
      c = c[3];
      var f = b * b + d * d + e * e + c * c;
      f = f ? 1 / f : 0;
      a[0] = -b * f;
      a[1] = -d * f;
      a[2] = -e * f;
      a[3] = c * f;
      return a;
    };
    b.conjugate = function (a, c) {
      a[0] = -c[0];
      a[1] = -c[1];
      a[2] = -c[2];
      a[3] = c[3];
      return a;
    };
    b.fromMat3 = g;
    b.fromEuler = function (a, c, b, d) {
      var e = (0.5 * Math.PI) / 180;
      c *= e;
      b *= e;
      d *= e;
      e = Math.sin(c);
      c = Math.cos(c);
      var f = Math.sin(b);
      b = Math.cos(b);
      var h = Math.sin(d);
      d = Math.cos(d);
      a[0] = e * b * d - c * f * h;
      a[1] = c * f * d + e * b * h;
      a[2] = c * b * h - e * f * d;
      a[3] = c * b * d + e * f * h;
      return a;
    };
    b.str = function (a) {
      return "quat(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
    };
    b.setAxes =
      b.sqlerp =
      b.rotationTo =
      b.equals =
      b.exactEquals =
      b.normalize =
      b.sqrLen =
      b.squaredLength =
      b.len =
      b.length =
      b.lerp =
      b.dot =
      b.scale =
      b.mul =
      b.add =
      b.set =
      b.copy =
      b.fromValues =
      b.clone =
        void 0;
    var k = d(Za),
      l = d(hf),
      n = d(kf);
    e = d(lf);
    b.clone = e.clone;
    b.fromValues = e.fromValues;
    b.copy = e.copy;
    b.set = e.set;
    b.add = e.add;
    b.mul = f;
    b.scale = e.scale;
    b.dot = e.dot;
    b.lerp = e.lerp;
    var m = e.length;
    b.length = m;
    b.len = m;
    m = e.squaredLength;
    b.squaredLength = m;
    b.sqrLen = m;
    var p = e.normalize;
    b.normalize = p;
    b.exactEquals = e.exactEquals;
    b.equals = e.equals;
    e = (function () {
      var a = n.create(),
        b = n.fromValues(1, 0, 0),
        d = n.fromValues(0, 1, 0);
      return function (e, f, h) {
        var g = n.dot(f, h);
        if (-0.999999 > g) return n.cross(a, b, f), 1e-6 > n.len(a) && n.cross(a, d, f), n.normalize(a, a), c(e, a, Math.PI), e;
        if (0.999999 < g) return (e[0] = 0), (e[1] = 0), (e[2] = 0), (e[3] = 1), e;
        n.cross(a, f, h);
        e[0] = a[0];
        e[1] = a[1];
        e[2] = a[2];
        e[3] = 1 + g;
        return p(e, e);
      };
    })();
    b.rotationTo = e;
    e = (function () {
      var c = a(),
        b = a();
      return function (a, d, e, f, g, k) {
        h(c, d, g, k);
        h(b, e, f, k);
        h(a, c, b, 2 * k * (1 - k));
        return a;
      };
    })();
    b.sqlerp = e;
    e = (function () {
      var a = l.create();
      return function (c, b, d, e) {
        a[0] = d[0];
        a[3] = d[1];
        a[6] = d[2];
        a[1] = e[0];
        a[4] = e[1];
        a[7] = e[2];
        a[2] = -b[0];
        a[5] = -b[1];
        a[8] = -b[2];
        return p(c, g(c, a));
      };
    })();
    b.setAxes = e;
  });
  Y(mf);
  var Qh = U(function (e, b) {
    function d(a) {
      if (a && a.__esModule) return a;
      var c = {};
      if (null != a)
        for (var b in a)
          if (Object.prototype.hasOwnProperty.call(a, b)) {
            var d = ra && pa ? pa(a, b) : {};
            d.get || d.set ? ra(c, b, d) : (c[b] = a[b]);
          }
      c.default = a;
      return c;
    }
    function a(a, c, b) {
      var d = 0.5 * b[0],
        e = 0.5 * b[1];
      b = 0.5 * b[2];
      var f = c[0],
        h = c[1],
        g = c[2];
      c = c[3];
      a[0] = f;
      a[1] = h;
      a[2] = g;
      a[3] = c;
      a[4] = d * c + e * g - b * h;
      a[5] = e * c + b * f - d * g;
      a[6] = b * c + d * h - e * f;
      a[7] = -d * f - e * h - b * g;
      return a;
    }
    function c(a, c) {
      a[0] = c[0];
      a[1] = c[1];
      a[2] = c[2];
      a[3] = c[3];
      a[4] = c[4];
      a[5] = c[5];
      a[6] = c[6];
      a[7] = c[7];
      return a;
    }
    function f(a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2],
        h = c[3],
        g = b[4],
        k = b[5],
        m = b[6],
        p = b[7],
        l = c[4],
        n = c[5],
        q = c[6];
      c = c[7];
      var J = b[0],
        G = b[1],
        M = b[2];
      b = b[3];
      a[0] = d * b + h * J + e * M - f * G;
      a[1] = e * b + h * G + f * J - d * M;
      a[2] = f * b + h * M + d * G - e * J;
      a[3] = h * b - d * J - e * G - f * M;
      a[4] = d * p + h * g + e * m - f * k + l * b + c * J + n * M - q * G;
      a[5] = e * p + h * k + f * g - d * m + n * b + c * G + q * J - l * M;
      a[6] = f * p + h * m + d * k - e * g + q * b + c * M + l * G - n * J;
      a[7] = h * p - d * g - e * k - f * m + c * b - l * J - n * G - q * M;
      return a;
    }
    Object.defineProperty(b, "__esModule", { value: !0 });
    b.create = function () {
      var a = new h.ARRAY_TYPE(8);
      h.ARRAY_TYPE != Float32Array && ((a[0] = 0), (a[1] = 0), (a[2] = 0), (a[4] = 0), (a[5] = 0), (a[6] = 0), (a[7] = 0));
      a[3] = 1;
      return a;
    };
    b.clone = function (a) {
      var c = new h.ARRAY_TYPE(8);
      c[0] = a[0];
      c[1] = a[1];
      c[2] = a[2];
      c[3] = a[3];
      c[4] = a[4];
      c[5] = a[5];
      c[6] = a[6];
      c[7] = a[7];
      return c;
    };
    b.fromValues = function (a, c, b, d, e, f, g, k) {
      var m = new h.ARRAY_TYPE(8);
      m[0] = a;
      m[1] = c;
      m[2] = b;
      m[3] = d;
      m[4] = e;
      m[5] = f;
      m[6] = g;
      m[7] = k;
      return m;
    };
    b.fromRotationTranslationValues = function (a, c, b, d, e, f, g) {
      var k = new h.ARRAY_TYPE(8);
      k[0] = a;
      k[1] = c;
      k[2] = b;
      k[3] = d;
      e *= 0.5;
      f *= 0.5;
      g *= 0.5;
      k[4] = e * d + f * b - g * c;
      k[5] = f * d + g * a - e * b;
      k[6] = g * d + e * c - f * a;
      k[7] = -e * a - f * c - g * b;
      return k;
    };
    b.fromRotationTranslation = a;
    b.fromTranslation = function (a, c) {
      a[0] = 0;
      a[1] = 0;
      a[2] = 0;
      a[3] = 1;
      a[4] = 0.5 * c[0];
      a[5] = 0.5 * c[1];
      a[6] = 0.5 * c[2];
      a[7] = 0;
      return a;
    };
    b.fromRotation = function (a, c) {
      a[0] = c[0];
      a[1] = c[1];
      a[2] = c[2];
      a[3] = c[3];
      a[4] = 0;
      a[5] = 0;
      a[6] = 0;
      a[7] = 0;
      return a;
    };
    b.fromMat4 = function (c, b) {
      var d = g.create();
      k.getRotation(d, b);
      var e = new h.ARRAY_TYPE(3);
      k.getTranslation(e, b);
      a(c, d, e);
      return c;
    };
    b.copy = c;
    b.identity = function (a) {
      a[0] = 0;
      a[1] = 0;
      a[2] = 0;
      a[3] = 1;
      a[4] = 0;
      a[5] = 0;
      a[6] = 0;
      a[7] = 0;
      return a;
    };
    b.set = function (a, c, b, d, e, f, h, g, k) {
      a[0] = c;
      a[1] = b;
      a[2] = d;
      a[3] = e;
      a[4] = f;
      a[5] = h;
      a[6] = g;
      a[7] = k;
      return a;
    };
    b.getDual = function (a, c) {
      a[0] = c[4];
      a[1] = c[5];
      a[2] = c[6];
      a[3] = c[7];
      return a;
    };
    b.setDual = function (a, c) {
      a[4] = c[0];
      a[5] = c[1];
      a[6] = c[2];
      a[7] = c[3];
      return a;
    };
    b.getTranslation = function (a, c) {
      var b = c[4],
        d = c[5],
        e = c[6],
        f = c[7],
        h = -c[0],
        g = -c[1],
        k = -c[2];
      c = c[3];
      a[0] = 2 * (b * c + f * h + d * k - e * g);
      a[1] = 2 * (d * c + f * g + e * h - b * k);
      a[2] = 2 * (e * c + f * k + b * g - d * h);
      return a;
    };
    b.translate = function (a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2],
        h = c[3],
        g = 0.5 * b[0],
        k = 0.5 * b[1];
      b = 0.5 * b[2];
      var m = c[4],
        p = c[5],
        l = c[6];
      c = c[7];
      a[0] = d;
      a[1] = e;
      a[2] = f;
      a[3] = h;
      a[4] = h * g + e * b - f * k + m;
      a[5] = h * k + f * g - d * b + p;
      a[6] = h * b + d * k - e * g + l;
      a[7] = -d * g - e * k - f * b + c;
      return a;
    };
    b.rotateX = function (a, c, b) {
      var d = -c[0],
        e = -c[1],
        f = -c[2],
        h = c[3],
        k = c[4],
        m = c[5],
        p = c[6],
        l = c[7],
        n = k * h + l * d + m * f - p * e,
        q = m * h + l * e + p * d - k * f,
        E = p * h + l * f + k * e - m * d;
      k = l * h - k * d - m * e - p * f;
      g.rotateX(a, c, b);
      d = a[0];
      e = a[1];
      f = a[2];
      h = a[3];
      a[4] = n * h + k * d + q * f - E * e;
      a[5] = q * h + k * e + E * d - n * f;
      a[6] = E * h + k * f + n * e - q * d;
      a[7] = k * h - n * d - q * e - E * f;
      return a;
    };
    b.rotateY = function (a, c, b) {
      var d = -c[0],
        e = -c[1],
        f = -c[2],
        h = c[3],
        k = c[4],
        m = c[5],
        p = c[6],
        l = c[7],
        n = k * h + l * d + m * f - p * e,
        q = m * h + l * e + p * d - k * f,
        E = p * h + l * f + k * e - m * d;
      k = l * h - k * d - m * e - p * f;
      g.rotateY(a, c, b);
      d = a[0];
      e = a[1];
      f = a[2];
      h = a[3];
      a[4] = n * h + k * d + q * f - E * e;
      a[5] = q * h + k * e + E * d - n * f;
      a[6] = E * h + k * f + n * e - q * d;
      a[7] = k * h - n * d - q * e - E * f;
      return a;
    };
    b.rotateZ = function (a, c, b) {
      var d = -c[0],
        e = -c[1],
        f = -c[2],
        h = c[3],
        k = c[4],
        m = c[5],
        p = c[6],
        l = c[7],
        n = k * h + l * d + m * f - p * e,
        q = m * h + l * e + p * d - k * f,
        E = p * h + l * f + k * e - m * d;
      k = l * h - k * d - m * e - p * f;
      g.rotateZ(a, c, b);
      d = a[0];
      e = a[1];
      f = a[2];
      h = a[3];
      a[4] = n * h + k * d + q * f - E * e;
      a[5] = q * h + k * e + E * d - n * f;
      a[6] = E * h + k * f + n * e - q * d;
      a[7] = k * h - n * d - q * e - E * f;
      return a;
    };
    b.rotateByQuatAppend = function (a, c, b) {
      var d = b[0],
        e = b[1],
        f = b[2];
      b = b[3];
      var h = c[0],
        g = c[1],
        k = c[2],
        m = c[3];
      a[0] = h * b + m * d + g * f - k * e;
      a[1] = g * b + m * e + k * d - h * f;
      a[2] = k * b + m * f + h * e - g * d;
      a[3] = m * b - h * d - g * e - k * f;
      h = c[4];
      g = c[5];
      k = c[6];
      m = c[7];
      a[4] = h * b + m * d + g * f - k * e;
      a[5] = g * b + m * e + k * d - h * f;
      a[6] = k * b + m * f + h * e - g * d;
      a[7] = m * b - h * d - g * e - k * f;
      return a;
    };
    b.rotateByQuatPrepend = function (a, c, b) {
      var d = c[0],
        e = c[1],
        f = c[2];
      c = c[3];
      var h = b[0],
        g = b[1],
        k = b[2],
        m = b[3];
      a[0] = d * m + c * h + e * k - f * g;
      a[1] = e * m + c * g + f * h - d * k;
      a[2] = f * m + c * k + d * g - e * h;
      a[3] = c * m - d * h - e * g - f * k;
      h = b[4];
      g = b[5];
      k = b[6];
      m = b[7];
      a[4] = d * m + c * h + e * k - f * g;
      a[5] = e * m + c * g + f * h - d * k;
      a[6] = f * m + c * k + d * g - e * h;
      a[7] = c * m - d * h - e * g - f * k;
      return a;
    };
    b.rotateAroundAxis = function (a, b, d, e) {
      if (Math.abs(e) < h.EPSILON) return c(a, b);
      var f = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
      e *= 0.5;
      var g = Math.sin(e),
        k = (g * d[0]) / f,
        m = (g * d[1]) / f;
      d = (g * d[2]) / f;
      e = Math.cos(e);
      f = b[0];
      g = b[1];
      var p = b[2],
        l = b[3];
      a[0] = f * e + l * k + g * d - p * m;
      a[1] = g * e + l * m + p * k - f * d;
      a[2] = p * e + l * d + f * m - g * k;
      a[3] = l * e - f * k - g * m - p * d;
      f = b[4];
      g = b[5];
      p = b[6];
      b = b[7];
      a[4] = f * e + b * k + g * d - p * m;
      a[5] = g * e + b * m + p * k - f * d;
      a[6] = p * e + b * d + f * m - g * k;
      a[7] = b * e - f * k - g * m - p * d;
      return a;
    };
    b.add = function (a, c, b) {
      a[0] = c[0] + b[0];
      a[1] = c[1] + b[1];
      a[2] = c[2] + b[2];
      a[3] = c[3] + b[3];
      a[4] = c[4] + b[4];
      a[5] = c[5] + b[5];
      a[6] = c[6] + b[6];
      a[7] = c[7] + b[7];
      return a;
    };
    b.multiply = f;
    b.scale = function (a, c, b) {
      a[0] = c[0] * b;
      a[1] = c[1] * b;
      a[2] = c[2] * b;
      a[3] = c[3] * b;
      a[4] = c[4] * b;
      a[5] = c[5] * b;
      a[6] = c[6] * b;
      a[7] = c[7] * b;
      return a;
    };
    b.lerp = function (a, c, b, d) {
      var e = 1 - d;
      0 > l(c, b) && (d = -d);
      a[0] = c[0] * e + b[0] * d;
      a[1] = c[1] * e + b[1] * d;
      a[2] = c[2] * e + b[2] * d;
      a[3] = c[3] * e + b[3] * d;
      a[4] = c[4] * e + b[4] * d;
      a[5] = c[5] * e + b[5] * d;
      a[6] = c[6] * e + b[6] * d;
      a[7] = c[7] * e + b[7] * d;
      return a;
    };
    b.invert = function (a, c) {
      var b = n(c);
      a[0] = -c[0] / b;
      a[1] = -c[1] / b;
      a[2] = -c[2] / b;
      a[3] = c[3] / b;
      a[4] = -c[4] / b;
      a[5] = -c[5] / b;
      a[6] = -c[6] / b;
      a[7] = c[7] / b;
      return a;
    };
    b.conjugate = function (a, c) {
      a[0] = -c[0];
      a[1] = -c[1];
      a[2] = -c[2];
      a[3] = c[3];
      a[4] = -c[4];
      a[5] = -c[5];
      a[6] = -c[6];
      a[7] = c[7];
      return a;
    };
    b.normalize = function (a, c) {
      var b = n(c);
      if (0 < b) {
        b = Math.sqrt(b);
        var d = c[0] / b,
          e = c[1] / b,
          f = c[2] / b,
          h = c[3] / b,
          g = c[4],
          k = c[5],
          m = c[6];
        c = c[7];
        var l = d * g + e * k + f * m + h * c;
        a[0] = d;
        a[1] = e;
        a[2] = f;
        a[3] = h;
        a[4] = (g - d * l) / b;
        a[5] = (k - e * l) / b;
        a[6] = (m - f * l) / b;
        a[7] = (c - h * l) / b;
      }
      return a;
    };
    b.str = function (a) {
      return "quat2(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ")";
    };
    b.exactEquals = function (a, c) {
      return a[0] === c[0] && a[1] === c[1] && a[2] === c[2] && a[3] === c[3] && a[4] === c[4] && a[5] === c[5] && a[6] === c[6] && a[7] === c[7];
    };
    b.equals = function (a, c) {
      var b = a[0],
        d = a[1],
        e = a[2],
        f = a[3],
        g = a[4],
        k = a[5],
        m = a[6];
      a = a[7];
      var l = c[0],
        p = c[1],
        n = c[2],
        A = c[3],
        E = c[4],
        J = c[5],
        G = c[6];
      c = c[7];
      return (
        Math.abs(b - l) <= h.EPSILON * Math.max(1, Math.abs(b), Math.abs(l)) &&
        Math.abs(d - p) <= h.EPSILON * Math.max(1, Math.abs(d), Math.abs(p)) &&
        Math.abs(e - n) <= h.EPSILON * Math.max(1, Math.abs(e), Math.abs(n)) &&
        Math.abs(f - A) <= h.EPSILON * Math.max(1, Math.abs(f), Math.abs(A)) &&
        Math.abs(g - E) <= h.EPSILON * Math.max(1, Math.abs(g), Math.abs(E)) &&
        Math.abs(k - J) <= h.EPSILON * Math.max(1, Math.abs(k), Math.abs(J)) &&
        Math.abs(m - G) <= h.EPSILON * Math.max(1, Math.abs(m), Math.abs(G)) &&
        Math.abs(a - c) <= h.EPSILON * Math.max(1, Math.abs(a), Math.abs(c))
      );
    };
    b.sqrLen = b.squaredLength = b.len = b.length = b.dot = b.mul = b.setReal = b.getReal = void 0;
    var h = d(Za),
      g = d(mf),
      k = d(jf);
    b.getReal = g.copy;
    b.setReal = g.copy;
    b.mul = f;
    var l = g.dot;
    b.dot = l;
    e = g.length;
    b.length = e;
    b.len = e;
    var n = g.squaredLength;
    b.squaredLength = n;
    b.sqrLen = n;
  });
  Y(Qh);
  var Rh = U(function (e, b) {
    function d() {
      var a = new n.ARRAY_TYPE(2);
      n.ARRAY_TYPE != Float32Array && ((a[0] = 0), (a[1] = 0));
      return a;
    }
    function a(a, c, b) {
      a[0] = c[0] - b[0];
      a[1] = c[1] - b[1];
      return a;
    }
    function c(a, c, b) {
      a[0] = c[0] * b[0];
      a[1] = c[1] * b[1];
      return a;
    }
    function f(a, c, b) {
      a[0] = c[0] / b[0];
      a[1] = c[1] / b[1];
      return a;
    }
    function h(a, c) {
      var b = c[0] - a[0];
      a = c[1] - a[1];
      return Math.sqrt(b * b + a * a);
    }
    function g(a, c) {
      var b = c[0] - a[0];
      a = c[1] - a[1];
      return b * b + a * a;
    }
    function k(a) {
      var c = a[0];
      a = a[1];
      return Math.sqrt(c * c + a * a);
    }
    function l(a) {
      var c = a[0];
      a = a[1];
      return c * c + a * a;
    }
    Object.defineProperty(b, "__esModule", { value: !0 });
    b.create = d;
    b.clone = function (a) {
      var c = new n.ARRAY_TYPE(2);
      c[0] = a[0];
      c[1] = a[1];
      return c;
    };
    b.fromValues = function (a, c) {
      var b = new n.ARRAY_TYPE(2);
      b[0] = a;
      b[1] = c;
      return b;
    };
    b.copy = function (a, c) {
      a[0] = c[0];
      a[1] = c[1];
      return a;
    };
    b.set = function (a, c, b) {
      a[0] = c;
      a[1] = b;
      return a;
    };
    b.add = function (a, c, b) {
      a[0] = c[0] + b[0];
      a[1] = c[1] + b[1];
      return a;
    };
    b.subtract = a;
    b.multiply = c;
    b.divide = f;
    b.ceil = function (a, c) {
      a[0] = Math.ceil(c[0]);
      a[1] = Math.ceil(c[1]);
      return a;
    };
    b.floor = function (a, c) {
      a[0] = Math.floor(c[0]);
      a[1] = Math.floor(c[1]);
      return a;
    };
    b.min = function (a, c, b) {
      a[0] = Math.min(c[0], b[0]);
      a[1] = Math.min(c[1], b[1]);
      return a;
    };
    b.max = function (a, c, b) {
      a[0] = Math.max(c[0], b[0]);
      a[1] = Math.max(c[1], b[1]);
      return a;
    };
    b.round = function (a, c) {
      a[0] = Math.round(c[0]);
      a[1] = Math.round(c[1]);
      return a;
    };
    b.scale = function (a, c, b) {
      a[0] = c[0] * b;
      a[1] = c[1] * b;
      return a;
    };
    b.scaleAndAdd = function (a, c, b, d) {
      a[0] = c[0] + b[0] * d;
      a[1] = c[1] + b[1] * d;
      return a;
    };
    b.distance = h;
    b.squaredDistance = g;
    b.length = k;
    b.squaredLength = l;
    b.negate = function (a, c) {
      a[0] = -c[0];
      a[1] = -c[1];
      return a;
    };
    b.inverse = function (a, c) {
      a[0] = 1 / c[0];
      a[1] = 1 / c[1];
      return a;
    };
    b.normalize = function (a, c) {
      var b = c[0],
        d = c[1];
      b = b * b + d * d;
      0 < b && (b = 1 / Math.sqrt(b));
      a[0] = c[0] * b;
      a[1] = c[1] * b;
      return a;
    };
    b.dot = function (a, c) {
      return a[0] * c[0] + a[1] * c[1];
    };
    b.cross = function (a, c, b) {
      c = c[0] * b[1] - c[1] * b[0];
      a[0] = a[1] = 0;
      a[2] = c;
      return a;
    };
    b.lerp = function (a, c, b, d) {
      var e = c[0];
      c = c[1];
      a[0] = e + d * (b[0] - e);
      a[1] = c + d * (b[1] - c);
      return a;
    };
    b.random = function (a, c) {
      c = c || 1;
      var b = 2 * n.RANDOM() * Math.PI;
      a[0] = Math.cos(b) * c;
      a[1] = Math.sin(b) * c;
      return a;
    };
    b.transformMat2 = function (a, c, b) {
      var d = c[0];
      c = c[1];
      a[0] = b[0] * d + b[2] * c;
      a[1] = b[1] * d + b[3] * c;
      return a;
    };
    b.transformMat2d = function (a, c, b) {
      var d = c[0];
      c = c[1];
      a[0] = b[0] * d + b[2] * c + b[4];
      a[1] = b[1] * d + b[3] * c + b[5];
      return a;
    };
    b.transformMat3 = function (a, c, b) {
      var d = c[0];
      c = c[1];
      a[0] = b[0] * d + b[3] * c + b[6];
      a[1] = b[1] * d + b[4] * c + b[7];
      return a;
    };
    b.transformMat4 = function (a, c, b) {
      var d = c[0];
      c = c[1];
      a[0] = b[0] * d + b[4] * c + b[12];
      a[1] = b[1] * d + b[5] * c + b[13];
      return a;
    };
    b.rotate = function (a, c, b, d) {
      var e = c[0] - b[0];
      c = c[1] - b[1];
      var f = Math.sin(d);
      d = Math.cos(d);
      a[0] = e * d - c * f + b[0];
      a[1] = e * f + c * d + b[1];
      return a;
    };
    b.angle = function (a, c) {
      var b = a[0];
      a = a[1];
      var d = c[0];
      c = c[1];
      var e = b * b + a * a;
      0 < e && (e = 1 / Math.sqrt(e));
      var f = d * d + c * c;
      0 < f && (f = 1 / Math.sqrt(f));
      b = (b * d + a * c) * e * f;
      return 1 < b ? 0 : -1 > b ? Math.PI : Math.acos(b);
    };
    b.zero = function (a) {
      a[0] = 0;
      a[1] = 0;
      return a;
    };
    b.str = function (a) {
      return "vec2(" + a[0] + ", " + a[1] + ")";
    };
    b.exactEquals = function (a, c) {
      return a[0] === c[0] && a[1] === c[1];
    };
    b.equals = function (a, c) {
      var b = a[0];
      a = a[1];
      var d = c[0];
      c = c[1];
      return Math.abs(b - d) <= n.EPSILON * Math.max(1, Math.abs(b), Math.abs(d)) && Math.abs(a - c) <= n.EPSILON * Math.max(1, Math.abs(a), Math.abs(c));
    };
    b.forEach = b.sqrLen = b.sqrDist = b.dist = b.div = b.mul = b.sub = b.len = void 0;
    var n = (function (a) {
      if (a && a.__esModule) return a;
      var c = {};
      if (null != a)
        for (var b in a)
          if (Object.prototype.hasOwnProperty.call(a, b)) {
            var d = ra && pa ? pa(a, b) : {};
            d.get || d.set ? ra(c, b, d) : (c[b] = a[b]);
          }
      c.default = a;
      return c;
    })(Za);
    b.len = k;
    b.sub = a;
    b.mul = c;
    b.div = f;
    b.dist = h;
    b.sqrDist = g;
    b.sqrLen = l;
    e = (function () {
      var a = d();
      return function (c, b, d, e, f, h) {
        b || (b = 2);
        d || (d = 0);
        for (e = e ? Math.min(e * b + d, c.length) : c.length; d < e; d += b) (a[0] = c[d]), (a[1] = c[d + 1]), f(a, a, h), (c[d] = a[0]), (c[d + 1] = a[1]);
        return c;
      };
    })();
    b.forEach = e;
  });
  Y(Rh);
  var Ua = U(function (e, b) {
    function d(a) {
      if (a && a.__esModule) return a;
      var c = {};
      if (null != a)
        for (var b in a)
          if (Object.prototype.hasOwnProperty.call(a, b)) {
            var d = ra && pa ? pa(a, b) : {};
            d.get || d.set ? ra(c, b, d) : (c[b] = a[b]);
          }
      c.default = a;
      return c;
    }
    Object.defineProperty(b, "__esModule", { value: !0 });
    b.vec4 = b.vec3 = b.vec2 = b.quat2 = b.quat = b.mat4 = b.mat3 = b.mat2d = b.mat2 = b.glMatrix = void 0;
    e = d(Za);
    b.glMatrix = e;
    e = d(Oh);
    b.mat2 = e;
    e = d(Ph);
    b.mat2d = e;
    e = d(hf);
    b.mat3 = e;
    e = d(jf);
    b.mat4 = e;
    e = d(mf);
    b.quat = e;
    e = d(Qh);
    b.quat2 = e;
    e = d(Rh);
    b.vec2 = e;
    e = d(kf);
    b.vec3 = e;
    e = d(lf);
    b.vec4 = e;
  });
  Y(Ua);
  var na = Ua.vec4,
    P = Ua.vec3,
    Z = Ua.vec2,
    Xk = Ua.quat2,
    Ed = Ua.quat,
    L = Ua.mat4,
    Yk = Ua.mat3,
    Zk = Ua.mat2d,
    $k = Ua.mat2,
    al = Ua.glMatrix,
    X = (function () {
      function e(b, d, a) {
        F(this, e);
        this.options = d;
        this.gl = b;
        a && (this.map = a.map);
        a = this.getVertexShader(d.vertexShader);
        var c = this.getFragmentShader(d.fragmentShader);
        d = b.createShader(b.VERTEX_SHADER);
        b.shaderSource(d, a);
        b.compileShader(d);
        b.getShaderParameter(d, b.COMPILE_STATUS)
          ? ((a = b.createShader(b.FRAGMENT_SHADER)),
            b.shaderSource(a, c),
            b.compileShader(a),
            b.getShaderParameter(a, b.COMPILE_STATUS)
              ? ((c = b.createProgram()),
                b.attachShader(c, d),
                b.attachShader(c, a),
                b.deleteShader(d),
                b.deleteShader(a),
                b.linkProgram(c),
                b.getProgramParameter(c, b.LINK_STATUS)
                  ? (d = c)
                  : ((d = "Shader program failed to link.  The error log is:" + b.getProgramInfoLog(c)), console.error(d), (d = -1)))
              : ((d = "Fragment shader failed to compile.  The error log is:" + b.getShaderInfoLog(a)), console.error(d), (d = -1)))
          : ((d = "Vertex shader failed to compile.  The error log is:" + b.getShaderInfoLog(d)), console.error(d), (d = -1));
        d = this.program = d;
        a = {};
        c = b.getProgramParameter(d, b.ACTIVE_ATTRIBUTES);
        for (var f = 0; f < c; f++) {
          var h = b.getActiveAttrib(d, f);
          a[h.name] = b.getAttribLocation(d, h.name);
        }
        f = {};
        h = {};
        for (var g = b.getProgramParameter(d, b.ACTIVE_UNIFORMS), k = 0; k < g; k++) {
          var l = b.getActiveUniform(d, k);
          f[l.name] = b.getUniformLocation(d, l.name);
          h[l.name] = l.type;
        }
        this.parameter = b = { attributes: a, numAttributes: c, uniformsType: h, uniforms: f };
        this.attributes = b.attributes;
        this.uniforms = b.uniforms;
        this.parameter = b;
      }
      I(e, [
        {
          key: "getVertexShader",
          value: function (b) {
            var d = "";
            this.map && "cesium" === this.map.type && (d = "#define LOG_DEPTH\n");
            d +=
              "#ifdef LOG_DEPTH\nuniform float currentFrustumX;varying float v_depthFromNearPlusOne;\n#endif\nuniform vec2 MAPV_resolution;\n#if defined(PICK)\nuniform bool uIsPickRender;attribute vec3 aPickColor;uniform vec3 uPickedColor;varying vec4 vPickColor;uniform bool uEnablePicked;bool mapvIsPicked(){return uEnablePicked&&aPickColor==uPickedColor;}\n#endif\nvoid afterMain(){\n#if defined(LOG_DEPTH)\nv_depthFromNearPlusOne=(gl_Position.w-currentFrustumX)+1.0;gl_Position.z=clamp(gl_Position.z/gl_Position.w,-1.0,1.0)*gl_Position.w;\n#endif\n#if defined(PICK)\nvPickColor=vec4(aPickColor,0.0);if(mapvIsPicked()){vPickColor.a=1.0;}\n#endif\n}";
            b = this.getDefines() + d + b;
            b = b.replace("void main", "void originMain");
            return b + "void main() {originMain(); afterMain();}";
          }
        },
        {
          key: "getFragmentShader",
          value: function (b) {
            var d = "";
            this.map && "cesium" === this.map.type && (d = "#define LOG_DEPTH\n");
            d +=
              "#if defined(LOG_DEPTH)\n#extension GL_EXT_frag_depth : enable\n#endif\nprecision highp float;uniform vec2 MAPV_resolution;uniform bool uIsPickRender;\n#if defined(PICK)\nvarying vec4 vPickColor;bool mapvIsPicked(){return vPickColor.a==1.0;}\n#endif\n#if defined(LOG_DEPTH)\nuniform float oneOverLog2FarDepthFromNearPlusOne;uniform float farDepthFromNearPlusOne;varying float v_depthFromNearPlusOne;void writeLogDepth(float depth){if(depth<=0.9999999||depth>farDepthFromNearPlusOne){discard;}gl_FragDepthEXT=log2(depth)*oneOverLog2FarDepthFromNearPlusOne;}\n#endif\nvoid afterMain(){\n#if defined(PICK)\nif(uIsPickRender){gl_FragColor=vec4(vPickColor.rgb,1.0);return;}\n#endif\n#if defined(LOG_DEPTH)\nwriteLogDepth(v_depthFromNearPlusOne);\n#endif\n}";
            b = this.getDefines() + d + b;
            b = b.replace("void main", "void originMain");
            return b + "void main() {originMain(); afterMain();}";
          }
        },
        {
          key: "getDefines",
          value: function () {
            var b = "",
              d = this.options.defines;
            if (d) for (var a = 0; a < d.length; a++) b += "#define " + d[a] + "\n";
            return b;
          }
        },
        {
          key: "use",
          value: function (b, d) {
            this.gl = b;
            b.useProgram(this.program);
            this.map &&
              "cesium" === this.map.type &&
              this.setUniforms({
                currentFrustumX: this.map.map.scene.camera.frustum.near,
                oneOverLog2FarDepthFromNearPlusOne: this.map.map.scene.context.uniformState.oneOverLog2FarDepthFromNearPlusOne,
                farDepthFromNearPlusOne: this.map.map.scene.context.uniformState.farDepthFromNearPlusOne
              });
            this.uniforms.MAPV_resolution && this.setUniforms({ MAPV_resolution: [b.canvas.width, b.canvas.height] });
          }
        },
        {
          key: "setUniform",
          value: function (b, d) {
            var a = this.gl,
              c = this.uniforms[b];
            if (c)
              switch (this.parameter.uniformsType[b]) {
                case a.FLOAT:
                  a.uniform1f(c, d);
                  break;
                case a.FLOAT_VEC2:
                  a.uniform2f(c, d[0], d[1]);
                  break;
                case a.FLOAT_VEC3:
                  a.uniform3f(c, d[0], d[1], d[2]);
                  break;
                case a.FLOAT_VEC4:
                  a.uniform4f(c, d[0], d[1], d[2], d[3]);
                  break;
                case a.SAMPLER_2D:
                case a.SAMPLER_CUBE:
                  a.activeTexture(a["TEXTURE" + this.textureIndex]);
                  a.uniform1i(c, this.textureIndex);
                  a.bindTexture(a.TEXTURE_2D, d);
                  this.textureIndex++;
                  break;
                case a.INT:
                case a.BOOL:
                  a.uniform1i(c, d);
                  break;
                case a.INT_VEC2:
                case a.BOOL_VEC2:
                  a.uniform2i(c, d[0], d[1]);
                  break;
                case a.INT_VEC3:
                case a.BOOL_VEC3:
                  a.uniform3i(c, d[0], d[1], d[2]);
                  break;
                case a.INT_VEC4:
                case a.BOOL_VEC4:
                  a.uniform4i(c, d[0], d[1], d[2], d[3]);
                  break;
                case a.FLOAT_MAT2:
                  a.uniformMatrix2fv(c, !1, d);
                  break;
                case a.FLOAT_MAT3:
                  a.uniformMatrix3fv(c, !1, d);
                  break;
                case a.FLOAT_MAT4:
                  a.uniformMatrix4fv(c, !1, d);
                  break;
                default:
                  console.error("Unrecognized uniform type: " + b);
              }
            else console.warn("Unrecognized uniform type: " + b);
          }
        },
        {
          key: "setUniforms",
          value: function (b) {
            this.textureIndex = 0;
            for (var d in b) this.setUniform(d, b[d]);
          }
        }
      ]);
      return e;
    })(),
    tb = function (e, b, d, a) {
      var c = d ? d.call(a, e, b) : void 0;
      if (void 0 !== c) return !!c;
      if (e === b) return !0;
      if ("object" !== ("undefined" === typeof e ? "undefined" : Ha(e)) || !e || "object" !== ("undefined" === typeof b ? "undefined" : Ha(b)) || !b) return !1;
      var f = qa(e),
        h = qa(b);
      if (f.length !== h.length) return !1;
      h = Object.prototype.hasOwnProperty.bind(b);
      for (var g = 0; g < f.length; g++) {
        c = f[g];
        if (!h(c)) return !1;
        var k = e[c],
          l = b[c];
        c = d ? d.call(a, k, l, c) : void 0;
        if (!1 === c || (void 0 === c && k !== l)) return !1;
      }
      return !0;
    },
    Sh = (function () {
      function e(b) {
        F(this, e);
        this.options = b;
        this.gl = b.gl;
        this.savedState = [];
        this.currentState = this.getDefaultState();
      }
      I(e, [
        {
          key: "setDefaultState",
          value: function () {
            this.setState();
          }
        },
        {
          key: "getDefaultState",
          value: function () {
            var b = this.gl;
            return {
              blend: !1,
              blendEquation: b.FUNC_ADD,
              blendFunc: [b.ONE, b.ZERO],
              depthMask: !0,
              depthTest: !0,
              depthFunc: b.LEQUAL,
              polygonOffset: [0, 0],
              cullFace: !1,
              stencilTest: !1
            };
          }
        },
        {
          key: "getRealState",
          value: function () {
            var b = this.gl;
            return {
              blend: b.getParameter(b.BLEND),
              blendEquation: b.getParameter(b.BLEND_EQUATION),
              depthMask: b.getParameter(b.DEPTH_WRITEMASK),
              depthTest: b.getParameter(b.DEPTH_TEST),
              depthFunc: b.getParameter(b.DEPTH_FUNC),
              polygonOffset: [b.getParameter(b.POLYGON_OFFSET_FACTOR), b.getParameter(b.POLYGON_OFFSET_UNITS)],
              cullFace: b.getParameter(b.CULL_FACE),
              stencilTest: b.getParameter(b.STENCIL_TEST)
            };
          }
        },
        {
          key: "getCurrentState",
          value: function () {
            return this.currentState;
          }
        },
        {
          key: "save",
          value: function () {
            this.savedState.push(this.getCurrentState());
          }
        },
        {
          key: "restore",
          value: function () {
            var b = this.savedState.pop();
            this.setState(b, { force: !0 });
          }
        },
        {
          key: "setState",
          value: function (b) {
            var d = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
            b = S(this.getDefaultState(), b);
            this.setBlend(b, d);
            this.setDepth(b, d);
            this.setCullFace(b, d);
            this.setPolygonOffset(b, d);
            this.setStencil(b, d);
            this.currentState = b;
          }
        },
        {
          key: "setBlend",
          value: function (b, d) {
            var a = this.gl,
              c = this.getCurrentState();
            if ((d = d.force) || !tb(b.blend, c.blend)) b.blend ? a.enable(a.BLEND) : a.disable(a.BLEND);
            (!d && tb(b.blendEquation, c.blendEquation)) || a.blendEquation(b.blendEquation);
            if (d || !tb(b.blendFunc, c.blendFunc))
              2 === b.blendFunc.length
                ? a.blendFunc(b.blendFunc[0], b.blendFunc[1])
                : 4 === b.blendFunc.length && a.blendFuncSeparate(b.blendFunc[0], b.blendFunc[1], b.blendFunc[2], b.blendFunc[3]);
          }
        },
        {
          key: "setDepth",
          value: function (b, d) {
            var a = this.gl,
              c = this.getCurrentState();
            if ((d = d.force) || !tb(b.depthTest, c.depthTest)) b.depthTest ? a.enable(a.DEPTH_TEST) : a.disable(a.DEPTH_TEST);
            if (d || !tb(b.depthMask, c.depthMask)) b.depthMask ? a.depthMask(!0) : a.depthMask(!1);
            (!d && tb(b.depthFunc, c.depthFunc)) || a.depthFunc(b.depthFunc);
          }
        },
        {
          key: "setPolygonOffset",
          value: function (b, d) {
            var a = this.gl,
              c = this.getCurrentState();
            if (d.force || !tb(b.polygonOffset, c.polygonOffset))
              0 !== b.polygonOffset[0] && 0 !== b.polygonOffset[1] ? a.enable(a.POLYGON_OFFSET_FILL) : a.disable(a.POLYGON_OFFSET_FILL),
                a.polygonOffset(b.polygonOffset[0], b.polygonOffset[1]);
          }
        },
        {
          key: "setCullFace",
          value: function (b, d) {
            var a = this.gl,
              c = this.getCurrentState();
            if (d.force || !tb(b.cullFace, c.cullFace)) b.cullFace ? (a.enable(a.CULL_FACE), a.cullFace(a.BACK)) : a.disable(a.CULL_FACE);
          }
        },
        {
          key: "setStencil",
          value: function (b, d) {
            var a = this.gl,
              c = this.getCurrentState();
            if (d.force || !tb(b.stencilTest, c.stencilTest)) b.stencilTest ? a.enable(a.STENCIL_TEST) : a.disable(a.STENCIL_TEST);
          }
        }
      ]);
      return e;
    })(),
    K = (function () {
      function e(b) {
        F(this, e);
        this.options = b;
        this.gl = b.gl;
        this.buffer = this.gl.createBuffer();
        b.data && this.updateData(b.data);
      }
      I(e, [
        {
          key: "updateData",
          value: function (b) {
            var d = this.options,
              a = this.gl;
            this.bind();
            a.bufferData(a[d.target], b, a[d.usage]);
          }
        },
        {
          key: "bind",
          value: function (b) {
            b = b || this.gl;
            b.bindBuffer(b[this.options.target], this.buffer);
          }
        },
        {
          key: "unBind",
          value: function (b) {
            b = b || this.gl;
            b.bindBuffer(b[this.options.target], null);
          }
        },
        {
          key: "destroy",
          value: function () {
            this.buffer = null;
          }
        }
      ]);
      return e;
    })(),
    bl = { BYTE: 1, UNSIGNED_BYTE: 1, SHORT: 2, UNSIGNED_SHORT: 2, FLOAT: 4 },
    fa = (function () {
      function e(b) {
        F(this, e);
        this.options = b;
        this.attributes = b.attributes;
        this.gl = b.gl;
        this.program = b.program;
        for (b = this.stride = 0; b < this.attributes.length; b++) this.stride += bl[this.attributes[b].type] * this.attributes[b].size;
      }
      I(e, [
        {
          key: "setVertexAttribPointers",
          value: function () {
            for (var b = this.gl, d = this.program, a = 0; a < this.attributes.length; a++) {
              var c = this.attributes[a],
                e = d.attributes[c.name];
              void 0 !== e &&
                (c.buffer.bind(b),
                b.vertexAttribPointer(e, c.size, b[c.type], c.normalize || !1, void 0 !== c.stride ? c.stride : this.stride, c.offset),
                b.enableVertexAttribArray(e));
            }
          }
        },
        {
          key: "bind",
          value: function () {
            this.setVertexAttribPointers();
          }
        },
        { key: "destroy", value: function () {} }
      ]);
      return e;
    })(),
    ya = function c(b, d, a) {
      F(this, c);
      d = d || b.canvas.width;
      a = a || b.canvas.height;
      var f = b.createFramebuffer(),
        h = b.createTexture();
      b.bindTexture(b.TEXTURE_2D, h);
      b.texImage2D(b.TEXTURE_2D, 0, b.RGBA, d, a, 0, b.RGBA, b.UNSIGNED_BYTE, null);
      b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MAG_FILTER, b.LINEAR);
      b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MIN_FILTER, b.LINEAR);
      b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_S, b.CLAMP_TO_EDGE);
      b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_T, b.CLAMP_TO_EDGE);
      f.texture = h;
      var g = b.createRenderbuffer();
      b.bindRenderbuffer(b.RENDERBUFFER, g);
      b.renderbufferStorage(b.RENDERBUFFER, b.DEPTH_STENCIL, d, a);
      f.depthBuffer = g;
      b.bindFramebuffer(b.FRAMEBUFFER, f);
      b.framebufferTexture2D(b.FRAMEBUFFER, b.COLOR_ATTACHMENT0, b.TEXTURE_2D, h, 0);
      b.framebufferRenderbuffer(b.FRAMEBUFFER, b.DEPTH_STENCIL_ATTACHMENT, b.RENDERBUFFER, g);
      d = b.checkFramebufferStatus(b.FRAMEBUFFER);
      b.FRAMEBUFFER_COMPLETE === d && (b.bindFramebuffer(b.FRAMEBUFFER, null), b.bindTexture(b.TEXTURE_2D, null), b.bindRenderbuffer(b.RENDERBUFFER, null), (this.framebuffer = f));
    },
    oc = (function () {
      function b(d) {
        F(this, b);
        this.options = {};
        S(this.options, d);
        this.vertex = [-1, 1, 0, -1, -1, 0, 1, 1, 0, 1, 1, 0, -1, -1, 0, 1, -1, 0];
        this.sampleCoord = [0, 1, 0, 0, 1, 1, 1, 1, 0, 0, 1, 0];
      }
      I(b, [
        {
          key: "getOptions",
          value: function () {
            return this.options;
          }
        },
        { key: "onResize", value: function (b) {} },
        {
          key: "render",
          value: function (b) {
            var a = b.gl;
            b = b.texture;
            var c = this.programSample;
            a.useProgram(c.program);
            var d = a.createBuffer();
            a.bindBuffer(a.ARRAY_BUFFER, d);
            var h = [-1, -1, 0, -1, 1, 0, 1, 1, 0, 1, 1, 0, -1, -1, 0, 1, -1, 0];
            a.bufferData(a.ARRAY_BUFFER, new Float32Array(h), a.STATIC_DRAW);
            a.enableVertexAttribArray(c.attributes.aPos);
            a.vertexAttribPointer(c.attributes.aPos, 3, a.FLOAT, !1, 0, 0);
            d = a.createBuffer();
            a.bindBuffer(a.ARRAY_BUFFER, d);
            a.bufferData(a.ARRAY_BUFFER, new Float32Array([0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 1, 0]), a.STATIC_DRAW);
            a.enableVertexAttribArray(c.attributes.aTextureCoord);
            a.vertexAttribPointer(c.attributes.aTextureCoord, 2, a.FLOAT, !1, 0, 0);
            a.activeTexture(a.TEXTURE0);
            a.bindTexture(a.TEXTURE_2D, b);
            a.uniform1i(c.uniforms.uSampler, 0);
            a.drawArrays(a.TRIANGLES, 0, h.length / 3);
          }
        }
      ]);
      return b;
    })(),
    cl = (function (b) {
      function d(a) {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).call(this, a));
      }
      R(d, b);
      I(d, [
        {
          key: "getProgram",
          value: function (a) {
            this.programSample ||
              (this.programSample = new X(a, {
                vertexShader:
                  "attribute vec3 aPos;attribute vec2 aTextureCoord;varying vec2 vTextureCoord;void main(void){vTextureCoord=aTextureCoord;gl_Position=vec4(aPos,1.0);}",
                fragmentShader:
                  "precision highp float;uniform sampler2D uSampler;uniform vec2 canvasSize;varying vec2 vTextureCoord;vec4 fxaa_2_0(sampler2D tex,vec2 fragCoord,vec2 resolution,vec2 v_rgbNW,vec2 v_rgbNE,vec2 v_rgbSW,vec2 v_rgbSE,vec2 v_rgbM){vec4 color;mediump vec2 inverseVP=vec2(1.0/resolution.x,1.0/resolution.y);vec3 rgbNW=texture2D(tex,v_rgbNW).xyz;vec3 rgbNE=texture2D(tex,v_rgbNE).xyz;vec3 rgbSW=texture2D(tex,v_rgbSW).xyz;vec3 rgbSE=texture2D(tex,v_rgbSE).xyz;vec4 texColor=texture2D(tex,v_rgbM);vec3 rgbM=texColor.xyz;vec3 luma=vec3(0.299,0.587,0.114);float lumaNW=dot(rgbNW,luma);float lumaNE=dot(rgbNE,luma);float lumaSW=dot(rgbSW,luma);float lumaSE=dot(rgbSE,luma);float lumaM=dot(rgbM,luma);float lumaMin=min(lumaM,min(min(lumaNW,lumaNE),min(lumaSW,lumaSE)));float lumaMax=max(lumaM,max(max(lumaNW,lumaNE),max(lumaSW,lumaSE)));mediump vec2 dir;dir.x=-((lumaNW+lumaNE)-(lumaSW+lumaSE));dir.y=((lumaNW+lumaSW)-(lumaNE+lumaSE));float dirReduce=max((lumaNW+lumaNE+lumaSW+lumaSE)*(0.25*1.0/8.0),1.0/128.0);float rcpDirMin=1.0/(min(abs(dir.x),abs(dir.y))+dirReduce);dir=min(vec2(8.0,8.0),max(vec2(-8.0,-8.0),dir*rcpDirMin))*inverseVP;vec3 rgbA=0.5*(texture2D(tex,fragCoord*inverseVP+dir*(1.0/3.0-0.5)).xyz+texture2D(tex,fragCoord*inverseVP+dir*(2.0/3.0-0.5)).xyz);vec3 rgbB=rgbA*0.5+0.25*(texture2D(tex,fragCoord*inverseVP+dir*-0.5).xyz+texture2D(tex,fragCoord*inverseVP+dir*0.5).xyz);float lumaB=dot(rgbB,luma);if((lumaB<lumaMin)||(lumaB>lumaMax)){color=vec4(rgbA,texColor.a);}else{color=vec4(rgbB,texColor.a);}return color;}void texcoords_3_1(vec2 fragCoord,vec2 resolution,out vec2 v_rgbNW,out vec2 v_rgbNE,out vec2 v_rgbSW,out vec2 v_rgbSE,out vec2 v_rgbM){vec2 inverseVP=1.0/resolution.xy;v_rgbNW=(fragCoord+vec2(-1.0,-1.0))*inverseVP;v_rgbNE=(fragCoord+vec2(1.0,-1.0))*inverseVP;v_rgbSW=(fragCoord+vec2(-1.0,1.0))*inverseVP;v_rgbSE=(fragCoord+vec2(1.0,1.0))*inverseVP;v_rgbM=vec2(fragCoord*inverseVP);}vec4 apply_1_2(sampler2D tex,vec2 fragCoord,vec2 resolution){mediump vec2 v_rgbNW;mediump vec2 v_rgbNE;mediump vec2 v_rgbSW;mediump vec2 v_rgbSE;mediump vec2 v_rgbM;texcoords_3_1(fragCoord,resolution,v_rgbNW,v_rgbNE,v_rgbSW,v_rgbSE,v_rgbM);return fxaa_2_0(tex,fragCoord,resolution,v_rgbNW,v_rgbNE,v_rgbSW,v_rgbSE,v_rgbM);}void main(void){vec2 fragCoord=vTextureCoord*canvasSize;gl_FragColor=apply_1_2(uSampler,fragCoord,canvasSize);}"
              }));
            return this.programSample;
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl;
            a = a.texture;
            this.getOptions();
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            var b = this.getProgram(c);
            c.useProgram(b.program);
            var d = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, d);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array(this.vertex), c.STATIC_DRAW);
            c.enableVertexAttribArray(b.attributes.aPos);
            c.vertexAttribPointer(b.attributes.aPos, 3, c.FLOAT, !1, 0, 0);
            d = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, d);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array(this.sampleCoord), c.STATIC_DRAW);
            c.enableVertexAttribArray(b.attributes.aTextureCoord);
            c.vertexAttribPointer(b.attributes.aTextureCoord, 2, c.FLOAT, !1, 0, 0);
            c.activeTexture(c.TEXTURE1);
            c.bindTexture(c.TEXTURE_2D, a);
            c.uniform1i(b.uniforms.uSampler, 1);
            c.uniform2fv(b.uniforms.canvasSize, [c.canvas.width, c.canvas.height]);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
            c.bindBuffer(c.ARRAY_BUFFER, null);
            c.useProgram(null);
          }
        }
      ]);
      return d;
    })(oc),
    dl = (function (b) {
      function d(a) {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).call(this, a));
      }
      R(d, b);
      I(d, [
        {
          key: "getProgram",
          value: function (a) {
            this.program1 ||
              (this.program1 = new X(a, {
                vertexShader:
                  "attribute vec3 position;attribute vec2 uv;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];void SMAAEdgeDetectionVS(vec2 texcoord){vOffset[0]=texcoord.xyxy+resolution.xyxy*vec4(-1.0,0.0,0.0,1.0);vOffset[1]=texcoord.xyxy+resolution.xyxy*vec4(1.0,0.0,0.0,-1.0);vOffset[2]=texcoord.xyxy+resolution.xyxy*vec4(-2.0,0.0,0.0,2.0);}void main(){vUv=uv;SMAAEdgeDetectionVS(vUv);gl_Position=vec4(position,1.0);}",
                fragmentShader:
                  "precision highp float;\n#define SMAA_THRESHOLD 0.1\nuniform sampler2D tDiffuse;varying vec2 vUv;varying vec4 vOffset[3];vec4 SMAAColorEdgeDetectionPS(vec2 texcoord,vec4 offset[3],sampler2D colorTex){vec2 threshold=vec2(SMAA_THRESHOLD,SMAA_THRESHOLD);vec4 delta;vec3 C=texture2D(colorTex,texcoord).rgb;vec3 Cleft=texture2D(colorTex,offset[0].xy).rgb;vec3 t=abs(C-Cleft);delta.x=max(max(t.r,t.g),t.b);vec3 Ctop=texture2D(colorTex,offset[0].zw).rgb;t=abs(C-Ctop);delta.y=max(max(t.r,t.g),t.b);vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0,1.0))==0.0)discard;vec3 Cright=texture2D(colorTex,offset[1].xy).rgb;t=abs(C-Cright);delta.z=max(max(t.r,t.g),t.b);vec3 Cbottom=texture2D(colorTex,offset[1].zw).rgb;t=abs(C-Cbottom);delta.w=max(max(t.r,t.g),t.b);float maxDelta=max(max(max(delta.x,delta.y),delta.z),delta.w);vec3 Cleftleft=texture2D(colorTex,offset[2].xy).rgb;t=abs(C-Cleftleft);delta.z=max(max(t.r,t.g),t.b);vec3 Ctoptop=texture2D(colorTex,offset[2].zw).rgb;t=abs(C-Ctoptop);delta.w=max(max(t.r,t.g),t.b);maxDelta=max(max(maxDelta,delta.z),delta.w);edges.xy*=step(0.5*maxDelta,delta.xy);return vec4(edges,0.0,0.0);}void main(){gl_FragColor=SMAAColorEdgeDetectionPS(vUv,vOffset,tDiffuse);}"
              }));
            this.program2 ||
              (this.program2 = new X(a, {
                vertexShader:
                  "precision highp float;\n#define SMAA_MAX_SEARCH_STEPS 8\n#define SMAA_AREATEX_MAX_DISTANCE 16\n#define SMAA_AREATEX_PIXEL_SIZE ( 1.0 / vec2( 160.0, 560.0 ) )\n#define SMAA_AREATEX_SUBTEX_SIZE ( 1.0 / 7.0 )\nattribute vec3 position;attribute vec2 uv;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixcoord;void SMAABlendingWeightCalculationVS(vec2 texcoord){vPixcoord=texcoord/resolution;vOffset[0]=texcoord.xyxy+resolution.xyxy*vec4(-0.25,0.125,1.25,0.125);vOffset[1]=texcoord.xyxy+resolution.xyxy*vec4(-0.125,0.25,-0.125,-1.25);vOffset[2]=vec4(vOffset[0].xz,vOffset[1].yw)+vec4(-2.0,2.0,-2.0,2.0)*resolution.xxyy*float(SMAA_MAX_SEARCH_STEPS);}void main(){vUv=uv;SMAABlendingWeightCalculationVS(vUv);gl_Position=vec4(position,1.0);}",
                fragmentShader:
                  "precision highp float;\n#define SMAA_MAX_SEARCH_STEPS 8\n#define SMAA_AREATEX_MAX_DISTANCE 16\n#define SMAA_AREATEX_PIXEL_SIZE ( 1.0 / vec2( 160.0, 560.0 ) )\n#define SMAA_AREATEX_SUBTEX_SIZE ( 1.0 / 7.0 )\n#define SMAASampleLevelZeroOffset( tex, coord, offset ) texture2D( tex, coord + float( offset ) * resolution, 0.0 )\nuniform sampler2D tDiffuse;uniform sampler2D tArea;uniform sampler2D tSearch;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixcoord;vec2 round(vec2 x){return sign(x)*floor(abs(x)+0.5);}float SMAASearchLength(sampler2D searchTex,vec2 e,float bias,float scale){e.r=bias+e.r*scale;return 255.0*texture2D(searchTex,e,0.0).r;}float SMAASearchXLeft(sampler2D edgesTex,sampler2D searchTex,vec2 texcoord,float end){/***@PSEUDO_GATHER4*This texcoord has been offset by(-0.25,-0.125)in the vertex shader to*sample between edge,thus fetching four edges in a row.*Sampling with different offsets in each direction allows to disambiguate*which edges are active from the four fetched ones.*/vec2 e=vec2(0.0,1.0);for(int i=0;i<SMAA_MAX_SEARCH_STEPS;i++){e=texture2D(edgesTex,texcoord,0.0).rg;texcoord-=vec2(2.0,0.0)*resolution;if(!(texcoord.x>end&&e.g>0.8281&&e.r==0.0))break;}texcoord.x+=0.25*resolution.x;texcoord.x+=resolution.x;texcoord.x+=2.0*resolution.x;texcoord.x-=resolution.x*SMAASearchLength(searchTex,e,0.0,0.5);return texcoord.x;}float SMAASearchXRight(sampler2D edgesTex,sampler2D searchTex,vec2 texcoord,float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<SMAA_MAX_SEARCH_STEPS;i++){e=texture2D(edgesTex,texcoord,0.0).rg;texcoord+=vec2(2.0,0.0)*resolution;if(!(texcoord.x<end&&e.g>0.8281&&e.r==0.0))break;}texcoord.x-=0.25*resolution.x;texcoord.x-=resolution.x;texcoord.x-=2.0*resolution.x;texcoord.x+=resolution.x*SMAASearchLength(searchTex,e,0.5,0.5);return texcoord.x;}float SMAASearchYUp(sampler2D edgesTex,sampler2D searchTex,vec2 texcoord,float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<SMAA_MAX_SEARCH_STEPS;i++){e=texture2D(edgesTex,texcoord,0.0).rg;texcoord+=vec2(0.0,2.0)*resolution;if(!(texcoord.y>end&&e.r>0.8281&&e.g==0.0))break;}texcoord.y-=0.25*resolution.y;texcoord.y-=resolution.y;texcoord.y-=2.0*resolution.y;texcoord.y+=resolution.y*SMAASearchLength(searchTex,e.gr,0.0,0.5);return texcoord.y;}float SMAASearchYDown(sampler2D edgesTex,sampler2D searchTex,vec2 texcoord,float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<SMAA_MAX_SEARCH_STEPS;i++){e=texture2D(edgesTex,texcoord,0.0).rg;texcoord-=vec2(0.0,2.0)*resolution;if(!(texcoord.y<end&&e.r>0.8281&&e.g==0.0))break;}texcoord.y+=0.25*resolution.y;texcoord.y+=resolution.y;texcoord.y+=2.0*resolution.y;texcoord.y-=resolution.y*SMAASearchLength(searchTex,e.gr,0.5,0.5);return texcoord.y;}vec2 SMAAArea(sampler2D areaTex,vec2 dist,float e1,float e2,float offset){vec2 texcoord=float(SMAA_AREATEX_MAX_DISTANCE)*round(4.0*vec2(e1,e2))+dist;texcoord=SMAA_AREATEX_PIXEL_SIZE*texcoord+(0.5*SMAA_AREATEX_PIXEL_SIZE);texcoord.y+=SMAA_AREATEX_SUBTEX_SIZE*offset;return texture2D(areaTex,texcoord,0.0).rg;}vec4 SMAABlendingWeightCalculationPS(vec2 texcoord,vec2 pixcoord,vec4 offset[3],sampler2D edgesTex,sampler2D areaTex,sampler2D searchTex,ivec4 subsampleIndices){vec4 weights=vec4(0.0,0.0,0.0,0.0);vec2 e=texture2D(edgesTex,texcoord).rg;if(e.g>0.0){vec2 d;vec2 coords;coords.x=SMAASearchXLeft(edgesTex,searchTex,offset[0].xy,offset[2].x);coords.y=offset[1].y;d.x=coords.x;float e1=texture2D(edgesTex,coords,0.0).r;coords.x=SMAASearchXRight(edgesTex,searchTex,offset[0].zw,offset[2].y);d.y=coords.x;d=d/resolution.x-pixcoord.x;vec2 sqrt_d=sqrt(abs(d));coords.y-=1.0*resolution.y;float e2=SMAASampleLevelZeroOffset(edgesTex,coords,ivec2(1,0)).r;weights.rg=SMAAArea(areaTex,sqrt_d,e1,e2,float(subsampleIndices.y));}if(e.r>0.0){vec2 d;vec2 coords;coords.y=SMAASearchYUp(edgesTex,searchTex,offset[1].xy,offset[2].z);coords.x=offset[0].x;d.x=coords.y;float e1=texture2D(edgesTex,coords,0.0).g;coords.y=SMAASearchYDown(edgesTex,searchTex,offset[1].zw,offset[2].w);d.y=coords.y;d=d/resolution.y-pixcoord.y;vec2 sqrt_d=sqrt(abs(d));coords.y-=1.0*resolution.y;float e2=SMAASampleLevelZeroOffset(edgesTex,coords,ivec2(0,1)).g;weights.ba=SMAAArea(areaTex,sqrt_d,e1,e2,float(subsampleIndices.x));}return weights;}void main(){gl_FragColor=SMAABlendingWeightCalculationPS(vUv,vPixcoord,vOffset,tDiffuse,tArea,tSearch,ivec4(0.0));}"
              }));
            this.program3 ||
              (this.program3 = new X(a, {
                vertexShader:
                  "precision highp float;uniform vec2 resolution;attribute vec3 position;attribute vec2 uv;varying vec2 vUv;varying vec4 vOffset[2];void SMAANeighborhoodBlendingVS(vec2 texcoord){vOffset[0]=texcoord.xyxy+resolution.xyxy*vec4(-1.0,0.0,0.0,1.0);vOffset[1]=texcoord.xyxy+resolution.xyxy*vec4(1.0,0.0,0.0,-1.0);}void main(){vUv=uv;SMAANeighborhoodBlendingVS(vUv);gl_Position=vec4(position,1.0);}",
                fragmentShader:
                  "precision highp float;uniform sampler2D tDiffuse;uniform sampler2D tColor;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[2];vec4 SMAANeighborhoodBlendingPS(vec2 texcoord,vec4 offset[2],sampler2D colorTex,sampler2D blendTex){vec4 a;a.xz=texture2D(blendTex,texcoord).xz;a.y=texture2D(blendTex,offset[1].zw).g;a.w=texture2D(blendTex,offset[1].xy).a;if(dot(a,vec4(1.0,1.0,1.0,1.0))<1e-5){return texture2D(colorTex,texcoord,0.0);}else{vec2 offset;offset.x=a.a>a.b ? a.a :-a.b;offset.y=a.g>a.r ?-a.g : a.r;if(abs(offset.x)>abs(offset.y)){offset.y=0.0;}else{offset.x=0.0;}vec4 C=texture2D(colorTex,texcoord,0.0);texcoord+=sign(offset)*resolution;vec4 Cop=texture2D(colorTex,texcoord,0.0);float s=abs(offset.x)>abs(offset.y)? abs(offset.x): abs(offset.y);C.xyz=pow(C.xyz,vec3(2.2));Cop.xyz=pow(Cop.xyz,vec3(2.2));vec4 mixed=mix(C,Cop,s);mixed.xyz=pow(mixed.xyz,vec3(1.0/2.2));return mixed;}}void main(){gl_FragColor=SMAANeighborhoodBlendingPS(vUv,vOffset,tColor,tDiffuse);}"
              }));
            if (!this.vertexBuffer || !this.sampleBuffer) {
              this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
              this.sampleBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
              this.vertexBuffer.updateData(new Float32Array(this.vertex));
              this.sampleBuffer.updateData(new Float32Array(this.sampleCoord));
              var c = [
                { stride: 12, name: "position", buffer: this.vertexBuffer, size: 3, type: "FLOAT", offset: 0 },
                { stride: 8, name: "uv", buffer: this.sampleBuffer, size: 2, type: "FLOAT", offset: 0 }
              ];
              this.vertexArray1 = new fa({ gl: a, program: this.program1, attributes: c });
              this.vertexArray2 = new fa({ gl: a, program: this.program2, attributes: c });
              this.vertexArray3 = new fa({ gl: a, program: this.program3, attributes: c });
            }
            return { program1: this.program1, program2: this.program2, program3: this.program3 };
          }
        },
        {
          key: "onResize",
          value: function (a) {
            this.collectBrightBuffer = new ya(a);
            this.bloomBuffer = new ya(a);
          }
        },
        {
          key: "getExtraFbo",
          value: function (a) {
            this.collectBrightBuffer || (this.collectBrightBuffer = new ya(a));
            this.bloomBuffer || (this.bloomBuffer = new ya(a));
            return { collectBrightBuffer: this.collectBrightBuffer.framebuffer, bloomBuffer: this.bloomBuffer.framebuffer };
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.texture;
            a = a.fbo;
            this.getOptions();
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            var d = this.getProgram(c),
              g = d.program1,
              k = d.program2;
            d = d.program3;
            var l = this.getExtraFbo(c),
              n = l.collectBrightBuffer;
            l = l.bloomBuffer;
            var m = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, m);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array(this.vertex), c.STATIC_DRAW);
            c.enableVertexAttribArray(g.attributes.position);
            c.vertexAttribPointer(g.attributes.position, 3, c.FLOAT, !1, 0, 0);
            c.enableVertexAttribArray(k.attributes.position);
            c.vertexAttribPointer(k.attributes.position, 3, c.FLOAT, !1, 0, 0);
            c.enableVertexAttribArray(d.attributes.position);
            c.vertexAttribPointer(d.attributes.position, 3, c.FLOAT, !1, 0, 0);
            m = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, m);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array(this.sampleCoord), c.STATIC_DRAW);
            c.enableVertexAttribArray(g.attributes.uv);
            c.vertexAttribPointer(g.attributes.uv, 2, c.FLOAT, !1, 0, 0);
            c.enableVertexAttribArray(k.attributes.uv);
            c.vertexAttribPointer(k.attributes.uv, 2, c.FLOAT, !1, 0, 0);
            c.enableVertexAttribArray(d.attributes.uv);
            c.vertexAttribPointer(d.attributes.uv, 2, c.FLOAT, !1, 0, 0);
            c.useProgram(g.program);
            c.bindFramebuffer(c.FRAMEBUFFER, n);
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            c.activeTexture(c.TEXTURE2);
            c.bindTexture(c.TEXTURE_2D, b);
            c.uniform1i(g.uniforms.tDiffuse, 2);
            c.uniform2fv(g.uniforms.resolution, [c.canvas.width, c.canvas.height]);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
            c.useProgram(k.program);
            c.bindFramebuffer(c.FRAMEBUFFER, l);
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            c.activeTexture(c.TEXTURE2);
            c.bindTexture(c.TEXTURE_2D, n.texture);
            c.uniform1i(k.uniforms.uSampler, 2);
            c.uniform2fv(k.uniforms.resolution, [c.canvas.width, c.canvas.height]);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
            c.useProgram(d.program);
            c.bindFramebuffer(c.FRAMEBUFFER, a);
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            c.activeTexture(c.TEXTURE2);
            c.bindTexture(c.TEXTURE_2D, b);
            c.uniform1i(d.uniforms.tDiffuse, 2);
            c.activeTexture(c.TEXTURE3);
            c.bindTexture(c.TEXTURE_2D, l.texture);
            c.uniform1i(d.uniforms.tColor, 3);
            c.uniform2fv(d.uniforms.resolution, [c.canvas.width, c.canvas.height]);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
            c.bindBuffer(c.ARRAY_BUFFER, null);
            c.useProgram(null);
          }
        },
        {
          key: "getAreaTexture",
          value: function () {
            return "data:image/png;base64,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";
          }
        },
        {
          key: "getSearchTexture",
          value: function () {
            return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAhCAIAAADiVupLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFZJREFUeNrs00EKgAAIRNEZ739mTQoiwmhRi4L/FiKiu9ERISkzbXdTVV3H4WhfOG6ehl1rNR7qDSF8hwkVcJXt+3A//I0Nv0GoCBUAAAAAAMA/LAIMAB+Dcg2OE2zsAAAAAElFTkSuQmCC";
          }
        }
      ]);
      return d;
    })(oc),
    el = (function (b) {
      function d(a) {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).call(this, a));
      }
      R(d, b);
      I(d, [
        {
          key: "getProgram",
          value: function (a) {
            this.programSample ||
              ((this.programSample = new X(a, {
                vertexShader: "attribute vec3 aPos;attribute vec2 aTextureCoord;varying vec2 vTextureCoord;void main(){vTextureCoord=aTextureCoord;gl_Position=vec4(aPos,1.0);}",
                fragmentShader:
                  "precision mediump float;uniform sampler2D uSampler;varying vec2 vTextureCoord;void main(){float fStep=1.0/512.0;vec4 sample11=texture2D(uSampler,vec2(vTextureCoord.s-1.0*fStep,vTextureCoord.t+1.0*fStep));vec4 sample12=texture2D(uSampler,vec2(vTextureCoord.s,vTextureCoord.t+1.0*fStep));vec4 sample13=texture2D(uSampler,vec2(vTextureCoord.s+1.0*fStep,vTextureCoord.t+1.0*fStep));vec4 sample21=texture2D(uSampler,vec2(vTextureCoord.s-1.0*fStep,vTextureCoord.t));vec4 sample22=texture2D(uSampler,vec2(vTextureCoord.s,vTextureCoord.t));vec4 sample23=texture2D(uSampler,vec2(vTextureCoord.s+1.0*fStep,vTextureCoord.t));vec4 sample31=texture2D(uSampler,vec2(vTextureCoord.s-1.0*fStep,vTextureCoord.t-1.0*fStep));vec4 sample32=texture2D(uSampler,vec2(vTextureCoord.s,vTextureCoord.t-1.0*fStep));vec4 sample33=texture2D(uSampler,vec2(vTextureCoord.s+1.0*fStep,vTextureCoord.t-1.0*fStep));vec4 blurSample=(sample11+sample12+sample13+sample21+2.0*sample22+sample23+sample31+sample32+sample33)/10.0;gl_FragColor=blurSample;}"
              })),
              (this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" })),
              (this.sampleBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" })),
              this.vertexBuffer.updateData(new Float32Array(this.vertex)),
              this.sampleBuffer.updateData(new Float32Array(this.sampleCoord)),
              (this.vertexArray = new fa({
                gl: a,
                program: this.programSample,
                attributes: [
                  { stride: 12, name: "aPos", buffer: this.vertexBuffer, size: 3, type: "FLOAT", offset: 0 },
                  { stride: 8, name: "aTextureCoord", buffer: this.sampleBuffer, size: 2, type: "FLOAT", offset: 0 }
                ]
              })));
            return this.programSample;
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl;
            a = a.texture;
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            var b = this.getProgram(c);
            b.use(c);
            this.vertexArray.bind();
            c.activeTexture(c.TEXTURE1);
            c.bindTexture(c.TEXTURE_2D, a);
            c.uniform1i(b.uniforms.uSampler, 1);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
          }
        }
      ]);
      return d;
    })(oc),
    fl = (function (b) {
      function d(a) {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).call(this, a));
      }
      R(d, b);
      I(d, [
        {
          key: "getProgram",
          value: function (a) {
            this.programBright ||
              (this.programBright = new X(a, {
                vertexShader: "attribute vec3 aPos;attribute vec2 aTextureCoord;varying vec2 vTextureCoord;void main(){vTextureCoord=aTextureCoord;gl_Position=vec4(aPos,1.0);}",
                fragmentShader:
                  "precision mediump float;uniform sampler2D uSampler;uniform float threshold;varying vec2 vTextureCoord;void main(){vec4 color=texture2D(uSampler,vTextureCoord);vec4 lightColor=max(vec4(0.0),(color-(1.0-threshold)/5.0));float brightness=dot(color.rgb,vec3(0.2126,0.7152,0.0722));if(brightness>threshold){color=lightColor;}else{color=vec4(0.0);}gl_FragColor=color;}"
              }));
            this.programBloom ||
              (this.programBloom = new X(a, {
                vertexShader: "attribute vec3 aPos;attribute vec2 aTextureCoord;varying vec2 vTextureCoord;void main(){vTextureCoord=aTextureCoord;gl_Position=vec4(aPos,1.0);}",
                fragmentShader:
                  "precision mediump float;uniform sampler2D uSampler;uniform bool isVertical;uniform vec2 canvasSize;uniform float blurSize;uniform float devicePixelRatio;varying vec2 vTextureCoord;void main(){float weight[10];weight[0]=0.2270270270;weight[1]=0.1945945946;weight[2]=0.1216216216;weight[3]=0.1135135135;weight[4]=0.0972972973;weight[5]=0.0608108108;weight[6]=0.0540540541;weight[7]=0.0270270270;weight[8]=0.0162162162;weight[9]=0.0081081081;vec2 offset=vec2(blurSize/canvasSize.x,blurSize/canvasSize.y)*devicePixelRatio;vec4 result=texture2D(uSampler,vTextureCoord)*weight[0];if(isVertical){for(int i=1;i<10;++i){result+=texture2D(uSampler,vTextureCoord+vec2(0.0,offset.y*float(i)))*weight[i];result+=texture2D(uSampler,vTextureCoord-vec2(0.0,offset.y*float(i)))*weight[i];}}else{for(int i=1;i<10;++i){result+=texture2D(uSampler,vTextureCoord+vec2(offset.x*float(i),0.0))*weight[i];result+=texture2D(uSampler,vTextureCoord-vec2(offset.x*float(i),0.0))*weight[i];}}gl_FragColor=result;}"
              }));
            this.programResult ||
              (this.programResult = new X(a, {
                vertexShader: "attribute vec3 aPos;attribute vec2 aTextureCoord;varying vec2 vTextureCoord;void main(){vTextureCoord=aTextureCoord;gl_Position=vec4(aPos,1.0);}",
                fragmentShader:
                  "precision mediump float;uniform sampler2D originalTexture;uniform sampler2D bloomTexture;varying vec2 vTextureCoord;void main(){vec4 color=texture2D(originalTexture,vTextureCoord);vec4 bloomColor=texture2D(bloomTexture,vTextureCoord);color+=bloomColor;gl_FragColor=color;}"
              }));
            return { programBright: this.programBright, programBloom: this.programBloom, programResult: this.programResult };
          }
        },
        {
          key: "onResize",
          value: function (a) {
            this.collectBrightBuffer = new ya(a);
            this.bloomBuffer = new ya(a);
          }
        },
        {
          key: "getExtraFbo",
          value: function (a) {
            this.collectBrightBuffer || (this.collectBrightBuffer = new ya(a));
            this.bloomBuffer || (this.bloomBuffer = new ya(a));
            return { collectBrightBuffer: this.collectBrightBuffer.framebuffer, bloomBuffer: this.bloomBuffer.framebuffer };
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.texture;
            a = a.fbo;
            var d = this.getOptions();
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            var g = this.getProgram(c),
              k = g.programBright,
              l = g.programBloom;
            g = g.programResult;
            var n = this.getExtraFbo(c),
              m = n.collectBrightBuffer;
            n = n.bloomBuffer;
            var p = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, p);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array(this.vertex), c.STATIC_DRAW);
            c.enableVertexAttribArray(k.attributes.aPos);
            c.vertexAttribPointer(k.attributes.aPos, 3, c.FLOAT, !1, 0, 0);
            c.enableVertexAttribArray(l.attributes.aPos);
            c.vertexAttribPointer(l.attributes.aPos, 3, c.FLOAT, !1, 0, 0);
            c.enableVertexAttribArray(g.attributes.aPos);
            c.vertexAttribPointer(g.attributes.aPos, 3, c.FLOAT, !1, 0, 0);
            p = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, p);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array(this.sampleCoord), c.STATIC_DRAW);
            c.enableVertexAttribArray(k.attributes.aTextureCoord);
            c.vertexAttribPointer(k.attributes.aTextureCoord, 2, c.FLOAT, !1, 0, 0);
            c.enableVertexAttribArray(l.attributes.aTextureCoord);
            c.vertexAttribPointer(l.attributes.aTextureCoord, 2, c.FLOAT, !1, 0, 0);
            c.enableVertexAttribArray(g.attributes.aTextureCoord);
            c.vertexAttribPointer(g.attributes.aTextureCoord, 2, c.FLOAT, !1, 0, 0);
            c.useProgram(k.program);
            c.bindFramebuffer(c.FRAMEBUFFER, m);
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            c.activeTexture(c.TEXTURE1);
            c.bindTexture(c.TEXTURE_2D, b);
            c.uniform1i(k.uniforms.uSampler, 1);
            c.uniform1f(k.uniforms.threshold, d.threshold || 0);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
            c.useProgram(l.program);
            c.bindFramebuffer(c.FRAMEBUFFER, n);
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            c.activeTexture(c.TEXTURE1);
            c.bindTexture(c.TEXTURE_2D, m.texture);
            c.uniform1i(l.uniforms.uSampler, 1);
            c.uniform1i(l.uniforms.isVertical, !0);
            c.uniform1f(l.uniforms.blurSize, d.blurSize || 2);
            c.uniform1f(l.uniforms.devicePixelRatio, window.devicePixelRatio);
            c.uniform2fv(l.uniforms.canvasSize, [c.canvas.width, c.canvas.height]);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
            c.useProgram(l.program);
            c.bindFramebuffer(c.FRAMEBUFFER, m);
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            c.activeTexture(c.TEXTURE1);
            c.bindTexture(c.TEXTURE_2D, n.texture);
            c.uniform1i(l.uniforms.uSampler, 1);
            c.uniform1i(l.uniforms.isVertical, !1);
            c.uniform1f(l.uniforms.blurSize, d.blurSize || 2);
            c.uniform1f(l.uniforms.devicePixelRatio, window.devicePixelRatio);
            c.uniform2fv(l.uniforms.canvasSize, [c.canvas.width, c.canvas.height]);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
            c.useProgram(g.program);
            c.bindFramebuffer(c.FRAMEBUFFER, a);
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            c.activeTexture(c.TEXTURE1);
            c.bindTexture(c.TEXTURE_2D, b);
            c.uniform1i(g.uniforms.originalTexture, 1);
            c.activeTexture(c.TEXTURE0);
            c.bindTexture(c.TEXTURE_2D, m.texture);
            c.uniform1i(g.uniforms.bloomTexture, 0);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
            c.bindBuffer(c.ARRAY_BUFFER, null);
            c.useProgram(null);
          }
        }
      ]);
      return d;
    })(oc),
    gl = (function (b) {
      function d(a) {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).call(this, a));
      }
      R(d, b);
      I(d, [
        {
          key: "getProgram",
          value: function (a) {
            this.programBright ||
              (this.programBright = new X(a, {
                vertexShader: "attribute vec3 aPos;attribute vec2 aTextureCoord;varying vec2 vTextureCoord;void main(){vTextureCoord=aTextureCoord;gl_Position=vec4(aPos,1.0);}",
                fragmentShader:
                  "precision mediump float;uniform sampler2D uSampler;uniform float threshold;varying vec2 vTextureCoord;void main(){vec4 color=texture2D(uSampler,vTextureCoord);vec4 lightColor=max(vec4(0.0),(color-threshold));gl_FragColor=lightColor;}"
              }));
            this.programBloom ||
              (this.programBloom = new X(a, {
                vertexShader: "attribute vec3 aPos;attribute vec2 aTextureCoord;varying vec2 vTextureCoord;void main(){vTextureCoord=aTextureCoord;gl_Position=vec4(aPos,1.0);}",
                fragmentShader:
                  "precision mediump float;uniform sampler2D uSampler;uniform bool isVertical;uniform vec2 canvasSize;uniform float blurSize;uniform float devicePixelRatio;varying vec2 vTextureCoord;void main(){float weight[10];weight[0]=0.2270270270;weight[1]=0.1945945946;weight[2]=0.1216216216;weight[3]=0.1135135135;weight[4]=0.0972972973;weight[5]=0.0608108108;weight[6]=0.0540540541;weight[7]=0.0270270270;weight[8]=0.0162162162;weight[9]=0.0081081081;vec2 offset=vec2(blurSize/canvasSize.x,blurSize/canvasSize.y)*devicePixelRatio;vec4 result=texture2D(uSampler,vTextureCoord)*weight[0];if(isVertical){for(int i=1;i<10;++i){result+=texture2D(uSampler,vTextureCoord+vec2(0.0,offset.y*float(i)))*weight[i];result+=texture2D(uSampler,vTextureCoord-vec2(0.0,offset.y*float(i)))*weight[i];}}else{for(int i=1;i<10;++i){result+=texture2D(uSampler,vTextureCoord+vec2(offset.x*float(i),0.0))*weight[i];result+=texture2D(uSampler,vTextureCoord-vec2(offset.x*float(i),0.0))*weight[i];}}gl_FragColor=result;}"
              }));
            this.programResult ||
              (this.programResult = new X(a, {
                vertexShader: "attribute vec3 aPos;attribute vec2 aTextureCoord;varying vec2 vTextureCoord;void main(){vTextureCoord=aTextureCoord;gl_Position=vec4(aPos,1.0);}",
                fragmentShader:
                  "precision mediump float;uniform sampler2D originalTexture;uniform sampler2D bloomTexture;uniform float toneScale;varying vec2 vTextureCoord;void main(){vec4 color=texture2D(originalTexture,vTextureCoord)*toneScale;vec4 bloomColor=texture2D(bloomTexture,vTextureCoord);color+=bloomColor;gl_FragColor=color;}"
              }));
            return { programBright: this.programBright, programBloom: this.programBloom, programResult: this.programResult };
          }
        },
        {
          key: "onResize",
          value: function (a) {
            this.collectBrightBuffer = new ya(a);
            this.bloomBuffer = new ya(a);
          }
        },
        {
          key: "getExtraFbo",
          value: function (a) {
            this.collectBrightBuffer || (this.collectBrightBuffer = new ya(a));
            this.bloomBuffer || (this.bloomBuffer = new ya(a));
            return { collectBrightBuffer: this.collectBrightBuffer.framebuffer, bloomBuffer: this.bloomBuffer.framebuffer };
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.texture;
            a = a.fbo;
            var d = this.getOptions(),
              g = "clarity" in d ? d.clarity : 1;
            g = Math.max(0, g);
            g = Math.min(1, g);
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            var k = this.getProgram(c),
              l = k.programBright,
              n = k.programBloom;
            k = k.programResult;
            var m = this.getExtraFbo(c),
              p = m.collectBrightBuffer;
            m = m.bloomBuffer;
            var q = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, q);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array(this.vertex), c.STATIC_DRAW);
            c.enableVertexAttribArray(l.attributes.aPos);
            c.vertexAttribPointer(l.attributes.aPos, 3, c.FLOAT, !1, 0, 0);
            c.enableVertexAttribArray(n.attributes.aPos);
            c.vertexAttribPointer(n.attributes.aPos, 3, c.FLOAT, !1, 0, 0);
            c.enableVertexAttribArray(k.attributes.aPos);
            c.vertexAttribPointer(k.attributes.aPos, 3, c.FLOAT, !1, 0, 0);
            q = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, q);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array(this.sampleCoord), c.STATIC_DRAW);
            c.enableVertexAttribArray(l.attributes.aTextureCoord);
            c.vertexAttribPointer(l.attributes.aTextureCoord, 2, c.FLOAT, !1, 0, 0);
            c.enableVertexAttribArray(n.attributes.aTextureCoord);
            c.vertexAttribPointer(n.attributes.aTextureCoord, 2, c.FLOAT, !1, 0, 0);
            c.enableVertexAttribArray(k.attributes.aTextureCoord);
            c.vertexAttribPointer(k.attributes.aTextureCoord, 2, c.FLOAT, !1, 0, 0);
            c.useProgram(l.program);
            c.bindFramebuffer(c.FRAMEBUFFER, p);
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            c.activeTexture(c.TEXTURE1);
            c.bindTexture(c.TEXTURE_2D, b);
            c.uniform1i(l.uniforms.uSampler, 1);
            c.uniform1f(l.uniforms.threshold, d.threshold || 0);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
            c.useProgram(n.program);
            c.bindFramebuffer(c.FRAMEBUFFER, m);
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            c.activeTexture(c.TEXTURE1);
            c.bindTexture(c.TEXTURE_2D, p.texture);
            c.uniform1i(n.uniforms.uSampler, 1);
            c.uniform1i(n.uniforms.isVertical, !0);
            c.uniform1f(n.uniforms.blurSize, d.blurSize || 2);
            c.uniform1f(n.uniforms.devicePixelRatio, window.devicePixelRatio);
            c.uniform2fv(n.uniforms.canvasSize, [c.canvas.width, c.canvas.height]);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
            c.useProgram(n.program);
            c.bindFramebuffer(c.FRAMEBUFFER, p);
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            c.activeTexture(c.TEXTURE1);
            c.bindTexture(c.TEXTURE_2D, m.texture);
            c.uniform1i(n.uniforms.uSampler, 1);
            c.uniform1i(n.uniforms.isVertical, !1);
            c.uniform1f(n.uniforms.blurSize, d.blurSize || 2);
            c.uniform1f(n.uniforms.devicePixelRatio, window.devicePixelRatio);
            c.uniform2fv(n.uniforms.canvasSize, [c.canvas.width, c.canvas.height]);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
            c.useProgram(k.program);
            c.bindFramebuffer(c.FRAMEBUFFER, a);
            c.clearColor(0, 0, 0, 0);
            c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);
            c.activeTexture(c.TEXTURE1);
            c.bindTexture(c.TEXTURE_2D, b);
            c.uniform1i(k.uniforms.originalTexture, 1);
            c.uniform1f(k.uniforms.toneScale, g);
            c.activeTexture(c.TEXTURE0);
            c.bindTexture(c.TEXTURE_2D, p.texture);
            c.uniform1i(k.uniforms.bloomTexture, 0);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
            c.bindBuffer(c.ARRAY_BUFFER, null);
            c.useProgram(null);
          }
        }
      ]);
      return d;
    })(oc),
    hl = (function (b) {
      function d(a) {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).call(this, a));
      }
      R(d, b);
      I(d, [
        {
          key: "getProgram",
          value: function (a) {
            this.programSample ||
              (this.programSample = new X(a, {
                vertexShader: "attribute vec3 aPos;attribute vec2 aTextureCoord;varying vec2 vTextureCoord;void main(){vTextureCoord=aTextureCoord;gl_Position=vec4(aPos,1.0);}",
                fragmentShader:
                  "precision mediump float;uniform sampler2D uSampler;uniform vec2 canvasSize;varying vec2 vTextureCoord;void main(){float fStep=1.0/312.0;vec4 sample11=texture2D(uSampler,vec2(vTextureCoord.s-1.0*fStep,vTextureCoord.t+1.0*fStep));vec4 sample12=texture2D(uSampler,vec2(vTextureCoord.s,vTextureCoord.t+1.0*fStep));vec4 sample13=texture2D(uSampler,vec2(vTextureCoord.s+1.0*fStep,vTextureCoord.t+1.0*fStep));vec4 sample21=texture2D(uSampler,vec2(vTextureCoord.s-1.0*fStep,vTextureCoord.t));vec4 sample22=texture2D(uSampler,vec2(vTextureCoord.s,vTextureCoord.t));vec4 sample23=texture2D(uSampler,vec2(vTextureCoord.s+1.0*fStep,vTextureCoord.t));vec4 sample31=texture2D(uSampler,vec2(vTextureCoord.s-1.0*fStep,vTextureCoord.t-1.0*fStep));vec4 sample32=texture2D(uSampler,vec2(vTextureCoord.s,vTextureCoord.t-1.0*fStep));vec4 sample33=texture2D(uSampler,vec2(vTextureCoord.s+1.0*fStep,vTextureCoord.t-1.0*fStep));vec4 blurSample=(sample11+sample12+sample13+sample21+2.0*sample22+sample23+sample31+sample32+sample33)/10.0;float desX=abs((gl_FragCoord.x-canvasSize.x/2.0)/(canvasSize.x/2.0));float desY=abs((gl_FragCoord.y-canvasSize.y/2.0)/(canvasSize.y/2.0));float factor=max(desX,desY);gl_FragColor=(sample22*(1.0-factor)+blurSample*factor);}"
              }));
            return this.programSample;
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl;
            a = a.texture;
            var b = this.getProgram(c);
            c.useProgram(b.program);
            var d = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, d);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array(this.vertex), c.STATIC_DRAW);
            c.enableVertexAttribArray(b.attributes.aPos);
            c.vertexAttribPointer(b.attributes.aPos, 3, c.FLOAT, !1, 0, 0);
            d = c.createBuffer();
            c.bindBuffer(c.ARRAY_BUFFER, d);
            c.bufferData(c.ARRAY_BUFFER, new Float32Array(this.sampleCoord), c.STATIC_DRAW);
            c.enableVertexAttribArray(b.attributes.aTextureCoord);
            c.vertexAttribPointer(b.attributes.aTextureCoord, 2, c.FLOAT, !1, 0, 0);
            c.activeTexture(c.TEXTURE1);
            c.bindTexture(c.TEXTURE_2D, a);
            c.uniform1i(b.uniforms.uSampler, 1);
            c.uniform2fv(b.uniforms.canvasSize, [c.canvas.width, c.canvas.height]);
            c.drawArrays(c.TRIANGLES, 0, this.vertex.length / 3);
          }
        }
      ]);
      return d;
    })(oc),
    Th = (function () {
      function b(d) {
        F(this, b);
        this.gl = d;
        this.effects = [];
        this.initFbo();
      }
      I(b, [
        {
          key: "addEffect",
          value: function (b) {
            this.effects.push(b);
          }
        },
        { key: "removeEffect", value: function (b) {} },
        {
          key: "setEffects",
          value: function (b) {
            this.effects = b;
          }
        },
        {
          key: "onResize",
          value: function () {
            this.initFbo();
            var b = this.gl,
              a = this.effects;
            if (a && 1 < a.length)
              for (var c = 1; c < a.length; c++) {
                var f = a[c];
                f.onResize && f.onResize(b);
              }
          }
        },
        {
          key: "initFbo",
          value: function () {
            var b = this.gl;
            b && (this.fbo = [new ya(b), new ya(b)]);
          }
        },
        {
          key: "destroy",
          value: function () {
            this.effects = [];
            this.fbo = [];
            this.gl = null;
          }
        },
        {
          key: "render",
          value: function () {
            var b = this.gl,
              a = this.effects;
            if (a && 0 < a.length)
              for (var c = {}, f = 0; f < a.length; f++) {
                var h = this.fbo[f % 2].framebuffer;
                f === a.length - 1 && (h = null);
                b.bindFramebuffer(b.FRAMEBUFFER, h);
                var g = [0, 0, 0, 0];
                b.clearColor(g[0], g[1], g[2], g[3]);
                b.clear(b.COLOR_BUFFER_BIT | b.DEPTH_BUFFER_BIT);
                a[f].render({ isPickRender: !1, gl: b, texture: c.texture, fbo: h });
                c = h;
              }
          }
        }
      ]);
      return b;
    })(),
    dd = (function () {
      function b(d, a) {
        F(this, b);
        this.map = d;
        this.options = a || {};
        this.eventMap = {};
      }
      I(b, [
        { key: "onResize", value: function (b) {} },
        {
          key: "onUpdate",
          value: function (b) {
            throw "\u672a\u5b9e\u73b0onUpdate\u65b9\u6cd5";
          }
        },
        {
          key: "getContainer",
          value: function () {
            throw "\u672a\u5b9e\u73b0getContainer\u65b9\u6cd5";
          }
        },
        {
          key: "getSize",
          value: function () {
            throw "\u672a\u5b9e\u73b0getSize\u65b9\u6cd5";
          }
        },
        {
          key: "getTilt",
          value: function () {
            throw "\u672a\u5b9e\u73b0getTilt\u65b9\u6cd5";
          }
        },
        {
          key: "getHeading",
          value: function () {
            throw "\u672a\u5b9e\u73b0getHeading\u65b9\u6cd5";
          }
        },
        {
          key: "getZoomUnits",
          value: function () {
            throw "\u672a\u5b9e\u73b0getZoomUnits\u65b9\u6cd5";
          }
        },
        {
          key: "getCenter",
          value: function () {
            throw "\u672a\u5b9e\u73b0getCenter\u65b9\u6cd5";
          }
        },
        {
          key: "getMapType",
          value: function () {
            throw "\u672a\u5b9e\u73b0getMapType\u65b9\u6cd5";
          }
        },
        {
          key: "lnglatToMercator",
          value: function (b, a) {
            if ("gcj02" === this.options.coordinateSystem)
              return (
                (a = (a * Math.PI) / 180),
                (a = 3189068.5 * Math.log((1 + Math.sin(a)) / (1 - Math.sin(a)))),
                [parseFloat((((b * Math.PI) / 180) * 6378137).toFixed(2)), parseFloat(a.toFixed(2))]
              );
            b = Ea.convertLL2MC({ lng: b, lat: a });
            return [b.lng, b.lat];
          }
        }
      ]);
      return b;
    })(),
    il = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.eventMap = {};
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "onResize",
          value: function (a) {
            this.map.addEventListener("resize", a);
            this.eventMap.resize = a;
          }
        },
        {
          key: "onMousemove",
          value: function (a) {
            a = this.extendCallback(a);
            this.map.addEventListener("mousemove", a);
            this.eventMap.mousemove = a;
          }
        },
        {
          key: "onClick",
          value: function (a) {
            a = this.extendCallback(a);
            this.map.addEventListener("click", a);
            this.eventMap.click = a;
          }
        },
        {
          key: "onDblClick",
          value: function (a) {
            a = this.extendCallback(a);
            this.map.addEventListener("dblclick", a);
            this.eventMap.dblclick = a;
          }
        },
        {
          key: "onRightClick",
          value: function (a) {
            a = this.extendCallback(a);
            this.map.addEventListener("rightclick", a);
            this.eventMap.rightclick = a;
          }
        },
        {
          key: "onUpdate",
          value: function (a) {
            this.map.addEventListener("update", a);
            this.map.addEventListener("onearthstatuschange", a);
            this.eventMap.update = a;
            this.eventMap.onearthstatuschange = a;
          }
        },
        {
          key: "extendCallback",
          value: function (a) {
            return function (c) {
              a(S(c, { x: c.x, y: c.y }));
            };
          }
        },
        {
          key: "unbind",
          value: function (a) {
            var c = this;
            this.eventMap[a]
              ? (this.map.removeEventListener(a, this.eventMap[a]), delete this.eventMap[a])
              : (qa(this.eventMap).forEach(function (a) {
                  c.map.removeEventListener(a, c.eventMap[a]);
                }),
                (this.eventMap = {}));
          }
        },
        {
          key: "getContainer",
          value: function () {
            return this.map.getContainer();
          }
        },
        {
          key: "getSize",
          value: function () {
            return this.map.getSize();
          }
        },
        {
          key: "getBounds",
          value: function () {
            return this.map.getBounds();
          }
        },
        {
          key: "getTilt",
          value: function () {
            return this.map.getTilt();
          }
        },
        {
          key: "getHeading",
          value: function () {
            return this.map.getHeading();
          }
        },
        {
          key: "getZoomUnits",
          value: function () {
            return this.map.getZoomUnits();
          }
        },
        {
          key: "getZoom",
          value: function () {
            return this.map.getZoom();
          }
        },
        {
          key: "getCenter",
          value: function () {
            var a = this.map.getCenter();
            -180 <= a.lng && 180 >= a.lng && ((a = this.map.lnglatToMercator(a.lng, a.lat)), (a = { lng: a[0], lat: a[1] }));
            return a;
          }
        },
        {
          key: "getMapType",
          value: function () {
            return this.map.getMapType();
          }
        },
        {
          key: "lnglatToMercator",
          value: function (a, c) {
            return this.map.lnglatToMercator(a, c);
          }
        },
        {
          key: "mercatorToLnglat",
          value: function (a, c) {
            return this.map.mercatorToLnglat(a, c);
          }
        },
        {
          key: "pixelToPointIn",
          value: function (a) {
            a = this.map.pixelToPointIn(a);
            return this.mercatorToLnglat(a.lng, a.lat);
          }
        }
      ]);
      return d;
    })(dd),
    jl = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.div = document.createElement("div");
        a.div.style.position = "absolute";
        a.div.style.userSelect = "none";
        a.map.getPanes().mapPane.appendChild(a.div);
        a.eventMap = {};
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "onResize",
          value: function (a) {
            this.map.addEventListener("resize", a);
            this.eventMap.resize = a;
          }
        },
        {
          key: "onMousemove",
          value: function (a) {
            a = this.extendCallback(a);
            this.map.addEventListener("mousemove", a);
            this.eventMap.mousemove = a;
          }
        },
        {
          key: "onClick",
          value: function (a) {
            a = this.extendCallback(a);
            fh ? (this.map.addEventListener("touchend", a), (this.eventMap.touchend = a)) : (this.map.addEventListener("click", a), (this.eventMap.click = a));
          }
        },
        {
          key: "onDblClick",
          value: function (a) {
            a = this.extendCallback(a);
            this.map.addEventListener("dblclick", a);
            this.eventMap.dblclick = a;
          }
        },
        {
          key: "onRightClick",
          value: function (a) {
            a = this.extendCallback(a);
            this.map.addEventListener("rightclick", a);
            this.eventMap.rightclick = a;
          }
        },
        {
          key: "changeCanvas",
          value: function () {
            var a = this.map,
              c = a.getSize(),
              b = a.getCenter();
            a = a.pointToOverlayPixel(b);
            this.div.style.left = a.x - c.width / 2 + "px";
            this.div.style.top = a.y - c.height / 2 + "px";
          }
        },
        {
          key: "onUpdate",
          value: function (a) {
            var c = this,
              b = function () {
                c.changeCanvas();
                a();
              };
            this.map.addEventListener("moveend", b);
            this.map.addEventListener("moving", b);
            this.map.addEventListener("zoomend", b);
            this.eventMap.moveend = b;
            this.eventMap.moving = b;
            this.eventMap.zoomend = b;
          }
        },
        {
          key: "extendCallback",
          value: function (a) {
            return function (c) {
              a(S(c, { x: c.pixel.x, y: c.pixel.y }));
            };
          }
        },
        {
          key: "unbind",
          value: function () {
            var a = this;
            qa(this.eventMap).forEach(function (c) {
              a.map.removeEventListener(c, a.eventMap[c]);
            });
            this.eventMap = {};
          }
        },
        {
          key: "getContainer",
          value: function () {
            return this.div;
          }
        },
        {
          key: "getSize",
          value: function () {
            return this.map.getSize();
          }
        },
        {
          key: "getBounds",
          value: function () {
            return this.map.getBounds();
          }
        },
        {
          key: "getTilt",
          value: function () {
            return 0;
          }
        },
        {
          key: "getHeading",
          value: function () {
            return 0;
          }
        },
        {
          key: "getZoom",
          value: function () {
            return this.map.getZoom();
          }
        },
        {
          key: "getZoomUnits",
          value: function () {
            var a = this.getZoom();
            return this.map.getMapType().getZoomUnits ? this.map.getMapType().getZoomUnits(a) : Math.pow(2, 18 - a);
          }
        },
        {
          key: "getCenter",
          value: function () {
            var a = this.map.getMapType().getProjection().lngLatToPoint(this.map.getCenter());
            return { lng: a.x, lat: a.y };
          }
        },
        {
          key: "lnglatToMercator",
          value: function (a, c) {
            a = this.map.getMapType().getProjection().lngLatToPoint({ lng: a, lat: c });
            return [a.x, a.y];
          }
        },
        {
          key: "mercatorToLnglat",
          value: function (a, c) {
            a = this.map.getMapType().getProjection().pointToLngLat({ lng: a, lat: c });
            return [a.lng, a.lat];
          }
        }
      ]);
      return d;
    })(dd),
    kl = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.eventMap = {};
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "onResize",
          value: function (a) {
            window.addEventListener("resize", a);
            this.eventMap.resize = a;
          }
        },
        { key: "onUpdate", value: function (a) {} },
        {
          key: "unbind",
          value: function () {
            var a = this;
            qa(this.eventMap).forEach(function (c) {
              window.removeEventListener(c, a.eventMap[c]);
            });
            this.eventMap = {};
          }
        },
        {
          key: "getContainer",
          value: function () {
            return this.map.container.getElementsByClassName("cesium-widget")[0];
          }
        },
        {
          key: "getSize",
          value: function () {
            var a = this.map;
            return { width: a.canvas.clientWidth, height: a.canvas.clientHeight };
          }
        },
        {
          key: "getTilt",
          value: function () {
            return (180 * this.map.camera.pitch) / Math.PI + 90;
          }
        },
        {
          key: "getHeading",
          value: function () {
            return 360 - (180 * this.map.camera.heading) / Math.PI;
          }
        },
        {
          key: "getZoomUnits",
          value: function () {
            var a = this.map;
            return (6.8 * a.scene.globe.ellipsoid.cartesianToCartographic(a.camera.position).height) / 6500;
          }
        },
        {
          key: "getZoom",
          value: function () {
            return 10;
          }
        },
        {
          key: "getCenter",
          value: function () {
            var a = this.map;
            a = a.camera.pickEllipsoid(new Cesium.Cartesian2(a.canvas.clientWidth / 2, a.canvas.clientHeight / 2));
            a = Cesium.Ellipsoid.WGS84.cartesianToCartographic(a);
            a = this.getMercator([(180 * a.longitude) / Math.PI, (180 * a.latitude) / Math.PI]);
            return { lng: a[0], lat: a[1] };
          }
        },
        {
          key: "getMercator",
          value: function (a) {
            var c = [];
            c[0] = ((a[0] * Math.PI) / 180) * 6378137;
            a = (a[1] * Math.PI) / 180;
            c[1] = 3189068.5 * Math.log((1 + Math.sin(a)) / (1 - Math.sin(a)));
            return c;
          }
        }
      ]);
      return d;
    })(dd),
    ll = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.eventMap = {};
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "onResize",
          value: function (a) {
            window.addEventListener("resize", a);
            this.eventMap.resize = a;
          }
        },
        { key: "onUpdate", value: function (a) {} },
        {
          key: "unbind",
          value: function () {
            var a = this;
            qa(this.eventMap).forEach(function (c) {
              window.removeEventListener(c, a.eventMap[c]);
            });
            this.eventMap = {};
          }
        },
        {
          key: "getContainer",
          value: function () {
            return this.map.container;
          }
        },
        {
          key: "getSize",
          value: function () {
            return { width: this.map.container.clientWidth, height: this.map.container.clientHeight };
          }
        },
        {
          key: "getTilt",
          value: function () {
            return this.map.tilt;
          }
        },
        {
          key: "getHeading",
          value: function () {
            return this.map.heading;
          }
        },
        {
          key: "getZoomUnits",
          value: function () {
            return this.map.zoomUnits;
          }
        },
        {
          key: "getZoom",
          value: function () {
            return this.map.zoom;
          }
        },
        {
          key: "getCenter",
          value: function () {
            return this.map.center;
          }
        }
      ]);
      return d;
    })(dd),
    ml = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.eventMap = {};
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "onResize",
          value: function (a) {
            window.addEventListener("resize", a);
            this.eventMap.resize = a;
          }
        },
        { key: "onUpdate", value: function (a) {} },
        {
          key: "unbind",
          value: function () {
            var a = this;
            qa(this.eventMap).forEach(function (c) {
              window.removeEventListener(c, a.eventMap[c]);
            });
            this.eventMap = {};
          }
        },
        {
          key: "getContainer",
          value: function () {
            return this.map.container;
          }
        },
        {
          key: "getSize",
          value: function () {
            return { width: this.map.container.clientWidth, height: this.map.container.clientHeight };
          }
        },
        {
          key: "getTilt",
          value: function () {
            return this.map.tilt;
          }
        },
        {
          key: "getHeading",
          value: function () {
            return this.map.heading;
          }
        },
        {
          key: "getZoomUnits",
          value: function () {
            return this.map.zoomUnits;
          }
        },
        {
          key: "getCenter",
          value: function () {
            return this.map.center;
          }
        }
      ]);
      return d;
    })(dd),
    Uh = (function () {
      function b(d, a) {
        var c = this;
        F(this, b);
        a = a || {};
        "bmap" === a.mapType
          ? (this.map = new jl(d, a))
          : "blank" === a.mapType
          ? (this.map = new ll(d, a))
          : "cesium" === a.mapType
          ? (this.map = new kl(d, a))
          : "three" === a.mapType
          ? (this.map = new ml(d, a))
          : ((a.mapType = "bmapgl"), (this.map = new il(d, a)));
        this.map.type = a.mapType;
        this._dpr = window.devicePixelRatio;
        "bmapgl" === a.mapType && (this._dpr = this.map.map.config.ratio);
        this.options = a || {};
        this.renderArr = [];
        (d = a.canvas) || (d = document.createElement("canvas"));
        this.canvas = d;
        this.gl = a.gl ? a.gl : Qf(d, a);
        ["OES_texture_float", "OES_element_index_uint", "WEBGL_color_buffer_float", "EXT_float_blend"].forEach(function (a) {
          c.gl.getExtension(a);
        });
        this.changeSize();
        this.projectionMatrix = L.create(Float64Array);
        this.orthoMatrix = L.create(Float64Array);
        this.matrix = L.create(Float64Array);
        this.viewMatrix = L.create(Float64Array);
        this.pointToPixelMatrix = L.create(Float64Array);
        this.pixelToViewMatrix = L.create(Float64Array);
        this.fovy = 35;
        this.fps = Math.min(a.fps, 60) || 60;
        this.renderTime = new Date().valueOf();
        this._animation = this.animation.bind(this);
        this._update = this.update.bind(this);
        this.onInitialize(this.options.onInitialize);
        this.options.onRender && this.renderArr.push(this.options.onRender);
        this.stateManager = new Sh({ gl: this.gl });
        this.pickFBO = new ya(this.gl);
        this.transferOptions = {};
        this.bind();
      }
      I(b, [
        {
          key: "bind",
          value: function () {
            var b = this,
              a = this.map;
            a.onResize(function () {
              b.changeSize();
              b.render();
            });
            a.onUpdate(this._update);
            a.onClick &&
              a.onClick(function (a) {
                b.onClick && b.onClick(a);
              });
            a.onDblClick &&
              a.onDblClick(function (a) {
                b.onDblClick && b.onDblClick(a);
              });
            a.onRightClick &&
              a.onRightClick(function (a) {
                b.onRightClick && b.onRightClick(a);
              });
            a.onMousemove &&
              a.onMousemove(function (a) {
                b.onMousemove && b.onMousemove(a);
              });
            this.options.canvas || a.getContainer().appendChild(this.canvas);
          }
        },
        {
          key: "unbind",
          value: function () {
            var b = this.map;
            b.unbind && b.unbind();
          }
        },
        {
          key: "setOptions",
          value: function (b) {
            this.options = b;
          }
        },
        {
          key: "onInitialize",
          value: function (b) {
            b && (this.transferOptions = b.bind(this)(this.gl) || {});
          }
        },
        {
          key: "bindFramebuffer",
          value: function (b) {
            var a = this.gl;
            b ? a.bindFramebuffer(a.FRAMEBUFFER, b.framebuffer) : a.bindFramebuffer(a.FRAMEBUFFER, null);
          }
        },
        {
          key: "saveFramebuffer",
          value: function () {
            var b = this.gl;
            this.preFramebuffer = b.getParameter(b.FRAMEBUFFER_BINDING);
          }
        },
        {
          key: "restoreFramebuffer",
          value: function () {
            var b = this.gl;
            b.bindFramebuffer(b.FRAMEBUFFER, this.preFramebuffer);
          }
        },
        {
          key: "onRender",
          value: function (b) {
            this.renderArr.push(b);
          }
        },
        {
          key: "changeSize",
          value: function () {
            var b = this.canvas,
              a = this.options;
            if (b) {
              var c = b.style,
                f = this.map.getSize(),
                h = this._dpr;
              b.width = f.width * h;
              b.height = f.height * h;
              c.cssText = "position: absolute;left:0;top:0;width:" + f.width + "px;height:" + f.height + "px;z-index:2;";
              "cesium" !== a.mapType || a.canvas || (c.pointerEvents = "none");
              this.gl.viewport(0, 0, b.width, b.height);
            }
          }
        },
        {
          key: "update",
          value: function () {
            !1 === this.options.autoUpdate || (this.isAnimation && 60 <= this.fps) || this.render();
          }
        },
        {
          key: "pixelToPointIn",
          value: function (b) {
            return this.map.pixelToPointIn(b);
          }
        },
        {
          key: "render",
          value: function () {
            if (this.map && this.gl) {
              var b = this.options,
                a = this.projectionMatrix,
                c = this.viewMatrix;
              if ("three" === b.mapType) (c = this.map.map.camera), (a = c.projectionMatrix.elements), (c = c.matrixWorldInverse.elements);
              else if ("cesium" === b.mapType) {
                c = this.map.map;
                var f = c.camera.frustum.projectionMatrix;
                a = new Float32Array([f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7], f[8], f[9], f[10], f[11], f[12], f[13], f[14], f[15]]);
                f = c.camera.viewMatrix;
                c = new Float32Array([f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7], f[8], f[9], f[10], f[11], f[12], f[13], f[14], f[15]]);
              } else
                "B_EARTH_MAP" === this.map.map.mapType
                  ? ((a = this.map.map.getEarth().scene._camera.getProjectionMatrix()), (c = this.map.map.getEarth().scene._camera.getModelViewMatrix()))
                  : (this.updateProjectionMatrix(), this.updateModelViewMatrix());
              f = L.multiply(this.matrix, a, c);
              S(this.transferOptions, {
                gl: this.gl,
                matrix: f,
                pointToPixelMatrix: this.pointToPixelMatrix,
                pixelToViewMatrix: this.pixelToViewMatrix,
                projectionMatrix: a,
                orthoMatrix: this.orthoMatrix,
                viewMatrix: c,
                stateManager: this.stateManager
              });
              "three" !== b.mapType && "cesium" !== b.mapType && !1 !== b.autoUpdate && this.clear();
              for (b = 0; b < this.renderArr.length; b++) this.renderArr[b] && this.renderArr[b].bind(this)(this.transferOptions);
            }
          }
        },
        {
          key: "clear",
          value: function (b) {
            var a = this.gl,
              c = this.options.clearColor || [0, 0, 0, 0];
            a.clearColor(c[0], c[1], c[2], c[3]);
            b && (b instanceof Array || (b = ka(b).unitArray()), a.clearColor(b[0], b[1], b[2], b[3]));
            a.clear(a.COLOR_BUFFER_BIT | a.DEPTH_BUFFER_BIT);
          }
        },
        {
          key: "updateProjectionMatrix",
          value: function () {
            var b = this.gl.canvas.width / this.gl.canvas.height,
              a = this.options.cameraNear || 1,
              c = this.options.cameraFar || 4e3;
            L.perspective(this.projectionMatrix, za(this.fovy), b, a, c);
            b = this.map.getSize();
            L.ortho(this.orthoMatrix, -b.width / 2, b.width / 2, -b.height / 2, b.height / 2, a, c);
          }
        },
        {
          key: "updateModelViewMatrix",
          value: function () {
            var b = this.map,
              a = this.viewMatrix,
              c = this.pointToPixelMatrix,
              f = this.pixelToViewMatrix;
            L.identity(a);
            L.identity(c);
            L.identity(f);
            var h = b.getSize();
            h = Math.round(-h.height / (2 * Math.tan(za(this.fovy) / 2)));
            L.translate(f, f, [0, 0, h]);
            L.rotate(f, f, za(b.getTilt()), [-1, 0, 0]);
            L.rotate(f, f, za(b.getHeading()), [0, 0, -1]);
            h = b.getCenter();
            var g = this.options.pointOffset || [0, 0];
            b = b.getZoomUnits();
            L.translate(c, c, [(g[0] - h.lng) / b, (g[1] - h.lat) / b, 0]);
            b = 1 / b;
            L.scale(c, c, [b, b, b]);
            L.multiply(a, f, c);
          }
        },
        {
          key: "destroy",
          value: function () {
            this.stopAnimation();
            this.unbind();
            var b = this.gl.getExtension("WEBGL_lose_context");
            b && b.loseContext();
            this.map.getContainer().removeChild(this.canvas);
            this.gl = this.canvas = null;
          }
        },
        {
          key: "animation",
          value: function () {
            if (this.isAnimation) {
              if (60 <= this.fps) this.render();
              else {
                var b = new Date().valueOf(),
                  a = Math.floor(1e3 / this.fps),
                  c = b - this.renderTime;
                c > a && (this.render(), (this.renderTime = b - (c % a)));
              }
              window.requestAnimationFrame(this._animation);
            }
          }
        },
        {
          key: "startAnimation",
          value: function () {
            this.isAnimation || ((this.isAnimation = !0), window.requestAnimationFrame(this._animation));
          }
        },
        {
          key: "stopAnimation",
          value: function () {
            this.isAnimation = !1;
          }
        }
      ]);
      return b;
    })(),
    nl = (function () {
      function b(d) {
        F(this, b);
        this.layers = [];
        this.options = d;
        this.webglLayer = d.webglLayer;
      }
      I(b, [
        {
          key: "addLayer",
          value: function (b) {
            for (var a = !1, c = 0; c < this.layers.length; c++)
              if (this.layers[c] === b) {
                a = !0;
                break;
              }
            a ||
              ((b.map = this.webglLayer.map),
              "threeLayer" === b.layerType
                ? (b.setWebglLayer(this.webglLayer), (a = b.getThreeLayer()), this.addLayer(a), b.initialize && b.initialize(a))
                : (b.setWebglLayer(this.webglLayer),
                  b.commonInitialize && b.commonInitialize(this.webglLayer.gl),
                  b.initialize && b.initialize(this.webglLayer.gl),
                  b.onOptionsChanged(b.getOptions(), {}),
                  b.onDataChanged(b.getData()),
                  b.onChanged(b.getOptions(), b.getData())),
              this.putInLayer(b));
            this.options.autoUpdate && (this.isRequestAnimation() ? this.webglLayer.startAnimation() : this.webglLayer.stopAnimation());
            this.webglLayer.render();
          }
        },
        {
          key: "putInLayer",
          value: function (b) {
            void 0 === b.options.renderOrder && (b.options.renderOrder = this.layers.length);
            this.layers.push(b);
            this.layers = this.layers.sort(function (a, c) {
              return a.options.renderOrder - c.options.renderOrder;
            });
          }
        },
        {
          key: "removeLayer",
          value: function (b) {
            for (var a = 0; a < this.layers.length; a++) this.layers[a] === b && this.layers.splice(a, 1);
            this.options.autoUpdate && (this.isRequestAnimation() ? this.webglLayer.startAnimation() : this.webglLayer.stopAnimation());
            this.webglLayer.render();
          }
        },
        {
          key: "showLayer",
          value: function (b) {
            for (var a = 0; a < this.layers.length; a++) this.layers[a] === b && b.show();
            this.options.autoUpdate && (this.isRequestAnimation() ? this.webglLayer.startAnimation() : this.webglLayer.stopAnimation());
            this.webglLayer.render();
          }
        },
        {
          key: "hideLayer",
          value: function (b) {
            for (var a = 0; a < this.layers.length; a++) this.layers[a] === b && b.hide();
            this.options.autoUpdate && (this.isRequestAnimation() ? this.webglLayer.startAnimation() : this.webglLayer.stopAnimation());
            this.webglLayer.render();
          }
        },
        {
          key: "removeAllLayers",
          value: function () {
            this.layers = [];
            this.webglLayer.stopAnimation();
            this.webglLayer.render();
          }
        },
        {
          key: "destroyAllLayers",
          value: function () {
            for (var b = 0; b < this.layers.length; b++) {
              var a = this.layers[b];
              a.destroy && a.destroy();
            }
          }
        },
        {
          key: "getAllLayers",
          value: function () {
            return this.layers;
          }
        },
        {
          key: "getAllThreeLayers",
          value: function () {
            for (var b = [], a = 0; a < this.layers.length; a++) {
              var c = this.layers[a];
              "ThreeLayer" === c.layerType && b.push(c);
            }
            return b;
          }
        },
        {
          key: "isRequestAnimation",
          value: function () {
            for (var b = !1, a = 0; a < this.layers.length; a++)
              if (this.layers[a].isRequestAnimation()) {
                b = !0;
                break;
              }
            return b;
          }
        },
        {
          key: "beforeRender",
          value: function (b) {
            b.gl && this.webglLayer.stateManager.setDefaultState();
          }
        },
        {
          key: "afterRender",
          value: function (b) {
            if ((b = b.gl)) b.bindBuffer(b.ARRAY_BUFFER, null), b.bindBuffer(b.ELEMENT_ARRAY_BUFFER, null), b.useProgram(null);
          }
        },
        {
          key: "renderGLLayers",
          value: function (b) {
            this.webglLayer.stateManager.save();
            for (var a = 0; a < this.layers.length; a++) {
              var c = this.layers[a];
              if (!0 === c._visible && "threeLayer" !== c.layerType && "ThreeLayer" !== c.layerType) {
                var d = c.map.getZoom(),
                  h = c.getOptions().zoomThreshold;
                (h && (d < h[0] || d >= h[1])) || (this.beforeRender(b), c.render(b), this.afterRender(b));
              }
            }
            this.webglLayer.stateManager.restore();
          }
        },
        {
          key: "renderThreeLayer",
          value: function (b) {
            this.webglLayer.stateManager.save();
            this.webglLayer.stateManager.setState({ blendFunc: [b.gl.SRC_ALPHA, b.gl.ONE], depthMask: !1, depthTest: !0, depthFunc: b.gl.LESS, cullFace: !1 });
            for (var a = 0; a < this.layers.length; a++) {
              var c = this.layers[a];
              if (!0 === c._visible && "ThreeLayer" === c.layerType) {
                var d = c.map.getZoom(),
                  h = c.getOptions().zoomThreshold;
                (h && (d < h[0] || d >= h[1])) || c.render(b);
              }
            }
            this.webglLayer.stateManager.restore();
          }
        },
        {
          key: "renderThreeLayers",
          value: function (b) {
            this.webglLayer.stateManager.save();
            this.webglLayer.stateManager.setState({ blendFunc: [b.gl.SRC_ALPHA, b.gl.ONE], depthMask: !1, depthTest: !0, depthFunc: b.gl.LESS, cullFace: !1 });
            for (var a = 0; a < this.layers.length; a++) {
              var c = this.layers[a];
              if (!0 === c._visible && "threeLayer" === c.layerType) {
                var d = c.map.getZoom(),
                  h = c.getOptions().zoomThreshold;
                (h && (d < h[0] || d >= h[1])) || c.render(b);
              }
            }
            this.webglLayer.stateManager.restore();
          }
        },
        {
          key: "onClick",
          value: function (b) {
            for (var a = 0; a < this.layers.length; a++) {
              var c = this.layers[a];
              if (!0 === c._visible && "threeLayer" !== c.layerType && "ThreeLayer" !== c.layerType) {
                var d = c.map.getZoom(),
                  h = c.getOptions().zoomThreshold;
                (h && (d <= h[0] || d >= h[1])) ||
                  !c.options.enablePicked ||
                  !c.options.onClick ||
                  !c.pick ||
                  ((d = c.pick(b.x, b.y, "onClick")), c.options.onClick(d, b), c.options.autoSelect && this.webglLayer.render());
              }
            }
          }
        },
        {
          key: "onDblClick",
          value: function (b) {
            for (var a = 0; a < this.layers.length; a++) {
              var c = this.layers[a];
              if (!0 === c._visible && "threeLayer" !== c.layerType && "ThreeLayer" !== c.layerType) {
                var d = c.map.getZoom(),
                  h = c.getOptions().zoomThreshold;
                (h && (d <= h[0] || d >= h[1])) ||
                  !c.options.enablePicked ||
                  !c.options.onDblClick ||
                  !c.pick ||
                  ((d = c.pick(b.x, b.y, "onDblClick")), c.options.onDblClick(d, b), c.options.autoSelect && this.webglLayer.render());
              }
            }
          }
        },
        {
          key: "onRightClick",
          value: function (b) {
            for (var a = 0; a < this.layers.length; a++) {
              var c = this.layers[a];
              if (!0 === c._visible && "threeLayer" !== c.layerType && "ThreeLayer" !== c.layerType) {
                var d = c.map.getZoom(),
                  h = c.getOptions().zoomThreshold;
                (h && (d <= h[0] || d >= h[1])) ||
                  !c.options.enablePicked ||
                  !c.options.onRightClick ||
                  !c.pick ||
                  ((d = c.pick(b.x, b.y, "onRightClick")), c.options.onRightClick(d, b), c.options.autoSelect && this.webglLayer.render());
              }
            }
          }
        },
        {
          key: "onMousemove",
          value: function (b) {
            for (var a = !1, c = 0; c < this.layers.length; c++) {
              var d = this.layers[c];
              if (!0 === d._visible && "threeLayer" !== d.layerType && "ThreeLayer" !== d.layerType) {
                var h = d.map.getZoom(),
                  g = d.getOptions().zoomThreshold;
                if ((!g || !(h <= g[0] || h >= g[1])) && d.options.enablePicked && d.pick && (d.options.onMousemove || d.options.autoSelect)) {
                  h = d.pick(b.x, b.y, "onMousemove");
                  this.webglLayer.map.map.platform.style.cursor = -1 === h.dataIndex ? "default" : "pointer";
                  if (d.options.onMousemove) d.options.onMousemove(h, b);
                  d.options.autoSelect && (a = !0);
                }
              }
            }
            a && (this.webglLayer.isAnimation || this.webglLayer.render());
          }
        },
        {
          key: "destroy",
          value: function () {
            this.destroyAllLayers();
            this.removeAllLayers();
          }
        }
      ]);
      return b;
    })(),
    nf = (function () {
      function b(d) {
        var a = this;
        F(this, b);
        this.options = { autoUpdate: !0 };
        this._visible = !0;
        S(this.options, d);
        var c = d.pointOffset;
        this.webglLayer = d.webglLayer || new Uh(d.map, this.options);
        this.layerManager = new nl({ autoUpdate: this.options.autoUpdate, webglLayer: this.webglLayer });
        this.effectManager = new Th(this.webglLayer.gl);
        this.webglRender = { render: function () {} };
        this.options.effects && this.effectManager.setEffects([this.webglRender].concat(this.options.effects));
        this.webglLayer.onRender(function (c) {
          a._render(c);
        });
        this.webglLayer.onClick = function (c) {
          a._visible && a.layerManager.onClick(c);
        };
        this.webglLayer.onDblClick = function (c) {
          a._visible && a.layerManager.onDblClick(c);
        };
        this.webglLayer.onRightClick = function (c) {
          a._visible && a.layerManager.onRightClick(c);
        };
        this.webglLayer.onMousemove = function (c) {
          a._visible && a.layerManager.onMousemove(c);
        };
        c || "cesium" === this.webglLayer.options.mapType || ((c = this.webglLayer.map.getCenter()), (this.webglLayer.options.pointOffset = [c.lng, c.lat]));
        this.webglLayer.map.onResize(function () {
          a.effectManager.onResize();
        });
        if ((this.postProcessing = d.postProcessing))
          this.postProcessing.setWebglLayer(this.webglLayer),
            (d = this.postProcessing.getThreeLayer()),
            this.addLayer(d),
            this.postProcessing.initialize(d),
            (d.postProcessing = this.postProcessing);
      }
      I(b, [
        {
          key: "renderCanvas",
          value: function (b) {
            var a = this;
            this.postProcessing
              ? this.postProcessing.addRender(function () {
                  a.layerManager.renderGLLayers(b);
                })
              : this.layerManager.renderGLLayers(b);
            this.layerManager.renderThreeLayers(b);
            this.layerManager.renderThreeLayer(b);
          }
        },
        {
          key: "render",
          value: function () {
            this.webglLayer && this.webglLayer.render();
          }
        },
        {
          key: "_render",
          value: function (b) {
            var a = this;
            if (this._visible) {
              var c = this.options.effects;
              c && 0 < c.length
                ? ((this.webglRender.render = function () {
                    a.renderCanvas(b);
                  }),
                  this.effectManager.render())
                : (this.webglLayer.saveFramebuffer(), this.renderCanvas(b), this.webglLayer.restoreFramebuffer());
            }
          }
        },
        {
          key: "onRender",
          value: function (b) {
            this.webglLayer.onRender(b);
          }
        },
        {
          key: "destroy",
          value: function () {
            this.stopAnimation();
            this.layerManager.destroy();
            this.effectManager.destroy();
            this.webglLayer.destroy();
          }
        },
        {
          key: "isRequestAnimation",
          value: function () {
            return this.layerManager.isRequestAnimation();
          }
        },
        {
          key: "startAnimation",
          value: function () {
            this.webglLayer.startAnimation();
          }
        },
        {
          key: "stopAnimation",
          value: function () {
            this.webglLayer.stopAnimation();
          }
        },
        {
          key: "show",
          value: function () {
            !0 !== this._visible && ((this._visible = !0), this.webglLayer.render(), this.isRequestAnimation() && this.startAnimation());
          }
        },
        {
          key: "hide",
          value: function () {
            !1 !== this._visible && ((this._visible = !1), this.stopAnimation(), this.webglLayer.clear());
          }
        },
        {
          key: "showLayer",
          value: function (b) {
            this.layerManager.showLayer(b);
          }
        },
        {
          key: "hideLayer",
          value: function (b) {
            this.layerManager.hideLayer(b);
          }
        },
        {
          key: "add",
          value: function (b) {
            this.addLayer(b);
          }
        },
        {
          key: "remove",
          value: function (b) {
            this.removeLayer(b);
          }
        },
        {
          key: "addLayer",
          value: function (b) {
            this.layerManager.addLayer(b);
          }
        },
        {
          key: "removeLayer",
          value: function (b) {
            this.layerManager.removeLayer(b);
          }
        },
        {
          key: "removeAllLayers",
          value: function () {
            this.layerManager.removeAllLayers();
          }
        },
        {
          key: "getAllLayers",
          value: function () {
            return this.layerManager.getAllLayers();
          }
        },
        {
          key: "getAllThreeLayers",
          value: function () {
            return this.layerManager.getAllThreeLayers();
          }
        }
      ]);
      return b;
    })(),
    of = (function () {
      function b(d) {
        F(this, b);
        this._visible = !0;
        this.options = this.getCommonDefaultOptions();
        this.options = S(this.options, this.getDefaultOptions());
        this.autoUpdate = !1;
        this.options = S(this.options, d);
        this.options.data && ((this.data = this.options.data), delete this.options.data);
      }
      I(b, [
        {
          key: "getCommonDefaultOptions",
          value: function () {
            return {};
          }
        },
        {
          key: "getDefaultOptions",
          value: function () {
            return {};
          }
        },
        { key: "initialize", value: function (b) {} },
        {
          key: "destroy",
          value: function () {
            this.onDestroy && this.onDestroy();
          }
        },
        {
          key: "show",
          value: function () {
            this._visible = !0;
          }
        },
        {
          key: "hide",
          value: function () {
            this._visible = !1;
          }
        },
        { key: "render", value: function () {} },
        {
          key: "clear",
          value: function () {
            this.setData([]);
          }
        },
        {
          key: "setData",
          value: function (b, a) {
            a = a || {};
            this.data = b;
            this.onDataChanged && this.onDataChanged(this.getData());
            this.onChanged && this.onChanged(this.getOptions(), this.getData(), a);
            !1 !== a.autoRender && this.webglLayer && this.webglLayer.render();
          }
        },
        {
          key: "getData",
          value: function () {
            return this.data || [];
          }
        },
        {
          key: "setOptions",
          value: function (b, a) {
            b = b || {};
            a = a || {};
            var c = S({}, this.getOptions());
            S(this.options, b);
            this.onOptionsChanged && this.onOptionsChanged(this.getOptions(), c);
            this.onChanged && this.onChanged(this.getOptions(), this.getData(), a);
            b.data ? (this.setData(b.data, a), delete b.data) : !1 !== a.autoRender && this.webglLayer && this.webglLayer.render();
          }
        },
        {
          key: "getOptions",
          value: function () {
            return this.options || {};
          }
        },
        { key: "onOptionsChanged", value: function (b, a) {} },
        { key: "onDataChanged", value: function (b) {} },
        { key: "onChanged", value: function (b, a) {} },
        { key: "onDestroy", value: function () {} },
        { key: "lnglatToMercator", value: function (b, a) {} },
        {
          key: "setWebglLayer",
          value: function (b) {
            this.webglLayer = b;
          }
        },
        {
          key: "getWebglLayer",
          value: function () {
            return this.webglLayer;
          }
        },
        {
          key: "isRequestAnimation",
          value: function () {
            return this.autoUpdate;
          }
        }
      ]);
      return b;
    })(),
    ca = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.pickedColor = [-1, -1, -1];
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getCommonDefaultOptions",
          value: function () {
            return {
              pickWidth: 1,
              pickHeight: 1,
              blend: "default",
              zIndex: 0,
              zoomThreshold: [0, 30],
              repeat: !1,
              enablePicked: !1,
              autoSelect: !1,
              selectedIndex: -1,
              selectedColor: "rgba(20, 20, 200, 1.0)"
            };
          }
        },
        {
          key: "commonInitialize",
          value: function (a) {
            var c = this.getOptions();
            this.gl = a;
            c.enablePicked && (this.pickBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" }));
          }
        },
        {
          key: "getCommonAttributes",
          value: function () {
            var a = [];
            this.getOptions().enablePicked && a.push({ name: "aPickColor", buffer: this.pickBuffer, size: 3, type: "FLOAT", stride: 12, offset: 0 });
            return a;
          }
        },
        {
          key: "getProperty",
          value: function (a, c, b) {
            if ("[object Function]" === Object.prototype.toString.call(c)) return c(b);
            c = b[a] || c;
            "properties" in b && a in b.properties && (c = b.properties[a]);
            return c;
          }
        },
        {
          key: "normizedColor",
          value: function (a) {
            var c = a;
            a instanceof Array || (c = ka(a).unitArray());
            void 0 === c[3] && (c[3] = 1);
            return c;
          }
        },
        {
          key: "normizedPoint",
          value: function (a) {
            var c = this.getPointOffset();
            if (!a || !a[0] || !a[1]) return [c[0], c[1], 0];
            var b = Number(a[0]),
              d = Number(a[1]);
            -180 <= b && 180 >= b && -90 <= d && 90 >= d && ((d = this.webglLayer.map.lnglatToMercator(b, d)), (b = d[0]), (d = d[1]));
            var g = Number(a[2]) || 0;
            this.webglLayer && "cesium" === this.webglLayer.options.mapType && window.Cesium
              ? ((b = this.convertLngLat([b, d])), (g = window.Cesium.Cartesian3.fromDegrees(b[0], b[1], g)), (b = g.x), (d = g.y), (g = g.z))
              : this.webglLayer &&
                "bmapgl" === this.webglLayer.options.mapType &&
                "B_EARTH_MAP" === this.webglLayer.map.map.mapType &&
                ((b = this.convertLngLat([b, d])), (g = this.webglLayer.map.map.getEarth().scene.fromLatLngToXYZ({ lng: b[0], lat: b[1] })), (b = g.x), (d = g.y), (g = g.z));
            return 3 < a.length ? [b - c[0], d - c[1], g].concat(W(a.slice(3))) : [b - c[0], d - c[1], g];
          }
        },
        {
          key: "convertLngLat",
          value: function (a) {
            return [(a[0] / 2.003750834e7) * 180, (180 / Math.PI) * (2 * Math.atan(Math.exp(((a[1] / 2.003750834e7) * 180 * Math.PI) / 180)) - Math.PI / 2)];
          }
        },
        {
          key: "getPointOffset",
          value: function () {
            var a = [0, 0],
              c = this.getOptions();
            this.webglLayer && this.webglLayer.options.pointOffset ? (a = this.webglLayer.options.pointOffset) : c.pointOffset && (a = c.pointOffset);
            return a;
          }
        },
        {
          key: "indexToRgb",
          value: function (a) {
            a++;
            var c = Math.floor(a / 65536);
            a -= 65536 * c;
            var b = Math.floor(a / 256);
            return [a - 256 * b, b, c];
          }
        },
        {
          key: "rgbToIndex",
          value: function (a) {
            for (
              var c = a.length / 4,
                b = Math.floor(c / 2),
                d = function (c) {
                  return a[c] + 256 * a[c + 1] + 65536 * a[c + 2] - 1;
                },
                g = 0;
              ;
              g++
            ) {
              var k = b + g,
                l = b - g;
              if (k === l) {
                if (((k = d(4 * k)), -1 < k)) return k;
              } else {
                if (k < c) {
                  var n = d(4 * k);
                  if (-1 < n) return n;
                }
                if (0 <= l && ((n = d(4 * l)), -1 < n)) return n;
                if (k >= c && 0 > l) break;
              }
            }
            return -1;
          }
        },
        {
          key: "getCommonUniforms",
          value: function (a) {
            a = a.isPickRender;
            var c = this.getOptions(),
              b = {};
            if (c.enablePicked) {
              var d = 0 <= c.selectedIndex ? c.selectedIndex : -1;
              d = c.autoSelect ? this.pickedColor : this.indexToRgb(d);
              b = S(b, {
                uSelectedColor: this.normizedColor(c.selectedColor),
                uEnablePicked: c.enablePicked,
                uPickedColor: d.map(function (a) {
                  return a / 255;
                }),
                uIsPickRender: !!a
              });
            }
            return b;
          }
        },
        {
          key: "pick",
          value: function (a, c, b) {
            var d = this.getOptions(),
              f = this.gl,
              k = this.webglLayer._dpr;
            this.webglLayer.saveFramebuffer();
            this.webglLayer.bindFramebuffer(this.webglLayer.pickFBO);
            this.webglLayer.clear();
            this.render({
              gl: f,
              isPickRender: !0,
              matrix: this.webglLayer.matrix,
              projectionMatrix: this.webglLayer.projectionMatrix,
              viewMatrix: this.webglLayer.viewMatrix,
              orthoMatrix: this.webglLayer.orthoMatrix
            });
            var l = new Uint8Array(4 * d.pickWidth * d.pickHeight);
            f.readPixels(a * k - Math.floor(d.pickWidth / 2), f.canvas.height - c * k - Math.floor(d.pickHeight / 2), d.pickWidth, d.pickHeight, f.RGBA, f.UNSIGNED_BYTE, l);
            a = this.rgbToIndex(l);
            this.pickAfter && (a = this.pickAfter(l, a + 1));
            this.setPickedIndex && this.setPickedIndex(a, b);
            b = this.getData();
            this.pickedColor = [l[0], l[1], l[2]];
            this.webglLayer.restoreFramebuffer();
            return { dataIndex: a, dataItem: b[a] };
          }
        },
        {
          key: "setGLState",
          value: function (a) {
            this.webglLayer.stateManager.setState(a, this.options);
          }
        },
        {
          key: "addMultipleCoords",
          value: function (a, c, b) {
            if (!this.options.repeat || !this.webglLayer || "bmapgl" !== this.webglLayer.options.mapType || "B_EARTH_MAP" === this.webglLayer.map.map.mapType) return [a];
            var d = this.webglLayer.map.map;
            c = c || d.getZoom();
            var f = b ? d.worldSize(c) : 4.007545274461451e7;
            c = function (a) {
              return [
                [a[0] - f, a[1], a[2] || 0],
                [a[0] + f, a[1], a[2] || 0]
              ];
            };
            if (a instanceof Array && !(a[0] instanceof Array)) return (c = c(a)), (c = da(c, 2)), [a, c[0], c[1]];
            if (a instanceof Array && a[0] instanceof Array && !(a[0][0] instanceof Array)) {
              b = [];
              d = [];
              for (var k = 0; k < a.length; k++) {
                var l = c(a[k]);
                l = da(l, 2);
                var n = l[1];
                b.push(l[0]);
                d.push(n);
              }
              return [a, b, d];
            }
            b = [];
            d = [];
            for (k = 0; k < a.length; k++) {
              l = [];
              n = [];
              for (var m = 0; m < a[k].length; m++) {
                var p = c(a[k][m]);
                p = da(p, 2);
                var q = p[1];
                l.push(p[0]);
                n.push(q);
              }
              b.push(l);
              d.push(n);
            }
            return [a, b, d];
          }
        }
      ]);
      return d;
    })(of),
    ol = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.name = "CircleLayer";
        a.bufferData = [];
        a.initializeTime = new Date();
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { depthWrite: !0, depthTest: !0, size: 10, unit: "px", color: "blue", borderWidth: 0, borderColor: "#000000", antialias: !0 };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions();
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "attribute vec3 aPos;attribute float aSize;attribute float aIndex;attribute vec4 aColor;attribute float aBorderWidth;attribute vec4 aBorderColor;varying vec4 vColor;varying vec3 vPosition;varying vec3 vFragPosition;varying float vSize;varying float vBorderWidth;varying vec4 vBorderColor;uniform mat4 uMatrix;uniform float uZoomUnits;uniform vec4 uSelectedColor;void main(){vColor=aColor;vBorderWidth=aBorderWidth*uZoomUnits;vBorderColor=aBorderColor;float x=aPos.x;float y=aPos.y;float z=aPos.z*uZoomUnits;vSize=aSize*uZoomUnits+vBorderWidth;if(aIndex==1.0){x+=vSize;y-=vSize;}else if(aIndex==2.0){x-=vSize;y+=vSize;}else if(aIndex==3.0){x+=vSize;y+=vSize;}else{x-=vSize;y-=vSize;}vPosition=aPos;vFragPosition=vec3(x,y,z);gl_Position=uMatrix*vec4(vFragPosition,1.0);\n#if defined(PICK)\nif(mapvIsPicked()){vColor=uSelectedColor;}\n#endif\n}",
                fragmentShader:
                  "varying vec3 vPosition;varying float vSize;varying vec3 vFragPosition;varying vec4 vColor;varying float vBorderWidth;varying vec4 vBorderColor;uniform mat4 uMatrix;uniform float uTime;uniform float duration;uniform float trail;uniform float lineWidth;uniform float uAntiAliasing;void main(){float d=distance(vFragPosition.xy,vPosition.xy);if(d>vSize){discard;}vec4 color=vColor;float r=vSize-vBorderWidth;if(vBorderWidth>0.0){if(d>r){color=vBorderColor;}else if(uAntiAliasing==1.0&&d>0.95*r){color=vBorderColor;float st=1.0-smoothstep(0.95*r,r,d);color.r+=(vColor.r-vBorderColor.r)*st;color.g+=(vColor.g-vBorderColor.g)*st;color.b+=(vColor.b-vBorderColor.b)*st;color.a+=(vColor.a-vBorderColor.a)*st;}}if(uAntiAliasing==1.0&&d>0.95*vSize&&d<=vSize){color.a*=1.0-smoothstep(0.95*vSize,vSize,d);}gl_FragColor=color;}",
                defines: c.enablePicked ? ["PICK"] : []
              },
              this
            );
            this.buffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            c = Float32Array.BYTES_PER_ELEMENT;
            var b = 14 * c;
            c = [
              { stride: b, name: "aPos", buffer: this.buffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: b, name: "aSize", buffer: this.buffer, size: 1, type: "FLOAT", offset: 3 * c },
              { stride: b, name: "aIndex", buffer: this.buffer, size: 1, type: "FLOAT", offset: 4 * c },
              { stride: b, name: "aColor", buffer: this.buffer, size: 4, type: "FLOAT", offset: 5 * c },
              { stride: b, name: "aBorderWidth", buffer: this.buffer, size: 1, type: "FLOAT", offset: 9 * c },
              { stride: b, name: "aBorderColor", buffer: this.buffer, size: 4, type: "FLOAT", offset: 10 * c }
            ];
            c = c.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: c });
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            this.gl && c && ((this.uniforms = {}), (this.data = c), this.processData(), a.enablePicked && this.parsePickData(c));
          }
        },
        {
          key: "processData",
          value: function () {
            var a = this,
              c = [],
              b = [];
            this.data.forEach(function (d, f) {
              var h = d.properties || {},
                g = function (c) {
                  return d[c] || h[c] || a.options[c];
                },
                n = g("color"),
                m = g("size"),
                p = g("borderWidth");
              g = g("borderColor");
              n = a.normizedColor(n);
              g = a.normizedColor(g);
              for (var q = a.normizedPoint(d.geometry.coordinates), t = 0; 4 > t; t++)
                c.push(q[0], q[1], q[2] || 0, m, t), c.push(n[0], n[1], n[2], n[3]), c.push(p, g[0], g[1], g[2], g[3]);
              n = 4 * f;
              0 < f && b.push(n - 1, n);
              b.push(n, n + 1, n + 2, n + 3);
            });
            this.bufferData = c;
            this.indexData = b;
            this.buffer.updateData(new Float32Array(c));
            this.indexBuffer.updateData(new Uint32Array(b));
          }
        },
        {
          key: "parsePickData",
          value: function (a) {
            var c = [];
            if (this.getOptions().enablePicked) {
              for (var b = 0; b < a.length; b++) {
                var d = this.indexToRgb(b);
                c.push(d[0] / 255, d[1] / 255, d[2] / 255);
                c.push(d[0] / 255, d[1] / 255, d[2] / 255);
                c.push(d[0] / 255, d[1] / 255, d[2] / 255);
                c.push(d[0] / 255, d[1] / 255, d[2] / 255);
              }
              this.pickBuffer.updateData(new Float32Array(c));
            }
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = this.getOptions(),
              b = this.program,
              d = a.gl,
              g = a.matrix;
            this.setGLState({ blend: !0, blendEquation: d.FUNC_ADD, blendFunc: Va(d, c.blend || "lighter"), depthTest: c.depthTest, depthMask: c.depthWrite });
            b.use(d);
            this.vertexArray.bind();
            this.indexBuffer.bind();
            c = this.map.getZoomUnits();
            S(this.uniforms, this.getCommonUniforms(a), { uZoomUnits: "px" === this.options.unit ? c : 1, uMatrix: g, uAntiAliasing: this.options.antialias ? 1 : 0 });
            b.setUniforms(this.uniforms);
            d.drawElements(d.TRIANGLE_STRIP, this.indexData.length, d.UNSIGNED_INT, 0);
          }
        }
      ]);
      return d;
    })(ca),
    Vh = {
      wave: "varying vec4 vPosition;varying float vSize;varying vec4 vFragPosition;varying vec4 vColor;varying float vStartTime;varying float vRadius;uniform mat4 uMatrix;uniform float uTime;uniform float duration;uniform float trail;uniform float uAntiAliasing;varying float vWidth;void main(){float d=distance(vFragPosition.xy,vPosition.xy);if(d>=vRadius){discard;}vec4 color=vColor;float R=vRadius;float center=vSize;float time=vStartTime+uTime;float alpha=sin((R-d)/R*trail*2.0*3.14+time/duration);if(d<=center){if(uAntiAliasing==1.0&&d>0.9*center&&d<=center){if(alpha>=0.5){color.a=0.9;}else{color.a=1.0-smoothstep(0.9*center,center,d);}}}else{if(alpha>=0.5){color.a=0.9;if(uAntiAliasing==1.0){if(alpha>=0.5&&alpha<=0.6){color.a*=smoothstep(0.0,0.1,alpha-0.5);}if(d>=0.98*R&&d<=R){color.a*=1.0-smoothstep(0.98,1.0,d/R);}}}else{color.a=0.0;}}gl_FragColor=color;}",
      bubble:
        "varying vec4 vPosition;varying float vSize;varying vec4 vFragPosition;varying vec4 vColor;varying float vStartTime;varying float vRadius;uniform mat4 uMatrix;uniform float uTime;uniform float duration;uniform float trail;uniform float uAntiAliasing;varying float vWidth;void main(){float d=distance(vFragPosition.xy,vPosition.xy);if(d>=vRadius){discard;}float time=vStartTime+uTime;float range=mod(time,(duration+trail));float percent=0.0;if(range<=duration){percent=range/duration;}else{percent=1.0;}float center=vSize;float R=vRadius;float r=R*percent;vec4 color=vColor;if(d<=center){if(uAntiAliasing==1.0&&d>0.9*center&&d<=center){color.a=1.0-smoothstep(0.9*center,center,d);}}else{if(d<r){color.a=smoothstep(0.1,0.9,pow(d/r,2.0)*0.9);if(uAntiAliasing==1.0&&d>=0.9*r&&d<=r){color.a*=1.0-smoothstep(0.9,1.0,d/r);}if(range>duration){color.a*=1.0-(range-duration)/trail;}}else{color.a=0.0;}}gl_FragColor=color;}",
      breath:
        "varying vec4 vPosition;varying vec4 vFragPosition;varying vec4 vColor;varying float vStartTime;varying float vRadius;uniform float uTime;uniform float duration;uniform float trail;uniform float uAntiAliasing;void main(){float d=distance(vFragPosition.xy,vPosition.xy);if(d>=vRadius){discard;}vec4 color=vColor;if(uAntiAliasing==1.0&&d>0.9*vRadius&&d<=vRadius){color.a=1.0-smoothstep(0.9*vRadius,vRadius,d);}float time=vStartTime+uTime;float range=mod(time,(duration+trail));float percent=0.0;if(range<=duration){percent=range/duration;}else{percent=1.0;}color.a*=abs(1.0-percent*2.0)+0.2;gl_FragColor=color;}",
      radar:
        "varying vec4 vPosition;varying float vSize;varying vec4 vFragPosition;varying vec4 vColor;varying float vStartTime;varying float vRadius;uniform mat4 uMatrix;uniform float uTime;uniform float duration;uniform float trail;uniform float uAntiAliasing;varying float vWidth;void main(){float d=distance(vFragPosition.xy,vPosition.xy);if(d>=vRadius){discard;}float time=vStartTime+uTime;float range=mod(time,duration);float percent=range/duration;float center=vSize;float startDeg=360.0*percent;vec4 color=vColor;float deltaX=vFragPosition.x-vPosition.x;float deltaY=vFragPosition.y-vPosition.y;float currDeg=degrees(atan(deltaX/deltaY));if(deltaX>=0.0&&deltaY<=0.0){currDeg=180.0+currDeg;}if(deltaX<=0.0&&deltaY<=0.0){currDeg=180.0+currDeg;}if(deltaX<=0.0&&deltaY>=0.0){currDeg=360.0+currDeg;}float maxDeg=trail;if(trail<0.0){currDeg=-currDeg;maxDeg=-trail;}float modDeg=mod((currDeg-startDeg),360.0);if(modDeg<maxDeg){color.a=modDeg/maxDeg;}else{color.a=0.0;}if(uAntiAliasing==1.0&&d>0.95*vRadius&&d<=vRadius){color.a=color.a-smoothstep(0.95*vRadius,vRadius,d);}gl_FragColor=color;}"
    },
    pl = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.name = "RippleCircleLayer";
        a.autoUpdate = !0;
        a.bufferData = [];
        a.initializeTime = new Date();
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            var a = 1;
            "radar" === this.options.type && (a = 120);
            return {
              depthWrite: !1,
              depthTest: !0,
              type: "bubble",
              size: 10,
              duration: 1,
              trail: a,
              unit: "px",
              random: !0,
              color: "blue",
              antialias: !0,
              radius: function (a) {
                return 2 * a;
              }
            };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "attribute vec3 aPos;attribute float aSize;attribute float aIndex;attribute vec4 aColor;attribute float aStartTime;attribute float aRadius;varying vec4 vColor;varying vec4 vPosition;varying vec4 vFragPosition;varying float vSize;varying float vWidth;varying float vStartTime;varying float vRadius;uniform mat4 uMatrix;uniform float uZoomUnits;uniform vec4 uSelectedColor;void main(){vColor=aColor;vStartTime=aStartTime;vSize=aSize*uZoomUnits;vRadius=aRadius*uZoomUnits;float x=aPos.x;float y=aPos.y;float z=aPos.z*uZoomUnits;float R=vRadius;if(aIndex==1.0){x+=R;y-=R;}else if(aIndex==2.0){x-=R;y+=R;}else if(aIndex==3.0){x+=R;y+=R;}else{x-=R;y-=R;}vPosition=vec4(aPos.xy,z,1.0);vFragPosition=vec4(x,y,z,1.0);gl_Position=uMatrix*vFragPosition;\n#if defined(PICK)\nif(mapvIsPicked()){vColor=uSelectedColor;}\n#endif\n}",
                fragmentShader: Vh[this.options.type] || "bubble",
                defines: this.options.enablePicked ? ["PICK"] : []
              },
              this
            );
            this.buffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            var c = [
              { stride: 44, name: "aPos", buffer: this.buffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: 44, name: "aSize", buffer: this.buffer, size: 1, type: "FLOAT", offset: 12 },
              { stride: 44, name: "aIndex", buffer: this.buffer, size: 1, type: "FLOAT", offset: 16 },
              { stride: 44, name: "aColor", buffer: this.buffer, size: 4, type: "FLOAT", offset: 20 },
              { stride: 44, name: "aRadius", buffer: this.buffer, size: 1, type: "FLOAT", offset: 36 },
              { stride: 44, name: "aStartTime", buffer: this.buffer, size: 1, type: "FLOAT", offset: 40 }
            ];
            c = c.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: c });
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            this.gl && c && ((this.uniforms = { duration: a.duration, trail: a.trail }), (this.data = c), this.processData(), a.enablePicked && this.parsePickData(c));
          }
        },
        {
          key: "processData",
          value: function () {
            var a = this,
              c = [],
              b = [];
            this.data.forEach(function (d, f) {
              var h = d.size || a.options.size,
                g = d.radius || a.options.radius || 1.618 * h;
              "function" === typeof g && (g = g(h));
              var n = d.color || a.options.color;
              n = a.normizedColor(n);
              d = a.normizedPoint(d.geometry.coordinates);
              for (var m = a.options.random ? Math.random() * a.data.length * 9999 : 0, p = 0; 4 > p; p++)
                c.push(d[0], d[1], d[2] || 0, h, p), c.push(n[0], n[1], n[2], n[3]), c.push(g), c.push(m);
              h = 4 * f;
              0 < f && b.push(h - 1, h);
              b.push(h, h + 1, h + 2, h + 3);
            });
            this.bufferData = c;
            this.indexData = b;
            this.buffer.updateData(new Float32Array(c));
            this.indexBuffer.updateData(new Uint32Array(b));
          }
        },
        {
          key: "parsePickData",
          value: function (a) {
            var c = [];
            if (this.getOptions().enablePicked) {
              for (var b = 0; b < a.length; b++) {
                var d = this.indexToRgb(b);
                c.push(d[0] / 255, d[1] / 255, d[2] / 255);
                c.push(d[0] / 255, d[1] / 255, d[2] / 255);
                c.push(d[0] / 255, d[1] / 255, d[2] / 255);
                c.push(d[0] / 255, d[1] / 255, d[2] / 255);
              }
              this.pickBuffer.updateData(new Float32Array(c));
            }
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = this.getOptions(),
              b = this.program,
              d = a.gl,
              g = a.matrix;
            b.use(d);
            var k = this.map.getZoomUnits();
            S(this.uniforms, this.getCommonUniforms(a), {
              uTime: (new Date() - this.initializeTime) / 1e3,
              uZoomUnits: "m" === c.unit ? 1 : k,
              uMatrix: g,
              uAntiAliasing: c.antialias ? 1 : 0
            });
            b.setUniforms(this.uniforms);
            this.setGLState({ blend: !0, blendEquation: d.FUNC_ADD, blendFunc: [d.SRC_ALPHA, d.ONE_MINUS_SRC_ALPHA], depthTest: c.depthTest, depthMask: c.depthWrite });
            0 < this.indexData.length && (this.vertexArray.bind(), this.indexBuffer.bind(), d.drawElements(d.TRIANGLE_STRIP, this.indexData.length, d.UNSIGNED_INT, 0));
          }
        }
      ]);
      return d;
    })(ca),
    ql = qa(Vh),
    rl = U(function (b, d) {
      d.__esModule = !0;
      var a = Kc && Kc.__esModule ? Kc : { default: Kc },
        c = Sc && Sc.__esModule ? Sc : { default: Sc };
      d.default = function l(b, d, k) {
        null === b && (b = Function.prototype);
        var h = (0, c.default)(b, d);
        if (void 0 === h) {
          if (((b = (0, a.default)(b)), null !== b)) return l(b, d, k);
        } else {
          if ("value" in h) return h.value;
          d = h.get;
          return void 0 === d ? void 0 : d.call(k);
        }
      };
    }),
    ib = Y(rl);
  Fa.deviation = function (b, d, a, c) {
    var f = d && d.length,
      h = Math.abs(te(b, 0, f ? d[0] * a : b.length, a));
    if (f) {
      f = 0;
      for (var g = d.length; f < g; f++) h -= Math.abs(te(b, d[f] * a, f < g - 1 ? d[f + 1] * a : b.length, a));
    }
    for (f = d = 0; f < c.length; f += 3) {
      g = c[f] * a;
      var k = c[f + 1] * a,
        l = c[f + 2] * a;
      d += Math.abs((b[g] - b[l]) * (b[k + 1] - b[g + 1]) - (b[g] - b[k]) * (b[l + 1] - b[g + 1]));
    }
    return 0 === h && 0 === d ? 0 : Math.abs((d - h) / h);
  };
  Fa.flatten = function (b) {
    for (var d = b[0][0].length, a = { vertices: [], holes: [], dimensions: d }, c = 0, f = 0; f < b.length; f++) {
      for (var h = 0; h < b[f].length; h++) for (var g = 0; g < d; g++) a.vertices.push(b[f][h][g]);
      0 < f && ((c += b[f - 1].length), a.holes.push(c));
    }
    return a;
  };
  Fa.default = Fa;
  var Wh = "undefined" === typeof Xg ? "__target" : Xg(),
    Ri = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder,
    wd = window.URL || window.webkitURL,
    pc = window.Worker;
  if (pc) {
    var Xh = Xf("self.onmessage = function () {}"),
      Yh = new Uint8Array(1);
    try {
      if (/(?:Trident|Edge)\/(?:[567]|12)/i.test(navigator.userAgent)) throw Error("Not available");
      var pf = new pc(Xh);
      pf.postMessage(Yh, [Yh.buffer]);
    } catch (b) {
      pc = null;
    } finally {
      wd.revokeObjectURL(Xh), pf && pf.terminate();
    }
  }
  var sl = new (function (b, d) {
      return function (a) {
        var c = this;
        if (d) {
          if (pc && !a) return (a = ("" + d).replace(/^function.+?{/, "").slice(0, -1)), (a = Xf(a)), (this[Wh] = new pc(a)), wd.revokeObjectURL(a), this[Wh];
          var f = {
            postMessage: function (a) {
              c.onmessage &&
                setTimeout(function () {
                  return c.onmessage({ data: a, target: f });
                });
            }
          };
          d.call(f);
          this.postMessage = function (a) {
            setTimeout(function () {
              return f.onmessage({ data: a, target: c });
            });
          };
          this.isThisThread = !0;
        } else return new pc(b);
      };
    })("./worker.js", function (b, d) {}),
    Zh = { window: 1, windowAnimation: 2, gradual: 3, ripple: 4, water: 6, repeat: 7 },
    Zd = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.name = "ShapeLayer";
        a._isShow = !0;
        c = a.getOptions();
        if ("windowAnimation" === c.style || "ripple" === c.style || 0 < c.riseTime) a.autoUpdate = !0;
        a.selectedColor = [-1, -1, -1];
        a.textureCache = {};
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              color: "rgba(50, 50, 230, 1.0)",
              opacity: 0.8,
              height: 0,
              isTextureFull: !1,
              topColor: "rgba(76, 76, 76, 0.8)",
              textureRotate: 0,
              textureScale: 1,
              useLight: !0,
              useTopColor: !1,
              riseTime: 0,
              polygonOffset: [0, 0],
              depthTest: !0,
              zIndex: 0,
              zFlight: 4e3
            };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions();
            this.dataMgr = new Qb(this, this.gl);
            this.texture = null;
            this.isUseTexture = !1;
            var b = [];
            c.enablePicked && b.push("PICK");
            c.texture && b.push("USE_TEXTURE");
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;uniform vec4 uSelectedColor;attribute vec4 a_pos;attribute vec3 a_normal;attribute vec4 a_color;attribute vec4 a_pre_color;attribute float a_height;attribute float a_pre_height;attribute float a_block_index;\n#if defined(USE_TEXTURE)\nattribute vec2 a_texture_coord;\n#endif\nuniform mat4 u_proj_matrix;uniform mat4 u_mv_matrix;uniform mat4 u_normal_matrix;uniform vec3 u_side_light_dir;uniform bool u_use_lighting;uniform bool u_use_texture;uniform vec3 u_ripple_center;uniform float u_radius;uniform float style;uniform float alpha;uniform float time;uniform float dataTime;uniform float riseTime;uniform vec2 uMapCenter;uniform float uMapZoom;uniform float u_zIndex;uniform float u_zFlight;varying float v_height;varying vec4 v_color;varying vec3 v_position;varying vec2 v_texture_coord;const vec3 point_color=vec3(0.06,0.06,0.06);const vec3 light_color=vec3(0.53,0.53,0.53);const vec3 light_color_2=vec3(0.4,0.4,0.4);const vec3 uAmbientColor=vec3(0.8,0.8,0.8);const vec3 uLightingDirection=vec3(0.0,1.0,1.0);const vec3 uDirectionalColor=vec3(1.0,1.0,1.0);float getTransitionValue(float pre_value,float to_value,float dataTime,float riseTime){float result=0.0;if(pre_value==to_value){result=to_value;}else{if(riseTime>0.0&&dataTime<riseTime){result=(pre_value+(to_value-pre_value)*(dataTime/riseTime));}else{result=to_value;}}return result;}void main(){vec4 pos=a_pos;pos.z=pos.z+pos.w*getTransitionValue(a_pre_height,a_height,dataTime,riseTime);v_position=pos.xyz;v_height=a_height;\n#if defined(USE_TEXTURE)\nif(u_use_texture){v_texture_coord=a_texture_coord;}\n#endif\npos.z+=u_zIndex;vec4 position=u_proj_matrix*u_mv_matrix*vec4(pos.xyz,1.0);gl_Position=position;float v_z_offset=-a_block_index/u_zFlight;gl_Position.z=gl_Position.z+v_z_offset;vec4 icolor=a_color;\n#if defined(PICK)\nif(mapvIsPicked()){icolor=uSelectedColor;}\n#endif\nif(u_use_lighting){vec3 N=normalize(vec3(u_normal_matrix*vec4(a_normal,1.0)));vec4 point_dir=u_mv_matrix*vec4(0,1,0,0);vec3 L_point=normalize(point_dir.xyz);float lambert_point=max(0.0,dot(N,-L_point));vec4 light_dir=u_mv_matrix*vec4(u_side_light_dir,0);vec3 L=normalize(light_dir.xyz);float lambert=max(0.0,dot(N,-L));if(pos.z<5.0){float deepGradientColor=(5.0-pos.z)/8.0;lambert=lambert-deepGradientColor;}vec4 light_dir_2=u_mv_matrix*vec4(0,0,-1,0);vec3 L2=normalize(light_dir_2.xyz);float lambert_2=max(0.0,dot(N,-L2));if(a_pre_color.r==a_color.r&&a_pre_color.g==a_color.g&&a_pre_color.b==a_color.b){}else{if(riseTime>0.0&&dataTime<riseTime){icolor.r=a_pre_color.r+(a_color.r-a_pre_color.r)*(dataTime/riseTime);icolor.g=a_pre_color.g+(a_color.g-a_pre_color.g)*(dataTime/riseTime);icolor.b=a_pre_color.b+(a_color.b-a_pre_color.b)*(dataTime/riseTime);}}v_color.rgb=icolor.rgb+icolor.rgb*light_color*lambert+icolor.rgb*light_color_2*lambert_2+icolor.rgb*point_color*lambert_point;v_color.a=icolor.a;if(u_use_texture){mat3 normalMatrix=mat3(u_normal_matrix);vec3 transformedNormal=normalMatrix*a_normal;vec3 dir=uLightingDirection;dir=vec3(normalMatrix*vec3(0.0,-1.0,2.0));float directionalLightWeighting=max(dot(normalize(transformedNormal),normalize(dir)),0.0);vec4 vLightWeighting;vLightWeighting=vec4(uAmbientColor+uDirectionalColor*directionalLightWeighting,1.0);v_color=vLightWeighting;}}else{v_color=icolor;}}",
                fragmentShader:
                  "precision highp float;varying vec4 v_color;varying vec3 v_position;varying float v_height;varying vec2 v_texture_coord;uniform vec3 u_ripple_center;uniform vec4 top_color;uniform float u_zoom_units;uniform float u_radius;uniform float style;uniform float alpha;uniform float time;uniform sampler2D u_sampler;uniform bool u_use_lighting;uniform bool u_use_texture;uniform bool u_use_top_color;void main(){vec4 color=vec4(v_color);vec4 textureColor=vec4(1.0,1.0,1.0,1.0);if(u_use_texture){if(style==6.0){float x=v_texture_coord.s;float y=v_texture_coord.t;vec2 cPos=-1.0+2.0*gl_FragCoord.xy/MAPV_resolution;float cLength=length(cPos);vec2 uv=gl_FragCoord.xy/MAPV_resolution+(cPos/cLength)*cos(cLength*12.0-time/1000.0*4.0)*0.03;textureColor=texture2D(u_sampler,uv/2.0+vec2(x,y));}else if(style==7.0){float tWidth=1.*u_zoom_units;float deltaX=mod(v_texture_coord.x,tWidth);float deltaY=mod(v_texture_coord.y,tWidth);if(deltaX>=0.&&deltaX<=tWidth){vec2 uv=vec2(deltaX,deltaY)/tWidth;vec4 texture=texture2D(u_sampler,uv);textureColor=texture.a>=0.1 ? texture : vec4(0.,0.,0.,0.);}}else{textureColor=texture2D(u_sampler,vec2(v_texture_coord.s,v_texture_coord.t));}if(u_use_lighting){color=vec4(textureColor*v_color*1.1);}else{color=textureColor;}}if(u_use_top_color&&v_position.z>=v_height){color=top_color;}if(style==1.0||style==2.0){float t=time/1000.0;float diffDistance=5.0;float modX=mod(v_position.x,diffDistance*2.0);float modZ=mod(v_position.z,diffDistance*2.0);if(modX<diffDistance&&modZ<diffDistance&&v_position.z<v_height){color*=1.05;if(time>0.0&&style==2.0){float iX=ceil(v_position.x/diffDistance);float iZ=ceil(v_position.z/diffDistance);float timeDistance=8.0;t+=tan(sin(iZ));color*=(1.0+mod(t,timeDistance)/timeDistance);}}color.a=alpha;}else if(style==5.0){float t=time/1000.0;float diffDistance=10.0;float modZ=mod(v_position.z-t*40.0,diffDistance*2.0);color.a=1.0-pow(v_position.z/v_height,0.5);if(v_position.z/v_height<0.3){color.r+=0.2;color.g+=0.2;color.b+=0.2;}if(modZ<diffDistance*2.0-4.0){discard;}}else if(style==3.0){float diffDistance=10.0;float modX=mod(v_position.x,diffDistance*2.0);color.a=1.0-pow(v_position.z/v_height,0.3);}else if(style==4.0){float dis=distance(u_ripple_center,v_position);float rSize=400.0;if(v_position.z>=v_height){color=top_color;}if(dis>u_radius-rSize&&dis<u_radius+rSize){color*=(1.0-abs(dis-u_radius)/rSize)*2.0+1.0;}}else if(style==6.0){}gl_FragColor=color;}",
                defines: b
              },
              this
            );
            this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.colorBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.heightBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.textureBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            b = [
              { name: "a_pos", buffer: this.vertexBuffer, stride: 28, size: 4, type: "FLOAT", offset: 0 },
              { name: "a_normal", buffer: this.vertexBuffer, size: 3, stride: 28, type: "FLOAT", offset: 16 },
              { name: "a_color", buffer: this.colorBuffer, size: 4, stride: 32, type: "FLOAT", offset: 0 },
              { name: "a_pre_color", buffer: this.colorBuffer, size: 4, stride: 32, type: "FLOAT", offset: 16 },
              { name: "a_height", buffer: this.heightBuffer, size: 1, stride: 12, type: "FLOAT", offset: 0 },
              { name: "a_pre_height", buffer: this.heightBuffer, size: 1, stride: 12, type: "FLOAT", offset: 4 },
              { name: "a_block_index", buffer: this.heightBuffer, size: 1, stride: 12, type: "FLOAT", offset: 8 }
            ];
            c.texture && b.push({ name: "a_texture_coord", buffer: this.textureBuffer, size: 2, stride: 8, type: "FLOAT", offset: 0 });
            b = b.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: b });
            this.initializeTime = new Date();
            this.normalMatrix = L.create();
          }
        },
        { key: "onDestroy", value: function () {} },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this;
            this.gl &&
              (this.loadTextureTime && clearTimeout(this.loadTextureTime),
              (this.loadTextureTime = setTimeout(function () {
                b.loadTexture(function () {
                  b.dataMgr.parseData(c);
                  b.dataTime = new Date();
                  b.webglLayer.render();
                });
              }, 0)));
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.projectionMatrix,
              d = a.viewMatrix;
            if (this._isShow) {
              var g = this.getData();
              if (g && !(0 >= g.length)) {
                g = this.getOptions();
                var k = this.program;
                k.use(c);
                if (!g.texture || this.texture) {
                  var l = 0;
                  g.style && Zh[g.style] && (l = Zh[g.style]);
                  var n = [c.ONE, c.ZERO];
                  g.blend && (n = Va(c, g.blend));
                  if (0 === g.height || "gradual" === g.style) n = [c.ONE, c.ONE_MINUS_SRC_ALPHA];
                  this.setGLState({
                    cullFace: !1,
                    blend: !0,
                    blendEquation: c.FUNC_ADD,
                    blendFunc: n,
                    polygonOffset: g.polygonOffset,
                    depthTest: g.depthTest,
                    depthMask: "gradual" === g.style ? !1 : !0
                  });
                  n = this.normizedColor(g.topColor);
                  if ("ripple" === g.style && g.rippleLayer && g.rippleLayer.data && g.rippleLayer.data[0]) {
                    var m = this.normizedPoint(g.rippleLayer.data[0].geometry.coordinates);
                    k.setUniforms({ u_ripple_center: [m[0], m[1], 0], u_radius: g.rippleLayer.options.size * g.rippleLayer.currentScale });
                  }
                  m = P.fromValues(0, -1, 2);
                  g.lightDir && (m = P.fromValues(g.lightDir[0], g.lightDir[1], g.lightDir[2]));
                  var p = this.normalMatrix;
                  L.invert(p, d);
                  L.transpose(p, p);
                  k.setUniforms(
                    S(this.getCommonUniforms(a), {
                      u_normal_matrix: p,
                      u_sampler: this.texture,
                      u_proj_matrix: b,
                      u_mv_matrix: d,
                      u_zoom_units: this.map.getZoomUnits(),
                      style: l,
                      u_use_top_color: g.useTopColor,
                      top_color: n,
                      u_use_lighting: g.useLight,
                      u_use_texture: this.isUseTexture,
                      alpha: void 0 === g.opacity ? 0.8 : parseFloat(g.opacity),
                      time: new Date() - this.initializeTime,
                      dataTime: new Date() - this.dataTime,
                      riseTime: g.riseTime,
                      u_side_light_dir: m,
                      u_zIndex: g.zIndex,
                      u_zFlight: g.zFlight
                    })
                  );
                  a = this.dataMgr.getData();
                  0 < a.vertex.length && (this.vertexArray.bind(), this.indexBuffer.bind(), c.drawElements(c.TRIANGLES, a.index.length, c.UNSIGNED_INT, 0));
                }
              }
            } else this.webglLayer.clear();
          }
        },
        {
          key: "loadTexture",
          value: function (a) {
            var c = this,
              b = this.getOptions();
            b.texture
              ? ((this.isUseTexture = !0),
                ta(this.gl, b.texture, function (b, d) {
                  c.image = d;
                  c.texture = b;
                  a && a();
                  c.webglLayer.render();
                }))
              : ((this.isUseTexture = !1), (this.image = this.texture = null), a && a());
          }
        }
      ]);
      return d;
    })(ca);
  Qb.prototype.initData = function () {
    this.outBuilding3d = { pickColorVertex: [], vertex: [], texture: [], color: [], height: [], index: [] };
  };
  Qb.prototype.getData = function () {
    return this.outBuilding3d;
  };
  Qb.prototype.initWorker = function () {
    this.worker = new sl();
    this.worker.onmessage = function (b) {};
  };
  Qb.prototype.parseData = function (b) {
    var d = this;
    this.initData();
    for (var a = this.shapeLayer.getOptions(), c = 0; c < b.length; c++) {
      var f = b[c],
        h = f.height || a.height;
      "properties" in f && "height" in f.properties && (h = f.properties.height);
      h *= 1;
      var g = f.color || a.color;
      "properties" in f && "color" in f.properties && (g = f.properties.color);
      "properties" in f && "fillColor" in f.properties && (g = f.properties.fillColor);
      "[object Function]" === Object.prototype.toString.call(g) && (g = g(f));
      g = this.shapeLayer.normizedColor(g);
      var k = this.shapeLayer.getProperty("angle", a.textureRotate, f),
        l = void 0;
      a.enablePicked && (l = this.shapeLayer.indexToRgb(c));
      var n = void 0,
        m = void 0;
      a.riseTime &&
        ((m = f.preColor),
        "properties" in f && "preColor" in f.properties && (m = f.properties.preColor),
        (n = f.preHeight),
        "properties" in f && "preHeight" in f.properties && (n = f.properties.preHeight),
        void 0 === n && (n = 0));
      if (f.geometry.coordinates) {
        if ("LineString" === f.geometry.type) {
          var p = f.geometry.coordinates.map(function (a) {
              return d.shapeLayer.normizedPoint(a);
            }),
            q = Fa.flatten([p]);
          p = q.vertices;
          q = q.holes;
          for (var t = [], v = [], r = 0; r < p.length; r += 3) t.push(p[r + 0], p[r + 1]), v.push(p[r + 2]);
          this.parseBuilding3d(this.outBuilding3d, t, v, n, h, m, g, l, k, q, c);
        }
        if ("MultiPolygon" === f.geometry.type) {
          p = f.geometry.coordinates;
          f = [];
          for (q = 0; q < p.length; q++)
            f.push(
              p[q].map(function (a) {
                return a.map(function (a) {
                  return d.shapeLayer.normizedPoint(a);
                });
              })
            );
          for (p = 0; p < f.length; p++) {
            q = [];
            t = [];
            r = Fa.flatten(f[p]);
            v = r.vertices;
            r = r.holes;
            for (var u = 0; u < v.length; u += 3) q.push(v[u + 0], v[u + 1]), t.push(v[u + 2]);
            this.parseBuilding3d(this.outBuilding3d, q, t, n, h, m, g, l, k, r, c);
          }
        } else {
          p = [];
          for (q = 0; q < f.geometry.coordinates.length; q++)
            p.push(
              f.geometry.coordinates[q].map(function (a) {
                return d.shapeLayer.normizedPoint(a);
              })
            );
          p = Fa.flatten(p);
          f = p.vertices;
          p = p.holes;
          q = [];
          t = [];
          for (v = 0; v < f.length; v += 3) q.push(f[v + 0], f[v + 1]), t.push(f[v + 2]);
          this.parseBuilding3d(this.outBuilding3d, q, t, n, h, m, g, l, k, p, c);
        }
      }
    }
    this.shapeLayer.vertexBuffer.updateData(new Float32Array(this.outBuilding3d.vertex));
    this.shapeLayer.colorBuffer.updateData(new Float32Array(this.outBuilding3d.color));
    this.shapeLayer.heightBuffer.updateData(new Float32Array(this.outBuilding3d.height));
    this.shapeLayer.textureBuffer.updateData(new Float32Array(this.outBuilding3d.texture));
    this.shapeLayer.indexBuffer.updateData(new Uint32Array(this.outBuilding3d.index));
    a.enablePicked && this.shapeLayer.pickBuffer.updateData(new Float32Array(this.outBuilding3d.pickColorVertex));
  };
  Qb.prototype.getBounds = function (b, d) {
    for (var a = b[0], c = b[1], f = b[0], h = b[1], g = 0; g < b.length; g += 2)
      (a = Math.min(b[g], a)), (c = Math.min(b[g + 1], c)), (f = Math.max(b[g], f)), (h = Math.max(b[g + 1], h));
    g = [(f - a) / 2 + a, (h - c) / 2 + c];
    if (0 === d || !d) return { minX: a, minY: c, maxX: f, maxY: h, width: f - a, height: h - c, center: g };
    a = b.slice(0);
    for (c = 0; c < a.length; c += 2) (f = Yf(b[c], b[c + 1], g, d)), (a[c] = f[0]), (a[c + 1] = f[1]);
    return this.getBounds(a, 0);
  };
  Qb.prototype.parseBuilding3d = function (b, d, a, c, f, h, g, k, l, n, m) {
    void 0 === c && (c = f);
    var p = this.shapeLayer.options,
      q = b.vertex,
      t = b.texture,
      v = b.color,
      r = b.height,
      u = b.pickColorVertex;
    b = b.index;
    void 0 === h && (h = g);
    var w = 0,
      y = 0;
    this.shapeLayer.image && ((w = this.shapeLayer.image.width * p.textureScale), (y = this.shapeLayer.image.height * p.textureScale));
    if ("gradual" !== p.style) {
      n = n && n.length ? Fa(d, n, 2) : Fa(d);
      var x = n[0],
        D = n[1],
        C = n[2];
      x = [d[2 * x], d[2 * x + 1], 1];
      D = [d[2 * D], d[2 * D + 1], 1];
      var A = [d[2 * C], d[2 * C + 1], 1];
      C = [];
      P.cross(C, [A[0] - D[0], A[1] - D[1], A[2] - D[2]], [x[0] - D[0], x[1] - D[1], x[2] - D[2]]);
      D = q.length / 7;
      var E;
      p.texture && (E = this.getBounds(d, l));
      x = p.isTextureFull;
      A = 0;
      for (var J = d.length; A < J; A += 2) {
        q.push(d[A], d[A + 1], a[A / 2], 1, C[0], C[1], C[2]);
        v.push(g[0], g[1], g[2], g[3], h[0], h[1], h[2], h[3]);
        r.push(f, c, m);
        if (p.texture) {
          var G = Yf(d[A], d[A + 1], E.center, l),
            M = da(G, 2);
          G = M[0];
          M = M[1];
          x ? ((G = (G - E.minX) / E.width), (M = (M - E.minY) / E.height)) : ((G = (G - E.minX) / w), (M = (M - E.minY) / y));
          t.push(G, M);
        }
        k && u.push(k[0] / 255, k[1] / 255, k[2] / 255);
      }
      l = 0;
      for (E = n.length; l < E; l++) b.push(n[l] + D);
    }
    if (!(f === c && 0 >= f))
      for (l = 0, n = d.length; l < n; l += 2)
        (E = q.length / 7),
          (J = d[l]),
          (G = d[l + 1]),
          (C = [J, G, a[l / 2], 0]),
          (D = [J, G, a[l / 2], 1]),
          (A = l + 2),
          (M = l + 3),
          l === n - 2 && ((A = 0), (M = 1)),
          (A = d[A]),
          (M = d[M]),
          (J = Math.sqrt(Math.pow(A - J, 2), Math.pow(M - G, 2))),
          (G = [A, M, a[l / 2], 0]),
          (A = [A, M, a[l / 2], 1]),
          (M = []),
          P.cross(M, [G[0] - C[0], G[1] - C[1], G[2] - C[2]], [D[0] - C[0], D[1] - C[1], D[2] - C[2]]),
          q.push(C[0], C[1], C[2], C[3]),
          q.push(M[0], M[1], M[2]),
          q.push(D[0], D[1], D[2], D[3]),
          q.push(M[0], M[1], M[2]),
          q.push(G[0], G[1], G[2], G[3]),
          q.push(M[0], M[1], M[2]),
          q.push(A[0], A[1], A[2], A[3]),
          q.push(M[0], M[1], M[2]),
          v.push(g[0], g[1], g[2], g[3]),
          v.push(h[0], h[1], h[2], h[3]),
          v.push(g[0], g[1], g[2], g[3]),
          v.push(h[0], h[1], h[2], h[3]),
          v.push(g[0], g[1], g[2], g[3]),
          v.push(h[0], h[1], h[2], h[3]),
          v.push(g[0], g[1], g[2], g[3]),
          v.push(h[0], h[1], h[2], h[3]),
          r.push(f),
          r.push(c),
          r.push(m),
          r.push(f),
          r.push(c),
          r.push(m),
          r.push(f),
          r.push(c),
          r.push(m),
          r.push(f),
          r.push(c),
          r.push(m),
          p.texture && (x ? (t.push(0, 0), t.push(0, 1), t.push(1, 0), t.push(1, 1)) : (t.push(0, 0), t.push(0, f / y), t.push(J / w, 0), t.push(J / w, f / y))),
          k &&
            (u.push(k[0] / 255, k[1] / 255, k[2] / 255),
            u.push(k[0] / 255, k[1] / 255, k[2] / 255),
            u.push(k[0] / 255, k[1] / 255, k[2] / 255),
            u.push(k[0] / 255, k[1] / 255, k[2] / 255)),
          b.push(E, E + 2, E + 3, E, E + 3, E + 1);
  };
  var qc = U(function (b, d) {
      (function (a, c) {
        b.exports = c();
      })(ug, function () {
        function a(b, d, f, h, g) {
          for (; h > f; ) {
            if (600 < h - f) {
              var k = h - f + 1,
                l = d - f + 1,
                m = Math.log(k),
                p = 0.5 * Math.exp((2 * m) / 3);
              m = 0.5 * Math.sqrt((m * p * (k - p)) / k) * (0 > l - k / 2 ? -1 : 1);
              a(b, d, Math.max(f, Math.floor(d - (l * p) / k + m)), Math.min(h, Math.floor(d + ((k - l) * p) / k + m)), g);
            }
            k = b[d];
            l = f;
            p = h;
            c(b, f, d);
            for (0 < g(b[h], k) && c(b, f, h); l < p; ) {
              c(b, l, p);
              l++;
              for (p--; 0 > g(b[l], k); ) l++;
              for (; 0 < g(b[p], k); ) p--;
            }
            0 === g(b[f], k) ? c(b, f, p) : (p++, c(b, p, h));
            p <= d && (f = p + 1);
            d <= p && (h = p - 1);
          }
        }
        function c(a, c, b) {
          var d = a[c];
          a[c] = a[b];
          a[b] = d;
        }
        function b(a, c) {
          return a < c ? -1 : a > c ? 1 : 0;
        }
        function d(a, c) {
          g(a, 0, a.children.length, c, a);
        }
        function g(a, c, b, d, f) {
          f || (f = v(null));
          f.minX = Infinity;
          f.minY = Infinity;
          f.maxX = -Infinity;
          for (f.maxY = -Infinity; c < b; c++) {
            var h = a.children[c];
            k(f, a.leaf ? d(h) : h);
          }
          return f;
        }
        function k(a, c) {
          a.minX = Math.min(a.minX, c.minX);
          a.minY = Math.min(a.minY, c.minY);
          a.maxX = Math.max(a.maxX, c.maxX);
          a.maxY = Math.max(a.maxY, c.maxY);
          return a;
        }
        function l(a, c) {
          return a.minX - c.minX;
        }
        function n(a, c) {
          return a.minY - c.minY;
        }
        function m(a) {
          return (a.maxX - a.minX) * (a.maxY - a.minY);
        }
        function p(a) {
          return a.maxX - a.minX + (a.maxY - a.minY);
        }
        function q(a, c) {
          return a.minX <= c.minX && a.minY <= c.minY && c.maxX <= a.maxX && c.maxY <= a.maxY;
        }
        function t(a, c) {
          return c.minX <= a.maxX && c.minY <= a.maxY && c.maxX >= a.minX && c.maxY >= a.minY;
        }
        function v(a) {
          return { children: a, height: 1, leaf: !0, minX: Infinity, minY: Infinity, maxX: -Infinity, maxY: -Infinity };
        }
        function r(c, d, f, h, g) {
          for (var k = [d, f]; k.length; )
            if (((f = k.pop()), (d = k.pop()), !(f - d <= h))) {
              var l = d + Math.ceil((f - d) / h / 2) * h;
              a(c, l, d || 0, f || c.length - 1, g || b);
              k.push(d, l, l, f);
            }
        }
        var u = function (a) {
          void 0 === a && (a = 9);
          this._maxEntries = Math.max(4, a);
          this._minEntries = Math.max(2, Math.ceil(0.4 * this._maxEntries));
          this.clear();
        };
        u.prototype.all = function () {
          return this._all(this.data, []);
        };
        u.prototype.search = function (a) {
          var c = this.data,
            b = [];
          if (!t(a, c)) return b;
          for (var d = this.toBBox, f = []; c; ) {
            for (var h = 0; h < c.children.length; h++) {
              var g = c.children[h],
                k = c.leaf ? d(g) : g;
              t(a, k) && (c.leaf ? b.push(g) : q(a, k) ? this._all(g, b) : f.push(g));
            }
            c = f.pop();
          }
          return b;
        };
        u.prototype.collides = function (a) {
          var c = this.data;
          if (!t(a, c)) return !1;
          for (var b = []; c; ) {
            for (var d = 0; d < c.children.length; d++) {
              var f = c.children[d],
                h = c.leaf ? this.toBBox(f) : f;
              if (t(a, h)) {
                if (c.leaf || q(a, h)) return !0;
                b.push(f);
              }
            }
            c = b.pop();
          }
          return !1;
        };
        u.prototype.load = function (a) {
          if (!a || !a.length) return this;
          if (a.length < this._minEntries) {
            for (var c = 0; c < a.length; c++) this.insert(a[c]);
            return this;
          }
          a = this._build(a.slice(), 0, a.length - 1, 0);
          this.data.children.length
            ? this.data.height === a.height
              ? this._splitRoot(this.data, a)
              : (this.data.height < a.height && ((c = this.data), (this.data = a), (a = c)), this._insert(a, this.data.height - a.height - 1, !0))
            : (this.data = a);
          return this;
        };
        u.prototype.insert = function (a) {
          a && this._insert(a, this.data.height - 1);
          return this;
        };
        u.prototype.clear = function () {
          this.data = v([]);
          return this;
        };
        u.prototype.remove = function (a, c) {
          if (!a) return this;
          for (var b = this.data, d = this.toBBox(a), f = [], h = [], g, k, l; b || f.length; ) {
            b || ((b = f.pop()), (k = f[f.length - 1]), (g = h.pop()), (l = !0));
            if (b.leaf) {
              a: {
                var m = a;
                var p = b.children,
                  n = c;
                if (n) {
                  for (var r = 0; r < p.length; r++)
                    if (n(m, p[r])) {
                      m = r;
                      break a;
                    }
                  m = -1;
                } else m = p.indexOf(m);
              }
              if (-1 !== m) {
                b.children.splice(m, 1);
                f.push(b);
                this._condense(f);
                break;
              }
            }
            l || b.leaf || !q(b, d) ? (k ? (g++, (b = k.children[g]), (l = !1)) : (b = null)) : (f.push(b), h.push(g), (g = 0), (k = b), (b = b.children[0]));
          }
          return this;
        };
        u.prototype.toBBox = function (a) {
          return a;
        };
        u.prototype.compareMinX = function (a, c) {
          return a.minX - c.minX;
        };
        u.prototype.compareMinY = function (a, c) {
          return a.minY - c.minY;
        };
        u.prototype.toJSON = function () {
          return this.data;
        };
        u.prototype.fromJSON = function (a) {
          this.data = a;
          return this;
        };
        u.prototype._all = function (a, c) {
          for (var b = []; a; ) a.leaf ? c.push.apply(c, a.children) : b.push.apply(b, a.children), (a = b.pop());
          return c;
        };
        u.prototype._build = function (a, c, b, f) {
          var h = b - c + 1,
            g = this._maxEntries;
          if (h <= g) {
            var k = v(a.slice(c, b + 1));
            d(k, this.toBBox);
            return k;
          }
          f || ((f = Math.ceil(Math.log(h) / Math.log(g))), (g = Math.ceil(h / Math.pow(g, f - 1))));
          k = v([]);
          k.leaf = !1;
          k.height = f;
          h = Math.ceil(h / g);
          g = h * Math.ceil(Math.sqrt(g));
          for (r(a, c, b, g, this.compareMinX); c <= b; c += g) {
            var l = Math.min(c + g - 1, b);
            r(a, c, l, h, this.compareMinY);
            for (var m = c; m <= l; m += h) k.children.push(this._build(a, m, Math.min(m + h - 1, l), f - 1));
          }
          d(k, this.toBBox);
          return k;
        };
        u.prototype._chooseSubtree = function (a, c, b, d) {
          for (;;) {
            d.push(c);
            if (c.leaf || d.length - 1 === b) break;
            for (var f = Infinity, h = Infinity, g = void 0, k = 0; k < c.children.length; k++) {
              var l = c.children[k],
                p = m(l),
                n = (Math.max(l.maxX, a.maxX) - Math.min(l.minX, a.minX)) * (Math.max(l.maxY, a.maxY) - Math.min(l.minY, a.minY)) - p;
              n < h ? ((h = n), (f = p < f ? p : f), (g = l)) : n === h && p < f && ((f = p), (g = l));
            }
            c = g || c.children[0];
          }
          return c;
        };
        u.prototype._insert = function (a, c, b) {
          b = b ? a : this.toBBox(a);
          var d = [],
            f = this._chooseSubtree(b, this.data, c, d);
          f.children.push(a);
          for (k(f, b); 0 <= c; )
            if (d[c].children.length > this._maxEntries) this._split(d, c), c--;
            else break;
          this._adjustParentBBoxes(b, d, c);
        };
        u.prototype._split = function (a, c) {
          var b = a[c],
            f = b.children.length,
            h = this._minEntries;
          this._chooseSplitAxis(b, h, f);
          f = this._chooseSplitIndex(b, h, f);
          f = v(b.children.splice(f, b.children.length - f));
          f.height = b.height;
          f.leaf = b.leaf;
          d(b, this.toBBox);
          d(f, this.toBBox);
          c ? a[c - 1].children.push(f) : this._splitRoot(b, f);
        };
        u.prototype._splitRoot = function (a, c) {
          this.data = v([a, c]);
          this.data.height = a.height + 1;
          this.data.leaf = !1;
          d(this.data, this.toBBox);
        };
        u.prototype._chooseSplitIndex = function (a, c, b) {
          for (var d, f = Infinity, h = Infinity, k = c; k <= b - c; k++) {
            var l = g(a, 0, k, this.toBBox),
              p = g(a, k, b, this.toBBox);
            var n = Math.max(0, Math.min(l.maxX, p.maxX) - Math.max(l.minX, p.minX)) * Math.max(0, Math.min(l.maxY, p.maxY) - Math.max(l.minY, p.minY));
            l = m(l) + m(p);
            n < f ? ((f = n), (d = k), (h = l < h ? l : h)) : n === f && l < h && ((h = l), (d = k));
          }
          return d || b - c;
        };
        u.prototype._chooseSplitAxis = function (a, c, b) {
          var d = a.leaf ? this.compareMinX : l,
            f = a.leaf ? this.compareMinY : n,
            h = this._allDistMargin(a, c, b, d);
          c = this._allDistMargin(a, c, b, f);
          h < c && a.children.sort(d);
        };
        u.prototype._allDistMargin = function (a, c, b, d) {
          a.children.sort(d);
          d = this.toBBox;
          for (var f = g(a, 0, c, d), h = g(a, b - c, b, d), l = p(f) + p(h), m = c; m < b - c; m++) {
            var n = a.children[m];
            k(f, a.leaf ? d(n) : n);
            l += p(f);
          }
          for (b = b - c - 1; b >= c; b--) (f = a.children[b]), k(h, a.leaf ? d(f) : f), (l += p(h));
          return l;
        };
        u.prototype._adjustParentBBoxes = function (a, c, b) {
          for (; 0 <= b; b--) k(c[b], a);
        };
        u.prototype._condense = function (a) {
          for (var c = a.length - 1, b; 0 <= c; c--)
            0 === a[c].children.length ? (0 < c ? ((b = a[c - 1].children), b.splice(b.indexOf(a[c]), 1)) : this.clear()) : d(a[c], this.toBBox);
        };
        return u;
      });
    }),
    rc = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.name = "TextLayer";
        var c = (a.canvas = document.createElement("canvas"));
        c = a.ctx = c.getContext("2d");
        c.textAlign = "start";
        c.textBaseline = "top";
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              depthWrite: !1,
              depthTest: !0,
              color: "#fff",
              fontFamily: "Microsoft Yahei",
              fontSize: 14,
              flat: !1,
              collides: !0,
              unit: "px",
              angle: 0,
              offset: [0, 0],
              padding: [2, 2],
              margin: [0, 0],
              polygonOffset: [0, 0],
              shadow: {},
              stroke: { color: "#000" }
            };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions();
            this.texture = null;
            this.lastUpdateTime = 0;
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;uniform mat4 matrix;uniform bool uFlat;uniform bool uUnitPx;uniform float zoomUnits;uniform float devicePixelRatio;uniform float zIndex;uniform vec2 offset;attribute vec3 position;attribute float corner;attribute float scale;attribute float rotation;attribute vec2 size;attribute vec2 aTextCoord;varying vec2 vTextCoord;/***\u70b9A(x,y)\uff0c\u7ed5\u539f\u70b9\u987a\u65f6\u9488\u65cb\u8f6c\u89d2\u5ea6a\u65b0\u5750\u6807\u7684\u8ba1\u7b97\u516c\u5f0f*x1=x*cos(a)+y*sin(a)*y1=y*cos(a)-x*sin(a)*/vec3 transformCoord(vec3 coord,vec2 size,float corner){float x=coord.x;float y=coord.y;if(corner==1.0){x+=-size.x*cos(rotation)+size.y*sin(rotation);y+=size.y*cos(rotation)+size.x*sin(rotation);}else if(corner==2.0){x+=size.x*cos(rotation)+size.y*sin(rotation);y+=size.y*cos(rotation)-size.x*sin(rotation);}else if(corner==3.0){x+=size.x*cos(rotation)-size.y*sin(rotation);y+=-size.y*cos(rotation)-size.x*sin(rotation);}else{x+=-size.x*cos(rotation)-size.y*sin(rotation);y+=-size.y*cos(rotation)+size.x*sin(rotation);}return vec3(x,y,coord.z);}void main(){vTextCoord=aTextCoord;if(uFlat){vec2 pixelOffset=offset;vec2 halfSize=size/2.0*scale;if(uUnitPx){halfSize*=zoomUnits;pixelOffset*=zoomUnits;}vec3 current=transformCoord(position,halfSize,corner);current.z+=zIndex;gl_Position=matrix*vec4(current.x+pixelOffset[0],current.y-pixelOffset[1],current.z,1.0);}else{vec4 pos=matrix*vec4(position,1.0);vec3 screen=pos.xyz/pos.w;vec2 halfSize=size/MAPV_resolution*devicePixelRatio;vec2 positionOffset=offset*2./MAPV_resolution*devicePixelRatio;if(!uUnitPx){halfSize/=zoomUnits;positionOffset/=zoomUnits;}vec3 current=transformCoord(screen,halfSize,corner);current.xy=current.xy-positionOffset;current.z+=zIndex;gl_Position=vec4(current,1.0);}}",
                fragmentShader:
                  "precision highp float;uniform sampler2D textureImage;uniform vec4 uSelectedColor;varying vec2 vTextCoord;void main(){gl_FragColor=texture2D(textureImage,vec2(vTextCoord.x,1.0-vTextCoord.y));\n#if defined(PICK)\nif(mapvIsPicked()){gl_FragColor=vec4(uSelectedColor.rgb,gl_FragColor.a);}\n#endif\n}",
                defines: c.enablePicked ? ["PICK"] : []
              },
              this
            );
            this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.uvBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            c = [
              { name: "position", buffer: this.vertexBuffer, size: 3, stride: 32, type: "FLOAT", offset: 0 },
              { name: "corner", buffer: this.vertexBuffer, size: 1, stride: 32, type: "FLOAT", offset: 12 },
              { name: "size", buffer: this.vertexBuffer, size: 2, stride: 32, type: "FLOAT", offset: 16 },
              { name: "scale", buffer: this.vertexBuffer, size: 1, stride: 32, type: "FLOAT", offset: 24 },
              { name: "rotation", buffer: this.vertexBuffer, size: 1, stride: 32, type: "FLOAT", offset: 28 },
              { name: "aTextCoord", buffer: this.uvBuffer, size: 2, stride: 8, type: "FLOAT", offset: 0 }
            ];
            c = c.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: c });
          }
        },
        { key: "onDestroy", value: function () {} },
        {
          key: "onChanged",
          value: function (a, c) {
            this.gl && this.processCache(a, c);
          }
        },
        {
          key: "processCache",
          value: function (a, c) {
            this.cachedData = [];
            for (var b = 0; b < c.length; b++) {
              var d = this.normizedPoint(c[b].geometry.coordinates),
                g = c[b].text;
              "properties" in c[b] && "text" in c[b].properties && (g = c[b].properties.text);
              var k = this.getProperty("angle", a.angle, c[b]),
                l = this.getProperty("color", a.color, c[b]);
              d && void 0 !== g && this.cachedData.push({ point: d, text: g, angle: k, color: l, index: b });
            }
          }
        },
        {
          key: "render",
          value: function (a) {
            if (this.cachedData && this.cachedData.length && this.map) {
              var c = a.gl,
                b = a.matrix,
                d = this.getOptions(),
                g = this.program;
              g.use(c);
              this.throttleUpdate(a);
              this.setGLState({
                blend: !0,
                blendEquation: c.FUNC_ADD,
                blendFunc: [c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA],
                polygonOffset: d.polygonOffset,
                depthTest: d.depthTest,
                depthMask: d.depthWrite
              });
              var k = this.map.getZoomUnits();
              g.setUniforms(
                S(this.getCommonUniforms(a), {
                  matrix: b,
                  devicePixelRatio: window.devicePixelRatio,
                  textureImage: this.texture,
                  uFlat: d.flat,
                  offset: d.offset,
                  zoomUnits: k,
                  zIndex: d.zIndex,
                  uUnitPx: "px" === d.unit
                })
              );
              0 < this.index.length && (this.indexBuffer.bind(), this.vertexArray.bind(), c.drawElements(c.TRIANGLES, this.index.length, c.UNSIGNED_INT, 0));
            }
          }
        },
        {
          key: "throttleUpdate",
          value: function (a) {
            this.updateText(a);
          }
        },
        {
          key: "updateText",
          value: function (a) {
            var c = a.gl,
              b = a.matrix,
              d = this.getOptions();
            a = d.fontSize;
            var g = d.fontFamily,
              k = d.padding,
              l = d.margin,
              n = d.collides,
              m = d.enablePicked,
              p = d.shadow,
              q = c.canvas.width / window.devicePixelRatio,
              t = c.canvas.height / window.devicePixelRatio,
              v = this.canvas;
            c = this.ctx;
            c.save();
            c.scale(window.devicePixelRatio, window.devicePixelRatio);
            c.textBaseline = "top";
            c.font = "20px " + g;
            var r = new qc();
            d = [];
            for (var u = 0; u < this.cachedData.length; u++) {
              var w = this.cachedData[u],
                y = w.point,
                x = w.text,
                D = w.angle,
                C = w.color;
              w = w.index;
              var A = da(y, 3),
                E = na.clone([A[0], A[1], A[2], 1]);
              na.transformMat4(E, E, b);
              na.scale(E, E, 1 / E[3]);
              A = this.map.getHeading() % 360;
              var J = ((E[0] + 1) / 2) * q,
                G = ((-E[1] + 1) / 2) * t;
              E = J * Math.cos((A * Math.PI) / 180) - G * Math.sin((A * Math.PI) / 180);
              var z = J * Math.sin((A * Math.PI) / 180) + G * Math.cos((A * Math.PI) / 180);
              G = c.measureText(x);
              A = G.width + 2 * k[0];
              J = 20;
              G.actualBoundingBoxAscent && G.actualBoundingBoxDescent && (J = G.actualBoundingBoxDescent - G.actualBoundingBoxAscent);
              J += 2 * k[1];
              var B = A + l[0];
              G = J + l[1];
              E -= B / 2;
              z -= G / 2;
              B = E + B;
              G = z + G;
              if (!(0 > B || 0 > G || E > q || z > t)) {
                if (n) {
                  E = { minX: E, maxX: B, minY: z, maxY: G };
                  if (r.collides(E)) continue;
                  r.insert(E);
                }
                d.push({ w: A, h: J, point: y, text: x, angle: D, color: C, dataIndex: w });
              }
            }
            c.restore();
            l = zb(d);
            b = l.w;
            l = l.h;
            0 >= b && (b = 1);
            0 >= l && (l = 1);
            v.width = b * window.devicePixelRatio;
            v.height = l * window.devicePixelRatio;
            c.save();
            c.scale(window.devicePixelRatio, window.devicePixelRatio);
            c.textBaseline = "top";
            c.font = "20px " + g;
            c.shadowColor = p && p.color;
            c.shadowOffsetX = p && p.offsetX;
            c.shadowOffsetY = p && p.offsetY;
            c.shadowBlur = p && p.blur;
            g = [];
            p = [];
            v = [];
            n = [];
            q = 0;
            for (t = d.length; q < t; ++q) {
              r = d[q];
              c.fillStyle = r.color;
              c.fillText(r.text, r.x + k[0], r.y + k[1]);
              x = da(r.point, 3);
              u = x[0];
              y = x[1];
              x = x[2];
              for (D = 0; 4 > D; D++) g.push(u, y, x), g.push(D), g.push(r.w, r.h), g.push(a / 20, (r.angle * Math.PI) / 180);
              u = r.x / b;
              y = (r.x + r.w) / b;
              x = (r.y + r.h) / l;
              D = r.y / l;
              p.push(u, x, u, D, y, D, y, x);
              u = 4 * q;
              v.push(u, u + 2, u + 1, u, u + 3, u + 2);
              m &&
                ((r = this.indexToRgb(r.dataIndex)),
                n.push(r[0] / 255, r[1] / 255, r[2] / 255),
                n.push(r[0] / 255, r[1] / 255, r[2] / 255),
                n.push(r[0] / 255, r[1] / 255, r[2] / 255),
                n.push(r[0] / 255, r[1] / 255, r[2] / 255));
            }
            c.restore();
            this.loadTexture();
            this.index = v;
            this.vertexBuffer.updateData(new Float32Array(g));
            this.uvBuffer.updateData(new Float32Array(p));
            this.indexBuffer.updateData(new Uint32Array(v));
            m && this.pickBuffer.updateData(new Float32Array(n));
          }
        },
        {
          key: "loadTexture",
          value: function () {
            var a = this;
            this.canvas
              ? ta(
                  this.gl,
                  this.canvas,
                  function (c) {
                    a.texture = c;
                  },
                  { TEXTURE_WRAP_S: "CLAMP_TO_EDGE", TEXTURE_WRAP_T: "CLAMP_TO_EDGE" }
                )
              : (this.texture = null);
          }
        }
      ]);
      return d;
    })(ca),
    jb = (function (b) {
      function d(a) {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).call(this, a));
      }
      R(d, b);
      I(d, [
        {
          key: "initialize",
          value: function (a) {
            var c = this;
            this.children &&
              this.children.forEach(function (b) {
                b.map = c.map;
                b.setWebglLayer(c.getWebglLayer());
                b.commonInitialize && b.commonInitialize(a);
                b.initialize && b.initialize(a);
                b.onOptionsChanged(b.getOptions());
                b.onDataChanged(b.getData());
                b.onChanged(b.getOptions(), b.getData());
              });
          }
        },
        {
          key: "isRequestAnimation",
          value: function () {
            if (void 0 !== this.autoUpdate) return ib(d.prototype.__proto__ || N(d.prototype), "isRequestAnimation", this).call(this);
            for (var a = !1, c = 0; c < this.children.length; c++)
              if (this.children[c].isRequestAnimation()) {
                a = !0;
                break;
              }
            return a;
          }
        },
        {
          key: "render",
          value: function (a) {
            this.children &&
              this.children.forEach(function (c) {
                c.render(a);
              });
          }
        },
        {
          key: "onDestroy",
          value: function (a) {
            this.children &&
              this.children.forEach(function (c) {
                c.onDestroy(a);
              });
          }
        }
      ]);
      return d;
    })(of),
    tl = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.preHeightMapper = {};
        a.preColorMapper = {};
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return S(ib(d.prototype.__proto__ || N(d.prototype), "getDefaultOptions", this).call(this), {
              style: "grid",
              gridSize: 500,
              gridGap: 5,
              height: function () {
                return 1e3;
              },
              color: function () {
                return "rgb(200, 200, 20)";
              }
            });
          }
        },
        {
          key: "generateGrid",
          value: function (a, c) {
            var b = c.gridSize,
              d = [],
              g = {};
            c = a.length;
            for (var k = this.getPointOffset(), l = 0; l < c; l++) {
              var n = this.normizedPoint(a[l].geometry.coordinates);
              n = ~~((n[0] + k[0]) / b) + "_" + ~~((n[1] + k[1]) / b);
              void 0 === g[n] && (g[n] = 0);
              var m = ~~a[l].count || 1;
              "properties" in a[l] && "count" in a[l].properties && (m = ~~a[l].properties.count);
              g[n] += m;
            }
            qa(g).forEach(function (a) {
              var c = a.split("_");
              d.push([c[0] * b + b / 2, c[1] * b + b / 2, g[a]]);
            });
            return d;
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            c = this.processData(c);
            ib(d.prototype.__proto__ || N(d.prototype), "onChanged", this).call(this, a, c);
          }
        },
        {
          key: "getGridDataRange",
          value: function () {
            var a = this.gridData,
              c = void 0,
              b = void 0;
            a[0] && ((c = a[0][2]), (b = a[0][2]));
            for (var d = a.length, g = 0; g < d; g++) {
              var k = a[g];
              c = Math.max(k[2], c);
              b = Math.min(k[2], b);
            }
            return { max: c / 2, min: b };
          }
        },
        {
          key: "processData",
          value: function (a) {
            var c = this.getOptions(),
              b = c.gridSize,
              d = [];
            if ("normal" === c.style)
              for (var g = this.getPointOffset(), k = 0; k < a.length; k++) {
                var l = this.normizedPoint(a[k].geometry.coordinates),
                  n = l[0] + g[0];
                l = l[1] + g[1];
                var m = ~~a[k].count || 1;
                "properties" in a[k] && "count" in a[k].properties && (m = ~~a[k].properties.count);
                var p = a[k].color;
                "properties" in a[k] && "color" in a[k].properties && (p = ~~a[k].properties.color);
                d.push([n, l, m, p]);
              }
            else d = this.generateGrid(a, c);
            a = [];
            this._preHeightMapper = {};
            this._preColorMapper = {};
            for (g = 0; g < d.length; g++)
              (k = d[g]),
                (k[0] = k[0]),
                (k[1] = k[1]),
                (n = k[2]),
                c.height && (n = "function" === typeof c.height ? c.height({ count: k[2], coordinates: [k[0], k[1]] }) : c.height),
                (l = b / 2 - c.gridGap),
                (m = k[3]),
                c.color && (m = "function" === typeof c.color ? c.color({ count: k[2], color: k[3] }) : ka(m || c.color).unitArray()),
                (p = "p" + k[0] + k[1]),
                a.push({
                  geometry: {
                    type: "Polygon",
                    coordinates: [
                      [
                        [k[0] - l, k[1] - l],
                        [k[0] - l, k[1] + l],
                        [k[0] + l, k[1] + l],
                        [k[0] + l, k[1] - l]
                      ]
                    ]
                  },
                  color: m,
                  origin: k,
                  count: k[2],
                  preHeight: this.preHeightMapper[p],
                  preColor: this.preColorMapper[p],
                  height: n
                }),
                (this._preHeightMapper[p] = n),
                (this._preColorMapper[p] = m);
            this.preHeightMapper = this._preHeightMapper;
            this.preColorMapper = this._preColorMapper;
            return (this.gridData = a);
          }
        }
      ]);
      return d;
    })(Zd),
    $h = (function (b) {
      function d(a) {
        F(this, d);
        var c = Q(this, (d.__proto__ || N(d)).call(this, a));
        c.gridLayer = new tl(a);
        c.options.textOptions = S({ show: !1, flat: !0, unit: "m", fontSize: 100, collides: !1 }, a.textOptions || {});
        c.textLayer = new rc(c.options.textOptions);
        c.children = [c.gridLayer, c.textLayer];
        return c;
      }
      R(d, b);
      I(d, [
        {
          key: "pick",
          value: function (a, c) {
            return this.gridLayer.pick(a, c);
          }
        },
        {
          key: "setData",
          value: function (a) {
            this.gridLayer.setData(a);
            this.options.textOptions.show && this.setTextData();
          }
        },
        {
          key: "setTextData",
          value: function () {
            var a = this.gridLayer.gridData.map(function (a) {
              return { geometry: { type: "Point", coordinates: [a.origin[0], a.origin[1], a.height + 5] }, properties: { text: a.count } };
            });
            this.textLayer.setData(a);
          }
        },
        {
          key: "setOptions",
          value: function () {
            var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
              c = this.options.textOptions;
            S(this.options, a);
            this.gridLayer.setOptions(this.options);
            a.textOptions &&
              (this.options.textOptions.show && this.setTextData(), (this.options.textOptions = S(c || {}, a.textOptions)), this.textLayer.setOptions(this.options.textOptions));
          }
        },
        {
          key: "getData",
          value: function () {
            return this.gridLayer.getData();
          }
        },
        {
          key: "render",
          value: function (a) {
            this.gridLayer.render(a);
            this.options.textOptions.show && this.textLayer.render(a);
          }
        }
      ]);
      return d;
    })(jb),
    ul = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.gridLayer = new $h(a.getGridOptions());
        a.children = [a.gridLayer];
        a.options.riseTime && (a.autoUpdate = !0);
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "pick",
          value: function (a, c) {
            return this.gridLayer.pick(a, c);
          }
        },
        {
          key: "onDataChanged",
          value: function (a) {
            this.gridLayer.setData(a);
          }
        },
        {
          key: "getGridOptions",
          value: function () {
            var a = this.getOptions(),
              c = a.max,
              b = a.min;
            void 0 === c && ((b = this.gridLayer.getGridDataRange()), (c = b.max), (b = b.min));
            var d = new Ba({ max: c, min: b, gradient: a.gradient, maxSize: a.maxHeight, minSize: a.minHeight });
            a.height = function (a) {
              var c = d.getSize(a.count);
              "properties" in a && "count" in a.properties && (c = d.getSize(a.properties.count));
              return c;
            };
            a.color = function (a) {
              var c = d.getImageData(a.count);
              "properties" in a && "count" in a.properties && (c = d.getImageData(a.properties.count));
              return [c[0] / 255, c[1] / 255, c[2] / 255, c[3] / 255];
            };
            return a;
          }
        },
        {
          key: "onOptionsChanged",
          value: function (a) {
            this.gridLayer.setOptions(this.getGridOptions());
          }
        },
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              enablePicked: !1,
              selectedIndex: -1,
              selectedColor: "#ff0000",
              autoSelect: !0,
              style: "grid",
              gridSize: 500,
              maxHeight: 8e3,
              minHeight: 200,
              gradient: { 0: "rgb(50, 50, 256)", 0.1: "rgb(50, 250, 56)", 0.5: "rgb(250, 250, 56)", 1: "rgb(250, 50, 56)" }
            };
          }
        }
      ]);
      return d;
    })(jb),
    ai = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.name = "SimpleLineLayer";
        a.bufferData = [];
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions();
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "uniform mat4 u_matrix;attribute vec3 aPos;attribute vec4 aColor;varying vec4 vColor;\n#if defined(DASH)\nvarying vec3 vPos;\n#endif\nvoid main(){if(aColor.w>=0.0&&aColor.w<=1.0){vColor=aColor;}else{vColor=vec4(aColor.xyz,1.0);}gl_Position=u_matrix*vec4(aPos,1.0);\n#if defined(DASH)\nvPos=aPos;\n#endif\n}",
                fragmentShader:
                  "precision highp float;varying vec4 vColor;varying vec3 vPos;void main(){\n#if defined(DASH)\nif(mod(vPos.x,3.0)<1.5){discard;}\n#endif\ngl_FragColor=vColor;}",
                defines: c.useDash ? ["DASH"] : ""
              },
              this
            );
            this.buffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.vertexArray = new fa({
              gl: a,
              program: this.program,
              attributes: [
                { stride: 28, name: "aPos", buffer: this.buffer, size: 3, type: "FLOAT", offset: 0 },
                { stride: 28, name: "aColor", buffer: this.buffer, size: 4, type: "FLOAT", offset: 12 }
              ]
            });
          }
        },
        {
          key: "onDestroy",
          value: function () {
            this.bufferData = [];
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this;
            if (this.gl) {
              var d = [],
                g = function (a, c) {
                  if (a)
                    for (var f = 0; f < a.length - 1; f++) {
                      var h = b.normizedPoint(a[f]);
                      d.push(h[0]);
                      d.push(h[1]);
                      d.push(h[2]);
                      d.push(c[0], c[1], c[2], c[3]);
                      h = b.normizedPoint(a[f + 1]);
                      d.push(h[0]);
                      d.push(h[1]);
                      d.push(h[2]);
                      d.push(c[0], c[1], c[2], c[3]);
                    }
                };
              a = a.color;
              for (var k = 0; k < c.length; k++) {
                var l = this.getProperty("color", a, c[k]);
                l = this.normizedColor(l);
                var n = c[k].geometry,
                  m = n.coordinates;
                if ("MultiPolygon" === n.type) {
                  if (m) for (n = 0; n < m.length; n++) g(m[n][0], l);
                } else if ("Polygon" === n.type) m && g(m[0], l);
                else if ("MultiLineString" === n.type) {
                  if (m) for (n = 0; n < m.length; n++) g(m[n], l);
                } else g(m, l);
              }
              this.bufferData = d;
              this.buffer.updateData(new Float32Array(d));
            }
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl;
            a = a.matrix;
            if (this.bufferData && !(0 >= this.bufferData.length)) {
              var b = this.program;
              b.use(c);
              this.vertexArray.bind();
              b.setUniforms({ u_matrix: a });
              a = this.getOptions();
              this.setGLState({ blend: !0, blendFunc: "lighter" === a.blend ? [c.SRC_ALPHA, c.ONE] : [c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA], blendEquation: c.FUNC_ADD });
              c.drawArrays(c.LINES, 0, this.bufferData.length / 7);
            }
          }
        }
      ]);
      return d;
    })(ca),
    vl = Nd.f("species"),
    wl = U(function (b) {
      b.exports = { default: vl, __esModule: !0 };
    });
  Y(wl);
  var bi = "undefined" !== typeof global ? global : "undefined" !== typeof self ? self : "undefined" !== typeof window ? window : {},
    bb = [],
    Qa = [],
    Wi = "undefined" !== typeof Uint8Array ? Uint8Array : Array,
    we = !1,
    xl = {}.toString,
    eg =
      Array.isArray ||
      function (b) {
        return "[object Array]" == xl.call(b);
      };
  z.TYPED_ARRAY_SUPPORT = void 0 !== bi.TYPED_ARRAY_SUPPORT ? bi.TYPED_ARRAY_SUPPORT : !0;
  z.poolSize = 8192;
  z._augment = function (b) {
    b.__proto__ = z.prototype;
    return b;
  };
  z.from = function (b, d, a) {
    return bg(null, b, d, a);
  };
  z.TYPED_ARRAY_SUPPORT && ((z.prototype.__proto__ = Uint8Array.prototype), (z.__proto__ = Uint8Array));
  z.alloc = function (b, d, a) {
    dg(b);
    b = 0 >= b ? ob(null, b) : void 0 !== d ? ("string" === typeof a ? ob(null, b).fill(d, a) : ob(null, b).fill(d)) : ob(null, b);
    return b;
  };
  z.allocUnsafe = function (b) {
    return xe(null, b);
  };
  z.allocUnsafeSlow = function (b) {
    return xe(null, b);
  };
  z.isBuffer = function (b) {
    return null != b && (!!b._isBuffer || og(b) || ("function" === typeof b.readFloatLE && "function" === typeof b.slice && og(b.slice(0, 0))));
  };
  z.compare = function (b, d) {
    if (!cb(b) || !cb(d)) throw new TypeError("Arguments must be Buffers");
    if (b === d) return 0;
    for (var a = b.length, c = d.length, f = 0, h = Math.min(a, c); f < h; ++f)
      if (b[f] !== d[f]) {
        a = b[f];
        c = d[f];
        break;
      }
    return a < c ? -1 : c < a ? 1 : 0;
  };
  z.isEncoding = function (b) {
    switch (String(b).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  };
  z.concat = function (b, d) {
    if (!eg(b)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (0 === b.length) return z.alloc(0);
    var a;
    if (void 0 === d) for (a = d = 0; a < b.length; ++a) d += b[a].length;
    d = z.allocUnsafe(d);
    var c = 0;
    for (a = 0; a < b.length; ++a) {
      var f = b[a];
      if (!cb(f)) throw new TypeError('"list" argument must be an Array of Buffers');
      f.copy(d, c);
      c += f.length;
    }
    return d;
  };
  z.byteLength = cg;
  z.prototype._isBuffer = !0;
  z.prototype.swap16 = function () {
    var b = this.length;
    if (0 !== b % 2) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var d = 0; d < b; d += 2) Rb(this, d, d + 1);
    return this;
  };
  z.prototype.swap32 = function () {
    var b = this.length;
    if (0 !== b % 4) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var d = 0; d < b; d += 4) Rb(this, d, d + 3), Rb(this, d + 1, d + 2);
    return this;
  };
  z.prototype.swap64 = function () {
    var b = this.length;
    if (0 !== b % 8) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var d = 0; d < b; d += 8) Rb(this, d, d + 7), Rb(this, d + 1, d + 6), Rb(this, d + 2, d + 5), Rb(this, d + 3, d + 4);
    return this;
  };
  z.prototype.toString = function () {
    var b = this.length | 0;
    return 0 === b ? "" : 0 === arguments.length ? gg(this, 0, b) : Ui.apply(this, arguments);
  };
  z.prototype.equals = function (b) {
    if (!cb(b)) throw new TypeError("Argument must be a Buffer");
    return this === b ? !0 : 0 === z.compare(this, b);
  };
  z.prototype.inspect = function () {
    var b = "";
    0 < this.length && ((b = this.toString("hex", 0, 50).match(/.{2}/g).join(" ")), 50 < this.length && (b += " ... "));
    return "<Buffer " + b + ">";
  };
  z.prototype.compare = function (b, d, a, c, f) {
    if (!cb(b)) throw new TypeError("Argument must be a Buffer");
    void 0 === d && (d = 0);
    void 0 === a && (a = b ? b.length : 0);
    void 0 === c && (c = 0);
    void 0 === f && (f = this.length);
    if (0 > d || a > b.length || 0 > c || f > this.length) throw new RangeError("out of range index");
    if (c >= f && d >= a) return 0;
    if (c >= f) return -1;
    if (d >= a) return 1;
    d >>>= 0;
    a >>>= 0;
    c >>>= 0;
    f >>>= 0;
    if (this === b) return 0;
    var h = f - c,
      g = a - d,
      k = Math.min(h, g);
    c = this.slice(c, f);
    b = b.slice(d, a);
    for (d = 0; d < k; ++d)
      if (c[d] !== b[d]) {
        h = c[d];
        g = b[d];
        break;
      }
    return h < g ? -1 : g < h ? 1 : 0;
  };
  z.prototype.includes = function (b, d, a) {
    return -1 !== this.indexOf(b, d, a);
  };
  z.prototype.indexOf = function (b, d, a) {
    return hg(this, b, d, a, !0);
  };
  z.prototype.lastIndexOf = function (b, d, a) {
    return hg(this, b, d, a, !1);
  };
  z.prototype.write = function (b, d, a, c) {
    if (void 0 === d) (c = "utf8"), (a = this.length), (d = 0);
    else if (void 0 === a && "string" === typeof d) (c = d), (a = this.length), (d = 0);
    else if (isFinite(d)) (d |= 0), isFinite(a) ? ((a |= 0), void 0 === c && (c = "utf8")) : ((c = a), (a = void 0));
    else throw Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var f = this.length - d;
    if (void 0 === a || a > f) a = f;
    if ((0 < b.length && (0 > a || 0 > d)) || d > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    c || (c = "utf8");
    for (f = !1; ; )
      switch (c) {
        case "hex":
          a: {
            d = Number(d) || 0;
            c = this.length - d;
            a ? ((a = Number(a)), a > c && (a = c)) : (a = c);
            c = b.length;
            if (0 !== c % 2) throw new TypeError("Invalid hex string");
            a > c / 2 && (a = c / 2);
            for (c = 0; c < a; ++c) {
              f = parseInt(b.substr(2 * c, 2), 16);
              if (isNaN(f)) {
                b = c;
                break a;
              }
              this[d + c] = f;
            }
            b = c;
          }
          return b;
        case "utf8":
        case "utf-8":
          return Hc(yd(b, this.length - d), this, d, a);
        case "ascii":
          return Hc(ng(b), this, d, a);
        case "latin1":
        case "binary":
          return Hc(ng(b), this, d, a);
        case "base64":
          return Hc(fg(b), this, d, a);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          c = b;
          f = this.length - d;
          for (var h = [], g = 0; g < c.length && !(0 > (f -= 2)); ++g) {
            var k = c.charCodeAt(g);
            b = k >> 8;
            k %= 256;
            h.push(k);
            h.push(b);
          }
          return Hc(h, this, d, a);
        default:
          if (f) throw new TypeError("Unknown encoding: " + c);
          c = ("" + c).toLowerCase();
          f = !0;
      }
  };
  z.prototype.toJSON = function () {
    return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
  };
  var jg = 4096;
  z.prototype.slice = function (b, d) {
    var a = this.length;
    b = ~~b;
    d = void 0 === d ? a : ~~d;
    0 > b ? ((b += a), 0 > b && (b = 0)) : b > a && (b = a);
    0 > d ? ((d += a), 0 > d && (d = 0)) : d > a && (d = a);
    d < b && (d = b);
    if (z.TYPED_ARRAY_SUPPORT) (d = this.subarray(b, d)), (d.__proto__ = z.prototype);
    else {
      a = d - b;
      d = new z(a, void 0);
      for (var c = 0; c < a; ++c) d[c] = this[c + b];
    }
    return d;
  };
  z.prototype.readUIntLE = function (b, d, a) {
    b |= 0;
    d |= 0;
    a || va(b, d, this.length);
    a = this[b];
    for (var c = 1, f = 0; ++f < d && (c *= 256); ) a += this[b + f] * c;
    return a;
  };
  z.prototype.readUIntBE = function (b, d, a) {
    b |= 0;
    d |= 0;
    a || va(b, d, this.length);
    a = this[b + --d];
    for (var c = 1; 0 < d && (c *= 256); ) a += this[b + --d] * c;
    return a;
  };
  z.prototype.readUInt8 = function (b, d) {
    d || va(b, 1, this.length);
    return this[b];
  };
  z.prototype.readUInt16LE = function (b, d) {
    d || va(b, 2, this.length);
    return this[b] | (this[b + 1] << 8);
  };
  z.prototype.readUInt16BE = function (b, d) {
    d || va(b, 2, this.length);
    return (this[b] << 8) | this[b + 1];
  };
  z.prototype.readUInt32LE = function (b, d) {
    d || va(b, 4, this.length);
    return (this[b] | (this[b + 1] << 8) | (this[b + 2] << 16)) + 16777216 * this[b + 3];
  };
  z.prototype.readUInt32BE = function (b, d) {
    d || va(b, 4, this.length);
    return 16777216 * this[b] + ((this[b + 1] << 16) | (this[b + 2] << 8) | this[b + 3]);
  };
  z.prototype.readIntLE = function (b, d, a) {
    b |= 0;
    d |= 0;
    a || va(b, d, this.length);
    a = this[b];
    for (var c = 1, f = 0; ++f < d && (c *= 256); ) a += this[b + f] * c;
    a >= 128 * c && (a -= Math.pow(2, 8 * d));
    return a;
  };
  z.prototype.readIntBE = function (b, d, a) {
    b |= 0;
    d |= 0;
    a || va(b, d, this.length);
    a = d;
    for (var c = 1, f = this[b + --a]; 0 < a && (c *= 256); ) f += this[b + --a] * c;
    f >= 128 * c && (f -= Math.pow(2, 8 * d));
    return f;
  };
  z.prototype.readInt8 = function (b, d) {
    d || va(b, 1, this.length);
    return this[b] & 128 ? -1 * (255 - this[b] + 1) : this[b];
  };
  z.prototype.readInt16LE = function (b, d) {
    d || va(b, 2, this.length);
    b = this[b] | (this[b + 1] << 8);
    return b & 32768 ? b | 4294901760 : b;
  };
  z.prototype.readInt16BE = function (b, d) {
    d || va(b, 2, this.length);
    b = this[b + 1] | (this[b] << 8);
    return b & 32768 ? b | 4294901760 : b;
  };
  z.prototype.readInt32LE = function (b, d) {
    d || va(b, 4, this.length);
    return this[b] | (this[b + 1] << 8) | (this[b + 2] << 16) | (this[b + 3] << 24);
  };
  z.prototype.readInt32BE = function (b, d) {
    d || va(b, 4, this.length);
    return (this[b] << 24) | (this[b + 1] << 16) | (this[b + 2] << 8) | this[b + 3];
  };
  z.prototype.readFloatLE = function (b, d) {
    d || va(b, 4, this.length);
    return xd(this, b, !0, 23, 4);
  };
  z.prototype.readFloatBE = function (b, d) {
    d || va(b, 4, this.length);
    return xd(this, b, !1, 23, 4);
  };
  z.prototype.readDoubleLE = function (b, d) {
    d || va(b, 8, this.length);
    return xd(this, b, !0, 52, 8);
  };
  z.prototype.readDoubleBE = function (b, d) {
    d || va(b, 8, this.length);
    return xd(this, b, !1, 52, 8);
  };
  z.prototype.writeUIntLE = function (b, d, a, c) {
    b = +b;
    d |= 0;
    a |= 0;
    c || Ia(this, b, d, a, Math.pow(2, 8 * a) - 1, 0);
    c = 1;
    var f = 0;
    for (this[d] = b & 255; ++f < a && (c *= 256); ) this[d + f] = (b / c) & 255;
    return d + a;
  };
  z.prototype.writeUIntBE = function (b, d, a, c) {
    b = +b;
    d |= 0;
    a |= 0;
    c || Ia(this, b, d, a, Math.pow(2, 8 * a) - 1, 0);
    c = a - 1;
    var f = 1;
    for (this[d + c] = b & 255; 0 <= --c && (f *= 256); ) this[d + c] = (b / f) & 255;
    return d + a;
  };
  z.prototype.writeUInt8 = function (b, d, a) {
    b = +b;
    d |= 0;
    a || Ia(this, b, d, 1, 255, 0);
    z.TYPED_ARRAY_SUPPORT || (b = Math.floor(b));
    this[d] = b & 255;
    return d + 1;
  };
  z.prototype.writeUInt16LE = function (b, d, a) {
    b = +b;
    d |= 0;
    a || Ia(this, b, d, 2, 65535, 0);
    z.TYPED_ARRAY_SUPPORT ? ((this[d] = b & 255), (this[d + 1] = b >>> 8)) : zd(this, b, d, !0);
    return d + 2;
  };
  z.prototype.writeUInt16BE = function (b, d, a) {
    b = +b;
    d |= 0;
    a || Ia(this, b, d, 2, 65535, 0);
    z.TYPED_ARRAY_SUPPORT ? ((this[d] = b >>> 8), (this[d + 1] = b & 255)) : zd(this, b, d, !1);
    return d + 2;
  };
  z.prototype.writeUInt32LE = function (b, d, a) {
    b = +b;
    d |= 0;
    a || Ia(this, b, d, 4, 4294967295, 0);
    z.TYPED_ARRAY_SUPPORT ? ((this[d + 3] = b >>> 24), (this[d + 2] = b >>> 16), (this[d + 1] = b >>> 8), (this[d] = b & 255)) : Ad(this, b, d, !0);
    return d + 4;
  };
  z.prototype.writeUInt32BE = function (b, d, a) {
    b = +b;
    d |= 0;
    a || Ia(this, b, d, 4, 4294967295, 0);
    z.TYPED_ARRAY_SUPPORT ? ((this[d] = b >>> 24), (this[d + 1] = b >>> 16), (this[d + 2] = b >>> 8), (this[d + 3] = b & 255)) : Ad(this, b, d, !1);
    return d + 4;
  };
  z.prototype.writeIntLE = function (b, d, a, c) {
    b = +b;
    d |= 0;
    c || ((c = Math.pow(2, 8 * a - 1)), Ia(this, b, d, a, c - 1, -c));
    c = 0;
    var f = 1,
      h = 0;
    for (this[d] = b & 255; ++c < a && (f *= 256); ) 0 > b && 0 === h && 0 !== this[d + c - 1] && (h = 1), (this[d + c] = (((b / f) >> 0) - h) & 255);
    return d + a;
  };
  z.prototype.writeIntBE = function (b, d, a, c) {
    b = +b;
    d |= 0;
    c || ((c = Math.pow(2, 8 * a - 1)), Ia(this, b, d, a, c - 1, -c));
    c = a - 1;
    var f = 1,
      h = 0;
    for (this[d + c] = b & 255; 0 <= --c && (f *= 256); ) 0 > b && 0 === h && 0 !== this[d + c + 1] && (h = 1), (this[d + c] = (((b / f) >> 0) - h) & 255);
    return d + a;
  };
  z.prototype.writeInt8 = function (b, d, a) {
    b = +b;
    d |= 0;
    a || Ia(this, b, d, 1, 127, -128);
    z.TYPED_ARRAY_SUPPORT || (b = Math.floor(b));
    0 > b && (b = 255 + b + 1);
    this[d] = b & 255;
    return d + 1;
  };
  z.prototype.writeInt16LE = function (b, d, a) {
    b = +b;
    d |= 0;
    a || Ia(this, b, d, 2, 32767, -32768);
    z.TYPED_ARRAY_SUPPORT ? ((this[d] = b & 255), (this[d + 1] = b >>> 8)) : zd(this, b, d, !0);
    return d + 2;
  };
  z.prototype.writeInt16BE = function (b, d, a) {
    b = +b;
    d |= 0;
    a || Ia(this, b, d, 2, 32767, -32768);
    z.TYPED_ARRAY_SUPPORT ? ((this[d] = b >>> 8), (this[d + 1] = b & 255)) : zd(this, b, d, !1);
    return d + 2;
  };
  z.prototype.writeInt32LE = function (b, d, a) {
    b = +b;
    d |= 0;
    a || Ia(this, b, d, 4, 2147483647, -2147483648);
    z.TYPED_ARRAY_SUPPORT ? ((this[d] = b & 255), (this[d + 1] = b >>> 8), (this[d + 2] = b >>> 16), (this[d + 3] = b >>> 24)) : Ad(this, b, d, !0);
    return d + 4;
  };
  z.prototype.writeInt32BE = function (b, d, a) {
    b = +b;
    d |= 0;
    a || Ia(this, b, d, 4, 2147483647, -2147483648);
    0 > b && (b = 4294967295 + b + 1);
    z.TYPED_ARRAY_SUPPORT ? ((this[d] = b >>> 24), (this[d + 1] = b >>> 16), (this[d + 2] = b >>> 8), (this[d + 3] = b & 255)) : Ad(this, b, d, !1);
    return d + 4;
  };
  z.prototype.writeFloatLE = function (b, d, a) {
    return lg(this, b, d, !0, a);
  };
  z.prototype.writeFloatBE = function (b, d, a) {
    return lg(this, b, d, !1, a);
  };
  z.prototype.writeDoubleLE = function (b, d, a) {
    return mg(this, b, d, !0, a);
  };
  z.prototype.writeDoubleBE = function (b, d, a) {
    return mg(this, b, d, !1, a);
  };
  z.prototype.copy = function (b, d, a, c) {
    a || (a = 0);
    c || 0 === c || (c = this.length);
    d >= b.length && (d = b.length);
    d || (d = 0);
    0 < c && c < a && (c = a);
    if (c === a || 0 === b.length || 0 === this.length) return 0;
    if (0 > d) throw new RangeError("targetStart out of bounds");
    if (0 > a || a >= this.length) throw new RangeError("sourceStart out of bounds");
    if (0 > c) throw new RangeError("sourceEnd out of bounds");
    c > this.length && (c = this.length);
    b.length - d < c - a && (c = b.length - d + a);
    var f = c - a;
    if (this === b && a < d && d < c) for (c = f - 1; 0 <= c; --c) b[c + d] = this[c + a];
    else if (1e3 > f || !z.TYPED_ARRAY_SUPPORT) for (c = 0; c < f; ++c) b[c + d] = this[c + a];
    else Uint8Array.prototype.set.call(b, this.subarray(a, a + f), d);
    return f;
  };
  z.prototype.fill = function (b, d, a, c) {
    if ("string" === typeof b) {
      "string" === typeof d ? ((c = d), (d = 0), (a = this.length)) : "string" === typeof a && ((c = a), (a = this.length));
      if (1 === b.length) {
        var f = b.charCodeAt(0);
        256 > f && (b = f);
      }
      if (void 0 !== c && "string" !== typeof c) throw new TypeError("encoding must be a string");
      if ("string" === typeof c && !z.isEncoding(c)) throw new TypeError("Unknown encoding: " + c);
    } else "number" === typeof b && (b &= 255);
    if (0 > d || this.length < d || this.length < a) throw new RangeError("Out of range index");
    if (a <= d) return this;
    d >>>= 0;
    a = void 0 === a ? this.length : a >>> 0;
    b || (b = 0);
    if ("number" === typeof b) for (c = d; c < a; ++c) this[c] = b;
    else for (b = cb(b) ? b : yd(new z(b, c).toString()), f = b.length, c = 0; c < a - d; ++c) this[c + d] = b[c % f];
    return this;
  };
  var Vi = /[^+\/0-9A-Za-z-_]/g,
    qf = { normal: null, road: sg() },
    yl = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.name = "LineLayer3D";
        a.initData();
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              color: "rgba(25, 25, 250, 1)",
              offset: 0,
              blend: "normal",
              width: 4,
              unit: "px",
              flat: !1,
              antialias: !1,
              style: "normal",
              dashArray: [0, 0],
              dashOffset: 0,
              polygonOffset: [0, 0]
            };
          }
        },
        {
          key: "initData",
          value: function () {
            this.dataMgr = { position: [], prev: [], next: [], direction: [], color: [], index: [], counter: [], uv: [] };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions(),
              b = [];
            c.enablePicked && b.push("PICK");
            qf[c.style] && ((this.isUseTexture = !0), b.push("USE_TEXTURE"));
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;uniform vec4 uSelectedColor;uniform mat4 uMatrix;uniform bool uFlat;uniform bool uUnitPx;uniform vec2 uDashArray;uniform float thickness;uniform float zoomUnits;uniform float devicePixelRatio;uniform float uOffset;attribute vec3 position;attribute vec3 next;attribute vec3 previous;attribute float direction;attribute vec4 aColor;attribute float aDistance;attribute float aTotalDistance;\n#if defined(USE_TEXTURE)\nattribute vec2 uv;\n#endif\nvarying vec4 vColor;varying vec2 vNormal;varying vec2 vUV;varying vec2 vDashArray;varying float vTotalDistance;varying float vCounter;vec2 project(vec4 coord){vec3 screen=coord.xyz/coord.w;vec2 clip=(screen.xy+1.0)/2.0;return clip*MAPV_resolution;}vec4 unproject(vec2 projected,float z,float w){vec2 clip=projected/MAPV_resolution;vec2 screen=clip*2.0-1.0;return vec4(screen*w,z,w);}vec3 getNormalAndWidth(vec2 currentScreen,vec2 previousScreen,vec2 nextScreen,float thickness){vec2 dir=vec2(0.0);if(currentScreen==previousScreen){dir=normalize(nextScreen-currentScreen);}else if(currentScreen==nextScreen){dir=normalize(currentScreen-previousScreen);}else{vec2 dirA=normalize((currentScreen-previousScreen));vec2 dirB=normalize((nextScreen-currentScreen));vec2 tangent=normalize(dirA+dirB);vec2 perp=vec2(-dirA.y,dirA.x);vec2 miter=vec2(-tangent.y,tangent.x);dir=tangent;float angle=40.0;if(dot(dirA,dirB)>cos(radians(angle))){thickness=thickness/dot(miter,perp);}}vec2 normal=vec2(-dir.y,dir.x);return vec3(normal,thickness);}void main(){vColor=aColor;vCounter=aDistance/aTotalDistance;vDashArray=uDashArray/aTotalDistance;if(uUnitPx){vDashArray*=zoomUnits;}vTotalDistance=aTotalDistance;\n#if defined(USE_TEXTURE)\nvUV=uv;\n#endif\n#if defined(PICK)\nif(mapvIsPicked()){vColor=uSelectedColor;}\n#endif\nif(uFlat){float width=thickness;if(uUnitPx){width*=zoomUnits;}vec3 nw=getNormalAndWidth(position.xy,previous.xy,next.xy,width);width=nw.z;vec2 normal=nw.xy;vNormal=normal*direction;normal*=width/2.0;float offsetXy=uOffset;float offsetHeight=uOffset/100.0;if(uUnitPx){offsetXy/=zoomUnits;offsetHeight*=zoomUnits;}gl_Position=uMatrix*vec4(position.xy+normal*(direction+offsetXy),position.z+offsetHeight,1.0);}else{vec4 previousProjected=uMatrix*vec4(previous,1.0);vec4 currentProjected=uMatrix*vec4(position,1.0);vec4 nextProjected=uMatrix*vec4(next,1.0);vec2 currentScreen=project(currentProjected);vec2 previousScreen=project(previousProjected);vec2 nextScreen=project(nextProjected);float width=thickness*devicePixelRatio;if(!uUnitPx){width/=zoomUnits;}vec3 nw=getNormalAndWidth(currentScreen,previousScreen,nextScreen,width);width=nw.z;vec2 normal=nw.xy;vNormal=normal*direction;normal*=width/2.0;vec2 pos=currentScreen+normal*direction;vec4 finalPos=unproject(pos,currentProjected.z,currentProjected.w);gl_Position=finalPos;}}",
                fragmentShader:
                  "precision highp float;varying vec4 vColor;varying vec2 vNormal;varying vec2 vUV;varying vec2 vDashArray;varying float vCounter;varying float vTotalDistance;uniform bool uAntialias;uniform float uDashOffset;uniform float zoomUnits;uniform float thickness;\n#if defined(USE_TEXTURE)\nuniform float uTextureMargin;uniform sampler2D textureImage;\n#endif\nvoid main(){vec4 color=vColor;if(uAntialias){float blur=1.0;blur=1.0-smoothstep(0.8,1.0,length(vNormal));color.a*=blur;}\n#if defined(USE_TEXTURE)\nfloat segLen=uTextureMargin*zoomUnits;float textureLen=thickness*zoomUnits;float deltaX=mod(vUV.x,segLen);float middle=segLen/2.0;if(deltaX>=middle&&deltaX<=middle+textureLen){float uvx=(deltaX-middle)/textureLen;vec4 texture=texture2D(textureImage,vec2(uvx,vUV.y));color=texture.a>=0.5 ? texture : color;}\n#endif\nif(vDashArray.y>0.0){float offset=uDashOffset*zoomUnits/vTotalDistance;color.a*=(1.0-step(vDashArray.x,mod(vCounter+offset,vDashArray.x+vDashArray.y)));}gl_FragColor=color;}",
                defines: b
              },
              this
            );
            this.prevBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.currentBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.nextBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.directionBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.colorBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.counterBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.uvBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            b = [
              { stride: 12, name: "previous", buffer: this.prevBuffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: 12, name: "position", buffer: this.currentBuffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: 12, name: "next", buffer: this.nextBuffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: 4, name: "direction", buffer: this.directionBuffer, size: 1, type: "FLOAT", offset: 0 },
              { stride: 16, name: "aColor", buffer: this.colorBuffer, size: 4, type: "FLOAT", offset: 0 },
              { stride: 8, name: "aDistance", buffer: this.counterBuffer, size: 1, type: "FLOAT", offset: 0 },
              { stride: 8, name: "aTotalDistance", buffer: this.counterBuffer, size: 1, type: "FLOAT", offset: 4 }
            ];
            b = b.concat(this.getCommonAttributes());
            qf[c.style] &&
              (b.push({ stride: 8, name: "uv", buffer: this.uvBuffer, size: 2, type: "FLOAT", offset: 0 }), this.setOptions({ texture: qf[c.style] }), this.loadTexture());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: b });
          }
        },
        { key: "onDestroy", value: function () {} },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this;
            if (this.gl) {
              this.initData();
              for (var d = a.color, g = [], k = 0; k < c.length; k++) {
                var l = [],
                  n = c[k].geometry.coordinates;
                n &&
                  0 < n.length &&
                  (l =
                    "MultiPolygon" === c[k].geometry.type
                      ? n
                          .reduce(function (a, c) {
                            return a.concat(c);
                          })[0]
                          .map(function (a) {
                            return b.normizedPoint(a);
                          })
                      : "Polygon" === c[k].geometry.type || "MultiLineString" === c[k].geometry.type
                      ? n[0].map(function (a) {
                          return b.normizedPoint(a);
                        })
                      : n.map(function (a) {
                          return b.normizedPoint(a);
                        }));
                n = this.getProperty("color", d, c[k]);
                n = this.getProperty("lineColor", d, c[k]);
                n = this.normizedColor(n);
                for (var m = this.addMultipleCoords(l), p = 0; p < m.length; p++) this.processData(this.dataMgr, m[p], n);
                if (a.enablePicked)
                  for (n = this.indexToRgb(k), m = 0; m < l.length; m++)
                    g.push(n[0] / 255, n[1] / 255, n[2] / 255),
                      g.push(n[0] / 255, n[1] / 255, n[2] / 255),
                      a.repeat &&
                        (g.push(n[0] / 255, n[1] / 255, n[2] / 255),
                        g.push(n[0] / 255, n[1] / 255, n[2] / 255),
                        g.push(n[0] / 255, n[1] / 255, n[2] / 255),
                        g.push(n[0] / 255, n[1] / 255, n[2] / 255));
              }
              this.counterBuffer.updateData(new Float32Array(this.dataMgr.counter));
              this.currentBuffer.updateData(new Float32Array(this.dataMgr.position));
              this.prevBuffer.updateData(new Float32Array(this.dataMgr.prev));
              this.nextBuffer.updateData(new Float32Array(this.dataMgr.next));
              this.directionBuffer.updateData(new Float32Array(this.dataMgr.direction));
              this.colorBuffer.updateData(new Float32Array(this.dataMgr.color));
              this.indexBuffer.updateData(new Uint32Array(this.dataMgr.index));
              this.isUseTexture && this.uvBuffer.updateData(new Float32Array(this.dataMgr.uv));
              a.enablePicked && this.pickBuffer.updateData(new Float32Array(g));
            }
          }
        },
        {
          key: "processData",
          value: function (a, c, b) {
            var d,
              f,
              k,
              l,
              n,
              m,
              p,
              q,
              t = c.length,
              v = a.position.length / 6,
              r = qg(c),
              u = r.arr,
              w = r.total;
            r = Ra(
              u.map(function (a) {
                return [a, w];
              })
            );
            u = u.map(function (a) {
              return [a, 0, a, 1];
            });
            var y = Ra(
                c.map(function (a) {
                  return -1;
                }),
                !0
              ),
              x = Ra(c),
              D = Ra(c.map(Bd(-1))),
              C = Ra(c.map(Bd(1)));
            c = Ra(
              c.map(function (a) {
                return b;
              })
            );
            t = pg(t, v);
            (d = a.uv).push.apply(d, W(db(u)));
            (f = a.counter).push.apply(f, W(db(r)));
            (k = a.position).push.apply(k, W(db(x)));
            (l = a.prev).push.apply(l, W(db(D)));
            (n = a.next).push.apply(n, W(db(C)));
            (m = a.direction).push.apply(m, W(y));
            (p = a.color).push.apply(p, W(db(c)));
            (q = a.index).push.apply(q, W(t));
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.matrix,
              d = this.dataMgr;
            if (d && !(0 >= d.index.length) && this.map) {
              var g = this.getOptions(),
                k = this.program;
              k.use(c);
              a = S(this.getCommonUniforms(a), {
                uMatrix: b,
                uFlat: g.flat,
                uUnitPx: "px" === g.unit,
                zoomUnits: this.map.getZoomUnits(),
                devicePixelRatio: window.devicePixelRatio,
                thickness: g.width,
                uDashArray: g.dashArray,
                uDashOffset: g.dashOffset,
                uAntialias: g.antialias,
                uOffset: g.offset
              });
              this.isUseTexture && (a = S(a, { uTextureMargin: 140, textureImage: this.texture }));
              k.setUniforms(a);
              this.setGLState({
                blend: !0,
                blendEquation: c.FUNC_ADD,
                blendFunc: "lighter" === g.blend ? [c.SRC_ALPHA, c.ONE] : [c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA],
                polygonOffset: g.polygonOffset
              });
              this.indexBuffer.bind();
              this.vertexArray.bind();
              c.drawElements(c.TRIANGLES, d.index.length, c.UNSIGNED_INT, 0);
            }
          }
        },
        {
          key: "loadTexture",
          value: function (a) {
            var c = this,
              b = this.getOptions();
            b.texture
              ? ta(this.gl, b.texture, function (b, d) {
                  c.image = d;
                  c.texture = b;
                  a && a();
                  c.webglLayer.render();
                })
              : ((this.image = this.texture = null), a && a());
          }
        }
      ]);
      return d;
    })(ca),
    zl = (function () {
      function b(d) {
        F(this, b);
        this.join = d.join || "miter";
        this.cap = d.cap || "butt";
        this.thickness = d.thickness || 4;
        this.miterLimit = d.miterLimit || 2 * this.thickness;
        this.dash = d.dash || !1;
        this.complex = { positions: [], indices: [], normals: [], colors: [], uvs: [], startIndex: 0, maxDistance: 0 };
        this._lastFlip = -1;
        this._started = !1;
        this._normal = null;
        this._totalDistance = 0;
        this._colorFlag = !1;
        this._count = 0;
      }
      I(b, [
        {
          key: "extrude",
          value: function (b, a, c, f) {
            var d = this.complex;
            if (1 >= b.length) return d;
            this._lastFlip = -1;
            this._started = !1;
            this._normal = null;
            this._totalDistance = 0;
            for (var g = b.length, k = d.startIndex, l = null, n = 1; n < g; n++) {
              var m = l || b[n - 1],
                p = b[n],
                q = n < g - 1 ? b[n + 1] : null;
              q && p[0] === q[0] && p[1] === q[1] && p[2] === q[2] ? (l = m) : ((m = this._segment(d, k, m, p, q, a, c, f)), -1 !== m && ((k += m), (l = null)));
            }
            this.dash && (d.maxDistance = Math.max(this._totalDistance, d.maxDistance));
            d.startIndex = d.positions.length / 7;
            return d;
          }
        },
        {
          key: "_segment",
          value: function (b, a, c, f, h, g, k, l) {
            l[0] instanceof Array && (this._colorFlag = !0);
            var d = 0,
              m = Z.create(),
              p = Z.create(),
              q = Z.create(),
              t = Z.create(),
              v = b.indices,
              r = b.positions,
              u = b.normals,
              w = b.colors;
            b = b.uvs;
            var y = "square" === this.cap,
              x = "round" === this.cap,
              D = "bevel" === this.join,
              C = "round" === this.join,
              A = [f[0], f[1]],
              E = [c[0], c[1]];
            tg(p, A, E);
            var J = 0;
            this.dash && ((J = this._calcDistance(A, E)), (this._totalDistance += J));
            this._normal || ((this._normal = Z.create()), Cd(this._normal, p));
            if (!this._started)
              if (((this._started = !0), y)) {
                E = Z.create();
                var G = Z.create();
                Z.add(E, this._normal, p);
                Z.sub(G, this._normal, p);
                u.push(G[0], G[1], 0);
                u.push(E[0], E[1], 0);
                r.push(c[0], c[1], c[2], this._totalDistance - J, g, k, 0);
                r.push(c[0], c[1], c[2], this._totalDistance - J, -g, k, 0);
                b.push(this._totalDistance - J, 0, this._totalDistance - J, 1);
                this._colorFlag
                  ? (w.push(l[0][0], l[0][1], l[0][2], l[0][3]), w.push(l[0][0], l[0][1], l[0][2], l[0][3]))
                  : (w.push(l[0], l[1], l[2], l[3]), w.push(l[0], l[1], l[2], l[3]));
              } else if (x) {
                E = Z.fromValues(-p[0], -p[1]);
                G = Z.create();
                Z.sub(G, this._normal, p);
                Z.normalize(G, G);
                var z = Z.create();
                Z.add(z, this._normal, p);
                Z.normalize(z, z);
                var B = Z.fromValues(this._normal[0], this._normal[1]),
                  F = Z.fromValues(-this._normal[0], -this._normal[1]);
                u.push(E[0], E[1], 0);
                u.push(G[0], G[1], 0);
                u.push(-z[0], -z[1], 0);
                u.push(B[0], B[1], 0);
                u.push(F[0], F[1], 0);
                for (E = 0; 5 > E; E++)
                  r.push(c[0], c[1], c[2], this._totalDistance - J, g, k, 0),
                    b.push(this._totalDistance - J, 0),
                    this._colorFlag ? w.push(l[0][0], l[0][1], l[0][2], l[0][3]) : w.push(l[0], l[1], l[2], l[3]);
                v.push(a + 0, a + 2, a + 1, a + 1, a + 2, a + 3, a + 3, a + 2, a + 4);
                d += 3;
                a += 3;
              } else this._extrusions(r, u, b, w, c, this._normal, g, this._totalDistance - J, k, l, 0);
            v.push.apply(v, W(-1 === this._lastFlip ? [a + 0, a + 1, a + 2] : [a + 1, a + 0, a + 2]));
            if (h)
              tg(q, [h[0], h[1]], A),
                this._count++,
                Z.create(),
                Z.add(t, p, q),
                Z.normalize(t, t),
                (x = Z.fromValues(-t[1], t[0])),
                (p = Z.fromValues(-p[1], p[0])),
                (p = [g / Z.dot(x, p), x]),
                (p = da(p, 2)),
                (x = p[0]),
                (p = p[1]),
                (t = 0 < Z.dot(t, this._normal) ? -1 : 1),
                D || "miter" !== this.join || (Math.abs(x) > this.miterLimit && (D = !0)),
                D
                  ? ((C = Math.min(2 * g, Math.abs(x))),
                    u.push(this._normal[0], this._normal[1], 0),
                    u.push(p[0], p[1], 0),
                    r.push(f[0], f[1], f[2], this._totalDistance, g * t, k, 0),
                    r.push(f[0], f[1], f[2], this._totalDistance, -C * t, k, 0),
                    v.push.apply(v, W(this._lastFlip === -t ? [a + 2, a + 1, a + 3] : [a + 0, a + 2, a + 3])),
                    Cd(m, q),
                    Z.copy(this._normal, m),
                    u.push(this._normal[0], this._normal[1], 0),
                    r.push(f[0], f[1], f[2], this._totalDistance, g * t, k, 0),
                    v.push.apply(v, W(1 === t ? [a + 2, a + 3, a + 4] : [a + 3, a + 2, a + 4])),
                    this._flipedUV(b, this._totalDistance, t, !0),
                    this._colorFlag
                      ? (w.push(l[this._count][0], l[this._count][1], l[this._count][2], l[this._count][3]),
                        w.push(l[this._count][0], l[this._count][1], l[this._count][2], l[this._count][3]),
                        w.push(l[this._count][0], l[this._count][1], l[this._count][2], l[this._count][3]))
                      : (w.push(l[0], l[1], l[2], l[3]), w.push(l[0], l[1], l[2], l[3]), w.push(l[0], l[1], l[2], l[3])),
                    (d += 3))
                  : C
                  ? ((C = Math.min(2 * g, Math.abs(x))),
                    u.push(this._normal[0], this._normal[1], 0),
                    u.push(p[0], p[1], 0),
                    u.push(p[0], p[1], 0),
                    r.push(f[0], f[1], f[2], this._totalDistance, g * t, k, 0),
                    r.push(f[0], f[1], f[2], this._totalDistance, g * t, k, 0),
                    r.push(f[0], f[1], f[2], this._totalDistance, -C * t, k, 0),
                    v.push.apply(v, W(this._lastFlip === -t ? [a + 2, a + 1, a + 4, a + 2, a + 4, a + 3] : [a + 0, a + 2, a + 4, a + 2, a + 3, a + 4])),
                    Cd(m, q),
                    Z.copy(this._normal, m),
                    u.push(this._normal[0], this._normal[1], 0),
                    r.push(f[0], f[1], f[2], this._totalDistance, g * t, k, 0),
                    v.push.apply(v, W(1 === t ? [a + 4, a + 3, a + 5] : [a + 3, a + 4, a + 5])),
                    this._flipedUV(b, this._totalDistance, t, !1),
                    this._colorFlag
                      ? (w.push(l[this._count][0], l[this._count][1], l[this._count][2], l[this._count][3]),
                        w.push(l[this._count][0], l[this._count][1], l[this._count][2], l[this._count][3]),
                        w.push(l[this._count][0], l[this._count][1], l[this._count][2], l[this._count][3]),
                        w.push(l[this._count][0], l[this._count][1], l[this._count][2], l[this._count][3]))
                      : (w.push(l[0], l[1], l[2], l[3]), w.push(l[0], l[1], l[2], l[3]), w.push(l[0], l[1], l[2], l[3]), w.push(l[0], l[1], l[2], l[3])),
                    (d += 4))
                  : (this._extrusions(r, u, b, w, f, p, x, this._totalDistance, k, l, this._count),
                    v.push.apply(v, W(-1 === this._lastFlip ? [a + 2, a + 1, a + 3] : [a + 2, a + 0, a + 3])),
                    (t = -1),
                    Z.copy(this._normal, p),
                    (d += 2)),
                (this._lastFlip = t);
            else if (
              (Cd(this._normal, p),
              (m = l.length - 1),
              y
                ? ((q = Z.create()),
                  (C = Z.create()),
                  Z.add(q, p, this._normal),
                  Z.sub(C, p, this._normal),
                  u.push(q[0], q[1], 0),
                  u.push(C[0], C[1], 0),
                  r.push(f[0], f[1], f[2], this._totalDistance, g, k, 0),
                  r.push(f[0], f[1], f[2], this._totalDistance, g, k, 0),
                  b.push(this._totalDistance, 0, this._totalDistance, 1),
                  this._colorFlag
                    ? (w.push(l[m][0], l[m][1], l[m][2], l[m][3]), w.push(l[m][0], l[m][1], l[m][2], l[m][3]))
                    : (w.push(l[0], l[1], l[2], l[3]), w.push(l[0], l[1], l[2], l[3])))
                : this._extrusions(r, u, b, w, f, this._normal, g, this._totalDistance, k, l, m),
              v.push.apply(v, W(-1 === this._lastFlip ? [a + 2, a + 1, a + 3] : [a + 2, a + 0, a + 3])),
              (d += 2),
              x)
            ) {
              q = Z.create();
              Z.add(q, p, this._normal);
              Z.normalize(q, q);
              C = Z.create();
              Z.sub(C, p, this._normal);
              Z.normalize(C, C);
              p = Z.fromValues(p[0], p[1]);
              u.push(q[0], q[1], 0);
              u.push(C[0], C[1], 0);
              u.push(p[0], p[1], 0);
              for (u = 0; 3 > u; u++)
                r.push(f[0], f[1], f[2], this._totalDistance, g, k, 0),
                  b.push(this._totalDistance, 0),
                  this._colorFlag ? w.push(l[m][0], l[m][1], l[m][2], l[m][3]) : w.push(l[0], l[1], l[2], l[3]);
              v.push(a + 2, a + 3, a + 4, a + 4, a + 3, a + 5, a + 4, a + 5, a + 6);
              d += 3;
            }
            return d;
          }
        },
        {
          key: "_extrusions",
          value: function (b, a, c, f, h, g, k, l, n, m, p) {
            a.push(g[0], g[1], 0);
            a.push(g[0], g[1], 0);
            b.push(h[0], h[1], h[2], l, k, n, 0);
            b.push(h[0], h[1], h[2], l, -k, n, 0);
            c.push(l, 0, l, 1);
            this._colorFlag
              ? (f.push(m[p][0], m[p][1], m[p][2], m[p][3]), f.push(m[p][0], m[p][1], m[p][2], m[p][3]))
              : (f.push(m[0], m[1], m[2], m[3]), f.push(m[0], m[1], m[2], m[3]));
          }
        },
        {
          key: "_calcDistance",
          value: function (b, a) {
            return Math.sqrt(Math.pow(b[0] - a[0], 2) + Math.pow(b[1] - a[1], 2));
          }
        },
        {
          key: "_flipedUV",
          value: function (b, a, c, f) {
            f ? (-1 === c ? b.push(a, 0, a, 1, a, 0) : b.push(a, 1, a, 0, a, 1)) : -1 === c ? b.push(a, 0, a, 0, a, 1, a, 0) : b.push(a, 1, a, 1, a, 0, a, 1);
          }
        }
      ]);
      return b;
    })(),
    rf = {
      normal: null,
      road: sg,
      arrow: function () {
        var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
          d = b.width;
        b = b.color;
        var a = rg(),
          c = a.canvas;
        a = a.ctx;
        a.save();
        a.moveTo(5, 0);
        a.lineTo(32, 16);
        a.lineTo(5, 32);
        a.strokeStyle = b || "#fff";
        a.lineWidth = d || 8;
        a.stroke();
        a.restore();
        return c;
      }
    },
    sf = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.name = "LineLayer";
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              style: "normal",
              styleOptions: {},
              color: "rgba(25, 25, 250, 1)",
              blend: "default",
              lineJoin: "miter",
              lineCap: "butt",
              unit: "px",
              width: 4,
              offset: 0,
              antialias: !1,
              dashArray: [0, 0],
              dashOffset: 0,
              animation: !1,
              interval: 0.1,
              duration: 2,
              trailLength: 0.5,
              minZoom: 2,
              maxZoom: 25,
              polygonOffset: [0, 0],
              depthTest: !0,
              depthWrite: !0
            };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions(),
              b = [];
            c.enablePicked && b.push("PICK");
            rf[c.style] && ((this.isUseTexture = !0), (this.prevStyle = c.style), (this.prevStyleOptions = c.styleOptions), b.push("USE_TEXTURE"));
            !0 === c.animation && ((this.isAnimateLine = !0), (this.date = new Date()), (this.autoUpdate = !0), b.push("USE_LINE_ANIMATION"));
            !0 === c.useDash && b.push("USE_SIMPLE_DASH");
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;uniform vec4 uSelectedColor;uniform mat4 u_matrix;uniform vec2 u_dash_array;uniform float u_zoom_units;uniform float u_zIndex;uniform bool u_unit_px;attribute vec4 a_color;attribute vec3 a_position;attribute vec3 a_normal;attribute float a_distance;attribute float a_total_distance;attribute float a_width;attribute float a_offset;\n#if defined(USE_TEXTURE)\nattribute vec2 uv;\n#endif\nvarying vec4 v_color;varying vec2 v_normal;varying vec2 v_uv;varying vec2 v_dash_array;varying float v_total_distance;varying float v_counter;varying float v_width;\n#if defined(USE_SIMPLE_DASH)\nvarying vec3 v_position;\n#endif\nvoid main(){v_width=a_width;v_color=a_color;v_counter=a_distance/a_total_distance;v_dash_array=u_dash_array/a_total_distance;if(u_unit_px){v_dash_array*=u_zoom_units;}v_total_distance=a_total_distance;v_normal=vec2(normalize(a_normal.xy)*sign(a_width));\n#if defined(USE_TEXTURE)\nv_uv=uv;\n#endif\n#if defined(PICK)\nif(mapvIsPicked()){v_color=uSelectedColor;}\n#endif\nvec2 extrude=a_normal.xy*a_width/2.0;if(u_unit_px){extrude*=u_zoom_units;}vec2 offsetXY=a_normal.xy*-a_offset;float offsetZ=a_offset/100.0+u_zIndex;if(u_unit_px){offsetXY*=u_zoom_units;offsetZ*=u_zoom_units;}\n#if defined(USE_SIMPLE_DASH)\nv_position=a_position;\n#endif\ngl_Position=u_matrix*vec4(a_position.xy+extrude+offsetXY,a_position.z+offsetZ,1.0);}",
                fragmentShader:
                  "precision highp float;varying vec4 v_color;varying vec2 v_normal;varying vec2 v_uv;varying vec2 v_dash_array;varying float v_counter;varying float v_total_distance;varying float v_width;\n#if defined(USE_SIMPLE_DASH)\nvarying vec3 v_position;\n#endif\nuniform bool u_antialias;uniform float u_dash_offset;uniform float u_zoom_units;\n#if defined(USE_LINE_ANIMATION)\nuniform bool u_animate;uniform float u_time;uniform float u_duration;uniform float u_interval;uniform float u_trail_length;\n#endif\n#if defined(USE_TEXTURE)\nuniform float u_texture_width;uniform float u_texture_margin;uniform sampler2D u_sampler;\n#endif\nvoid main(){vec4 color=v_color;\n#if defined(USE_SIMPLE_DASH)\nif(mod(v_position.x,5.0)<3.0){discard;}\n#endif\nif(u_antialias){float blur=1.0;blur=1.0-smoothstep(0.8,1.0,length(v_normal));color.a*=blur;}\n#if defined(USE_LINE_ANIMATION)\nif(u_animate){float alpha=1.0-fract(mod(1.0-v_counter,u_interval)*(1.0/u_interval)+u_time/u_duration);alpha=(alpha+u_trail_length-1.0)/u_trail_length;color.a*=alpha;gl_FragColor=color;return;}\n#endif\n#if defined(USE_TEXTURE)\nfloat margin_width=u_texture_margin*u_zoom_units;float margin_width_half=margin_width/2.0;float texture_width=u_texture_width*u_zoom_units;float delta=mod(v_uv.x,texture_width+margin_width);if(delta>=margin_width_half&&delta<=margin_width_half+texture_width){float uvx=(delta-margin_width_half)/texture_width;vec4 texture=texture2D(u_sampler,vec2(uvx,v_uv.y));color=texture.a>=0.5 ? texture : color;}\n#endif\nif(v_dash_array.y>0.0){float offset=u_dash_offset*u_zoom_units/v_total_distance;color.a*=(1.0-step(v_dash_array.x,mod(v_counter+offset,v_dash_array.x+v_dash_array.y)));}gl_FragColor=color;}",
                defines: b
              },
              this
            );
            this.positionBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.colorBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.normalBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            b = [
              { stride: 28, name: "a_position", buffer: this.positionBuffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: 28, name: "a_distance", buffer: this.positionBuffer, size: 1, type: "FLOAT", offset: 12 },
              { stride: 28, name: "a_width", buffer: this.positionBuffer, size: 1, type: "FLOAT", offset: 16 },
              { stride: 28, name: "a_offset", buffer: this.positionBuffer, size: 1, type: "FLOAT", offset: 20 },
              { stride: 28, name: "a_total_distance", buffer: this.positionBuffer, size: 1, type: "FLOAT", offset: 24 },
              { stride: 12, name: "a_normal", buffer: this.normalBuffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: 16, name: "a_color", buffer: this.colorBuffer, size: 4, type: "FLOAT", offset: 0 }
            ];
            b = b.concat(this.getCommonAttributes());
            this.isUseTexture &&
              ((this.uvBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" })),
              b.push({ stride: 8, name: "uv", buffer: this.uvBuffer, size: 2, type: "FLOAT", offset: 0 }),
              (c = (0, rf[c.style])(c.styleOptions)),
              this.setOptions({ texture: c }),
              this.loadTexture());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: b });
          }
        },
        { key: "onDestroy", value: function () {} },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this,
              d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
            if (this.gl)
              if (!this.isUseTexture || (this.prevStyle === a.style && yc(this.prevStyleOptions) === yc(a.styleOptions))) this.parseData(a, c, d);
              else {
                this.prevStyle = a.style;
                this.prevStyleOptions = a.styleOptions;
                var g = (0, rf[a.style])(a.styleOptions);
                this.setOptions({ texture: g });
                this.loadTextureTime && clearTimeout(this.loadTextureTime);
                this.loadTextureTime = setTimeout(function () {
                  b.loadTexture(function () {
                    b.parseData(a, c, d);
                  });
                }, 0);
              }
          }
        },
        {
          key: "onParseProperties",
          value: function (a) {
            return this.normizedColor(a);
          }
        },
        {
          key: "parseData",
          value: function (a, c, b) {
            var d = this,
              f = a.dashArray,
              k = a.width,
              l = a.color,
              n = a.offset;
            f = !!this.isUseTexture || !!f[1] || !!this.isAnimateLine;
            for (
              var m = new zl({ dash: f, cap: a.lineCap, join: a.lineJoin, miterLimit: a.miterLimit, thickness: k }),
                p = [],
                q = function (f) {
                  var h = c[f].geometry.coordinates;
                  h &&
                    0 < h.length &&
                    ("MultiPolygon" === c[f].geometry.type
                      ? (h = h.reduce(function (a, c) {
                          return a.concat(c);
                        }))
                      : "LineString" === c[f].geometry.type && (h = [h]),
                    (h = h.map(function (a) {
                      a = a.map(function (a) {
                        return d.normizedPoint(a);
                      });
                      !0 === b.closePath && a[0].toString() !== a[a.length - 1].toString() && a.push(a[0]);
                      return a;
                    })));
                  var g = d.getProperty("color", l, c[f]);
                  g = d.getProperty("lineColor", g, c[f]);
                  g = d.onParseProperties(g, c[0].geometry.coordinates.length);
                  var q = d.getProperty("width", k, c[f]);
                  q = Number(q);
                  var t = d.getProperty("offset", n, c[f]);
                  t = Number(t);
                  var v = m.complex.startIndex;
                  h = d.addMultipleCoords(h);
                  for (var D = 0; D < h.length; D++)
                    h[D].forEach(function (a) {
                      m.extrude(a, q, t, g);
                    });
                  if (a.enablePicked)
                    for (f = d.indexToRgb(f), h = m.complex.startIndex; v < h; v++)
                      p.push(f[0] / 255, f[1] / 255, f[2] / 255), a.repeat && (p.push(f[0] / 255, f[1] / 255, f[2] / 255), p.push(f[0] / 255, f[1] / 255, f[2] / 255));
                },
                t = 0;
              t < c.length;
              t++
            )
              q(t);
            q = m.complex;
            if (f) for (t = 0; t < q.positions.length / 7; t++) q.positions[7 * t + 6] = q.maxDistance;
            this.lineData = q;
            this.positionBuffer.updateData(new Float32Array(q.positions));
            this.normalBuffer.updateData(new Float32Array(q.normals));
            this.colorBuffer.updateData(new Float32Array(q.colors));
            this.indexBuffer.updateData(new Uint32Array(q.indices));
            this.isUseTexture && this.uvBuffer.updateData(new Float32Array(q.uvs));
            a.enablePicked && this.pickBuffer.updateData(new Float32Array(p));
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.matrix,
              d = this.lineData;
            if (d && !(0 >= d.indices.length) && this.map) {
              var g = this.getOptions(),
                k = this.program;
              k.use(c);
              a = S(this.getCommonUniforms(a), {
                u_matrix: b,
                u_zoom_units: this.map.getZoomUnits(),
                u_dash_array: g.dashArray,
                u_dash_offset: g.dashOffset,
                u_antialias: g.antialias,
                u_unit_px: "px" === g.unit,
                u_zIndex: g.zIndex
              });
              this.isUseTexture && (a = S(a, { u_texture_width: g.width, u_texture_margin: 140, u_sampler: this.texture }));
              this.isAnimateLine &&
                ((b = this.map.getZoom()),
                (a = S(a, {
                  u_time: (new Date() - this.date) / 1e3,
                  u_animate: b >= g.minZoom && b <= g.maxZoom && this.autoUpdate ? !0 : !1,
                  u_duration: g.duration,
                  u_interval: g.interval,
                  u_trail_length: g.trailLength
                })));
              k.setUniforms(a);
              this.setGLState({ blend: !0, blendEquation: c.FUNC_ADD, blendFunc: Va(c, g.blend), polygonOffset: g.polygonOffset, depthTest: g.depthTest, depthMask: g.depthWrite });
              this.indexBuffer.bind();
              this.vertexArray.bind();
              c.drawElements(c.TRIANGLES, d.indices.length, c.UNSIGNED_INT, 0);
            }
          }
        },
        {
          key: "loadTexture",
          value: function (a) {
            var c = this,
              b = this.getOptions();
            b.texture
              ? ta(this.gl, b.texture, function (b, d) {
                  c.image = d;
                  c.texture = b;
                  a && a();
                  c.webglLayer.render();
                })
              : ((this.image = this.texture = null), a && a());
          }
        }
      ]);
      return d;
    })(ca),
    Al = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.name = "LineRainbowLayer";
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              style: "normal",
              styleOptions: {},
              color: "rgba(25, 25, 250, 1)",
              blend: "normal",
              lineJoin: "miter",
              lineCap: "butt",
              unit: "px",
              width: 4,
              offset: 0,
              antialias: !1,
              dashArray: [0, 0],
              dashOffset: 0,
              animation: !1,
              interval: 0.1,
              duration: 2,
              trailLength: 0.5,
              minZoom: 2,
              maxZoom: 25,
              polygonOffset: [0, 0],
              depthTest: !0,
              depthWrite: !0
            };
          }
        },
        {
          key: "onDestroy",
          value: function () {
            this.options && this.options.enablePicked && (this.pickBuffer = null);
            this.options = this.data = this.indexBuffer = this.normalBuffer = this.colorBuffer = this.positionBuffer = this.program = this.vertexArray = null;
          }
        },
        {
          key: "onParseProperties",
          value: function (a, c) {
            var b = a.length;
            if (a instanceof Array) {
              var d = [];
              if (b < c) {
                var g = Math.floor(c / b);
                c %= b;
                for (var k = 0, l = 0; k < b; k++, l++) for (var n = l < c ? g + 1 : g, m = 0; m < n; m++) d.push(a[k]);
                a = d;
              }
              b = [];
              for (g = 0; g < a.length; g++) b.push(this.normizedColor(a[g]));
            } else b = this.normizedColor(a);
            return b;
          }
        }
      ]);
      return d;
    })(sf),
    Bl = (function () {
      function b(d, a) {
        F(this, b);
        this.layer = d;
        this.gl = a;
        this.initData();
      }
      I(b, [
        {
          key: "initData",
          value: function () {
            this.outWall3d = { vertex: [], vertexBuffer: [], index: [], indexBuffer: [] };
            this.maxLength = 0;
          }
        },
        {
          key: "getData",
          value: function () {
            return this.outWall3d;
          }
        },
        {
          key: "getMaxDataLength",
          value: function () {
            return this.maxLength;
          }
        },
        {
          key: "onLayerChange",
          value: function (b, a) {
            this.initData();
            var c = b.color,
              d = b.height,
              h = b.gradient;
            b = this.gl;
            for (var g = 0; g < a.length; g++) {
              var k = a[g].geometry.coordinates,
                l = k.length;
              this.maxLength = l > this.maxLength ? l : this.maxLength;
              for (var n = [], m = 0; m < l; m++) {
                var p = this.layer.normizedPoint(k[m]);
                n.push(p);
              }
              l = a[g].color || c;
              "properties" in a[g] && "color" in a[g].properties && (l = a[g].properties.color);
              h || "[object Function]" !== Object.prototype.toString.call(l) || (l = l(a[g]));
              k = this.layer.normizedColor(h ? h[0] : l);
              l = this.layer.normizedColor(h ? h[1] : l);
              m = a[g].height || d;
              "properties" in a[g] && "height" in a[g].properties && (m = a[g].properties.height);
              "[object Function]" === Object.prototype.toString.call(m) && (m = m(a[g]));
              this.processData(this.outWall3d, n, k, l, m);
            }
            for (a = 0; a < this.outWall3d.vertex.length; a++) {
              c = [];
              d = this.outWall3d.vertex[a].length;
              for (h = 0; h < d; h++) c.push.apply(c, W(this.outWall3d.vertex[a][h]));
              d = b.createBuffer();
              b.bindBuffer(b.ARRAY_BUFFER, d);
              b.bufferData(b.ARRAY_BUFFER, new Float32Array(c), b.STATIC_DRAW);
              this.outWall3d.vertexBuffer[a] = d;
              b.bindBuffer(b.ARRAY_BUFFER, null);
              d = b.createBuffer();
              b.bindBuffer(b.ELEMENT_ARRAY_BUFFER, d);
              b.bufferData(b.ELEMENT_ARRAY_BUFFER, new Uint16Array(this.outWall3d.index[a]), b.STATIC_DRAW);
              this.outWall3d.indexBuffer[a] = d;
              b.bindBuffer(b.ELEMENT_ARRAY_BUFFER, null);
            }
          }
        },
        {
          key: "processData",
          value: function (b, a, c, f, h) {
            var d = b.vertex[b.vertex.length - 1],
              k = b.index[b.index.length - 1],
              l = a.length;
            if (!k || 65536 <= k.length + 2 * l + 2) (d = []), (k = []), b.vertex.push(d), b.index.push(k);
            (b = d.length) && k.push(b - 1, b);
            for (var n = (b = 0); n < l; n++) {
              var m = [],
                p = [],
                q = a[n];
              m.push(q[0], q[1]);
              m.push(q[2] ? Number(q[2]) + h : h);
              m.push(q[3] ? Number(q[3]) : n);
              m.push(b);
              m.push(c[0], c[1], c[2], c[3]);
              p.push(q[0], q[1]);
              p.push(q[2] ? Number(q[2]) : 0);
              p.push(q[3] ? Number(q[3]) : n);
              p.push(b);
              p.push(f[0], f[1], f[2], f[3]);
              q = d.length;
              d.push(m, p);
              k.push(q, q + 1);
              n < l - 1 && (b += this.getDistance(a[n], a[n + 1]));
            }
          }
        },
        {
          key: "getDistance",
          value: function (b, a) {
            return Math.sqrt(Math.pow(Math.abs(b[0] - a[0]), 2) + Math.pow(Math.abs(b[1] - a[1]), 2));
          }
        }
      ]);
      return b;
    })(),
    Cl = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.startTime = a.options.startTime || 0;
        a.endTime = a.options.endTime;
        a.time = a.startTime;
        a.autoUpdate = !0;
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { height: 100, color: [1, 1, 1, 1], trailLength: 3, step: 0.1 };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            this.dataMgr = new Bl(this, this.gl);
            this.program = new X(this.gl, {
              vertexShader:
                "uniform mat4 u_matrix;uniform float currentTime;uniform float trailLength;attribute vec4 aPos;attribute float aDistance;attribute vec4 aColor;varying vec4 vColor;varying float vHeight;varying float vTime;varying float vDistance;void main(){vTime=1.0-((currentTime-aPos.w)/trailLength);vHeight=aPos.z;vColor=aColor;vDistance=aDistance;gl_Position=u_matrix*vec4(aPos.xyz,1.0);}",
              fragmentShader:
                "precision highp float;varying vec4 vColor;varying float vTime;varying float vDistance;varying float vHeight;uniform float currentTime;void main(){if(vTime>1.0||vTime<0.0){}float radius=2.5;float distance=vDistance+currentTime*20.0;float modDistance=mod(distance,9.0);float alpha=1.0;if(modDistance>radius*2.0){discard;}else{float x=abs(modDistance-radius);float y=abs(vHeight-radius);float dis=sqrt(pow(x,2.0)+pow(y,2.0));if(dis>radius){discard;}alpha=dis/radius;}gl_FragColor=vec4(vColor.rgb,1.0-alpha);}"
            });
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            this.gl && (this.dataMgr.onLayerChange(a, c), void 0 === a.endTime && (this.endTime = this.dataMgr.getMaxDataLength()));
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.matrix;
            if ((a = this.dataMgr.getData()) && !(0 >= a.vertex.length)) {
              var d = this.getOptions(),
                g = this.program;
              c.useProgram(g.program);
              this.setGLState({ blend: !0, blendEquation: c.FUNC_ADD, blendFunc: [c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA] });
              c.enableVertexAttribArray(g.attributes.aPos);
              c.enableVertexAttribArray(g.attributes.aDistance);
              c.enableVertexAttribArray(g.attributes.aColor);
              c.uniformMatrix4fv(g.uniforms.u_matrix, !1, b);
              c.uniform1f(g.uniforms.currentTime, this.time);
              c.uniform1f(g.uniforms.trailLength, d.trailLength);
              for (b = 0; b < a.vertex.length; b++)
                if (!(0 >= a.vertex[b].length)) {
                  var k = a.vertex[b],
                    l = new Float32Array(k[0]).BYTES_PER_ELEMENT;
                  k = l * k[0].length;
                  c.bindBuffer(c.ARRAY_BUFFER, a.vertexBuffer[b]);
                  c.vertexAttribPointer(g.attributes.aPos, 4, c.FLOAT, !1, k, 0);
                  c.vertexAttribPointer(g.attributes.aDistance, 1, c.FLOAT, !1, k, 4 * l);
                  c.vertexAttribPointer(g.attributes.aColor, 4, c.FLOAT, !1, k, 5 * l);
                  c.bindBuffer(c.ELEMENT_ARRAY_BUFFER, a.indexBuffer[b]);
                  c.drawElements(c.TRIANGLE_STRIP, a.index[b].length, c.UNSIGNED_SHORT, 0);
                  c.bindBuffer(c.ARRAY_BUFFER, null);
                  c.bindBuffer(c.ELEMENT_ARRAY_BUFFER, null);
                }
              this.time += d.step;
              this.time > this.endTime && (this.time = this.startTime);
            }
          }
        }
      ]);
      return d;
    })(ca),
    $d = function (b, d, a, c) {
      if (!(b instanceof d) || (void 0 !== c && c in b)) throw TypeError(a + ": incorrect invocation!");
      return b;
    },
    bc = U(function (b) {
      var d = {},
        a = {};
      b = b.exports = function (c, b, h, g, k) {
        k = k
          ? function () {
              return c;
            }
          : Ue(c);
        h = wa(h, g, b ? 2 : 1);
        g = 0;
        var f, n;
        if ("function" != typeof k) throw TypeError(c + " is not iterable!");
        if (void 0 === k || (fb.Array !== k && bh[ah] !== k))
          for (g = k.call(c); !(n = g.next()).done; ) {
            if (((k = $g(g, h, n.value, b)), k === d || k === a)) return k;
          }
        else for (f = Fd(c.length); f > g; g++) if (((k = b ? h(Ga((n = c[g]))[0], n[1]) : h(c[g])), k === d || k === a)) return k;
      };
      b.BREAK = d;
      b.RETURN = a;
    }),
    Dl = ua("species"),
    ci = function (b, d) {
      b = Ga(b).constructor;
      var a;
      return void 0 === b || void 0 == (a = Ga(b)[Dl]) ? d : Sb(a);
    },
    El = function (b, d, a) {
      var c = void 0 === a;
      switch (d.length) {
        case 0:
          return c ? b() : b.call(a);
        case 1:
          return c ? b(d[0]) : b.call(a, d[0]);
        case 2:
          return c ? b(d[0], d[1]) : b.call(a, d[0], d[1]);
        case 3:
          return c ? b(d[0], d[1], d[2]) : b.call(a, d[0], d[1], d[2]);
        case 4:
          return c ? b(d[0], d[1], d[2], d[3]) : b.call(a, d[0], d[1], d[2], d[3]);
      }
      return b.apply(a, d);
    },
    di = aa.process,
    tf = aa.setImmediate,
    ei = aa.clearImmediate,
    fi = aa.MessageChannel,
    uf = aa.Dispatch,
    vf = 0,
    ed = {},
    fd = function () {
      var b = +this;
      if (ed.hasOwnProperty(b)) {
        var d = ed[b];
        delete ed[b];
        d();
      }
    },
    gi = function (b) {
      fd.call(b.data);
    };
  if (!tf || !ei)
    if (
      ((tf = function (b) {
        for (var d = [], a = 1; arguments.length > a; ) d.push(arguments[a++]);
        ed[++vf] = function () {
          El("function" == typeof b ? b : Function(b), d);
        };
        gd(vf);
        return vf;
      }),
      (ei = function (b) {
        delete ed[b];
      }),
      "process" == Tb(di))
    )
      var gd = function (b) {
        di.nextTick(wa(fd, b, 1));
      };
    else if (uf && uf.now)
      gd = function (b) {
        uf.now(wa(fd, b, 1));
      };
    else if (fi) {
      var hi = new fi();
      var ii = hi.port2;
      hi.port1.onmessage = gi;
      gd = wa(ii.postMessage, ii, 1);
    } else
      aa.addEventListener && "function" == typeof postMessage && !aa.importScripts
        ? ((gd = function (b) {
            aa.postMessage(b + "", "*");
          }),
          aa.addEventListener("message", gi, !1))
        : (gd =
            "onreadystatechange" in (Id ? jc.createElement("script") : {})
              ? function (b) {
                  Ge.appendChild(Id ? jc.createElement("script") : {}).onreadystatechange = function () {
                    Ge.removeChild(this);
                    fd.call(b);
                  };
                }
              : function (b) {
                  setTimeout(wa(fd, b, 1), 0);
                });
  var wf = tf,
    ji = aa.MutationObserver || aa.WebKitMutationObserver,
    xf = aa.process,
    yf = aa.Promise,
    ki = "process" == Tb(xf),
    ae = {
      f: function (b) {
        return new Xi(b);
      }
    },
    be = function (b) {
      try {
        return { e: !1, v: b() };
      } catch (d) {
        return { e: !0, v: d };
      }
    },
    li = aa.navigator,
    Fl = (li && li.userAgent) || "",
    zf = function (b, d) {
      Ga(b);
      if (Ca(d) && d.constructor === b) return d;
      b = ae.f(b);
      var a = b.resolve;
      a(d);
      return b.promise;
    },
    Af = function (b, d, a) {
      for (var c in d) a && b[c] ? (b[c] = d[c]) : pb(b, c, d[c]);
      return b;
    },
    mi = ua("species"),
    ni = function (b) {
      b = "function" == typeof ea[b] ? ea[b] : aa[b];
      Sa &&
        b &&
        !b[mi] &&
        Pa.f(b, mi, {
          configurable: !0,
          get: function () {
            return this;
          }
        });
    },
    oi = (function () {
      var b,
        d,
        a = function () {
          var a;
          for (ki && (a = xf.domain) && a.exit(); b; ) {
            var f = b.fn;
            b = b.next;
            try {
              f();
            } catch (n) {
              throw (b ? c() : (d = void 0), n);
            }
          }
          d = void 0;
          a && a.enter();
        };
      if (ki)
        var c = function () {
          xf.nextTick(a);
        };
      else if (!ji || (aa.navigator && aa.navigator.standalone))
        if (yf && yf.resolve) {
          var f = yf.resolve(void 0);
          c = function () {
            f.then(a);
          };
        } else
          c = function () {
            wf.call(aa, a);
          };
      else {
        var h = !0,
          g = document.createTextNode("");
        new ji(a).observe(g, { characterData: !0 });
        c = function () {
          g.data = h = !h;
        };
      }
      return function (a) {
        a = { fn: a, next: void 0 };
        d && (d.next = a);
        b || ((b = a), c());
        d = a;
      };
    })(),
    pi = aa.TypeError,
    sc = aa.process,
    qi = sc && sc.versions,
    Gl = (qi && qi.v8) || "",
    kb = aa.Promise,
    hd = "process" == Td(sc),
    ce = function () {},
    ri,
    id = (ri = ae.f),
    de = !!(function () {
      try {
        var b = kb.resolve(1),
          d = ((b.constructor = {})[ua("species")] = function (a) {
            a(ce, ce);
          });
        return (hd || "function" == typeof PromiseRejectionEvent) && b.then(ce) instanceof d && 0 !== Gl.indexOf("6.6") && -1 === Fl.indexOf("Chrome/66");
      } catch (a) {}
    })(),
    si = function (b) {
      var d;
      return Ca(b) && "function" == typeof (d = b.then) ? d : !1;
    },
    Bf = function (b, d) {
      if (!b._n) {
        b._n = !0;
        var a = b._c;
        oi(function () {
          for (var c = b._v, f = 1 == b._s, h = 0; a.length > h; ) {
            var g = void 0,
              k = void 0,
              l = void 0,
              n = a[h++],
              m = f ? n.ok : n.fail,
              p = n.resolve,
              q = n.reject,
              t = n.domain;
            try {
              m
                ? (f || (2 == b._h && Hl(b), (b._h = 1)),
                  !0 === m ? (l = c) : (t && t.enter(), (l = m(c)), t && (t.exit(), (g = !0))),
                  l === n.promise ? q(pi("Promise-chain cycle")) : (k = si(l)) ? k.call(l, p, q) : p(l))
                : q(c);
            } catch (v) {
              t && !g && t.exit(), q(v);
            }
          }
          b._c = [];
          b._n = !1;
          d && !b._h && Il(b);
        });
      }
    },
    Il = function (b) {
      wf.call(aa, function () {
        var d = b._v,
          a = 1 !== b._h && 0 === (b._a || b._c).length,
          c,
          f;
        if (a) {
          var h = be(function () {
            hd
              ? sc.emit("unhandledRejection", d, b)
              : (c = aa.onunhandledrejection)
              ? c({ promise: b, reason: d })
              : (f = aa.console) && f.error && f.error("Unhandled promise rejection", d);
          });
          b._h = hd || (1 !== b._h && 0 === (b._a || b._c).length) ? 2 : 1;
        }
        b._a = void 0;
        if (a && h.e) throw h.v;
      });
    },
    Hl = function (b) {
      wf.call(aa, function () {
        var d;
        hd ? sc.emit("rejectionHandled", b) : (d = aa.onrejectionhandled) && d({ promise: b, reason: b._v });
      });
    },
    tc = function (b) {
      var d = this;
      d._d || ((d._d = !0), (d = d._w || d), (d._v = b), (d._s = 2), d._a || (d._a = d._c.slice()), Bf(d, !0));
    },
    Cf = function (b) {
      var d = this,
        a;
      if (!d._d) {
        d._d = !0;
        d = d._w || d;
        try {
          if (d === b) throw pi("Promise can't be resolved itself");
          (a = si(b))
            ? oi(function () {
                var c = { _w: d, _d: !1 };
                try {
                  a.call(b, wa(Cf, c, 1), wa(tc, c, 1));
                } catch (f) {
                  tc.call(c, f);
                }
              })
            : ((d._v = b), (d._s = 1), Bf(d, !1));
        } catch (c) {
          tc.call({ _w: d, _d: !1 }, c);
        }
      }
    };
  if (!de) {
    kb = function (b) {
      $d(this, kb, "Promise", "_h");
      Sb(b);
      Df.call(this);
      try {
        b(wa(Cf, this, 1), wa(tc, this, 1));
      } catch (d) {
        tc.call(this, d);
      }
    };
    var Df = function (b) {
      this._c = [];
      this._a = void 0;
      this._s = 0;
      this._d = !1;
      this._v = void 0;
      this._h = 0;
      this._n = !1;
    };
    Df.prototype = Af(kb.prototype, {
      then: function (b, d) {
        var a = id(ci(this, kb));
        a.ok = "function" == typeof b ? b : !0;
        a.fail = "function" == typeof d && d;
        a.domain = hd ? sc.domain : void 0;
        this._c.push(a);
        this._a && this._a.push(a);
        this._s && Bf(this, !1);
        return a.promise;
      },
      catch: function (b) {
        return this.then(void 0, b);
      }
    });
    var Jl = function () {
      var b = new Df();
      this.promise = b;
      this.resolve = wa(Cf, b, 1);
      this.reject = wa(tc, b, 1);
    };
    ae.f = id = function (b) {
      return b === kb || b === ti ? new Jl(b) : ri(b);
    };
  }
  H(H.G + H.W + H.F * !de, { Promise: kb });
  Ub(kb, "Promise");
  ni("Promise");
  var ti = ea.Promise;
  H(H.S + H.F * !de, "Promise", {
    reject: function (b) {
      var d = id(this),
        a = d.reject;
      a(b);
      return d.promise;
    }
  });
  H(H.S + 1 * H.F, "Promise", {
    resolve: function (b) {
      return zf(this === ti ? kb : this, b);
    }
  });
  H(
    H.S +
      H.F *
        !(
          de &&
          dh(function (b) {
            kb.all(b)["catch"](ce);
          })
        ),
    "Promise",
    {
      all: function (b) {
        var d = this,
          a = id(d),
          c = a.resolve,
          f = a.reject,
          h = be(function () {
            var a = [],
              h = 0,
              l = 1;
            bc(b, !1, function (b) {
              var g = h++,
                k = !1;
              a.push(void 0);
              l++;
              d.resolve(b).then(function (b) {
                k || ((k = !0), (a[g] = b), --l || c(a));
              }, f);
            });
            --l || c(a);
          });
        h.e && f(h.v);
        return a.promise;
      },
      race: function (b) {
        var d = this,
          a = id(d),
          c = a.reject,
          f = be(function () {
            bc(b, !1, function (b) {
              d.resolve(b).then(a.resolve, c);
            });
          });
        f.e && c(f.v);
        return a.promise;
      }
    }
  );
  H(H.P + H.R, "Promise", {
    finally: function (b) {
      var d = ci(this, ea.Promise || aa.Promise),
        a = "function" == typeof b;
      return this.then(
        a
          ? function (a) {
              return zf(d, b()).then(function () {
                return a;
              });
            }
          : b,
        a
          ? function (a) {
              return zf(d, b()).then(function () {
                throw a;
              });
            }
          : b
      );
    }
  });
  H(H.S, "Promise", {
    try: function (b) {
      var d = ae.f(this);
      b = be(b);
      (b.e ? d.reject : d.resolve)(b.v);
      return d.promise;
    }
  });
  var Kl = ea.Promise,
    Ll = U(function (b) {
      b.exports = { default: Kl, __esModule: !0 };
    }),
    Lb = Y(Ll),
    Mb = function (b, d) {
      if (!Ca(b) || b._t !== d) throw TypeError("Incompatible receiver, " + d + " required!");
      return b;
    },
    Ml = Pa.f,
    ui = Od.fastKey,
    jd = Sa ? "_s" : "size",
    ee = function (b, d) {
      var a = ui(d);
      if ("F" !== a) return b._i[a];
      for (b = b._f; b; b = b.n) if (b.k == d) return b;
    },
    Ef = {
      getConstructor: function (b, d, a, c) {
        var f = b(function (b, g) {
          $d(b, f, d, "_i");
          b._t = d;
          b._i = Db(null);
          b._f = void 0;
          b._l = void 0;
          b[jd] = 0;
          void 0 != g && bc(g, a, b[c], b);
        });
        Af(f.prototype, {
          clear: function () {
            for (var a = Mb(this, d), c = a._i, b = a._f; b; b = b.n) (b.r = !0), b.p && (b.p = b.p.n = void 0), delete c[b.i];
            a._f = a._l = void 0;
            a[jd] = 0;
          },
          delete: function (a) {
            var c = Mb(this, d);
            if ((a = ee(c, a))) {
              var b = a.n,
                f = a.p;
              delete c._i[a.i];
              a.r = !0;
              f && (f.n = b);
              b && (b.p = f);
              c._f == a && (c._f = b);
              c._l == a && (c._l = f);
              c[jd]--;
            }
            return !!a;
          },
          forEach: function (a) {
            Mb(this, d);
            for (var c = wa(a, 1 < arguments.length ? arguments[1] : void 0, 3), b; (b = b ? b.n : this._f); ) for (c(b.v, b.k, this); b && b.r; ) b = b.p;
          },
          has: function (a) {
            return !!ee(Mb(this, d), a);
          }
        });
        Sa &&
          Ml(f.prototype, "size", {
            get: function () {
              return Mb(this, d)[jd];
            }
          });
        return f;
      },
      def: function (b, d, a) {
        var c = ee(b, d),
          f;
        c ? (c.v = a) : ((b._l = c = { i: (f = ui(d, !0)), k: d, v: a, p: (d = b._l), n: void 0, r: !1 }), b._f || (b._f = c), d && (d.n = c), b[jd]++, "F" !== f && (b._i[f] = c));
        return b;
      },
      getEntry: ee,
      setStrong: function (b, d, a) {
        Ke(
          b,
          d,
          function (a, b) {
            this._t = Mb(a, d);
            this._k = b;
            this._l = void 0;
          },
          function () {
            for (var a = this._k, b = this._l; b && b.r; ) b = b.p;
            return this._t && (this._l = b = b ? b.n : this._t._f) ? ("keys" == a ? Eb(0, b.k) : "values" == a ? Eb(0, b.v) : Eb(0, [b.k, b.v])) : ((this._t = void 0), Eb(1));
          },
          a ? "entries" : "values",
          !a,
          !0
        );
        ni(d);
      }
    },
    Nl = ua("species"),
    Ol = function (b, d) {
      if (Pe(b)) {
        var a = b.constructor;
        "function" != typeof a || (a !== Array && !Pe(a.prototype)) || (a = void 0);
        Ca(a) && ((a = a[Nl]), null === a && (a = void 0));
      }
      return new (void 0 === a ? Array : a)(d);
    },
    Pl = Pa.f,
    Ql = (function (b, d) {
      var a = 1 == b,
        c = 2 == b,
        f = 3 == b,
        h = 4 == b,
        g = 6 == b,
        k = 5 == b || g,
        l = d || Ol;
      return function (d, m, p) {
        var n = Object(Ab(d)),
          t = Ce(n);
        m = wa(m, p, 3);
        p = Fd(t.length);
        var v = 0;
        d = a ? l(d, p) : c ? l(d, 0) : void 0;
        for (var r, u; p > v; v++)
          if (k || v in t)
            if (((r = t[v]), (u = m(r, v, n)), b))
              if (a) d[v] = u;
              else if (u)
                switch (b) {
                  case 3:
                    return !0;
                  case 5:
                    return r;
                  case 6:
                    return v;
                  case 2:
                    d.push(r);
                }
              else if (h) return !1;
        return g ? -1 : f || h ? h : d;
      };
    })(0);
  (function (b, d, a, c, f, h) {
    var g = aa[b],
      k = g,
      l = f ? "set" : "add",
      n = k && k.prototype,
      m = {};
    Sa &&
    "function" == typeof k &&
    (h ||
      (n.forEach &&
        !Bb(function () {
          new k().entries().next();
        })))
      ? ((k = d(function (a, c) {
          $d(a, k, b, "_c");
          a._c = new g();
          void 0 != c && bc(c, f, a[l], a);
        })),
        Ql("add clear delete forEach get has set keys values entries toJSON".split(" "), function (a) {
          var c = "add" == a || "set" == a;
          a in n &&
            (!h || "clear" != a) &&
            pb(k.prototype, a, function (b, d) {
              $d(this, k, a);
              if (!c && h && !Ca(b)) return "get" == a ? void 0 : !1;
              b = this._c[a](0 === b ? 0 : b, d);
              return c ? this : b;
            });
        }),
        h ||
          Pl(k.prototype, "size", {
            get: function () {
              return this._c.size;
            }
          }))
      : ((k = c.getConstructor(d, b, f, l)), Af(k.prototype, a), (Od.NEED = !0));
    Ub(k, b);
    m[b] = k;
    H(H.G + H.W + H.F, m);
    h || c.setStrong(k, b, f);
    return k;
  })(
    "Map",
    function (b) {
      return function () {
        return b(this, 0 < arguments.length ? arguments[0] : void 0);
      };
    },
    {
      get: function (b) {
        return (b = Ef.getEntry(Mb(this, "Map"), b)) && b.v;
      },
      set: function (b, d) {
        return Ef.def(Mb(this, "Map"), 0 === b ? 0 : b, d);
      }
    },
    Ef,
    !0
  );
  H(H.P + H.R, "Map", {
    toJSON: (function (b) {
      return function () {
        if (Td(this) != b) throw TypeError(b + "#toJSON isn't generic");
        var d = [];
        bc(this, !1, d.push, d, void 0);
        return d;
      };
    })("Map")
  });
  (function (b) {
    H(H.S, b, {
      of: function () {
        for (var b = arguments.length, a = Array(b); b--; ) a[b] = arguments[b];
        return new this(a);
      }
    });
  })("Map");
  (function (b) {
    H(H.S, b, {
      from: function (b, a, c) {
        var d;
        Sb(this);
        (d = void 0 !== a) && Sb(a);
        if (void 0 == b) return new this();
        var h = [];
        if (d) {
          var g = 0;
          var k = wa(a, c, 2);
          bc(b, !1, function (a) {
            h.push(k(a, g++));
          });
        } else bc(b, !1, h.push, h);
        return new this(h);
      }
    });
  })("Map");
  var Rl = ea.Map,
    Sl = U(function (b) {
      b.exports = { default: Rl, __esModule: !0 };
    }),
    Nb = Y(Sl),
    Tl = U(function (b, d) {
      d.__esModule = !0;
      var a = qb && qb.__esModule ? qb : { default: qb };
      d.default = function (c, b, d) {
        b in c ? (0, a.default)(c, b, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : (c[b] = d);
        return c;
      };
    }),
    uc = Y(Tl),
    kd,
    ld,
    Ul = ((kd = {}), uc(kd, 1, 1), uc(kd, 2, 1), uc(kd, 3, 1), kd),
    Vl = ((ld = {}), uc(ld, 1, 1), uc(ld, 2, 1), uc(ld, 3, 1), ld),
    cc = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.vertCount = 0;
        a.bufferMap = {};
        a.bufferData = [];
        a.autoUpdate = !0;
        c = a.canvas = document.createElement("canvas");
        a.ctx = c.getContext("2d");
        a.iconHash = new Nb();
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              color: [1, 1, 1, 0.8],
              speed: 1,
              size: 5,
              pointFade: !0,
              pointFadeBuffer: 1,
              minLineLength: 2,
              animationType: 2,
              shapeType: 2,
              depthTest: !1,
              delay: 0,
              unit: "px",
              padding: 0
            };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            this.texture = null;
            this.isUseTexture = !1;
            var c = this.getOptions();
            this.updateUniformsFromOptions(c);
            this.program = new X(this.gl, {
              vertexShader:
                "precision highp float;attribute vec3 aPos;attribute vec3 aNextPos;attribute vec4 aColor;attribute float aIndex;attribute float aNextIndex;attribute float aLength;attribute float aSpeed;attribute float aDelay;attribute vec3 aUV;uniform float uSize;uniform mat4 u_matrix;uniform float uOriginSpeed;uniform float uElapsedSteps;uniform int uAnimationType;uniform int uPointFade;uniform float uPointFadeBuffer;uniform float uZoomUnits;varying float vAddOpacity;varying vec3 vUV;varying vec4 vColor;void main(){vColor=aColor;if(uAnimationType==1){if(abs(aIndex-mod(uElapsedSteps,aLength))>.1){gl_Position=vec4(-2.,-2.,0,1.0);return;}gl_Position=u_matrix*vec4(aPos.xyz,1.0);vAddOpacity=1.;}else if(uAnimationType==2){float lineLength=aLength-1.;float cIndex=mod(uElapsedSteps,lineLength);float rest=cIndex-aIndex;if(rest<1.&&rest>=0.){if(uPointFade==1){if(cIndex<uPointFadeBuffer){vAddOpacity=cIndex/uPointFadeBuffer;}else if(cIndex>lineLength-uPointFadeBuffer){vAddOpacity=(lineLength-cIndex)/uPointFadeBuffer;}else{vAddOpacity=1.;}}else{vAddOpacity=1.;}gl_Position=u_matrix*vec4(aPos.x+(aNextPos.x-aPos.x)*rest,aPos.y+(aNextPos.y-aPos.y)*rest,aPos.z+(aNextPos.z-aPos.z)*rest,1.0);}else{gl_Position=vec4(-2.,-2.,0,1.0);return;}}else if(uAnimationType==3){float speedRatio=aSpeed/uOriginSpeed;float percent=mod(mod(uElapsedSteps*aSpeed,aLength)/aLength-aDelay,1.0);if(percent<=aNextIndex&&percent>=aIndex){if(uPointFade==1){float fadePercent=uPointFadeBuffer*1000./aLength;if(percent<fadePercent){vAddOpacity=percent/fadePercent;}else if(percent>1.-fadePercent){vAddOpacity=(1.-percent)/fadePercent;}else{vAddOpacity=1.;}}else{vAddOpacity=1.;}float rest=(percent-aIndex)/(aNextIndex-aIndex);gl_Position=u_matrix*vec4(aPos.x+(aNextPos.x-aPos.x)*rest,aPos.y+(aNextPos.y-aPos.y)*rest,aPos.z+(aNextPos.z-aPos.z)*rest,1.0);}else{gl_Position=vec4(-2.,-2.,0,1.0);return;}}vUV=aUV;gl_PointSize=uSize/uZoomUnits;}",
              fragmentShader:
                "precision highp float;uniform int ushapeType;uniform bool uUseTexture;uniform sampler2D uSampler;varying float vAddOpacity;varying vec4 vColor;varying vec3 vUV;void main(){if(ushapeType==2){float d=distance(gl_PointCoord,vec2(0.5,0.5));if(d>0.5){discard;}gl_FragColor=vec4(vColor.rgb,vColor.a*vAddOpacity);}else if(ushapeType==3){float d=distance(gl_PointCoord,vec2(0.5,0.5));if(d>0.5){discard;}gl_FragColor=vec4(vColor.rgb,vColor.a*smoothstep(1.0,0.0,d*2.)*vAddOpacity);}else{gl_FragColor=vec4(vColor.rgb,vColor.a*vAddOpacity);}if(uUseTexture){float ratio=vUV.z;vec2 uv=vUV.xy;gl_FragColor=texture2D(uSampler,vec2(gl_PointCoord.x*ratio+uv.x,1.0-(uv.y+gl_PointCoord.y*ratio)));}}"
            });
            this.buffer = a.createBuffer();
            a.bindBuffer(a.ARRAY_BUFFER, this.buffer);
          }
        },
        {
          key: "bindAttributeBufferData",
          value: function (a, c, b, d) {
            var f = a.createBuffer();
            a.bindBuffer(a.ARRAY_BUFFER, f);
            b = new Float32Array(b);
            a.bufferData(a.ARRAY_BUFFER, b, a.STATIC_DRAW);
            this.bufferMap[c] = { buffer: f, data: b, elementSize: d };
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
            this.gl && (Array.isArray(c) || (c = []), this.processCache(a, c, b));
          }
        },
        {
          key: "processCache",
          value: function (a, c, b) {
            var d = this;
            this.cachedData = [];
            for (var f = a.icon, k = a.speed, l = a.color, n = 0; n < c.length; n++) {
              var m = c[n].geometry.coordinates,
                p = this.getProperty("color", l, c[n]);
              p = this.normizedColor(p);
              var q = this.getProperty("icon", f, c[n]),
                t = this.getProperty("speed", k, c[n]),
                v = this.getProperty("delay", 0, c[n]);
              m && (this.cachedData.push({ coordinates: m, color: p, icon: q, speed: t, delay: v }), this.iconHash.get(q) || this.iconHash.set(q, q));
            }
            c = Ud(this.iconHash.entries())
              .filter(function (a) {
                return "string" === typeof a[1];
              })
              .map(function (a) {
                var c = da(a, 2)[0];
                return new Lb(function (a, b) {
                  d.url2canvas(c, function (b) {
                    d.iconHash.set(c, b);
                    a();
                  });
                });
              });
            Lb.all(c).then(function (c) {
              d.buildSprite(a);
              !1 !== b.autoRender && d.webglLayer && d.webglLayer.render();
            });
          }
        },
        {
          key: "buildSprite",
          value: function (a) {
            var c = a.padding,
              b = this.canvas,
              d = this.ctx,
              g = 0,
              k = [],
              l = new Nb();
            if (a.icon) {
              g = !0;
              var n = !1,
                m = void 0;
              try {
                for (var p = gc(this.iconHash), q; !(g = (q = p.next()).done); g = !0) {
                  var t = da(q.value, 2),
                    v = t[1];
                  if ("string" !== typeof v) {
                    var r = v.width,
                      u = r + c;
                    k.push({ w: u, h: u, width: r, key: t[0], icon: v });
                  }
                }
              } catch (w) {
                (n = !0), (m = w);
              } finally {
                try {
                  !g && p.return && p.return();
                } finally {
                  if (n) throw m;
                }
              }
              p = zb(k);
              for (q = 0; q < k.length; q++) (t = k[q]), l.get(t.key) || l.set(t.key, t);
              g = Math.max(lb(p.w), lb(p.h));
              b.width = g || 1;
              b.height = g || 1;
              d.save();
              for (b = 0; b < k.length; b++) (p = k[b]), d.drawImage(p.icon, p.x + c, p.y + c, p.width, p.width);
              d.restore();
            }
            this.loadTexture();
            this.buildVertex(a, l, g);
          }
        },
        {
          key: "buildVertex",
          value: function (a, c, b) {
            var d = this.gl;
            this.updateUniformsFromOptions(a);
            for (var f = [], k = [], l = [], n = [], m = [], p = [], q = [], t = [], v = [], r = a.minLineLength, u = 0; u < this.cachedData.length; u++) {
              var w = this.cachedData[u],
                y = w.coordinates,
                x = w.icon,
                D = w.speed,
                C = w.delay;
              w = w.color;
              var A = y.length,
                E = [];
              if (!(A < r)) {
                a.icon && (E = (E = c.get(x)) ? [E.x / b, E.y / b, E.w / b] : [0, 0, 0]);
                for (x = 0; x < A; ++x) {
                  var J = this.normizedPoint(y[x]);
                  f.push(J[0]);
                  f.push(J[1]);
                  f.push(J[2] || 0);
                  k.push.apply(k, W(w));
                  v.push.apply(v, W(E));
                  3 !== this.animationType && (l.push(x), m.push(A));
                }
                if (1 !== this.animationType) {
                  E = f.length - 3 * A + 3;
                  A = f.length;
                  for (y = E; y < A; ++y) p.push(f[y]);
                  f.splice(A - 3, 3);
                  v.splice(A - 3, 2);
                  k.splice(A - 3, 4);
                  if (2 === this.animationType) l.pop(), m.pop();
                  else if (3 === this.animationType) {
                    E -= 3;
                    A = f.length - 3;
                    y = 0;
                    w = [];
                    for (x = E; x <= A; x += 3)
                      (E = Math.sqrt(Math.pow(p[x] - f[x], 2) + Math.pow(p[x + 1] - f[x + 1], 2) + Math.pow(p[x + 2] - f[x + 2], 2))), (y += E), w.push(E);
                    l.push(0);
                    q.push(D);
                    C /= y / D;
                    t.push(C);
                    x = A = 0;
                    for (J = w.length - 1; x < J; ++x) (A += w[x]), (E = A / y), l.push(E), n.push(E), m.push(y), q.push(D), t.push(C);
                    n.push(1);
                    m.push(y);
                  }
                }
              }
            }
            this.bindAttributeBufferData(d, "aPos", f, 3);
            this.bindAttributeBufferData(d, "aIndex", l, 1);
            this.bindAttributeBufferData(d, "aLength", m, 1);
            this.bindAttributeBufferData(d, "aColor", k, 4);
            1 !== this.animationType &&
              (this.bindAttributeBufferData(d, "aNextPos", p, 3),
              3 === this.animationType &&
                (this.bindAttributeBufferData(d, "aNextIndex", n, 1), this.bindAttributeBufferData(d, "aSpeed", q, 1), this.bindAttributeBufferData(d, "aDelay", t, 1)));
            a.icon && this.bindAttributeBufferData(d, "aUV", v, 3);
            this.vertCount = f.length / 3;
          }
        },
        {
          key: "updateUniformsFromOptions",
          value: function (a) {
            this.startTime = new Date().getTime();
            Ul[a.animationType] || (a.animationType = 2);
            Vl[a.shapeType] || (a.shapeType = 2);
            if (isNaN(a.minLineLength) || 2 > a.minLineLength) a.minLineLength = 2;
            this.animationType = a.animationType;
          }
        },
        {
          key: "renderAttributeArr",
          value: function (a, c, b) {
            if (void 0 !== c.attributes[b]) {
              var d = this.bufferMap[b];
              d &&
                (a.bindBuffer(a.ARRAY_BUFFER, d.buffer),
                a.enableVertexAttribArray(c.attributes[b]),
                a.vertexAttribPointer(c.attributes[b], d.elementSize, a.FLOAT, !1, d.data.BYTES_PER_ELEMENT * d.elementSize, 0));
            }
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl;
            a = a.matrix;
            if (!(0 >= this.vertCount)) {
              var b = this.getOptions(),
                d = this.program;
              c.useProgram(d.program);
              this.renderAttributeArr(c, d, "aPos");
              this.renderAttributeArr(c, d, "aIndex");
              this.renderAttributeArr(c, d, "aLength");
              this.renderAttributeArr(c, d, "aColor");
              1 !== this.animationType &&
                (this.renderAttributeArr(c, d, "aNextPos"),
                3 === this.animationType && (this.renderAttributeArr(c, d, "aNextIndex"), this.renderAttributeArr(c, d, "aSpeed"), this.renderAttributeArr(c, d, "aDelay")));
              b.icon &&
                this.texture &&
                (this.renderAttributeArr(c, d, "aUV"), c.activeTexture(c.TEXTURE0), c.bindTexture(c.TEXTURE_2D, this.texture), c.uniform1i(d.uniforms.uSampler, 0));
              c.uniform1i(d.uniforms.uUseTexture, this.isUseTexture);
              var g = new Date().getTime() - this.startTime;
              g < this.options.delay
                ? (g = 0)
                : ((g -= this.options.delay),
                  (g =
                    1 === this.animationType
                      ? Math.round((g / 1e3) * this.options.speed * 20)
                      : 3 === this.animationType
                      ? (g / 1e3) * this.options.speed * 1e3
                      : (g / 1e3) * this.options.speed));
              var k = this.options.size;
              if (Array.isArray(k)) {
                var l = this.map.map.getMaxZoom(),
                  n = this.map.map.getMinZoom();
                k = k[0] + ((this.map.getZoom() - n) / (l - n)) * (k[1] - k[0]);
              }
              c.uniformMatrix4fv(d.uniforms.u_matrix, !1, a);
              c.uniform1f(d.uniforms.uSize, k);
              c.uniform1f(d.uniforms.uElapsedSteps, g);
              c.uniform1f(d.uniforms.uOriginSpeed, this.options.speed);
              c.uniform1i(d.uniforms.uAnimationType, this.animationType);
              c.uniform1i(d.uniforms.ushapeType, this.options.shapeType);
              c.uniform1i(d.uniforms.uPointFade, this.options.pointFade ? 1 : 0);
              c.uniform1f(d.uniforms.uPointFadeBuffer, this.options.pointFadeBuffer);
              c.uniform1f(d.uniforms.uZoomUnits, "m" === this.options.unit ? this.map.getZoomUnits() : 1);
              this.setGLState({
                blend: !0,
                blendEquation: c.FUNC_ADD,
                blendFunc: "lighter" === b.blend ? [c.SRC_ALPHA, c.ONE] : [c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA],
                depthTest: !!b.depthTest
              });
              c.drawArrays(c.POINTS, 0, this.vertCount);
            }
          }
        },
        {
          key: "url2canvas",
          value: function (a, c) {
            if ("object" === ("undefined" === typeof a ? "undefined" : Ha(a))) c(a);
            else {
              var b = new Image();
              b.crossOrigin = "anonymous";
              b.onload = function () {
                var a = document.createElement("canvas");
                a.width = 128;
                a.height = 128;
                a.getContext("2d").drawImage(b, 0, 0, 128, 128);
                c(a);
              };
              b.src = a;
            }
          }
        },
        {
          key: "loadTexture",
          value: function () {
            var a = this;
            this.canvas && this.getOptions().icon
              ? ta(this.gl, this.canvas, function (c) {
                  a.isUseTexture = !0;
                  a.texture = c;
                })
              : ((this.isUseTexture = !1), (this.texture = null));
          }
        }
      ]);
      return d;
    })(ca);
  cc.ANIMATION_TYPE_LEAP = 1;
  cc.ANIMATION_TYPE_SMOOTH = 2;
  cc.ANIMATION_TYPE_UNIFORM_SPEED = 3;
  cc.SHAPE_TYPE_SQUARE = 1;
  cc.SHAPE_TYPE_CIRCLE = 2;
  cc.SHAPE_TYPE_CIRCLE_GRADIENT = 3;
  var Wl = (function () {
      function b(d, a) {
        F(this, b);
        this.layer = d;
        this.gl = a;
        this.initData();
      }
      I(b, [
        {
          key: "initData",
          value: function () {
            this.outWall3d = { vertex: [], vertexBuffer: [], index: [], indexBuffer: [] };
          }
        },
        {
          key: "getData",
          value: function () {
            return this.outWall3d;
          }
        },
        {
          key: "onLayerChange",
          value: function (b, a) {
            this.initData();
            for (var c = b.color, d = b.height, h = b.gradient, g = b.enablePreciseMap, k = b.repeatMap, l = b.closePath, n = this.gl, m = 0; m < a.length; m++) {
              var p = a[m],
                q = p.color || c;
              "properties" in p && "color" in p.properties && (q = p.properties.color);
              h || "[object Function]" !== Object.prototype.toString.call(q) || (q = q(p));
              var t = this.layer.normizedColor(h ? h[0] : q);
              q = this.layer.normizedColor(h ? h[1] : q);
              var v = p.height || d;
              "properties" in p && "height" in p.properties && (v = p.properties.height);
              "[object Function]" === Object.prototype.toString.call(v) && (v = v(p));
              if ("MultiLineString" === p.geometry.type || "Polygon" === p.geometry.type)
                for (var r = 0; r < p.geometry.coordinates.length; r++) {
                  var u = p.geometry.coordinates[r];
                  l && !le(u) && u.push(u[0]);
                  for (var w = [], y = [], x = 0, D = 0; D < u.length; D++) {
                    var C = this.layer.normizedPoint(u[D]);
                    if (0 < D && (g || k)) {
                      var A = this.layer.normizedPoint(u[D - 1]);
                      x += Math.sqrt(Math.pow(C[0] - A[0], 2) + Math.pow(C[1] - A[1], 2));
                    }
                    w.push(C);
                    y.push(x);
                  }
                  this.processData(this.outWall3d, b, w, y, t, q, v);
                }
              else {
                p = p.geometry.coordinates;
                l && !le(p) && p.push(p[0]);
                r = [];
                u = [];
                for (y = w = 0; y < p.length; y++)
                  (x = this.layer.normizedPoint(p[y])),
                    0 < y && (g || k) && ((D = this.layer.normizedPoint(p[y - 1])), (w += Math.sqrt(Math.pow(x[0] - D[0], 2) + Math.pow(x[1] - D[1], 2)))),
                    r.push(x),
                    u.push(w);
                this.processData(this.outWall3d, b, r, u, t, q, v);
              }
            }
            for (b = 0; b < this.outWall3d.vertex.length; b++) {
              a = [];
              c = this.outWall3d.vertex[b].length;
              for (d = 0; d < c; d++) a.push.apply(a, W(this.outWall3d.vertex[b][d]));
              c = n.createBuffer();
              n.bindBuffer(n.ARRAY_BUFFER, c);
              n.bufferData(n.ARRAY_BUFFER, new Float32Array(a), n.STATIC_DRAW);
              this.outWall3d.vertexBuffer[b] = c;
              n.bindBuffer(n.ARRAY_BUFFER, null);
              c = n.createBuffer();
              n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, c);
              n.bufferData(n.ELEMENT_ARRAY_BUFFER, new Uint16Array(this.outWall3d.index[b]), n.STATIC_DRAW);
              this.outWall3d.indexBuffer[b] = c;
              n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, null);
            }
          }
        },
        {
          key: "processData",
          value: function (b, a, c, f, h, g, k) {
            var d = f[f.length - 1],
              n = b.vertex[b.vertex.length - 1],
              m = b.index[b.index.length - 1],
              p = c.length;
            if (!m || 65536 <= m.length + 2 * p + 2) (n = []), (m = []), b.vertex.push(n), b.index.push(m);
            (b = n.length) && m.push(b - 1, b);
            for (b = 0; b < p; b++) {
              var q = [],
                t = [],
                v = c[b];
              q.push(v[0], v[1], v[2] + k);
              q.push(h[0], h[1], h[2], h[3]);
              t.push(v[0], v[1], v[2]);
              t.push(g[0], g[1], g[2], g[3]);
              a.texture && ((v = f[b]), a.enablePreciseMap || a.repeatMap ? (q.push(v, 1, d), t.push(v, 0, d)) : (q.push(b, 1, p - 1), t.push(b, 0, p - 1)));
              v = n.length;
              n.push(q, t);
              m.push(v, v + 1);
            }
          }
        }
      ]);
      return b;
    })(),
    Xl = (function (b) {
      function d(a, c) {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).call(this, a, c));
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { texture: null, enablePreciseMap: !1, repeatMap: 0, height: 100, closePath: !1, color: [1, 1, 1, 1] };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            this.dataMgr = new Wl(this, this.gl);
            this.texture = null;
            this.isUseTexture = !1;
            this.vertexLength = 10;
            this.program = new X(this.gl, {
              vertexShader:
                "uniform mat4 u_matrix;uniform bool uUseTexture;attribute vec3 aPos;attribute vec4 aColor;attribute vec2 aTextureCoords;attribute float aTotalDistance;varying vec2 vTextureCoords;varying float vTotalDistance;varying vec4 vColor;void main(){if(aColor.w>=0.0&&aColor.w<=1.0){vColor=aColor;}else{vColor=vec4(aColor.xyz,1.0);}if(uUseTexture){vTextureCoords=aTextureCoords;vTotalDistance=aTotalDistance;}gl_Position=u_matrix*vec4(aPos,1.0);}",
              fragmentShader:
                "precision highp float;uniform bool uUseTexture;uniform float uDistance;uniform sampler2D uSampler;varying vec2 vTextureCoords;varying float vTotalDistance;varying vec4 vColor;void main(){if(uUseTexture){float uvx=vTextureCoords.x/vTotalDistance;if(uDistance>0.0){uvx=mod(vTextureCoords.x,uDistance)/uDistance;}gl_FragColor=vec4(1.0,1.0,1.0,1.0)*texture2D(uSampler,vec2(uvx,vTextureCoords.y));}else{gl_FragColor=vColor;}}"
            });
            this.loadTexture();
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this;
            this.gl &&
              (this.loadTextureTime && clearTimeout(this.loadTextureTime),
              (this.loadTextureTime = setTimeout(function () {
                b.loadTexture(function () {
                  b.dataMgr.onLayerChange(a, c);
                  b.webglLayer.render();
                });
              }, 0)));
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.matrix;
            if ((a = this.dataMgr.getData()) && !(0 >= a.vertex.length)) {
              var d = this.getOptions(),
                g = this.program;
              c.useProgram(g.program);
              if (d.texture) {
                if (!this.texture) return;
                c.activeTexture(c.TEXTURE0);
                c.bindTexture(c.TEXTURE_2D, this.texture);
                c.uniform1i(g.uniforms.uSampler, 0);
              }
              this.setGLState({
                blend: !0,
                blendEquation: c.FUNC_ADD,
                blendFunc: [c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA],
                depthMask: d.texture ? !0 : !1,
                depthFunc: d.texture ? c.LESS : c.LEQUAL
              });
              d.texture ? c.enableVertexAttribArray(g.attributes.aTextureCoords) : c.disableVertexAttribArray(g.attributes.aTextureCoords);
              c.enableVertexAttribArray(g.attributes.aPos);
              c.enableVertexAttribArray(g.attributes.aColor);
              c.uniformMatrix4fv(g.uniforms.u_matrix, !1, b);
              c.uniform1i(g.uniforms.uUseTexture, this.isUseTexture);
              c.uniform1f(g.uniforms.uDistance, d.repeatMap);
              for (b = 0; b < a.vertex.length; b++)
                if (!(0 >= a.vertex[b].length)) {
                  var k = a.vertex[b],
                    l = new Float32Array(k[0]).BYTES_PER_ELEMENT;
                  k = l * k[0].length;
                  c.bindBuffer(c.ARRAY_BUFFER, a.vertexBuffer[b]);
                  c.vertexAttribPointer(g.attributes.aPos, 3, c.FLOAT, !1, k, 0);
                  c.vertexAttribPointer(g.attributes.aColor, 4, c.FLOAT, !1, k, 3 * l);
                  d.texture &&
                    (c.vertexAttribPointer(g.attributes.aTextureCoords, 2, c.FLOAT, !1, k, 7 * l), c.vertexAttribPointer(g.attributes.aTotalDistance, 1, c.FLOAT, !1, k, 9 * l));
                  c.bindBuffer(c.ELEMENT_ARRAY_BUFFER, a.indexBuffer[b]);
                  c.drawElements(c.TRIANGLE_STRIP, a.index[b].length, c.UNSIGNED_SHORT, 0);
                  c.bindBuffer(c.ARRAY_BUFFER, null);
                  c.bindBuffer(c.ELEMENT_ARRAY_BUFFER, null);
                }
            }
          }
        },
        {
          key: "loadTexture",
          value: function (a) {
            var c = this,
              b = this.getOptions();
            b.texture
              ? ((this.isUseTexture = !0),
                ta(this.gl, b.texture, function (b, d) {
                  c.image = d;
                  c.texture = b;
                  a && a();
                  c.webglLayer.render();
                }))
              : ((this.isUseTexture = !1), (this.image = this.texture = null), a && a());
          }
        }
      ]);
      return d;
    })(ca),
    Yl = (function () {
      function b(d, a) {
        F(this, b);
        this.layer = d;
        this.gl = a;
        this.initData();
      }
      I(b, [
        {
          key: "initData",
          value: function () {
            this.outWall3d = { vertex: [], vertexBuffer: [], index: [], indexBuffer: [] };
            this.maxLength = 0;
          }
        },
        {
          key: "getData",
          value: function () {
            return this.outWall3d;
          }
        },
        {
          key: "getMaxDataLength",
          value: function () {
            return this.maxLength;
          }
        },
        {
          key: "onLayerChange",
          value: function (b, a) {
            this.initData();
            var c = b.color,
              d = b.height,
              h = b.gradient;
            b = this.gl;
            for (var g = 0; g < a.length; g++) {
              var k = a[g].geometry.coordinates,
                l = k.length;
              this.maxLength = l > this.maxLength ? l : this.maxLength;
              for (var n = [], m = 0; m < l; m++) {
                var p = this.layer.normizedPoint(k[m]);
                n.push(p);
              }
              l = a[g].color || c;
              "properties" in a[g] && "color" in a[g].properties && (l = a[g].properties.color);
              h || "[object Function]" !== Object.prototype.toString.call(l) || (l = l(a[g]));
              k = this.layer.normizedColor(h ? h[0] : l);
              l = this.layer.normizedColor(h ? h[1] : l);
              m = a[g].height || d;
              "properties" in a[g] && "height" in a[g].properties && (m = a[g].properties.height);
              "[object Function]" === Object.prototype.toString.call(m) && (m = m(a[g]));
              this.processData(this.outWall3d, n, k, l, m);
            }
            for (a = 0; a < this.outWall3d.vertex.length; a++) {
              c = [];
              d = this.outWall3d.vertex[a].length;
              for (h = 0; h < d; h++) c.push.apply(c, W(this.outWall3d.vertex[a][h]));
              d = b.createBuffer();
              b.bindBuffer(b.ARRAY_BUFFER, d);
              b.bufferData(b.ARRAY_BUFFER, new Float32Array(c), b.STATIC_DRAW);
              this.outWall3d.vertexBuffer[a] = d;
              b.bindBuffer(b.ARRAY_BUFFER, null);
              d = b.createBuffer();
              b.bindBuffer(b.ELEMENT_ARRAY_BUFFER, d);
              b.bufferData(b.ELEMENT_ARRAY_BUFFER, new Uint16Array(this.outWall3d.index[a]), b.STATIC_DRAW);
              this.outWall3d.indexBuffer[a] = d;
              b.bindBuffer(b.ELEMENT_ARRAY_BUFFER, null);
            }
          }
        },
        {
          key: "processData",
          value: function (b, a, c, f, h) {
            var d = b.vertex[b.vertex.length - 1],
              k = b.index[b.index.length - 1],
              l = a.length;
            if (!k || 65536 <= k.length + 2 * l + 2) (d = []), (k = []), b.vertex.push(d), b.index.push(k);
            (b = d.length) && k.push(b - 1, b);
            for (b = 0; b < l; b++) {
              var n = [],
                m = [],
                p = a[b];
              n.push(p[0], p[1]);
              n.push(p[2] ? Number(p[2]) + h : h);
              n.push(p[3] ? Number(p[3]) : b);
              n.push(c[0], c[1], c[2], c[3]);
              m.push(p[0], p[1]);
              m.push(p[2] ? Number(p[2]) : 0);
              m.push(p[3] ? Number(p[3]) : b);
              m.push(f[0], f[1], f[2], f[3]);
              p = d.length;
              d.push(n, m);
              k.push(p, p + 1);
            }
          }
        }
      ]);
      return b;
    })(),
    Zl = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.startTime = a.options.startTime || 0;
        a.endTime = a.options.endTime;
        a.time = a.startTime;
        a.autoUpdate = !0;
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { height: 100, color: [1, 1, 1, 1], trailLength: 3, step: 0.1 };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            this.dataMgr = new Yl(this, this.gl);
            this.program = new X(this.gl, {
              vertexShader:
                "uniform mat4 u_matrix;uniform float currentTime;uniform float trailLength;attribute vec4 aPos;attribute vec4 aColor;varying vec4 vColor;varying float vTime;void main(){vTime=1.0-((currentTime-aPos.w)/trailLength);vColor=aColor;gl_Position=u_matrix*vec4(aPos.xyz,1.0);}",
              fragmentShader:
                "precision highp float;varying vec4 vColor;varying float vTime;void main(){if(vTime>1.0||vTime<0.0){discard;}gl_FragColor=vec4(vColor.rgb,1.0*vTime);}"
            });
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            this.gl && (this.dataMgr.onLayerChange(a, c), void 0 === a.endTime && (this.endTime = this.dataMgr.getMaxDataLength()));
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.matrix;
            if ((a = this.dataMgr.getData()) && !(0 >= a.vertex.length)) {
              var d = this.getOptions(),
                g = this.program;
              c.useProgram(g.program);
              this.setGLState({ blend: !0, blendEquation: c.FUNC_ADD, blendFunc: [c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA] });
              c.enableVertexAttribArray(g.attributes.aPos);
              c.enableVertexAttribArray(g.attributes.aColor);
              c.uniformMatrix4fv(g.uniforms.u_matrix, !1, b);
              c.uniform1f(g.uniforms.currentTime, this.time);
              c.uniform1f(g.uniforms.trailLength, d.trailLength);
              for (b = 0; b < a.vertex.length; b++)
                if (!(0 >= a.vertex[b].length)) {
                  var k = a.vertex[b],
                    l = new Float32Array(k[0]).BYTES_PER_ELEMENT;
                  k = l * k[0].length;
                  c.bindBuffer(c.ARRAY_BUFFER, a.vertexBuffer[b]);
                  c.vertexAttribPointer(g.attributes.aPos, 4, c.FLOAT, !1, k, 0);
                  c.vertexAttribPointer(g.attributes.aColor, 4, c.FLOAT, !1, k, 4 * l);
                  c.bindBuffer(c.ELEMENT_ARRAY_BUFFER, a.indexBuffer[b]);
                  c.drawElements(c.TRIANGLE_STRIP, a.index[b].length, c.UNSIGNED_SHORT, 0);
                  c.bindBuffer(c.ARRAY_BUFFER, null);
                  c.bindBuffer(c.ELEMENT_ARRAY_BUFFER, null);
                }
              this.time += d.step;
              this.time > this.endTime && (this.time = this.startTime);
            }
          }
        }
      ]);
      return d;
    })(ca),
    $l = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.simpleLineLayer = new ai(a.getHeatOptions());
        a.children = [a.simpleLineLayer];
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { blend: "normal", gradient: { 0: "rgb(50, 50, 256)", 0.1: "rgb(50, 250, 56)", 0.5: "rgb(250, 250, 56)", 1: "rgb(250, 50, 56)" } };
          }
        },
        {
          key: "onDataChanged",
          value: function (a) {
            this.simpleLineLayer.setData(a);
          }
        },
        {
          key: "onOptionsChanged",
          value: function (a) {
            this.simpleLineLayer.setOptions(this.getHeatOptions());
          }
        },
        {
          key: "getHeatOptions",
          value: function () {
            var a = this.getOptions(),
              c = a.max,
              b = a.min;
            void 0 === c && ((b = this.getDataRange()), (c = b.max), (b = b.min));
            var d = new Ba({ max: c, min: b, gradient: a.gradient });
            a.color = function (a) {
              var c = ~~a.count || 1;
              "properties" in a && "count" in a.properties && (c = ~~a.properties.count);
              a = d.getImageData(c);
              return [a[0] / 255, a[1] / 255, a[2] / 255, a[3] / 255];
            };
            return a;
          }
        },
        {
          key: "getDataRange",
          value: function () {
            var a = this.getData(),
              c = 0,
              b = 0;
            a[0] && ((c = ~~a[0].count || 1), (b = ~~a[0].count || 1));
            "properties" in a[0] && "count" in a[0].properties && ((c = ~~a[0].properties.count), (b = ~~a[0].properties.count));
            for (var d = a.length, g = 0; g < d; g++) {
              var k = ~~a[g].count || 1;
              "properties" in a[g] && "count" in a[g].properties && (k = ~~a[g].properties.count);
              c = Math.max(k, c);
              b = Math.min(k, b);
            }
            return { max: c / 2, min: b };
          }
        }
      ]);
      return d;
    })(jb),
    Ff = U(function (b, d) {
      (function (a, c) {
        b.exports = c();
      })(ug, function () {
        function a(b, d, f, g, h, k) {
          if (!(h - g <= f)) {
            var l = (g + h) >> 1;
            c(b, d, l, g, h, k % 2);
            a(b, d, f, g, l - 1, k + 1);
            a(b, d, f, l + 1, h, k + 1);
          }
        }
        function c(a, d, f, g, h, k) {
          for (; h > g; ) {
            if (600 < h - g) {
              var l = h - g + 1,
                m = f - g + 1,
                p = Math.log(l),
                n = 0.5 * Math.exp((2 * p) / 3);
              p = 0.5 * Math.sqrt((p * n * (l - n)) / l) * (0 > m - l / 2 ? -1 : 1);
              c(a, d, f, Math.max(g, Math.floor(f - (m * n) / l + p)), Math.min(h, Math.floor(f + ((l - m) * n) / l + p)), k);
            }
            l = d[2 * f + k];
            m = g;
            n = h;
            b(a, d, g, f);
            for (d[2 * h + k] > l && b(a, d, g, h); m < n; ) {
              b(a, d, m, n);
              m++;
              for (n--; d[2 * m + k] < l; ) m++;
              for (; d[2 * n + k] > l; ) n--;
            }
            d[2 * g + k] === l ? b(a, d, g, n) : (n++, b(a, d, n, h));
            n <= f && (g = n + 1);
            f <= n && (h = n - 1);
          }
        }
        function b(a, c, b, f) {
          d(a, b, f);
          d(c, 2 * b, 2 * f);
          d(c, 2 * b + 1, 2 * f + 1);
        }
        function d(a, c, b) {
          var d = a[c];
          a[c] = a[b];
          a[b] = d;
        }
        function g(a, c) {
          a = a.geometry.coordinates;
          return { x: a[0] / 360 + 0.5, y: n(a[1]), zoom: Infinity, index: c, parentId: -1 };
        }
        function k(a) {
          var c = a.id,
            b = l(a);
          return {
            type: "Feature",
            id: c,
            properties: b,
            geometry: { type: "Point", coordinates: [360 * (a.x - 0.5), (360 * Math.atan(Math.exp(((180 - 360 * a.y) * Math.PI) / 180))) / Math.PI - 90] }
          };
        }
        function l(a) {
          var c = a.numPoints,
            b = 1e4 <= c ? Math.round(c / 1e3) + "k" : 1e3 <= c ? Math.round(c / 100) / 10 + "k" : c;
          return m(m({}, a.properties), { cluster: !0, cluster_id: a.id, point_count: c, point_count_abbreviated: b });
        }
        function n(a) {
          a = Math.sin((a * Math.PI) / 180);
          a = 0.5 - (0.25 * Math.log((1 + a) / (1 - a))) / Math.PI;
          return 0 > a ? 0 : 1 < a ? 1 : a;
        }
        function m(a, c) {
          for (var b in c) a[b] = c[b];
          return a;
        }
        function p(a) {
          return a.x;
        }
        function q(a) {
          return a.y;
        }
        var t = function (a) {
            return a[0];
          },
          v = function (a) {
            return a[1];
          },
          r = function (c, b, d, f, g) {
            void 0 === b && (b = t);
            void 0 === d && (d = v);
            void 0 === f && (f = 64);
            void 0 === g && (g = Float64Array);
            this.nodeSize = f;
            this.points = c;
            var h = (this.ids = new (65536 > c.length ? Uint16Array : Uint32Array)(c.length));
            g = this.coords = new g(2 * c.length);
            for (var k = 0; k < c.length; k++) (h[k] = k), (g[2 * k] = b(c[k])), (g[2 * k + 1] = d(c[k]));
            a(h, g, f, 0, h.length - 1, 0);
          };
        r.prototype.range = function (a, c, b, d) {
          for (var f = this.ids, g = this.coords, h = this.nodeSize, k = [0, f.length - 1, 0], l = [], m, p; k.length; ) {
            var n = k.pop(),
              q = k.pop(),
              r = k.pop();
            if (q - r <= h) for (n = r; n <= q; n++) (m = g[2 * n]), (p = g[2 * n + 1]), m >= a && m <= b && p >= c && p <= d && l.push(f[n]);
            else {
              var t = Math.floor((r + q) / 2);
              m = g[2 * t];
              p = g[2 * t + 1];
              m >= a && m <= b && p >= c && p <= d && l.push(f[t]);
              var u = (n + 1) % 2;
              if (0 === n ? a <= m : c <= p) k.push(r), k.push(t - 1), k.push(u);
              if (0 === n ? b >= m : d >= p) k.push(t + 1), k.push(q), k.push(u);
            }
          }
          return l;
        };
        r.prototype.within = function (a, c, b) {
          for (var d = this.ids, f = this.coords, g = this.nodeSize, h = [0, d.length - 1, 0], k = [], l = b * b; h.length; ) {
            var m = h.pop(),
              p = h.pop(),
              n = h.pop();
            if (p - n <= g)
              for (m = n; m <= p; m++) {
                n = f[2 * m] - a;
                var q = f[2 * m + 1] - c;
                n * n + q * q <= l && k.push(d[m]);
              }
            else {
              q = Math.floor((n + p) / 2);
              var r = f[2 * q],
                t = f[2 * q + 1],
                u = r - a,
                v = t - c;
              u * u + v * v <= l && k.push(d[q]);
              u = (m + 1) % 2;
              if (0 === m ? a - b <= r : c - b <= t) h.push(n), h.push(q - 1), h.push(u);
              if (0 === m ? a + b >= r : c + b >= t) h.push(q + 1), h.push(p), h.push(u);
            }
          }
          return k;
        };
        var u = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: function (a) {
              return a;
            }
          },
          w = function (a) {
            this.options = m(Xj(u), a);
            this.trees = Array(this.options.maxZoom + 1);
          };
        w.prototype.load = function (a) {
          var c = this.options,
            b = c.minZoom,
            d = c.maxZoom;
          c = c.nodeSize;
          this.points = a;
          for (var f = [], h = 0; h < a.length; h++) a[h].geometry && f.push(g(a[h], h));
          this.trees[d + 1] = new r(f, p, q, c, Float32Array);
          for (a = d; a >= b; a--) (f = this._cluster(f, a)), (this.trees[a] = new r(f, p, q, c, Float32Array));
          return this;
        };
        w.prototype.getClusters = function (a, c) {
          var b = ((((a[0] + 180) % 360) + 360) % 360) - 180,
            d = Math.max(-90, Math.min(90, a[1])),
            f = 180 === a[2] ? 180 : ((((a[2] + 180) % 360) + 360) % 360) - 180,
            h = Math.max(-90, Math.min(90, a[3]));
          if (360 <= a[2] - a[0]) (b = -180), (f = 180);
          else if (b > f) return (b = this.getClusters([b, d, 180, h], c)), (d = this.getClusters([-180, d, f, h], c)), b.concat(d);
          c = this.trees[this._limitZoom(c)];
          a = [];
          var g = 0;
          for (d = c.range(b / 360 + 0.5, n(h), f / 360 + 0.5, n(d)); g < d.length; g += 1) (f = c.points[d[g]]), a.push(f.numPoints ? k(f) : this.points[f.index]);
          return a;
        };
        w.prototype.getChildren = function (a) {
          var c = this._getOriginId(a),
            b = this._getOriginZoom(a),
            d = this.trees[b];
          if (!d) throw Error("No cluster with the specified id.");
          var f = d.points[c];
          if (!f) throw Error("No cluster with the specified id.");
          c = [];
          var h = 0;
          for (b = d.within(f.x, f.y, this.options.radius / (this.options.extent * Math.pow(2, b - 1))); h < b.length; h += 1)
            (f = d.points[b[h]]), f.parentId === a && c.push(f.numPoints ? k(f) : this.points[f.index]);
          if (0 === c.length) throw Error("No cluster with the specified id.");
          return c;
        };
        w.prototype.getLeaves = function (a, c, b) {
          var d = [];
          this._appendLeaves(d, a, c || 10, b || 0, 0);
          return d;
        };
        w.prototype.getTile = function (a, c, b) {
          var d = this.trees[this._limitZoom(a)];
          a = Math.pow(2, a);
          var f = this.options;
          f = f.radius / f.extent;
          var h = (b - f) / a,
            g = (b + 1 + f) / a,
            k = { features: [] };
          this._addTileFeatures(d.range((c - f) / a, h, (c + 1 + f) / a, g), d.points, c, b, a, k);
          0 === c && this._addTileFeatures(d.range(1 - f / a, h, 1, g), d.points, a, b, a, k);
          c === a - 1 && this._addTileFeatures(d.range(0, h, f / a, g), d.points, -1, b, a, k);
          return k.features.length ? k : null;
        };
        w.prototype.getClusterExpansionZoom = function (a) {
          for (var c = this._getOriginZoom(a) - 1; c <= this.options.maxZoom; ) {
            a = this.getChildren(a);
            c++;
            if (1 !== a.length) break;
            a = a[0].properties.cluster_id;
          }
          return c;
        };
        w.prototype._appendLeaves = function (a, c, b, d, f) {
          var h = 0;
          for (c = this.getChildren(c); h < c.length; h += 1) {
            var g = c[h],
              k = g.properties;
            k && k.cluster ? (f = f + k.point_count <= d ? f + k.point_count : this._appendLeaves(a, k.cluster_id, b, d, f)) : f < d ? f++ : a.push(g);
            if (a.length === b) break;
          }
          return f;
        };
        w.prototype._addTileFeatures = function (a, c, b, d, f, h) {
          for (var g = 0; g < a.length; g += 1) {
            var k = c[a[g]],
              m = k.numPoints,
              p = {
                type: 1,
                geometry: [[Math.round(this.options.extent * (k.x * f - b)), Math.round(this.options.extent * (k.y * f - d))]],
                tags: m ? l(k) : this.points[k.index].properties
              },
              n = void 0;
            m ? (n = k.id) : this.options.generateId ? (n = k.index) : this.points[k.index].id && (n = this.points[k.index].id);
            void 0 !== n && (p.id = n);
            h.features.push(p);
          }
        };
        w.prototype._limitZoom = function (a) {
          return Math.max(this.options.minZoom, Math.min(+a, this.options.maxZoom + 1));
        };
        w.prototype._cluster = function (a, c) {
          var b = [],
            d = this.options,
            f = d.reduce,
            h = d.minPoints;
          d = d.radius / (d.extent * Math.pow(2, c));
          for (var g = 0; g < a.length; g++) {
            var k = a[g];
            if (!(k.zoom <= c)) {
              k.zoom = c;
              for (var l = this.trees[c + 1], m = l.within(k.x, k.y, d), p = k.numPoints || 1, n = p, q = 0, r = m; q < r.length; q += 1) {
                var t = l.points[r[q]];
                t.zoom > c && (n += t.numPoints || 1);
              }
              if (n >= h) {
                q = k.x * p;
                r = k.y * p;
                p = f && 1 < p ? this._map(k, !0) : null;
                t = (g << 5) + (c + 1) + this.points.length;
                for (var u = 0; u < m.length; u += 1) {
                  var v = l.points[m[u]];
                  if (!(v.zoom <= c)) {
                    v.zoom = c;
                    var w = v.numPoints || 1;
                    q += v.x * w;
                    r += v.y * w;
                    v.parentId = t;
                    f && (p || (p = this._map(k, !0)), f(p, this._map(v)));
                  }
                }
                k.parentId = t;
                b.push({ x: q / n, y: r / n, zoom: Infinity, id: t, parentId: -1, numPoints: n, properties: p });
              } else if ((b.push(k), 1 < n)) for (k = 0, n = m; k < n.length; k += 1) (m = l.points[n[k]]), m.zoom <= c || ((m.zoom = c), b.push(m));
            }
          }
          return b;
        };
        w.prototype._getOriginId = function (a) {
          return (a - this.points.length) >> 5;
        };
        w.prototype._getOriginZoom = function (a) {
          return (a - this.points.length) % 32;
        };
        w.prototype._map = function (a, c) {
          if (a.numPoints) return c ? m({}, a.properties) : a.properties;
          a = this.points[a.index].properties;
          var b = this.options.map(a);
          return c && b === a ? m({}, b) : b;
        };
        return w;
      });
    }),
    am = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.shapeLayer = new Zd(a.options);
        a.textLayer = new rc(a.options.textOptions);
        a.children = [a.shapeLayer, a.textLayer];
        a.max = [];
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              size: 50,
              height: 0,
              maxZoom: 19,
              minZoom: 5,
              gradient: { 0: "rgb(50, 50, 256)", 0.1: "rgb(50, 250, 56)", 0.5: "rgb(250, 250, 56)", 1: "rgb(250, 50, 56)" },
              enableCluster: !1,
              showText: !0,
              textOptions: { fontSize: 13, color: "white" }
            };
          }
        },
        {
          key: "onOptionsChanged",
          value: function (a) {
            this.textLayer.setOptions(a.textOptions);
          }
        },
        {
          key: "setOptions",
          value: function () {
            var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
              c = this.options.textOptions;
            a.textOptions && S(c, a.textOptions);
            var b = a.minZoom,
              d = a.maxZoom,
              g = a.size;
            b = (d && d !== this.options.maxZoom) || (b && b !== this.options.minZoom) || (g && g !== this.options.size);
            S(this.options, a, { textOptions: c });
            if (b) this.onChanged(this.options, this.data);
            else this.refreshLayer();
            this.onOptionsChanged(this.getOptions());
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            if (c && c.length) {
              this.zoom = Math.floor(this.map.getZoom());
              var b = a.maxZoom,
                d = a.minZoom,
                g = a.enableCluster;
              a = a.size;
              this.zoom > b ? (this.zoom = b) : this.zoom < d && (this.zoom = d);
              g && ((this.supercluster = new Ff({ maxZoom: b, minZoom: d, radius: a / 2 })), this.supercluster.load(c));
              this.refreshLayer();
            }
          }
        },
        {
          key: "refreshLayer",
          value: function () {
            var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : this.options,
              c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : this.data,
              b = this.map,
              d = this.zoom;
            a.enableCluster && this.supercluster && (c = this.getClusterData(a));
            if (c && c.length) {
              var g = a.gradient,
                k = a.showText,
                l = a.textOptions,
                n = a.height,
                m = a.size;
              m *= Math.pow(2, 18 - d);
              c = Zi(c, m, function (a) {
                var c = da(a, 2),
                  d = c[0];
                c = c[1];
                -180 <= d && 180 >= d && -90 <= c && 90 >= c && ((c = b.lnglatToMercator(d, c)), (d = c[0]), (c = c[1]));
                a[0] = d;
                a[1] = c;
                return a;
              });
              this.max[d] = Math.max(this.max[d] || 0, c.max);
              var p = new Ba({ max: this.max[d], min: 0, maxSize: n * Math.pow(2, 18 - d), minSize: 0, gradient: g });
              g = [];
              if (k) {
                var q = l && l.format;
                q = "function" === typeof q ? q : null;
                g = c.map(function (a) {
                  return { geometry: { coordinates: [a.center.x, a.center.y, p.getSize(a.count) + (l.fontSize / 2) * Math.pow(2, 18 - d)] }, text: q ? q(a.count) : a.count };
                });
              }
              this.textLayer.setData(g);
              k = c.map(function (a) {
                for (var b = a.center, d = c.r, f = [], g = 0; 6 > g; g++) f.push(Yi({ x: b.x, y: b.y }, d, g));
                return { geometry: { type: "Polygon", coordinates: [f] }, properties: { height: p.getSize(a.count), color: p.getColor(a.count) } };
              });
              this.shapeLayer.setData(k);
              a.enablePicked && a.autoSelect && this.pick(-1, -1);
            }
          }
        },
        {
          key: "getClusterData",
          value: function () {
            var a = this.map,
              c = a.getBounds(),
              b = c.ne;
            c = c.sw;
            this.ne = b;
            this.sw = c;
            var d = b,
              g = d.lng;
            d = d.lat;
            var k = [];
            -180 <= g && 180 >= g && -90 <= d && 90 >= d
              ? (k = [c.lng, c.lat, b.lng, b.lat])
              : ((b = a.mercatorToLnglat(this.ne.lng, this.ne.lat)), (c = a.mercatorToLnglat(this.sw.lng, this.sw.lat)), (k = c.concat(b)));
            return this.supercluster.getClusters(k, this.zoom).map(function (a) {
              var c = 0;
              a.properties && a.properties.point_count && (c = a.properties.point_count);
              return { geometry: a.geometry, count: c };
            });
          }
        },
        {
          key: "pick",
          value: function (a, c) {
            return this.shapeLayer.pick(a, c);
          }
        },
        {
          key: "shouldUpdate",
          value: function () {
            if (!this.data) return !1;
            var a = this.map,
              c = Math.floor(a.getZoom()),
              b = this.options,
              d = b.maxZoom;
            b = b.minZoom;
            c > d ? (c = d) : c < b && (c = b);
            if (this.zoom !== c) return (this.zoom = c), !0;
            if (!this.options.enableCluster) return !1;
            c = a.getBounds();
            a = c.ne;
            c = c.sw;
            if (!(a && c && this.ne && this.sw)) return !1;
            if (this.ne.lng !== a.lng || this.ne.lat !== a.lat || this.sw.lng !== c.lng || this.sw.lat !== c.lat) return !0;
          }
        },
        {
          key: "render",
          value: function (a) {
            this.shouldUpdate() ? this.refreshLayer() : ib(d.prototype.__proto__ || N(d.prototype), "render", this).call(this, a);
          }
        }
      ]);
      return d;
    })(jb),
    md = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.name = "PointLayer";
        a.bufferData = [];
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              color: [0.1, 0.1, 0.9, 1],
              blend: "default",
              shape: "circle",
              size: 5,
              unit: "px",
              borderWidth: 0,
              borderColor: [1, 1, 1, 0.9],
              polygonOffset: [0, 0],
              depthTest: !0
            };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions(),
              b = [];
            c.enablePicked && b.push("PICK");
            c.shape && "circle" === c.shape && b.push("SHAPE_CIRCLE");
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "attribute vec3 aPos;attribute vec4 aColor;attribute float aSize;attribute float aBorderWidth;attribute vec4 aBorderColor;uniform mat4 uMatrix;uniform vec4 uSelectedColor;uniform bool uUnitPx;uniform float zoomUnits;uniform float devicePixelRatio;varying vec4 vColor;varying float vSize;varying float vBorderWidth;varying vec4 vBorderColor;void main(void){if(aColor.w>=0.0&&aColor.w<=1.0){vColor=aColor;}else{vColor=vec4(aColor.xyz,1.0);}float size=aSize*devicePixelRatio;float borderWidth=aBorderWidth*devicePixelRatio;gl_Position=uMatrix*vec4(aPos.xyz,1.0);gl_PointSize=uUnitPx ? size : size/zoomUnits;vSize=size;vBorderWidth=borderWidth;vBorderColor=aBorderColor;\n#if defined(PICK)\nif(mapvIsPicked()){vColor=uSelectedColor;}\n#endif\n}",
                fragmentShader:
                  "varying vec4 vColor;varying float vSize;varying float vBorderWidth;varying vec4 vBorderColor;void main(void){vec4 color=vColor;\n#if defined(SHAPE_CIRCLE)\nfloat d=distance(gl_PointCoord,vec2(0.5,0.5));float ratio=1.0-vBorderWidth/vSize*2.0;if(d>0.5){discard;}if(d>ratio*0.5){color=vBorderColor;}float blur=1.0;blur=1.0-smoothstep(0.49,0.5,d);color.a*=blur;\n#else\nfloat ratio=vBorderWidth/vSize;if(gl_PointCoord.x<ratio||gl_PointCoord.x>1.0-ratio||gl_PointCoord.y<ratio||gl_PointCoord.y>1.0-ratio){color=vBorderColor;}\n#endif\ngl_FragColor=color;}",
                defines: b
              },
              this
            );
            this.buffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            c = [
              { stride: 52, name: "aPos", buffer: this.buffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: 52, name: "aColor", buffer: this.buffer, size: 4, type: "FLOAT", offset: 12 },
              { stride: 52, name: "aSize", buffer: this.buffer, size: 1, type: "FLOAT", offset: 28 },
              { stride: 52, name: "aBorderWidth", buffer: this.buffer, size: 1, type: "FLOAT", offset: 32 },
              { stride: 52, name: "aBorderColor", buffer: this.buffer, size: 4, type: "FLOAT", offset: 36 }
            ];
            c = c.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: c });
          }
        },
        {
          key: "onDestroy",
          value: function () {
            this.bufferData = [];
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            if (this.gl) {
              for (var b = [], d = a.color, g = a.size, k = a.borderWidth, l = a.borderColor, n = 0; n < c.length; n++) {
                var m = this.normizedPoint(c[n].geometry.coordinates),
                  p = this.getProperty("color", d, c[n]);
                p = this.normizedColor(p);
                var q = this.getProperty("size", g, c[n]);
                q = Number(q);
                var t = this.getProperty("borderWidth", k, c[n]);
                t = Number(t);
                var v = this.getProperty("borderColor", l, c[n]);
                v = this.normizedColor(v);
                m = this.addMultipleCoords(m);
                for (var r = 0; r < m.length; r++) {
                  var u = m[r];
                  b.push(u[0], u[1], Number(u[2] || 0));
                  b.push(p[0], p[1], p[2], p[3]);
                  b.push(q);
                  b.push(t, v[0], v[1], v[2], v[3]);
                }
              }
              this.bufferData = b;
              this.buffer.updateData(new Float32Array(b));
              a.enablePicked && this.parsePickData(c);
            }
          }
        },
        {
          key: "parsePickData",
          value: function (a) {
            var c = this.getOptions(),
              b = [];
            if (c.enablePicked)
              for (var d = 0; d < a.length; d++) {
                var g = this.indexToRgb(d);
                b.push(g[0] / 255, g[1] / 255, g[2] / 255);
                c.repeat && (b.push(g[0] / 255, g[1] / 255, g[2] / 255), b.push(g[0] / 255, g[1] / 255, g[2] / 255));
              }
            c.enablePicked && this.pickBuffer.updateData(new Float32Array(b));
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.matrix,
              d = a.isPickRender;
            if (!(0 >= this.bufferData.length)) {
              var g = this.getOptions(),
                k = this.program;
              k.use(c);
              a = this.getCommonUniforms(a);
              a = S(a, { uMatrix: b, uUnitPx: "px" === g.unit, zoomUnits: this.map.getZoomUnits(), devicePixelRatio: window.devicePixelRatio });
              k.setUniforms(a);
              this.setGLState({ blend: d ? !1 : !0, blendFunc: Va(c, g.blend), blendEquation: c.FUNC_ADD, polygonOffset: g.polygonOffset, depthTest: g.depthTest });
              this.vertexArray.bind();
              c.drawArrays(c.POINTS, 0, this.bufferData.length / 13);
            }
          }
        }
      ]);
      return d;
    })(ca),
    bm = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.name = "GroundRippleLayer";
        a.bufferDataArr = [];
        a.indexDataArr = [];
        a.vertexBuffer = [];
        a.indexBuffer = [];
        a.position = [];
        a.opacity = 1;
        a.currentScale = 1;
        a.autoUpdate = !0;
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { color: [0.1, 0.1, 0.9, 1], size: 5, segs: 32, scale: 2, unit: "m", step: 0.1 };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            this.program = new X(this.gl, {
              vertexShader:
                "uniform mat4 u_projectionMatrix;uniform mat4 u_modelViewMatrix;uniform mat4 u_modelMatrix;uniform float u_opacity;attribute vec4 aPos;attribute vec4 aColor;varying vec4 vColor;void main(){vColor=aColor;vColor.a=u_opacity;gl_Position=u_projectionMatrix*u_modelViewMatrix*u_modelMatrix*vec4(aPos.xyz,1.0);}",
              fragmentShader: "precision highp float;varying vec4 vColor;void main(){if(vColor.a==0.0){discard;}gl_FragColor=vColor;}"
            });
          }
        },
        {
          key: "onDestroy",
          value: function () {
            this.bufferDataArr = [];
            this.indexDataArr = [];
            this.vertexBuffer = [];
            this.indexBuffer = [];
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this.gl;
            if (b && ((this.currentScale = this.opacity = 1), (this.data = c) && c.length)) {
              var d = a.color,
                g = a.segs;
              a = a.size;
              for (var k = 360 / g, l = 0; l < c.length; l++) {
                var n = [],
                  m = [],
                  p = this.normizedPoint(c[l].geometry.coordinates),
                  q = d;
                "[object Function]" === Object.prototype.toString.call(q)
                  ? (q = q(c[l]))
                  : ((q = c[l].color || d), "properties" in c[l] && "color" in c[l].properties && (q = c[l].properties.color));
                q = this.normizedColor(q);
                var t = "[object Function]" === Object.prototype.toString.call(a) ? a(c[l]) : Number(a);
                var v = p[0],
                  r = p[1];
                n.push(0, 0, -0.5);
                n.push(q[0], q[1], q[2], 0);
                for (var u = 1, w = 0; u <= g; u++, w += k)
                  n.push(p[0] - v + Math.cos((Math.PI / 180) * w) * t, p[1] - r + Math.sin((Math.PI / 180) * w) * t, -0.5),
                    n.push(q[0], q[1], q[2], this.opacity),
                    u === g ? m.push(0, 0 + u, 1) : m.push(0, 0 + u, 0 + u + 1);
                q = b.createBuffer();
                b.bindBuffer(b.ARRAY_BUFFER, q);
                b.bufferData(b.ARRAY_BUFFER, new Float32Array(n), b.STATIC_DRAW);
                this.vertexBuffer[l] = q;
                this.bufferDataArr[l] = n;
                b.bindBuffer(b.ARRAY_BUFFER, null);
                n = b.createBuffer();
                b.bindBuffer(b.ELEMENT_ARRAY_BUFFER, n);
                b.bufferData(b.ELEMENT_ARRAY_BUFFER, new Uint16Array(m), b.STATIC_DRAW);
                this.indexBuffer[l] = n;
                this.indexDataArr[l] = m;
                b.bindBuffer(b.ELEMENT_ARRAY_BUFFER, null);
                this.position[l] = [p[0], p[1]];
              }
              this.webglLayer && this.webglLayer.render();
            }
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.projectionMatrix,
              d = a.viewMatrix;
            a = this.program;
            c.useProgram(a.program);
            c.uniformMatrix4fv(a.uniforms.u_projectionMatrix, !1, b);
            c.uniformMatrix4fv(a.uniforms.u_modelViewMatrix, !1, d);
            b = this.opacity;
            void 0 !== this.options.opacity && (b = this.options.opacity);
            c.uniform1f(a.uniforms.u_opacity, b);
            this.setGLState({ blend: !0, blendEquation: c.FUNC_ADD, blendFunc: [c.SRC_ALPHA, c.DST_ALPHA] });
            c.enableVertexAttribArray(a.attributes.aPos);
            c.enableVertexAttribArray(a.attributes.aColor);
            for (b = 0; b < this.bufferDataArr.length; b++)
              if (!(0 >= this.bufferDataArr[b].length)) {
                d = new Float32Array(this.bufferDataArr[b]).BYTES_PER_ELEMENT;
                c.bindBuffer(c.ARRAY_BUFFER, this.vertexBuffer[b]);
                c.vertexAttribPointer(a.attributes.aColor, 4, c.FLOAT, !1, 7 * d, 3 * d);
                c.vertexAttribPointer(a.attributes.aPos, 3, c.FLOAT, !1, 7 * d, 0);
                d = this.position[b];
                var g = L.create(),
                  k = [this.currentScale, this.currentScale, this.currentScale];
                "px" === this.options.unit && this.map && ((k = this.map.getZoomUnits()), (k = [this.currentScale * k, this.currentScale * k, this.currentScale]));
                L.identity(g);
                L.translate(g, g, [d[0], d[1], 0]);
                L.scale(g, g, k);
                c.uniformMatrix4fv(a.uniforms.u_modelMatrix, !1, g);
                c.bindBuffer(c.ELEMENT_ARRAY_BUFFER, this.indexBuffer[b]);
                c.drawElements(c.TRIANGLES, this.indexDataArr[b].length, c.UNSIGNED_SHORT, 0);
                c.bindBuffer(c.ARRAY_BUFFER, null);
                c.bindBuffer(c.ELEMENT_ARRAY_BUFFER, null);
              }
            a = this.getOptions();
            c = a.scale;
            a = a.step;
            this.opacity -= a / 10;
            this.currentScale += c * a;
            0 > this.opacity && (this.currentScale = this.opacity = 1);
          }
        }
      ]);
      return d;
    })(ca),
    cm = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.name = "RippleLayer";
        a.bufferData = [];
        a.date = new Date();
        a.autoUpdate = !0;
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { depthTest: !0, polygonOffset: [0, 0], color: [0.1, 0.1, 0.9, 1], blend: "normal", size: 20, unit: "px", duration: 2 };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions();
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "attribute vec3 aPos;attribute vec4 aColor;attribute float aSize;uniform mat4 uMatrix;uniform vec4 uSelectedColor;uniform float uTime;uniform float duration;uniform float zoomUnits;varying vec4 vColor;void main(void){if(aColor.w>=0.0&&aColor.w<=1.0){vColor=aColor;}else{vColor=vec4(aColor.xyz,1.0);}float percent=mod(uTime,duration)/duration;vColor.a=1.-percent;gl_Position=uMatrix*vec4(aPos.xyz,1.0);gl_PointSize=aSize/zoomUnits*percent;\n#if defined(PICK)\nif(mapvIsPicked()){vColor=uSelectedColor;}\n#endif\n}",
                fragmentShader:
                  "varying vec4 vColor;void main(void){vec4 color=vColor;float d=distance(gl_PointCoord,vec2(0.5,0.5));if(d>0.5){discard;}float blur=1.0;blur=1.0-smoothstep(0.49,0.5,d);color.a*=blur;gl_FragColor=color;}",
                defines: c.enablePicked ? ["PICK"] : []
              },
              this
            );
            this.buffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            c = [
              { stride: 32, name: "aPos", buffer: this.buffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: 32, name: "aColor", buffer: this.buffer, size: 4, type: "FLOAT", offset: 12 },
              { stride: 32, name: "aSize", buffer: this.buffer, size: 1, type: "FLOAT", offset: 28 }
            ];
            c = c.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: c });
          }
        },
        {
          key: "onDestroy",
          value: function () {
            this.bufferData = [];
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            if (this.gl) {
              for (var b = [], d = a.color, g = a.size, k = 0; k < c.length; k++) {
                var l = c[k].geometry.coordinates,
                  n = d;
                "[object Function]" === Object.prototype.toString.call(n)
                  ? (n = n(c[k]))
                  : ((n = c[k].color || d), "properties" in c[k] && "color" in c[k].properties && (n = c[k].properties.color));
                n = this.normizedColor(n);
                l = this.normizedPoint(l);
                var m = c[k].size || g;
                "properties" in c[k] && "size" in c[k].properties && (m = c[k].properties.size);
                m = "[object Function]" === Object.prototype.toString.call(m) ? m(c[k]) : Number(m);
                b.push(l[0], l[1], Number(l[2] || 0));
                b.push(n[0], n[1], n[2], n[3]);
                b.push(m * window.devicePixelRatio);
              }
              this.bufferData = b;
              this.buffer.updateData(new Float32Array(b));
              a.enablePicked && this.parsePickData(c);
            }
          }
        },
        {
          key: "parsePickData",
          value: function (a) {
            var c = this.getOptions(),
              b = [];
            if (c.enablePicked)
              for (var d = 0; d < a.length; d++) {
                var g = this.indexToRgb(d);
                b.push(g[0] / 255, g[1] / 255, g[2] / 255);
              }
            c.enablePicked && this.pickBuffer.updateData(new Float32Array(b));
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.matrix,
              d = a.isPickRender;
            if (!(0 >= this.bufferData.length)) {
              var g = this.getOptions(),
                k = this.program;
              k.use(c);
              this.vertexArray.bind();
              a = this.getCommonUniforms(a);
              var l = 1;
              "m" === g.unit && this.map && (l = this.map.getZoomUnits());
              a = S(a, { zoomUnits: l, uTime: (new Date() - this.date) / 1e3, duration: g.duration, uMatrix: b });
              k.setUniforms(a);
              this.setGLState({
                blend: d ? !1 : !0,
                blendFunc: "lighter" === g.blend ? [c.SRC_ALPHA, c.ONE] : [c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA],
                blendEquation: c.FUNC_ADD,
                polygonOffset: g.polygonOffset,
                depthTest: g.depthTest
              });
              c.drawArrays(c.POINTS, 0, this.bufferData.length / 8);
            }
          }
        }
      ]);
      return d;
    })(ca),
    dm = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.name = "SparkLayer";
        a.bufferData = [];
        a.startTime = Number(a.options.startTime) || 0;
        a.endTime = Number(a.options.endTime);
        a.time = a.startTime;
        a.segs = Number(a.options.segs) || 10;
        a.autoUpdate = !0;
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { color: [0.9, 0.1, 0.1, 1], trailLength: 3, height: 100, step: 0.1, segs: 10, polygonOffset: [0, 0] };
          }
        },
        {
          key: "setTime",
          value: function (a) {
            this.time = a;
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            this.program = new X(this.gl, {
              vertexShader:
                "precision mediump float;attribute vec4 aPos;uniform mat4 u_matrix;uniform float currentTime;uniform float trailLength;varying float vTime;void main(){gl_Position=u_matrix*vec4(aPos.xyz,1.0);vTime=1.0-((currentTime-aPos.w)/trailLength);}",
              fragmentShader:
                "precision mediump float;uniform vec3 uFragColor;varying float vTime;void main(){if(vTime>1.0||vTime<0.0){discard;}gl_FragColor=vec4(uFragColor,1.0*vTime);}"
            });
            this.buffer = a.createBuffer();
            a.bindBuffer(a.ARRAY_BUFFER, this.buffer);
          }
        },
        {
          key: "onDestroy",
          value: function () {
            this.bufferData = [];
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this.gl;
            if (b) {
              this.buffer = b.createBuffer();
              b.bindBuffer(b.ARRAY_BUFFER, this.buffer);
              for (var d = [], g = a.height, k = 0; k < c.length; k++) {
                var l = c[k].geometry.coordinates;
                var n = "[object Function]" === Object.prototype.toString.call(g) ? g(c[k]) : Number(g);
                for (var m = 0, p = 0; p < this.segs; p++) {
                  var q = this.normizedPoint(l);
                  d.push(q[0], q[1], m);
                  void 0 === l[2] ? d.push(p) : d.push(Number(l[2]));
                  m += n / this.segs;
                  d.push(q[0], q[1], m);
                  void 0 === l[2] ? d.push(p + 1) : d.push(Number(l[2]));
                }
              }
              void 0 === a.endTime && (this.endTime = this.segs);
              this.bufferData = d;
              b.bufferData(b.ARRAY_BUFFER, new Float32Array(d), b.STATIC_DRAW);
              this.webglLayer && this.webglLayer.render();
            }
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.matrix;
            a = this.program;
            c.useProgram(a.program);
            c.uniformMatrix4fv(a.uniforms.u_matrix, !1, b);
            c.bindBuffer(c.ARRAY_BUFFER, this.buffer);
            c.enableVertexAttribArray(a.attributes.aPos);
            c.vertexAttribPointer(a.attributes.aPos, 4, c.FLOAT, !1, 0, 0);
            b = this.normizedColor(this.options.color);
            c.uniform3f(a.uniforms.uFragColor, b[0], b[1], b[2]);
            c.uniform1f(a.uniforms.currentTime, this.time);
            c.uniform1f(a.uniforms.trailLength, this.options.trailLength);
            this.setGLState({ blend: !0, blendFunc: [c.SRC_ALPHA, c.ONE], blendEquation: c.FUNC_ADD, polygonOffset: this.options.polygonOffset });
            c.drawArrays(c.LINES, 0, this.bufferData.length / 4);
            this.time += Number(this.options.step);
            this.time > 1.5 * this.endTime && (this.time = this.startTime);
          }
        }
      ]);
      return d;
    })(ca),
    Gf = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.name = "IconLayer";
        a.index = [];
        c = a.canvas = document.createElement("canvas");
        a.ctx = c.getContext("2d");
        a.iconHash = new Nb();
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              depthWrite: !0,
              depthTest: !0,
              blend: "default",
              flat: !1,
              unit: "px",
              scale: 1,
              angle: 0,
              opacity: 1,
              offset: [0, 0],
              padding: [0, 0],
              polygonOffset: [0, 0]
            };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions();
            this.texture = null;
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;attribute vec3 a_pos;attribute float a_corner;attribute float a_rotation;attribute vec2 a_size;attribute vec2 a_offset;attribute vec2 a_texture_coord;uniform mat4 u_matrix;uniform vec2 u_size;uniform float devicePixelRatio;uniform float u_zoom_units;uniform float u_zIndex;uniform float u_scale;uniform bool u_unit_px;uniform bool u_flat;varying vec2 v_texture_coord;/***\u70b9A(x,y)\uff0c\u7ed5\u539f\u70b9\u987a\u65f6\u9488\u65cb\u8f6c\u89d2\u5ea6a\u65b0\u5750\u6807\u7684\u8ba1\u7b97\u516c\u5f0f*x1=x*cos(a)+y*sin(a)*y1=y*cos(a)-x*sin(a)*/vec3 transformCoord(vec3 coord,vec2 size,float corner){float x=coord.x;float y=coord.y;if(corner==1.0){x+=-size.x*cos(a_rotation)+size.y*sin(a_rotation);y+=size.y*cos(a_rotation)+size.x*sin(a_rotation);}else if(corner==2.0){x+=size.x*cos(a_rotation)+size.y*sin(a_rotation);y+=size.y*cos(a_rotation)-size.x*sin(a_rotation);}else if(corner==3.0){x+=size.x*cos(a_rotation)-size.y*sin(a_rotation);y+=-size.y*cos(a_rotation)-size.x*sin(a_rotation);}else{x+=-size.x*cos(a_rotation)-size.y*sin(a_rotation);y+=-size.y*cos(a_rotation)+size.x*sin(a_rotation);}return vec3(x,y,coord.z);}void main(){v_texture_coord=a_texture_coord;if(u_flat){vec2 offset=a_offset;vec2 halfSize=a_size/2.0*u_scale;if(u_unit_px){halfSize*=u_zoom_units;offset*=u_zoom_units;}vec3 current=transformCoord(a_pos,halfSize,a_corner);current.z+=u_zIndex;gl_Position=u_matrix*vec4(current.x+offset[0],current.y-offset[1],current.z,1.0);}else{vec4 position=u_matrix*vec4(a_pos,1.0);vec3 screen=position.xyz/position.w;vec2 halfSize=a_size/MAPV_resolution*devicePixelRatio*u_scale;vec2 offset=a_offset*2./MAPV_resolution*devicePixelRatio;if(!u_unit_px){halfSize/=u_zoom_units;offset/=u_zoom_units;}vec3 current=transformCoord(screen,halfSize,a_corner);current.xy=current.xy-offset;current.z+=u_zIndex;gl_Position=vec4(current,1.0);}}",
                fragmentShader:
                  "precision highp float;varying vec2 v_texture_coord;uniform sampler2D u_icon;uniform float u_opacity;uniform vec4 uSelectedColor;void main(){vec4 textureColor=texture2D(u_icon,vec2(v_texture_coord.x,1.0-v_texture_coord.y));if(textureColor.a==0.0&&uIsPickRender==false){discard;}textureColor.a*=u_opacity;gl_FragColor=textureColor;\n#if defined(PICK)\nif(mapvIsPicked()){gl_FragColor=vec4(uSelectedColor.rgb,gl_FragColor.a);}\n#endif\n}",
                defines: c.enablePicked ? ["PICK"] : []
              },
              this
            );
            this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.uvBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            c = [
              { name: "a_pos", buffer: this.vertexBuffer, size: 3, stride: 36, type: "FLOAT", offset: 0 },
              { name: "a_corner", buffer: this.vertexBuffer, size: 1, stride: 36, type: "FLOAT", offset: 12 },
              { name: "a_size", buffer: this.vertexBuffer, size: 2, stride: 36, type: "FLOAT", offset: 16 },
              { name: "a_offset", buffer: this.vertexBuffer, size: 2, stride: 36, type: "FLOAT", offset: 24 },
              { name: "a_rotation", buffer: this.vertexBuffer, size: 1, stride: 36, type: "FLOAT", offset: 32 },
              { name: "a_texture_coord", buffer: this.uvBuffer, size: 2, stride: 8, type: "FLOAT", offset: 0 }
            ];
            c = c.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: c });
          }
        },
        { key: "onDestroy", value: function () {} },
        {
          key: "onChanged",
          value: function (a, c) {
            this.gl && this.processCache(a, c, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {});
          }
        },
        {
          key: "processCache",
          value: function (a, c, b) {
            var d = this;
            this.cachedData = [];
            for (var f = a.icon, k = a.width, l = a.height, n = a.offset, m = a.angle, p = 0; p < c.length; p++) {
              var q = this.normizedPoint(c[p].geometry.coordinates),
                t = this.getProperty("icon", f, c[p]),
                v = this.getProperty("width", k, c[p]),
                r = this.getProperty("height", l, c[p]),
                u = this.getProperty("offset", n, c[p]),
                w = this.getProperty("angle", m, c[p]);
              q && t && (this.cachedData.push({ point: q, icon: t, width: v, height: r, offset: u, angle: w, index: p }), this.iconHash.get(t) || this.iconHash.set(t, t));
            }
            c = Ud(this.iconHash.entries())
              .filter(function (a) {
                return "string" === typeof a[1];
              })
              .map(function (a) {
                var c = da(a, 2)[0];
                return new Lb(function (a, b) {
                  d.url2canvas(c, function (b) {
                    d.iconHash.set(c, b);
                    a();
                  });
                });
              });
            Lb.all(c).then(function (c) {
              d.buildSprite(a);
              !1 !== b.autoRender && d.webglLayer && d.webglLayer.render();
            });
          }
        },
        {
          key: "buildSprite",
          value: function (a) {
            var c = a.padding,
              b = this.canvas,
              d = this.ctx,
              g = [],
              k = new Nb(),
              l = !0,
              n = !1,
              m = void 0;
            try {
              for (var p = gc(this.iconHash), q; !(l = (q = p.next()).done); l = !0) {
                var t = da(q.value, 2),
                  v = t[1];
                if ("string" !== typeof v) {
                  var r = v.width,
                    u = v.height;
                  g.push({ w: r + c[0], h: u + c[0], width: r, height: u, key: t[0], icon: v });
                }
              }
            } catch (w) {
              (n = !0), (m = w);
            } finally {
              try {
                !l && p.return && p.return();
              } finally {
                if (n) throw m;
              }
            }
            n = zb(g);
            for (l = 0; l < g.length; l++) (m = g[l]), k.get(m.key) || k.set(m.key, m);
            l = lb(n.w);
            n = lb(n.h);
            b.width = l || 1;
            b.height = n || 1;
            d.save();
            for (b = 0; b < g.length; b++) (m = g[b]), d.drawImage(m.icon, m.x + c[0], m.y + c[1], m.width, m.height);
            d.restore();
            this.loadTexture();
            this.buildVertex(a, k, l, n);
          }
        },
        {
          key: "buildVertex",
          value: function (a, c, b, d) {
            a = a.enablePicked;
            for (var f = [], h = [], l = [], n = [], m = 0; m < this.cachedData.length; m++) {
              var p = this.cachedData[m],
                q = p.point,
                t = p.width,
                v = p.height,
                r = p.offset,
                u = p.angle,
                w = p.index;
              if ((p = c.get(p.icon))) {
                t = t || p.icon.width;
                v = v || p.icon.height;
                var y = da(q, 3);
                q = y[0];
                var x = y[1];
                y = y[2];
                for (var D = 0; 4 > D; D++) f.push(q, x, y), f.push(D), f.push(t, v), f.push.apply(f, W(r)), f.push((u * Math.PI) / 180);
                t = p.x / b;
                v = (p.x + p.w) / b;
                r = (p.y + p.h) / d;
                p = p.y / d;
                h.push(t, r, t, p, v, p, v, r);
                p = 4 * m;
                l.push(p, p + 2, p + 1, p, p + 3, p + 2);
                a &&
                  ((w = this.indexToRgb(w)),
                  n.push(w[0] / 255, w[1] / 255, w[2] / 255),
                  n.push(w[0] / 255, w[1] / 255, w[2] / 255),
                  n.push(w[0] / 255, w[1] / 255, w[2] / 255),
                  n.push(w[0] / 255, w[1] / 255, w[2] / 255));
              }
            }
            this.index = l;
            this.vertexBuffer.updateData(new Float32Array(f));
            this.uvBuffer.updateData(new Float32Array(h));
            this.indexBuffer.updateData(new Uint32Array(l));
            a && this.pickBuffer.updateData(new Float32Array(n));
          }
        },
        {
          key: "render",
          value: function (a) {
            if (this.cachedData && this.cachedData.length && this.iconHash && this.texture) {
              var c = a.gl,
                b = a.matrix,
                d = this.getOptions(),
                g = this.program;
              g.use(c);
              var k = a.isPickRender ? Va(c, null) : Va(c, d.blend);
              this.setGLState({ blend: !0, blendFunc: k, polygonOffset: d.polygonOffset, depthTest: d.depthTest, depthMask: d.depthWrite });
              g.setUniforms(
                S(this.getCommonUniforms(a), {
                  u_icon: this.texture,
                  u_matrix: b,
                  u_flat: d.flat,
                  u_unit_px: "px" === d.unit,
                  u_zoom_units: this.map.getZoomUnits(),
                  u_scale: d.scale,
                  u_opacity: d.opacity,
                  u_zIndex: d.zIndex,
                  devicePixelRatio: window.devicePixelRatio
                })
              );
              0 < this.index.length && (this.indexBuffer.bind(), this.vertexArray.bind(), c.drawElements(c.TRIANGLES, this.index.length, c.UNSIGNED_INT, 0));
            }
          }
        },
        {
          key: "url2canvas",
          value: function (a, c) {
            if ("object" === ("undefined" === typeof a ? "undefined" : Ha(a))) c(a);
            else {
              var b = new Image();
              b.crossOrigin = "anonymous";
              b.onload = function () {
                var a = b.width,
                  d = b.height,
                  f = document.createElement("canvas");
                f.width = a;
                f.height = d;
                f.getContext("2d").drawImage(b, 0, 0, a, d);
                c(f);
              };
              b.onerror = function () {
                var a = document.createElement("canvas");
                a.width = 20;
                a.height = 40;
                var b = a.getContext("2d");
                b.fillStyle = "red";
                b.beginPath();
                b.lineTo(0, 0);
                b.lineTo(20, 0);
                b.lineTo(10, 40);
                b.closePath();
                b.fill();
                c(a);
              };
              b.src = a;
            }
          }
        },
        {
          key: "loadTexture",
          value: function () {
            var a = this;
            this.canvas
              ? ta(this.gl, this.canvas, function (c) {
                  a.texture = c;
                })
              : (this.texture = null);
          }
        }
      ]);
      return d;
    })(ca),
    em = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        var c = S({ blend: "default" }, a.options);
        a.pointLayer = new md(c);
        a.options.textOptions = S({ depthTest: !1, collides: !1 }, a.options.textOptions);
        a.textLayer = new rc(a.options.textOptions);
        c = S({}, a.options, a.options.iconOptions);
        a.iconLayer = new Gf(c);
        a.children = [a.pointLayer, a.textLayer, a.iconLayer];
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              minSize: 25,
              maxSize: 40,
              clusterRadius: 200,
              minPoints: 2,
              extent: 400,
              showText: !0,
              maxZoom: 19,
              minZoom: 4,
              gradient: { 0: "rgb(50, 50, 256)", 0.1: "rgb(50, 250, 56)", 0.5: "rgb(250, 250, 56)", 1: "rgb(250, 50, 56)" },
              textOptions: { fontSize: 12, color: "white" },
              iconOptions: {}
            };
          }
        },
        {
          key: "onOptionsChanged",
          value: function (a) {
            this.textLayer.setOptions(a.textOptions);
          }
        },
        {
          key: "setOptions",
          value: function () {
            var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
              c = this.options.textOptions;
            a.textOptions && S(c, a.textOptions);
            var b = a.minZoom,
              d = a.maxZoom,
              g = a.clusterRadius;
            b = (d && d !== this.options.maxZoom) || (b && b !== this.options.minZoom) || (g && g !== this.options.clusterRadius);
            S(this.options, a, { textOptions: c });
            if (b) this.onChanged(this.options, this.data);
            else this.refreshCluster();
            this.onOptionsChanged(this.getOptions());
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this;
            c && c.length
              ? (c.forEach(function (a) {
                  var c = da(a.geometry.coordinates, 2),
                    d = c[0];
                  c = c[1];
                  (-180 <= d && 180 >= d && -90 <= c && 90 >= c) || ((d = b.map.mercatorToLnglat(d, c)), (a.geometry.coordinates[0] = d[0]), (a.geometry.coordinates[1] = d[1]));
                }),
                (this.supercluster = new Ff({ maxZoom: a.maxZoom, minZoom: a.minZoom, radius: a.clusterRadius, minPoints: a.minPoints, extent: a.extent })),
                this.supercluster.load(c),
                this.supercluster.trees.forEach(function (a) {
                  var c = 0,
                    b = Infinity;
                  a.points.forEach(function (a) {
                    c = Math.max(a.numPoints || 0, c);
                    b = Math.min(a.numPoints || Infinity, b);
                  });
                  a.max = c;
                  a.min = b;
                }),
                this.refreshCluster())
              : ((this.supercluster = null), this.pointLayer.setData([]), this.iconLayer.setData([]), this.textLayer.setData([]));
          }
        },
        {
          key: "refreshCluster",
          value: function () {
            var a = this,
              c = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : this.options;
            if (this.supercluster) {
              var b = this.getClusterData(c);
              if (b && b.length)
                if ("function" === typeof c.beforeRender && !1 === c.beforeRender(b)) this.pointLayer.setData([]), this.iconLayer.setData([]), this.textLayer.setData([]);
                else {
                  var d = [],
                    g = [],
                    k = [];
                  b.forEach(function (c) {
                    c.properties.cluster
                      ? (d.push(c), k.push({ geometry: c.geometry, properties: { text: c.properties.text } }))
                      : c.properties.icon || a.options.iconOptions.icon
                      ? g.push(c)
                      : d.push(c);
                  });
                  this.pointLayer.setData(d);
                  this.iconLayer.setData(g);
                  this.textLayer.setData(c.showText ? k : []);
                  c.enablePicked && c.autoSelect && this.pick(-1, -1);
                }
            }
          }
        },
        {
          key: "getClusterData",
          value: function () {
            var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : this.options,
              c = this.map.getBounds(),
              b = (this.ne = c.getNorthEast());
            c = this.sw = c.getSouthWest();
            var d = b,
              g = d.lng;
            d = d.lat;
            -180 <= g && 180 >= g && -90 <= d && 90 >= d
              ? (c = [c.lng, c.lat, b.lng, b.lat])
              : ((b = this.map.mercatorToLnglat(this.ne.lng, this.ne.lat)), (c = this.map.mercatorToLnglat(this.sw.lng, this.sw.lat)), (c = c.concat(b)));
            b = Math.floor(this.map.getZoom());
            c = this.supercluster.getClusters(c, b);
            this.zoom !== b &&
              0 < c.length &&
              ((this.zoom = b),
              (d = this.supercluster.trees),
              (g = (d[b] && d[b].max) || this.max),
              (b = (d[b] && d[b].min) || this.min),
              g !== b && ((this.max = g), (this.min = b)));
            return this.processData(c, a);
          }
        },
        {
          key: "processData",
          value: function (a, c) {
            var b = c.defaultColor,
              d = c.defaultSize,
              g = c.gradient,
              k = c.minSize,
              l = c.textOptions,
              n = new Ba({ max: this.max, min: ~~this.min || 1, minSize: k || 8, maxSize: c.maxSize || 30, gradient: g });
            b = b || g[0] || "black";
            d = d || 0.5 * k || 5;
            var m = l && l.format;
            m = "function" === typeof m ? m : null;
            return a.map(function (a) {
              var c = d,
                f = b,
                g = "";
              a.properties && a.properties.point_count && ((g = a.properties.point_count), (c = n.getSize(g) || c), (f = n.getColor(g)), (g = m ? m(g) : g));
              c = S({}, a.properties, { text: g, size: c, color: f });
              return S({}, a, { properties: c, children: a.id });
            });
          }
        },
        {
          key: "pick",
          value: function (a, c) {
            var b = this.pointLayer.pick(a, c);
            0 > b.dataIndex && (b = this.iconLayer.pick(a, c));
            (a = b.dataItem) && "number" === typeof a.children && (a.children = this.getClusterPoints(a.children));
            return b;
          }
        },
        {
          key: "getClusterPoints",
          value: function (a) {
            var c = this;
            return a
              ? this.supercluster
                  .getChildren(a)
                  .map(function (a) {
                    return "Feature" === a.type ? c.getClusterPoints(a.id) : a;
                  })
                  .flat()
              : [];
          }
        },
        {
          key: "shouldUpdate",
          value: function () {
            if (!this.data || !this.supercluster) return !1;
            if (this.zoom !== Math.floor(this.map.getZoom())) return !0;
            var a = this.map.getBounds(),
              c = a.getNorthEast();
            a = a.getSouthWest();
            if (this.ne.lng !== c.lng || this.ne.lat !== c.lat || this.sw.lng !== a.lng || this.sw.lat !== a.lat) return !0;
          }
        },
        {
          key: "render",
          value: function (a) {
            this.shouldUpdate() ? this.refreshCluster() : ib(d.prototype.__proto__ || N(d.prototype), "render", this).call(this, a);
          }
        }
      ]);
      return d;
    })(jb),
    fm = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.options.textOptions = S({ collides: !1, depthWrite: !0 }, a.options.textOptions);
        a.textLayer = new rc(a.options.textOptions);
        a.options.iconOptions = S({}, a.options, a.options.iconOptions);
        a.iconLayer = new Gf(a.options.iconOptions);
        a.children = [a.textLayer, a.iconLayer];
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { clusterRadius: 200, minPoints: 2, showText: !0, minZoom: 19, maxZoom: 4, extent: 400, textOptions: { fontSize: 12, color: "white" }, iconOptions: {} };
          }
        },
        {
          key: "setOptions",
          value: function () {
            var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
              c = this.options.textOptions,
              b = this.options.iconOptions;
            a.textOptions && S(c, a.textOptions);
            a.iconOptions && S(b, a.textOptions);
            b = a.minZoom;
            var d = a.maxZoom,
              g = a.clusterRadius;
            b = (d && d !== this.options.maxZoom) || (b && b !== this.options.minZoom) || (g && g !== this.options.clusterRadius);
            S(this.options, a, { textOptions: c });
            if (b) this.onChanged(this.options, this.data);
            else this.refreshCluster();
            this.onOptionsChanged(this.getOptions());
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this;
            c && c.length
              ? (c.forEach(function (a) {
                  var c = da(a.geometry.coordinates, 2),
                    d = c[0];
                  c = c[1];
                  (-180 <= d && 180 >= d && -90 <= c && 90 >= c) || ((d = b.map.mercatorToLngLat(d, c)), (a.geometry.coordinates[0] = d[0]), (a.geometry.coordinates[1] = d[1]));
                }),
                (this.supercluster = new Ff({ maxZoom: a.maxZoom, minZoom: a.minZoom, minPoints: a.minPoints, radius: a.clusterRadius, extent: a.extent })),
                this.supercluster.load(c),
                this.supercluster.trees.forEach(function (a) {
                  var c = 0,
                    b = Infinity;
                  a.points.forEach(function (a) {
                    c = Math.max(a.numPoints || 0, c);
                    b = Math.min(a.numPoints || Infinity, b);
                  });
                  a.max = c;
                  a.min = b;
                }),
                this.refreshCluster())
              : ((this.supercluster = null), this.textLayer.setData([]), this.iconLayer.setData([]));
          }
        },
        {
          key: "refreshCluster",
          value: function () {
            var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : this.options;
            if (this.supercluster) {
              var c = this.getClusterData(a);
              if (c && c.length)
                if ("function" === typeof a.beforeRender && !1 === a.beforeRender(a)) this.textLayer.setData([]), this.iconLayer.setData([]);
                else {
                  var b = [],
                    d = [];
                  c.forEach(function (a) {
                    a.properties.cluster && b.push({ geometry: a.geometry, properties: { text: a.properties.text } });
                    d.push(a);
                  });
                  this.textLayer.setData(a.showText ? b : []);
                  this.iconLayer.setData(d);
                  a.enablePicked && a.autoSelect && this.pick(-1, -1);
                }
            }
          }
        },
        {
          key: "getClusterData",
          value: function (a) {
            var c = this.map.getBounds(),
              b = (this.ne = c.getNorthEast());
            c = this.sw = c.getSouthWest();
            var d = b,
              g = d.lng;
            d = d.lat;
            -180 <= g && 180 >= g && -90 <= d && 90 >= d
              ? (c = [c.lng, c.lat, b.lng, b.lat])
              : ((b = this.map.mercatorToLnglat(this.ne.lng, this.ne.lat)), (c = this.map.mercatorToLnglat(this.sw.lng, this.sw.lat)), (c = c.concat(b)));
            b = Math.floor(this.map.getZoom());
            c = this.supercluster.getClusters(c, b);
            this.zoom !== b &&
              0 < c.length &&
              ((this.zoom = b),
              (d = this.supercluster.trees),
              (g = (d[b] && d[b].max) || this.max),
              (b = (d[b] && d[b].min) || this.min),
              g !== b && ((this.max = g), (this.min = b)));
            return this.processData(c, a);
          }
        },
        {
          key: "processData",
          value: function (a, c) {
            var b = this,
              d = (c = c.textOptions) && c.format;
            d = "function" === typeof d ? d : null;
            return a.map(function (a) {
              var c;
              if ((c = a.properties) && a.properties.point_count) {
                c = a.properties.point_count;
                var f = b.getClusterIcon(c);
                c = d && d(c);
                c = S({}, a.properties, { text: c, icon: f });
              }
              return S({}, a, { properties: c, children: a.id });
            });
          }
        },
        {
          key: "getClusterIcon",
          value: function (a) {
            var c = this.options.iconExtent,
              b = qa(c).map(function (a) {
                return +a;
              }),
              d = b.length;
            if (0 !== d) {
              for (var g = 1, k = void 0, l = b[0]; g < d; ) {
                k = l;
                l = b[g];
                if (k <= a && l > a) return c[k];
                g++;
              }
              if (a > l) return c[l];
            }
          }
        },
        {
          key: "pick",
          value: function (a, c) {
            a = this.iconLayer.pick(a, c);
            (c = a.dataItem) && "number" === typeof c.children && (c.children = this.getClusterPoints(c.children));
            return a;
          }
        },
        {
          key: "getClusterPoints",
          value: function (a) {
            var c = this;
            return a
              ? this.supercluster
                  .getChildren(a)
                  .map(function (a) {
                    return "Feature" === a.type ? c.getClusterPoints(a.id) : a;
                  })
                  .flat()
              : [];
          }
        },
        {
          key: "shouldUpdate",
          value: function () {
            if (!this.data || !this.supercluster) return !1;
            if (this.zoom !== Math.floor(this.map.getZoom())) return !0;
            var a = this.map.getBounds(),
              c = a.getNorthEast();
            a = a.getSouthWest();
            if (this.ne.lng !== c.lng || this.ne.lat !== c.lat || this.sw.lng !== a.lng || this.sw.lat !== a.lat) return !0;
          }
        },
        {
          key: "render",
          value: function (a) {
            this.shouldUpdate() ? this.refreshCluster() : ib(d.prototype.__proto__ || N(d.prototype), "render", this).call(this, a);
          }
        }
      ]);
      return d;
    })(jb),
    gm = (function (b) {
      function d(a, c) {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).call(this, a, c));
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return S(ib(d.prototype.__proto__ || N(d.prototype), "getDefaultOptions", this).call(this), {
              style: "grid",
              gridSize: 500,
              gradient: { 0: "rgb(50, 50, 256)", 0.1: "rgb(50, 250, 56)", 0.5: "rgb(250, 250, 56)", 1: "rgb(250, 50, 56)" }
            });
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            this.gl && ((c = this.processData(c, a)), ib(d.prototype.__proto__ || N(d.prototype), "onChanged", this).call(this, a, c));
          }
        },
        {
          key: "generateGrid",
          value: function (a, c) {
            var b = c.gridSize,
              d = [],
              g = {};
            c = a.length;
            for (var k = this.getPointOffset(), l = 0; l < c; l++) {
              var n = this.normizedPoint(a[l].geometry.coordinates),
                m = n[2];
              n = ~~((n[0] + k[0]) / b) + "_" + ~~((n[1] + k[1]) / b);
              void 0 === g[n] && (g[n] = { count: 0, num: 0, z: 0 });
              var p = ~~a[l].count || 1;
              "properties" in a[l] && "count" in a[l].properties && (p = ~~a[l].properties.count);
              g[n].count += p;
              g[n].num += 1;
              g[n].z += m;
            }
            qa(g).forEach(function (a) {
              var c = a.split("_");
              d.push([c[0] * b + b / 2, c[1] * b + b / 2, g[a].z / g[a].num, g[a].count]);
            });
            return d;
          }
        },
        {
          key: "processData",
          value: function (a, c) {
            var b = [];
            if ("normal" === c.style)
              for (var d = this.getPointOffset(), g = 0; g < a.length; g++) {
                var k = this.normizedPoint(a[g].geometry.coordinates),
                  l = k[0] + d[0],
                  n = k[1] + d[1];
                k = k[2];
                var m = ~~a[g].count || 1;
                "properties" in a[g] && "count" in a[g].properties && (m = ~~a[g].properties.count);
                b.push([l, n, k, m]);
              }
            else b = this.generateGrid(a, c);
            d = a = 0;
            if (void 0 !== c.max && void 0 !== c.min) (a = c.max), (d = c.min);
            else {
              b[0] && ((a = b[0][3]), (d = b[0][3]));
              g = b.length;
              for (l = 0; l < g; l++) (n = b[l]), (a = Math.max(n[3], a)), (d = Math.min(n[3], d));
              a /= 2;
            }
            c = new Ba({ max: ~~a, min: d, gradient: c.gradient });
            a = [];
            for (d = 0; d < b.length; d++)
              (g = b[d]),
                (g[0] = g[0]),
                (g[1] = g[1]),
                (l = c.getImageData(g[3])),
                a.push({ geometry: { type: "Point", coordinates: [g[0], g[1], g[2]] }, color: [l[0] / 255, l[1] / 255, l[2] / 255, l[3] / 255] });
            return a;
          }
        }
      ]);
      return d;
    })(md),
    hm = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.bufferData = [];
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { color: [1, 0.05, 0.05, 1] };
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this;
            if ((a = this.gl)) {
              this.buffer = a.createBuffer();
              a.bindBuffer(a.ARRAY_BUFFER, this.buffer);
              for (
                var d = [],
                  g = function (a) {
                    var f = 5 * a;
                    for (a = 0; a < c.length; a++)
                      c[a].geometry.coordinates.forEach(function (a) {
                        for (var c = 0; c < a.length - 1; c++) {
                          var g = b.normizedPoint(a[c]);
                          d.push(g[0]);
                          d.push(g[1]);
                          d.push(Number(f));
                          g = b.normizedPoint(a[c + 1]);
                          d.push(g[0]);
                          d.push(g[1]);
                          d.push(Number(f));
                        }
                      });
                  },
                  k = 0;
                20 > k;
                k++
              )
                g(k);
              a.bufferData(a.ARRAY_BUFFER, new Float32Array(d), a.STATIC_DRAW);
              this.bufferData = d;
              a.bindBuffer(a.ARRAY_BUFFER, null);
            }
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            this.program = new X(a, {
              vertexShader: "uniform mat4 uMatrix;attribute vec3 aPos;void main(){gl_PointSize=10.0;gl_Position=uMatrix*vec4(aPos,1.0);}",
              fragmentShader: "precision mediump float;uniform vec4 uFragColor;void main(){gl_FragColor=uFragColor;}"
            });
            this.buffer = a.createBuffer();
            a.bindBuffer(a.ARRAY_BUFFER, this.buffer);
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl;
            a = a.matrix;
            var b = this.program;
            c.useProgram(b.program);
            var d = this.normizedColor(this.options.color);
            c.uniform4f(b.uniforms.uFragColor, d[0], d[1], d[2], d[3]);
            c.uniformMatrix4fv(b.uniforms.uMatrix, !1, a);
            c.bindBuffer(c.ARRAY_BUFFER, this.buffer);
            c.enableVertexAttribArray(b.attributes.aPos);
            c.vertexAttribPointer(b.attributes.aPos, 3, c.FLOAT, !1, 0, 0);
            this.setGLState({ blend: !0, blendEquation: c.FUNC_ADD, blendFunc: [c.ONE, c.ONE] });
            c.drawArrays(c.LINES, 0, this.bufferData.length / 3);
          }
        }
      ]);
      return d;
    })(ca),
    vi = { circle: 1, square: 2 },
    im = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.bufferData = [];
        a.startTime = a.options.startTime || 0;
        a.endTime = a.options.endTime;
        a.time = a.startTime;
        a.autoUpdate = !0;
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            this.program = new X(this.gl, {
              vertexShader:
                "attribute vec4 aPos;attribute vec4 aColor;attribute float aSize;uniform mat4 u_matrix;varying vec4 vColor;uniform float currentTime;uniform float trailLength;varying float vTime;void main(void){if(aColor.w>=0.0&&aColor.w<=1.0){vColor=aColor;}else{vColor=vec4(aColor.xyz,1.0);}gl_Position=u_matrix*vec4(aPos.xyz,1.0);gl_PointSize=aSize;vTime=1.0-((currentTime-aPos.w)/trailLength);}",
              fragmentShader:
                "precision highp float;varying vec4 vColor;uniform int uShape;varying float vTime;void main(void){if(vTime>1.0||vTime<0.0){discard;}if(uShape==1){float d=distance(gl_PointCoord,vec2(0.5,0.5));if(d<0.5){gl_FragColor=vColor;}else{discard;}}else{gl_FragColor=vec4(vColor.rgb,vColor.a*vTime);}}"
            });
            this.f32BufferData = new Float32Array();
            this.buffer = a.createBuffer();
            a.bindBuffer(a.ARRAY_BUFFER, this.buffer);
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this.gl;
            if (b) {
              this.buffer = b.createBuffer();
              b.bindBuffer(b.ARRAY_BUFFER, this.buffer);
              for (var d = [], g = a.color || [0.1, 0.1, 0.9, 1], k = a.size || 5, l = 0; l < c.length; l++) {
                var n = c[l].geometry.coordinates,
                  m = g;
                "[object Function]" === Object.prototype.toString.call(m)
                  ? (m = m(c[l]))
                  : ((m = c[l].color || g), "properties" in c[l] && "color" in c[l].properties && (m = c[l].properties.color));
                m = this.normizedColor(m);
                var p = this.normizedPoint(n),
                  q = k;
                q = "[object Function]" === Object.prototype.toString.call(q) ? q(c[l]) : Number(q);
                var t = c[l].time || l;
                "properties" in c[l] && "time" in c[l].properties && (t = c[l].properties.time);
                d.push(p[0], p[1], Number(n[2] || 0), t);
                d.push(m[0], m[1], m[2], m[3]);
                d.push(q * window.devicePixelRatio);
              }
              void 0 === a.endTime && (this.endTime = c.length);
              this.bufferData = d;
              this.f32BufferData = new Float32Array(d);
              b.bufferData(b.ARRAY_BUFFER, this.f32BufferData, b.STATIC_DRAW);
            }
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.matrix;
            0 >= this.bufferData.length ||
              ((a = this.program),
              c.useProgram(a.program),
              c.uniformMatrix4fv(a.uniforms.u_matrix, !1, b),
              c.bindBuffer(c.ARRAY_BUFFER, this.buffer),
              (b = this.f32BufferData.BYTES_PER_ELEMENT),
              c.enableVertexAttribArray(a.attributes.aPos),
              c.vertexAttribPointer(a.attributes.aPos, 4, c.FLOAT, !1, 9 * b, 0),
              c.enableVertexAttribArray(a.attributes.aColor),
              c.vertexAttribPointer(a.attributes.aColor, 4, c.FLOAT, !1, 9 * b, 4 * b),
              c.enableVertexAttribArray(a.attributes.aSize),
              c.vertexAttribPointer(a.attributes.aSize, 1, c.FLOAT, !1, 9 * b, 8 * b),
              c.uniform1f(a.uniforms.currentTime, this.time),
              c.uniform1f(a.uniforms.trailLength, this.options.trailLength || 3),
              (b = 1),
              this.options.shape && vi[this.options.shape] && (b = vi[this.options.shape]),
              c.uniform1i(a.uniforms.uShape, b),
              this.setGLState({ blend: !0, blendEquation: c.FUNC_ADD, blendFunc: "lighter" === this.options.blend ? [c.SRC_ALPHA, c.ONE] : [c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA] }),
              c.drawArrays(c.POINTS, 0, this.bufferData.length / 9),
              (this.time += this.options.step || 0.1),
              this.time > this.endTime && (this.time = this.startTime));
          }
        }
      ]);
      return d;
    })(ca),
    jm = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.bufferData = [];
        a.startTime = a.options.startTime || 0;
        a.endTime = a.options.endTime;
        a.time = a.startTime;
        a.autoUpdate = !0;
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { color: [1, 0.05, 0.05, 1], trailLength: 3, step: 0.1, polygonOffset: [0, 0] };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;attribute vec4 aPos;attribute vec4 aColor;uniform mat4 u_matrix;uniform float currentTime;uniform float trailLength;varying float vTime;varying vec4 vColor;void main(){gl_Position=u_matrix*vec4(aPos.xyz,1.0);vColor=aColor;vTime=1.0-((currentTime-aPos.w)/trailLength);}",
                fragmentShader:
                  "precision highp float;uniform vec3 uFragColor;varying vec4 vColor;varying float vTime;void main(){if(vTime>1.0||vTime<0.0){discard;}gl_FragColor=vec4(vColor.rgb,1.0*vTime);}"
              },
              this
            );
            this.buffer = a.createBuffer();
            a.bindBuffer(a.ARRAY_BUFFER, this.buffer);
          }
        },
        {
          key: "setTime",
          value: function (a) {
            this.time = a;
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this.gl;
            if (b) {
              this.buffer = b.createBuffer();
              b.bindBuffer(b.ARRAY_BUFFER, this.buffer);
              for (var d = [], g = 0, k = this.options.color, l = 0; l < c.length; l++) {
                var n = c[l].geometry.coordinates;
                c[l].color && (k = c[l].color);
                "properties" in c[l] && "color" in c[l].properties && (k = c[l].properties.color);
                "[object Function]" === Object.prototype.toString.call(k) && (k = k(c[l]));
                k = this.normizedColor(k);
                n.length > g && (g = n.length);
                for (var m = 0; m < n.length - 1; m++) {
                  var p = this.normizedPoint(n[m]);
                  d.push(p[0]);
                  d.push(p[1]);
                  d.push(p[2]);
                  void 0 === n[m][3] ? d.push(m) : d.push(Number(n[m][3]));
                  d.push(k[0]);
                  d.push(k[1]);
                  d.push(k[2]);
                  d.push(k[3]);
                  p = this.normizedPoint(n[m + 1]);
                  d.push(p[0]);
                  d.push(p[1]);
                  d.push(p[2]);
                  void 0 === n[m + 1][3] ? d.push(m + 1) : d.push(Number(n[m + 1][3]));
                  d.push(k[0]);
                  d.push(k[1]);
                  d.push(k[2]);
                  d.push(k[3]);
                }
              }
              void 0 === a.endTime && (this.endTime = g);
              this.bufferData = d;
              this.f32BufferData = new Float32Array(d);
              b.bufferData(b.ARRAY_BUFFER, this.f32BufferData, b.STATIC_DRAW);
            }
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.matrix;
            a = this.getOptions();
            var d = this.program;
            d.use(c);
            c.uniformMatrix4fv(d.uniforms.u_matrix, !1, b);
            c.bindBuffer(c.ARRAY_BUFFER, this.buffer);
            b = this.f32BufferData.BYTES_PER_ELEMENT;
            c.enableVertexAttribArray(d.attributes.aPos);
            c.vertexAttribPointer(d.attributes.aPos, 4, c.FLOAT, !1, 8 * b, 0);
            c.enableVertexAttribArray(d.attributes.aColor);
            c.vertexAttribPointer(d.attributes.aColor, 4, c.FLOAT, !1, 8 * b, 4 * b);
            b = this.normizedColor(a.color);
            c.uniform3f(d.uniforms.uFragColor, b[0], b[1], b[2]);
            c.uniform1f(d.uniforms.currentTime, this.time);
            c.uniform1f(d.uniforms.trailLength, a.trailLength);
            this.setGLState({
              blend: !0,
              blendEquation: c.FUNC_ADD,
              blendFunc: "lighter" === a.blend ? [c.ONE, c.ONE] : [c.SRC_ALPHA, c.ONE],
              polygonOffset: a.polygonOffset,
              depthMask: !1
            });
            c.drawArrays(c.LINES, 0, this.bufferData.length / 8);
            this.time += a.step;
            this.time > this.endTime && (this.time = this.startTime);
          }
        }
      ]);
      return d;
    })(ca),
    km = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.name = "IconCollidesLayer";
        a.index = [];
        c = a.canvas = document.createElement("canvas");
        a.ctx = c.getContext("2d");
        a.iconHash = new Nb();
        a.boxHash = new Nb();
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { flat: !1, unit: "px", scale: 1, angle: 0, offset: [0, 0], padding: [0, 0] };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions();
            this.texture = null;
            this.lastUpdateTime = 0;
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;attribute vec3 a_pos;attribute float a_corner;attribute float a_rotation;attribute vec2 a_size;attribute vec2 a_offset;attribute vec2 a_texture_coord;uniform mat4 u_matrix;uniform vec2 u_size;uniform float devicePixelRatio;uniform float u_zoom_units;uniform float u_zIndex;uniform float u_scale;uniform bool u_unit_px;uniform bool u_flat;varying vec2 v_texture_coord;/***\u70b9A(x,y)\uff0c\u7ed5\u539f\u70b9\u987a\u65f6\u9488\u65cb\u8f6c\u89d2\u5ea6a\u65b0\u5750\u6807\u7684\u8ba1\u7b97\u516c\u5f0f*x1=x*cos(a)+y*sin(a)*y1=y*cos(a)-x*sin(a)*/vec3 transformCoord(vec3 coord,vec2 size,float corner){float x=coord.x;float y=coord.y;if(corner==1.0){x+=-size.x*cos(a_rotation)+size.y*sin(a_rotation);y+=size.y*cos(a_rotation)+size.x*sin(a_rotation);}else if(corner==2.0){x+=size.x*cos(a_rotation)+size.y*sin(a_rotation);y+=size.y*cos(a_rotation)-size.x*sin(a_rotation);}else if(corner==3.0){x+=size.x*cos(a_rotation)-size.y*sin(a_rotation);y+=-size.y*cos(a_rotation)-size.x*sin(a_rotation);}else{x+=-size.x*cos(a_rotation)-size.y*sin(a_rotation);y+=-size.y*cos(a_rotation)+size.x*sin(a_rotation);}return vec3(x,y,coord.z);}void main(){v_texture_coord=a_texture_coord;if(u_flat){vec2 offset=a_offset;vec2 halfSize=a_size/2.0*u_scale;if(u_unit_px){halfSize*=u_zoom_units;offset*=u_zoom_units;}vec3 current=transformCoord(a_pos,halfSize,a_corner);current.z+=u_zIndex;gl_Position=u_matrix*vec4(current.x+offset[0],current.y-offset[1],current.z,1.0);}else{vec4 position=u_matrix*vec4(a_pos,1.0);vec3 screen=position.xyz/position.w;vec2 halfSize=a_size/MAPV_resolution*devicePixelRatio*u_scale;vec2 offset=a_offset*2./MAPV_resolution*devicePixelRatio;if(!u_unit_px){halfSize/=u_zoom_units;offset/=u_zoom_units;}vec3 current=transformCoord(screen,halfSize,a_corner);current.xy=current.xy-offset;current.z+=u_zIndex;gl_Position=vec4(current,1.0);}}",
                fragmentShader:
                  "precision highp float;varying vec2 v_texture_coord;uniform sampler2D u_icon;uniform vec4 uSelectedColor;void main(){vec4 textureColor=texture2D(u_icon,vec2(v_texture_coord.x,1.0-v_texture_coord.y));if(textureColor.a==0.0&&uIsPickRender==false){discard;}gl_FragColor=textureColor;\n#if defined(PICK)\nif(mapvIsPicked()){gl_FragColor=vec4(uSelectedColor.rgb,gl_FragColor.a);}\n#endif\n}",
                defines: c.enablePicked ? ["PICK"] : []
              },
              this
            );
            this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.uvBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            c = [
              { name: "a_pos", buffer: this.vertexBuffer, size: 3, stride: 36, type: "FLOAT", offset: 0 },
              { name: "a_corner", buffer: this.vertexBuffer, size: 1, stride: 36, type: "FLOAT", offset: 12 },
              { name: "a_size", buffer: this.vertexBuffer, size: 2, stride: 36, type: "FLOAT", offset: 16 },
              { name: "a_offset", buffer: this.vertexBuffer, size: 2, stride: 36, type: "FLOAT", offset: 24 },
              { name: "a_rotation", buffer: this.vertexBuffer, size: 1, stride: 36, type: "FLOAT", offset: 32 },
              { name: "a_texture_coord", buffer: this.uvBuffer, size: 2, stride: 8, type: "FLOAT", offset: 0 }
            ];
            c = c.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: c });
          }
        },
        { key: "onDestroy", value: function () {} },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
            this.gl && ((this.cachedData = []), this.boxHash.clear(), this.processCache(a, c, b));
          }
        },
        {
          key: "processCache",
          value: function (a, c, b) {
            for (var d = this, f = a.icon, k = a.width, l = a.height, n = a.offset, m = a.angle, p = 0; p < c.length; p++) {
              var q = this.normizedPoint(c[p].geometry.coordinates),
                t = this.getProperty("icon", f, c[p]),
                v = this.getProperty("width", k, c[p]),
                r = this.getProperty("height", l, c[p]),
                u = this.getProperty("offset", n, c[p]),
                w = this.getProperty("angle", m, c[p]);
              q && t && (this.cachedData.push({ point: q, icon: t, width: v, height: r, offset: u, angle: w, dataIndex: p }), this.iconHash.get(t) || this.iconHash.set(t, t));
            }
            c = Ud(this.iconHash.entries())
              .filter(function (a) {
                return "string" === typeof a[1];
              })
              .map(function (a) {
                var c = da(a, 2)[0];
                return new Lb(function (a, b) {
                  d.url2canvas(c, function (b) {
                    d.iconHash.set(c, b);
                    a();
                  });
                });
              });
            Lb.all(c).then(function (c) {
              d.buildSprite(a);
              !1 !== b.autoRender && d.webglLayer && d.webglLayer.render();
            });
          }
        },
        {
          key: "buildSprite",
          value: function (a) {
            a = a.padding;
            var c = this.canvas,
              b = this.ctx,
              d = [],
              g = !0,
              k = !1,
              l = void 0;
            try {
              for (var n = gc(this.iconHash), m; !(g = (m = n.next()).done); g = !0) {
                var p = da(m.value, 2),
                  q = p[1];
                if ("string" !== typeof q) {
                  var t = q.width,
                    v = q.height;
                  d.push({ w: t + a[0], h: v + a[0], width: t, height: v, key: p[0], icon: q });
                }
              }
            } catch (r) {
              (k = !0), (l = r);
            } finally {
              try {
                !g && n.return && n.return();
              } finally {
                if (k) throw l;
              }
            }
            n = zb(d);
            for (m = 0; m < d.length; m++) (p = d[m]), this.boxHash.get(p.key) || this.boxHash.set(p.key, p);
            m = lb(n.w) || 1;
            n = lb(n.h) || 1;
            c.width = m;
            c.height = n;
            b.save();
            for (c = 0; c < d.length; c++) (n = d[c]), b.drawImage(n.icon, n.x + a[0], n.y + a[1], n.width, n.height);
            b.restore();
            this.loadTexture();
          }
        },
        {
          key: "render",
          value: function (a) {
            if (this.cachedData && this.cachedData.length && this.texture) {
              var c = a.gl,
                b = a.matrix,
                d = this.getOptions(),
                g = this.program;
              g.use(c);
              this.throttleUpdate(a);
              this.setGLState({ blend: !0, blendFunc: [c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA] });
              g.setUniforms(
                S(this.getCommonUniforms(a), {
                  u_icon: this.texture,
                  u_matrix: b,
                  u_flat: d.flat,
                  u_unit_px: "px" === d.unit,
                  u_zoom_units: this.map.getZoomUnits(),
                  u_scale: d.scale,
                  u_zIndex: d.zIndex,
                  devicePixelRatio: window.devicePixelRatio
                })
              );
              0 < this.index.length && (this.indexBuffer.bind(), this.vertexArray.bind(), c.drawElements(c.TRIANGLES, this.index.length, c.UNSIGNED_INT, 0));
            }
          }
        },
        {
          key: "throttleUpdate",
          value: function (a) {
            this.updateIcon(a);
          }
        },
        {
          key: "updateIcon",
          value: function (a) {
            if (this.iconHash.size && this.boxHash.size) {
              var c = this.getOptions(),
                b = a.gl;
              a = a.matrix;
              c = c.enablePicked;
              var d = [],
                g = [],
                k = [],
                l = [],
                n = this.canvas.width,
                m = this.canvas.height,
                p = b.canvas.width / window.devicePixelRatio;
              b = b.canvas.height / window.devicePixelRatio;
              for (var q = new qc(), t = 0, v = 0; v < this.cachedData.length; v++) {
                var r = this.cachedData[v],
                  u = r.point,
                  w = r.width,
                  y = r.height,
                  x = r.offset,
                  D = r.angle,
                  C = r.dataIndex;
                if ((r = this.boxHash.get(r.icon))) {
                  w = w || r.icon.width;
                  y = y || r.icon.height;
                  var A = da(u, 3);
                  u = A[0];
                  var E = A[1];
                  A = A[2];
                  var z = na.clone([u, E, A, 1]);
                  na.transformMat4(z, z, a);
                  na.scale(z, z, 1 / z[3]);
                  var B = ((z[0] + 1) / 2) * p - w / 2;
                  z = ((-z[1] + 1) / 2) * b - y / 2;
                  var M = B + w,
                    F = z + y;
                  if (!(0 > M || 0 > F || B > p || z > b || ((B = { minX: B, maxX: M, minY: z, maxY: F }), q.collides(B)))) {
                    q.insert(B);
                    for (B = 0; 4 > B; B++) d.push(u, E, A), d.push(B), d.push(w, y), d.push.apply(d, W(x)), d.push((D * Math.PI) / 180);
                    w = r.x / n;
                    y = (r.x + r.w) / n;
                    x = (r.y + r.h) / m;
                    r = r.y / m;
                    g.push(w, x, w, r, y, r, y, x);
                    r = 4 * t;
                    k.push(r, r + 2, r + 1, r, r + 3, r + 2);
                    c &&
                      ((C = this.indexToRgb(C)),
                      l.push(C[0] / 255, C[1] / 255, C[2] / 255),
                      l.push(C[0] / 255, C[1] / 255, C[2] / 255),
                      l.push(C[0] / 255, C[1] / 255, C[2] / 255),
                      l.push(C[0] / 255, C[1] / 255, C[2] / 255));
                    t += 1;
                  }
                }
              }
              this.index = k;
              this.vertexBuffer.updateData(new Float32Array(d));
              this.uvBuffer.updateData(new Float32Array(g));
              this.indexBuffer.updateData(new Uint32Array(k));
              c && this.pickBuffer.updateData(new Float32Array(l));
            }
          }
        },
        {
          key: "url2canvas",
          value: function (a, c) {
            if ("object" === ("undefined" === typeof a ? "undefined" : Ha(a))) c(a);
            else {
              var b = new Image();
              b.crossOrigin = "anonymous";
              b.onload = function () {
                var a = b.width,
                  d = b.height,
                  f = document.createElement("canvas");
                f.width = a;
                f.height = d;
                f.getContext("2d").drawImage(b, 0, 0, a, d);
                c(f);
              };
              b.onerror = function () {
                var a = document.createElement("canvas");
                a.width = 20;
                a.height = 40;
                var b = a.getContext("2d");
                b.fillStyle = "red";
                b.beginPath();
                b.lineTo(0, 0);
                b.lineTo(20, 0);
                b.lineTo(10, 40);
                b.closePath();
                b.fill();
                c(a);
              };
              b.src = a;
            }
          }
        },
        {
          key: "loadTexture",
          value: function () {
            var a = this;
            this.canvas
              ? ta(this.gl, this.canvas, function (c) {
                  a.texture = c;
                })
              : (this.texture = null);
          }
        }
      ]);
      return d;
    })(ca),
    wi = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.name = "LineFlowLayer";
        a.initData();
        a.date = new Date();
        a.autoUpdate = !0;
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              color: "rgba(25, 25, 250, 1)",
              blend: "normal",
              width: 2,
              antialias: !1,
              interval: 0.1,
              duration: 2,
              trailLength: 0.5,
              minZoom: 2,
              maxZoom: 25,
              polygonOffset: [0, 0]
            };
          }
        },
        {
          key: "initData",
          value: function () {
            this.dataMgr = { position: [], prev: [], next: [], direction: [], color: [], index: [], counter: [] };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions();
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "uniform mat4 u_matrix;uniform float thickness;uniform vec4 uSelectedColor;attribute vec3 position;attribute vec3 next;attribute vec3 previous;attribute float direction;attribute vec4 aColor;attribute float aCounter;attribute vec2 uv;varying vec4 vColor;varying vec2 vNormal;varying float vCounter;vec2 project(vec4 coord){vec3 screen=coord.xyz/coord.w;vec2 clip=(screen.xy+1.0)/2.0;return clip*MAPV_resolution;}vec4 unproject(vec2 projected,float z,float w){vec2 clip=projected/MAPV_resolution;vec2 screen=clip*2.0-1.0;return vec4(screen*w,z,w);}void main(){vColor=aColor;vCounter=aCounter;\n#if defined(PICK)\nif(mapvIsPicked()){vColor=uSelectedColor;}\n#endif\nvec4 previousProjected=u_matrix*vec4(previous,1.0);vec4 currentProjected=u_matrix*vec4(position,1.0);vec4 nextProjected=u_matrix*vec4(next,1.0);vec2 currentScreen=project(currentProjected);vec2 previousScreen=project(previousProjected);vec2 nextScreen=project(nextProjected);float len=thickness;float orientation=direction;vec2 dir=vec2(0.0);if(currentScreen==previousScreen){dir=normalize(nextScreen-currentScreen);}else if(currentScreen==nextScreen){dir=normalize(currentScreen-previousScreen);}else{vec2 dirA=normalize((currentScreen-previousScreen));vec2 dirB=normalize((nextScreen-currentScreen));vec2 tangent=normalize(dirA+dirB);vec2 perp=vec2(-dirA.y,dirA.x);vec2 miter=vec2(-tangent.y,tangent.x);dir=tangent;float angle=40.0;if(dot(dirA,dirB)>cos(radians(angle))){len=thickness/dot(miter,perp);}}vec2 normal=vec2(-dir.y,dir.x);vNormal=normal*orientation;normal*=len/2.0;vec2 pos=currentScreen+normal*orientation;vec4 finalPos=unproject(pos,currentProjected.z,currentProjected.w);gl_Position=finalPos;}",
                fragmentShader:
                  "precision highp float;uniform bool uAntialias;uniform bool uAnimate;uniform float uTime;uniform float duration;uniform float interval;uniform float trailLength;varying vec4 vColor;varying vec2 vNormal;varying float vCounter;void main(){vec4 color=vColor;if(uAntialias){float blur=1.0;blur=1.0-smoothstep(0.98,1.0,length(vNormal));color.a*=blur;}if(uAnimate){float alpha=1.0-fract(mod(1.0-vCounter,interval)*(1.0/interval)+uTime/duration);alpha=(alpha+trailLength-1.0)/trailLength;color.a*=alpha;}gl_FragColor=color;}",
                defines: c.enablePicked ? ["PICK"] : []
              },
              this
            );
            this.prevBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.currentBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.nextBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.directionBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.colorBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.counterBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            c = [
              { stride: 12, name: "previous", buffer: this.prevBuffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: 12, name: "position", buffer: this.currentBuffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: 12, name: "next", buffer: this.nextBuffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: 4, name: "direction", buffer: this.directionBuffer, size: 1, type: "FLOAT", offset: 0 },
              { stride: 16, name: "aColor", buffer: this.colorBuffer, size: 4, type: "FLOAT", offset: 0 },
              { stride: 4, name: "aCounter", buffer: this.counterBuffer, size: 1, type: "FLOAT", offset: 0 }
            ];
            c = c.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: c });
          }
        },
        { key: "onDestroy", value: function () {} },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this;
            if (this.gl) {
              this.initData();
              for (var d = 1, g = [], k = 0; k < c.length; k++) {
                var l = [],
                  n = c[k].geometry.coordinates;
                n &&
                  0 < n.length &&
                  (l =
                    "Polygon" === c[k].geometry.type
                      ? n[0].map(function (a) {
                          return b.normizedPoint(a);
                        })
                      : n.map(function (a) {
                          return b.normizedPoint(a);
                        }));
                l = qg(l);
                n = l.total;
                g[k] = l.arr;
                d = Math.max(n, d);
              }
              k = [];
              l = a.color;
              for (n = 0; n < c.length; n++) {
                var m = [],
                  p = c[n].geometry.coordinates;
                p &&
                  0 < p.length &&
                  (m =
                    "Polygon" === c[n].geometry.type
                      ? p[0].map(function (a) {
                          return b.normizedPoint(a);
                        })
                      : p.map(function (a) {
                          return b.normizedPoint(a);
                        }));
                p = l;
                "[object Function]" === Object.prototype.toString.call(p)
                  ? (p = p(c[n]))
                  : ((p = c[n].color || l), "properties" in c[n] && "color" in c[n].properties && (p = c[n].properties.color));
                p = this.normizedColor(p);
                for (var q = this.addMultipleCoords(m), t = 0; t < q.length; t++) this.processData(this.dataMgr, q[t], g[n], d, p);
                if (a.enablePicked)
                  for (p = this.indexToRgb(n), q = 0; q < m.length; q++)
                    k.push(p[0] / 255, p[1] / 255, p[2] / 255),
                      k.push(p[0] / 255, p[1] / 255, p[2] / 255),
                      a.repeat &&
                        (k.push(p[0] / 255, p[1] / 255, p[2] / 255),
                        k.push(p[0] / 255, p[1] / 255, p[2] / 255),
                        k.push(p[0] / 255, p[1] / 255, p[2] / 255),
                        k.push(p[0] / 255, p[1] / 255, p[2] / 255));
              }
              this.counterBuffer.updateData(new Float32Array(this.dataMgr.counter));
              this.currentBuffer.updateData(new Float32Array(this.dataMgr.position));
              this.prevBuffer.updateData(new Float32Array(this.dataMgr.prev));
              this.nextBuffer.updateData(new Float32Array(this.dataMgr.next));
              this.directionBuffer.updateData(new Float32Array(this.dataMgr.direction));
              this.colorBuffer.updateData(new Float32Array(this.dataMgr.color));
              this.indexBuffer.updateData(new Uint32Array(this.dataMgr.index));
              a.enablePicked && this.pickBuffer.updateData(new Float32Array(k));
            }
          }
        },
        {
          key: "processData",
          value: function (a, c, b, d, g) {
            var f,
              h,
              n,
              m,
              p,
              q,
              t,
              v = c.length,
              r = a.position.length / 6;
            b = Ra(
              b.map(function (a) {
                return a / d;
              })
            );
            var u = Ra(
                c.map(function (a) {
                  return -1;
                }),
                !0
              ),
              w = Ra(c),
              y = Ra(c.map(Bd(-1))),
              x = Ra(c.map(Bd(1)));
            c = Ra(
              c.map(function (a) {
                return g;
              })
            );
            v = pg(v, r);
            (f = a.counter).push.apply(f, W(b));
            (h = a.position).push.apply(h, W(db(w)));
            (n = a.prev).push.apply(n, W(db(y)));
            (m = a.next).push.apply(m, W(db(x)));
            (p = a.direction).push.apply(p, W(u));
            (q = a.color).push.apply(q, W(db(c)));
            (t = a.index).push.apply(t, W(v));
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.matrix,
              d = this.dataMgr;
            if (d && !(0 >= d.index.length)) {
              var g = this.getOptions(),
                k = this.program;
              k.use(c);
              if (this.map) {
                var l = this.map.getZoom();
                l = l >= g.minZoom && l <= g.maxZoom && this.autoUpdate ? !0 : !1;
              } else l = !0;
              k.setUniforms(
                S(this.getCommonUniforms(a), {
                  u_matrix: b,
                  thickness: g.width,
                  uAntialias: g.antialias,
                  uTime: (new Date() - this.date) / 1e3,
                  uAnimate: l,
                  duration: g.duration,
                  interval: g.interval,
                  trailLength: g.trailLength
                })
              );
              this.setGLState({
                blend: !0,
                blendEquation: c.FUNC_ADD,
                blendFunc: "lighter" === g.blend ? [c.SRC_ALPHA, c.ONE] : [c.SRC_ALPHA, c.ONE_MINUS_SRC_ALPHA],
                polygonOffset: g.polygonOffset
              });
              this.indexBuffer.bind();
              this.vertexArray.bind();
              c.drawElements(c.TRIANGLES, d.index.length, c.UNSIGNED_INT, 0);
            }
          }
        }
      ]);
      return d;
    })(ca),
    lm = (function (b) {
      function d(a, c) {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).call(this, a, c));
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {};
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions();
            this.texture = null;
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;attribute vec3 a_pos;attribute vec2 a_texture_coord;uniform sampler2D uTerrain;uniform mat4 u_proj_matrix;uniform mat4 u_mv_matrix;varying vec2 v_texture_coord;void main(){v_texture_coord=a_texture_coord;vec3 pos=a_pos.xyz;\n#if defined(TERRAIN)\nvec4 terrainColor=texture2D(uTerrain,vec2(v_texture_coord.s,v_texture_coord.t));vec3 rgb=terrainColor.rgb*256.0;pos.z=-10000.0+((rgb.r*256.0*256.0+rgb.g*256.0+rgb.b)*0.1);pos.z=pos.z-60.0;\n#endif\nvec4 position=u_proj_matrix*u_mv_matrix*vec4(pos,1.0);gl_Position=position;}",
                fragmentShader:
                  "precision highp float;varying vec2 v_texture_coord;uniform sampler2D uTile;uniform bool uUseFilter;uniform vec4 uFilterColor;void main(){vec4 textureColor=texture2D(uTile,vec2(v_texture_coord.s,v_texture_coord.t));if(uUseFilter){textureColor=textureColor*uFilterColor;}gl_FragColor=textureColor;}",
                defines: c.terrain ? ["TERRAIN"] : ""
              },
              this
            );
            this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.vertexArray = new fa({
              gl: a,
              program: this.program,
              attributes: [
                { name: "a_pos", buffer: this.vertexBuffer, stride: 20, size: 3, type: "FLOAT", offset: 0 },
                { name: "a_texture_coord", buffer: this.vertexBuffer, size: 2, stride: 20, type: "FLOAT", offset: 12 }
              ]
            });
          }
        },
        {
          key: "onChanged",
          value: function (a, c) {
            var b = this;
            this.gl &&
              (this.loadTextureTime && clearTimeout(this.loadTextureTime),
              (this.loadTextureTime = setTimeout(function () {
                b.loadTexture(function () {
                  b.parseData(c);
                  b.dataTime = new Date();
                  b.webglLayer.render();
                });
              }, 0)));
          }
        },
        {
          key: "render",
          value: function (a) {
            var c = a.gl,
              b = a.projectionMatrix;
            a = a.viewMatrix;
            var d = this.getOptions(),
              g = this.program,
              k = g.uniforms;
            g.use(c);
            this.texture &&
              (c.activeTexture(c.TEXTURE0),
              c.uniform1i(k.uTile, 0),
              c.bindTexture(c.TEXTURE_2D, this.texture),
              c.activeTexture(c.TEXTURE1),
              c.uniform1i(k.uTerrain, 1),
              c.bindTexture(c.TEXTURE_2D, this.terrainSampler),
              this.setGLState({ cullFace: !1 }),
              g.setUniforms({ u_proj_matrix: b, uUseFilter: !!d.filterColor, uFilterColor: this.normizedColor(d.filterColor || "rgba(0, 0, 100, 1.0)"), u_mv_matrix: a }),
              0 < this.index.length && (this.indexBuffer.bind(), this.vertexArray.bind(), c.drawElements(c.TRIANGLES, this.index.length, c.UNSIGNED_INT, 0)));
          }
        },
        {
          key: "loadTexture",
          value: function (a) {
            var c = this,
              b = this.getOptions();
            b.tile
              ? b.terrain
                ? ta(
                    this.gl,
                    b.terrain,
                    function (d, f) {
                      c.terrainSampler = d;
                      ta(c.gl, b.tile, function (b, d) {
                        c.texture = b;
                        a && a();
                        c.webglLayer.render();
                      });
                    },
                    { TEXTURE_WRAP_S: "MIRRORED_REPEAT", TEXTURE_WRAP_T: "MIRRORED_REPEAT" }
                  )
                : ta(this.gl, b.tile, function (b, d) {
                    c.texture = b;
                    a && a();
                    c.webglLayer.render();
                  })
              : ((this.texture = null), a && a());
          }
        },
        {
          key: "parseData",
          value: function (a) {
            var c = this,
              b = [],
              d = [];
            if (a && a[0]) {
              var g = a[0].geometry.coordinates[0];
              g = g.map(function (a) {
                return c.normizedPoint(a);
              });
              a = g[0][0];
              var k = g[0][1],
                l = g[0][2],
                n = (g[2][0] - a) / 16;
              g = (g[2][1] - k) / 16;
              for (var m = 0; 16 >= m; m++)
                for (var p = 0; 16 >= p; p++)
                  if ((b.push(a + n * p, k + g * m, l), b.push(p / 16, m / 16), 16 > p && 16 > m)) {
                    var q = 17 * m + p,
                      t = 17 * (m + 1) + p;
                    d.push(q, t + 1, q + 1);
                    d.push(q, t, t + 1);
                  }
            }
            this.index = d;
            this.vertexBuffer.updateData(new Float32Array(b));
            this.indexBuffer.updateData(new Uint32Array(d));
          }
        }
      ]);
      return d;
    })(ca),
    mm = (function (b) {
      function d(a, c) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, c));
        a.name = "BoardLayer";
        a.index = [];
        c = a.canvas = document.createElement("canvas");
        a.ctx = c.getContext("2d");
        a.iconHash = new Nb();
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { unit: "px", scale: 1, angle: 0, offsetZ: 0, padding: [0, 0], polygonOffset: [0, 0], enableColorMix: !1, mixColor: "#fff", mixAmount: 0.5 };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var c = this.getOptions();
            this.texture = null;
            this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.uvBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            var b = [
              { name: "a_pos", buffer: this.vertexBuffer, size: 3, stride: 32, type: "FLOAT", offset: 0 },
              { name: "a_corner", buffer: this.vertexBuffer, size: 1, stride: 32, type: "FLOAT", offset: 12 },
              { name: "a_size", buffer: this.vertexBuffer, size: 2, stride: 32, type: "FLOAT", offset: 16 },
              { name: "a_offsetZ", buffer: this.vertexBuffer, size: 1, stride: 32, type: "FLOAT", offset: 24 },
              { name: "a_rotation", buffer: this.vertexBuffer, size: 1, stride: 32, type: "FLOAT", offset: 28 },
              { name: "a_texture_coord", buffer: this.uvBuffer, size: 2, stride: 8, type: "FLOAT", offset: 0 }
            ];
            b = b.concat(this.getCommonAttributes());
            var d = [];
            c.enablePicked && d.push("PICK");
            this.options.enableColorMix &&
              ((this.colorBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" })),
              b.push({ stride: 16, name: "a_color", buffer: this.colorBuffer, size: 4, type: "FLOAT", offset: 0 }),
              d.push("USE_COLOR_MIX"));
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;attribute vec3 a_pos;attribute float a_corner;attribute float a_rotation;attribute float a_offsetZ;attribute vec2 a_size;attribute vec2 a_texture_coord;\n#if defined(USE_COLOR_MIX)\nattribute vec4 a_color;\n#endif\nuniform mat4 u_matrix;uniform vec2 u_size;uniform float u_zoom_units;uniform float u_scale;uniform bool u_unit_px;varying vec2 v_texture_coord;varying vec4 v_color;/***\u4e09\u7ef4\u7a7a\u95f4\u5185\uff0c\u7ed5Z\u8f74\u65cb\u8f6c\u7684\u77e9\u9635\uff0c\u53f3\u624b\u5750\u6807\u7cfb\u4e0b*[x'][cos0-sin0  0  0]*[y']=[sin0 cos0   0  0]*[z'][0     0     1  0]*[1][0     0     0  1]*/mat3 rotateZ(float angle){float cos0=cos(angle);float sin0=sin(angle);return mat3(cos0,sin0,0.,-sin0,cos0,0.,0.,0.,1.);}vec3 transformCoord(vec3 coord,vec2 size,float corner){float x=coord.x;float y=coord.y;float z=coord.z;mat3 mat=rotateZ(a_rotation);vec3 rotated=vec3(size[0],0.0,size[1]);if(corner==1.0){rotated=mat*vec3(-size[0],0.0,size[1]);}else if(corner==2.0){rotated=mat*vec3(size[0],0.0,size[1]);}else if(corner==3.0){rotated=mat*vec3(size[0],0.0,-size[1]);}else{rotated=mat*vec3(-size[0],0.0,-size[1]);}x+=rotated.x;y+=rotated.y;z+=rotated.z;return vec3(x,y,z);}void main(){\n#if defined(USE_COLOR_MIX)\nv_color=a_color;\n#endif\nv_texture_coord=a_texture_coord;vec2 halfSize=a_size/2.0*u_scale;if(u_unit_px){halfSize*=u_zoom_units;}vec3 current=transformCoord(a_pos,halfSize,a_corner);current.z+=a_offsetZ;gl_Position=u_matrix*vec4(current,1.0);}",
                fragmentShader:
                  "precision highp float;varying vec2 v_texture_coord;varying vec4 v_color;uniform sampler2D u_icon;uniform vec4 uSelectedColor;\n#if defined(USE_COLOR_MIX)\nuniform float u_mix_amount;\n#endif\nvoid main(){vec4 textureColor=texture2D(u_icon,vec2(v_texture_coord.x,1.0-v_texture_coord.y));if(textureColor.a==0.0&&uIsPickRender==false){discard;}gl_FragColor=textureColor;\n#if defined(USE_COLOR_MIX)\ngl_FragColor=mix(gl_FragColor,v_color,u_mix_amount);\n#endif\n#if defined(PICK)\nif(mapvIsPicked()){gl_FragColor=vec4(uSelectedColor.rgb,gl_FragColor.a);}\n#endif\n}",
                defines: d
              },
              this
            );
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: b });
          }
        },
        { key: "onDestroy", value: function () {} },
        {
          key: "onChanged",
          value: function (a, c) {
            this.gl && this.processCache(a, c);
          }
        },
        {
          key: "forceUpdate",
          value: function () {
            this.gl && this.processCache(this.options, this.data);
          }
        },
        {
          key: "processCache",
          value: function (a, c) {
            var b = this;
            this.cachedData = [];
            for (var d = a.icon, g = a.width, k = a.height, l = a.offsetZ, n = a.angle, m = a.mixColor, p = 0; p < c.length; p++) {
              var q = this.normizedPoint(c[p].geometry.coordinates),
                t = this.getProperty("icon", d, c[p]),
                v = this.getProperty("width", g, c[p]),
                r = this.getProperty("height", k, c[p]),
                u = this.getProperty("angle", n, c[p]),
                w = this.getProperty("offsetZ", l, c[p]),
                y = this.normizedColor(this.getProperty("mixColor", m, c[p]));
              q &&
                t &&
                (this.cachedData.push({ point: q, icon: t, width: v, height: r, offsetZ: w, angle: u, mixColor: y, index: p }), this.iconHash.get(t) || this.iconHash.set(t, t));
            }
            c = Ud(this.iconHash.entries())
              .filter(function (a) {
                return "string" === typeof a[1];
              })
              .map(function (a) {
                var c = da(a, 2)[0];
                return new Lb(function (a, d) {
                  b.url2canvas(c, function (d) {
                    b.iconHash.set(c, d);
                    a();
                  });
                });
              });
            Lb.all(c).then(function (c) {
              b.buildSprite(a);
              b.webglLayer.render();
            });
          }
        },
        {
          key: "buildSprite",
          value: function (a) {
            var c = a.padding,
              b = this.canvas,
              d = this.ctx,
              g = [],
              k = new Nb(),
              l = !0,
              n = !1,
              m = void 0;
            try {
              for (var p = gc(this.iconHash), q; !(l = (q = p.next()).done); l = !0) {
                var t = da(q.value, 2),
                  v = t[1];
                if ("string" !== typeof v) {
                  var r = v.width,
                    u = v.height;
                  g.push({ w: r + c[0], h: u + c[0], width: r, height: u, key: t[0], icon: v });
                }
              }
            } catch (w) {
              (n = !0), (m = w);
            } finally {
              try {
                !l && p.return && p.return();
              } finally {
                if (n) throw m;
              }
            }
            n = zb(g);
            for (l = 0; l < g.length; l++) (m = g[l]), k.get(m.key) || k.set(m.key, m);
            l = lb(n.w);
            n = lb(n.h);
            b.width = l || 1;
            b.height = n || 1;
            d.save();
            for (b = 0; b < g.length; b++) (m = g[b]), d.drawImage(m.icon, m.x + c[0], m.y + c[1], m.width, m.height);
            d.restore();
            this.loadTexture();
            this.buildVertex(a, k, l, n);
          }
        },
        {
          key: "buildVertex",
          value: function (a, b, d, h) {
            var c = a.enablePicked;
            a = a.enableColorMix;
            for (var f = [], l = [], n = [], m = [], p = [], q = 0; q < this.cachedData.length; q++) {
              var t = this.cachedData[q],
                v = t.point,
                r = t.width,
                u = t.height,
                w = t.offsetZ,
                y = t.angle,
                x = t.mixColor,
                D = t.index;
              if ((t = b.get(t.icon))) {
                r = r || t.icon.width;
                u = u || t.icon.height;
                var C = da(v, 3);
                v = C[0];
                var A = C[1];
                C = C[2];
                for (var z = 0; 4 > z; z++) f.push(v, A, C), f.push(z), f.push(r, u), f.push(w), f.push((y * Math.PI) / 180);
                r = t.x / d;
                u = (t.x + t.w) / d;
                w = (t.y + t.h) / h;
                t = t.y / h;
                l.push(r, w, r, t, u, t, u, w);
                t = 4 * q;
                n.push(t, t + 2, t + 1, t, t + 3, t + 2);
                c &&
                  ((D = this.indexToRgb(D)),
                  m.push(D[0] / 255, D[1] / 255, D[2] / 255),
                  m.push(D[0] / 255, D[1] / 255, D[2] / 255),
                  m.push(D[0] / 255, D[1] / 255, D[2] / 255),
                  m.push(D[0] / 255, D[1] / 255, D[2] / 255));
                a && (p.push.apply(p, W(x)), p.push.apply(p, W(x)), p.push.apply(p, W(x)), p.push.apply(p, W(x)));
              }
            }
            this.index = n;
            this.vertexBuffer.updateData(new Float32Array(f));
            this.uvBuffer.updateData(new Float32Array(l));
            this.indexBuffer.updateData(new Uint32Array(n));
            c && this.pickBuffer.updateData(new Float32Array(m));
            a && this.colorBuffer.updateData(new Float32Array(p));
          }
        },
        {
          key: "render",
          value: function (a) {
            if (this.cachedData && this.cachedData.length && this.iconHash && this.texture) {
              var b = a.gl,
                d = a.matrix,
                h = this.getOptions(),
                g = this.program;
              g.use(b);
              this.setGLState({ blend: !0, blendFunc: Va(b, h.blend), polygonOffset: h.polygonOffset });
              a = S(this.getCommonUniforms(a), { u_icon: this.texture, u_matrix: d, u_unit_px: "px" === h.unit, u_zoom_units: this.map.getZoomUnits(), u_scale: h.scale });
              h.enableColorMix && (a = S(a, { u_mix_amount: h.mixAmount }));
              g.setUniforms(a);
              0 < this.index.length && (this.indexBuffer.bind(), this.vertexArray.bind(), b.drawElements(b.TRIANGLES, this.index.length, b.UNSIGNED_INT, 0));
            }
          }
        },
        {
          key: "url2canvas",
          value: function (a, b) {
            if ("object" === ("undefined" === typeof a ? "undefined" : Ha(a))) b(a);
            else {
              var c = new Image();
              c.crossOrigin = "anonymous";
              c.onload = function () {
                var a = c.width,
                  d = c.height,
                  f = document.createElement("canvas");
                f.width = a;
                f.height = d;
                f.getContext("2d").drawImage(c, 0, 0, a, d);
                b(f);
              };
              c.onerror = function () {
                var a = document.createElement("canvas");
                a.width = 20;
                a.height = 40;
                var c = a.getContext("2d");
                c.fillStyle = "red";
                c.beginPath();
                c.lineTo(0, 0);
                c.lineTo(20, 0);
                c.lineTo(10, 40);
                c.closePath();
                c.fill();
                b(a);
              };
              c.src = a;
            }
          }
        },
        {
          key: "loadTexture",
          value: function () {
            var a = this;
            this.canvas
              ? ta(this.gl, this.canvas, function (b) {
                  a.texture = b;
                })
              : (this.texture = null);
          }
        }
      ]);
      return d;
    })(ca),
    nm = (function (b) {
      function d(a) {
        F(this, d);
        var b = Q(this, (d.__proto__ || N(d)).call(this, a));
        a = b.getOptions();
        b.shapeLayer = new Zd({ enablePicked: a.enablePicked });
        b.lineLayer = new sf();
        b.children = [b.shapeLayer, b.lineLayer];
        return b;
      }
      R(d, b);
      I(d, [
        {
          key: "pick",
          value: function (a, b) {
            return this.shapeLayer.pick(a, b);
          }
        },
        {
          key: "onOptionsChanged",
          value: function (a) {
            this.shapeLayer.setOptions({
              onClick: function (b) {
                a.onClick && a.onClick(b);
              },
              selectedIndex: a.selectedIndex,
              selectedColor: a.selectedColor,
              height: 0,
              polygonOffset: [2, 2],
              depthTest: a.depthTest,
              autoSelect: a.autoSelect,
              color: a.fillColor,
              opacity: a.fillOpacity,
              topColor: a.fillColor,
              useLight: !1,
              blend: a.blend
            });
            this.lineLayer.setOptions({ depthTest: a.depthTest, dashArray: a.dashArray, color: a.lineColor, width: a.lineWidth, lineJoin: a.lineJoin, blend: a.blend });
          }
        },
        {
          key: "onDataChanged",
          value: function (a) {
            this.shapeLayer.setData(a);
            this.lineLayer.setData(a, { closePath: !0 });
          }
        },
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              enablePicked: !1,
              selectedIndex: -1,
              selectedColor: "#ff0000",
              autoSelect: !0,
              dashArray: [0, 0],
              lineColor: "rgba(250, 250, 25, 1)",
              depthTest: !0,
              lineWidth: 2,
              lineJoin: "miter",
              fillColor: "rgba(25, 25, 250, 1)",
              fillOpacity: 1,
              blend: "default"
            };
          }
        }
      ]);
      return d;
    })(jb),
    la = la || {},
    xi = 0,
    $a = null,
    om = (la.Scene = function (b, d) {
      this.name = void 0 !== d.name ? d.name : null;
      this.nodes = Array(d.nodes.length);
      for (var a = 0, c = d.nodes.length; a < c; a++) this.nodes[a] = b.nodes[d.nodes[a]];
      this.extensions = void 0 !== d.extensions ? d.extensions : null;
      this.extras = void 0 !== d.extras ? d.extras : null;
      this.boundingBox = null;
    }),
    ub = (la.BoundingBox = function (b, d, a) {
      b = b || P.fromValues(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY);
      d = d || P.fromValues(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);
      void 0 === a || !0 === a ? ((this.min = P.clone(b)), (this.max = P.clone(d))) : ((this.min = b), (this.max = d));
      this.transform = L.create();
    });
  ub.prototype.updateBoundingBox = function (b) {
    P.min(this.min, this.min, b.min);
    P.max(this.max, this.max, b.max);
  };
  ub.prototype.calculateTransform = function () {
    this.transform[0] = this.max[0] - this.min[0];
    this.transform[5] = this.max[1] - this.min[1];
    this.transform[10] = this.max[2] - this.min[2];
    this.transform[12] = this.min[0];
    this.transform[13] = this.min[1];
    this.transform[14] = this.min[2];
  };
  ub.getAABBFromOBB = (function () {
    var b = P.create(),
      d = P.create(),
      a = P.create(),
      c = P.create(),
      f = P.create();
    return function (h, g) {
      P.set(b, g[0], g[1], g[2]);
      P.set(d, g[4], g[5], g[6]);
      P.set(a, g[8], g[9], g[10]);
      g = P.fromValues(g[12], g[13], g[14]);
      var k = P.clone(g);
      P.scale(c, b, h.min[0]);
      P.scale(f, b, h.max[0]);
      P.min(b, c, f);
      P.add(g, g, b);
      P.max(b, c, f);
      P.add(k, k, b);
      P.scale(c, d, h.min[1]);
      P.scale(f, d, h.max[1]);
      P.min(d, c, f);
      P.add(g, g, d);
      P.max(d, c, f);
      P.add(k, k, d);
      P.scale(c, a, h.min[2]);
      P.scale(f, a, h.max[2]);
      P.min(a, c, f);
      P.add(g, g, a);
      P.max(a, c, f);
      P.add(k, k, a);
      h = new ub(g, k, !1);
      h.calculateTransform();
      return h;
    };
  })();
  var yi = (la.Accessor = function (b, d) {
    this.bufferView = d;
    this.componentType = b.componentType;
    this.byteOffset = void 0 !== b.byteOffset ? b.byteOffset : 0;
    this.byteStride = d.byteStride;
    this.normalized = void 0 !== b.normalized ? b.normalized : !1;
    this.count = b.count;
    this.type = b.type;
    this.size = Ae[this.type];
    this.min = b.min;
    this.max = b.max;
    this.extensions = void 0 !== b.extensions ? b.extensions : null;
    this.extras = void 0 !== b.extras ? b.extras : null;
  });
  yi.prototype.prepareVertexAttrib = function (b, d) {
    d.vertexAttribPointer(b, this.size, this.componentType, this.normalized, this.byteStride, this.byteOffset);
    d.enableVertexAttribArray(b);
  };
  var Hf = (la.BufferView = function (b, d) {
    this.byteLength = b.byteLength;
    this.byteOffset = void 0 !== b.byteOffset ? b.byteOffset : 0;
    this.byteStride = void 0 !== b.byteStride ? b.byteStride : 0;
    this.target = void 0 !== b.target ? b.target : null;
    this.data = d.slice(this.byteOffset, this.byteOffset + this.byteLength);
    this.extensions = void 0 !== b.extensions ? b.extensions : null;
    this.extras = void 0 !== b.extras ? b.extras : null;
    this.buffer = null;
  });
  Hf.prototype.createBuffer = function (b) {
    this.buffer = b.createBuffer();
  };
  Hf.prototype.bindData = function (b) {
    return this.target ? (b.bindBuffer(this.target, this.buffer), b.bufferData(this.target, this.data, b.STATIC_DRAW), b.bindBuffer(this.target, null), !0) : !1;
  };
  var pm = (la.Camera = function (b) {
      this.name = void 0 !== b.name ? b.name : null;
      this.type = b.type;
      this.othographic = void 0 === b.othographic ? null : b.othographic;
      this.perspective =
        void 0 === b.perspective
          ? null
          : {
              yfov: b.perspective.yfov,
              znear: b.perspective.znear,
              zfar: void 0 !== b.perspective.zfar ? b.perspective.zfar : null,
              aspectRatio: void 0 !== b.perspective.aspectRatio ? b.perspective.aspectRatio : null
            };
      this.extensions = void 0 !== b.extensions ? b.extensions : null;
      this.extras = void 0 !== b.extras ? b.extras : null;
    }),
    vc = (la.Node = function (b, d) {
      this.name = void 0 !== b.name ? b.name : null;
      this.nodeID = d;
      this.camera = void 0 !== b.camera ? b.camera : null;
      this.matrix = L.create();
      if (b.hasOwnProperty("matrix")) {
        for (d = 0; 16 > d; ++d) this.matrix[d] = b.matrix[d];
        this.translation = P.create();
        L.getTranslation(this.translation, this.matrix);
        this.rotation = Ed.create();
        L.getRotation(this.rotation, this.matrix);
        this.scale = P.create();
        L.getScaling(this.scale, this.matrix);
      } else this.getTransformMatrixFromTRS(b.translation, b.rotation, b.scale);
      this.children = b.children || [];
      this.mesh = void 0 !== b.mesh ? $a.glTF.meshes[b.mesh] : null;
      this.skin = void 0 !== b.skin ? b.skin : null;
      void 0 !== b.extensions &&
        void 0 !== b.extensions.gl_avatar &&
        !0 === $a.enableGLAvatar &&
        (this.skin = new qm(
          $a.glTF,
          $a.skeletonGltf.skins[$a.skeletonGltf.json.extensions.gl_avatar.skins[b.extensions.gl_avatar.skin.name]],
          b.extensions.gl_avatar.skin.inverseBindMatrices
        ));
      this.weights = void 0 !== b.weights ? b.weights : null;
      this.extensions = void 0 !== b.extensions ? b.extensions : null;
      this.extras = void 0 !== b.extras ? b.extras : null;
      this.aabb = null;
      this.bvh = new ub();
    });
  vc.prototype.traverse = function (b, d) {
    d(this, b);
    b = 0;
    for (var a = this.children.length; b < a; b++) this.children[b].traverse(this, d);
  };
  vc.prototype.traversePostOrder = function (b, d) {
    for (var a = 0, c = this.children.length; a < c; a++) this.children[a].traversePostOrder(this, d);
    d(this, b);
  };
  vc.prototype.traverseTwoExecFun = function (b, d, a) {
    d(this, b);
    for (var c = 0, f = this.children.length; c < f; c++) this.children[c].traverseTwoExecFun(this, d, a);
    a(this, b);
  };
  var zi = L.create();
  vc.prototype.getTransformMatrixFromTRS = function (b, d, a) {
    this.translation = void 0 !== b ? P.fromValues(b[0], b[1], b[2]) : P.fromValues(0, 0, 0);
    this.rotation = void 0 !== d ? na.fromValues(d[0], d[1], d[2], d[3]) : na.fromValues(0, 0, 0, 1);
    this.scale = void 0 !== a ? P.fromValues(a[0], a[1], a[2]) : P.fromValues(1, 1, 1);
    this.updateMatrixFromTRS();
  };
  vc.prototype.updateMatrixFromTRS = function () {
    L.fromRotationTranslation(zi, this.rotation, this.translation);
    L.scale(this.matrix, zi, this.scale);
  };
  var sm = (la.Mesh = function (b, d) {
      this.meshID = d;
      this.name = void 0 !== b.name ? b.name : null;
      this.primitives = [];
      this.boundingBox = null;
      d = 0;
      for (var a = b.primitives.length; d < a; ++d) {
        var c = b.primitives[d];
        c = new rm($a.glTF, c);
        this.primitives.push(c);
        c.boundingBox && (this.boundingBox || (this.boundingBox = new ub()), this.boundingBox.updateBoundingBox(c.boundingBox));
      }
      this.boundingBox && this.boundingBox.calculateTransform();
      this.weights = void 0 !== b.weights ? b.weights : null;
      this.extensions = void 0 !== b.extensions ? b.extensions : null;
      this.extras = void 0 !== b.extras ? b.extras : null;
    }),
    rm = (la.Primitive = function (b, d) {
      this.attributes = d.attributes;
      this.indices = void 0 !== d.indices ? d.indices : null;
      var a;
      if (void 0 !== d.extensions && void 0 !== d.extensions.gl_avatar && !0 === $a.enableGLAvatar && d.extensions.gl_avatar.attributes)
        for (a in d.extensions.gl_avatar.attributes) this.attributes[a] = d.extensions.gl_avatar.attributes[a];
      null !== this.indices
        ? ((this.indicesComponentType = b.json.accessors[this.indices].componentType),
          (this.indicesLength = b.json.accessors[this.indices].count),
          (this.indicesOffset = b.json.accessors[this.indices].byteOffset || 0))
        : ((this.drawArraysCount = b.json.accessors[this.attributes.POSITION].count), (this.drawArraysOffset = b.json.accessors[this.attributes.POSITION].byteOffset || 0));
      for (a in this.attributes) this.attributes[a] = b.accessors[this.attributes[a]];
      this.material = void 0 !== d.material ? b.materials[d.material] : null;
      this.mode = void 0 !== d.mode ? d.mode : 4;
      this.targets = d.targets;
      this.extensions = void 0 !== d.extensions ? d.extensions : null;
      this.extras = void 0 !== d.extras ? d.extras : null;
      this.boundingBox = this.shader = this.indexBuffer = this.vertexBuffer = this.vertexArray = null;
      void 0 !== this.attributes.POSITION &&
        ((b = this.attributes.POSITION),
        b.max &&
          "VEC3" === b.type &&
          ((this.boundingBox = new ub(P.fromValues(b.min[0], b.min[1], b.min[2]), P.fromValues(b.max[0], b.max[1], b.max[2]), !1)), this.boundingBox.calculateTransform()));
    }),
    Ai = (la.Texture = function (b) {
      this.name = void 0 !== b.name ? b.name : null;
      this.sampler = void 0 !== b.sampler ? $a.glTF.samplers[b.sampler] : null;
      this.source = void 0 !== b.source ? $a.glTF.images[b.source] : null;
      this.extensions = void 0 !== b.extensions ? b.extensions : null;
      this.extras = void 0 !== b.extras ? b.extras : null;
      this.texture = null;
    });
  Ai.prototype.createTexture = function (b) {
    this.texture = b.createTexture();
    b.bindTexture(b.TEXTURE_2D, this.texture);
    b.texImage2D(b.TEXTURE_2D, 0, b.RGBA, b.RGBA, b.UNSIGNED_BYTE, this.source);
    b.generateMipmap(b.TEXTURE_2D);
    b.bindTexture(b.TEXTURE_2D, null);
  };
  var Bi = (la.Sampler = function (b) {
    this.name = void 0 !== b.name ? b.name : null;
    this.magFilter = void 0 !== b.magFilter ? b.magFilter : null;
    this.minFilter = void 0 !== b.minFilter ? b.minFilter : null;
    this.wrapS = void 0 !== b.wrapS ? b.wrapS : 10497;
    this.wrapT = void 0 !== b.wrapT ? b.wrapT : 10497;
    this.extensions = void 0 !== b.extensions ? b.extensions : null;
    this.extras = void 0 !== b.extras ? b.extras : null;
    this.sampler = null;
  });
  Bi.prototype.createSampler = function (b) {
    this.sampler = b.createSampler();
    this.minFilter ? b.samplerParameteri(this.sampler, b.TEXTURE_MIN_FILTER, this.minFilter) : b.samplerParameteri(this.sampler, b.TEXTURE_MIN_FILTER, b.NEAREST_MIPMAP_LINEAR);
    this.magFilter ? b.samplerParameteri(this.sampler, b.TEXTURE_MAG_FILTER, this.magFilter) : b.samplerParameteri(this.sampler, b.TEXTURE_MAG_FILTER, b.LINEAR);
    b.samplerParameteri(this.sampler, b.TEXTURE_WRAP_S, this.wrapS);
    b.samplerParameteri(this.sampler, b.TEXTURE_WRAP_T, this.wrapT);
  };
  var If = (la.TextureInfo = function (b) {
      this.index = b.index;
      this.texCoord = void 0 !== b.texCoord ? b.texCoord : 0;
      this.extensions = void 0 !== b.extensions ? b.extensions : null;
      this.extras = void 0 !== b.extras ? b.extras : null;
    }),
    Ci = (la.PbrMetallicRoughness = function (b) {
      this.baseColorFactor = void 0 !== b.baseColorFactor ? b.baseColorFactor : [1, 1, 1, 1];
      this.baseColorTexture = void 0 !== b.baseColorTexture ? new If(b.baseColorTexture) : null;
      this.metallicFactor = void 0 !== b.metallicFactor ? b.metallicFactor : 1;
      this.roughnessFactor = void 0 !== b.roughnessFactor ? b.roughnessFactor : 1;
      this.metallicRoughnessTexture = void 0 !== b.metallicRoughnessTexture ? new If(b.metallicRoughnessTexture) : null;
      this.extensions = void 0 !== b.extensions ? b.extensions : null;
      this.extras = void 0 !== b.extras ? b.extras : null;
    }),
    tm = (la.NormalTextureInfo = function (b) {
      this.index = b.index;
      this.texCoord = void 0 !== b.texCoord ? b.texCoord : 0;
      this.scale = void 0 !== b.scale ? b.scale : 1;
      this.extensions = void 0 !== b.extensions ? b.extensions : null;
      this.extras = void 0 !== b.extras ? b.extras : null;
    }),
    um = (la.OcclusionTextureInfo = function (b) {
      this.index = b.index;
      this.texCoord = void 0 !== b.texCoord ? b.texCoord : 0;
      this.strength = void 0 !== b.strength ? b.strength : 1;
      this.extensions = void 0 !== b.extensions ? b.extensions : null;
      this.extras = void 0 !== b.extras ? b.extras : null;
    }),
    vm = (la.Material = function (b) {
      this.name = void 0 !== b.name ? b.name : null;
      this.pbrMetallicRoughness =
        void 0 !== b.pbrMetallicRoughness ? new Ci(b.pbrMetallicRoughness) : new Ci({ baseColorFactor: [1, 1, 1, 1], metallicFactor: 1, metallicRoughnessTexture: 1 });
      this.normalTexture = void 0 !== b.normalTexture ? new tm(b.normalTexture) : null;
      this.occlusionTexture = void 0 !== b.occlusionTexture ? new um(b.occlusionTexture) : null;
      this.emissiveTexture = void 0 !== b.emissiveTexture ? new If(b.emissiveTexture) : null;
      this.emissiveFactor = void 0 !== b.emissiveFactor ? b.emissiveFactor : [0, 0, 0];
      this.alphaMode = void 0 !== b.alphaMode ? b.alphaMode : "OPAQUE";
      this.alphaCutoff = void 0 !== b.alphaCutoff ? b.alphaCutoff : 0.5;
      this.doubleSided = b.doubleSided || !1;
      this.extensions = void 0 !== b.extensions ? b.extensions : null;
      this.extras = void 0 !== b.extras ? b.extras : null;
    }),
    wm = (la.Skin = function (b, d, a) {
      this.name = void 0 !== d.name ? d.name : null;
      this.skinID = a;
      this.joints = Array(d.joints.length);
      var c;
      a = 0;
      for (c = this.joints.length; a < c; a++) this.joints[a] = b.nodes[d.joints[a]];
      this.skeleton = void 0 !== d.skeleton ? b.nodes[d.skeleton] : null;
      this.inverseBindMatrices = void 0 !== d.inverseBindMatrices ? b.accessors[d.inverseBindMatrices] : null;
      this.extensions = void 0 !== d.extensions ? d.extensions : null;
      this.extras = void 0 !== d.extras ? d.extras : null;
      this.uniformBlockID = xi++;
      if (this.inverseBindMatrices)
        for (
          this.inverseBindMatricesData = Dd(this.inverseBindMatrices),
            this.inverseBindMatrix = [],
            this.jointMatrixUniformBuffer = null,
            this.jointMatrixUnidormBufferData = new Float32Array(1040),
            a = 0,
            c = this.inverseBindMatricesData.length;
          a < c;
          a += 16
        )
          this.inverseBindMatrix.push(
            L.fromValues(
              this.inverseBindMatricesData[a],
              this.inverseBindMatricesData[a + 1],
              this.inverseBindMatricesData[a + 2],
              this.inverseBindMatricesData[a + 3],
              this.inverseBindMatricesData[a + 4],
              this.inverseBindMatricesData[a + 5],
              this.inverseBindMatricesData[a + 6],
              this.inverseBindMatricesData[a + 7],
              this.inverseBindMatricesData[a + 8],
              this.inverseBindMatricesData[a + 9],
              this.inverseBindMatricesData[a + 10],
              this.inverseBindMatricesData[a + 11],
              this.inverseBindMatricesData[a + 12],
              this.inverseBindMatricesData[a + 13],
              this.inverseBindMatricesData[a + 14],
              this.inverseBindMatricesData[a + 15]
            )
          );
    }),
    qm = (la.SkinLink = function (b, d, a) {
      this.isLink = !0;
      b.skins || (b.skins = []);
      b.skins.push(this);
      this.name = d.name;
      this.skinID = b.skins.length - 1;
      this.joints = d.joints;
      this.skeleton = d.skeleton;
      this.inverseBindMatrices = void 0 !== a ? b.accessors[a] : null;
      this.uniformBlockID = xi++;
      if (this.inverseBindMatrices)
        for (
          this.inverseBindMatricesData = Dd(this.inverseBindMatrices),
            this.inverseBindMatrix = [],
            this.jointMatrixUniformBuffer = null,
            this.jointMatrixUnidormBufferData = new Float32Array(1040),
            b = 0,
            d = this.inverseBindMatricesData.length;
          b < d;
          b += 16
        )
          this.inverseBindMatrix.push(
            L.fromValues(
              this.inverseBindMatricesData[b],
              this.inverseBindMatricesData[b + 1],
              this.inverseBindMatricesData[b + 2],
              this.inverseBindMatricesData[b + 3],
              this.inverseBindMatricesData[b + 4],
              this.inverseBindMatricesData[b + 5],
              this.inverseBindMatricesData[b + 6],
              this.inverseBindMatricesData[b + 7],
              this.inverseBindMatricesData[b + 8],
              this.inverseBindMatricesData[b + 9],
              this.inverseBindMatricesData[b + 10],
              this.inverseBindMatricesData[b + 11],
              this.inverseBindMatricesData[b + 12],
              this.inverseBindMatricesData[b + 13],
              this.inverseBindMatricesData[b + 14],
              this.inverseBindMatricesData[b + 15]
            )
          );
    }),
    xm = (la.Target = function (b) {
      this.nodeID = void 0 !== b.node ? b.node : null;
      this.path = b.path;
      this.extensions = void 0 !== b.extensions ? b.extensions : null;
      this.extras = void 0 !== b.extras ? b.extras : null;
    }),
    ym = (la.Channel = function (b, d) {
      this.sampler = d.samplers[b.sampler];
      this.target = new xm(b.target);
      this.extensions = void 0 !== b.extensions ? b.extensions : null;
      this.extras = void 0 !== b.extras ? b.extras : null;
    }),
    Di = (la.AnimationSampler = function (b, d) {
      this.input = b.accessors[d.input];
      this.output = b.accessors[d.output];
      this.inputTypedArray = Dd(this.input);
      this.outputTypedArray = Dd(this.output);
      this.interpolation = void 0 !== d.interpolation ? d.interpolation : "LINEAR";
      this.extensions = void 0 !== d.extensions ? d.extensions : null;
      this.extras = void 0 !== d.extras ? d.extras : null;
      this.curIdx = 0;
      this.curValue = na.create();
      this.endT = this.inputTypedArray[this.inputTypedArray.length - 1];
      this.inputMax = this.endT - this.inputTypedArray[0];
    }),
    Ei = na.create(),
    Fi = na.create();
  Di.prototype.getValue = function (b) {
    b > this.endT && ((b -= this.inputMax * Math.ceil((b - this.endT) / this.inputMax)), (this.curIdx = 0));
    for (var d = this.inputTypedArray.length; this.curIdx <= d - 2 && b >= this.inputTypedArray[this.curIdx + 1]; ) this.curIdx++;
    this.curIdx >= d - 1 && ((b -= this.inputMax), (this.curIdx = 0));
    d = Ae[this.output.type];
    var a = 4 === d ? Ed.slerp : na.lerp,
      c = this.curIdx,
      f = c * d,
      h = f + d;
    b = Math.max(0, b - this.inputTypedArray[c]) / (this.inputTypedArray[c + 1] - this.inputTypedArray[c]);
    for (c = 0; c < d; c++) (Ei[c] = this.outputTypedArray[f + c]), (Fi[c] = this.outputTypedArray[h + c]);
    switch (this.interpolation) {
      case "LINEAR":
        a(this.curValue, Ei, Fi, b);
    }
  };
  var zm = (la.Animation = function (b, d) {
      this.name = void 0 !== d.name ? d.name : null;
      var a;
      this.samplers = [];
      var c = 0;
      for (a = d.samplers.length; c < a; c++) this.samplers[c] = new Di(b, d.samplers[c]);
      this.channels = [];
      c = 0;
      for (a = d.channels.length; c < a; c++) this.channels[c] = new ym(d.channels[c], this);
      this.extensions = void 0 !== d.extensions ? d.extensions : null;
      this.extras = void 0 !== d.extras ? d.extras : null;
    }),
    Am = (la.glTFModel = function (b) {
      this.json = b;
      this.defaultScene = void 0 !== b.scene ? b.scene : 0;
      this.version = Number(b.asset.version);
      b.accessors && (this.accessors = Array(b.accessors.length));
      b.bufferViews && (this.bufferViews = Array(b.bufferViews.length));
      b.scenes && (this.scenes = Array(b.scenes.length));
      b.nodes && (this.nodes = Array(b.nodes.length));
      b.meshes && (this.meshes = Array(b.meshes.length));
      b.materials && (this.materials = Array(b.materials.length));
      b.textures && (this.textures = Array(b.textures.length));
      b.samplers && (this.samplers = Array(b.samplers.length));
      b.images && (this.images = Array(b.images.length));
      b.skins && (this.skins = Array(b.skins.length));
      b.animations && (this.animations = Array(b.animations.length));
      b.cameras && (this.cameras = Array(b.cameras.length));
      this.extensions = void 0 !== b.extensions ? b.extensions : null;
      this.extras = void 0 !== b.extras ? b.extras : null;
    }),
    wc = (la.glTFLoader = function (b) {
      this._init();
      this.glTF = null;
      this.enableGLAvatar = !1;
      this.linkSkeletonGltf = null;
    });
  wc.prototype._init = function () {
    this._loadDone = !1;
    this._bufferLoaded = this._bufferRequested = 0;
    this._buffers = [];
    this._bufferTasks = {};
    this._finishedPendingTasks = this._pendingTasks = this._imageLoaded = this._imageRequested = this._shaderLoaded = this._shaderRequested = 0;
    this.onload = null;
    $a = this;
  };
  wc.prototype._checkComplete = function () {
    this._bufferRequested == this._bufferLoaded && this._imageRequested == this._imageLoaded && (this._loadDone = !0);
    this._loadDone && this._pendingTasks == this._finishedPendingTasks && (this._postprocess(), this.onload(this.glTF));
  };
  wc.prototype.loadGLTF_GL_Avatar_Skin = function (b, d, a) {
    this.enableGLAvatar = !0;
    this.skeletonGltf = d;
    this.loadGLTF(b, a);
  };
  wc.prototype.loadGLTF = function (b, d) {
    this._init();
    this.onload = d || function (a) {};
    this.baseUri = aj(b);
    var a = this;
    bj(b, function (b) {
      b = JSON.parse(b);
      a.glTF = new Am(b);
      var c,
        d = function (b) {
          a._buffers[c] = b;
          a._bufferLoaded++;
          if (a._bufferTasks[c]) {
            var d;
            var f = 0;
            for (d = a._bufferTasks[c].length; f < d; ++f) a._bufferTasks[c][f](b);
          }
          a._checkComplete();
        };
      if (b.buffers)
        for (c in b.buffers) {
          a._bufferRequested++;
          var g = b.buffers[c].uri;
          -1 === g.indexOf("base64") && (g = a.baseUri + g);
          cj(g, d);
        }
      d = function (b, c) {
        a._imageLoaded++;
        a.glTF.images[c] = b;
        a._checkComplete();
      };
      var k;
      if (b.images) for (k in b.images) a._imageRequested++, dj(a.baseUri + b.images[k].uri, k, d);
      a._checkComplete();
    });
  };
  wc.prototype._postprocess = function () {
    function b(a, b) {
      var c = l[a.nodeID];
      null !== b ? L.mul(c, l[b.nodeID], a.matrix) : L.copy(c, a.matrix);
    }
    function d(a, b) {
      var c = l[a.nodeID];
      b = null !== b ? b.bvh : n.boundingBox;
      a.mesh &&
        ((f = a.mesh),
        f.boundingBox && ((a.aabb = ub.getAABBFromOBB(f.boundingBox, c)), 0 === a.children.length && (P.copy(a.bvh.min, a.aabb.min), P.copy(a.bvh.max, a.aabb.max))));
      P.min(b.min, b.min, a.bvh.min);
      P.max(b.max, b.max, a.bvh.max);
    }
    $a = this;
    var a, c, f;
    if (this.glTF.cameras) {
      var h = 0;
      for (a = this.glTF.cameras.length; h < a; h++) this.glTF.cameras[h] = new pm(this.glTF.json.cameras[h]);
    }
    if (this.glTF.bufferViews)
      for (h = 0, a = this.glTF.bufferViews.length; h < a; h++)
        this.glTF.bufferViews[h] = new Hf(this.glTF.json.bufferViews[h], this._buffers[this.glTF.json.bufferViews[h].buffer]);
    if (this.glTF.accessors)
      for (h = 0, a = this.glTF.accessors.length; h < a; h++)
        this.glTF.accessors[h] = new yi(this.glTF.json.accessors[h], this.glTF.bufferViews[this.glTF.json.accessors[h].bufferView]);
    if (this.glTF.materials) for (h = 0, a = this.glTF.materials.length; h < a; h++) this.glTF.materials[h] = new vm(this.glTF.json.materials[h]);
    if (this.glTF.samplers) for (h = 0, a = this.glTF.samplers.length; h < a; h++) this.glTF.samplers[h] = new Bi(this.glTF.json.samplers[h]);
    if (this.glTF.textures) for (h = 0, a = this.glTF.textures.length; h < a; h++) this.glTF.textures[h] = new Ai(this.glTF.json.textures[h]);
    h = 0;
    for (a = this.glTF.meshes.length; h < a; h++) this.glTF.meshes[h] = new sm(this.glTF.json.meshes[h], h);
    h = 0;
    for (a = this.glTF.nodes.length; h < a; h++) this.glTF.nodes[h] = new vc(this.glTF.json.nodes[h], h);
    h = 0;
    for (a = this.glTF.nodes.length; h < a; h++) {
      var g = this.glTF.nodes[h];
      var k = 0;
      for (c = g.children.length; k < c; k++) g.children[k] = this.glTF.nodes[g.children[k]];
    }
    var l = Array(this.glTF.nodes.length);
    h = 0;
    for (a = l.length; h < a; h++) l[h] = L.create();
    h = 0;
    for (a = this.glTF.scenes.length; h < a; h++) {
      var n = (this.glTF.scenes[h] = new om(this.glTF, this.glTF.json.scenes[h]));
      n.boundingBox = new ub();
      k = 0;
      for (c = n.nodes.length; k < c; k++) (g = n.nodes[k]), g.traverseTwoExecFun(null, b, d);
      n.boundingBox.calculateTransform();
    }
    k = 0;
    for (c = this.glTF.nodes.length; k < c; k++) (g = this.glTF.nodes[k]), null !== g.bvh && g.bvh.calculateTransform();
    if (this.glTF.animations) for (h = 0, a = this.glTF.animations.length; h < a; h++) this.glTF.animations[h] = new zm(this.glTF, this.glTF.json.animations[h]);
    if (this.glTF.json.skins)
      for (h = 0, a = this.glTF.skins.length; h < a; h++)
        for (this.glTF.skins[h] = new wm(this.glTF, this.glTF.json.skins[h], h), g = this.glTF.skins[h].joints, k = 0, c = g.length; k < c; k++) g[k].jointID = k;
    h = 0;
    for (a = this.glTF.nodes.length; h < a; h++) (g = this.glTF.nodes[h]), null !== g.skin && "number" == typeof g.skin && (g.skin = this.glTF.skins[g.skin]);
  };
  var Ae = { SCALAR: 1, VEC2: 2, VEC3: 3, VEC4: 4, MAT2: 4, MAT3: 9, MAT4: 16 },
    Gi = (function (b) {
      function d(a, b) {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).call(this, a, b));
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { scale: 1 };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            var b = this;
            this.gl = a;
            var d = this.getOptions();
            this.gltfObj = ej({ gl: a, options: d });
            new wc().loadGLTF(d.url, function (a) {
              b.gltfObj.setupScene(a);
              b.webglLayer.render();
            });
          }
        },
        { key: "onChanged", value: function (a, b) {} },
        {
          key: "render",
          value: function (a) {
            var b = a.gl;
            a = a.matrix;
            var d = this.getData(),
              h = this.getOptions(),
              g = h.scale,
              k = [g, g, g];
            "px" === h.unit && this.map && ((k = this.map.getZoomUnits()), (k = [g * k, g * k, g * k]));
            for (g = 0; g < d.length; g++) {
              var l = d[g].geometry.coordinates;
              h = L.create();
              var n = L.create();
              l = this.normizedPoint(l);
              L.identity(h);
              L.translate(h, h, [l[0], l[1], l[2]]);
              L.rotateX(h, h, Math.PI / 2);
              L.rotateY(h, h, ((d[g].angle || 0) * Math.PI) / 180);
              L.scale(h, h, k);
              L.mul(n, a, h);
              this.gltfObj.render({ gl: b, matrix: n });
            }
          }
        }
      ]);
      return d;
    })(ca),
    hc = hc || {};
  (function () {
    function b(a, b, d) {
      d = a.createShader(d);
      a.shaderSource(d, b);
      a.compileShader(d);
      return d;
    }
    hc.getShaderSource = function (a) {
      return document.getElementById(a).textContent.replace(/^\s+|\s+$/g, "");
    };
    hc.createProgram = function (a, c, d) {
      var f = a.createProgram();
      c = b(a, c, a.VERTEX_SHADER);
      d = b(a, d, a.FRAGMENT_SHADER);
      a.attachShader(f, c);
      a.deleteShader(c);
      a.attachShader(f, d);
      a.deleteShader(d);
      a.linkProgram(f);
      a.getProgramInfoLog(f);
      a.getShaderInfoLog(c);
      a.getShaderInfoLog(d);
      return f;
    };
    var d = (hc.loadImage = function (a, b) {
      var c = new Image();
      c.crossOrigin = "Anonymous";
      c.src = a;
      c.onload = b;
      return c;
    });
    hc.loadImages = function (a, b) {
      function c() {
        0 >= --g && b(h);
      }
      for (var h = [], g = a.length, k = 0; k < g; ++k) h.push(d(a[k], c));
    };
  })();
  var Bm = (function (b) {
      function d(a) {
        F(this, d);
        var b = Q(this, (d.__proto__ || N(d)).call(this, a));
        a = b.getOptions();
        b.gltfLayer = new Gi({ url: a.url, scale: a.scale });
        b.children = [b.gltfLayer];
        b.autoUpdate = !0;
        b.index = [];
        b.newData = [];
        b.isStarted = !1 === a.autoPlay ? !1 : !0;
        return b;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { url: "https://mapv-website.bj.bcebos.com/gl/examples/model/car.gltf", scale: 1, step: 1, defaultAngle: 90 };
          }
        },
        {
          key: "onOptionsChanged",
          value: function (a) {
            this.gltfLayer.setOptions({});
          }
        },
        {
          key: "onDataChanged",
          value: function (a) {
            var b = this;
            this.index = [];
            this.newData = [];
            for (var d = 0; d < a.length; d++) {
              this.index.push(0);
              var h = a[d].geometry.coordinates;
              "LineString" === a[d].geometry.type
                ? this.newData.push(this._addPath(h))
                : h.forEach(function (a) {
                    b.newData.push(b._addPath(a));
                  });
            }
            this.updatePoints();
          }
        },
        {
          key: "lnglatToMercator",
          value: function (a, b) {
            b = (b * Math.PI) / 180;
            b = 3189068.5 * Math.log((1 + Math.sin(b)) / (1 - Math.sin(b)));
            return [parseFloat((((a * Math.PI) / 180) * 6378137).toFixed(2)), parseFloat(b.toFixed(2))];
          }
        },
        {
          key: "getDeg",
          value: function (a, b) {
            -180 < a[0] && 180 > a[0] && ((a = this.lnglatToMercator(a[0], a[1])), (b = this.lnglatToMercator(b[0], b[1])));
            var c = (180 * Math.atan((b[1] - a[1]) / (b[0] - a[0]))) / Math.PI;
            b[0] > a[0] && (c -= 180);
            return c;
          }
        },
        {
          key: "getPoint",
          value: function (a, b, d) {
            return [a[0] + (b[0] - a[0]) * d, a[1] + (b[1] - a[1]) * d, a[2] && b[2] ? a[2] + (b[2] - a[2]) * d : 0];
          }
        },
        {
          key: "updatePoints",
          value: function () {
            for (var a = this.getOptions(), b = this.newData, d = [], h = 0; h < b.length; h++) {
              for (var g = b[h], k = Math.floor(this.index[h]), l = k + 1; g[l] && g[l][0] === g[k][0] && g[l][1] === g[k][1]; ) l++;
              l >= g.length - 1 && (l = --k);
              l = this.getDeg(g[k], g[l]);
              d.push({ geometry: { type: "Point", coordinates: this.getPoint(g[k], g[k + 1], this.index[h] % 1) }, angle: l - a.defaultAngle });
            }
            this.pointData = d;
            this.gltfLayer.setData(d, { autoRender: !1 });
          }
        },
        {
          key: "getCurrentPoint",
          value: function () {
            return this.pointData;
          }
        },
        {
          key: "getDistance",
          value: function (a, b) {
            var c = (a[1] * Math.PI) / 180,
              d = (b[1] * Math.PI) / 180;
            a =
              2 *
              Math.asin(Math.sqrt(Math.pow(Math.sin((c - d) / 2), 2) + Math.cos(c) * Math.cos(d) * Math.pow(Math.sin(((a[0] * Math.PI) / 180 - (b[0] * Math.PI) / 180) / 2), 2)));
            return (a = Math.round(6378137e4 * a) / 1e4);
          }
        },
        {
          key: "_addPath",
          value: function (a) {
            for (var b = a.length, d = 0, h = [], g = [], k = 1; k < b; k++) {
              var l = this.getDistance(a[k - 1], a[k]);
              h.push(l);
              d += l;
            }
            l = [0];
            for (k = 1; k < b; k++) {
              var n = (h[k - 1] / d).toFixed(2);
              l[k] = l[k - 1] + parseFloat(n, 10);
              g = g.concat(this._getPath(a[k - 1], a[k], 1e3 * n));
            }
            this._pathPercents = l;
            return g;
          }
        },
        {
          key: "_getPath",
          value: function (a, b, d) {
            if (0 === d) return [a];
            for (var c = [], f = 0; f <= d; f++) c.push([((b[0] - a[0]) / d) * f + a[0], ((b[1] - a[1]) / d) * f + a[1], b[2] && a[2] ? ((b[2] - a[2]) / d) * f + a[2] : 0]);
            return c;
          }
        },
        {
          key: "start",
          value: function () {
            this.isStarted = !0;
          }
        },
        {
          key: "stop",
          value: function () {
            this.isStarted = !1;
          }
        },
        {
          key: "render",
          value: function (a) {
            ib(d.prototype.__proto__ || N(d.prototype), "render", this).call(this, a);
            a = this.getOptions();
            if (this.isStarted) for (var b = this.newData, f = 0; f < this.index.length; f++) (this.index[f] += a.step), this.index[f] > b[f].length - 2 && (this.index[f] = 0);
            this.updatePoints();
          }
        }
      ]);
      return d;
    })(jb),
    Cm = (function (b) {
      function d(a, b) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, b));
        a.name = "BoardTextLayer";
        b = a.canvas = document.createElement("canvas");
        b = a.ctx = b.getContext("2d");
        b.textAlign = "start";
        b.textBaseline = "top";
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              depthWrite: !1,
              depthTest: !0,
              color: "#fff",
              fontFamily: "Microsoft Yahei",
              fontSize: 14,
              collides: !0,
              unit: "px",
              angle: 0,
              translateX: 0,
              offset: [0, 0],
              padding: [2, 2],
              margin: [0, 0],
              polygonOffset: [0, 0],
              shadow: {},
              maxHeightLine: 20,
              lineBreak: "\n"
            };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var b = this.getOptions();
            this.texture = null;
            this.lastUpdateTime = 0;
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;uniform mat4 matrix;uniform bool uUnitPx;uniform float zoomUnits;uniform float zIndex;uniform vec2 offset;attribute vec3 position;attribute float corner;attribute float scale;attribute float rotation;attribute vec2 size;attribute vec2 aTextCoord;varying vec2 vTextCoord;/***\u70b9A(x,y)\uff0c\u7ed5\u539f\u70b9\u987a\u65f6\u9488\u65cb\u8f6c\u89d2\u5ea6a\u65b0\u5750\u6807\u7684\u8ba1\u7b97\u516c\u5f0f*x1=x*cos(a)+y*sin(a)*y1=y*cos(a)-x*sin(a)*/mat3 rotateZ(float angle){float cos0=cos(angle);float sin0=sin(angle);return mat3(cos0,sin0,0.,-sin0,cos0,0.,0.,0.,1.);}vec3 transformCoord(vec3 coord,vec2 size,float corner){float x=coord.x;float y=coord.y;float z=coord.z;mat3 mat=rotateZ(rotation);vec3 rotated=vec3(size[0],0.0,size[1]);if(corner==1.0){rotated=mat*vec3(-size[0],0.0,size[1]);}else if(corner==2.0){rotated=mat*vec3(size[0],0.0,size[1]);}else if(corner==3.0){rotated=mat*vec3(size[0],0.0,-size[1]);}else{rotated=mat*vec3(-size[0],0.0,-size[1]);}x+=rotated.x;y+=rotated.y;z+=rotated.z;return vec3(x,y,z);}void main(){vTextCoord=aTextCoord;vec2 pixelOffset=offset;vec2 halfSize=size/2.0*scale;if(uUnitPx){halfSize*=zoomUnits;pixelOffset*=zoomUnits;}vec3 current=transformCoord(position,halfSize,corner);current.z+=zIndex;gl_Position=matrix*vec4(current.x+pixelOffset[0],current.y-pixelOffset[1],current.z,1.0);}",
                fragmentShader:
                  "precision highp float;uniform sampler2D textureImage;uniform vec4 uSelectedColor;varying vec2 vTextCoord;void main(){vec4 textureColor=texture2D(textureImage,vec2(vTextCoord.x,1.0-vTextCoord.y));if(textureColor.a<=0.1&&uIsPickRender==false){discard;}gl_FragColor=textureColor;\n#if defined(PICK)\nif(mapvIsPicked()){gl_FragColor=vec4(uSelectedColor.rgb,gl_FragColor.a);}\n#endif\n}",
                defines: b.enablePicked ? ["PICK"] : []
              },
              this
            );
            this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.uvBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            b = [
              { name: "position", buffer: this.vertexBuffer, size: 3, stride: 32, type: "FLOAT", offset: 0 },
              { name: "corner", buffer: this.vertexBuffer, size: 1, stride: 32, type: "FLOAT", offset: 12 },
              { name: "size", buffer: this.vertexBuffer, size: 2, stride: 32, type: "FLOAT", offset: 16 },
              { name: "scale", buffer: this.vertexBuffer, size: 1, stride: 32, type: "FLOAT", offset: 24 },
              { name: "rotation", buffer: this.vertexBuffer, size: 1, stride: 32, type: "FLOAT", offset: 28 },
              { name: "aTextCoord", buffer: this.uvBuffer, size: 2, stride: 8, type: "FLOAT", offset: 0 }
            ];
            b = b.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: b });
          }
        },
        { key: "onDestroy", value: function () {} },
        {
          key: "onChanged",
          value: function (a, b) {
            this.gl && this.processCache(a, b);
          }
        },
        {
          key: "processCache",
          value: function (a, b) {
            this.cachedData = [];
            for (var c = 0; c < b.length; c++) {
              var d = this.normizedPoint(b[c].geometry.coordinates),
                g = b[c].text;
              "properties" in b[c] && "text" in b[c].properties && (g = b[c].properties.text);
              var k = this.getProperty("angle", a.angle, b[c]),
                l = this.getProperty("color", a.color, b[c]),
                n = this.getProperty("maxHeightLine", a.maxHeightLine, b[c]);
              d && void 0 !== g && this.cachedData.push({ point: d, text: g, angle: k, color: l, maxHeightLine: n, index: c });
            }
          }
        },
        {
          key: "render",
          value: function (a) {
            if (this.cachedData && this.cachedData.length && this.map) {
              var b = a.gl,
                d = a.matrix,
                h = this.getOptions(),
                g = this.program;
              g.use(b);
              this.throttleUpdate(a);
              this.setGLState({ blend: !0, blendEquation: b.FUNC_ADD, blendFunc: Va(b, h.blend), polygonOffset: h.polygonOffset, depthTest: h.depthTest, depthMask: h.depthWrite });
              var k = this.map.getZoomUnits();
              g.setUniforms(S(this.getCommonUniforms(a), { matrix: d, textureImage: this.texture, offset: h.offset, zoomUnits: k, zIndex: h.zIndex, uUnitPx: "px" === h.unit }));
              0 < this.index.length && (this.indexBuffer.bind(), this.vertexArray.bind(), b.drawElements(b.TRIANGLES, this.index.length, b.UNSIGNED_INT, 0));
            }
          }
        },
        {
          key: "throttleUpdate",
          value: function (a) {
            this.updateText(a);
          }
        },
        {
          key: "updateText",
          value: function (a) {
            var b = a.gl,
              d = a.matrix,
              h = this.getOptions();
            a = h.fontSize;
            var g = h.fontFamily,
              k = h.translateX,
              l = h.padding,
              n = h.margin,
              m = h.collides,
              p = h.enablePicked,
              q = h.shadow;
            h = h.lineBreak;
            var t = b.canvas.width / window.devicePixelRatio,
              v = b.canvas.height / window.devicePixelRatio,
              r = this.canvas,
              u = this.ctx;
            u.save();
            u.scale(window.devicePixelRatio, window.devicePixelRatio);
            u.textBaseline = "top";
            u.font = "normal bold 20px " + g;
            var w = new qc();
            b = [];
            for (var y = 0; y < this.cachedData.length; y++) {
              var x = this.cachedData[y],
                D = x.point,
                C = x.text,
                A = x.angle,
                z = x.index,
                B = x.color;
              x = x.maxHeightLine;
              var G = da(D, 3),
                F = na.clone([G[0], G[1], G[2], 1]);
              na.transformMat4(F, F, d);
              na.scale(F, F, 1 / F[3]);
              G = ((F[0] + 1) / 2) * t;
              F = ((-F[1] + 1) / 2) * v;
              var H = u.measureText(C),
                I = C.split(h),
                K = I.map(function (a) {
                  return u.measureText(a).width;
                });
              K = Math.max.apply(Math, W(K));
              for (var L = 20, N = 0; N < I.length - 1; N++) L += x;
              I = L;
              H = Math.min(H.width, K) + 1;
              H += 2 * l[0] + k;
              I += 2 * l[1];
              L = H + n[0];
              K = I + n[1];
              G -= L / 2;
              F -= K / 2;
              L = G + L;
              K = F + K;
              if (!(0 > L || 0 > K || G > t || F > v)) {
                if (m) {
                  G = { minX: G, maxX: L, minY: F, maxY: K };
                  if (w.collides(G)) continue;
                  w.insert(G);
                }
                b.push({ w: H, h: I, point: D, text: C, color: B, angle: A, maxHeightLine: x, dataIndex: z });
              }
            }
            u.restore();
            d = [];
            n = [];
            m = [];
            t = [];
            w = zb(b);
            v = w.w;
            w = w.h;
            0 >= v && (v = 1);
            0 >= w && (w = 1);
            r.width = v * window.devicePixelRatio;
            r.height = w * window.devicePixelRatio;
            u.save();
            u.scale(window.devicePixelRatio, window.devicePixelRatio);
            u.textBaseline = "top";
            u.font = "normal bold 20px " + g;
            u.shadowColor = q && q.color;
            u.shadowOffsetX = q && q.offsetX;
            u.shadowOffsetY = q && q.offsetY;
            u.shadowBlur = q && q.blur;
            g = 0;
            for (q = b.length; g < q; ++g) {
              r = b[g];
              u.fillStyle = r.color;
              fj(u, r.text, r.x + l[0] + k, r.y + l[1], r.maxHeightLine, h);
              C = da(r.point, 3);
              y = C[0];
              D = C[1];
              C = C[2];
              for (A = 0; 4 > A; A++) d.push(y, D, C), d.push(A), d.push(r.w, r.h), d.push(a / 20, (r.angle * Math.PI) / 180);
              y = r.x / v;
              D = (r.x + r.w) / v;
              C = (r.y + r.h) / w;
              A = r.y / w;
              n.push(y, C, y, A, D, A, D, C);
              y = 4 * g;
              m.push(y, y + 2, y + 1, y, y + 3, y + 2);
              p &&
                ((r = this.indexToRgb(r.dataIndex)),
                t.push(r[0] / 255, r[1] / 255, r[2] / 255),
                t.push(r[0] / 255, r[1] / 255, r[2] / 255),
                t.push(r[0] / 255, r[1] / 255, r[2] / 255),
                t.push(r[0] / 255, r[1] / 255, r[2] / 255));
            }
            u.restore();
            this.loadTexture();
            this.index = m;
            this.vertexBuffer.updateData(new Float32Array(d));
            this.uvBuffer.updateData(new Float32Array(n));
            this.indexBuffer.updateData(new Uint32Array(m));
            p && this.pickBuffer.updateData(new Float32Array(t));
          }
        },
        {
          key: "loadTexture",
          value: function () {
            var a = this;
            this.canvas
              ? ta(
                  this.gl,
                  this.canvas,
                  function (b) {
                    a.texture = b;
                  },
                  { TEXTURE_WRAP_S: "CLAMP_TO_EDGE", TEXTURE_WRAP_T: "CLAMP_TO_EDGE" }
                )
              : (this.texture = null);
          }
        }
      ]);
      return d;
    })(ca),
    Dm = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.name = "LabelLayer";
        a.pickedIndex = null;
        var b = (a.canvas = document.createElement("canvas"));
        a.ctx = b.getContext("2d");
        a.arrowHeight = 8;
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              depthWrite: !1,
              depthTest: !0,
              textColor: "#0f0",
              borderColor: "#f00",
              backgroundColor: "#fff",
              pickedTextColor: "#fff",
              pickedBorderColor: "#666",
              pickedBackgroundColor: "#666",
              fontFamily: "Microsoft Yahei",
              fontSize: 14,
              lineHeight: 20,
              textAlign: "left",
              collides: !1,
              offset: [0, 0],
              padding: [2, 2],
              polygonOffset: [0, 0],
              borderRadius: 5
            };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var b = this.getOptions();
            this.texture = null;
            this.lastUpdateTime = 0;
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;uniform mat4 matrix;uniform float zoomUnits;uniform float devicePixelRatio;uniform float zIndex;uniform vec2 offset;attribute vec3 position;attribute float corner;attribute vec2 size;attribute vec2 aTextCoord;varying vec2 vTextCoord;/***\u70b9A(x,y)\uff0c\u7ed5\u539f\u70b9\u987a\u65f6\u9488\u65cb\u8f6c\u89d2\u5ea6a\u65b0\u5750\u6807\u7684\u8ba1\u7b97\u516c\u5f0f*x1=x*cos(a)+y*sin(a)*y1=y*cos(a)-x*sin(a)*/vec3 transformCoord(vec3 coord,vec2 size,float corner){float x=coord.x;float y=coord.y;if(corner==1.0){x+=-size.x;y+=size.y;}else if(corner==2.0){x+=size.x;y+=size.y;}else if(corner==3.0){x+=size.x;y+=-size.y;}else{x+=-size.x;y+=-size.y;}return vec3(x,y+size.y,coord.z);}void main(){vTextCoord=aTextCoord;vec2 pixelOffset=offset*zoomUnits;vec4 projection=matrix*vec4(position.x+pixelOffset[0],position.y-pixelOffset[1],position.z+zIndex,1.0);vec3 screen=projection.xyz/projection.w;vec2 halfSize=size/MAPV_resolution*devicePixelRatio;vec3 current=transformCoord(screen,halfSize,corner);gl_Position=vec4(current,1.0);}",
                fragmentShader:
                  "precision highp float;uniform sampler2D textureImage;varying vec2 vTextCoord;void main(){gl_FragColor=texture2D(textureImage,vec2(vTextCoord.x,1.0-vTextCoord.y));}",
                defines: b.enablePicked ? ["PICK"] : []
              },
              this
            );
            this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.uvBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            b = [
              { name: "position", buffer: this.vertexBuffer, size: 3, stride: 24, type: "FLOAT", offset: 0 },
              { name: "corner", buffer: this.vertexBuffer, size: 1, stride: 24, type: "FLOAT", offset: 12 },
              { name: "size", buffer: this.vertexBuffer, size: 2, stride: 24, type: "FLOAT", offset: 16 },
              { name: "aTextCoord", buffer: this.uvBuffer, size: 2, stride: 8, type: "FLOAT", offset: 0 }
            ];
            b = b.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: b });
          }
        },
        { key: "onDestroy", value: function () {} },
        {
          key: "onChanged",
          value: function (a, b) {
            this.gl && this.processCache(a, b);
          }
        },
        {
          key: "processCache",
          value: function (a, b) {
            this.cachedData = [];
            this.pickedIndex = null;
            for (a = 0; a < b.length; a++) {
              var c = b[a],
                d = this.normizedPoint(c.geometry.coordinates);
              d && this.cachedData.push({ point: d, item: c, index: a });
            }
          }
        },
        {
          key: "setPickedIndex",
          value: function (a, b) {
            var c = this;
            "onMousemove" !== b
              ? 0 <= a &&
                ((this.pickedIndex = a),
                setTimeout(function () {
                  c.webglLayer.render();
                }))
              : (this.pickedIndex = a);
          }
        },
        {
          key: "render",
          value: function (a) {
            if (this.cachedData && this.cachedData.length && this.map) {
              var b = a.gl,
                d = a.matrix,
                h = this.getOptions(),
                g = this.program;
              g.use(b);
              this.updateText(a);
              this.setGLState({
                blend: !0,
                blendEquation: b.FUNC_ADD,
                blendFunc: [b.SRC_ALPHA, b.ONE_MINUS_SRC_ALPHA],
                polygonOffset: h.polygonOffset,
                depthTest: h.depthTest,
                depthMask: h.depthWrite
              });
              var k = this.map.getZoomUnits();
              a = S(this.getCommonUniforms(a), {
                matrix: d,
                devicePixelRatio: window.devicePixelRatio,
                textureImage: this.texture,
                offset: h.offset,
                zoomUnits: k,
                zIndex: h.zIndex
              });
              delete a.uSelectedColor;
              g.setUniforms(a);
              0 < this.index.length && (this.indexBuffer.bind(), this.vertexArray.bind(), b.drawElements(b.TRIANGLES, this.index.length, b.UNSIGNED_INT, 0));
            }
          }
        },
        {
          key: "updateText",
          value: function (a) {
            var b = this,
              d = a.gl,
              h = a.matrix,
              g = this.getOptions().enablePicked;
            a = this.canvas;
            var k = this.ctx;
            d = this.createMapbox(k, d, h);
            h = zb(d);
            var l = h.w,
              n = h.h;
            0 >= l && (l = 1);
            0 >= n && (n = 1);
            a.width = l * window.devicePixelRatio;
            a.height = n * window.devicePixelRatio;
            var m = [],
              p = [],
              q = [],
              t = [];
            d.forEach(function (a, c) {
              b.drawItem(k, a);
              var d = da(a.point, 3),
                f = d[0],
                h = d[1];
              d = d[2];
              for (var r = 0; 4 > r; r++) m.push(f, h, d), m.push(r), m.push(a.w, a.h);
              f = a.x / l;
              h = (a.x + a.w) / l;
              d = (a.y + a.h) / n;
              r = a.y / n;
              p.push(f, d, f, r, h, r, h, d);
              c *= 4;
              q.push(c, c + 2, c + 1, c, c + 3, c + 2);
              g &&
                ((a = b.indexToRgb(a.dataIndex)),
                t.push(a[0] / 255, a[1] / 255, a[2] / 255),
                t.push(a[0] / 255, a[1] / 255, a[2] / 255),
                t.push(a[0] / 255, a[1] / 255, a[2] / 255),
                t.push(a[0] / 255, a[1] / 255, a[2] / 255));
            });
            this.loadTexture();
            this.index = q;
            this.vertexBuffer.updateData(new Float32Array(m));
            this.uvBuffer.updateData(new Float32Array(p));
            this.indexBuffer.updateData(new Uint32Array(q));
            g && this.pickBuffer.updateData(new Float32Array(t));
          }
        },
        {
          key: "createMapbox",
          value: function (a, b, d) {
            function c(b) {
              var c = b.point,
                f = b.item;
              b = b.index;
              var g = da(c, 3);
              g = na.clone([g[0], g[1], g[2], 1]);
              na.transformMat4(g, g, d);
              na.scale(g, g, 1 / g[3]);
              var h = ((g[0] + 1) / 2) * p,
                k = ((-g[1] + 1) / 2) * q;
              g = this.computeTextWH(f, a, l, m);
              var r = da(g, 2);
              g = r[0];
              r = r[1];
              h -= g / 2;
              k -= r / 2;
              var A = h + g,
                z = k + r;
              if (!(0 > A || 0 > z || h > p || k > q)) {
                if (n) {
                  h = { minX: h, maxX: A, minY: k, maxY: z };
                  if (t.collides(h)) return;
                  t.insert(h);
                }
                v.push({ w: g, h: r + this.arrowHeight, point: c, item: f, dataIndex: b });
              }
            }
            var f = this,
              k = this.getOptions(),
              l = k.padding,
              n = k.collides,
              m = k.fontSize,
              p = b.canvas.width / window.devicePixelRatio,
              q = b.canvas.height / window.devicePixelRatio,
              t = new qc(),
              v = [];
            this.cachedData[this.pickedIndex] && c.bind(this)(this.cachedData[this.pickedIndex]);
            this.cachedData.forEach(function (a) {
              f.pickedIndex !== a.index && c.bind(f)(a);
            });
            return v;
          }
        },
        {
          key: "computeTextWH",
          value: function (a, b) {
            var c = this.getOptions(),
              d = c.padding,
              g = c.fontSize,
              k = c.borderRadius,
              l = c.fontFamily;
            c = c.lineHeight;
            b.save();
            b.scale(window.devicePixelRatio, window.devicePixelRatio);
            b.font = g + "px " + l;
            a = a.properties.text.split("\n");
            g = a.reduce(function (a, b) {
              return a.length < b.length ? b : a;
            }, "");
            g = b.measureText(g);
            b.restore();
            return [g.width + 2 * (d[1] + k), 2 * (d[0] + k) + c * a.length];
          }
        },
        {
          key: "drawItem",
          value: function (a, b) {
            var c = this.getOptions(),
              d = c.padding,
              g = c.backgroundColor,
              k = c.textColor,
              l = c.fontSize,
              n = c.borderColor,
              m = c.borderRadius,
              p = c.fontFamily,
              q = c.lineHeight,
              t = c.textAlign,
              v = c.pickedTextColor,
              r = c.pickedBorderColor,
              u = c.pickedBackgroundColor,
              w = m - 1,
              y = b.x,
              x = b.y;
            c = b.w;
            var D = b.h,
              z = b.item;
            b = b.dataIndex;
            var A = "";
            "object" === Ha(z.properties) &&
              ((A = z.properties.text || ""), (k = z.properties.textColor || k), (n = z.properties.borderColor || n), (g = z.properties.backgroundColor || g));
            this.pickedIndex === b && ((k = v), (n = r), (g = u));
            v = A.split("\n");
            r = D - this.arrowHeight;
            a.save();
            a.scale(window.devicePixelRatio, window.devicePixelRatio);
            a.textBaseline = "top";
            a.font = l + "px " + p;
            a.translate(y, x);
            a.fillStyle = g;
            a.strokeStyle = n;
            a.beginPath();
            a.arc(m, m, w, Math.PI, 1.5 * Math.PI);
            a.lineTo(c - m, 1);
            a.arc(c - m, m, w, 1.5 * Math.PI, 0);
            a.lineTo(c - 1, r - m);
            a.arc(c - m, r - m, w, 0 * Math.PI, 0.5 * Math.PI);
            a.lineTo(m, r - 1);
            a.arc(m, r - m, w, 0.5 * Math.PI, 1 * Math.PI);
            a.lineTo(1, m);
            a.closePath();
            a.fill();
            a.stroke();
            a.beginPath();
            g = this.arrowHeight;
            p = c / 2;
            w = g / 2;
            a.moveTo(p - w, r - 1);
            a.lineTo(p + w, r - 1);
            a.lineTo(p, r + 0.8 * g);
            a.fillStyle = n;
            a.fill();
            a.fillStyle = k;
            var B = "center" === t ? p : "right" === t ? c - m - d[1] : m + d[1];
            a.textAlign = t;
            v.forEach(function (b, c) {
              a.fillText(b, B, m + d[0] + (c + 0.5) * q - 0.5 * l);
            });
            a.restore();
          }
        },
        {
          key: "loadTexture",
          value: function () {
            var a = this;
            this.canvas
              ? ta(
                  this.gl,
                  this.canvas,
                  function (b) {
                    a.texture = b;
                  },
                  { TEXTURE_WRAP_S: "CLAMP_TO_EDGE", TEXTURE_WRAP_T: "CLAMP_TO_EDGE" }
                )
              : (this.texture = null);
          }
        }
      ]);
      return d;
    })(ca);
  oa.prototype.parseColors = function (b) {
    this.arrFeatureStyles = [
      [2, b[0] || "rgba(79,210,125,1)", 2, 2, 0, [], 0, 0],
      [2, b[0] || "rgba(79,210,125,1)", 3, 2, 0, [], 0, 0],
      [2, b[0] || "rgba(79,210,125,1)", 3, 2, 0, [], 0, 0],
      [2, b[0] || "rgba(79,210,125,1)", 5, 2, 0, [], 0, 0],
      [2, b[0] || "rgba(79,210,125,1)", 6, 2, 0, [], 0, 0],
      [2, b[2] || "rgba(255,208,69,1)", 2, 2, 0, [], 0, 0],
      [2, b[2] || "rgba(255,208,69,1)", 3, 2, 0, [], 0, 0],
      [2, b[2] || "rgba(255,208,69,1)", 3, 2, 0, [], 0, 0],
      [2, b[2] || "rgba(255,208,69,1)", 5, 2, 0, [], 0, 0],
      [2, b[2] || "rgba(255,208,69,1)", 6, 2, 0, [], 0, 0],
      [2, b[1] || "rgba(232,14,14,1)", 2, 2, 0, [], 0, 0],
      [2, b[1] || "rgba(232,14,14,1)", 3, 2, 0, [], 0, 0],
      [2, b[1] || "rgba(232,14,14,1)", 3, 2, 0, [], 0, 0],
      [2, b[1] || "rgba(232,14,14,1)", 5, 2, 0, [], 0, 0],
      [2, b[1] || "rgba(232,14,14,1)", 6, 2, 0, [], 0, 0],
      [2, b[3] || "rgba(181,0,0,1)", 2, 2, 0, [], 0, 0],
      [2, b[3] || "rgba(181,0,0,1)", 3, 2, 0, [], 0, 0],
      [2, b[3] || "rgba(181,0,0,1)", 3, 2, 0, [], 0, 0],
      [2, b[3] || "rgba(181,0,0,1)", 5, 2, 0, [], 0, 0],
      [2, b[3] || "rgba(181,0,0,1)", 6, 2, 0, [], 0, 0],
      [2, "rgba(255,255,255,1)", 4, 0, 0, [], 0, 0],
      [2, "rgba(255,255,255,1)", 5.5, 0, 0, [], 0, 0],
      [2, "rgba(255,255,255,1)", 7, 0, 0, [], 0, 0],
      [2, "rgba(255,255,255,1)", 8.5, 0, 0, [], 0, 0],
      [2, "rgba(255,255,255,1)", 10, 0, 0, [], 0, 0]
    ];
  };
  oa.prototype.setColors = function (b) {
    this.parseColors(b);
  };
  oa.prototype.initialize = function (b) {
    this._initialize || (this._initialize = !0);
  };
  oa.prototype.clearCache = function (b) {
    this.cache = {};
  };
  oa.prototype.setMap = function (b) {
    b ? ((this.map = b), this._initialize ? this.canvaslayer.show() : this.initialize(b)) : this.canvaslayer.hide();
  };
  oa.prototype.draw = function (b) {
    b = b || {};
    b.clearCache && this.clearCache();
    this.canvaslayer.draw();
  };
  oa.prototype.clear = function () {};
  oa.prototype.update = function () {
    var b = this.map,
      d = this.getDataZoom(),
      a = Math.pow(2, 18 - d),
      c = 256 * a,
      f = Ea.convertLL2MC(b.getCenter()),
      h = Math.ceil(f.lng / c),
      g = Math.ceil(f.lat / c),
      k = this.tileSize,
      l = d - Math.round(b.getZoom());
    0 < l && (k /= Math.pow(2, l));
    c = [h, g, ((f.lng - h * c) / c) * k, ((f.lat - g * c) / c) * k];
    h = b.getBounds();
    f = h.getNorthEast();
    h = h.getSouthWest();
    b.getSize();
    b.getSize();
    b = (f.lng - h.lng) / a;
    a = (f.lat - h.lat) / a;
    f = c[1] - Math.ceil((a / 2 - c[3]) / k);
    h = c[0] + Math.ceil((b / 2 + c[2]) / k);
    g = c[1] + Math.ceil((a / 2 + c[3]) / k);
    a = [];
    for (k = c[0] - Math.ceil((b / 2 - c[2]) / k); k < h; k++) for (c = f; c < g; c++) a.push([k, c, d]);
    this.tilesOrder = a;
    this._loadCount = {};
    for (k = 0; k < a.length; k++) (c = a[k][0]), (b = a[k][1]), (this._loadCount[c + "_" + b + "_" + a[k][2]] = !1);
    for (k = 0; k < a.length; k++) (c = a[k][0]), (b = a[k][1]), this.showTile(c, b, d);
  };
  oa.prototype.showTile = function (b, d, a) {
    this._parseDataAndDraw(b, d, a);
  };
  oa.prototype.drawCurrentData = function () {
    this.clear();
    for (var b = [], d = 0; d < this.tilesOrder.length; d++) {
      var a = this.tilesOrder[d][0],
        c = this.tilesOrder[d][1],
        f = this.tilesOrder[d][2],
        h = this.cache[this.getCacheKey(a, c, f)];
      if (h) for (a = this._drawFeatures(h, a, c, f), c = 0; c < a.length; c++) b.push(a[c]);
    }
    this.lineLayer.setData(b);
  };
  oa.prototype.isAllLoaded = function () {
    var b = !0,
      d;
    for (d in this._loadCount)
      if (!this._loadCount[d]) {
        b = !1;
        break;
      }
    return b;
  };
  oa.prototype.getCacheKey = function (b, d, a) {
    return b + "_" + d + "_" + a;
  };
  oa.prototype.getDataZoom = function () {
    var b = Math.round(this.map.getZoom());
    19 < b && (b = 19);
    return b;
  };
  oa.prototype._parseDataAndDraw = function (b, d, a) {
    var c = this,
      f = c.map,
      h = f.getCenter(),
      g = Math.round(f.getZoom()),
      k = this.getCacheKey(b, d, a),
      l = "_cbk" + (1e5 * Math.random()).toFixed(0),
      n = this.getTileUrl(b, d, a, "BMapGL." + l);
    BMapGL[l] = function (m) {
      c._loadCount[b + "_" + d + "_" + a] = !0;
      var p = f.getCenter(),
        n = Math.round(f.getZoom());
      p.equals(h) && n === g
        ? ((p = m.content && m.content.tf),
          m.data && (p = m.data),
          (c.cache[k] = p ? { traffic: p, precision: m.precision } : null),
          c.drawTogether && c.isAllLoaded() && c.drawCurrentData())
        : n !== g && c.clear();
      delete BMapGL[l];
    };
    void 0 !== c.cache[k] ? ((c._loadCount[b + "_" + d + "_" + a] = !0), c.drawTogether && c.isAllLoaded() && c.drawCurrentData()) : this.request(n);
  };
  oa.prototype.getTileUrl = function (b, d, a, c) {
    return "https://sp3.baidu.com/7_AZsjOpB1gCo2Kml5_Y_DAcsMJiwa/traffic/?qt=vtraffic&x=" + b + "&y=" + d + "&z=" + a + "&fn=" + c + "&t=" + new Date().getTime();
  };
  oa.prototype._drawFeatures = function (b, d, a, c) {
    var f = 10;
    c = Math.pow(2, 18 - c);
    this.map.getCenter();
    var h = this.tileSize;
    d = [d * h * c, (a + 1) * h * c];
    a = [];
    if (b && b.traffic) {
      f *= b.precision;
      b = b.traffic;
      h = 0;
      for (var g = b.length; h < g; h++) {
        var k = b[h],
          l = k[1];
        k = this.arrFeatureStyles[k[3]];
        var n = l[0] / f,
          m = -l[1] / f,
          p = [];
        p.push([d[0] + n * c, d[1] + m * c, 1]);
        for (var q = 2, t = l.length; q < t; q += 2) (n += l[q] / f), (m -= l[q + 1] / f), p.push([d[0] + n * c, d[1] + m * c, 1]);
        a.push({ color: k[1], geometry: { type: "LineString", coordinates: p } });
      }
    }
    return a;
  };
  oa.prototype.request = function (b, d) {
    if (d) {
      var a = (1e5 * Math.random()).toFixed(0);
      BMapGL._rd["_cbk" + a] = function (b) {
        d && d(b);
        delete BMapGL._rd["_cbk" + a];
      };
      b += "&callback=BMapGL._rd._cbk" + a;
    }
    var c = document.createElement("script");
    c.type = "text/javascript";
    c.charset = "utf-8";
    c.src = b;
    c.addEventListener
      ? c.addEventListener(
          "load",
          function (a) {
            a = a.target;
            a.parentNode.removeChild(a);
          },
          !1
        )
      : c.attachEvent &&
        c.attachEvent("onreadystatechange", function (a) {
          a = window.event.srcElement;
          !a || ("loaded" !== a.readyState && "complete" !== a.readyState) || a.parentNode.removeChild(a);
        });
    setTimeout(function () {
      document.getElementsByTagName("head")[0].appendChild(c);
      c = null;
    }, 1);
  };
  oa.prototype.getRGBA = function (b) {
    b >>>= 0;
    return "rgba(" + ((b >> 24) & 255) + "," + ((b >> 16) & 255) + "," + ((b >> 8) & 255) + "," + (b & 255) / 256 + ")";
  };
  oa.prototype.getLineCap = function (b) {
    return ["butt", "square", "round"][b];
  };
  oa.prototype.getLineJoin = function (b) {
    return ["miter", "bevel", "round"][b];
  };
  var Em = (function (b) {
      function d(a) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a));
        a.autoUpdate = !0;
        a.getOptions();
        var b = new wi({ color: "rgba(257, 254, 47, 0.9)", minZoom: 18, duration: 0.8, interval: 0.2, trailLength: 0.4 });
        a.lineLayer = b;
        a.children = [b];
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "initialize",
          value: function (a) {
            ib(d.prototype.__proto__ || N(d.prototype), "initialize", this).call(this, a);
            a = this.map.map;
            var b = new oa({});
            b.lineLayer = this.lineLayer;
            this.trafficTileManager = b;
            b.setMap(a);
            b.update();
            a.addEventListener("moveend", function () {
              b.update();
            });
            a.addEventListener("zoomend", function () {
              b.update();
            });
            a.addEventListener("ondraw", function () {});
          }
        },
        { key: "onOptionsChanged", value: function (a) {} },
        { key: "onDataChanged", value: function (a) {} },
        {
          key: "getDefaultOptions",
          value: function () {
            return {};
          }
        }
      ]);
      return d;
    })(jb),
    Fm = (function (b) {
      function d(a, b) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, b));
        a.name = "HeatmapLayer";
        a.bufferData = [];
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { size: 13, unit: "px", height: 0, max: 100, min: 0, opacity: 1, minOpacity: 0, maxOpacity: 1, blend: "normal" };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            var b = this;
            this.gl = a;
            var d = this.getOptions();
            this.inverseMatrix = L.create(Float64Array);
            this.frameBuffer = new ya(a);
            this.webglLayer.map.onResize(function () {
              b.frameBuffer = new ya(a);
            });
            this.circle = gj(64);
            this.circleTexture = ec(a, this.circle, {
              TEXTURE_MAG_FILTER: "LINEAR",
              TEXTURE_MIN_FILTER: "LINEAR",
              TEXTURE_WRAP_S: "CLAMP_TO_EDGE",
              TEXTURE_WRAP_T: "CLAMP_TO_EDGE"
            }).texture;
            this.intensity = new Ba({ gradient: d.gradient });
            this.paletteTexture = ec(a, this.intensity.paletteCtx.canvas, {
              TEXTURE_MAG_FILTER: "LINEAR",
              TEXTURE_MIN_FILTER: "LINEAR",
              TEXTURE_WRAP_S: "CLAMP_TO_EDGE",
              TEXTURE_WRAP_T: "CLAMP_TO_EDGE"
            }).texture;
            this.offlineProgram = new X(
              this.gl,
              {
                vertexShader:
                  "uniform mat4 u_matrix;uniform mat4 pointToPixelMatrix;uniform mat4 pixelToViewMatrix;uniform mat4 projectionMatrix;uniform int unit;uniform float size;uniform float max;uniform float min;attribute vec3 aPos;attribute vec2 aOffset;attribute float aCount;varying vec2 vOffset;varying float vCount;varying vec3 vPosition;void main(){vOffset=aOffset;vCount=(aCount-min)/(max-min);if(unit==1){vec2 pos=(pointToPixelMatrix*vec4(aPos.xy,0.0,1.0)).xy+aOffset.xy*size/2.0;gl_Position=projectionMatrix*pixelToViewMatrix*vec4(pos,0.0,1.0);}else{vec2 pos=aPos.xy+aOffset.xy*size;gl_Position=u_matrix*vec4(pos,0.0,1.0);}vPosition=vec3(gl_Position.z/gl_Position.w);}",
                fragmentShader:
                  "varying vec2 vOffset;varying float vCount;varying vec3 vPosition;uniform sampler2D uCircle;void main(){vec4 circle=texture2D(uCircle,(vOffset+1.0)/2.0);float intensity=circle.a*vCount;if(intensity<=0.0){discard;}gl_FragColor=vec4(vPosition,intensity);}"
              },
              this
            );
            this.offlineBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.offlineIndexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.offlineVertexArray = new fa({
              gl: a,
              program: this.offlineProgram,
              attributes: [
                { stride: 24, name: "aPos", buffer: this.offlineBuffer, size: 3, type: "FLOAT", offset: 0 },
                { stride: 24, name: "aOffset", buffer: this.offlineBuffer, size: 2, type: "FLOAT", offset: 12 },
                { stride: 24, name: "aCount", buffer: this.offlineBuffer, size: 1, type: "FLOAT", offset: 20 }
              ]
            });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "attribute vec2 aPos;varying vec2 vPos;uniform float uHeight;uniform mat4 pixelToViewMatrix;uniform mat4 projectionMatrix;uniform sampler2D u_sampler;uniform mat4 inverseMatrix;void main(){vPos=aPos;if(uHeight<=0.0){gl_Position=vec4(aPos,0.0,1.0);}else{vec4 gray=texture2D(u_sampler,(aPos+1.0)/2.0);vec4 m0=inverseMatrix*vec4(aPos.xy,0.0,1.0);vec4 m1=inverseMatrix*vec4(aPos.xy,1.0,1.0);m0/=m0.w;m1/=m1.w;vec4 pixel=m0+(-m0.z/(m1.z-m0.z))*(m1-m0);pixel.z=uHeight*gray.a;gl_Position=projectionMatrix*pixelToViewMatrix*vec4(pixel.xyz,1.0);}}",
                fragmentShader:
                  "uniform sampler2D u_sampler;uniform sampler2D u_samplerPalette;uniform float uHeight;uniform float opacity;uniform float minOpacity;uniform float maxOpacity;uniform bool u_strict;varying vec2 vPos;void main(){vec4 gray=texture2D(u_sampler,(vPos+1.0)/2.0);float grayAlpha=gray.a;if(grayAlpha<=0.0){discard;}gl_FragColor=texture2D(u_samplerPalette,vec2(grayAlpha,1.0));float addAlpha=1.0;if(gray.a<0.3){addAlpha=gray.a*3.3;}gl_FragColor.a*=addAlpha;gl_FragColor.a=max(gl_FragColor.a,minOpacity);gl_FragColor.a=min(gl_FragColor.a,maxOpacity);gl_FragColor.a*=opacity;}"
              },
              this
            );
            this.buffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: [{ stride: 8, name: "aPos", buffer: this.buffer, size: 2, type: "FLOAT", offset: 0 }] });
            d = [];
            for (var h = [], g = Math.floor(a.canvas.width / 4), k = Math.floor(a.canvas.height / 4), l = g + 1, n = 0; n <= k; n++)
              for (var m = 0; m <= g; m++)
                if ((d.push((2 * m) / g - 1, (2 * n) / k - 1), m < g && n < k)) {
                  var p = l * n + m,
                    q = l * (n + 1) + m;
                  h.push(p, p + 1, q + 1);
                  h.push(p, q + 1, q);
                }
            this.bufferData = d;
            this.buffer.updateData(new Float32Array(d));
            this.indexData = h;
            this.indexBuffer.updateData(new Uint32Array(h));
          }
        },
        {
          key: "onDestroy",
          value: function () {
            this.bufferData = [];
          }
        },
        {
          key: "onOptionsChanged",
          value: function (a, b) {
            var c = this.gl;
            c &&
              a.gradient !== b.gradient &&
              ((this.intensity = new Ba({ gradient: a.gradient })),
              (this.paletteTexture = ec(c, this.intensity.paletteCtx.canvas, {
                TEXTURE_MAG_FILTER: "LINEAR",
                TEXTURE_MIN_FILTER: "LINEAR",
                TEXTURE_WRAP_S: "CLAMP_TO_EDGE",
                TEXTURE_WRAP_T: "CLAMP_TO_EDGE"
              }).texture));
          }
        },
        {
          key: "onDataChanged",
          value: function (a) {
            if (this.gl) {
              var b = [],
                d = [];
              this.getOptions();
              for (var h = 0; h < a.length; h++) {
                var g = a[h],
                  k = this.normizedPoint(a[h].geometry.coordinates),
                  l = void 0 === g.count ? 1 : g.count;
                "properties" in g && "count" in g.properties && (l = g.properties.count);
                b.push(k[0], k[1], k[2]);
                b.push(-1, -1);
                b.push(l);
                b.push(k[0], k[1], k[2]);
                b.push(-1, 1);
                b.push(l);
                b.push(k[0], k[1], k[2]);
                b.push(1, 1);
                b.push(l);
                b.push(k[0], k[1], k[2]);
                b.push(1, -1);
                b.push(l);
                g = 4 * h;
                d.push(g + 0, g + 2, g + 1);
                d.push(g + 0, g + 3, g + 2);
              }
              this.offlineBufferData = b;
              this.offlineIndexData = d;
              this.offlineBuffer.updateData(new Float32Array(b));
              this.offlineIndexBuffer.updateData(new Uint32Array(d));
            }
          }
        },
        {
          key: "render",
          value: function (a) {
            var b = a.gl,
              d = a.matrix,
              h = a.pointToPixelMatrix,
              g = a.pixelToViewMatrix;
            a = a.projectionMatrix;
            if (this.offlineBufferData && !(0 >= this.offlineBufferData.length)) {
              var k = this.getOptions();
              this.setGLState({ blend: !0, blendFunc: [b.ONE, b.ONE], depthTest: !1 });
              b.bindFramebuffer(b.FRAMEBUFFER, this.frameBuffer.framebuffer);
              b.clearColor(0, 0, 0, 0);
              b.clear(b.COLOR_BUFFER_BIT);
              this.offlineProgram.use(b);
              this.offlineProgram.setUniforms({
                u_matrix: d,
                uCircle: this.circleTexture,
                pointToPixelMatrix: h,
                pixelToViewMatrix: g,
                projectionMatrix: a,
                unit: "px" === k.unit ? 1 : 0,
                size: k.size,
                max: k.max,
                min: k.min
              });
              this.offlineVertexArray.bind();
              this.offlineIndexBuffer.bind();
              b.drawElements(b.TRIANGLES, this.offlineIndexData.length, b.UNSIGNED_INT, 0);
              b.bindFramebuffer(b.FRAMEBUFFER, null);
              this.program.use(b);
              this.vertexArray.bind();
              d = this.inverseMatrix;
              L.identity(d);
              L.multiply(d, a, g);
              L.invert(d, d);
              this.setGLState({ blend: !0, blendFunc: Va(b, k.blend), depthTest: k.height ? !0 : !1 });
              this.program.setUniforms({
                u_sampler: this.frameBuffer.framebuffer.texture,
                u_samplerPalette: this.paletteTexture,
                uHeight: k.height,
                opacity: k.opacity,
                minOpacity: k.minOpacity,
                maxOpacity: k.maxOpacity,
                pixelToViewMatrix: g,
                inverseMatrix: d,
                projectionMatrix: a
              });
              this.indexBuffer.bind();
              b.drawElements(b.TRIANGLES, this.indexData.length, b.UNSIGNED_INT, 0);
            }
          }
        }
      ]);
      return d;
    })(ca),
    Gm = (function (b) {
      function d(a, b) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, b));
        a.name = "BarLayer";
        a.selectedColor = [-1, -1, -1];
        a.textureCache = {};
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { color: "rgba(0, 180, 0, 1.0)", edgeCount: 4, unit: "m", height: 1e5, type: "normal", size: 5e4 };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var b = this.getOptions(),
              d = {
                normal: [
                  "attribute vec3 aPos;attribute vec4 aColor;attribute float aSize;attribute float aEdgeIndex;attribute float aPointIndex;attribute float aEdgeCount;varying vec4 vColor;varying vec4 vPosition;varying vec4 vFragPosition;varying float vSize;varying float vEdgeIndex;varying float vPointIndex;varying float vEdgeCount;uniform mat4 uMatrix;uniform float uZoomUnits;uniform vec4 uSelectedColor;void main(){vColor=aColor;vEdgeIndex=aEdgeIndex;vEdgeCount=aEdgeCount;vPointIndex=aPointIndex;float z=aPos.z*uZoomUnits;float x=aPos.x;float y=aPos.y;vSize=aSize*uZoomUnits;float a=radians(360.0/aEdgeCount);float b=a/2.0;float r=vSize/cos(b);if(aEdgeIndex<0.0){float index=aPointIndex;float angle=0.0;if(mod(index,2.0)==0.0){angle=a*(index/2.0)-b;}else{angle=-a*((index-1.0)/2.0)-b;}y=y+r*sin(angle);x=x+r*cos(angle);}else{float i=aEdgeIndex-1.0;float j=aPointIndex;float angle=a*i+b;y=y+r*sin(angle);x=x+r*cos(angle);}vPosition=vec4(aPos,1.0);vFragPosition=vec4(x,y,z,1.0);gl_Position=uMatrix*vFragPosition;if(aEdgeIndex==1.0&&aPointIndex==1.0){gl_PointSize=20.0;}else{gl_PointSize=10.0;}\n#if defined(PICK)\nif(mapvIsPicked()){vColor=uSelectedColor;}\n#endif\n}",
                  "varying vec4 vColor;varying float vEdgeIndex;varying float vPointIndex;varying float vEdgeCount;varying vec4 vPosition;varying vec4 vFragPosition;uniform mat4 uMatrix;void main(){vec4 color=vColor;if(vEdgeIndex<0.0){color.r+=0.2;color.g+=0.2;color.b+=0.2;}else{float i=ceil(vEdgeIndex);;float d=i/vEdgeCount*0.5;if(i<=vEdgeCount/2.0){d=0.2*(i/vEdgeCount*0.5)-0.1;}else{d=0.2*(vEdgeCount-i)/vEdgeCount*0.5-0.1;}color.r+=d;color.g+=d;color.b+=d;}gl_FragColor=color;}"
                ],
                light: [
                  "attribute vec3 aPos;attribute vec4 aColor;attribute float aSize;attribute float aEdgeIndex;attribute float aPointIndex;attribute float aEdgeCount;varying vec4 vColor;varying vec4 vPosition;varying vec4 vFragPosition;varying float vSize;varying float vEdgeIndex;varying float vPointIndex;varying float vEdgeCount;uniform mat4 uMatrix;uniform float uZoomUnits;uniform vec4 uSelectedColor;void main(){vColor=aColor;vEdgeIndex=aEdgeIndex;vEdgeCount=aEdgeCount;vPointIndex=aPointIndex;float z=aPos.z*uZoomUnits;float x=aPos.x;float y=aPos.y;vSize=aSize*uZoomUnits;float a=radians(360.0/aEdgeCount);float b=a/2.0;float i=aEdgeIndex;float j=aPointIndex;float angle=a*(i-1.0)+b;float r=vSize/cos(b);y=y+r*sin(angle);x=x+r*cos(angle);if(j==1.0){z=0.0;}vPosition=vec4(aPos.xyz,1.0);vFragPosition=vec4(x,y,z,1.0);gl_Position=uMatrix*vFragPosition;\n#if defined(PICK)\nif(mapvIsPicked()){vColor=uSelectedColor;}\n#endif\n}",
                  "varying vec4 vColor;varying float vEdgeIndex;varying float vPointIndex;varying float vEdgeCount;varying vec4 vPosition;varying vec4 vFragPosition;uniform mat4 uMatrix;void main(){vec4 color=vColor;color.a=1.0-vFragPosition.z/vPosition.z;gl_FragColor=color;}"
                ]
              };
            d = d[b.type] || d.normal;
            this.program = new X(this.gl, { vertexShader: d[0], fragmentShader: d[1], defines: b.enablePicked ? ["PICK"] : [] }, this);
            this.buffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            b = [
              { stride: 44, name: "aPos", buffer: this.buffer, size: 3, type: "FLOAT", offset: 0 },
              { stride: 44, name: "aSize", buffer: this.buffer, size: 1, type: "FLOAT", offset: 12 },
              { stride: 44, name: "aEdgeIndex", buffer: this.buffer, size: 1, type: "FLOAT", offset: 16 },
              { stride: 44, name: "aPointIndex", buffer: this.buffer, size: 1, type: "FLOAT", offset: 20 },
              { stride: 44, name: "aEdgeCount", buffer: this.buffer, size: 1, type: "FLOAT", offset: 24 },
              { stride: 44, name: "aColor", buffer: this.buffer, size: 4, type: "FLOAT", offset: 28 }
            ];
            b = b.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: b });
          }
        },
        {
          key: "onChanged",
          value: function (a, b) {
            this.gl && b && ((this.uniforms = {}), (this.data = b), (this.options = a), this.processData(), a.enablePicked && this.parsePickData(b));
          }
        },
        {
          key: "processData",
          value: function () {
            var a = [],
              b = [];
            "light" === this.options.type ? this.createLightBuffer(this.data, a, b) : this.createNormalBuffer(this.data, a, b);
            this.bufferData = a;
            this.indexData = b;
            this.buffer.updateData(new Float32Array(a));
            this.indexBuffer.updateData(new Uint32Array(b));
          }
        },
        {
          key: "createNormalBuffer",
          value: function (a, b, d) {
            var c = this,
              f = parseInt(this.options.edgeCount, 10) || 4;
            a.forEach(function (a, g) {
              var h = a.color || c.options.color,
                k = a.size || c.options.size,
                l = Array.isArray(a.value) ? a.value : "number" === typeof a.value ? [a.value] : [1],
                q = c.normizedPoint(a.geometry.coordinates),
                t = a.height || c.options.height,
                v = l.reduce(function (a, b) {
                  return Number(a) + Number(b);
                }),
                r = 0,
                u = "blue";
              l.forEach(function (a, g) {
                u = c.normizedColor("function" === typeof h ? h(a, g, l) : Array.isArray(h) ? h[g] : h);
                a = "function" === typeof t ? t(a, g, l) : Array.isArray(t) ? t[g] : (t / v) * a;
                var m = d[d.length - 1],
                  p = b.length / 11;
                0 < p && (1 === f % 2 && 0 === g ? d.push(m, m, p) : d.push(m, p));
                for (g = 1; g <= 2 * f; g++)
                  0 === g % 2 ? b.push.apply(b, [q[0], q[1], r, k, g / 2, 2, f].concat(W(u))) : b.push.apply(b, [q[0], q[1], r + a, k, (g + 1) / 2, 1, f].concat(W(u))),
                    d.push(p + g - 1),
                    g === 2 * f &&
                      (b.push.apply(b, [q[0], q[1], r + a, k, g / 2 + 1, 1, f].concat(W(u))),
                      b.push.apply(b, [q[0], q[1], r, k, g / 2 + 1, 2, f].concat(W(u))),
                      d.push(p + g, p + g + 1));
                r += a;
              });
              g = d[d.length - 1];
              a = b.length / 11;
              0 < a && d.push(g, a);
              for (g = 1; g <= f; g++) b.push.apply(b, [q[0], q[1], r, k, -1, g, f].concat(W(u))), d.push(a + g - 1);
            });
          }
        },
        {
          key: "createLightBuffer",
          value: function (a, b, d) {
            var c = this,
              f = parseInt(this.options.edgeCount, 10) || 4;
            a.forEach(function (a, g) {
              g = a.color || c.options.color;
              g = c.normizedColor("function" === typeof g ? g(a.value) : "string" === typeof g ? g : "blue");
              var h = a.size || c.options.size,
                k = c.normizedPoint(a.geometry.coordinates),
                l = a.height || c.options.height;
              l = "function" === typeof l ? l(a.value) : l;
              for (a = 1; a <= f; a++) {
                var q = d[d.length - 1],
                  t = b.length / 11;
                0 < t && d.push(q, t);
                for (q = 1; q <= 2 * f; q++)
                  0 === q % 2 ? b.push.apply(b, [k[0], k[1], l, h, q / 2, 1, f].concat(W(g))) : b.push.apply(b, [k[0], k[1], l, h, (q + 1) / 2, 2, f].concat(W(g))),
                    d.push(t + q - 1),
                    q === 2 * f && d.push(t, t + 1);
              }
            });
          }
        },
        {
          key: "render",
          value: function (a) {
            var b = this.program,
              d = a.gl,
              h = a.matrix;
            this.setGLState({ cullFace: "normal" === this.options.type });
            b.use(d);
            this.vertexArray.bind();
            this.indexBuffer.bind();
            var g = this.map.getZoomUnits();
            S(this.uniforms, this.getCommonUniforms(a), { uZoomUnits: "px" === this.options.unit ? g : 1, uMatrix: h });
            b.setUniforms(this.uniforms);
            d.drawElements(d.TRIANGLE_STRIP, this.indexData.length, d.UNSIGNED_INT, 0);
          }
        }
      ]);
      return d;
    })(ca),
    Hm = (function (b) {
      function d(a) {
        F(this, d);
        var b = Q(this, (d.__proto__ || N(d)).call(this, a));
        a = b.getOptions();
        b.fillPoint = new md({ enablePicked: a.enablePicked, autoSelect: a.autoSelect });
        b.shadowPoint = new md();
        b.textPoint = new rc();
        b.children = [b.shadowPoint, b.fillPoint, b.textPoint];
        return b;
      }
      R(d, b);
      I(d, [
        {
          key: "pick",
          value: function (a, b) {
            return this.fillPoint.pick(a, b);
          }
        },
        {
          key: "onOptionsChanged",
          value: function (a) {
            this.shadowPoint.setOptions({
              depthTest: !1,
              polygonOffset: [1, 1],
              color: a.shadowColor,
              size: a.shadowSize,
              borderWidth: a.shadowBorderWidth,
              borderColor: a.shadowBorderColor
            });
            this.fillPoint.setOptions({
              onClick: function (b) {
                a.onClick && a.onClick(b);
              },
              selectedIndex: a.selectedIndex,
              selectedColor: a.selectedColor,
              depthTest: !1,
              color: a.fillColor,
              size: a.fillSize,
              borderWidth: a.fillBorderWidth,
              borderColor: a.fillBorderColor
            });
            this.textPoint.setOptions({ collides: !1, polygonOffset: [-1, -1], color: a.fontColor, fontFamily: a.fontFamily, fontSize: a.fontSize });
          }
        },
        {
          key: "onDataChanged",
          value: function (a) {
            var b = this,
              d = this.getOptions(),
              h = JSON.parse(yc(a)).map(function (a) {
                a.properties.size = b.getProperty("shadowSize", d.shadowSize, a);
                a.properties.color = b.getProperty("shadowColor", d.shadowColor, a);
                a.properties.borderColor = b.getProperty("shadowBorderColor", d.shadowBorderColor, a);
                a.properties.borderWidth = b.getProperty("shadowBorderWidth", d.shadowBorderWidth, a);
                return a;
              }),
              g = JSON.parse(yc(a)).map(function (a) {
                a.properties.size = b.getProperty("fillSize", d.fillSize, a);
                a.properties.color = b.getProperty("fillColor", d.fillColor, a);
                a.properties.borderColor = b.getProperty("fillBorderColor", d.fillBorderColor, a);
                a.properties.borderWidth = b.getProperty("fillBorderWidth", d.fillBorderWidth, a);
                return a;
              });
            this.shadowPoint.setData(h);
            this.fillPoint.setData(g);
            this.textPoint.setData(a);
          }
        },
        {
          key: "getProperty",
          value: function (a, b, d) {
            if ("[object Function]" === Object.prototype.toString.call(b)) return b(d);
            b = d[a] || b;
            "properties" in d && a in d.properties && (b = d.properties[a]);
            return b;
          }
        },
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              enablePicked: !1,
              selectedIndex: -1,
              selectedColor: "#ffff00",
              autoSelect: !0,
              fillColor: "rgba(255, 50, 10, 1)",
              fillSize: 20,
              fillBorderColor: "#ffffff",
              fillBorderWidth: 1.2,
              shadowColor: "rgba(255, 80, 110, 0.7)",
              shadowSize: 40,
              shadowBorderColor: "rgba(255, 80, 110, 1)",
              shadowBorderWidth: 1.2,
              fontSize: 12,
              fontFamily: "Microsoft Yahei",
              fontColor: "#ffffff"
            };
          }
        }
      ]);
      return d;
    })(jb),
    Im = (function (b) {
      function d(a, b) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, b));
        a.name = "MaskLayer";
        a.bufferData = [];
        a.indices = [];
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return { blend: "deeper", color: "rgba(100, 100, 100, 0.6)", height: 0, polygonOffset: [0, 0], depthTest: !1, depthWrite: !1 };
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;attribute vec2 a_position;uniform mat4 u_matrix;uniform float u_height;void main(){vec4 position=u_matrix*vec4(a_position.xy,u_height,1.0);gl_Position=position;}",
                fragmentShader: "precision highp float;uniform vec4 u_color;void main(){gl_FragColor=u_color;}",
                defines: []
              },
              this
            );
            this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            var b = [{ stride: 8, name: "a_position", buffer: this.vertexBuffer, size: 2, type: "FLOAT", offset: 0 }];
            b = b.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: b });
          }
        },
        {
          key: "onDestroy",
          value: function () {
            this.bufferData = [];
            this.index = [];
          }
        },
        {
          key: "onChanged",
          value: function (a, b) {
            var c = this;
            if (this.gl) {
              a = [];
              for (var d = [], g = 0; g < b.length; g++)
                if (b[g].geometry.coordinates) {
                  var k = [[this.normizedPoint([-180, -90]), this.normizedPoint([180, -90]), this.normizedPoint([180, 90]), this.normizedPoint([-180, 90])]],
                    l = [];
                  "LineString" === b[g].geometry.type &&
                    (l = [
                      b[g].geometry.coordinates.map(function (a) {
                        return c.normizedPoint(a);
                      })
                    ]);
                  if ("MultiPolygon" === b[g].geometry.type)
                    for (var n = b[g].geometry.coordinates, m = 0; m < n.length; m++)
                      l = l.concat(
                        n[m].map(function (a) {
                          return a.map(function (a) {
                            return c.normizedPoint(a);
                          });
                        })
                      );
                  else
                    for (n = 0; n < b[g].geometry.coordinates.length; n++)
                      l.push(
                        b[g].geometry.coordinates[n].map(function (a) {
                          return c.normizedPoint(a);
                        })
                      );
                  l = Fa.flatten(k.concat(l));
                  k = l.vertices;
                  l = l.holes;
                  n = [];
                  for (m = 0; m < k.length; m += 3) n.push(k[m + 0], k[m + 1]);
                  this.parseBufferData(a, d, n, l);
                }
              this.bufferData = a;
              this.index = d;
              this.vertexBuffer.updateData(new Float32Array(a));
              this.indexBuffer.updateData(new Uint32Array(d));
            }
          }
        },
        {
          key: "parseBufferData",
          value: function (a, b, d, h) {
            var c = a.length / 2;
            h = h && h.length ? Fa(d, h, 2) : Fa(d);
            a.push.apply(a, W(d));
            for (a = 0; a < h.length; a++) b.push(h[a] + c);
          }
        },
        {
          key: "render",
          value: function (a) {
            if (this.index && this.index.length) {
              var b = a.gl,
                d = a.matrix,
                h = this.getOptions(),
                g = this.program;
              g.use(b);
              a = S(this.getCommonUniforms(a), { u_matrix: d, u_height: h.height, u_color: this.normizedColor(h.color) });
              g.setUniforms(a);
              this.setGLState({ blend: !0, blendFunc: Va(b, h.blend), polygonOffset: h.polygonOffset, depthTest: h.depthTest, depthMask: h.depthWrite });
              this.indexBuffer.bind();
              this.vertexArray.bind();
              b.drawElements(b.TRIANGLES, this.index.length, b.UNSIGNED_INT, 0);
            }
          }
        }
      ]);
      return d;
    })(ca),
    Jm = (function (b) {
      function d() {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).apply(this, arguments));
      }
      R(d, b);
      I(d, [
        {
          key: "toBBox",
          value: function (a) {
            var b = da(a.item.geometry.coordinates, 2);
            a = b[0];
            b = b[1];
            return { minX: a, minY: b, maxX: a, maxY: b };
          }
        },
        {
          key: "compareMinX",
          value: function (a, b) {
            return a.item.geometry.coordinates[0] - b.item.geometry.coordinates[0];
          }
        },
        {
          key: "compareMinY",
          value: function (a, b) {
            return a.item.geometry.coordinates[1] - b.item.geometry.coordinates[1];
          }
        }
      ]);
      return d;
    })(qc),
    Km = (function (b) {
      function d(a, b) {
        F(this, d);
        a = Q(this, (d.__proto__ || N(d)).call(this, a, b));
        a.name = "PointCanvasCustomLayer";
        b = a.canvas = document.createElement("canvas");
        a.ctx = b.getContext("2d");
        a.geoRBush = new Jm();
        return a;
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {
              depthWrite: !1,
              depthTest: !0,
              color: "#fff",
              fontFamily: "Microsoft Yahei",
              fontSize: 14,
              flat: !1,
              collides: !0,
              unit: "px",
              angle: 0,
              offset: [0, 0],
              padding: [2, 2],
              margin: [0, 0],
              polygonOffset: [0, 0],
              itemDimension: [20, 20],
              renderItem: this.defaultOptionRenderItem
            };
          }
        },
        {
          key: "defaultOptionRenderItem",
          value: function (a, b, d) {
            d.fillStyle = "red";
            d.fillRect(b.x, b.y, b.w, b.h);
          }
        },
        {
          key: "initialize",
          value: function (a) {
            this.gl = a;
            var b = this.getOptions();
            this.texture = null;
            this.lastUpdateTime = 0;
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;uniform mat4 matrix;uniform bool uFlat;uniform bool uUnitPx;uniform float zoomUnits;uniform float devicePixelRatio;uniform float zIndex;uniform vec2 offset;attribute vec3 position;attribute float corner;attribute float scale;attribute float rotation;attribute vec2 size;attribute vec2 aTextCoord;varying vec2 vTextCoord;/***\u70b9A(x,y)\uff0c\u7ed5\u539f\u70b9\u987a\u65f6\u9488\u65cb\u8f6c\u89d2\u5ea6a\u65b0\u5750\u6807\u7684\u8ba1\u7b97\u516c\u5f0f*x1=x*cos(a)+y*sin(a)*y1=y*cos(a)-x*sin(a)*/vec3 transformCoord(vec3 coord,vec2 size,float corner){float x=coord.x;float y=coord.y;if(corner==1.0){x+=-size.x*cos(rotation)+size.y*sin(rotation);y+=size.y*cos(rotation)+size.x*sin(rotation);}else if(corner==2.0){x+=size.x*cos(rotation)+size.y*sin(rotation);y+=size.y*cos(rotation)-size.x*sin(rotation);}else if(corner==3.0){x+=size.x*cos(rotation)-size.y*sin(rotation);y+=-size.y*cos(rotation)-size.x*sin(rotation);}else{x+=-size.x*cos(rotation)-size.y*sin(rotation);y+=-size.y*cos(rotation)+size.x*sin(rotation);}return vec3(x,y,coord.z);}void main(){vTextCoord=aTextCoord;if(uFlat){vec2 pixelOffset=offset;vec2 halfSize=size/2.0*scale;if(uUnitPx){halfSize*=zoomUnits;pixelOffset*=zoomUnits;}vec3 current=transformCoord(position,halfSize,corner);current.z+=zIndex;gl_Position=matrix*vec4(current.x+pixelOffset[0],current.y-pixelOffset[1],current.z,1.0);}else{vec2 pixelOffset=offset*zoomUnits;vec4 projection=matrix*vec4(position.x+pixelOffset[0],position.y-pixelOffset[1],position.z,1.0);vec3 screen=projection.xyz/projection.w;vec2 halfSize=size/MAPV_resolution*devicePixelRatio*scale;vec3 current=transformCoord(screen,halfSize,corner);current.z+=zIndex;gl_Position=vec4(current,1.0);}}",
                fragmentShader:
                  "precision highp float;uniform sampler2D textureImage;uniform vec4 uSelectedColor;varying vec2 vTextCoord;void main(){gl_FragColor=texture2D(textureImage,vec2(vTextCoord.x,1.0-vTextCoord.y));\n#if defined(PICK)\nif(mapvIsPicked()){gl_FragColor=vec4(uSelectedColor.rgb,gl_FragColor.a);}\n#endif\n}",
                defines: b.enablePicked ? ["PICK"] : []
              },
              this
            );
            this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.uvBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            b = [
              { name: "position", buffer: this.vertexBuffer, size: 3, stride: 32, type: "FLOAT", offset: 0 },
              { name: "corner", buffer: this.vertexBuffer, size: 1, stride: 32, type: "FLOAT", offset: 12 },
              { name: "size", buffer: this.vertexBuffer, size: 2, stride: 32, type: "FLOAT", offset: 16 },
              { name: "scale", buffer: this.vertexBuffer, size: 1, stride: 32, type: "FLOAT", offset: 24 },
              { name: "rotation", buffer: this.vertexBuffer, size: 1, stride: 32, type: "FLOAT", offset: 28 },
              { name: "aTextCoord", buffer: this.uvBuffer, size: 2, stride: 8, type: "FLOAT", offset: 0 }
            ];
            b = b.concat(this.getCommonAttributes());
            this.vertexArray = new fa({ gl: a, program: this.program, attributes: b });
          }
        },
        { key: "onDestroy", value: function () {} },
        {
          key: "onChanged",
          value: function (a, b) {
            this.gl && this.processCache(a, b);
          }
        },
        {
          key: "processCache",
          value: function (a, b) {
            this.cachedData = [];
            this.geoRBush.clear();
            for (a = 0; a < b.length; a++) {
              var c = b[a],
                d = this.normizedPoint(c.geometry.coordinates);
              d && this.cachedData.push({ point: d, item: c, extra: {}, index: a });
            }
            this.geoRBush.load(this.cachedData);
          }
        },
        {
          key: "render",
          value: function (a) {
            if (this.cachedData && this.cachedData.length && this.map) {
              var b = a.gl,
                d = a.matrix,
                h = this.getOptions(),
                g = this.program;
              g.use(b);
              this.throttleUpdate(a);
              this.setGLState({
                blend: !0,
                blendEquation: b.FUNC_ADD,
                blendFunc: [b.SRC_ALPHA, b.ONE_MINUS_SRC_ALPHA],
                polygonOffset: h.polygonOffset,
                depthTest: h.depthTest,
                depthMask: h.depthWrite
              });
              var k = this.map.getZoomUnits();
              g.setUniforms(
                S(this.getCommonUniforms(a), {
                  matrix: d,
                  devicePixelRatio: window.devicePixelRatio,
                  textureImage: this.texture,
                  uFlat: h.flat,
                  offset: h.offset,
                  zoomUnits: k,
                  zIndex: h.zIndex,
                  uUnitPx: "px" === h.unit
                })
              );
              0 < this.index.length && (this.indexBuffer.bind(), this.vertexArray.bind(), b.drawElements(b.TRIANGLES, this.index.length, b.UNSIGNED_INT, 0));
            }
          }
        },
        {
          key: "throttleUpdate",
          value: function (a) {
            this.updateText(a);
          }
        },
        {
          key: "updateText",
          value: function (a) {
            var b = a.gl,
              d = a.matrix,
              h = this.getOptions(),
              g = h.padding,
              k = h.margin,
              l = h.collides;
            a = h.enablePicked;
            var n = h.itemDimension,
              m = h.beforeRenderAll,
              p = h.beforeComputeDimension;
            h = h.renderItem;
            var q = this.map.getBounds(),
              t = b.canvas.width / window.devicePixelRatio,
              v = b.canvas.height / window.devicePixelRatio,
              r = this.canvas;
            b = this.ctx;
            b.save();
            b.scale(window.devicePixelRatio, window.devicePixelRatio);
            p && p(b);
            q = this.geoRBush.search({ minX: q.sw.lng, minY: q.sw.lat, maxX: q.ne.lng, maxY: q.ne.lat });
            var u = new qc();
            p = [];
            for (var w = 0; w < q.length; w++) {
              var y = q[w],
                x = y.point,
                z = y.item,
                C = y.extra;
              y = y.index;
              var A = da(x, 3);
              A = na.clone([A[0], A[1], A[2], 1]);
              na.transformMat4(A, A, d);
              na.scale(A, A, 1 / A[3]);
              var B = ((A[0] + 1) / 2) * t,
                F = ((-A[1] + 1) / 2) * v;
              var G = Array.isArray(n) ? n : n(z, b, C);
              A = G[0] + 2 * g[0];
              G = G[1] + 2 * g[1];
              var I = A + k[0],
                H = G + k[1];
              B -= I / 2;
              F -= H / 2;
              I = B + I;
              H = F + H;
              if (!(0 > I || 0 > H || B > t || F > v)) {
                if (l) {
                  H = { minX: B, maxX: I, minY: F, maxY: H };
                  if (u.collides(H)) continue;
                  u.insert(H);
                }
                p.push({ w: A, h: G, point: x, item: z, extra: C, dataIndex: y });
              }
            }
            b.restore();
            g = zb(p);
            d = g.w;
            g = g.h;
            0 >= d && (d = 1);
            0 >= g && (g = 1);
            r.width = d * window.devicePixelRatio;
            r.height = g * window.devicePixelRatio;
            b.save();
            b.scale(window.devicePixelRatio, window.devicePixelRatio);
            m && m(b);
            m = [];
            r = [];
            k = [];
            l = [];
            n = 0;
            for (t = p.length; n < t; ++n) {
              v = p[n];
              h(v.item, v, b, v.extra);
              w = da(v.point, 3);
              q = w[0];
              u = w[1];
              w = w[2];
              for (x = 0; 4 > x; x++) m.push(q, u, w), m.push(x), m.push(v.w, v.h), m.push(1, 0);
              q = v.x / d;
              u = (v.x + v.w) / d;
              w = (v.y + v.h) / g;
              x = v.y / g;
              r.push(q, w, q, x, u, x, u, w);
              q = 4 * n;
              k.push(q, q + 2, q + 1, q, q + 3, q + 2);
              a &&
                ((v = this.indexToRgb(v.dataIndex)),
                l.push(v[0] / 255, v[1] / 255, v[2] / 255),
                l.push(v[0] / 255, v[1] / 255, v[2] / 255),
                l.push(v[0] / 255, v[1] / 255, v[2] / 255),
                l.push(v[0] / 255, v[1] / 255, v[2] / 255));
            }
            b.restore();
            this.loadTexture();
            this.index = k;
            this.vertexBuffer.updateData(new Float32Array(m));
            this.uvBuffer.updateData(new Float32Array(r));
            this.indexBuffer.updateData(new Uint32Array(k));
            a && this.pickBuffer.updateData(new Float32Array(l));
          }
        },
        {
          key: "loadTexture",
          value: function () {
            var a = this;
            this.canvas
              ? ta(
                  this.gl,
                  this.canvas,
                  function (b) {
                    a.texture = b;
                  },
                  { TEXTURE_WRAP_S: "CLAMP_TO_EDGE", TEXTURE_WRAP_T: "CLAMP_TO_EDGE" }
                )
              : (this.texture = null);
          }
        }
      ]);
      return d;
    })(ca),
    Lm = (function () {
      function b(d, a) {
        F(this, b);
        this.name = "Mask";
        this.webglLayer = d;
        this.options = a || {};
        this.bufferData = [];
        this.indices = [];
      }
      I(b, [
        {
          key: "initialize",
          value: function (b) {
            this.gl = b;
            this.program = new X(
              this.gl,
              {
                vertexShader:
                  "precision highp float;attribute vec2 a_position;uniform mat4 u_matrix;uniform float u_height;void main(){vec4 position=u_matrix*vec4(a_position.xy,u_height,1.0);gl_Position=position;}",
                fragmentShader: "precision highp float;uniform vec4 u_color;void main(){gl_FragColor=u_color;}",
                defines: []
              },
              this
            );
            this.vertexBuffer = new K({ gl: b, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.indexBuffer = new K({ gl: b, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
            this.vertexArray = new fa({
              gl: b,
              program: this.program,
              attributes: [{ stride: 8, name: "a_position", buffer: this.vertexBuffer, size: 2, type: "FLOAT", offset: 0 }]
            });
            return this;
          }
        },
        {
          key: "onDestroy",
          value: function () {
            this.bufferData = [];
            this.index = [];
          }
        },
        {
          key: "setData",
          value: function (b) {
            var a = this;
            if (this.gl) {
              for (var c = [], d = [], h = 0; h < b.length; h++)
                if (b[h].geometry.coordinates) {
                  var g = [];
                  "LineString" === b[h].geometry.type &&
                    (g = [
                      b[h].geometry.coordinates.map(function (b) {
                        return a.normizedPoint(b);
                      })
                    ]);
                  if ("MultiPolygon" === b[h].geometry.type)
                    for (var k = b[h].geometry.coordinates, l = 0; l < k.length; l++)
                      g = g.concat(
                        k[l].map(function (b) {
                          return b.map(function (b) {
                            return a.normizedPoint(b);
                          });
                        })
                      );
                  else
                    for (k = 0; k < b[h].geometry.coordinates.length; k++)
                      g.push(
                        b[h].geometry.coordinates[k].map(function (b) {
                          return a.normizedPoint(b);
                        })
                      );
                  k = Fa.flatten(g);
                  g = k.vertices;
                  k = k.holes;
                  l = [];
                  for (var n = 0; n < g.length; n += 3) l.push(g[n + 0], g[n + 1]);
                  this.parseBufferData(c, d, l, k);
                }
              this.bufferData = c;
              this.index = d;
              this.vertexBuffer.updateData(new Float32Array(c));
              this.indexBuffer.updateData(new Uint32Array(d));
              return this;
            }
          }
        },
        {
          key: "parseBufferData",
          value: function (b, a, c, f) {
            var d = b.length / 2;
            f = f && f.length ? Fa(c, f, 2) : Fa(c);
            b.push.apply(b, W(c));
            for (b = 0; b < f.length; b++) a.push(f[b] + d);
          }
        },
        {
          key: "render",
          value: function (b) {
            if (this.index && this.index.length) {
              var a = b.gl,
                c = b.matrix,
                d = this.options;
              b = this.program;
              b.use(a);
              c = { u_matrix: c, u_height: d.height || 0, u_color: this.normizedColor(d.color) };
              b.setUniforms(c);
              this.indexBuffer.bind();
              this.vertexArray.bind();
              a.drawElements(a.TRIANGLES, this.index.length, a.UNSIGNED_INT, 0);
            }
          }
        },
        {
          key: "normizedColor",
          value: function (b) {
            var a = b;
            b instanceof Array || (a = ka(b).unitArray());
            void 0 === a[3] && (a[3] = 1);
            return a;
          }
        },
        {
          key: "normizedPoint",
          value: function (b) {
            var a = this.getPointOffset();
            if (!b || !b[0] || !b[1]) return [a[0], a[1], 0];
            var c = Number(b[0]),
              d = Number(b[1]);
            -180 <= c && 180 >= c && -90 <= d && 90 >= d && ((d = this.webglLayer.map.lnglatToMercator(c, d)), (c = d[0]), (d = d[1]));
            var h = Number(b[2]) || 0;
            this.webglLayer && "cesium" === this.webglLayer.options.mapType && window.Cesium
              ? ((c = this.convertLngLat([c, d])), (h = window.Cesium.Cartesian3.fromDegrees(c[0], c[1], h)), (c = h.x), (d = h.y), (h = h.z))
              : this.webglLayer &&
                "bmapgl" === this.webglLayer.options.mapType &&
                "B_EARTH_MAP" === this.webglLayer.map.map.mapType &&
                ((c = this.convertLngLat([c, d])), (h = this.webglLayer.map.map.getEarth().scene.fromLatLngToXYZ({ lng: c[0], lat: c[1] })), (c = h.x), (d = h.y), (h = h.z));
            return 3 < b.length ? [c - a[0], d - a[1], h].concat(W(b.slice(3))) : [c - a[0], d - a[1], h];
          }
        },
        {
          key: "convertLngLat",
          value: function (b) {
            return [(b[0] / 2.003750834e7) * 180, (180 / Math.PI) * (2 * Math.atan(Math.exp(((b[1] / 2.003750834e7) * 180 * Math.PI) / 180)) - Math.PI / 2)];
          }
        },
        {
          key: "getPointOffset",
          value: function () {
            var b = [0, 0],
              a = this.options;
            this.webglLayer && this.webglLayer.options.pointOffset ? (b = this.webglLayer.options.pointOffset) : a.pointOffset && (b = a.pointOffset);
            return b;
          }
        }
      ]);
      return b;
    })(),
    Mm = (function (b) {
      function d(a, b) {
        F(this, d);
        return Q(this, (d.__proto__ || N(d)).call(this, a, b));
      }
      R(d, b);
      I(d, [
        {
          key: "getDefaultOptions",
          value: function () {
            return {};
          }
        },
        {
          key: "initialize",
          value: function (a) {
            var b = this.getOptions();
            if (b.source && b.source.image && b.domain && ("string" === typeof b.source.image || (b.source.width && b.source.height))) {
              var d = b.refColors,
                h = b.refImage;
              if ((d || h) && (!d || (d.colors && d.positions)) && (!h || "string" === typeof h.url)) {
                this.gl = a;
                var g = [];
                d
                  ? (this.imageData = Sf(d.colors, d.positions, d.clamp, d.color, d.height))
                  : ((this.imageData = { data: h.url }), g.push("USE_IMAGE_TEXTURE"), (this.imageTexture = !0));
                b.isTerrain &&
                  ((this.isTerrain = b.isTerrain),
                  g.push("USE_TERRAIN"),
                  (this.gridRowMax = 1600),
                  b.gridRowMax && (this.gridRowMax = b.gridRowMax),
                  (this.gridColMax = 1600),
                  b.gridColMax && (this.gridColMax = b.gridColMax));
                this.texture = null;
                d = "\n        float generateValue(vec4 rgba){\n            return rgba.r;\n        }";
                b.fomularC && (d = b.fomularC);
                b =
                  "precision highp float;attribute vec3 a_pos;attribute vec2 a_texture_coord;uniform mat4 u_proj_matrix;uniform mat4 u_mv_matrix;uniform sampler2D uTile;uniform float u_baseLine;uniform float u_elevationScale;varying vec2 v_texture_coord;void main(){v_texture_coord=a_texture_coord;vec3 pos=a_pos.xyz;\n#if defined(USE_TERRAIN)\nvec4 terrainColor=texture2D(uTile,vec2(a_texture_coord.s,a_texture_coord.t));float value=generateValue(terrainColor);float h=(value-u_baseLine)*u_elevationScale;pos.z=max(0.,h);\n#endif\nvec4 position=u_proj_matrix*u_mv_matrix*vec4(pos,1.0);gl_Position=position;}".replace(
                    "void main()",
                    d + "\nvoid main()"
                  );
                d =
                  "precision highp float;varying vec2 v_texture_coord;uniform sampler2D uTile;uniform sampler2D uColorRamp;uniform bool uUseFilter;uniform vec4 uFilterColor;uniform float u_opacity;uniform float u_noData;uniform vec3 u_noTextureData;uniform vec2 u_clamp;uniform vec2 u_domain;uniform vec3 u_linearOpacity;uniform bool u_isOneBand;uniform float u_brightness;uniform float u_contrast;uniform float u_exposure;uniform float u_saturation;vec4 indexToRgba(float value){float index=value;float b=floor(index/65536.);index-=b*65536.;float g=floor(index/256.);index-=g*256.;float r=index;return vec4(r,g,b,255.);}vec3 adjustBrightness(vec3 color,float value){return color+value;}vec3 adjustContrast(vec3 color,float value){return 0.5+(1.0+value)*(color-0.5);}vec3 adjustExposure(vec3 color,float value){return color*(1.0+value);}vec3 adjustSaturation(vec3 color,float value){const vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);vec3 grayscale=vec3(dot(color,luminosityFactor));return mix(grayscale,color,1.0+value);}void main(){vec4 data=texture2D(uTile,vec2(v_texture_coord.s,v_texture_coord.t));float value=generateValue(data);vec4 textureColor=vec4(0,0,0,0);if(value>=u_clamp.s&&value<=u_clamp.t){float normalisedValue=(value-u_domain.s)/(u_domain.t-u_domain.s);\n#if defined(USE_IMAGE_TEXTURE)\nvec4 color=texture2D(uColorRamp,vec2(v_texture_coord.s,v_texture_coord.t));if(vec3(color.rgb)==u_noTextureData){color=vec4(0,0,0,0);}\n#else\nvec4 color=texture2D(uColorRamp,vec2(normalisedValue,0));\n#endif\ncolor.a=smoothstep(u_linearOpacity.s,u_linearOpacity.t,color.a*normalisedValue)+u_linearOpacity.p;textureColor=color;textureColor.a=textureColor.a*u_opacity;vec3 mixColor=adjustBrightness(textureColor.rgb,u_brightness);mixColor=adjustContrast(mixColor,u_contrast);mixColor=adjustExposure(mixColor,u_exposure);mixColor=adjustSaturation(mixColor,u_saturation);textureColor=vec4(mixColor,textureColor.a);if(uIsPickRender&&u_isOneBand){textureColor=indexToRgba(value)/255.;}if(uIsPickRender&&!u_isOneBand){textureColor=data;}}if(value==u_noData){textureColor=vec4(0,0,0,0);}if(uUseFilter){textureColor=textureColor*uFilterColor;}gl_FragColor=textureColor;}".replace(
                    "void main()",
                    d + "\nvoid main()"
                  );
                this.program = new X(this.gl, { vertexShader: b, fragmentShader: d, defines: g }, this);
                this.vertexBuffer = new K({ gl: a, target: "ARRAY_BUFFER", usage: "STATIC_DRAW" });
                this.indexBuffer = new K({ gl: a, target: "ELEMENT_ARRAY_BUFFER", usage: "STATIC_DRAW" });
                this.vertexArray = new fa({
                  gl: a,
                  program: this.program,
                  attributes: [
                    { name: "a_pos", buffer: this.vertexBuffer, stride: 20, size: 3, type: "FLOAT", offset: 0 },
                    { name: "a_texture_coord", buffer: this.vertexBuffer, size: 2, stride: 20, type: "FLOAT", offset: 12 }
                  ]
                });
              }
            }
          }
        },
        {
          key: "onChanged",
          value: function (a, b) {
            var c = this;
            this.gl &&
              (this.loadDataTexture && clearTimeout(this.loadDataTexture),
              (this.loadDataTexture = setTimeout(function () {
                c.loadTexture(function () {
                  c.parseData(b);
                  c.webglLayer.render();
                });
              }, 0)));
          }
        },
        {
          key: "drawMask",
          value: function (a) {
            var b = a.gl,
              d = a.matrix,
              h = a.projectionMatrix,
              g = a.viewMatrix;
            if ((a = a.polygons)) {
              var k = new Lm(this.webglLayer, { color: "rgba(19, 14, 7, 0.8)" });
              this.setGLState({ stencilTest: !0, depthTest: !1, depthMask: !1 });
              b.clear(b.STENCIL_BUFFER_BIT);
              b.stencilFunc(b.ALWAYS, 1, 255);
              b.stencilOp(b.KEEP, b.KEEP, b.REPLACE);
              b.colorMask(!1, !1, !1, !1);
              k.initialize(b).setData(a).render({ gl: b, matrix: d, projectionMatrix: h, viewMatrix: g });
            }
          }
        },
        {
          key: "onOptionsChanged",
          value: function (a, b) {
            this.gl && (this.initialize(this.gl), this.loadTexture(), this.webglLayer.render());
          }
        },
        {
          key: "render",
          value: function (a) {
            var b = a.gl,
              d = a.matrix,
              h = a.projectionMatrix,
              g = a.viewMatrix,
              k = a.isPickRender;
            a = this.getOptions();
            var l = this.program;
            if (l || this.texture)
              a.stencilData && this.drawMask({ gl: b, matrix: d, projectionMatrix: h, viewMatrix: g, polygons: a.stencilData }),
                this.setGLState({
                  blend: !0,
                  blendEquation: b.FUNC_ADD,
                  blendFunc: [b.SRC_ALPHA, b.ONE_MINUS_SRC_ALPHA],
                  stencilTest: a.stencilData ? !0 : !1,
                  depthTest: a.depthTest,
                  depthMask: a.depthMask
                }),
                l.use(b),
                a.stencilData && (b.stencilFunc(b.EQUAL, 1, 1), b.stencilOp(b.KEEP, b.KEEP, b.KEEP), b.colorMask(!0, !0, !0, !0)),
                this.colorRamp &&
                  this.texture &&
                  ((d = [0, 0, 0]),
                  a.linearOpacity && this.formaLinear(a.linearOpacity, d),
                  (h = {
                    uColorRamp: this.colorRamp,
                    uTile: this.texture,
                    u_proj_matrix: h,
                    uUseFilter: !!a.filterColor,
                    uFilterColor: this.normizedColor(a.filterColor || "rgba(0, 0, 100, 1.0)"),
                    u_mv_matrix: g,
                    uIsPickRender: !!k,
                    u_noData: a.noData || -99999,
                    u_domain: a.domain,
                    u_clamp: a.clamp ? a.clamp : a.domain,
                    u_linearOpacity: d,
                    u_opacity: a.opacity || 1,
                    u_isOneBand: !!this.isOneBand,
                    u_brightness: a.brightness || 0,
                    u_contrast: a.contrast || 0,
                    u_exposure: a.exposure || 0,
                    u_saturation: a.saturation || 0
                  }),
                  this.isTerrain && ((h.u_baseLine = a.baseLine || 0), (h.u_elevationScale = a.elevationScale || 1)),
                  this.imageTexture && (h.u_noTextureData = a.baseLine || 0),
                  l.setUniforms(h),
                  this.index && 0 < this.index.length && (this.indexBuffer.bind(), this.vertexArray.bind(), b.drawElements(b.TRIANGLES, this.index.length, b.UNSIGNED_INT, 0)),
                  a.stencilData && !a.stencilAfter && (b.clear(b.STENCIL_BUFFER_BIT), b.stencilMask(255), b.stencilFunc(b.ALWAYS, 1, 255)));
          }
        },
        {
          key: "onDestroy",
          value: function () {
            this.texturePixels = this.texture = this.colorRamp = this.indexBuffer = this.vertexBuffer = this.index = this.program = null;
          }
        },
        {
          key: "pickAfter",
          value: function (a, b) {
            var c, d;
            this.isOneBand ? ((b = c = d = b), (a = 1)) : ((b = a[0]), (c = a[1]), (d = a[2]), (a = a[3]));
            return this.getOptions().fomularJS ? this.getOptions().fomularJS({ r: b, g: c, b: d, a: a }) : b;
          }
        },
        {
          key: "formaLinear",
          value: function (a, b) {
            a.start && (b[0] = a.start || 0);
            a.end && (b[1] = a.end || 0);
            a.base && (b[2] = a.base || 0);
          }
        },
        {
          key: "loadTexture",
          value: function (a) {
            var b = this,
              d = this.getOptions();
            d.source.image && this.imageData
              ? ta(
                  this.gl,
                  this.imageData.data,
                  function (c, f) {
                    b.colorRamp = c;
                    "object" === Ha(d.source.image)
                      ? ((b.isOneBand = !0),
                        ta(
                          b.gl,
                          d.source.image,
                          function (c, d, f) {
                            b.texture = c;
                            b.texturePixels = f;
                            b.textureWidth = f.width;
                            b.textureHeight = f.height;
                            a && a();
                            b.webglLayer.render();
                          },
                          { TEXTURE_MIN_FILTER: "NEAREST", TEXTURE_MAG_FILTER: "NEAREST", TEXTURE_WRAP_S: "CLAMP_TO_EDGE", TEXTURE_WRAP_T: "CLAMP_TO_EDGE" },
                          { width: d.source.width, height: d.source.height, format: "LUMINANCE", type: "FLOAT" }
                        ))
                      : ((b.isOneBand = !1),
                        ta(
                          b.gl,
                          d.source.image,
                          function (c, d, f) {
                            b.texture = c;
                            b.texturePixels = f;
                            b.textureWidth = f.width;
                            b.textureHeight = f.height;
                            a && a();
                            b.webglLayer.render();
                          },
                          { TEXTURE_WRAP_S: "CLAMP_TO_EDGE", TEXTURE_WRAP_T: "CLAMP_TO_EDGE" }
                        ));
                  },
                  { TEXTURE_WRAP_S: "CLAMP_TO_EDGE", TEXTURE_WRAP_T: "CLAMP_TO_EDGE" },
                  { width: this.imageData.width, height: this.imageData.height, flipY: !0, format: "RGBA", type: "UNSIGNED_BYTE" }
                )
              : ((this.texture = null), a && a());
          }
        },
        {
          key: "parseData",
          value: function (a) {
            var b = this;
            if (this.vertexBuffer) {
              var d = [],
                h = [];
              if (a && a[0]) {
                var g = a[0].geometry.coordinates[0];
                g = g.map(function (a) {
                  return b.normizedPoint(a);
                });
                a = g[0][0];
                var k = g[0][1],
                  l = g[2][0],
                  n = g[2][1];
                this.bound = [a, k, l, n];
                this.gridRowMax > this.textureHeight && (this.gridRowMax = this.textureHeight);
                this.gridColMax > this.textureWidth && (this.gridColMax = this.textureWidth);
                g = this.isTerrain ? this.gridColMax : 1;
                var m = this.isTerrain ? this.gridRowMax : 1,
                  p = g + 1;
                l = (l - a) / g;
                n = (n - k) / m;
                for (var q = 0; q <= m; q++)
                  for (var t = 0; t <= g; t++)
                    if ((d.push(a + l * t, k + n * q, 0), d.push(t / g, q / m), t < g && q < m)) {
                      var v = p * q + t,
                        r = p * (q + 1) + t;
                      h.push(v, r + 1, v + 1);
                      h.push(v, r, r + 1);
                    }
              }
              this.index = h;
              this.vertexBuffer.updateData(new Float32Array(d));
              this.indexBuffer.updateData(new Uint32Array(h));
            }
          }
        },
        {
          key: "getValue",
          value: function (a, b) {
            return this.isTerrain &&
              a &&
              this.bound &&
              ((a = this.normizedPoint(a)),
              this.containsPoint(a, this.bound) && ((a = this.uvPoint(a, this.bound)), (b = this.pixelByUV(a, b, this.getOptions().fomularJS)), b.result))
              ? b
              : 0;
          }
        },
        {
          key: "containsPoint",
          value: function (a, b) {
            if (a) return a[0] >= b[0] && a[0] <= b[2] && a[1] >= b[1] && a[1] <= b[3];
          }
        },
        {
          key: "uvPoint",
          value: function (a, b) {
            if (a) return [(a[0] - b[0]) / (b[2] - b[0]), (b[3] - a[1]) / (b[3] - b[1])];
          }
        },
        {
          key: "pixelByUV",
          value: function (a, b, d) {
            if (this.texturePixels) {
              var c = this.texturePixels,
                f = c.width,
                k = c.height,
                l = c.data,
                n = Math.floor(a[0] * (f - 1));
              a = Math.floor(a[1] * (k - 1));
              var m = 1;
              "RGBA" === c.type && (m = 4);
              return this._getPixelBound(n, a, b, f, k, l, m, d);
            }
            return null;
          }
        },
        {
          key: "_getPixelBound",
          value: function (a, b, d, h, g, k, l, n) {
            var c = a - d;
            0 > c && (c = 0);
            a += d;
            a > h - 1 && (a = h - 1);
            var f = b - d;
            0 > f && (f = 0);
            b += d;
            b > g - 1 && (b = g - 1);
            d = g = 0;
            for (var q = [0, 0, 0, 1], t = c; t <= a; t++)
              for (var v = f; v <= b; v++) {
                var r = (v * h + t) * l,
                  u = k[r],
                  w = k[r + this.min(0, l - 3)],
                  y = k[r + this.min(0, l - 2)];
                r = 4 === l ? k[r + 3] : 1;
                var x = n ? n({ r: u, g: w, b: y, a: r }) : u;
                x > g && ((g = x), (q = [u, w, y, r]));
                d += x;
              }
            return { result: d / ((a - c + 1) * (b - f + 1)), pixel: q, max: g };
          }
        },
        {
          key: "min",
          value: function (a, b) {
            return b < a ? a : b;
          }
        }
      ]);
      return d;
    })(ca);
  B.View = nf;
  B.CanvasLayer = ja;
  B.CircleLayer = function d() {
    var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    F(this, d);
    return ql.includes(a.type) ? new pl(a) : new ol(a);
  };
  B.GridLayer = $h;
  B.HeatGridLayer = ul;
  B.ShapeLayer = Zd;
  B.SimpleLineLayer = ai;
  B.LineLayer3D = yl;
  B.LineLayer = sf;
  B.LineRainbowLayer = Al;
  B.WallSpriteLayer = Cl;
  B.LinePointLayer = cc;
  B.WallLayer = Xl;
  B.WallTripLayer = Zl;
  B.HeatLineLayer = $l;
  B.HoneycombLayer = am;
  B.WebglLayer = Uh;
  B.PointLayer = md;
  B.GroundRippleLayer = bm;
  B.RippleLayer = cm;
  B.SparkLayer = dm;
  B.ClusterLayer = em;
  B.IconClusterLayer = fm;
  B.HeatPointLayer = gm;
  B.ShapeLineLayer = hm;
  B.PointTripLayer = im;
  B.LineTripLayer = jm;
  B.IconCollidesLayer = km;
  B.LineFlowLayer = wi;
  B.TileLayer = lm;
  B.IconLayer = Gf;
  B.BoardLayer = mm;
  B.PolygonLayer = nm;
  B.CarLineLayer = Bm;
  B.Layer = ca;
  B.TextLayer = rc;
  B.BoardTextLayer = Cm;
  B.LabelLayer = Dm;
  B.TrafficLayer = Em;
  B.GltfLayer = Gi;
  B.HeatmapLayer = Fm;
  B.BarLayer = Gm;
  B.MarkerListLayer = Hm;
  B.MaskLayer = Im;
  B.PointCanvasCustomLayer = Km;
  B.PixelLayer = Mm;
  B.FXAA = cl;
  B.SMAA = dl;
  B.BlurEffect = el;
  B.BloomEffect = fl;
  B.BrightEffect = gl;
  B.DepthEffect = hl;
  B.EffectManager = Th;
  B.getContext = Qf;
  B.createTexture = ec;
  B.loadTextureImage = ta;
  B.getBlend = Va;
  B.FrameBufferObject = ya;
  B.Program = X;
  B.StateManager = Sh;
  B.Buffer = K;
  B.VertexArray = fa;
  B.CommonLayer = of;
  B.MercatorProjection = Ea;
  B.Canvas = ne;
  B.Intensity = Ba;
  B.BezierCurve = mb;
  B.GeodesicCurve = wb;
  B.OdCurve = rk;
  B.utilCity = {
    getProvinceNameByCityName: function (d) {
      for (var a = 0; a < Xb.length; a++) for (var c = Xb[a].n, f = Xb[a].cities, h = 0; h < f.length; h++) if (f[h].n == d) return c;
      return null;
    },
    getCenterByCityName: function (d) {
      d = d.replace("\u5e02", "");
      for (var a = 0; a < We.length; a++) if (We[a].n == d) return pd(We[a].g);
      for (a = 0; a < Xe.length; a++) if (Xe[a].n == d) return pd(Xe[a].g);
      for (a = 0; a < Xb.length; a++) {
        if (Xb[a].n == d) return pd(Xb[a].g);
        for (var c = Xb[a].cities, f = 0; f < c.length; f++) if (c[f].n == d) return pd(c[f].g);
      }
      return null;
    }
  };
  B.isMobile = fh;
  B.isIOSMobile = Rf;
  B.Encryptor = {
    encode: function (d) {
      d = Nh.deflateRaw(d);
      for (var a = [], c = 0; c < d.length; c++) a.push(d[c] ^ 23);
      return new Uint8Array(a);
    },
    decode: function (d) {
      d = new Uint8Array(d);
      for (var a = [], c = 0; c < d.length; c++) a.push(d[c] ^ 23);
      d = new Uint8Array(a);
      try {
        var f = window.flate.deflate_decode_raw(d);
        return new TextDecoder("utf-8").decode(f);
      } catch (h) {
        return console.warn("inflate by pako!"), Nh.inflateRaw(d, { to: "string" });
      }
    },
    download: function (d, a) {
      var c = new Blob([d], { type: "application/octet-binary" });
      d = document.createElement("a");
      c = window.URL.createObjectURL(c);
      d.href = c;
      d.download = a || "mapvgl_download";
      d.click();
    }
  };
  B.createFusionView = function (d, a) {
    var c = void 0,
      f = !1;
    d.addEventListener("glmoduleloaded", function (h) {
      f ||
        ((f = !0),
        setTimeout(function () {
          c = new nf({ cameraNear: 10, cameraFar: 4e3, gl: d._webglPainter.gl, canvas: d._webglPainter.gl.canvas, autoUpdate: !1, map: d });
          c.webglLayer.canvas.style.zIndex = 1;
          var f = c.webglLayer.stateManager;
          d.insertRender = function () {
            f.setState({ blend: !0, depthTest: !1 });
            c.render();
          };
          a && a(c);
        }, 3e3));
    });
    setTimeout(function () {
      if (!f && d._webglMapScene && d._webglPainter && d._webglPainter.gl && d._webglPainter.gl.canvas) {
        f = !0;
        c = new nf({ cameraNear: 10, cameraFar: 4e3, gl: d._webglPainter.gl, canvas: d._webglPainter.gl.canvas, autoUpdate: !1, map: d });
        c.webglLayer.canvas.style.zIndex = 1;
        var h = c.webglLayer.stateManager;
        d.insertRender = function () {
          h.setState({ blend: !0, depthTest: !1 });
          c.render();
        };
        a && a(c);
      }
    }, 4e3);
  };
  B.toRadian = za;
  B.toAngle = ie;
  B.ceilPowerOfTwo = lb;
  B.floorPowerOfTwo = je;
  B.approximatelyEqual = ke;
  B.isClosed = le;
  B.generateColorRamp = Sf;
  B.__moduleExports = Ua;
  B.vec4 = na;
  B.vec3 = P;
  B.vec2 = Z;
  B.quat2 = Xk;
  B.quat = Ed;
  B.mat4 = L;
  B.mat3 = Yk;
  B.mat2d = Zk;
  B.mat2 = $k;
  B.glMatrix = al;
  Object.defineProperty(B, "__esModule", { value: !0 });
});
